import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, createElement, memo } from "react";
import { c as cn } from "./cn-BHs2eMrl.js";
var l = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, u = (e) => !e || typeof e != "object" || Object.keys(e).length === 0, x = (e, o) => JSON.stringify(e) === JSON.stringify(o);
function i(e, o) {
  e.forEach(function(r) {
    Array.isArray(r) ? i(r, o) : o.push(r);
  });
}
function y(e) {
  let o = [];
  return i(e, o), o;
}
var a = (...e) => y(e).filter(Boolean), p = (e, o) => {
  let r = {}, c = Object.keys(e), f = Object.keys(o);
  for (let t of c) if (f.includes(t)) {
    let s = e[t], n = o[t];
    typeof s == "object" && typeof n == "object" ? r[t] = p(s, n) : Array.isArray(s) || Array.isArray(n) ? r[t] = a(n, s) : r[t] = n + " " + s;
  } else r[t] = e[t];
  for (let t of f) c.includes(t) || (r[t] = o[t]);
  return r;
}, g = (e) => !e || typeof e != "string" ? e : e.replace(/\s+/g, " ").trim();
const CLASS_PART_SEPARATOR = "-";
const createClassGroupUtils = (config) => {
  const classMap = createClassMap(config);
  const {
    conflictingClassGroups,
    conflictingClassGroupModifiers
  } = config;
  const getClassGroupId = (className) => {
    const classParts = className.split(CLASS_PART_SEPARATOR);
    if (classParts[0] === "" && classParts.length !== 1) {
      classParts.shift();
    }
    return getGroupRecursive(classParts, classMap) || getGroupIdForArbitraryProperty(className);
  };
  const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier) => {
    const conflicts = conflictingClassGroups[classGroupId] || [];
    if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) {
      return [...conflicts, ...conflictingClassGroupModifiers[classGroupId]];
    }
    return conflicts;
  };
  return {
    getClassGroupId,
    getConflictingClassGroupIds
  };
};
const getGroupRecursive = (classParts, classPartObject) => {
  var _a;
  if (classParts.length === 0) {
    return classPartObject.classGroupId;
  }
  const currentClassPart = classParts[0];
  const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
  const classGroupFromNextClassPart = nextClassPartObject ? getGroupRecursive(classParts.slice(1), nextClassPartObject) : void 0;
  if (classGroupFromNextClassPart) {
    return classGroupFromNextClassPart;
  }
  if (classPartObject.validators.length === 0) {
    return void 0;
  }
  const classRest = classParts.join(CLASS_PART_SEPARATOR);
  return (_a = classPartObject.validators.find(({
    validator
  }) => validator(classRest))) == null ? void 0 : _a.classGroupId;
};
const arbitraryPropertyRegex = /^\[(.+)\]$/;
const getGroupIdForArbitraryProperty = (className) => {
  if (arbitraryPropertyRegex.test(className)) {
    const arbitraryPropertyClassName = arbitraryPropertyRegex.exec(className)[1];
    const property = arbitraryPropertyClassName == null ? void 0 : arbitraryPropertyClassName.substring(0, arbitraryPropertyClassName.indexOf(":"));
    if (property) {
      return "arbitrary.." + property;
    }
  }
};
const createClassMap = (config) => {
  const {
    theme,
    prefix
  } = config;
  const classMap = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  const prefixedClassGroupEntries = getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
  prefixedClassGroupEntries.forEach(([classGroupId, classGroup]) => {
    processClassesRecursively(classGroup, classMap, classGroupId, theme);
  });
  return classMap;
};
const processClassesRecursively = (classGroup, classPartObject, classGroupId, theme) => {
  classGroup.forEach((classDefinition) => {
    if (typeof classDefinition === "string") {
      const classPartObjectToEdit = classDefinition === "" ? classPartObject : getPart(classPartObject, classDefinition);
      classPartObjectToEdit.classGroupId = classGroupId;
      return;
    }
    if (typeof classDefinition === "function") {
      if (isThemeGetter(classDefinition)) {
        processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
      }
      classPartObject.validators.push({
        validator: classDefinition,
        classGroupId
      });
      return;
    }
    Object.entries(classDefinition).forEach(([key, classGroup2]) => {
      processClassesRecursively(classGroup2, getPart(classPartObject, key), classGroupId, theme);
    });
  });
};
const getPart = (classPartObject, path) => {
  let currentClassPartObject = classPartObject;
  path.split(CLASS_PART_SEPARATOR).forEach((pathPart) => {
    if (!currentClassPartObject.nextPart.has(pathPart)) {
      currentClassPartObject.nextPart.set(pathPart, {
        nextPart: /* @__PURE__ */ new Map(),
        validators: []
      });
    }
    currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
  });
  return currentClassPartObject;
};
const isThemeGetter = (func) => func.isThemeGetter;
const getPrefixedClassGroupEntries = (classGroupEntries, prefix) => {
  if (!prefix) {
    return classGroupEntries;
  }
  return classGroupEntries.map(([classGroupId, classGroup]) => {
    const prefixedClassGroup = classGroup.map((classDefinition) => {
      if (typeof classDefinition === "string") {
        return prefix + classDefinition;
      }
      if (typeof classDefinition === "object") {
        return Object.fromEntries(Object.entries(classDefinition).map(([key, value]) => [prefix + key, value]));
      }
      return classDefinition;
    });
    return [classGroupId, prefixedClassGroup];
  });
};
const createLruCache = (maxCacheSize) => {
  if (maxCacheSize < 1) {
    return {
      get: () => void 0,
      set: () => {
      }
    };
  }
  let cacheSize = 0;
  let cache = /* @__PURE__ */ new Map();
  let previousCache = /* @__PURE__ */ new Map();
  const update = (key, value) => {
    cache.set(key, value);
    cacheSize++;
    if (cacheSize > maxCacheSize) {
      cacheSize = 0;
      previousCache = cache;
      cache = /* @__PURE__ */ new Map();
    }
  };
  return {
    get(key) {
      let value = cache.get(key);
      if (value !== void 0) {
        return value;
      }
      if ((value = previousCache.get(key)) !== void 0) {
        update(key, value);
        return value;
      }
    },
    set(key, value) {
      if (cache.has(key)) {
        cache.set(key, value);
      } else {
        update(key, value);
      }
    }
  };
};
const IMPORTANT_MODIFIER = "!";
const createParseClassName = (config) => {
  const {
    separator,
    experimentalParseClassName
  } = config;
  const isSeparatorSingleCharacter = separator.length === 1;
  const firstSeparatorCharacter = separator[0];
  const separatorLength = separator.length;
  const parseClassName = (className) => {
    const modifiers = [];
    let bracketDepth = 0;
    let modifierStart = 0;
    let postfixModifierPosition;
    for (let index = 0; index < className.length; index++) {
      let currentCharacter = className[index];
      if (bracketDepth === 0) {
        if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
          modifiers.push(className.slice(modifierStart, index));
          modifierStart = index + separatorLength;
          continue;
        }
        if (currentCharacter === "/") {
          postfixModifierPosition = index;
          continue;
        }
      }
      if (currentCharacter === "[") {
        bracketDepth++;
      } else if (currentCharacter === "]") {
        bracketDepth--;
      }
    }
    const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
    const hasImportantModifier = baseClassNameWithImportantModifier.startsWith(IMPORTANT_MODIFIER);
    const baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
    const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : void 0;
    return {
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    };
  };
  if (experimentalParseClassName) {
    return (className) => experimentalParseClassName({
      className,
      parseClassName
    });
  }
  return parseClassName;
};
const sortModifiers = (modifiers) => {
  if (modifiers.length <= 1) {
    return modifiers;
  }
  const sortedModifiers = [];
  let unsortedModifiers = [];
  modifiers.forEach((modifier) => {
    const isArbitraryVariant = modifier[0] === "[";
    if (isArbitraryVariant) {
      sortedModifiers.push(...unsortedModifiers.sort(), modifier);
      unsortedModifiers = [];
    } else {
      unsortedModifiers.push(modifier);
    }
  });
  sortedModifiers.push(...unsortedModifiers.sort());
  return sortedModifiers;
};
const createConfigUtils = (config) => ({
  cache: createLruCache(config.cacheSize),
  parseClassName: createParseClassName(config),
  ...createClassGroupUtils(config)
});
const SPLIT_CLASSES_REGEX = /\s+/;
const mergeClassList = (classList, configUtils) => {
  const {
    parseClassName,
    getClassGroupId,
    getConflictingClassGroupIds
  } = configUtils;
  const classGroupsInConflict = [];
  const classNames = classList.trim().split(SPLIT_CLASSES_REGEX);
  let result = "";
  for (let index = classNames.length - 1; index >= 0; index -= 1) {
    const originalClassName = classNames[index];
    const {
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    } = parseClassName(originalClassName);
    let hasPostfixModifier = Boolean(maybePostfixModifierPosition);
    let classGroupId = getClassGroupId(hasPostfixModifier ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
    if (!classGroupId) {
      if (!hasPostfixModifier) {
        result = originalClassName + (result.length > 0 ? " " + result : result);
        continue;
      }
      classGroupId = getClassGroupId(baseClassName);
      if (!classGroupId) {
        result = originalClassName + (result.length > 0 ? " " + result : result);
        continue;
      }
      hasPostfixModifier = false;
    }
    const variantModifier = sortModifiers(modifiers).join(":");
    const modifierId = hasImportantModifier ? variantModifier + IMPORTANT_MODIFIER : variantModifier;
    const classId = modifierId + classGroupId;
    if (classGroupsInConflict.includes(classId)) {
      continue;
    }
    classGroupsInConflict.push(classId);
    const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
    for (let i2 = 0; i2 < conflictGroups.length; ++i2) {
      const group = conflictGroups[i2];
      classGroupsInConflict.push(modifierId + group);
    }
    result = originalClassName + (result.length > 0 ? " " + result : result);
  }
  return result;
};
function twJoin() {
  let index = 0;
  let argument;
  let resolvedValue;
  let string = "";
  while (index < arguments.length) {
    if (argument = arguments[index++]) {
      if (resolvedValue = toValue(argument)) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
}
const toValue = (mix) => {
  if (typeof mix === "string") {
    return mix;
  }
  let resolvedValue;
  let string = "";
  for (let k = 0; k < mix.length; k++) {
    if (mix[k]) {
      if (resolvedValue = toValue(mix[k])) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
};
function createTailwindMerge(createConfigFirst, ...createConfigRest) {
  let configUtils;
  let cacheGet;
  let cacheSet;
  let functionToCall = initTailwindMerge;
  function initTailwindMerge(classList) {
    const config = createConfigRest.reduce((previousConfig, createConfigCurrent) => createConfigCurrent(previousConfig), createConfigFirst());
    configUtils = createConfigUtils(config);
    cacheGet = configUtils.cache.get;
    cacheSet = configUtils.cache.set;
    functionToCall = tailwindMerge;
    return tailwindMerge(classList);
  }
  function tailwindMerge(classList) {
    const cachedResult = cacheGet(classList);
    if (cachedResult) {
      return cachedResult;
    }
    const result = mergeClassList(classList, configUtils);
    cacheSet(classList, result);
    return result;
  }
  return function callTailwindMerge() {
    return functionToCall(twJoin.apply(null, arguments));
  };
}
const fromTheme = (key) => {
  const themeGetter = (theme) => theme[key] || [];
  themeGetter.isThemeGetter = true;
  return themeGetter;
};
const arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
const fractionRegex = /^\d+\/\d+$/;
const stringLengths = /* @__PURE__ */ new Set(["px", "full", "screen"]);
const tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/;
const shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
const isLength = (value) => isNumber(value) || stringLengths.has(value) || fractionRegex.test(value);
const isArbitraryLength = (value) => getIsArbitraryValue(value, "length", isLengthOnly);
const isNumber = (value) => Boolean(value) && !Number.isNaN(Number(value));
const isArbitraryNumber = (value) => getIsArbitraryValue(value, "number", isNumber);
const isInteger = (value) => Boolean(value) && Number.isInteger(Number(value));
const isPercent = (value) => value.endsWith("%") && isNumber(value.slice(0, -1));
const isArbitraryValue = (value) => arbitraryValueRegex.test(value);
const isTshirtSize = (value) => tshirtUnitRegex.test(value);
const sizeLabels = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
const isArbitrarySize = (value) => getIsArbitraryValue(value, sizeLabels, isNever);
const isArbitraryPosition = (value) => getIsArbitraryValue(value, "position", isNever);
const imageLabels = /* @__PURE__ */ new Set(["image", "url"]);
const isArbitraryImage = (value) => getIsArbitraryValue(value, imageLabels, isImage);
const isArbitraryShadow = (value) => getIsArbitraryValue(value, "", isShadow);
const isAny = () => true;
const getIsArbitraryValue = (value, label, testValue) => {
  const result = arbitraryValueRegex.exec(value);
  if (result) {
    if (result[1]) {
      return typeof label === "string" ? result[1] === label : label.has(result[1]);
    }
    return testValue(result[2]);
  }
  return false;
};
const isLengthOnly = (value) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  lengthUnitRegex.test(value) && !colorFunctionRegex.test(value)
);
const isNever = () => false;
const isShadow = (value) => shadowRegex.test(value);
const isImage = (value) => imageRegex.test(value);
const getDefaultConfig = () => {
  const colors = fromTheme("colors");
  const spacing = fromTheme("spacing");
  const blur = fromTheme("blur");
  const brightness = fromTheme("brightness");
  const borderColor = fromTheme("borderColor");
  const borderRadius = fromTheme("borderRadius");
  const borderSpacing = fromTheme("borderSpacing");
  const borderWidth = fromTheme("borderWidth");
  const contrast = fromTheme("contrast");
  const grayscale = fromTheme("grayscale");
  const hueRotate = fromTheme("hueRotate");
  const invert = fromTheme("invert");
  const gap = fromTheme("gap");
  const gradientColorStops = fromTheme("gradientColorStops");
  const gradientColorStopPositions = fromTheme("gradientColorStopPositions");
  const inset = fromTheme("inset");
  const margin = fromTheme("margin");
  const opacity = fromTheme("opacity");
  const padding = fromTheme("padding");
  const saturate = fromTheme("saturate");
  const scale = fromTheme("scale");
  const sepia = fromTheme("sepia");
  const skew = fromTheme("skew");
  const space = fromTheme("space");
  const translate = fromTheme("translate");
  const getOverscroll = () => ["auto", "contain", "none"];
  const getOverflow = () => ["auto", "hidden", "clip", "visible", "scroll"];
  const getSpacingWithAutoAndArbitrary = () => ["auto", isArbitraryValue, spacing];
  const getSpacingWithArbitrary = () => [isArbitraryValue, spacing];
  const getLengthWithEmptyAndArbitrary = () => ["", isLength, isArbitraryLength];
  const getNumberWithAutoAndArbitrary = () => ["auto", isNumber, isArbitraryValue];
  const getPositions = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  const getLineStyles = () => ["solid", "dashed", "dotted", "double", "none"];
  const getBlendModes = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"];
  const getAlign = () => ["start", "end", "center", "between", "around", "evenly", "stretch"];
  const getZeroAndEmpty = () => ["", "0", isArbitraryValue];
  const getBreaks = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  const getNumberAndArbitrary = () => [isNumber, isArbitraryValue];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [isAny],
      spacing: [isLength, isArbitraryLength],
      blur: ["none", "", isTshirtSize, isArbitraryValue],
      brightness: getNumberAndArbitrary(),
      borderColor: [colors],
      borderRadius: ["none", "", "full", isTshirtSize, isArbitraryValue],
      borderSpacing: getSpacingWithArbitrary(),
      borderWidth: getLengthWithEmptyAndArbitrary(),
      contrast: getNumberAndArbitrary(),
      grayscale: getZeroAndEmpty(),
      hueRotate: getNumberAndArbitrary(),
      invert: getZeroAndEmpty(),
      gap: getSpacingWithArbitrary(),
      gradientColorStops: [colors],
      gradientColorStopPositions: [isPercent, isArbitraryLength],
      inset: getSpacingWithAutoAndArbitrary(),
      margin: getSpacingWithAutoAndArbitrary(),
      opacity: getNumberAndArbitrary(),
      padding: getSpacingWithArbitrary(),
      saturate: getNumberAndArbitrary(),
      scale: getNumberAndArbitrary(),
      sepia: getZeroAndEmpty(),
      skew: getNumberAndArbitrary(),
      space: getSpacingWithArbitrary(),
      translate: getSpacingWithArbitrary()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", isArbitraryValue]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [isTshirtSize]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": getBreaks()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": getBreaks()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...getPositions(), isArbitraryValue]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: getOverflow()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": getOverflow()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": getOverflow()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: getOverscroll()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": getOverscroll()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": getOverscroll()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [inset]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [inset]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [inset]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [inset]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [inset]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [inset]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [inset]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [inset]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [inset]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", isInteger, isArbitraryValue]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: getSpacingWithAutoAndArbitrary()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", isArbitraryValue]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: getZeroAndEmpty()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: getZeroAndEmpty()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", isInteger, isArbitraryValue]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [isAny]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", isInteger, isArbitraryValue]
        }, isArbitraryValue]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [isAny]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [isInteger, isArbitraryValue]
        }, isArbitraryValue]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [gap]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [gap]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [gap]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...getAlign()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...getAlign(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...getAlign(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [padding]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [padding]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [padding]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [padding]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [padding]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [padding]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [padding]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [padding]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [padding]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [margin]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [margin]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [margin]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [margin]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [margin]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [margin]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [margin]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [margin]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [margin]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [space]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [space]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", isArbitraryValue, spacing]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [isArbitraryValue, spacing, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [isArbitraryValue, spacing, "none", "full", "min", "max", "fit", "prose", {
          screen: [isTshirtSize]
        }, isTshirtSize]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [isArbitraryValue, spacing, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [isArbitraryValue, spacing, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [isArbitraryValue, spacing, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [isArbitraryValue, spacing, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", isTshirtSize, isArbitraryLength]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", isArbitraryNumber]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [isAny]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", isArbitraryValue]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", isNumber, isArbitraryNumber]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", isLength, isArbitraryValue]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", isArbitraryValue]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", isArbitraryValue]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [colors]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [opacity]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [colors]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [opacity]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...getLineStyles(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", isLength, isArbitraryLength]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", isLength, isArbitraryValue]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [colors]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: getSpacingWithArbitrary()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", isArbitraryValue]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", isArbitraryValue]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [opacity]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...getPositions(), isArbitraryPosition]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", isArbitrarySize]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, isArbitraryImage]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [colors]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [gradientColorStops]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [borderRadius]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [borderRadius]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [borderRadius]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [borderRadius]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [borderRadius]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [borderRadius]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [borderRadius]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [borderRadius]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [borderRadius]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [borderRadius]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [borderRadius]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [borderRadius]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [borderRadius]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [borderRadius]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [borderRadius]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [borderWidth]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [borderWidth]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [borderWidth]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [borderWidth]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [borderWidth]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [borderWidth]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [borderWidth]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [borderWidth]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [borderWidth]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [opacity]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...getLineStyles(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [borderWidth]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [borderWidth]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [opacity]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: getLineStyles()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [borderColor]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [borderColor]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [borderColor]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [borderColor]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [borderColor]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [borderColor]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [borderColor]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [borderColor]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...getLineStyles()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [isLength, isArbitraryValue]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [isLength, isArbitraryLength]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [colors]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: getLengthWithEmptyAndArbitrary()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [colors]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [opacity]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [isLength, isArbitraryLength]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [colors]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", isTshirtSize, isArbitraryShadow]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [isAny]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [opacity]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...getBlendModes(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": getBlendModes()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [blur]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [brightness]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [contrast]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", isTshirtSize, isArbitraryValue]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [grayscale]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [hueRotate]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [invert]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [saturate]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [sepia]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [blur]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [brightness]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [contrast]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [grayscale]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [hueRotate]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [invert]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [opacity]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [saturate]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [sepia]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [borderSpacing]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [borderSpacing]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [borderSpacing]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", isArbitraryValue]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: getNumberAndArbitrary()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", isArbitraryValue]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: getNumberAndArbitrary()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", isArbitraryValue]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [scale]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [scale]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [scale]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [isInteger, isArbitraryValue]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [translate]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [translate]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [skew]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [skew]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", isArbitraryValue]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", colors]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", isArbitraryValue]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [colors]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", isArbitraryValue]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [colors, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [isLength, isArbitraryLength, isArbitraryNumber]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [colors, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
};
const mergeConfigs = (baseConfig, {
  cacheSize,
  prefix,
  separator,
  experimentalParseClassName,
  extend = {},
  override = {}
}) => {
  overrideProperty(baseConfig, "cacheSize", cacheSize);
  overrideProperty(baseConfig, "prefix", prefix);
  overrideProperty(baseConfig, "separator", separator);
  overrideProperty(baseConfig, "experimentalParseClassName", experimentalParseClassName);
  for (const configKey in override) {
    overrideConfigProperties(baseConfig[configKey], override[configKey]);
  }
  for (const key in extend) {
    mergeConfigProperties(baseConfig[key], extend[key]);
  }
  return baseConfig;
};
const overrideProperty = (baseObject, overrideKey, overrideValue) => {
  if (overrideValue !== void 0) {
    baseObject[overrideKey] = overrideValue;
  }
};
const overrideConfigProperties = (baseObject, overrideObject) => {
  if (overrideObject) {
    for (const key in overrideObject) {
      overrideProperty(baseObject, key, overrideObject[key]);
    }
  }
};
const mergeConfigProperties = (baseObject, mergeObject) => {
  if (mergeObject) {
    for (const key in mergeObject) {
      const mergeValue = mergeObject[key];
      if (mergeValue !== void 0) {
        baseObject[key] = (baseObject[key] || []).concat(mergeValue);
      }
    }
  }
};
const extendTailwindMerge = (configExtension, ...createConfig) => typeof configExtension === "function" ? createTailwindMerge(getDefaultConfig, configExtension, ...createConfig) : createTailwindMerge(() => mergeConfigs(getDefaultConfig(), configExtension), ...createConfig);
const twMerge = /* @__PURE__ */ createTailwindMerge(getDefaultConfig);
var ie = { twMerge: true, twMergeConfig: {}, responsiveVariants: false }, _ = (s) => s || void 0, M = (...s) => _(y(s).filter(Boolean).join(" ")), R = null, v = {}, q = false, j = (...s) => (b$1) => b$1.twMerge ? ((!R || q) && (q = false, R = u(v) ? twMerge : extendTailwindMerge({ ...v, extend: { theme: v.theme, classGroups: v.classGroups, conflictingClassGroupModifiers: v.conflictingClassGroupModifiers, conflictingClassGroups: v.conflictingClassGroups, ...v.extend } })), _(R(M(s)))) : M(s), Z = (s, b) => {
  for (let e in b) s.hasOwnProperty(e) ? s[e] = M(s[e], b[e]) : s[e] = b[e];
  return s;
}, ce = (s, b$1) => {
  let { extend: e = null, slots: N = {}, variants: F = {}, compoundVariants: U = [], compoundSlots: C = [], defaultVariants: W = {} } = s, m = { ...ie, ...b$1 }, S = e != null && e.base ? M(e.base, s == null ? void 0 : s.base) : s == null ? void 0 : s.base, g$1 = e != null && e.variants && !u(e.variants) ? p(F, e.variants) : F, A = e != null && e.defaultVariants && !u(e.defaultVariants) ? { ...e.defaultVariants, ...W } : W;
  !u(m.twMergeConfig) && !x(m.twMergeConfig, v) && (q = true, v = m.twMergeConfig);
  let O = u(e == null ? void 0 : e.slots), $ = u(N) ? {} : { base: M(s == null ? void 0 : s.base, O && (e == null ? void 0 : e.base)), ...N }, w = O ? $ : Z({ ...e == null ? void 0 : e.slots }, u($) ? { base: s == null ? void 0 : s.base } : $), h$1 = u(e == null ? void 0 : e.compoundVariants) ? U : a(e == null ? void 0 : e.compoundVariants, U), V = (f) => {
    if (u(g$1) && u(N) && O) return j(S, f == null ? void 0 : f.class, f == null ? void 0 : f.className)(m);
    if (h$1 && !Array.isArray(h$1)) throw new TypeError(`The "compoundVariants" prop must be an array. Received: ${typeof h$1}`);
    if (C && !Array.isArray(C)) throw new TypeError(`The "compoundSlots" prop must be an array. Received: ${typeof C}`);
    let K = (t, n, a2 = [], i2) => {
      let r = a2;
      if (typeof n == "string") r = r.concat(g(n).split(" ").map((o) => `${t}:${o}`));
      else if (Array.isArray(n)) r = r.concat(n.reduce((o, c) => o.concat(`${t}:${c}`), []));
      else if (typeof n == "object" && typeof i2 == "string") {
        for (let o in n) if (n.hasOwnProperty(o) && o === i2) {
          let c = n[o];
          if (c && typeof c == "string") {
            let l2 = g(c);
            r[i2] ? r[i2] = r[i2].concat(l2.split(" ").map((u2) => `${t}:${u2}`)) : r[i2] = l2.split(" ").map((u2) => `${t}:${u2}`);
          } else Array.isArray(c) && c.length > 0 && (r[i2] = c.reduce((l2, u2) => l2.concat(`${t}:${u2}`), []));
        }
      }
      return r;
    }, z = (t, n = g$1, a$1 = null, i2 = null) => {
      var J;
      let r = n[t];
      if (!r || u(r)) return null;
      let o = (J = i2 == null ? void 0 : i2[t]) != null ? J : f == null ? void 0 : f[t];
      if (o === null) return null;
      let c = l(o), l$1 = Array.isArray(m.responsiveVariants) && m.responsiveVariants.length > 0 || m.responsiveVariants === true, u$1 = A == null ? void 0 : A[t], d = [];
      if (typeof c == "object" && l$1) for (let [T, L] of Object.entries(c)) {
        let ne = r[L];
        if (T === "initial") {
          u$1 = L;
          continue;
        }
        Array.isArray(m.responsiveVariants) && !m.responsiveVariants.includes(T) || (d = K(T, ne, d, a$1));
      }
      let ae = c != null && typeof c != "object" ? c : l(u$1), k = r[ae || "false"];
      return typeof d == "object" && typeof a$1 == "string" && d[a$1] ? Z(d, k) : d.length > 0 ? (d.push(k), d) : k;
    }, P = () => g$1 ? Object.keys(g$1).map((t) => z(t, g$1)) : null, p2 = (t, n) => {
      if (!g$1 || typeof g$1 != "object") return null;
      let a2 = new Array();
      for (let i2 in g$1) {
        let r = z(i2, g$1, t, n), o = t === "base" && typeof r == "string" ? r : r && r[t];
        o && (a2[a2.length] = o);
      }
      return a2;
    }, D = {};
    for (let t in f) f[t] !== void 0 && (D[t] = f[t]);
    let H = (t, n) => {
      var i2;
      let a2 = typeof (f == null ? void 0 : f[t]) == "object" ? { [t]: (i2 = f[t]) == null ? void 0 : i2.initial } : {};
      return { ...A, ...D, ...a2, ...n };
    }, I = (t = [], n) => {
      let a2 = [];
      for (let { class: i2, className: r, ...o } of t) {
        let c = true;
        for (let [l2, u2] of Object.entries(o)) {
          let d = H(l2, n);
          if (Array.isArray(u2)) {
            if (!u2.includes(d[l2])) {
              c = false;
              break;
            }
          } else if (d[l2] !== u2) {
            c = false;
            break;
          }
        }
        c && (i2 && a2.push(i2), r && a2.push(r));
      }
      return a2;
    }, ee = (t) => {
      let n = I(h$1, t);
      if (!Array.isArray(n)) return n;
      let a2 = {};
      for (let i2 of n) if (typeof i2 == "string" && (a2.base = j(a2.base, i2)(m)), typeof i2 == "object") for (let [r, o] of Object.entries(i2)) a2[r] = j(a2[r], o)(m);
      return a2;
    }, te = (t) => {
      if (C.length < 1) return null;
      let n = {};
      for (let { slots: a2 = [], class: i2, className: r, ...o } of C) {
        if (!u(o)) {
          let c = true;
          for (let l2 of Object.keys(o)) {
            let u2 = H(l2, t)[l2];
            if (u2 === void 0 || (Array.isArray(o[l2]) ? !o[l2].includes(u2) : o[l2] !== u2)) {
              c = false;
              break;
            }
          }
          if (!c) continue;
        }
        for (let c of a2) n[c] = n[c] || [], n[c].push([i2, r]);
      }
      return n;
    };
    if (!u(N) || !O) {
      let t = {};
      if (typeof w == "object" && !u(w)) for (let n of Object.keys(w)) t[n] = (a2) => {
        var i2, r;
        return j(w[n], p2(n, a2), ((i2 = ee(a2)) != null ? i2 : [])[n], ((r = te(a2)) != null ? r : [])[n], a2 == null ? void 0 : a2.class, a2 == null ? void 0 : a2.className)(m);
      };
      return t;
    }
    return j(S, P(), I(h$1), f == null ? void 0 : f.class, f == null ? void 0 : f.className)(m);
  }, x$1 = () => {
    if (!(!g$1 || typeof g$1 != "object")) return Object.keys(g$1);
  };
  return V.variantKeys = x$1(), V.extend = e, V.base = S, V.slots = w, V.variants = g$1, V.defaultVariants = A, V.compoundSlots = C, V.compoundVariants = h$1, V;
};
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const toKebabCase = (string) => string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const mergeClasses = (...classes) => classes.filter((className, index, array) => {
  return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
}).join(" ").trim();
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Icon$2 = forwardRef(
  ({
    color = "currentColor",
    size = 24,
    strokeWidth = 2,
    absoluteStrokeWidth,
    className = "",
    children,
    iconNode,
    ...rest
  }, ref) => {
    return createElement(
      "svg",
      {
        ref,
        ...defaultAttributes,
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: mergeClasses("lucide", className),
        ...rest
      },
      [
        ...iconNode.map(([tag, attrs]) => createElement(tag, attrs)),
        ...Array.isArray(children) ? children : [children]
      ]
    );
  }
);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const createLucideIcon = (iconName, iconNode) => {
  const Component2 = forwardRef(
    ({ className, ...props }, ref) => createElement(Icon$2, {
      ref,
      iconNode,
      className: mergeClasses(`lucide-${toKebabCase(iconName)}`, className),
      ...props
    })
  );
  Component2.displayName = `${iconName}`;
  return Component2;
};
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AArrowDown = createLucideIcon("AArrowDown", [
  ["path", { d: "M3.5 13h6", key: "p1my2r" }],
  ["path", { d: "m2 16 4.5-9 4.5 9", key: "ndf0b3" }],
  ["path", { d: "M18 7v9", key: "pknjwm" }],
  ["path", { d: "m14 12 4 4 4-4", key: "buelq4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AArrowUp = createLucideIcon("AArrowUp", [
  ["path", { d: "M3.5 13h6", key: "p1my2r" }],
  ["path", { d: "m2 16 4.5-9 4.5 9", key: "ndf0b3" }],
  ["path", { d: "M18 16V7", key: "ty0viw" }],
  ["path", { d: "m14 11 4-4 4 4", key: "1pu57t" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ALargeSmall = createLucideIcon("ALargeSmall", [
  ["path", { d: "M21 14h-5", key: "1vh23k" }],
  ["path", { d: "M16 16v-3.5a2.5 2.5 0 0 1 5 0V16", key: "1wh10o" }],
  ["path", { d: "M4.5 13h6", key: "dfilno" }],
  ["path", { d: "m3 16 4.5-9 4.5 9", key: "2dxa0e" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Accessibility = createLucideIcon("Accessibility", [
  ["circle", { cx: "16", cy: "4", r: "1", key: "1grugj" }],
  ["path", { d: "m18 19 1-7-6 1", key: "r0i19z" }],
  ["path", { d: "m5 8 3-3 5.5 3-2.36 3.5", key: "9ptxx2" }],
  ["path", { d: "M4.24 14.5a5 5 0 0 0 6.88 6", key: "10kmtu" }],
  ["path", { d: "M13.76 17.5a5 5 0 0 0-6.88-6", key: "2qq6rc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Activity = createLucideIcon("Activity", [
  [
    "path",
    {
      d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
      key: "169zse"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AirVent = createLucideIcon("AirVent", [
  [
    "path",
    {
      d: "M6 12H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
      key: "larmp2"
    }
  ],
  ["path", { d: "M6 8h12", key: "6g4wlu" }],
  ["path", { d: "M18.3 17.7a2.5 2.5 0 0 1-3.16 3.83 2.53 2.53 0 0 1-1.14-2V12", key: "1bo8pg" }],
  ["path", { d: "M6.6 15.6A2 2 0 1 0 10 17v-5", key: "t9h90c" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Airplay = createLucideIcon("Airplay", [
  [
    "path",
    {
      d: "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1",
      key: "ns4c3b"
    }
  ],
  ["path", { d: "m12 15 5 6H7Z", key: "14qnn2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlarmClockCheck = createLucideIcon("AlarmClockCheck", [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "m9 13 2 2 4-4", key: "6343dt" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlarmClockMinus = createLucideIcon("AlarmClockMinus", [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlarmClockOff = createLucideIcon("AlarmClockOff", [
  ["path", { d: "M6.87 6.87a8 8 0 1 0 11.26 11.26", key: "3on8tj" }],
  ["path", { d: "M19.9 14.25a8 8 0 0 0-9.15-9.15", key: "15ghsc" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.26 18.67 4 21", key: "yzmioq" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M4 4 2 6", key: "1ycko6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlarmClockPlus = createLucideIcon("AlarmClockPlus", [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlarmClock = createLucideIcon("AlarmClock", [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M12 9v4l2 2", key: "1c63tq" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlarmSmoke = createLucideIcon("AlarmSmoke", [
  ["path", { d: "M11 21c0-2.5 2-2.5 2-5", key: "1sicvv" }],
  ["path", { d: "M16 21c0-2.5 2-2.5 2-5", key: "1o3eny" }],
  ["path", { d: "m19 8-.8 3a1.25 1.25 0 0 1-1.2 1H7a1.25 1.25 0 0 1-1.2-1L5 8", key: "1bvca4" }],
  [
    "path",
    { d: "M21 3a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a1 1 0 0 1 1-1z", key: "x3qr1j" }
  ],
  ["path", { d: "M6 21c0-2.5 2-2.5 2-5", key: "i3w1gp" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Album = createLucideIcon("Album", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["polyline", { points: "11 3 11 11 14 8 17 11 17 3", key: "1wcwz3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignCenterHorizontal = createLucideIcon("AlignCenterHorizontal", [
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M10 16v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4", key: "11f1s0" }],
  ["path", { d: "M10 8V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4", key: "t14dx9" }],
  ["path", { d: "M20 16v1a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1", key: "1w07xs" }],
  ["path", { d: "M14 8V7c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v1", key: "1apec2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignCenterVertical = createLucideIcon("AlignCenterVertical", [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "M8 10H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h4", key: "14d6g8" }],
  ["path", { d: "M16 10h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4", key: "1e2lrw" }],
  ["path", { d: "M8 20H7a2 2 0 0 1-2-2v-2c0-1.1.9-2 2-2h1", key: "1fkdwx" }],
  ["path", { d: "M16 14h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1", key: "1euafb" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignCenter = createLucideIcon("AlignCenter", [
  ["path", { d: "M17 12H7", key: "16if0g" }],
  ["path", { d: "M19 18H5", key: "18s9l3" }],
  ["path", { d: "M21 6H3", key: "1jwq7v" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignEndHorizontal = createLucideIcon("AlignEndHorizontal", [
  ["rect", { width: "6", height: "16", x: "4", y: "2", rx: "2", key: "z5wdxg" }],
  ["rect", { width: "6", height: "9", x: "14", y: "9", rx: "2", key: "um7a8w" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignEndVertical = createLucideIcon("AlignEndVertical", [
  ["rect", { width: "16", height: "6", x: "2", y: "4", rx: "2", key: "10wcwx" }],
  ["rect", { width: "9", height: "6", x: "9", y: "14", rx: "2", key: "4p5bwg" }],
  ["path", { d: "M22 22V2", key: "12ipfv" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignHorizontalDistributeCenter = createLucideIcon("AlignHorizontalDistributeCenter", [
  ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
  ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
  ["path", { d: "M17 22v-5", key: "4b6g73" }],
  ["path", { d: "M17 7V2", key: "hnrr36" }],
  ["path", { d: "M7 22v-3", key: "1r4jpn" }],
  ["path", { d: "M7 5V2", key: "liy1u9" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignHorizontalDistributeEnd = createLucideIcon("AlignHorizontalDistributeEnd", [
  ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
  ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
  ["path", { d: "M10 2v20", key: "uyc634" }],
  ["path", { d: "M20 2v20", key: "1tx262" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignHorizontalDistributeStart = createLucideIcon("AlignHorizontalDistributeStart", [
  ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
  ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
  ["path", { d: "M4 2v20", key: "gtpd5x" }],
  ["path", { d: "M14 2v20", key: "tg6bpw" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignHorizontalJustifyCenter = createLucideIcon("AlignHorizontalJustifyCenter", [
  ["rect", { width: "6", height: "14", x: "2", y: "5", rx: "2", key: "dy24zr" }],
  ["rect", { width: "6", height: "10", x: "16", y: "7", rx: "2", key: "13zkjt" }],
  ["path", { d: "M12 2v20", key: "t6zp3m" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignHorizontalJustifyEnd = createLucideIcon("AlignHorizontalJustifyEnd", [
  ["rect", { width: "6", height: "14", x: "2", y: "5", rx: "2", key: "dy24zr" }],
  ["rect", { width: "6", height: "10", x: "12", y: "7", rx: "2", key: "1ht384" }],
  ["path", { d: "M22 2v20", key: "40qfg1" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignHorizontalJustifyStart = createLucideIcon("AlignHorizontalJustifyStart", [
  ["rect", { width: "6", height: "14", x: "6", y: "5", rx: "2", key: "hsirpf" }],
  ["rect", { width: "6", height: "10", x: "16", y: "7", rx: "2", key: "13zkjt" }],
  ["path", { d: "M2 2v20", key: "1ivd8o" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignHorizontalSpaceAround = createLucideIcon("AlignHorizontalSpaceAround", [
  ["rect", { width: "6", height: "10", x: "9", y: "7", rx: "2", key: "yn7j0q" }],
  ["path", { d: "M4 22V2", key: "tsjzd3" }],
  ["path", { d: "M20 22V2", key: "1bnhr8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignHorizontalSpaceBetween = createLucideIcon("AlignHorizontalSpaceBetween", [
  ["rect", { width: "6", height: "14", x: "3", y: "5", rx: "2", key: "j77dae" }],
  ["rect", { width: "6", height: "10", x: "15", y: "7", rx: "2", key: "bq30hj" }],
  ["path", { d: "M3 2v20", key: "1d2pfg" }],
  ["path", { d: "M21 2v20", key: "p059bm" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignJustify = createLucideIcon("AlignJustify", [
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M3 18h18", key: "1h113x" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignLeft = createLucideIcon("AlignLeft", [
  ["path", { d: "M15 12H3", key: "6jk70r" }],
  ["path", { d: "M17 18H3", key: "1amg6g" }],
  ["path", { d: "M21 6H3", key: "1jwq7v" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignRight = createLucideIcon("AlignRight", [
  ["path", { d: "M21 12H9", key: "dn1m92" }],
  ["path", { d: "M21 18H7", key: "1ygte8" }],
  ["path", { d: "M21 6H3", key: "1jwq7v" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignStartHorizontal = createLucideIcon("AlignStartHorizontal", [
  ["rect", { width: "6", height: "16", x: "4", y: "6", rx: "2", key: "1n4dg1" }],
  ["rect", { width: "6", height: "9", x: "14", y: "6", rx: "2", key: "17khns" }],
  ["path", { d: "M22 2H2", key: "fhrpnj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignStartVertical = createLucideIcon("AlignStartVertical", [
  ["rect", { width: "9", height: "6", x: "6", y: "14", rx: "2", key: "lpm2y7" }],
  ["rect", { width: "16", height: "6", x: "6", y: "4", rx: "2", key: "rdj6ps" }],
  ["path", { d: "M2 2v20", key: "1ivd8o" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignVerticalDistributeCenter = createLucideIcon("AlignVerticalDistributeCenter", [
  ["path", { d: "M22 17h-3", key: "1lwga1" }],
  ["path", { d: "M22 7h-5", key: "o2endc" }],
  ["path", { d: "M5 17H2", key: "1gx9xc" }],
  ["path", { d: "M7 7H2", key: "6bq26l" }],
  ["rect", { x: "5", y: "14", width: "14", height: "6", rx: "2", key: "1qrzuf" }],
  ["rect", { x: "7", y: "4", width: "10", height: "6", rx: "2", key: "we8e9z" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignVerticalDistributeEnd = createLucideIcon("AlignVerticalDistributeEnd", [
  ["rect", { width: "14", height: "6", x: "5", y: "14", rx: "2", key: "jmoj9s" }],
  ["rect", { width: "10", height: "6", x: "7", y: "4", rx: "2", key: "aza5on" }],
  ["path", { d: "M2 20h20", key: "owomy5" }],
  ["path", { d: "M2 10h20", key: "1ir3d8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignVerticalDistributeStart = createLucideIcon("AlignVerticalDistributeStart", [
  ["rect", { width: "14", height: "6", x: "5", y: "14", rx: "2", key: "jmoj9s" }],
  ["rect", { width: "10", height: "6", x: "7", y: "4", rx: "2", key: "aza5on" }],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M2 4h20", key: "mda7wb" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignVerticalJustifyCenter = createLucideIcon("AlignVerticalJustifyCenter", [
  ["rect", { width: "14", height: "6", x: "5", y: "16", rx: "2", key: "1i8z2d" }],
  ["rect", { width: "10", height: "6", x: "7", y: "2", rx: "2", key: "ypihtt" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignVerticalJustifyEnd = createLucideIcon("AlignVerticalJustifyEnd", [
  ["rect", { width: "14", height: "6", x: "5", y: "12", rx: "2", key: "4l4tp2" }],
  ["rect", { width: "10", height: "6", x: "7", y: "2", rx: "2", key: "ypihtt" }],
  ["path", { d: "M2 22h20", key: "272qi7" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignVerticalJustifyStart = createLucideIcon("AlignVerticalJustifyStart", [
  ["rect", { width: "14", height: "6", x: "5", y: "16", rx: "2", key: "1i8z2d" }],
  ["rect", { width: "10", height: "6", x: "7", y: "6", rx: "2", key: "13squh" }],
  ["path", { d: "M2 2h20", key: "1ennik" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignVerticalSpaceAround = createLucideIcon("AlignVerticalSpaceAround", [
  ["rect", { width: "10", height: "6", x: "7", y: "9", rx: "2", key: "b1zbii" }],
  ["path", { d: "M22 20H2", key: "1p1f7z" }],
  ["path", { d: "M22 4H2", key: "1b7qnq" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AlignVerticalSpaceBetween = createLucideIcon("AlignVerticalSpaceBetween", [
  ["rect", { width: "14", height: "6", x: "5", y: "15", rx: "2", key: "1w91an" }],
  ["rect", { width: "10", height: "6", x: "7", y: "3", rx: "2", key: "17wqzy" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }],
  ["path", { d: "M2 3h20", key: "91anmk" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ambulance = createLucideIcon("Ambulance", [
  ["path", { d: "M10 10H6", key: "1bsnug" }],
  ["path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2", key: "wrbu53" }],
  [
    "path",
    {
      d: "M19 18h2a1 1 0 0 0 1-1v-3.28a1 1 0 0 0-.684-.948l-1.923-.641a1 1 0 0 1-.578-.502l-1.539-3.076A1 1 0 0 0 16.382 8H14",
      key: "lrkjwd"
    }
  ],
  ["path", { d: "M8 8v4", key: "1fwk8c" }],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["circle", { cx: "17", cy: "18", r: "2", key: "332jqn" }],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ampersand = createLucideIcon("Ampersand", [
  [
    "path",
    {
      d: "M17.5 12c0 4.4-3.6 8-8 8A4.5 4.5 0 0 1 5 15.5c0-6 8-4 8-8.5a3 3 0 1 0-6 0c0 3 2.5 8.5 12 13",
      key: "1o9ehi"
    }
  ],
  ["path", { d: "M16 12h3", key: "4uvgyw" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ampersands = createLucideIcon("Ampersands", [
  [
    "path",
    {
      d: "M10 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5",
      key: "12lh1k"
    }
  ],
  [
    "path",
    {
      d: "M22 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5",
      key: "173c68"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Amphora = createLucideIcon("Amphora", [
  [
    "path",
    { d: "M10 2v5.632c0 .424-.272.795-.653.982A6 6 0 0 0 6 14c.006 4 3 7 5 8", key: "1h8rid" }
  ],
  ["path", { d: "M10 5H8a2 2 0 0 0 0 4h.68", key: "3ezsi6" }],
  ["path", { d: "M14 2v5.632c0 .424.272.795.652.982A6 6 0 0 1 18 14c0 4-3 7-5 8", key: "yt6q09" }],
  ["path", { d: "M14 5h2a2 2 0 0 1 0 4h-.68", key: "8f95yk" }],
  ["path", { d: "M18 22H6", key: "mg6kv4" }],
  ["path", { d: "M9 2h6", key: "1jrp98" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Anchor = createLucideIcon("Anchor", [
  ["path", { d: "M12 22V8", key: "qkxhtm" }],
  ["path", { d: "M5 12H2a10 10 0 0 0 20 0h-3", key: "1hv3nh" }],
  ["circle", { cx: "12", cy: "5", r: "3", key: "rqqgnr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Angry = createLucideIcon("Angry", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2", key: "epbg0q" }],
  ["path", { d: "M7.5 8 10 9", key: "olxxln" }],
  ["path", { d: "m14 9 2.5-1", key: "1j6cij" }],
  ["path", { d: "M9 10h.01", key: "qbtxuw" }],
  ["path", { d: "M15 10h.01", key: "1qmjsl" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Annoyed = createLucideIcon("Annoyed", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 15h8", key: "45n4r" }],
  ["path", { d: "M8 9h2", key: "1g203m" }],
  ["path", { d: "M14 9h2", key: "116p9w" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Antenna = createLucideIcon("Antenna", [
  ["path", { d: "M2 12 7 2", key: "117k30" }],
  ["path", { d: "m7 12 5-10", key: "1tvx22" }],
  ["path", { d: "m12 12 5-10", key: "ev1o1a" }],
  ["path", { d: "m17 12 5-10", key: "1e4ti3" }],
  ["path", { d: "M4.5 7h15", key: "vlsxkz" }],
  ["path", { d: "M12 16v6", key: "c8a4gj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Anvil = createLucideIcon("Anvil", [
  ["path", { d: "M7 10H6a4 4 0 0 1-4-4 1 1 0 0 1 1-1h4", key: "1hjpb6" }],
  [
    "path",
    { d: "M7 5a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1 7 7 0 0 1-7 7H8a1 1 0 0 1-1-1z", key: "1qn45f" }
  ],
  ["path", { d: "M9 12v5", key: "3anwtq" }],
  ["path", { d: "M15 12v5", key: "5xh3zn" }],
  [
    "path",
    { d: "M5 20a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3 1 1 0 0 1-1 1H6a1 1 0 0 1-1-1", key: "1fi4x8" }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Aperture = createLucideIcon("Aperture", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m14.31 8 5.74 9.94", key: "1y6ab4" }],
  ["path", { d: "M9.69 8h11.48", key: "1wxppr" }],
  ["path", { d: "m7.38 12 5.74-9.94", key: "1grp0k" }],
  ["path", { d: "M9.69 16 3.95 6.06", key: "libnyf" }],
  ["path", { d: "M14.31 16H2.83", key: "x5fava" }],
  ["path", { d: "m16.62 12-5.74 9.94", key: "1vwawt" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AppWindowMac = createLucideIcon("AppWindowMac", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M6 8h.01", key: "x9i8wu" }],
  ["path", { d: "M10 8h.01", key: "1r9ogq" }],
  ["path", { d: "M14 8h.01", key: "1primd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AppWindow = createLucideIcon("AppWindow", [
  ["rect", { x: "2", y: "4", width: "20", height: "16", rx: "2", key: "izxlao" }],
  ["path", { d: "M10 4v4", key: "pp8u80" }],
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["path", { d: "M6 4v4", key: "1svtjw" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Apple = createLucideIcon("Apple", [
  [
    "path",
    {
      d: "M12 20.94c1.5 0 2.75 1.06 4 1.06 3 0 6-8 6-12.22A4.91 4.91 0 0 0 17 5c-2.22 0-4 1.44-5 2-1-.56-2.78-2-5-2a4.9 4.9 0 0 0-5 4.78C2 14 5 22 8 22c1.25 0 2.5-1.06 4-1.06Z",
      key: "3s7exb"
    }
  ],
  ["path", { d: "M10 2c1 .5 2 2 2 5", key: "fcco2y" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArchiveRestore = createLucideIcon("ArchiveRestore", [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h2", key: "tvwodi" }],
  ["path", { d: "M20 8v11a2 2 0 0 1-2 2h-2", key: "1gkqxj" }],
  ["path", { d: "m9 15 3-3 3 3", key: "1pd0qc" }],
  ["path", { d: "M12 12v9", key: "192myk" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArchiveX = createLucideIcon("ArchiveX", [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8", key: "1s80jp" }],
  ["path", { d: "m9.5 17 5-5", key: "nakeu6" }],
  ["path", { d: "m9.5 12 5 5", key: "1hccrj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Archive = createLucideIcon("Archive", [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8", key: "1s80jp" }],
  ["path", { d: "M10 12h4", key: "a56b0p" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Armchair = createLucideIcon("Armchair", [
  ["path", { d: "M19 9V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3", key: "irtipd" }],
  [
    "path",
    {
      d: "M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z",
      key: "1qyhux"
    }
  ],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowBigDownDash = createLucideIcon("ArrowBigDownDash", [
  ["path", { d: "M15 5H9", key: "1tp3ed" }],
  ["path", { d: "M15 9v3h4l-7 7-7-7h4V9z", key: "ncdc4b" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowBigDown = createLucideIcon("ArrowBigDown", [
  ["path", { d: "M15 6v6h4l-7 7-7-7h4V6h6z", key: "1thax2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowBigLeftDash = createLucideIcon("ArrowBigLeftDash", [
  ["path", { d: "M19 15V9", key: "1hci5f" }],
  ["path", { d: "M15 15h-3v4l-7-7 7-7v4h3v6z", key: "16tjna" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowBigLeft = createLucideIcon("ArrowBigLeft", [
  ["path", { d: "M18 15h-6v4l-7-7 7-7v4h6v6z", key: "lbrdak" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowBigRightDash = createLucideIcon("ArrowBigRightDash", [
  ["path", { d: "M5 9v6", key: "158jrl" }],
  ["path", { d: "M9 9h3V5l7 7-7 7v-4H9V9z", key: "1sg2xn" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowBigRight = createLucideIcon("ArrowBigRight", [
  ["path", { d: "M6 9h6V5l7 7-7 7v-4H6V9z", key: "7fvt9c" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowBigUpDash = createLucideIcon("ArrowBigUpDash", [
  ["path", { d: "M9 19h6", key: "456am0" }],
  ["path", { d: "M9 15v-3H5l7-7 7 7h-4v3H9z", key: "1r2uve" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowBigUp = createLucideIcon("ArrowBigUp", [
  ["path", { d: "M9 18v-6H5l7-7 7 7h-4v6H9z", key: "1x06kx" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowDown01 = createLucideIcon("ArrowDown01", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["rect", { x: "15", y: "4", width: "4", height: "6", ry: "2", key: "1bwicg" }],
  ["path", { d: "M17 20v-6h-2", key: "1qp1so" }],
  ["path", { d: "M15 20h4", key: "1j968p" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowDown10 = createLucideIcon("ArrowDown10", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M17 10V4h-2", key: "zcsr5x" }],
  ["path", { d: "M15 10h4", key: "id2lce" }],
  ["rect", { x: "15", y: "14", width: "4", height: "6", ry: "2", key: "33xykx" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowDownAZ = createLucideIcon("ArrowDownAZ", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M20 8h-5", key: "1vsyxs" }],
  ["path", { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10", key: "ag13bf" }],
  ["path", { d: "M15 14h5l-5 6h5", key: "ur5jdg" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowDownFromLine = createLucideIcon("ArrowDownFromLine", [
  ["path", { d: "M19 3H5", key: "1236rx" }],
  ["path", { d: "M12 21V7", key: "gj6g52" }],
  ["path", { d: "m6 15 6 6 6-6", key: "h15q88" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowDownLeft = createLucideIcon("ArrowDownLeft", [
  ["path", { d: "M17 7 7 17", key: "15tmo1" }],
  ["path", { d: "M17 17H7V7", key: "1org7z" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowDownNarrowWide = createLucideIcon("ArrowDownNarrowWide", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M11 4h4", key: "6d7r33" }],
  ["path", { d: "M11 8h7", key: "djye34" }],
  ["path", { d: "M11 12h10", key: "1438ji" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowDownRight = createLucideIcon("ArrowDownRight", [
  ["path", { d: "m7 7 10 10", key: "1fmybs" }],
  ["path", { d: "M17 7v10H7", key: "6fjiku" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowDownToDot = createLucideIcon("ArrowDownToDot", [
  ["path", { d: "M12 2v14", key: "jyx4ut" }],
  ["path", { d: "m19 9-7 7-7-7", key: "1oe3oy" }],
  ["circle", { cx: "12", cy: "21", r: "1", key: "o0uj5v" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowDownToLine = createLucideIcon("ArrowDownToLine", [
  ["path", { d: "M12 17V3", key: "1cwfxf" }],
  ["path", { d: "m6 11 6 6 6-6", key: "12ii2o" }],
  ["path", { d: "M19 21H5", key: "150jfl" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowDownUp = createLucideIcon("ArrowDownUp", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "m21 8-4-4-4 4", key: "1c9v7m" }],
  ["path", { d: "M17 4v16", key: "7dpous" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowDownWideNarrow = createLucideIcon("ArrowDownWideNarrow", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M11 4h10", key: "1w87gc" }],
  ["path", { d: "M11 8h7", key: "djye34" }],
  ["path", { d: "M11 12h4", key: "q8tih4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowDownZA = createLucideIcon("ArrowDownZA", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M15 4h5l-5 6h5", key: "8asdl1" }],
  ["path", { d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20", key: "r6l5cz" }],
  ["path", { d: "M20 18h-5", key: "18j1r2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowDown = createLucideIcon("ArrowDown", [
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowLeftFromLine = createLucideIcon("ArrowLeftFromLine", [
  ["path", { d: "m9 6-6 6 6 6", key: "7v63n9" }],
  ["path", { d: "M3 12h14", key: "13k4hi" }],
  ["path", { d: "M21 19V5", key: "b4bplr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowLeftRight = createLucideIcon("ArrowLeftRight", [
  ["path", { d: "M8 3 4 7l4 4", key: "9rb6wj" }],
  ["path", { d: "M4 7h16", key: "6tx8e3" }],
  ["path", { d: "m16 21 4-4-4-4", key: "siv7j2" }],
  ["path", { d: "M20 17H4", key: "h6l3hr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowLeftToLine = createLucideIcon("ArrowLeftToLine", [
  ["path", { d: "M3 19V5", key: "rwsyhb" }],
  ["path", { d: "m13 6-6 6 6 6", key: "1yhaz7" }],
  ["path", { d: "M7 12h14", key: "uoisry" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowLeft = createLucideIcon("ArrowLeft", [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowRightFromLine = createLucideIcon("ArrowRightFromLine", [
  ["path", { d: "M3 5v14", key: "1nt18q" }],
  ["path", { d: "M21 12H7", key: "13ipq5" }],
  ["path", { d: "m15 18 6-6-6-6", key: "6tx3qv" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowRightLeft = createLucideIcon("ArrowRightLeft", [
  ["path", { d: "m16 3 4 4-4 4", key: "1x1c3m" }],
  ["path", { d: "M20 7H4", key: "zbl0bi" }],
  ["path", { d: "m8 21-4-4 4-4", key: "h9nckh" }],
  ["path", { d: "M4 17h16", key: "g4d7ey" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowRightToLine = createLucideIcon("ArrowRightToLine", [
  ["path", { d: "M17 12H3", key: "8awo09" }],
  ["path", { d: "m11 18 6-6-6-6", key: "8c2y43" }],
  ["path", { d: "M21 5v14", key: "nzette" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowRight = createLucideIcon("ArrowRight", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowUp01 = createLucideIcon("ArrowUp01", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["rect", { x: "15", y: "4", width: "4", height: "6", ry: "2", key: "1bwicg" }],
  ["path", { d: "M17 20v-6h-2", key: "1qp1so" }],
  ["path", { d: "M15 20h4", key: "1j968p" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowUp10 = createLucideIcon("ArrowUp10", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M17 10V4h-2", key: "zcsr5x" }],
  ["path", { d: "M15 10h4", key: "id2lce" }],
  ["rect", { x: "15", y: "14", width: "4", height: "6", ry: "2", key: "33xykx" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowUpAZ = createLucideIcon("ArrowUpAZ", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M20 8h-5", key: "1vsyxs" }],
  ["path", { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10", key: "ag13bf" }],
  ["path", { d: "M15 14h5l-5 6h5", key: "ur5jdg" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowUpDown = createLucideIcon("ArrowUpDown", [
  ["path", { d: "m21 16-4 4-4-4", key: "f6ql7i" }],
  ["path", { d: "M17 20V4", key: "1ejh1v" }],
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowUpFromDot = createLucideIcon("ArrowUpFromDot", [
  ["path", { d: "m5 9 7-7 7 7", key: "1hw5ic" }],
  ["path", { d: "M12 16V2", key: "ywoabb" }],
  ["circle", { cx: "12", cy: "21", r: "1", key: "o0uj5v" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowUpFromLine = createLucideIcon("ArrowUpFromLine", [
  ["path", { d: "m18 9-6-6-6 6", key: "kcunyi" }],
  ["path", { d: "M12 3v14", key: "7cf3v8" }],
  ["path", { d: "M5 21h14", key: "11awu3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowUpLeft = createLucideIcon("ArrowUpLeft", [
  ["path", { d: "M7 17V7h10", key: "11bw93" }],
  ["path", { d: "M17 17 7 7", key: "2786uv" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowUpNarrowWide = createLucideIcon("ArrowUpNarrowWide", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M11 12h4", key: "q8tih4" }],
  ["path", { d: "M11 16h7", key: "uosisv" }],
  ["path", { d: "M11 20h10", key: "jvxblo" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowUpRight = createLucideIcon("ArrowUpRight", [
  ["path", { d: "M7 7h10v10", key: "1tivn9" }],
  ["path", { d: "M7 17 17 7", key: "1vkiza" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowUpToLine = createLucideIcon("ArrowUpToLine", [
  ["path", { d: "M5 3h14", key: "7usisc" }],
  ["path", { d: "m18 13-6-6-6 6", key: "1kf1n9" }],
  ["path", { d: "M12 7v14", key: "1akyts" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowUpWideNarrow = createLucideIcon("ArrowUpWideNarrow", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M11 12h10", key: "1438ji" }],
  ["path", { d: "M11 16h7", key: "uosisv" }],
  ["path", { d: "M11 20h4", key: "1krc32" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowUpZA = createLucideIcon("ArrowUpZA", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M15 4h5l-5 6h5", key: "8asdl1" }],
  ["path", { d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20", key: "r6l5cz" }],
  ["path", { d: "M20 18h-5", key: "18j1r2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowUp = createLucideIcon("ArrowUp", [
  ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
  ["path", { d: "M12 19V5", key: "x0mq9r" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ArrowsUpFromLine = createLucideIcon("ArrowsUpFromLine", [
  ["path", { d: "m4 6 3-3 3 3", key: "9aidw8" }],
  ["path", { d: "M7 17V3", key: "19qxw1" }],
  ["path", { d: "m14 6 3-3 3 3", key: "6iy689" }],
  ["path", { d: "M17 17V3", key: "o0fmgi" }],
  ["path", { d: "M4 21h16", key: "1h09gz" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Asterisk = createLucideIcon("Asterisk", [
  ["path", { d: "M12 6v12", key: "1vza4d" }],
  ["path", { d: "M17.196 9 6.804 15", key: "1ah31z" }],
  ["path", { d: "m6.804 9 10.392 6", key: "1b6pxd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AtSign = createLucideIcon("AtSign", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8", key: "7n84p3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Atom = createLucideIcon("Atom", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  [
    "path",
    {
      d: "M20.2 20.2c2.04-2.03.02-7.36-4.5-11.9-4.54-4.52-9.87-6.54-11.9-4.5-2.04 2.03-.02 7.36 4.5 11.9 4.54 4.52 9.87 6.54 11.9 4.5Z",
      key: "1l2ple"
    }
  ],
  [
    "path",
    {
      d: "M15.7 15.7c4.52-4.54 6.54-9.87 4.5-11.9-2.03-2.04-7.36-.02-11.9 4.5-4.52 4.54-6.54 9.87-4.5 11.9 2.03 2.04 7.36.02 11.9-4.5Z",
      key: "1wam0m"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AudioLines = createLucideIcon("AudioLines", [
  ["path", { d: "M2 10v3", key: "1fnikh" }],
  ["path", { d: "M6 6v11", key: "11sgs0" }],
  ["path", { d: "M10 3v18", key: "yhl04a" }],
  ["path", { d: "M14 8v7", key: "3a1oy3" }],
  ["path", { d: "M18 5v13", key: "123xd1" }],
  ["path", { d: "M22 10v3", key: "154ddg" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AudioWaveform = createLucideIcon("AudioWaveform", [
  [
    "path",
    {
      d: "M2 13a2 2 0 0 0 2-2V7a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0V4a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0v-4a2 2 0 0 1 2-2",
      key: "57tc96"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Award = createLucideIcon("Award", [
  [
    "path",
    {
      d: "m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526",
      key: "1yiouv"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "6", key: "1vp47v" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Axe = createLucideIcon("Axe", [
  ["path", { d: "m14 12-8.5 8.5a2.12 2.12 0 1 1-3-3L11 9", key: "csbz4o" }],
  ["path", { d: "M15 13 9 7l4-4 6 6h3a8 8 0 0 1-7 7z", key: "113wfo" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Axis3d = createLucideIcon("Axis3d", [
  ["path", { d: "M4 4v16h16", key: "1s015l" }],
  ["path", { d: "m4 20 7-7", key: "17qe9y" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Baby = createLucideIcon("Baby", [
  ["path", { d: "M9 12h.01", key: "157uk2" }],
  ["path", { d: "M15 12h.01", key: "1k8ypt" }],
  ["path", { d: "M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5", key: "1u7htd" }],
  [
    "path",
    {
      d: "M19 6.3a9 9 0 0 1 1.8 3.9 2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1",
      key: "5yv0yz"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Backpack = createLucideIcon("Backpack", [
  [
    "path",
    { d: "M4 10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z", key: "1ol0lm" }
  ],
  ["path", { d: "M8 10h8", key: "c7uz4u" }],
  ["path", { d: "M8 18h8", key: "1no2b1" }],
  ["path", { d: "M8 22v-6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v6", key: "1fr6do" }],
  ["path", { d: "M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2", key: "donm21" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BadgeAlert = createLucideIcon("BadgeAlert", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BadgeCent = createLucideIcon("BadgeCent", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M15.4 10a4 4 0 1 0 0 4", key: "2eqtx8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BadgeCheck = createLucideIcon("BadgeCheck", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BadgeDollarSign = createLucideIcon("BadgeDollarSign", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BadgeEuro = createLucideIcon("BadgeEuro", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M7 12h5", key: "gblrwe" }],
  ["path", { d: "M15 9.4a4 4 0 1 0 0 5.2", key: "1makmb" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BadgeHelp = createLucideIcon("BadgeHelp", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["line", { x1: "12", x2: "12.01", y1: "17", y2: "17", key: "io3f8k" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BadgeIndianRupee = createLucideIcon("BadgeIndianRupee", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M8 8h8", key: "1bis0t" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m13 17-5-1h1a4 4 0 0 0 0-8", key: "nu2bwa" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BadgeInfo = createLucideIcon("BadgeInfo", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "12", key: "1y1yb1" }],
  ["line", { x1: "12", x2: "12.01", y1: "8", y2: "8", key: "110wyk" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BadgeJapaneseYen = createLucideIcon("BadgeJapaneseYen", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m9 8 3 3v7", key: "17yadx" }],
  ["path", { d: "m12 11 3-3", key: "p4cfq1" }],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M9 16h6", key: "8wimt3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BadgeMinus = createLucideIcon("BadgeMinus", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BadgePercent = createLucideIcon("BadgePercent", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BadgePlus = createLucideIcon("BadgePlus", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "16", key: "10p56q" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BadgePoundSterling = createLucideIcon("BadgePoundSterling", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M8 12h4", key: "qz6y1c" }],
  ["path", { d: "M10 16V9.5a2.5 2.5 0 0 1 5 0", key: "3mlbjk" }],
  ["path", { d: "M8 16h7", key: "sbedsn" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BadgeRussianRuble = createLucideIcon("BadgeRussianRuble", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M9 16h5", key: "1syiyw" }],
  ["path", { d: "M9 12h5a2 2 0 1 0 0-4h-3v9", key: "1ge9c1" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BadgeSwissFranc = createLucideIcon("BadgeSwissFranc", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M11 17V8h4", key: "1bfq6y" }],
  ["path", { d: "M11 12h3", key: "2eqnfz" }],
  ["path", { d: "M9 16h4", key: "1skf3a" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BadgeX = createLucideIcon("BadgeX", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "15", x2: "9", y1: "9", y2: "15", key: "f7djnv" }],
  ["line", { x1: "9", x2: "15", y1: "9", y2: "15", key: "1shsy8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Badge = createLucideIcon("Badge", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BaggageClaim = createLucideIcon("BaggageClaim", [
  ["path", { d: "M22 18H6a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2", key: "4irg2o" }],
  ["path", { d: "M17 14V4a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v10", key: "14fcyx" }],
  ["rect", { width: "13", height: "8", x: "8", y: "6", rx: "1", key: "o6oiis" }],
  ["circle", { cx: "18", cy: "20", r: "2", key: "t9985n" }],
  ["circle", { cx: "9", cy: "20", r: "2", key: "e5v82j" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ban = createLucideIcon("Ban", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m4.9 4.9 14.2 14.2", key: "1m5liu" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Banana = createLucideIcon("Banana", [
  ["path", { d: "M4 13c3.5-2 8-2 10 2a5.5 5.5 0 0 1 8 5", key: "1cscit" }],
  [
    "path",
    {
      d: "M5.15 17.89c5.52-1.52 8.65-6.89 7-12C11.55 4 11.5 2 13 2c3.22 0 5 5.5 5 8 0 6.5-4.2 12-10.49 12C5.11 22 2 22 2 20c0-1.5 1.14-1.55 3.15-2.11Z",
      key: "1y1nbv"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bandage = createLucideIcon("Bandage", [
  ["path", { d: "M10 10.01h.01", key: "1e9xi7" }],
  ["path", { d: "M10 14.01h.01", key: "ac23bv" }],
  ["path", { d: "M14 10.01h.01", key: "2wfrvf" }],
  ["path", { d: "M14 14.01h.01", key: "8tw8yn" }],
  ["path", { d: "M18 6v11.5", key: "dkbidh" }],
  ["path", { d: "M6 6v12", key: "vkc79e" }],
  ["rect", { x: "2", y: "6", width: "20", height: "12", rx: "2", key: "1wpnh2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Banknote = createLucideIcon("Banknote", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M6 12h.01M18 12h.01", key: "113zkx" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Barcode = createLucideIcon("Barcode", [
  ["path", { d: "M3 5v14", key: "1nt18q" }],
  ["path", { d: "M8 5v14", key: "1ybrkv" }],
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "M17 5v14", key: "ycjyhj" }],
  ["path", { d: "M21 5v14", key: "nzette" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Baseline = createLucideIcon("Baseline", [
  ["path", { d: "M4 20h16", key: "14thso" }],
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bath = createLucideIcon("Bath", [
  [
    "path",
    {
      d: "M9 6 6.5 3.5a1.5 1.5 0 0 0-1-.5C4.683 3 4 3.683 4 4.5V17a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5",
      key: "1r8yf5"
    }
  ],
  ["line", { x1: "10", x2: "8", y1: "5", y2: "7", key: "h5g8z4" }],
  ["line", { x1: "2", x2: "22", y1: "12", y2: "12", key: "1dnqot" }],
  ["line", { x1: "7", x2: "7", y1: "19", y2: "21", key: "16jp00" }],
  ["line", { x1: "17", x2: "17", y1: "19", y2: "21", key: "1pxrnk" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BatteryCharging = createLucideIcon("BatteryCharging", [
  ["path", { d: "M15 7h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2", key: "1sdynx" }],
  ["path", { d: "M6 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h1", key: "1gkd3k" }],
  ["path", { d: "m11 7-3 5h4l-3 5", key: "b4a64w" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BatteryFull = createLucideIcon("BatteryFull", [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "13", key: "haxvl5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "13", key: "c6fn6x" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BatteryLow = createLucideIcon("BatteryLow", [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BatteryMedium = createLucideIcon("BatteryMedium", [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "13", key: "haxvl5" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BatteryWarning = createLucideIcon("BatteryWarning", [
  ["path", { d: "M10 17h.01", key: "nbq80n" }],
  ["path", { d: "M10 7v6", key: "nne03l" }],
  ["path", { d: "M14 7h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2", key: "1x5o8m" }],
  ["path", { d: "M22 11v2", key: "1wo06k" }],
  ["path", { d: "M6 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2", key: "1mdjgh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Battery = createLucideIcon("Battery", [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Beaker = createLucideIcon("Beaker", [
  ["path", { d: "M4.5 3h15", key: "c7n0jr" }],
  ["path", { d: "M6 3v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3", key: "m1uhx7" }],
  ["path", { d: "M6 14h12", key: "4cwo0f" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BeanOff = createLucideIcon("BeanOff", [
  [
    "path",
    {
      d: "M9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22a13.96 13.96 0 0 0 9.9-4.1",
      key: "bq3udt"
    }
  ],
  ["path", { d: "M10.75 5.093A6 6 0 0 1 22 8c0 2.411-.61 4.68-1.683 6.66", key: "17ccse" }],
  [
    "path",
    {
      d: "M5.341 10.62a4 4 0 0 0 6.487 1.208M10.62 5.341a4.015 4.015 0 0 1 2.039 2.04",
      key: "18zqgq"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bean = createLucideIcon("Bean", [
  [
    "path",
    {
      d: "M10.165 6.598C9.954 7.478 9.64 8.36 9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22c7.732 0 14-6.268 14-14a6 6 0 0 0-11.835-1.402Z",
      key: "1tvzk7"
    }
  ],
  ["path", { d: "M5.341 10.62a4 4 0 1 0 5.279-5.28", key: "2cyri2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BedDouble = createLucideIcon("BedDouble", [
  ["path", { d: "M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8", key: "1k78r4" }],
  ["path", { d: "M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4", key: "fb3tl2" }],
  ["path", { d: "M12 4v6", key: "1dcgq2" }],
  ["path", { d: "M2 18h20", key: "ajqnye" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BedSingle = createLucideIcon("BedSingle", [
  ["path", { d: "M3 20v-8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8", key: "1wm6mi" }],
  ["path", { d: "M5 10V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4", key: "4k93s5" }],
  ["path", { d: "M3 18h18", key: "1h113x" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bed = createLucideIcon("Bed", [
  ["path", { d: "M2 4v16", key: "vw9hq8" }],
  ["path", { d: "M2 8h18a2 2 0 0 1 2 2v10", key: "1dgv2r" }],
  ["path", { d: "M2 17h20", key: "18nfp3" }],
  ["path", { d: "M6 8v9", key: "1yriud" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Beef = createLucideIcon("Beef", [
  ["circle", { cx: "12.5", cy: "8.5", r: "2.5", key: "9738u8" }],
  [
    "path",
    {
      d: "M12.5 2a6.5 6.5 0 0 0-6.22 4.6c-1.1 3.13-.78 3.9-3.18 6.08A3 3 0 0 0 5 18c4 0 8.4-1.8 11.4-4.3A6.5 6.5 0 0 0 12.5 2Z",
      key: "o0f6za"
    }
  ],
  [
    "path",
    {
      d: "m18.5 6 2.19 4.5a6.48 6.48 0 0 1 .31 2 6.49 6.49 0 0 1-2.6 5.2C15.4 20.2 11 22 7 22a3 3 0 0 1-2.68-1.66L2.4 16.5",
      key: "k7p6i0"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BeerOff = createLucideIcon("BeerOff", [
  ["path", { d: "M13 13v5", key: "igwfh0" }],
  ["path", { d: "M17 11.47V8", key: "16yw0g" }],
  ["path", { d: "M17 11h1a3 3 0 0 1 2.745 4.211", key: "1xbt65" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-3", key: "c55o3e" }],
  [
    "path",
    { d: "M7.536 7.535C6.766 7.649 6.154 8 5.5 8a2.5 2.5 0 0 1-1.768-4.268", key: "1ydug7" }
  ],
  [
    "path",
    {
      d: "M8.727 3.204C9.306 2.767 9.885 2 11 2c1.56 0 2 1.5 3 1.5s1.72-.5 2.5-.5a1 1 0 1 1 0 5c-.78 0-1.5-.5-2.5-.5a3.149 3.149 0 0 0-.842.12",
      key: "q81o7q"
    }
  ],
  ["path", { d: "M9 14.6V18", key: "20ek98" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Beer = createLucideIcon("Beer", [
  ["path", { d: "M17 11h1a3 3 0 0 1 0 6h-1", key: "1yp76v" }],
  ["path", { d: "M9 12v6", key: "1u1cab" }],
  ["path", { d: "M13 12v6", key: "1sugkk" }],
  [
    "path",
    {
      d: "M14 7.5c-1 0-1.44.5-3 .5s-2-.5-3-.5-1.72.5-2.5.5a2.5 2.5 0 0 1 0-5c.78 0 1.57.5 2.5.5S9.44 2 11 2s2 1.5 3 1.5 1.72-.5 2.5-.5a2.5 2.5 0 0 1 0 5c-.78 0-1.5-.5-2.5-.5Z",
      key: "1510fo"
    }
  ],
  ["path", { d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8", key: "19jb7n" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BellDot = createLucideIcon("BellDot", [
  [
    "path",
    {
      d: "M19.4 14.9C20.2 16.4 21 17 21 17H3s3-2 3-9c0-3.3 2.7-6 6-6 .7 0 1.3.1 1.9.3",
      key: "xcehk"
    }
  ],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
  ["circle", { cx: "18", cy: "8", r: "3", key: "1g0gzu" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BellElectric = createLucideIcon("BellElectric", [
  ["path", { d: "M18.8 4A6.3 8.7 0 0 1 20 9", key: "xve1fh" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["circle", { cx: "9", cy: "9", r: "7", key: "p2h5vp" }],
  ["rect", { width: "10", height: "6", x: "4", y: "16", rx: "2", key: "17f3te" }],
  ["path", { d: "M14 19c3 0 4.6-1.6 4.6-1.6", key: "n7odp6" }],
  ["circle", { cx: "20", cy: "16", r: "2", key: "1v9bxh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BellMinus = createLucideIcon("BellMinus", [
  [
    "path",
    { d: "M18.4 12c.8 3.8 2.6 5 2.6 5H3s3-2 3-9c0-3.3 2.7-6 6-6 1.8 0 3.4.8 4.5 2", key: "eck70s" }
  ],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
  ["path", { d: "M15 8h6", key: "8ybuxh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BellOff = createLucideIcon("BellOff", [
  ["path", { d: "M8.7 3A6 6 0 0 1 18 8a21.3 21.3 0 0 0 .6 5", key: "o7mx20" }],
  ["path", { d: "M17 17H3s3-2 3-9a4.67 4.67 0 0 1 .3-1.7", key: "16f1lm" }],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BellPlus = createLucideIcon("BellPlus", [
  [
    "path",
    {
      d: "M19.3 14.8C20.1 16.4 21 17 21 17H3s3-2 3-9c0-3.3 2.7-6 6-6 1 0 1.9.2 2.8.7",
      key: "guizqy"
    }
  ],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
  ["path", { d: "M15 8h6", key: "8ybuxh" }],
  ["path", { d: "M18 5v6", key: "g5ayrv" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BellRing = createLucideIcon("BellRing", [
  ["path", { d: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9", key: "1qo2s2" }],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
  ["path", { d: "M4 2C2.8 3.7 2 5.7 2 8", key: "tap9e0" }],
  ["path", { d: "M22 8c0-2.3-.8-4.3-2-6", key: "5bb3ad" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bell = createLucideIcon("Bell", [
  ["path", { d: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9", key: "1qo2s2" }],
  ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BetweenHorizontalEnd = createLucideIcon("BetweenHorizontalEnd", [
  ["rect", { width: "13", height: "7", x: "3", y: "3", rx: "1", key: "11xb64" }],
  ["path", { d: "m22 15-3-3 3-3", key: "26chmm" }],
  ["rect", { width: "13", height: "7", x: "3", y: "14", rx: "1", key: "k6ky7n" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BetweenHorizontalStart = createLucideIcon("BetweenHorizontalStart", [
  ["rect", { width: "13", height: "7", x: "8", y: "3", rx: "1", key: "pkso9a" }],
  ["path", { d: "m2 9 3 3-3 3", key: "1agib5" }],
  ["rect", { width: "13", height: "7", x: "8", y: "14", rx: "1", key: "1q5fc1" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BetweenVerticalEnd = createLucideIcon("BetweenVerticalEnd", [
  ["rect", { width: "7", height: "13", x: "3", y: "3", rx: "1", key: "1fdu0f" }],
  ["path", { d: "m9 22 3-3 3 3", key: "17z65a" }],
  ["rect", { width: "7", height: "13", x: "14", y: "3", rx: "1", key: "1squn4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BetweenVerticalStart = createLucideIcon("BetweenVerticalStart", [
  ["rect", { width: "7", height: "13", x: "3", y: "8", rx: "1", key: "1fjrkv" }],
  ["path", { d: "m15 2-3 3-3-3", key: "1uh6eb" }],
  ["rect", { width: "7", height: "13", x: "14", y: "8", rx: "1", key: "w3fjg8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BicepsFlexed = createLucideIcon("BicepsFlexed", [
  [
    "path",
    {
      d: "M12.409 13.017A5 5 0 0 1 22 15c0 3.866-4 7-9 7-4.077 0-8.153-.82-10.371-2.462-.426-.316-.631-.832-.62-1.362C2.118 12.723 2.627 2 10 2a3 3 0 0 1 3 3 2 2 0 0 1-2 2c-1.105 0-1.64-.444-2-1",
      key: "1pmlyh"
    }
  ],
  ["path", { d: "M15 14a5 5 0 0 0-7.584 2", key: "5rb254" }],
  ["path", { d: "M9.964 6.825C8.019 7.977 9.5 13 8 15", key: "kbvsx9" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bike = createLucideIcon("Bike", [
  ["circle", { cx: "18.5", cy: "17.5", r: "3.5", key: "15x4ox" }],
  ["circle", { cx: "5.5", cy: "17.5", r: "3.5", key: "1noe27" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["path", { d: "M12 17.5V14l-3-3 4-3 2 3h2", key: "1npguv" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Binary = createLucideIcon("Binary", [
  ["rect", { x: "14", y: "14", width: "4", height: "6", rx: "2", key: "p02svl" }],
  ["rect", { x: "6", y: "4", width: "4", height: "6", rx: "2", key: "xm4xkj" }],
  ["path", { d: "M6 20h4", key: "1i6q5t" }],
  ["path", { d: "M14 10h4", key: "ru81e7" }],
  ["path", { d: "M6 14h2v6", key: "16z9wg" }],
  ["path", { d: "M14 4h2v6", key: "1idq9u" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Binoculars = createLucideIcon("Binoculars", [
  ["path", { d: "M10 10h4", key: "tcdvrf" }],
  ["path", { d: "M19 7V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3", key: "3apit1" }],
  [
    "path",
    {
      d: "M20 21a2 2 0 0 0 2-2v-3.851c0-1.39-2-2.962-2-4.829V8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v11a2 2 0 0 0 2 2z",
      key: "rhpgnw"
    }
  ],
  ["path", { d: "M 22 16 L 2 16", key: "14lkq7" }],
  [
    "path",
    {
      d: "M4 21a2 2 0 0 1-2-2v-3.851c0-1.39 2-2.962 2-4.829V8a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v11a2 2 0 0 1-2 2z",
      key: "104b3k"
    }
  ],
  ["path", { d: "M9 7V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v3", key: "14fczp" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Biohazard = createLucideIcon("Biohazard", [
  ["circle", { cx: "12", cy: "11.9", r: "2", key: "e8h31w" }],
  ["path", { d: "M6.7 3.4c-.9 2.5 0 5.2 2.2 6.7C6.5 9 3.7 9.6 2 11.6", key: "17bolr" }],
  ["path", { d: "m8.9 10.1 1.4.8", key: "15ezny" }],
  ["path", { d: "M17.3 3.4c.9 2.5 0 5.2-2.2 6.7 2.4-1.2 5.2-.6 6.9 1.5", key: "wtwa5u" }],
  ["path", { d: "m15.1 10.1-1.4.8", key: "1r0b28" }],
  ["path", { d: "M16.7 20.8c-2.6-.4-4.6-2.6-4.7-5.3-.2 2.6-2.1 4.8-4.7 5.2", key: "m7qszh" }],
  ["path", { d: "M12 13.9v1.6", key: "zfyyim" }],
  ["path", { d: "M13.5 5.4c-1-.2-2-.2-3 0", key: "1bi9q0" }],
  ["path", { d: "M17 16.4c.7-.7 1.2-1.6 1.5-2.5", key: "1rhjqw" }],
  ["path", { d: "M5.5 13.9c.3.9.8 1.8 1.5 2.5", key: "8gsud3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bird = createLucideIcon("Bird", [
  ["path", { d: "M16 7h.01", key: "1kdx03" }],
  ["path", { d: "M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20", key: "oj1oa8" }],
  ["path", { d: "m20 7 2 .5-2 .5", key: "12nv4d" }],
  ["path", { d: "M10 18v3", key: "1yea0a" }],
  ["path", { d: "M14 17.75V21", key: "1pymcb" }],
  ["path", { d: "M7 18a6 6 0 0 0 3.84-10.61", key: "1npnn0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bitcoin = createLucideIcon("Bitcoin", [
  [
    "path",
    {
      d: "M11.767 19.089c4.924.868 6.14-6.025 1.216-6.894m-1.216 6.894L5.86 18.047m5.908 1.042-.347 1.97m1.563-8.864c4.924.869 6.14-6.025 1.215-6.893m-1.215 6.893-3.94-.694m5.155-6.2L8.29 4.26m5.908 1.042.348-1.97M7.48 20.364l3.126-17.727",
      key: "yr8idg"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Blend = createLucideIcon("Blend", [
  ["circle", { cx: "9", cy: "9", r: "7", key: "p2h5vp" }],
  ["circle", { cx: "15", cy: "15", r: "7", key: "19ennj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Blinds = createLucideIcon("Blinds", [
  ["path", { d: "M3 3h18", key: "o7r712" }],
  ["path", { d: "M20 7H8", key: "gd2fo2" }],
  ["path", { d: "M20 11H8", key: "1ynp89" }],
  ["path", { d: "M10 19h10", key: "19hjk5" }],
  ["path", { d: "M8 15h12", key: "1yqzne" }],
  ["path", { d: "M4 3v14", key: "fggqzn" }],
  ["circle", { cx: "4", cy: "19", r: "2", key: "p3m9r0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Blocks = createLucideIcon("Blocks", [
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  [
    "path",
    {
      d: "M10 21V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H3",
      key: "1fpvtg"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BluetoothConnected = createLucideIcon("BluetoothConnected", [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }],
  ["line", { x1: "18", x2: "21", y1: "12", y2: "12", key: "1rsjjs" }],
  ["line", { x1: "3", x2: "6", y1: "12", y2: "12", key: "11yl8c" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BluetoothOff = createLucideIcon("BluetoothOff", [
  ["path", { d: "m17 17-5 5V12l-5 5", key: "v5aci6" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M14.5 9.5 17 7l-5-5v4.5", key: "1kddfz" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BluetoothSearching = createLucideIcon("BluetoothSearching", [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }],
  ["path", { d: "M20.83 14.83a4 4 0 0 0 0-5.66", key: "k8tn1j" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bluetooth = createLucideIcon("Bluetooth", [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bold = createLucideIcon("Bold", [
  [
    "path",
    { d: "M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8", key: "mg9rjx" }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bolt = createLucideIcon("Bolt", [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bomb = createLucideIcon("Bomb", [
  ["circle", { cx: "11", cy: "13", r: "9", key: "hd149" }],
  [
    "path",
    {
      d: "M14.35 4.65 16.3 2.7a2.41 2.41 0 0 1 3.4 0l1.6 1.6a2.4 2.4 0 0 1 0 3.4l-1.95 1.95",
      key: "jp4j1b"
    }
  ],
  ["path", { d: "m22 2-1.5 1.5", key: "ay92ug" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bone = createLucideIcon("Bone", [
  [
    "path",
    {
      d: "M17 10c.7-.7 1.69 0 2.5 0a2.5 2.5 0 1 0 0-5 .5.5 0 0 1-.5-.5 2.5 2.5 0 1 0-5 0c0 .81.7 1.8 0 2.5l-7 7c-.7.7-1.69 0-2.5 0a2.5 2.5 0 0 0 0 5c.28 0 .5.22.5.5a2.5 2.5 0 1 0 5 0c0-.81-.7-1.8 0-2.5Z",
      key: "w610uw"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookA = createLucideIcon("BookA", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m8 13 4-7 4 7", key: "4rari8" }],
  ["path", { d: "M9.1 11h5.7", key: "1gkovt" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookAudio = createLucideIcon("BookAudio", [
  ["path", { d: "M12 6v7", key: "1f6ttz" }],
  ["path", { d: "M16 8v3", key: "gejaml" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M8 8v3", key: "1qzp49" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookCheck = createLucideIcon("BookCheck", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m9 9.5 2 2 4-4", key: "1dth82" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookCopy = createLucideIcon("BookCopy", [
  ["path", { d: "M2 16V4a2 2 0 0 1 2-2h11", key: "spzkk5" }],
  [
    "path",
    {
      d: "M22 18H11a2 2 0 1 0 0 4h10.5a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5H11a2 2 0 0 0-2 2v12",
      key: "1wz07i"
    }
  ],
  ["path", { d: "M5 14H4a2 2 0 1 0 0 4h1", key: "16gqf9" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookDashed = createLucideIcon("BookDashed", [
  ["path", { d: "M12 17h2", key: "13u4lk" }],
  ["path", { d: "M12 22h2", key: "kn7ki6" }],
  ["path", { d: "M12 2h2", key: "cvn524" }],
  ["path", { d: "M18 22h1a1 1 0 0 0 1-1", key: "w6gbqz" }],
  ["path", { d: "M18 2h1a1 1 0 0 1 1 1v1", key: "1vpra5" }],
  ["path", { d: "M20 15v2h-2", key: "fph276" }],
  ["path", { d: "M20 8v3", key: "deu0bs" }],
  ["path", { d: "M4 11V9", key: "v3xsx8" }],
  ["path", { d: "M4 19.5V15", key: "6gr39e" }],
  ["path", { d: "M4 5v-.5A2.5 2.5 0 0 1 6.5 2H8", key: "wywhs9" }],
  ["path", { d: "M8 22H6.5a1 1 0 0 1 0-5H8", key: "1cu73q" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookDown = createLucideIcon("BookDown", [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m9 10 3 3 3-3", key: "zt5b4y" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookHeadphones = createLucideIcon("BookHeadphones", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M8 12v-2a4 4 0 0 1 8 0v2", key: "1vsqkj" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookHeart = createLucideIcon("BookHeart", [
  [
    "path",
    {
      d: "M16 8.2A2.22 2.22 0 0 0 13.8 6c-.8 0-1.4.3-1.8.9-.4-.6-1-.9-1.8-.9A2.22 2.22 0 0 0 8 8.2c0 .6.3 1.2.7 1.6A226.652 226.652 0 0 0 12 13a404 404 0 0 0 3.3-3.1 2.413 2.413 0 0 0 .7-1.7",
      key: "1t75a8"
    }
  ],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookImage = createLucideIcon("BookImage", [
  ["path", { d: "m20 13.7-2.1-2.1a2 2 0 0 0-2.8 0L9.7 17", key: "q6ojf0" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["circle", { cx: "10", cy: "8", r: "2", key: "2qkj4p" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookKey = createLucideIcon("BookKey", [
  ["path", { d: "m19 3 1 1", key: "ze14oc" }],
  ["path", { d: "m20 2-4.5 4.5", key: "1sppr8" }],
  ["path", { d: "M20 8v13a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20", key: "1ocbpn" }],
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H14", key: "1gfsgw" }],
  ["circle", { cx: "14", cy: "8", r: "2", key: "u49eql" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookLock = createLucideIcon("BookLock", [
  ["path", { d: "M18 6V4a2 2 0 1 0-4 0v2", key: "1aquzs" }],
  ["path", { d: "M20 15v6a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20", key: "1rkj32" }],
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H10", key: "18wgow" }],
  ["rect", { x: "12", y: "6", width: "8", height: "5", rx: "1", key: "73l30o" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookMarked = createLucideIcon("BookMarked", [
  ["path", { d: "M10 2v8l3-3 3 3V2", key: "sqw3rj" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookMinus = createLucideIcon("BookMinus", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookOpenCheck = createLucideIcon("BookOpenCheck", [
  ["path", { d: "M12 21V7", key: "gj6g52" }],
  ["path", { d: "m16 12 2 2 4-4", key: "mdajum" }],
  [
    "path",
    {
      d: "M22 6V4a1 1 0 0 0-1-1h-5a4 4 0 0 0-4 4 4 4 0 0 0-4-4H3a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h6a3 3 0 0 1 3 3 3 3 0 0 1 3-3h6a1 1 0 0 0 1-1v-1.3",
      key: "8arnkb"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookOpenText = createLucideIcon("BookOpenText", [
  ["path", { d: "M12 7v14", key: "1akyts" }],
  ["path", { d: "M16 12h2", key: "7q9ll5" }],
  ["path", { d: "M16 8h2", key: "msurwy" }],
  [
    "path",
    {
      d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
      key: "ruj8y"
    }
  ],
  ["path", { d: "M6 12h2", key: "32wvfc" }],
  ["path", { d: "M6 8h2", key: "30oboj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookOpen = createLucideIcon("BookOpen", [
  ["path", { d: "M12 7v14", key: "1akyts" }],
  [
    "path",
    {
      d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
      key: "ruj8y"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookPlus = createLucideIcon("BookPlus", [
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookText = createLucideIcon("BookText", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M8 11h8", key: "vwpz6n" }],
  ["path", { d: "M8 7h6", key: "1f0q6e" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookType = createLucideIcon("BookType", [
  ["path", { d: "M10 13h4", key: "ytezjc" }],
  ["path", { d: "M12 6v7", key: "1f6ttz" }],
  ["path", { d: "M16 8V6H8v2", key: "x8j6u4" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookUp2 = createLucideIcon("BookUp2", [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "M18 2h1a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20", key: "161d7n" }],
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2", key: "1lorq7" }],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }],
  ["path", { d: "m9 5 3-3 3 3", key: "l8vdw6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookUp = createLucideIcon("BookUp", [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookUser = createLucideIcon("BookUser", [
  ["path", { d: "M15 13a3 3 0 1 0-6 0", key: "10j68g" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookX = createLucideIcon("BookX", [
  ["path", { d: "m14.5 7-5 5", key: "dy991v" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m9.5 7 5 5", key: "s45iea" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Book = createLucideIcon("Book", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookmarkCheck = createLucideIcon("BookmarkCheck", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z", key: "169p4p" }],
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookmarkMinus = createLucideIcon("BookmarkMinus", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }],
  ["line", { x1: "15", x2: "9", y1: "10", y2: "10", key: "1gty7f" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookmarkPlus = createLucideIcon("BookmarkPlus", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }],
  ["line", { x1: "12", x2: "12", y1: "7", y2: "13", key: "1cppfj" }],
  ["line", { x1: "15", x2: "9", y1: "10", y2: "10", key: "1gty7f" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BookmarkX = createLucideIcon("BookmarkX", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z", key: "169p4p" }],
  ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
  ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bookmark = createLucideIcon("Bookmark", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BoomBox = createLucideIcon("BoomBox", [
  ["path", { d: "M4 9V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4", key: "vvzvr1" }],
  ["path", { d: "M8 8v1", key: "xcqmfk" }],
  ["path", { d: "M12 8v1", key: "1rj8u4" }],
  ["path", { d: "M16 8v1", key: "1q12zr" }],
  ["rect", { width: "20", height: "12", x: "2", y: "9", rx: "2", key: "igpb89" }],
  ["circle", { cx: "8", cy: "15", r: "2", key: "fa4a8s" }],
  ["circle", { cx: "16", cy: "15", r: "2", key: "14c3ya" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BotMessageSquare = createLucideIcon("BotMessageSquare", [
  ["path", { d: "M12 6V2H8", key: "1155em" }],
  ["path", { d: "m8 18-4 4V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z", key: "w2lp3e" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M9 11v2", key: "1ueba0" }],
  ["path", { d: "M15 11v2", key: "i11awn" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BotOff = createLucideIcon("BotOff", [
  ["path", { d: "M13.67 8H18a2 2 0 0 1 2 2v4.33", key: "7az073" }],
  ["path", { d: "M2 14h2", key: "vft8re" }],
  ["path", { d: "M20 14h2", key: "4cs60a" }],
  ["path", { d: "M22 22 2 2", key: "1r8tn9" }],
  ["path", { d: "M8 8H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 1.414-.586", key: "s09a7a" }],
  ["path", { d: "M9 13v2", key: "rq6x2g" }],
  ["path", { d: "M9.67 4H12v2.33", key: "110xot" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bot = createLucideIcon("Bot", [
  ["path", { d: "M12 8V4H8", key: "hb8ula" }],
  ["rect", { width: "16", height: "12", x: "4", y: "8", rx: "2", key: "enze0r" }],
  ["path", { d: "M2 14h2", key: "vft8re" }],
  ["path", { d: "M20 14h2", key: "4cs60a" }],
  ["path", { d: "M15 13v2", key: "1xurst" }],
  ["path", { d: "M9 13v2", key: "rq6x2g" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Box = createLucideIcon("Box", [
  [
    "path",
    {
      d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
      key: "hh9hay"
    }
  ],
  ["path", { d: "m3.3 7 8.7 5 8.7-5", key: "g66t2b" }],
  ["path", { d: "M12 22V12", key: "d0xqtd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Boxes = createLucideIcon("Boxes", [
  [
    "path",
    {
      d: "M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z",
      key: "lc1i9w"
    }
  ],
  ["path", { d: "m7 16.5-4.74-2.85", key: "1o9zyk" }],
  ["path", { d: "m7 16.5 5-3", key: "va8pkn" }],
  ["path", { d: "M7 16.5v5.17", key: "jnp8gn" }],
  [
    "path",
    {
      d: "M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z",
      key: "8zsnat"
    }
  ],
  ["path", { d: "m17 16.5-5-3", key: "8arw3v" }],
  ["path", { d: "m17 16.5 4.74-2.85", key: "8rfmw" }],
  ["path", { d: "M17 16.5v5.17", key: "k6z78m" }],
  [
    "path",
    {
      d: "M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z",
      key: "1xygjf"
    }
  ],
  ["path", { d: "M12 8 7.26 5.15", key: "1vbdud" }],
  ["path", { d: "m12 8 4.74-2.85", key: "3rx089" }],
  ["path", { d: "M12 13.5V8", key: "1io7kd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Braces = createLucideIcon("Braces", [
  [
    "path",
    { d: "M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2 2 2 0 0 1 2 2v5c0 1.1.9 2 2 2h1", key: "ezmyqa" }
  ],
  [
    "path",
    {
      d: "M16 21h1a2 2 0 0 0 2-2v-5c0-1.1.9-2 2-2a2 2 0 0 1-2-2V5a2 2 0 0 0-2-2h-1",
      key: "e1hn23"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Brackets = createLucideIcon("Brackets", [
  ["path", { d: "M16 3h3v18h-3", key: "1yor1f" }],
  ["path", { d: "M8 21H5V3h3", key: "1qrfwo" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BrainCircuit = createLucideIcon("BrainCircuit", [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z",
      key: "l5xja"
    }
  ],
  ["path", { d: "M9 13a4.5 4.5 0 0 0 3-4", key: "10igwf" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M12 13h4", key: "1ku699" }],
  ["path", { d: "M12 18h6a2 2 0 0 1 2 2v1", key: "105ag5" }],
  ["path", { d: "M12 8h8", key: "1lhi5i" }],
  ["path", { d: "M16 8V5a2 2 0 0 1 2-2", key: "u6izg6" }],
  ["circle", { cx: "16", cy: "13", r: ".5", key: "ry7gng" }],
  ["circle", { cx: "18", cy: "3", r: ".5", key: "1aiba7" }],
  ["circle", { cx: "20", cy: "21", r: ".5", key: "yhc1fs" }],
  ["circle", { cx: "20", cy: "8", r: ".5", key: "1e43v0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BrainCog = createLucideIcon("BrainCog", [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.142 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588 4 4 0 0 0 7.636 2.106 3.2 3.2 0 0 0 .164-.546c.028-.13.306-.13.335 0a3.2 3.2 0 0 0 .163.546 4 4 0 0 0 7.636-2.106 4 4 0 0 0 .556-6.588 4 4 0 0 0-2.526-5.77A3 3 0 1 0 12 5",
      key: "1kgmhc"
    }
  ],
  ["path", { d: "M17.599 6.5a3 3 0 0 0 .399-1.375", key: "tmeiqw" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M19.938 10.5a4 4 0 0 1 .585.396", key: "1qfode" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M19.967 17.484A4 4 0 0 1 18 18", key: "159ez6" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m15.7 10.4-.9.4", key: "ayzo6p" }],
  ["path", { d: "m9.2 13.2-.9.4", key: "1uzb3g" }],
  ["path", { d: "m13.6 15.7-.4-.9", key: "11ifqf" }],
  ["path", { d: "m10.8 9.2-.4-.9", key: "1pmk2v" }],
  ["path", { d: "m15.7 13.5-.9-.4", key: "7ng02m" }],
  ["path", { d: "m9.2 10.9-.9-.4", key: "1x66zd" }],
  ["path", { d: "m10.5 15.7.4-.9", key: "3js94g" }],
  ["path", { d: "m13.1 9.2.4-.9", key: "18n7mc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Brain = createLucideIcon("Brain", [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z",
      key: "l5xja"
    }
  ],
  [
    "path",
    {
      d: "M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z",
      key: "ep3f8r"
    }
  ],
  ["path", { d: "M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4", key: "1p4c4q" }],
  ["path", { d: "M17.599 6.5a3 3 0 0 0 .399-1.375", key: "tmeiqw" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M19.938 10.5a4 4 0 0 1 .585.396", key: "1qfode" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M19.967 17.484A4 4 0 0 1 18 18", key: "159ez6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BrickWall = createLucideIcon("BrickWall", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 9v6", key: "199k2o" }],
  ["path", { d: "M16 15v6", key: "8rj2es" }],
  ["path", { d: "M16 3v6", key: "1j6rpj" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M8 15v6", key: "1stoo3" }],
  ["path", { d: "M8 3v6", key: "vlvjmk" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BriefcaseBusiness = createLucideIcon("BriefcaseBusiness", [
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2", key: "1ksdt3" }],
  ["path", { d: "M22 13a18.15 18.15 0 0 1-20 0", key: "12hx5q" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BriefcaseConveyorBelt = createLucideIcon("BriefcaseConveyorBelt", [
  ["path", { d: "M10 20v2", key: "1n8e1g" }],
  ["path", { d: "M14 20v2", key: "1lq872" }],
  ["path", { d: "M18 20v2", key: "10uadw" }],
  ["path", { d: "M21 20H3", key: "kdqkdp" }],
  ["path", { d: "M6 20v2", key: "a9bc87" }],
  ["path", { d: "M8 16V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v12", key: "17n9tx" }],
  ["rect", { x: "4", y: "6", width: "16", height: "10", rx: "2", key: "1097i5" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BriefcaseMedical = createLucideIcon("BriefcaseMedical", [
  ["path", { d: "M12 11v4", key: "a6ujw6" }],
  ["path", { d: "M14 13h-4", key: "1pl8zg" }],
  ["path", { d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2", key: "1ksdt3" }],
  ["path", { d: "M18 6v14", key: "1mu4gy" }],
  ["path", { d: "M6 6v14", key: "1s15cj" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Briefcase = createLucideIcon("Briefcase", [
  ["path", { d: "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16", key: "jecpp" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BringToFront = createLucideIcon("BringToFront", [
  ["rect", { x: "8", y: "8", width: "8", height: "8", rx: "2", key: "yj20xf" }],
  ["path", { d: "M4 10a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2", key: "1ltk23" }],
  ["path", { d: "M14 20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2", key: "1q24h9" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Brush = createLucideIcon("Brush", [
  ["path", { d: "m9.06 11.9 8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08", key: "1styjt" }],
  [
    "path",
    {
      d: "M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 0 0-3-3.02z",
      key: "z0l1mu"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BugOff = createLucideIcon("BugOff", [
  ["path", { d: "M15 7.13V6a3 3 0 0 0-5.14-2.1L8 2", key: "vl8zik" }],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M22 13h-4v-2a4 4 0 0 0-4-4h-1.3", key: "1ou0bd" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M7.7 7.7A4 4 0 0 0 6 11v3a6 6 0 0 0 11.13 3.13", key: "1njkjs" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BugPlay = createLucideIcon("BugPlay", [
  [
    "path",
    {
      d: "M12.765 21.522a.5.5 0 0 1-.765-.424v-8.196a.5.5 0 0 1 .765-.424l5.878 3.674a1 1 0 0 1 0 1.696z",
      key: "17shqo"
    }
  ],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M18 11a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4v3a6.1 6.1 0 0 0 2 4.5", key: "1tjixy" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M6.53 9C4.6 8.8 3 7.1 3 5", key: "32zzws" }],
  ["path", { d: "m8 2 1.88 1.88", key: "fmnt4t" }],
  ["path", { d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1", key: "d7y7pr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bug = createLucideIcon("Bug", [
  ["path", { d: "m8 2 1.88 1.88", key: "fmnt4t" }],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1", key: "d7y7pr" }],
  [
    "path",
    {
      d: "M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6",
      key: "xs1cw7"
    }
  ],
  ["path", { d: "M12 20v-9", key: "1qisl0" }],
  ["path", { d: "M6.53 9C4.6 8.8 3 7.1 3 5", key: "32zzws" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "M22 13h-4", key: "1jl80f" }],
  ["path", { d: "M17.2 17c2.1.1 3.8 1.9 3.8 4", key: "k3fwyw" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Building2 = createLucideIcon("Building2", [
  ["path", { d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z", key: "1b4qmf" }],
  ["path", { d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2", key: "i71pzd" }],
  ["path", { d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2", key: "10jefs" }],
  ["path", { d: "M10 6h4", key: "1itunk" }],
  ["path", { d: "M10 10h4", key: "tcdvrf" }],
  ["path", { d: "M10 14h4", key: "kelpxr" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Building = createLucideIcon("Building", [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", ry: "2", key: "76otgf" }],
  ["path", { d: "M9 22v-4h6v4", key: "r93iot" }],
  ["path", { d: "M8 6h.01", key: "1dz90k" }],
  ["path", { d: "M16 6h.01", key: "1x0f13" }],
  ["path", { d: "M12 6h.01", key: "1vi96p" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }],
  ["path", { d: "M16 14h.01", key: "1gbofw" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BusFront = createLucideIcon("BusFront", [
  ["path", { d: "M4 6 2 7", key: "1mqr15" }],
  ["path", { d: "M10 6h4", key: "1itunk" }],
  ["path", { d: "m22 7-2-1", key: "1umjhc" }],
  ["rect", { width: "16", height: "16", x: "4", y: "3", rx: "2", key: "1wxw4b" }],
  ["path", { d: "M4 11h16", key: "mpoxn0" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["path", { d: "M18 21v-2", key: "sqyl04" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bus = createLucideIcon("Bus", [
  ["path", { d: "M8 6v6", key: "18i7km" }],
  ["path", { d: "M15 6v6", key: "1sg6z9" }],
  ["path", { d: "M2 12h19.6", key: "de5uta" }],
  [
    "path",
    {
      d: "M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3",
      key: "1wwztk"
    }
  ],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }],
  ["path", { d: "M9 18h5", key: "lrx6i" }],
  ["circle", { cx: "16", cy: "18", r: "2", key: "1v4tcr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CableCar = createLucideIcon("CableCar", [
  ["path", { d: "M10 3h.01", key: "lbucoy" }],
  ["path", { d: "M14 2h.01", key: "1k8aa1" }],
  ["path", { d: "m2 9 20-5", key: "1kz0j5" }],
  ["path", { d: "M12 12V6.5", key: "1vbrij" }],
  ["rect", { width: "16", height: "10", x: "4", y: "12", rx: "3", key: "if91er" }],
  ["path", { d: "M9 12v5", key: "3anwtq" }],
  ["path", { d: "M15 12v5", key: "5xh3zn" }],
  ["path", { d: "M4 17h16", key: "g4d7ey" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cable = createLucideIcon("Cable", [
  [
    "path",
    {
      d: "M17 21v-2a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1",
      key: "10bnsj"
    }
  ],
  ["path", { d: "M19 15V6.5a1 1 0 0 0-7 0v11a1 1 0 0 1-7 0V9", key: "1eqmu1" }],
  ["path", { d: "M21 21v-2h-4", key: "14zm7j" }],
  ["path", { d: "M3 5h4V3", key: "z442eg" }],
  [
    "path",
    { d: "M7 5a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a1 1 0 0 1 1-1V3", key: "ebdjd7" }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CakeSlice = createLucideIcon("CakeSlice", [
  ["circle", { cx: "9", cy: "7", r: "2", key: "1305pl" }],
  [
    "path",
    { d: "M7.2 7.9 3 11v9c0 .6.4 1 1 1h16c.6 0 1-.4 1-1v-9c0-2-3-6-7-8l-3.6 2.6", key: "xle13f" }
  ],
  ["path", { d: "M16 13H3", key: "1wpj08" }],
  ["path", { d: "M16 17H3", key: "3lvfcd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cake = createLucideIcon("Cake", [
  ["path", { d: "M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8", key: "1w3rig" }],
  ["path", { d: "M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2-1 2-1", key: "n2jgmb" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }],
  ["path", { d: "M7 8v3", key: "1qtyvj" }],
  ["path", { d: "M12 8v3", key: "hwp4zt" }],
  ["path", { d: "M17 8v3", key: "1i6e5u" }],
  ["path", { d: "M7 4h.01", key: "1bh4kh" }],
  ["path", { d: "M12 4h.01", key: "1ujb9j" }],
  ["path", { d: "M17 4h.01", key: "1upcoc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Calculator = createLucideIcon("Calculator", [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["line", { x1: "8", x2: "16", y1: "6", y2: "6", key: "x4nwl0" }],
  ["line", { x1: "16", x2: "16", y1: "14", y2: "18", key: "wjye3r" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Calendar1 = createLucideIcon("Calendar1", [
  ["path", { d: "M11 14h1v4", key: "fy54vd" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["rect", { x: "3", y: "4", width: "18", height: "18", rx: "2", key: "12vinp" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CalendarArrowDown = createLucideIcon("CalendarArrowDown", [
  ["path", { d: "m14 18 4 4 4-4", key: "1waygx" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M18 14v8", key: "irew45" }],
  [
    "path",
    { d: "M21 11.354V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.343", key: "bse4f3" }
  ],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CalendarArrowUp = createLucideIcon("CalendarArrowUp", [
  ["path", { d: "m14 18 4-4 4 4", key: "ftkppy" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M18 22v-8", key: "su0gjh" }],
  ["path", { d: "M21 11.343V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9", key: "1exg90" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CalendarCheck2 = createLucideIcon("CalendarCheck2", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 14V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "bce9hv" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m16 20 2 2 4-4", key: "13tcca" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CalendarCheck = createLucideIcon("CalendarCheck", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m9 16 2 2 4-4", key: "19s6y9" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CalendarClock = createLucideIcon("CalendarClock", [
  ["path", { d: "M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5", key: "1osxxc" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M3 10h5", key: "r794hk" }],
  ["path", { d: "M17.5 17.5 16 16.3V14", key: "akvzfd" }],
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CalendarCog = createLucideIcon("CalendarCog", [
  ["path", { d: "m15.2 16.9-.9-.4", key: "1r0w5f" }],
  ["path", { d: "m15.2 19.1-.9.4", key: "j188fs" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "m16.9 15.2-.4-.9", key: "699xu" }],
  ["path", { d: "m16.9 20.8-.4.9", key: "dfjc4z" }],
  ["path", { d: "m19.5 14.3-.4.9", key: "1eb35c" }],
  ["path", { d: "m19.5 21.7-.4-.9", key: "1tonu5" }],
  ["path", { d: "M21 10.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6", key: "11kmuh" }],
  ["path", { d: "m21.7 16.5-.9.4", key: "1knoei" }],
  ["path", { d: "m21.7 19.5-.9-.4", key: "q4dx6b" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CalendarDays = createLucideIcon("CalendarDays", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M16 14h.01", key: "1gbofw" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M16 18h.01", key: "kzsmim" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CalendarFold = createLucideIcon("CalendarFold", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 17V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11Z", key: "kg77oy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M15 22v-4a2 2 0 0 1 2-2h4", key: "1gnbqr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CalendarHeart = createLucideIcon("CalendarHeart", [
  ["path", { d: "M3 10h18V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7", key: "136lmk" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  [
    "path",
    {
      d: "M21.29 14.7a2.43 2.43 0 0 0-2.65-.52c-.3.12-.57.3-.8.53l-.34.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L17.5 22l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z",
      key: "1t7hil"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CalendarMinus2 = createLucideIcon("CalendarMinus2", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M10 16h4", key: "17e571" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CalendarMinus = createLucideIcon("CalendarMinus", [
  ["path", { d: "M16 19h6", key: "xwg31i" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 15V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8.5", key: "1scpom" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CalendarOff = createLucideIcon("CalendarOff", [
  ["path", { d: "M4.2 4.2A2 2 0 0 0 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 1.82-1.18", key: "16swn3" }],
  ["path", { d: "M21 15.5V6a2 2 0 0 0-2-2H9.5", key: "yhw86o" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h7", key: "1wap6i" }],
  ["path", { d: "M21 10h-5.5", key: "quycpq" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CalendarPlus2 = createLucideIcon("CalendarPlus2", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M10 16h4", key: "17e571" }],
  ["path", { d: "M12 14v4", key: "1thi36" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CalendarPlus = createLucideIcon("CalendarPlus", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "3spt84" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CalendarRange = createLucideIcon("CalendarRange", [
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M17 14h-6", key: "bkmgh3" }],
  ["path", { d: "M13 18H7", key: "bb0bb7" }],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 18h.01", key: "1bdyru" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CalendarSearch = createLucideIcon("CalendarSearch", [
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 11.75V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.25", key: "1jrsq6" }],
  ["path", { d: "m22 22-1.875-1.875", key: "13zax7" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CalendarX2 = createLucideIcon("CalendarX2", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "3spt84" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m17 22 5-5", key: "1k6ppv" }],
  ["path", { d: "m17 17 5 5", key: "p7ous7" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CalendarX = createLucideIcon("CalendarX", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m14 14-4 4", key: "rymu2i" }],
  ["path", { d: "m10 14 4 4", key: "3sz06r" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Calendar = createLucideIcon("Calendar", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CameraOff = createLucideIcon("CameraOff", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16", key: "qmtpty" }],
  ["path", { d: "M9.5 4h5L17 7h3a2 2 0 0 1 2 2v7.5", key: "1ufyfc" }],
  ["path", { d: "M14.121 15.121A3 3 0 1 1 9.88 10.88", key: "11zox6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Camera$1 = createLucideIcon("Camera", [
  [
    "path",
    {
      d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z",
      key: "1tc9qg"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "3", key: "1vg3eu" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CandyCane = createLucideIcon("CandyCane", [
  [
    "path",
    {
      d: "M5.7 21a2 2 0 0 1-3.5-2l8.6-14a6 6 0 0 1 10.4 6 2 2 0 1 1-3.464-2 2 2 0 1 0-3.464-2Z",
      key: "isaq8g"
    }
  ],
  ["path", { d: "M17.75 7 15 2.1", key: "12x7e8" }],
  ["path", { d: "M10.9 4.8 13 9", key: "100a87" }],
  ["path", { d: "m7.9 9.7 2 4.4", key: "ntfhaj" }],
  ["path", { d: "M4.9 14.7 7 18.9", key: "1x43jy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CandyOff = createLucideIcon("CandyOff", [
  ["path", { d: "m8.5 8.5-1 1a4.95 4.95 0 0 0 7 7l1-1", key: "1ff4ui" }],
  [
    "path",
    { d: "M11.843 6.187A4.947 4.947 0 0 1 16.5 7.5a4.947 4.947 0 0 1 1.313 4.657", key: "1sbrv4" }
  ],
  ["path", { d: "M14 16.5V14", key: "1maf8j" }],
  ["path", { d: "M14 6.5v1.843", key: "1a6u6t" }],
  ["path", { d: "M10 10v7.5", key: "80pj65" }],
  [
    "path",
    {
      d: "m16 7 1-5 1.367.683A3 3 0 0 0 19.708 3H21v1.292a3 3 0 0 0 .317 1.341L22 7l-5 1",
      key: "11a9mt"
    }
  ],
  [
    "path",
    {
      d: "m8 17-1 5-1.367-.683A3 3 0 0 0 4.292 21H3v-1.292a3 3 0 0 0-.317-1.341L2 17l5-1",
      key: "3mjmon"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Candy = createLucideIcon("Candy", [
  ["path", { d: "m9.5 7.5-2 2a4.95 4.95 0 1 0 7 7l2-2a4.95 4.95 0 1 0-7-7Z", key: "ue6khb" }],
  ["path", { d: "M14 6.5v10", key: "5xnk7c" }],
  ["path", { d: "M10 7.5v10", key: "1uew51" }],
  [
    "path",
    { d: "m16 7 1-5 1.37.68A3 3 0 0 0 19.7 3H21v1.3c0 .46.1.92.32 1.33L22 7l-5 1", key: "b9cp6k" }
  ],
  [
    "path",
    { d: "m8 17-1 5-1.37-.68A3 3 0 0 0 4.3 21H3v-1.3a3 3 0 0 0-.32-1.33L2 17l5-1", key: "5lney8" }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cannabis = createLucideIcon("Cannabis", [
  ["path", { d: "M12 22v-4", key: "1utk9m" }],
  [
    "path",
    {
      d: "M7 12c-1.5 0-4.5 1.5-5 3 3.5 1.5 6 1 6 1-1.5 1.5-2 3.5-2 5 2.5 0 4.5-1.5 6-3 1.5 1.5 3.5 3 6 3 0-1.5-.5-3.5-2-5 0 0 2.5.5 6-1-.5-1.5-3.5-3-5-3 1.5-1 4-4 4-6-2.5 0-5.5 1.5-7 3 0-2.5-.5-5-2-7-1.5 2-2 4.5-2 7-1.5-1.5-4.5-3-7-3 0 2 2.5 5 4 6",
      key: "1mezod"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CaptionsOff = createLucideIcon("CaptionsOff", [
  ["path", { d: "M10.5 5H19a2 2 0 0 1 2 2v8.5", key: "jqtk4d" }],
  ["path", { d: "M17 11h-.5", key: "1961ue" }],
  ["path", { d: "M19 19H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2", key: "1keqsi" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M7 11h4", key: "1o1z6v" }],
  ["path", { d: "M7 15h2.5", key: "1ina1g" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Captions = createLucideIcon("Captions", [
  ["rect", { width: "18", height: "14", x: "3", y: "5", rx: "2", ry: "2", key: "12ruh7" }],
  ["path", { d: "M7 15h4M15 15h2M7 11h2M13 11h4", key: "1ueiar" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CarFront = createLucideIcon("CarFront", [
  [
    "path",
    { d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8", key: "1imjwt" }
  ],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  ["rect", { width: "18", height: "8", x: "3", y: "10", rx: "2", key: "a7itu8" }],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CarTaxiFront = createLucideIcon("CarTaxiFront", [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  [
    "path",
    { d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8", key: "1imjwt" }
  ],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  ["rect", { width: "18", height: "8", x: "3", y: "10", rx: "2", key: "a7itu8" }],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Car = createLucideIcon("Car", [
  [
    "path",
    {
      d: "M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2",
      key: "5owen"
    }
  ],
  ["circle", { cx: "7", cy: "17", r: "2", key: "u2ysq9" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }],
  ["circle", { cx: "17", cy: "17", r: "2", key: "axvx0g" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Caravan = createLucideIcon("Caravan", [
  ["path", { d: "M18 19V9a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v8a2 2 0 0 0 2 2h2", key: "19jm3t" }],
  ["path", { d: "M2 9h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2", key: "13hakp" }],
  ["path", { d: "M22 17v1a1 1 0 0 1-1 1H10v-9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v9", key: "1crci8" }],
  ["circle", { cx: "8", cy: "19", r: "2", key: "t8fc5s" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Carrot = createLucideIcon("Carrot", [
  [
    "path",
    {
      d: "M2.27 21.7s9.87-3.5 12.73-6.36a4.5 4.5 0 0 0-6.36-6.37C5.77 11.84 2.27 21.7 2.27 21.7zM8.64 14l-2.05-2.04M15.34 15l-2.46-2.46",
      key: "rfqxbe"
    }
  ],
  ["path", { d: "M22 9s-1.33-2-3.5-2C16.86 7 15 9 15 9s1.33 2 3.5 2S22 9 22 9z", key: "6b25w4" }],
  ["path", { d: "M15 2s-2 1.33-2 3.5S15 9 15 9s2-1.84 2-3.5C17 3.33 15 2 15 2z", key: "fn65lo" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CaseLower = createLucideIcon("CaseLower", [
  ["circle", { cx: "7", cy: "12", r: "3", key: "12clwm" }],
  ["path", { d: "M10 9v6", key: "17i7lo" }],
  ["circle", { cx: "17", cy: "12", r: "3", key: "gl7c2s" }],
  ["path", { d: "M14 7v8", key: "dl84cr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CaseSensitive = createLucideIcon("CaseSensitive", [
  ["path", { d: "m3 15 4-8 4 8", key: "1vwr6u" }],
  ["path", { d: "M4 13h6", key: "1r9ots" }],
  ["circle", { cx: "18", cy: "12", r: "3", key: "1kchzo" }],
  ["path", { d: "M21 9v6", key: "anns31" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CaseUpper = createLucideIcon("CaseUpper", [
  ["path", { d: "m3 15 4-8 4 8", key: "1vwr6u" }],
  ["path", { d: "M4 13h6", key: "1r9ots" }],
  ["path", { d: "M15 11h4.5a2 2 0 0 1 0 4H15V7h4a2 2 0 0 1 0 4", key: "1sqfas" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CassetteTape = createLucideIcon("CassetteTape", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["circle", { cx: "8", cy: "10", r: "2", key: "1xl4ub" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["circle", { cx: "16", cy: "10", r: "2", key: "r14t7q" }],
  ["path", { d: "m6 20 .7-2.9A1.4 1.4 0 0 1 8.1 16h7.8a1.4 1.4 0 0 1 1.4 1l.7 3", key: "l01ucn" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cast = createLucideIcon("Cast", [
  ["path", { d: "M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6", key: "3zrzxg" }],
  ["path", { d: "M2 12a9 9 0 0 1 8 8", key: "g6cvee" }],
  ["path", { d: "M2 16a5 5 0 0 1 4 4", key: "1y1dii" }],
  ["line", { x1: "2", x2: "2.01", y1: "20", y2: "20", key: "xu2jvo" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Castle = createLucideIcon("Castle", [
  ["path", { d: "M22 20v-9H2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2Z", key: "109fe4" }],
  ["path", { d: "M18 11V4H6v7", key: "mon5oj" }],
  ["path", { d: "M15 22v-4a3 3 0 0 0-3-3a3 3 0 0 0-3 3v4", key: "1k4jtn" }],
  ["path", { d: "M22 11V9", key: "3zbp94" }],
  ["path", { d: "M2 11V9", key: "1x5rnq" }],
  ["path", { d: "M6 4V2", key: "1rsq15" }],
  ["path", { d: "M18 4V2", key: "1jsdo1" }],
  ["path", { d: "M10 4V2", key: "75d9ly" }],
  ["path", { d: "M14 4V2", key: "8nj3z6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cat = createLucideIcon("Cat", [
  [
    "path",
    {
      d: "M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5Z",
      key: "x6xyqk"
    }
  ],
  ["path", { d: "M8 14v.5", key: "1nzgdb" }],
  ["path", { d: "M16 14v.5", key: "1lajdz" }],
  ["path", { d: "M11.25 16.25h1.5L12 17l-.75-.75Z", key: "12kq1m" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cctv = createLucideIcon("Cctv", [
  [
    "path",
    {
      d: "M16.75 12h3.632a1 1 0 0 1 .894 1.447l-2.034 4.069a1 1 0 0 1-1.708.134l-2.124-2.97",
      key: "ir91b5"
    }
  ],
  [
    "path",
    {
      d: "M17.106 9.053a1 1 0 0 1 .447 1.341l-3.106 6.211a1 1 0 0 1-1.342.447L3.61 12.3a2.92 2.92 0 0 1-1.3-3.91L3.69 5.6a2.92 2.92 0 0 1 3.92-1.3z",
      key: "jlp8i1"
    }
  ],
  ["path", { d: "M2 19h3.76a2 2 0 0 0 1.8-1.1L9 15", key: "19bib8" }],
  ["path", { d: "M2 21v-4", key: "l40lih" }],
  ["path", { d: "M7 9h.01", key: "19b3jx" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChartArea = createLucideIcon("ChartArea", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  [
    "path",
    {
      d: "M7 11.207a.5.5 0 0 1 .146-.353l2-2a.5.5 0 0 1 .708 0l3.292 3.292a.5.5 0 0 0 .708 0l4.292-4.292a.5.5 0 0 1 .854.353V16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z",
      key: "q0gr47"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChartBarBig = createLucideIcon("ChartBarBig", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["rect", { x: "7", y: "13", width: "9", height: "4", rx: "1", key: "1iip1u" }],
  ["rect", { x: "7", y: "5", width: "12", height: "4", rx: "1", key: "1anskk" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChartBarDecreasing = createLucideIcon("ChartBarDecreasing", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M7 11h8", key: "1feolt" }],
  ["path", { d: "M7 16h3", key: "ur6vzw" }],
  ["path", { d: "M7 6h12", key: "sz5b0d" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChartBarIncreasing = createLucideIcon("ChartBarIncreasing", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M7 11h8", key: "1feolt" }],
  ["path", { d: "M7 16h12", key: "wsnu98" }],
  ["path", { d: "M7 6h3", key: "w9rmul" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChartBarStacked = createLucideIcon("ChartBarStacked", [
  ["path", { d: "M11 13v4", key: "vyy2rb" }],
  ["path", { d: "M15 5v4", key: "1gx88a" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["rect", { x: "7", y: "13", width: "9", height: "4", rx: "1", key: "1iip1u" }],
  ["rect", { x: "7", y: "5", width: "12", height: "4", rx: "1", key: "1anskk" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChartBar = createLucideIcon("ChartBar", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M7 16h8", key: "srdodz" }],
  ["path", { d: "M7 11h12", key: "127s9w" }],
  ["path", { d: "M7 6h3", key: "w9rmul" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChartCandlestick = createLucideIcon("ChartCandlestick", [
  ["path", { d: "M9 5v4", key: "14uxtq" }],
  ["rect", { width: "4", height: "6", x: "7", y: "9", rx: "1", key: "f4fvz0" }],
  ["path", { d: "M9 15v2", key: "r5rk32" }],
  ["path", { d: "M17 3v2", key: "1l2re6" }],
  ["rect", { width: "4", height: "8", x: "15", y: "5", rx: "1", key: "z38je5" }],
  ["path", { d: "M17 13v3", key: "5l0wba" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChartColumnBig = createLucideIcon("ChartColumnBig", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["rect", { x: "15", y: "5", width: "4", height: "12", rx: "1", key: "q8uenq" }],
  ["rect", { x: "7", y: "8", width: "4", height: "9", rx: "1", key: "sr5ea" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChartColumnDecreasing = createLucideIcon("ChartColumnDecreasing", [
  ["path", { d: "M13 17V9", key: "1fwyjl" }],
  ["path", { d: "M18 17v-3", key: "1sqioe" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M8 17V5", key: "1wzmnc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChartColumnIncreasing = createLucideIcon("ChartColumnIncreasing", [
  ["path", { d: "M13 17V9", key: "1fwyjl" }],
  ["path", { d: "M18 17V5", key: "sfb6ij" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M8 17v-3", key: "17ska0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChartColumnStacked = createLucideIcon("ChartColumnStacked", [
  ["path", { d: "M11 13H7", key: "t0o9gq" }],
  ["path", { d: "M19 9h-4", key: "rera1j" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["rect", { x: "15", y: "5", width: "4", height: "12", rx: "1", key: "q8uenq" }],
  ["rect", { x: "7", y: "8", width: "4", height: "9", rx: "1", key: "sr5ea" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChartColumn = createLucideIcon("ChartColumn", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M18 17V9", key: "2bz60n" }],
  ["path", { d: "M13 17V5", key: "1frdt8" }],
  ["path", { d: "M8 17v-3", key: "17ska0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChartGantt = createLucideIcon("ChartGantt", [
  ["path", { d: "M10 6h8", key: "zvc2xc" }],
  ["path", { d: "M12 16h6", key: "yi5mkt" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M8 11h7", key: "wz2hg0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChartLine = createLucideIcon("ChartLine", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "m19 9-5 5-4-4-3 3", key: "2osh9i" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChartNetwork = createLucideIcon("ChartNetwork", [
  ["path", { d: "m13.11 7.664 1.78 2.672", key: "go2gg9" }],
  ["path", { d: "m14.162 12.788-3.324 1.424", key: "11x848" }],
  ["path", { d: "m20 4-6.06 1.515", key: "1wxxh7" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["circle", { cx: "12", cy: "6", r: "2", key: "1jj5th" }],
  ["circle", { cx: "16", cy: "12", r: "2", key: "4ma0v8" }],
  ["circle", { cx: "9", cy: "15", r: "2", key: "lf2ghp" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChartNoAxesColumnDecreasing = createLucideIcon("ChartNoAxesColumnDecreasing", [
  ["path", { d: "M12 20V10", key: "g8npz5" }],
  ["path", { d: "M18 20v-4", key: "8uic4z" }],
  ["path", { d: "M6 20V4", key: "1w1bmo" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChartNoAxesColumnIncreasing = createLucideIcon("ChartNoAxesColumnIncreasing", [
  ["line", { x1: "12", x2: "12", y1: "20", y2: "10", key: "1vz5eb" }],
  ["line", { x1: "18", x2: "18", y1: "20", y2: "4", key: "cun8e5" }],
  ["line", { x1: "6", x2: "6", y1: "20", y2: "16", key: "hq0ia6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChartNoAxesColumn = createLucideIcon("ChartNoAxesColumn", [
  ["line", { x1: "18", x2: "18", y1: "20", y2: "10", key: "1xfpm4" }],
  ["line", { x1: "12", x2: "12", y1: "20", y2: "4", key: "be30l9" }],
  ["line", { x1: "6", x2: "6", y1: "20", y2: "14", key: "1r4le6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChartNoAxesCombined = createLucideIcon("ChartNoAxesCombined", [
  ["path", { d: "M12 16v5", key: "zza2cw" }],
  ["path", { d: "M16 14v7", key: "1g90b9" }],
  ["path", { d: "M20 10v11", key: "1iqoj0" }],
  [
    "path",
    { d: "m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15", key: "1fw8x9" }
  ],
  ["path", { d: "M4 18v3", key: "1yp0dc" }],
  ["path", { d: "M8 14v7", key: "n3cwzv" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChartNoAxesGantt = createLucideIcon("ChartNoAxesGantt", [
  ["path", { d: "M8 6h10", key: "9lnwnk" }],
  ["path", { d: "M6 12h9", key: "1g9pqf" }],
  ["path", { d: "M11 18h7", key: "c8dzvl" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChartPie = createLucideIcon("ChartPie", [
  [
    "path",
    {
      d: "M21 12c.552 0 1.005-.449.95-.998a10 10 0 0 0-8.953-8.951c-.55-.055-.998.398-.998.95v8a1 1 0 0 0 1 1z",
      key: "pzmjnu"
    }
  ],
  ["path", { d: "M21.21 15.89A10 10 0 1 1 8 2.83", key: "k2fpak" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChartScatter = createLucideIcon("ChartScatter", [
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }],
  ["circle", { cx: "18.5", cy: "5.5", r: ".5", fill: "currentColor", key: "lysivs" }],
  ["circle", { cx: "11.5", cy: "11.5", r: ".5", fill: "currentColor", key: "byv1b8" }],
  ["circle", { cx: "7.5", cy: "16.5", r: ".5", fill: "currentColor", key: "nkw3mc" }],
  ["circle", { cx: "17.5", cy: "14.5", r: ".5", fill: "currentColor", key: "1gjh6j" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChartSpline = createLucideIcon("ChartSpline", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M7 16c.5-2 1.5-7 4-7 2 0 2 3 4 3 2.5 0 4.5-5 5-7", key: "lw07rv" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CheckCheck = createLucideIcon("CheckCheck", [
  ["path", { d: "M18 6 7 17l-5-5", key: "116fxf" }],
  ["path", { d: "m22 10-7.5 7.5L13 16", key: "ke71qq" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Check = createLucideIcon("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChefHat = createLucideIcon("ChefHat", [
  [
    "path",
    {
      d: "M17 21a1 1 0 0 0 1-1v-5.35c0-.457.316-.844.727-1.041a4 4 0 0 0-2.134-7.589 5 5 0 0 0-9.186 0 4 4 0 0 0-2.134 7.588c.411.198.727.585.727 1.041V20a1 1 0 0 0 1 1Z",
      key: "1qvrer"
    }
  ],
  ["path", { d: "M6 17h12", key: "1jwigz" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cherry = createLucideIcon("Cherry", [
  ["path", { d: "M2 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z", key: "cvxqlc" }],
  ["path", { d: "M12 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z", key: "1ostrc" }],
  ["path", { d: "M7 14c3.22-2.91 4.29-8.75 5-12 1.66 2.38 4.94 9 5 12", key: "hqx58h" }],
  ["path", { d: "M22 9c-4.29 0-7.14-2.33-10-7 5.71 0 10 4.67 10 7Z", key: "eykp1o" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChevronDown = createLucideIcon("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChevronFirst = createLucideIcon("ChevronFirst", [
  ["path", { d: "m17 18-6-6 6-6", key: "1yerx2" }],
  ["path", { d: "M7 6v12", key: "1p53r6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChevronLast = createLucideIcon("ChevronLast", [
  ["path", { d: "m7 18 6-6-6-6", key: "lwmzdw" }],
  ["path", { d: "M17 6v12", key: "1o0aio" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChevronLeft = createLucideIcon("ChevronLeft", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChevronRight = createLucideIcon("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChevronUp = createLucideIcon("ChevronUp", [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChevronsDownUp = createLucideIcon("ChevronsDownUp", [
  ["path", { d: "m7 20 5-5 5 5", key: "13a0gw" }],
  ["path", { d: "m7 4 5 5 5-5", key: "1kwcof" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChevronsDown = createLucideIcon("ChevronsDown", [
  ["path", { d: "m7 6 5 5 5-5", key: "1lc07p" }],
  ["path", { d: "m7 13 5 5 5-5", key: "1d48rs" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChevronsLeftRightEllipsis = createLucideIcon("ChevronsLeftRightEllipsis", [
  ["path", { d: "m18 8 4 4-4 4", key: "1ak13k" }],
  ["path", { d: "m6 8-4 4 4 4", key: "15zrgr" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChevronsLeftRight = createLucideIcon("ChevronsLeftRight", [
  ["path", { d: "m9 7-5 5 5 5", key: "j5w590" }],
  ["path", { d: "m15 7 5 5-5 5", key: "1bl6da" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChevronsLeft = createLucideIcon("ChevronsLeft", [
  ["path", { d: "m11 17-5-5 5-5", key: "13zhaf" }],
  ["path", { d: "m18 17-5-5 5-5", key: "h8a8et" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChevronsRightLeft = createLucideIcon("ChevronsRightLeft", [
  ["path", { d: "m20 17-5-5 5-5", key: "30x0n2" }],
  ["path", { d: "m4 17 5-5-5-5", key: "16spf4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChevronsRight = createLucideIcon("ChevronsRight", [
  ["path", { d: "m6 17 5-5-5-5", key: "xnjwq" }],
  ["path", { d: "m13 17 5-5-5-5", key: "17xmmf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChevronsUpDown = createLucideIcon("ChevronsUpDown", [
  ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
  ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ChevronsUp = createLucideIcon("ChevronsUp", [
  ["path", { d: "m17 11-5-5-5 5", key: "e8nh98" }],
  ["path", { d: "m17 18-5-5-5 5", key: "2avn1x" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Chrome = createLucideIcon("Chrome", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["line", { x1: "21.17", x2: "12", y1: "8", y2: "8", key: "a0cw5f" }],
  ["line", { x1: "3.95", x2: "8.54", y1: "6.06", y2: "14", key: "1kftof" }],
  ["line", { x1: "10.88", x2: "15.46", y1: "21.94", y2: "14", key: "1ymyh8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Church = createLucideIcon("Church", [
  ["path", { d: "M10 9h4", key: "u4k05v" }],
  ["path", { d: "M12 7v5", key: "ma6bk" }],
  ["path", { d: "M14 22v-4a2 2 0 0 0-4 0v4", key: "1pdhuj" }],
  [
    "path",
    {
      d: "M18 22V5.618a1 1 0 0 0-.553-.894l-4.553-2.277a2 2 0 0 0-1.788 0L6.553 4.724A1 1 0 0 0 6 5.618V22",
      key: "1rkokr"
    }
  ],
  [
    "path",
    {
      d: "m18 7 3.447 1.724a1 1 0 0 1 .553.894V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.618a1 1 0 0 1 .553-.894L6 7",
      key: "1w6esw"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CigaretteOff = createLucideIcon("CigaretteOff", [
  ["path", { d: "M12 12H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h13", key: "1gdiyg" }],
  ["path", { d: "M18 8c0-2.5-2-2.5-2-5", key: "1il607" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M21 12a1 1 0 0 1 1 1v2a1 1 0 0 1-.5.866", key: "166zjj" }],
  ["path", { d: "M22 8c0-2.5-2-2.5-2-5", key: "1gah44" }],
  ["path", { d: "M7 12v4", key: "jqww69" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cigarette = createLucideIcon("Cigarette", [
  ["path", { d: "M17 12H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h14", key: "1mb5g1" }],
  ["path", { d: "M18 8c0-2.5-2-2.5-2-5", key: "1il607" }],
  ["path", { d: "M21 16a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1", key: "1yl5r7" }],
  ["path", { d: "M22 8c0-2.5-2-2.5-2-5", key: "1gah44" }],
  ["path", { d: "M7 12v4", key: "jqww69" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleAlert = createLucideIcon("CircleAlert", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleArrowDown = createLucideIcon("CircleArrowDown", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8 12 4 4 4-4", key: "k98ssh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleArrowLeft = createLucideIcon("CircleArrowLeft", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "m12 8-4 4 4 4", key: "15vm53" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleArrowOutDownLeft = createLucideIcon("CircleArrowOutDownLeft", [
  ["path", { d: "M2 12a10 10 0 1 1 10 10", key: "1yn6ov" }],
  ["path", { d: "m2 22 10-10", key: "28ilpk" }],
  ["path", { d: "M8 22H2v-6", key: "sulq54" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleArrowOutDownRight = createLucideIcon("CircleArrowOutDownRight", [
  ["path", { d: "M12 22a10 10 0 1 1 10-10", key: "130bv5" }],
  ["path", { d: "M22 22 12 12", key: "131aw7" }],
  ["path", { d: "M22 16v6h-6", key: "1gvm70" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleArrowOutUpLeft = createLucideIcon("CircleArrowOutUpLeft", [
  ["path", { d: "M2 8V2h6", key: "hiwtdz" }],
  ["path", { d: "m2 2 10 10", key: "1oh8rs" }],
  ["path", { d: "M12 2A10 10 0 1 1 2 12", key: "rrk4fa" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleArrowOutUpRight = createLucideIcon("CircleArrowOutUpRight", [
  ["path", { d: "M22 12A10 10 0 1 1 12 2", key: "1fm58d" }],
  ["path", { d: "M22 2 12 12", key: "yg2myt" }],
  ["path", { d: "M16 2h6v6", key: "zan5cs" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleArrowRight = createLucideIcon("CircleArrowRight", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m12 16 4-4-4-4", key: "1i9zcv" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleArrowUp = createLucideIcon("CircleArrowUp", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleCheckBig = createLucideIcon("CircleCheckBig", [
  ["path", { d: "M21.801 10A10 10 0 1 1 17 3.335", key: "yps3ct" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleCheck = createLucideIcon("CircleCheck", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleChevronDown = createLucideIcon("CircleChevronDown", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m16 10-4 4-4-4", key: "894hmk" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleChevronLeft = createLucideIcon("CircleChevronLeft", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m14 16-4-4 4-4", key: "ojs7w8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleChevronRight = createLucideIcon("CircleChevronRight", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m10 8 4 4-4 4", key: "1wy4r4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleChevronUp = createLucideIcon("CircleChevronUp", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m8 14 4-4 4 4", key: "fy2ptz" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleDashed = createLucideIcon("CircleDashed", [
  ["path", { d: "M10.1 2.182a10 10 0 0 1 3.8 0", key: "5ilxe3" }],
  ["path", { d: "M13.9 21.818a10 10 0 0 1-3.8 0", key: "11zvb9" }],
  ["path", { d: "M17.609 3.721a10 10 0 0 1 2.69 2.7", key: "1iw5b2" }],
  ["path", { d: "M2.182 13.9a10 10 0 0 1 0-3.8", key: "c0bmvh" }],
  ["path", { d: "M20.279 17.609a10 10 0 0 1-2.7 2.69", key: "1ruxm7" }],
  ["path", { d: "M21.818 10.1a10 10 0 0 1 0 3.8", key: "qkgqxc" }],
  ["path", { d: "M3.721 6.391a10 10 0 0 1 2.7-2.69", key: "1mcia2" }],
  ["path", { d: "M6.391 20.279a10 10 0 0 1-2.69-2.7", key: "1fvljs" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleDivide = createLucideIcon("CircleDivide", [
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "16", key: "aqc6ln" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "8", key: "1mkcni" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleDollarSign = createLucideIcon("CircleDollarSign", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleDotDashed = createLucideIcon("CircleDotDashed", [
  ["path", { d: "M10.1 2.18a9.93 9.93 0 0 1 3.8 0", key: "1qdqn0" }],
  ["path", { d: "M17.6 3.71a9.95 9.95 0 0 1 2.69 2.7", key: "1bq7p6" }],
  ["path", { d: "M21.82 10.1a9.93 9.93 0 0 1 0 3.8", key: "1rlaqf" }],
  ["path", { d: "M20.29 17.6a9.95 9.95 0 0 1-2.7 2.69", key: "1xk03u" }],
  ["path", { d: "M13.9 21.82a9.94 9.94 0 0 1-3.8 0", key: "l7re25" }],
  ["path", { d: "M6.4 20.29a9.95 9.95 0 0 1-2.69-2.7", key: "1v18p6" }],
  ["path", { d: "M2.18 13.9a9.93 9.93 0 0 1 0-3.8", key: "xdo6bj" }],
  ["path", { d: "M3.71 6.4a9.95 9.95 0 0 1 2.7-2.69", key: "1jjmaz" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleDot = createLucideIcon("CircleDot", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleEllipsis = createLucideIcon("CircleEllipsis", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M17 12h.01", key: "1m0b6t" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M7 12h.01", key: "eqddd0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleEqual = createLucideIcon("CircleEqual", [
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M7 14h10", key: "1mhdw3" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleFadingArrowUp = createLucideIcon("CircleFadingArrowUp", [
  ["path", { d: "M12 2a10 10 0 0 1 7.38 16.75", key: "175t95" }],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }],
  ["path", { d: "M2.5 8.875a10 10 0 0 0-.5 3", key: "1vce0s" }],
  ["path", { d: "M2.83 16a10 10 0 0 0 2.43 3.4", key: "o3fkw4" }],
  ["path", { d: "M4.636 5.235a10 10 0 0 1 .891-.857", key: "1szpfk" }],
  ["path", { d: "M8.644 21.42a10 10 0 0 0 7.631-.38", key: "9yhvd4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleFadingPlus = createLucideIcon("CircleFadingPlus", [
  ["path", { d: "M12 2a10 10 0 0 1 7.38 16.75", key: "175t95" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "M2.5 8.875a10 10 0 0 0-.5 3", key: "1vce0s" }],
  ["path", { d: "M2.83 16a10 10 0 0 0 2.43 3.4", key: "o3fkw4" }],
  ["path", { d: "M4.636 5.235a10 10 0 0 1 .891-.857", key: "1szpfk" }],
  ["path", { d: "M8.644 21.42a10 10 0 0 0 7.631-.38", key: "9yhvd4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleGauge = createLucideIcon("CircleGauge", [
  ["path", { d: "M15.6 2.7a10 10 0 1 0 5.7 5.7", key: "1e0p6d" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M13.4 10.6 19 5", key: "1kr7tw" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleHelp = createLucideIcon("CircleHelp", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleMinus = createLucideIcon("CircleMinus", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleOff = createLucideIcon("CircleOff", [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M8.35 2.69A10 10 0 0 1 21.3 15.65", key: "1pfsoa" }],
  ["path", { d: "M19.08 19.08A10 10 0 1 1 4.92 4.92", key: "1ablyi" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleParkingOff = createLucideIcon("CircleParkingOff", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m5 5 14 14", key: "11anup" }],
  ["path", { d: "M13 13a3 3 0 1 0 0-6H9v2", key: "uoagbd" }],
  ["path", { d: "M9 17v-2.34", key: "a9qo08" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleParking = createLucideIcon("CircleParking", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9", key: "1dfk2c" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CirclePause = createLucideIcon("CirclePause", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "10", x2: "10", y1: "15", y2: "9", key: "c1nkhi" }],
  ["line", { x1: "14", x2: "14", y1: "15", y2: "9", key: "h65svq" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CirclePercent = createLucideIcon("CirclePercent", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CirclePlay = createLucideIcon("CirclePlay", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polygon", { points: "10 8 16 12 10 16 10 8", key: "1cimsy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CirclePlus = createLucideIcon("CirclePlus", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CirclePower = createLucideIcon("CirclePower", [
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M7.998 9.003a5 5 0 1 0 8-.005", key: "1pek45" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleSlash2 = createLucideIcon("CircleSlash2", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M22 2 2 22", key: "y4kqgn" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleSlash = createLucideIcon("CircleSlash", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "9", x2: "15", y1: "15", y2: "9", key: "1dfufj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleStop = createLucideIcon("CircleStop", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["rect", { x: "9", y: "9", width: "6", height: "6", rx: "1", key: "1ssd4o" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleUserRound = createLucideIcon("CircleUserRound", [
  ["path", { d: "M18 20a6 6 0 0 0-12 0", key: "1qehca" }],
  ["circle", { cx: "12", cy: "10", r: "4", key: "1h16sb" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleUser = createLucideIcon("CircleUser", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662", key: "154egf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircleX = createLucideIcon("CircleX", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Circle = createLucideIcon("Circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CircuitBoard = createLucideIcon("CircuitBoard", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M11 9h4a2 2 0 0 0 2-2V3", key: "1ve2rv" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "M7 21v-4a2 2 0 0 1 2-2h4", key: "1fwkro" }],
  ["circle", { cx: "15", cy: "15", r: "2", key: "3i40o0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Citrus = createLucideIcon("Citrus", [
  [
    "path",
    {
      d: "M21.66 17.67a1.08 1.08 0 0 1-.04 1.6A12 12 0 0 1 4.73 2.38a1.1 1.1 0 0 1 1.61-.04z",
      key: "4ite01"
    }
  ],
  ["path", { d: "M19.65 15.66A8 8 0 0 1 8.35 4.34", key: "1gxipu" }],
  ["path", { d: "m14 10-5.5 5.5", key: "92pfem" }],
  ["path", { d: "M14 17.85V10H6.15", key: "xqmtsk" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Clapperboard = createLucideIcon("Clapperboard", [
  [
    "path",
    { d: "M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3Z", key: "1tn4o7" }
  ],
  ["path", { d: "m6.2 5.3 3.1 3.9", key: "iuk76l" }],
  ["path", { d: "m12.4 3.4 3.1 4", key: "6hsd6n" }],
  ["path", { d: "M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z", key: "ltgou9" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ClipboardCheck = createLucideIcon("ClipboardCheck", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "m9 14 2 2 4-4", key: "df797q" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ClipboardCopy = createLucideIcon("ClipboardCopy", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  ["path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2", key: "4jdomd" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v4", key: "3hqy98" }],
  ["path", { d: "M21 14H11", key: "1bme5i" }],
  ["path", { d: "m15 10-4 4 4 4", key: "5dvupr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ClipboardList = createLucideIcon("ClipboardList", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M12 11h4", key: "1jrz19" }],
  ["path", { d: "M12 16h4", key: "n85exb" }],
  ["path", { d: "M8 11h.01", key: "1dfujw" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ClipboardMinus = createLucideIcon("ClipboardMinus", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 14h6", key: "159ibu" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ClipboardPaste = createLucideIcon("ClipboardPaste", [
  [
    "path",
    { d: "M15 2H9a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Z", key: "1pp7kr" }
  ],
  [
    "path",
    {
      d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2M16 4h2a2 2 0 0 1 2 2v2M11 14h10",
      key: "2ik1ml"
    }
  ],
  ["path", { d: "m17 10 4 4-4 4", key: "vp2hj1" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ClipboardPenLine = createLucideIcon("ClipboardPenLine", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", key: "1oijnt" }],
  ["path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-.5", key: "1but9f" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 1.73 1", key: "1p8n7l" }],
  ["path", { d: "M8 18h1", key: "13wk12" }],
  [
    "path",
    {
      d: "M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "2t3380"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ClipboardPen = createLucideIcon("ClipboardPen", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", key: "1oijnt" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5.5", key: "cereej" }],
  ["path", { d: "M4 13.5V6a2 2 0 0 1 2-2h2", key: "5ua5vh" }],
  [
    "path",
    {
      d: "M13.378 15.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1y4qbx"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ClipboardPlus = createLucideIcon("ClipboardPlus", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 14h6", key: "159ibu" }],
  ["path", { d: "M12 17v-6", key: "1y8rbf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ClipboardType = createLucideIcon("ClipboardType", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 12v-1h6v1", key: "iehl6m" }],
  ["path", { d: "M11 17h2", key: "12w5me" }],
  ["path", { d: "M12 11v6", key: "1bwqyc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ClipboardX = createLucideIcon("ClipboardX", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "m15 11-6 6", key: "1toa9n" }],
  ["path", { d: "m9 11 6 6", key: "wlibny" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Clipboard = createLucideIcon("Clipboard", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Clock1 = createLucideIcon("Clock1", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 14.5 8", key: "12zbmj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Clock10 = createLucideIcon("Clock10", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 8 10", key: "atfzqc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Clock11 = createLucideIcon("Clock11", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 9.5 8", key: "l5bg6f" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Clock12 = createLucideIcon("Clock12", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12", key: "1fub01" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Clock2 = createLucideIcon("Clock2", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 10", key: "1g230d" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Clock3 = createLucideIcon("Clock3", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16.5 12", key: "1aq6pp" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Clock4 = createLucideIcon("Clock4", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Clock5 = createLucideIcon("Clock5", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 14.5 16", key: "1pcbox" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Clock6 = createLucideIcon("Clock6", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 12 16.5", key: "hb2qv6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Clock7 = createLucideIcon("Clock7", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 9.5 16", key: "ka3394" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Clock8 = createLucideIcon("Clock8", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 8 14", key: "tmc9b4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Clock9 = createLucideIcon("Clock9", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 7.5 12", key: "1k60p0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ClockAlert = createLucideIcon("ClockAlert", [
  ["path", { d: "M12 6v6l4 2", key: "mmk7yg" }],
  ["path", { d: "M16 21.16a10 10 0 1 1 5-13.516", key: "cxo92l" }],
  ["path", { d: "M20 11.5v6", key: "2ei3xq" }],
  ["path", { d: "M20 21.5h.01", key: "1r2dzp" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ClockArrowDown = createLucideIcon("ClockArrowDown", [
  ["path", { d: "M12.338 21.994A10 10 0 1 1 21.925 13.227", key: "1i7shu" }],
  ["path", { d: "M12 6v6l2 1", key: "19cm8n" }],
  ["path", { d: "m14 18 4 4 4-4", key: "1waygx" }],
  ["path", { d: "M18 14v8", key: "irew45" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ClockArrowUp = createLucideIcon("ClockArrowUp", [
  ["path", { d: "M13.228 21.925A10 10 0 1 1 21.994 12.338", key: "1fzlyi" }],
  ["path", { d: "M12 6v6l1.562.781", key: "1ujuk9" }],
  ["path", { d: "m14 18 4-4 4 4", key: "ftkppy" }],
  ["path", { d: "M18 22v-8", key: "su0gjh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Clock = createLucideIcon("Clock", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CloudCog = createLucideIcon("CloudCog", [
  ["circle", { cx: "12", cy: "17", r: "3", key: "1spfwm" }],
  ["path", { d: "M4.2 15.1A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.2", key: "zaobp" }],
  ["path", { d: "m15.7 18.4-.9-.3", key: "4qxpbn" }],
  ["path", { d: "m9.2 15.9-.9-.3", key: "17q7o2" }],
  ["path", { d: "m10.6 20.7.3-.9", key: "1pf4s2" }],
  ["path", { d: "m13.1 14.2.3-.9", key: "1mnuqm" }],
  ["path", { d: "m13.6 20.7-.4-1", key: "1jpd1m" }],
  ["path", { d: "m10.8 14.3-.4-1", key: "17ugyy" }],
  ["path", { d: "m8.3 18.6 1-.4", key: "s42vdx" }],
  ["path", { d: "m14.7 15.8 1-.4", key: "2wizun" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CloudDownload = createLucideIcon("CloudDownload", [
  ["path", { d: "M12 13v8l-4-4", key: "1f5nwf" }],
  ["path", { d: "m12 21 4-4", key: "1lfcce" }],
  ["path", { d: "M4.393 15.269A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.436 8.284", key: "ui1hmy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CloudDrizzle = createLucideIcon("CloudDrizzle", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M8 19v1", key: "1dk2by" }],
  ["path", { d: "M8 14v1", key: "84yxot" }],
  ["path", { d: "M16 19v1", key: "v220m7" }],
  ["path", { d: "M16 14v1", key: "g12gj6" }],
  ["path", { d: "M12 21v1", key: "q8vafk" }],
  ["path", { d: "M12 16v1", key: "1mx6rx" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CloudFog = createLucideIcon("CloudFog", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 17H7", key: "pygtm1" }],
  ["path", { d: "M17 21H9", key: "1u2q02" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CloudHail = createLucideIcon("CloudHail", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 14v2", key: "a1is7l" }],
  ["path", { d: "M8 14v2", key: "1e9m6t" }],
  ["path", { d: "M16 20h.01", key: "xwek51" }],
  ["path", { d: "M8 20h.01", key: "1vjney" }],
  ["path", { d: "M12 16v2", key: "z66u1j" }],
  ["path", { d: "M12 22h.01", key: "1urd7a" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CloudLightning = createLucideIcon("CloudLightning", [
  ["path", { d: "M6 16.326A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 .5 8.973", key: "1cez44" }],
  ["path", { d: "m13 12-3 5h4l-3 5", key: "1t22er" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CloudMoonRain = createLucideIcon("CloudMoonRain", [
  ["path", { d: "M10.188 8.5A6 6 0 0 1 16 4a1 1 0 0 0 6 6 6 6 0 0 1-3 5.197", key: "erj67n" }],
  ["path", { d: "M11 20v2", key: "174qtz" }],
  ["path", { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24", key: "1qmrp3" }],
  ["path", { d: "M7 19v2", key: "12npes" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CloudMoon = createLucideIcon("CloudMoon", [
  ["path", { d: "M10.188 8.5A6 6 0 0 1 16 4a1 1 0 0 0 6 6 6 6 0 0 1-3 5.197", key: "erj67n" }],
  ["path", { d: "M13 16a3 3 0 1 1 0 6H7a5 5 0 1 1 4.9-6Z", key: "p44pc9" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CloudOff = createLucideIcon("CloudOff", [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M5.782 5.782A7 7 0 0 0 9 19h8.5a4.5 4.5 0 0 0 1.307-.193", key: "yfwify" }],
  [
    "path",
    { d: "M21.532 16.5A4.5 4.5 0 0 0 17.5 10h-1.79A7.008 7.008 0 0 0 10 5.07", key: "jlfiyv" }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CloudRainWind = createLucideIcon("CloudRainWind", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "m9.2 22 3-7", key: "sb5f6j" }],
  ["path", { d: "m9 13-3 7", key: "500co5" }],
  ["path", { d: "m17 13-3 7", key: "8t2fiy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CloudRain = createLucideIcon("CloudRain", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 14v6", key: "1j4efv" }],
  ["path", { d: "M8 14v6", key: "17c4r9" }],
  ["path", { d: "M12 16v6", key: "c8a4gj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CloudSnow = createLucideIcon("CloudSnow", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M8 19h.01", key: "puxtts" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }],
  ["path", { d: "M12 21h.01", key: "h35vbk" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }],
  ["path", { d: "M16 19h.01", key: "1vcnzz" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CloudSunRain = createLucideIcon("CloudSunRain", [
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }],
  ["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128", key: "dpwdj0" }],
  ["path", { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24", key: "1qmrp3" }],
  ["path", { d: "M11 20v2", key: "174qtz" }],
  ["path", { d: "M7 19v2", key: "12npes" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CloudSun = createLucideIcon("CloudSun", [
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }],
  ["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128", key: "dpwdj0" }],
  ["path", { d: "M13 22H7a5 5 0 1 1 4.9-6H13a3 3 0 0 1 0 6Z", key: "s09mg5" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CloudUpload = createLucideIcon("CloudUpload", [
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "m8 17 4-4 4 4", key: "1quai1" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cloud = createLucideIcon("Cloud", [
  ["path", { d: "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z", key: "p7xjir" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cloudy = createLucideIcon("Cloudy", [
  ["path", { d: "M17.5 21H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z", key: "gqqjvc" }],
  ["path", { d: "M22 10a3 3 0 0 0-3-3h-2.207a5.502 5.502 0 0 0-10.702.5", key: "1p2s76" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Clover = createLucideIcon("Clover", [
  ["path", { d: "M16.17 7.83 2 22", key: "t58vo8" }],
  [
    "path",
    {
      d: "M4.02 12a2.827 2.827 0 1 1 3.81-4.17A2.827 2.827 0 1 1 12 4.02a2.827 2.827 0 1 1 4.17 3.81A2.827 2.827 0 1 1 19.98 12a2.827 2.827 0 1 1-3.81 4.17A2.827 2.827 0 1 1 12 19.98a2.827 2.827 0 1 1-4.17-3.81A1 1 0 1 1 4 12",
      key: "17k36q"
    }
  ],
  ["path", { d: "m7.83 7.83 8.34 8.34", key: "1d7sxk" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Club = createLucideIcon("Club", [
  [
    "path",
    {
      d: "M17.28 9.05a5.5 5.5 0 1 0-10.56 0A5.5 5.5 0 1 0 12 17.66a5.5 5.5 0 1 0 5.28-8.6Z",
      key: "27yuqz"
    }
  ],
  ["path", { d: "M12 17.66L12 22", key: "ogfahf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CodeXml = createLucideIcon("CodeXml", [
  ["path", { d: "m18 16 4-4-4-4", key: "1inbqp" }],
  ["path", { d: "m6 8-4 4 4 4", key: "15zrgr" }],
  ["path", { d: "m14.5 4-5 16", key: "e7oirm" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Code = createLucideIcon("Code", [
  ["polyline", { points: "16 18 22 12 16 6", key: "z7tu5w" }],
  ["polyline", { points: "8 6 2 12 8 18", key: "1eg1df" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Codepen = createLucideIcon("Codepen", [
  ["polygon", { points: "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2", key: "srzb37" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "15.5", key: "1t73f2" }],
  ["polyline", { points: "22 8.5 12 15.5 2 8.5", key: "ajlxae" }],
  ["polyline", { points: "2 15.5 12 8.5 22 15.5", key: "susrui" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "8.5", key: "2cldga" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Codesandbox = createLucideIcon("Codesandbox", [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ],
  ["polyline", { points: "7.5 4.21 12 6.81 16.5 4.21", key: "fabo96" }],
  ["polyline", { points: "7.5 19.79 7.5 14.6 3 12", key: "z377f1" }],
  ["polyline", { points: "21 12 16.5 14.6 16.5 19.79", key: "9nrev1" }],
  ["polyline", { points: "3.27 6.96 12 12.01 20.73 6.96", key: "1180pa" }],
  ["line", { x1: "12", x2: "12", y1: "22.08", y2: "12", key: "3z3uq6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Coffee = createLucideIcon("Coffee", [
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M14 2v2", key: "6buw04" }],
  [
    "path",
    {
      d: "M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1",
      key: "pwadti"
    }
  ],
  ["path", { d: "M6 2v2", key: "colzsn" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cog = createLucideIcon("Cog", [
  ["path", { d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z", key: "sobvz5" }],
  ["path", { d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z", key: "11i496" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 22v-2", key: "1osdcq" }],
  ["path", { d: "m17 20.66-1-1.73", key: "eq3orb" }],
  ["path", { d: "M11 10.27 7 3.34", key: "16pf9h" }],
  ["path", { d: "m20.66 17-1.73-1", key: "sg0v6f" }],
  ["path", { d: "m3.34 7 1.73 1", key: "1ulond" }],
  ["path", { d: "M14 12h8", key: "4f43i9" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "m20.66 7-1.73 1", key: "1ow05n" }],
  ["path", { d: "m3.34 17 1.73-1", key: "nuk764" }],
  ["path", { d: "m17 3.34-1 1.73", key: "2wel8s" }],
  ["path", { d: "m11 13.73-4 6.93", key: "794ttg" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Coins = createLucideIcon("Coins", [
  ["circle", { cx: "8", cy: "8", r: "6", key: "3yglwk" }],
  ["path", { d: "M18.09 10.37A6 6 0 1 1 10.34 18", key: "t5s6rm" }],
  ["path", { d: "M7 6h1v4", key: "1obek4" }],
  ["path", { d: "m16.71 13.88.7.71-2.82 2.82", key: "1rbuyh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Columns2 = createLucideIcon("Columns2", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 3v18", key: "108xh3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Columns3 = createLucideIcon("Columns3", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Columns4 = createLucideIcon("Columns4", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7.5 3v18", key: "w0wo6v" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["path", { d: "M16.5 3v18", key: "10tjh1" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Combine = createLucideIcon("Combine", [
  ["path", { d: "M10 18H5a3 3 0 0 1-3-3v-1", key: "ru65g8" }],
  ["path", { d: "M14 2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2", key: "e30een" }],
  ["path", { d: "M20 2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2", key: "2ahx8o" }],
  ["path", { d: "m7 21 3-3-3-3", key: "127cv2" }],
  ["rect", { x: "14", y: "14", width: "8", height: "8", rx: "2", key: "1b0bso" }],
  ["rect", { x: "2", y: "2", width: "8", height: "8", rx: "2", key: "1x09vl" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Command = createLucideIcon("Command", [
  [
    "path",
    { d: "M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3", key: "11bfej" }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Compass = createLucideIcon("Compass", [
  [
    "path",
    {
      d: "m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z",
      key: "9ktpf1"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Component = createLucideIcon("Component", [
  [
    "path",
    {
      d: "M15.536 11.293a1 1 0 0 0 0 1.414l2.376 2.377a1 1 0 0 0 1.414 0l2.377-2.377a1 1 0 0 0 0-1.414l-2.377-2.377a1 1 0 0 0-1.414 0z",
      key: "1uwlt4"
    }
  ],
  [
    "path",
    {
      d: "M2.297 11.293a1 1 0 0 0 0 1.414l2.377 2.377a1 1 0 0 0 1.414 0l2.377-2.377a1 1 0 0 0 0-1.414L6.088 8.916a1 1 0 0 0-1.414 0z",
      key: "10291m"
    }
  ],
  [
    "path",
    {
      d: "M8.916 17.912a1 1 0 0 0 0 1.415l2.377 2.376a1 1 0 0 0 1.414 0l2.377-2.376a1 1 0 0 0 0-1.415l-2.377-2.376a1 1 0 0 0-1.414 0z",
      key: "1tqoq1"
    }
  ],
  [
    "path",
    {
      d: "M8.916 4.674a1 1 0 0 0 0 1.414l2.377 2.376a1 1 0 0 0 1.414 0l2.377-2.376a1 1 0 0 0 0-1.414l-2.377-2.377a1 1 0 0 0-1.414 0z",
      key: "1x6lto"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Computer = createLucideIcon("Computer", [
  ["rect", { width: "14", height: "8", x: "5", y: "2", rx: "2", key: "wc9tft" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6 18h2", key: "rwmk9e" }],
  ["path", { d: "M12 18h6", key: "aqd8w3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ConciergeBell = createLucideIcon("ConciergeBell", [
  [
    "path",
    { d: "M3 20a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1Z", key: "1pvr1r" }
  ],
  ["path", { d: "M20 16a8 8 0 1 0-16 0", key: "1pa543" }],
  ["path", { d: "M12 4v4", key: "1bq03y" }],
  ["path", { d: "M10 4h4", key: "1xpv9s" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cone = createLucideIcon("Cone", [
  ["path", { d: "m20.9 18.55-8-15.98a1 1 0 0 0-1.8 0l-8 15.98", key: "53pte7" }],
  ["ellipse", { cx: "12", cy: "19", rx: "9", ry: "3", key: "1ji25f" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Construction = createLucideIcon("Construction", [
  ["rect", { x: "2", y: "6", width: "20", height: "8", rx: "1", key: "1estib" }],
  ["path", { d: "M17 14v7", key: "7m2elx" }],
  ["path", { d: "M7 14v7", key: "1cm7wv" }],
  ["path", { d: "M17 3v3", key: "1v4jwn" }],
  ["path", { d: "M7 3v3", key: "7o6guu" }],
  ["path", { d: "M10 14 2.3 6.3", key: "1023jk" }],
  ["path", { d: "m14 6 7.7 7.7", key: "1s8pl2" }],
  ["path", { d: "m8 6 8 8", key: "hl96qh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ContactRound = createLucideIcon("ContactRound", [
  ["path", { d: "M16 2v2", key: "scm5qe" }],
  ["path", { d: "M17.915 22a6 6 0 0 0-12 0", key: "suqz9p" }],
  ["path", { d: "M8 2v2", key: "pbkmx" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["rect", { x: "3", y: "4", width: "18", height: "18", rx: "2", key: "12vinp" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Contact = createLucideIcon("Contact", [
  ["path", { d: "M16 2v2", key: "scm5qe" }],
  ["path", { d: "M7 22v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2", key: "1waht3" }],
  ["path", { d: "M8 2v2", key: "pbkmx" }],
  ["circle", { cx: "12", cy: "11", r: "3", key: "itu57m" }],
  ["rect", { x: "3", y: "4", width: "18", height: "18", rx: "2", key: "12vinp" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Container = createLucideIcon("Container", [
  [
    "path",
    {
      d: "M22 7.7c0-.6-.4-1.2-.8-1.5l-6.3-3.9a1.72 1.72 0 0 0-1.7 0l-10.3 6c-.5.2-.9.8-.9 1.4v6.6c0 .5.4 1.2.8 1.5l6.3 3.9a1.72 1.72 0 0 0 1.7 0l10.3-6c.5-.3.9-1 .9-1.5Z",
      key: "1t2lqe"
    }
  ],
  ["path", { d: "M10 21.9V14L2.1 9.1", key: "o7czzq" }],
  ["path", { d: "m10 14 11.9-6.9", key: "zm5e20" }],
  ["path", { d: "M14 19.8v-8.1", key: "159ecu" }],
  ["path", { d: "M18 17.5V9.4", key: "11uown" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Contrast = createLucideIcon("Contrast", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 18a6 6 0 0 0 0-12v12z", key: "j4l70d" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cookie = createLucideIcon("Cookie", [
  ["path", { d: "M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5", key: "laymnq" }],
  ["path", { d: "M8.5 8.5v.01", key: "ue8clq" }],
  ["path", { d: "M16 15.5v.01", key: "14dtrp" }],
  ["path", { d: "M12 12v.01", key: "u5ubse" }],
  ["path", { d: "M11 17v.01", key: "1hyl5a" }],
  ["path", { d: "M7 14v.01", key: "uct60s" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CookingPot = createLucideIcon("CookingPot", [
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M20 12v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8", key: "u0tga0" }],
  ["path", { d: "m4 8 16-4", key: "16g0ng" }],
  [
    "path",
    {
      d: "m8.86 6.78-.45-1.81a2 2 0 0 1 1.45-2.43l1.94-.48a2 2 0 0 1 2.43 1.46l.45 1.8",
      key: "12cejc"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CopyCheck = createLucideIcon("CopyCheck", [
  ["path", { d: "m12 15 2 2 4-4", key: "2c609p" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CopyMinus = createLucideIcon("CopyMinus", [
  ["line", { x1: "12", x2: "18", y1: "15", y2: "15", key: "1nscbv" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CopyPlus = createLucideIcon("CopyPlus", [
  ["line", { x1: "15", x2: "15", y1: "12", y2: "18", key: "1p7wdc" }],
  ["line", { x1: "12", x2: "18", y1: "15", y2: "15", key: "1nscbv" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CopySlash = createLucideIcon("CopySlash", [
  ["line", { x1: "12", x2: "18", y1: "18", y2: "12", key: "ebkxgr" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CopyX = createLucideIcon("CopyX", [
  ["line", { x1: "12", x2: "18", y1: "12", y2: "18", key: "1rg63v" }],
  ["line", { x1: "12", x2: "18", y1: "18", y2: "12", key: "ebkxgr" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Copy = createLucideIcon("Copy", [
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Copyleft = createLucideIcon("Copyleft", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.17 14.83a4 4 0 1 0 0-5.66", key: "1sveal" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Copyright = createLucideIcon("Copyright", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M14.83 14.83a4 4 0 1 1 0-5.66", key: "1i56pz" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CornerDownLeft = createLucideIcon("CornerDownLeft", [
  ["polyline", { points: "9 10 4 15 9 20", key: "r3jprv" }],
  ["path", { d: "M20 4v7a4 4 0 0 1-4 4H4", key: "6o5b7l" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CornerDownRight = createLucideIcon("CornerDownRight", [
  ["polyline", { points: "15 10 20 15 15 20", key: "1q7qjw" }],
  ["path", { d: "M4 4v7a4 4 0 0 0 4 4h12", key: "z08zvw" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CornerLeftDown = createLucideIcon("CornerLeftDown", [
  ["polyline", { points: "14 15 9 20 4 15", key: "nkc4i" }],
  ["path", { d: "M20 4h-7a4 4 0 0 0-4 4v12", key: "nbpdq2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CornerLeftUp = createLucideIcon("CornerLeftUp", [
  ["polyline", { points: "14 9 9 4 4 9", key: "m9oyvo" }],
  ["path", { d: "M20 20h-7a4 4 0 0 1-4-4V4", key: "1blwi3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CornerRightDown = createLucideIcon("CornerRightDown", [
  ["polyline", { points: "10 15 15 20 20 15", key: "axus6l" }],
  ["path", { d: "M4 4h7a4 4 0 0 1 4 4v12", key: "wcbgct" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CornerRightUp = createLucideIcon("CornerRightUp", [
  ["polyline", { points: "10 9 15 4 20 9", key: "1lr6px" }],
  ["path", { d: "M4 20h7a4 4 0 0 0 4-4V4", key: "1plgdj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CornerUpLeft = createLucideIcon("CornerUpLeft", [
  ["polyline", { points: "9 14 4 9 9 4", key: "881910" }],
  ["path", { d: "M20 20v-7a4 4 0 0 0-4-4H4", key: "1nkjon" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CornerUpRight = createLucideIcon("CornerUpRight", [
  ["polyline", { points: "15 14 20 9 15 4", key: "1tbx3s" }],
  ["path", { d: "M4 20v-7a4 4 0 0 1 4-4h12", key: "1lu4f8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cpu = createLucideIcon("Cpu", [
  ["rect", { width: "16", height: "16", x: "4", y: "4", rx: "2", key: "14l7u7" }],
  ["rect", { width: "6", height: "6", x: "9", y: "9", rx: "1", key: "5aljv4" }],
  ["path", { d: "M15 2v2", key: "13l42r" }],
  ["path", { d: "M15 20v2", key: "15mkzm" }],
  ["path", { d: "M2 15h2", key: "1gxd5l" }],
  ["path", { d: "M2 9h2", key: "1bbxkp" }],
  ["path", { d: "M20 15h2", key: "19e6y8" }],
  ["path", { d: "M20 9h2", key: "19tzq7" }],
  ["path", { d: "M9 2v2", key: "165o2o" }],
  ["path", { d: "M9 20v2", key: "i2bqo8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CreativeCommons = createLucideIcon("CreativeCommons", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  [
    "path",
    { d: "M10 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1", key: "1ss3eq" }
  ],
  [
    "path",
    { d: "M17 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1", key: "1od56t" }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CreditCard = createLucideIcon("CreditCard", [
  ["rect", { width: "20", height: "14", x: "2", y: "5", rx: "2", key: "ynyp8z" }],
  ["line", { x1: "2", x2: "22", y1: "10", y2: "10", key: "1b3vmo" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Croissant = createLucideIcon("Croissant", [
  [
    "path",
    {
      d: "m4.6 13.11 5.79-3.21c1.89-1.05 4.79 1.78 3.71 3.71l-3.22 5.81C8.8 23.16.79 15.23 4.6 13.11Z",
      key: "1ozxlb"
    }
  ],
  [
    "path",
    {
      d: "m10.5 9.5-1-2.29C9.2 6.48 8.8 6 8 6H4.5C2.79 6 2 6.5 2 8.5a7.71 7.71 0 0 0 2 4.83",
      key: "ffuyb5"
    }
  ],
  ["path", { d: "M8 6c0-1.55.24-4-2-4-2 0-2.5 2.17-2.5 4", key: "osnpzi" }],
  [
    "path",
    {
      d: "m14.5 13.5 2.29 1c.73.3 1.21.7 1.21 1.5v3.5c0 1.71-.5 2.5-2.5 2.5a7.71 7.71 0 0 1-4.83-2",
      key: "1vubaw"
    }
  ],
  ["path", { d: "M18 16c1.55 0 4-.24 4 2 0 2-2.17 2.5-4 2.5", key: "wxr772" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Crop = createLucideIcon("Crop", [
  ["path", { d: "M6 2v14a2 2 0 0 0 2 2h14", key: "ron5a4" }],
  ["path", { d: "M18 22V8a2 2 0 0 0-2-2H2", key: "7s9ehn" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cross = createLucideIcon("Cross", [
  [
    "path",
    {
      d: "M11 2a2 2 0 0 0-2 2v5H4a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h5v5c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2v-5h5a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-5V4a2 2 0 0 0-2-2h-2z",
      key: "1t5g7j"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Crosshair = createLucideIcon("Crosshair", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "22", x2: "18", y1: "12", y2: "12", key: "l9bcsi" }],
  ["line", { x1: "6", x2: "2", y1: "12", y2: "12", key: "13hhkx" }],
  ["line", { x1: "12", x2: "12", y1: "6", y2: "2", key: "10w3f3" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "18", key: "15g9kq" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Crown = createLucideIcon("Crown", [
  [
    "path",
    {
      d: "M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z",
      key: "1vdc57"
    }
  ],
  ["path", { d: "M5 21h14", key: "11awu3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cuboid = createLucideIcon("Cuboid", [
  [
    "path",
    {
      d: "m21.12 6.4-6.05-4.06a2 2 0 0 0-2.17-.05L2.95 8.41a2 2 0 0 0-.95 1.7v5.82a2 2 0 0 0 .88 1.66l6.05 4.07a2 2 0 0 0 2.17.05l9.95-6.12a2 2 0 0 0 .95-1.7V8.06a2 2 0 0 0-.88-1.66Z",
      key: "1u2ovd"
    }
  ],
  ["path", { d: "M10 22v-8L2.25 9.15", key: "11pn4q" }],
  ["path", { d: "m10 14 11.77-6.87", key: "1kt1wh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CupSoda = createLucideIcon("CupSoda", [
  ["path", { d: "m6 8 1.75 12.28a2 2 0 0 0 2 1.72h4.54a2 2 0 0 0 2-1.72L18 8", key: "8166m8" }],
  ["path", { d: "M5 8h14", key: "pcz4l3" }],
  ["path", { d: "M7 15a6.47 6.47 0 0 1 5 0 6.47 6.47 0 0 0 5 0", key: "yjz344" }],
  ["path", { d: "m12 8 1-6h2", key: "3ybfa4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Currency = createLucideIcon("Currency", [
  ["circle", { cx: "12", cy: "12", r: "8", key: "46899m" }],
  ["line", { x1: "3", x2: "6", y1: "3", y2: "6", key: "1jkytn" }],
  ["line", { x1: "21", x2: "18", y1: "3", y2: "6", key: "14zfjt" }],
  ["line", { x1: "3", x2: "6", y1: "21", y2: "18", key: "iusuec" }],
  ["line", { x1: "21", x2: "18", y1: "21", y2: "18", key: "yj2dd7" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cylinder = createLucideIcon("Cylinder", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5v14a9 3 0 0 0 18 0V5", key: "aqi0yr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dam = createLucideIcon("Dam", [
  [
    "path",
    { d: "M11 11.31c1.17.56 1.54 1.69 3.5 1.69 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1", key: "157kva" }
  ],
  ["path", { d: "M11.75 18c.35.5 1.45 1 2.75 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1", key: "d7q6m6" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  [
    "path",
    { d: "M7 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1L10 4a1 1 0 0 0-1-1z", key: "pr6s65" }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DatabaseBackup = createLucideIcon("DatabaseBackup", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 12a9 3 0 0 0 5 2.69", key: "1ui2ym" }],
  ["path", { d: "M21 9.3V5", key: "6k6cib" }],
  ["path", { d: "M3 5v14a9 3 0 0 0 6.47 2.88", key: "i62tjy" }],
  ["path", { d: "M12 12v4h4", key: "1bxaet" }],
  [
    "path",
    {
      d: "M13 20a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L12 16",
      key: "1f4ei9"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DatabaseZap = createLucideIcon("DatabaseZap", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5V19A9 3 0 0 0 15 21.84", key: "14ibmq" }],
  ["path", { d: "M21 5V8", key: "1marbg" }],
  ["path", { d: "M21 12L18 17H22L19 22", key: "zafso" }],
  ["path", { d: "M3 12A9 3 0 0 0 14.59 14.87", key: "1y4wr8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Database = createLucideIcon("Database", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5V19A9 3 0 0 0 21 19V5", key: "1wlel7" }],
  ["path", { d: "M3 12A9 3 0 0 0 21 12", key: "mv7ke4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Delete = createLucideIcon("Delete", [
  [
    "path",
    {
      d: "M10 5a2 2 0 0 0-1.344.519l-6.328 5.74a1 1 0 0 0 0 1.481l6.328 5.741A2 2 0 0 0 10 19h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z",
      key: "1yo7s0"
    }
  ],
  ["path", { d: "m12 9 6 6", key: "anjzzh" }],
  ["path", { d: "m18 9-6 6", key: "1fp51s" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dessert = createLucideIcon("Dessert", [
  ["circle", { cx: "12", cy: "4", r: "2", key: "muu5ef" }],
  [
    "path",
    {
      d: "M10.2 3.2C5.5 4 2 8.1 2 13a2 2 0 0 0 4 0v-1a2 2 0 0 1 4 0v4a2 2 0 0 0 4 0v-4a2 2 0 0 1 4 0v1a2 2 0 0 0 4 0c0-4.9-3.5-9-8.2-9.8",
      key: "lfo06j"
    }
  ],
  ["path", { d: "M3.2 14.8a9 9 0 0 0 17.6 0", key: "12xarc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Diameter = createLucideIcon("Diameter", [
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["circle", { cx: "5", cy: "5", r: "2", key: "1gwv83" }],
  ["path", { d: "M6.48 3.66a10 10 0 0 1 13.86 13.86", key: "xr8kdq" }],
  ["path", { d: "m6.41 6.41 11.18 11.18", key: "uhpjw7" }],
  ["path", { d: "M3.66 6.48a10 10 0 0 0 13.86 13.86", key: "cldpwv" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DiamondMinus = createLucideIcon("DiamondMinus", [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0z",
      key: "1ey20j"
    }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DiamondPercent = createLucideIcon("DiamondPercent", [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0Z",
      key: "1tpxz2"
    }
  ],
  ["path", { d: "M9.2 9.2h.01", key: "1b7bvt" }],
  ["path", { d: "m14.5 9.5-5 5", key: "17q4r4" }],
  ["path", { d: "M14.7 14.8h.01", key: "17nsh4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DiamondPlus = createLucideIcon("DiamondPlus", [
  ["path", { d: "M12 8v8", key: "napkw2" }],
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0z",
      key: "1ey20j"
    }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Diamond = createLucideIcon("Diamond", [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41l-7.59-7.59a2.41 2.41 0 0 0-3.41 0Z",
      key: "1f1r0c"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dice1 = createLucideIcon("Dice1", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dice2 = createLucideIcon("Dice2", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }],
  ["path", { d: "M9 15h.01", key: "fzyn71" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dice3 = createLucideIcon("Dice3", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dice4 = createLucideIcon("Dice4", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dice5 = createLucideIcon("Dice5", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dice6 = createLucideIcon("Dice6", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dices = createLucideIcon("Dices", [
  ["rect", { width: "12", height: "12", x: "2", y: "10", rx: "2", ry: "2", key: "6agr2n" }],
  [
    "path",
    { d: "m17.92 14 3.5-3.5a2.24 2.24 0 0 0 0-3l-5-4.92a2.24 2.24 0 0 0-3 0L10 6", key: "1o487t" }
  ],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 14h.01", key: "ssrbsk" }],
  ["path", { d: "M15 6h.01", key: "cblpky" }],
  ["path", { d: "M18 9h.01", key: "2061c0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Diff = createLucideIcon("Diff", [
  ["path", { d: "M12 3v14", key: "7cf3v8" }],
  ["path", { d: "M5 10h14", key: "elsbfy" }],
  ["path", { d: "M5 21h14", key: "11awu3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Disc2 = createLucideIcon("Disc2", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Disc3 = createLucideIcon("Disc3", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M6 12c0-1.7.7-3.2 1.8-4.2", key: "oqkarx" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M18 12c0 1.7-.7 3.2-1.8 4.2", key: "1eah9h" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DiscAlbum = createLucideIcon("DiscAlbum", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "12", cy: "12", r: "5", key: "nd82uf" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Disc = createLucideIcon("Disc", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Divide = createLucideIcon("Divide", [
  ["circle", { cx: "12", cy: "6", r: "1", key: "1bh7o1" }],
  ["line", { x1: "5", x2: "19", y1: "12", y2: "12", key: "13b5wn" }],
  ["circle", { cx: "12", cy: "18", r: "1", key: "lqb9t5" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DnaOff = createLucideIcon("DnaOff", [
  ["path", { d: "M15 2c-1.35 1.5-2.092 3-2.5 4.5L14 8", key: "1bivrr" }],
  ["path", { d: "m17 6-2.891-2.891", key: "xu6p2f" }],
  ["path", { d: "M2 15c3.333-3 6.667-3 10-3", key: "nxix30" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "m20 9 .891.891", key: "3xwk7g" }],
  ["path", { d: "M22 9c-1.5 1.35-3 2.092-4.5 2.5l-1-1", key: "18cutr" }],
  ["path", { d: "M3.109 14.109 4 15", key: "q76aoh" }],
  ["path", { d: "m6.5 12.5 1 1", key: "cs35ky" }],
  ["path", { d: "m7 18 2.891 2.891", key: "1sisit" }],
  ["path", { d: "M9 22c1.35-1.5 2.092-3 2.5-4.5L10 16", key: "rlvei3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dna = createLucideIcon("Dna", [
  ["path", { d: "m10 16 1.5 1.5", key: "11lckj" }],
  ["path", { d: "m14 8-1.5-1.5", key: "1ohn8i" }],
  ["path", { d: "M15 2c-1.798 1.998-2.518 3.995-2.807 5.993", key: "80uv8i" }],
  ["path", { d: "m16.5 10.5 1 1", key: "696xn5" }],
  ["path", { d: "m17 6-2.891-2.891", key: "xu6p2f" }],
  ["path", { d: "M2 15c6.667-6 13.333 0 20-6", key: "1pyr53" }],
  ["path", { d: "m20 9 .891.891", key: "3xwk7g" }],
  ["path", { d: "M3.109 14.109 4 15", key: "q76aoh" }],
  ["path", { d: "m6.5 12.5 1 1", key: "cs35ky" }],
  ["path", { d: "m7 18 2.891 2.891", key: "1sisit" }],
  ["path", { d: "M9 22c1.798-1.998 2.518-3.995 2.807-5.993", key: "q3hbxp" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dock = createLucideIcon("Dock", [
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M6 16h12", key: "u522kt" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dog = createLucideIcon("Dog", [
  ["path", { d: "M11.25 16.25h1.5L12 17z", key: "w7jh35" }],
  ["path", { d: "M16 14v.5", key: "1lajdz" }],
  [
    "path",
    {
      d: "M4.42 11.247A13.152 13.152 0 0 0 4 14.556C4 18.728 7.582 21 12 21s8-2.272 8-6.444a11.702 11.702 0 0 0-.493-3.309",
      key: "u7s9ue"
    }
  ],
  ["path", { d: "M8 14v.5", key: "1nzgdb" }],
  [
    "path",
    {
      d: "M8.5 8.5c-.384 1.05-1.083 2.028-2.344 2.5-1.931.722-3.576-.297-3.656-1-.113-.994 1.177-6.53 4-7 1.923-.321 3.651.845 3.651 2.235A7.497 7.497 0 0 1 14 5.277c0-1.39 1.844-2.598 3.767-2.277 2.823.47 4.113 6.006 4 7-.08.703-1.725 1.722-3.656 1-1.261-.472-1.855-1.45-2.239-2.5",
      key: "v8hric"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DollarSign = createLucideIcon("DollarSign", [
  ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }],
  ["path", { d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6", key: "1b0p4s" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Donut = createLucideIcon("Donut", [
  [
    "path",
    {
      d: "M20.5 10a2.5 2.5 0 0 1-2.4-3H18a2.95 2.95 0 0 1-2.6-4.4 10 10 0 1 0 6.3 7.1c-.3.2-.8.3-1.2.3",
      key: "19sr3x"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DoorClosed = createLucideIcon("DoorClosed", [
  ["path", { d: "M18 20V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v14", key: "36qu9e" }],
  ["path", { d: "M2 20h20", key: "owomy5" }],
  ["path", { d: "M14 12v.01", key: "xfcn54" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DoorOpen = createLucideIcon("DoorOpen", [
  ["path", { d: "M13 4h3a2 2 0 0 1 2 2v14", key: "hrm0s9" }],
  ["path", { d: "M2 20h3", key: "1gaodv" }],
  ["path", { d: "M13 20h9", key: "s90cdi" }],
  ["path", { d: "M10 12v.01", key: "vx6srw" }],
  [
    "path",
    {
      d: "M13 4.562v16.157a1 1 0 0 1-1.242.97L5 20V5.562a2 2 0 0 1 1.515-1.94l4-1A2 2 0 0 1 13 4.561Z",
      key: "199qr4"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dot = createLucideIcon("Dot", [
  ["circle", { cx: "12.1", cy: "12.1", r: "1", key: "18d7e5" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Download = createLucideIcon("Download", [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "7 10 12 15 17 10", key: "2ggqvy" }],
  ["line", { x1: "12", x2: "12", y1: "15", y2: "3", key: "1vk2je" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DraftingCompass = createLucideIcon("DraftingCompass", [
  ["path", { d: "m12.99 6.74 1.93 3.44", key: "iwagvd" }],
  ["path", { d: "M19.136 12a10 10 0 0 1-14.271 0", key: "ppmlo4" }],
  ["path", { d: "m21 21-2.16-3.84", key: "vylbct" }],
  ["path", { d: "m3 21 8.02-14.26", key: "1ssaw4" }],
  ["circle", { cx: "12", cy: "5", r: "2", key: "f1ur92" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Drama = createLucideIcon("Drama", [
  ["path", { d: "M10 11h.01", key: "d2at3l" }],
  ["path", { d: "M14 6h.01", key: "k028ub" }],
  ["path", { d: "M18 6h.01", key: "1v4wsw" }],
  ["path", { d: "M6.5 13.1h.01", key: "1748ia" }],
  ["path", { d: "M22 5c0 9-4 12-6 12s-6-3-6-12c0-2 2-3 6-3s6 1 6 3", key: "172yzv" }],
  ["path", { d: "M17.4 9.9c-.8.8-2 .8-2.8 0", key: "1obv0w" }],
  [
    "path",
    {
      d: "M10.1 7.1C9 7.2 7.7 7.7 6 8.6c-3.5 2-4.7 3.9-3.7 5.6 4.5 7.8 9.5 8.4 11.2 7.4.9-.5 1.9-2.1 1.9-4.7",
      key: "rqjl8i"
    }
  ],
  ["path", { d: "M9.1 16.5c.3-1.1 1.4-1.7 2.4-1.4", key: "1mr6wy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dribbble = createLucideIcon("Dribbble", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M19.13 5.09C15.22 9.14 10 10.44 2.25 10.94", key: "hpej1" }],
  ["path", { d: "M21.75 12.84c-6.62-1.41-12.14 1-16.38 6.32", key: "1tr44o" }],
  ["path", { d: "M8.56 2.75c4.37 6 6 9.42 8 17.72", key: "kbh691" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Drill = createLucideIcon("Drill", [
  [
    "path",
    { d: "M14 9c0 .6-.4 1-1 1H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9c.6 0 1 .4 1 1Z", key: "b6nnkj" }
  ],
  ["path", { d: "M18 6h4", key: "66u95g" }],
  ["path", { d: "M14 4h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3", key: "105ega" }],
  ["path", { d: "m5 10-2 8", key: "xt2lic" }],
  ["path", { d: "M12 10v3c0 .6-.4 1-1 1H8", key: "mwpjnk" }],
  ["path", { d: "m7 18 2-8", key: "1bzku2" }],
  [
    "path",
    { d: "M5 22c-1.7 0-3-1.3-3-3 0-.6.4-1 1-1h7c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1Z", key: "117add" }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Droplet = createLucideIcon("Droplet", [
  [
    "path",
    {
      d: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z",
      key: "c7niix"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Droplets = createLucideIcon("Droplets", [
  [
    "path",
    {
      d: "M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z",
      key: "1ptgy4"
    }
  ],
  [
    "path",
    {
      d: "M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97",
      key: "1sl1rz"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Drum = createLucideIcon("Drum", [
  ["path", { d: "m2 2 8 8", key: "1v6059" }],
  ["path", { d: "m22 2-8 8", key: "173r8a" }],
  ["ellipse", { cx: "12", cy: "9", rx: "10", ry: "5", key: "liohsx" }],
  ["path", { d: "M7 13.4v7.9", key: "1yi6u9" }],
  ["path", { d: "M12 14v8", key: "1tn2tj" }],
  ["path", { d: "M17 13.4v7.9", key: "eqz2v3" }],
  ["path", { d: "M2 9v8a10 5 0 0 0 20 0V9", key: "1750ul" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Drumstick = createLucideIcon("Drumstick", [
  [
    "path",
    { d: "M15.4 15.63a7.875 6 135 1 1 6.23-6.23 4.5 3.43 135 0 0-6.23 6.23", key: "1dtqwm" }
  ],
  [
    "path",
    {
      d: "m8.29 12.71-2.6 2.6a2.5 2.5 0 1 0-1.65 4.65A2.5 2.5 0 1 0 8.7 18.3l2.59-2.59",
      key: "1oq1fw"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dumbbell = createLucideIcon("Dumbbell", [
  ["path", { d: "M14.4 14.4 9.6 9.6", key: "ic80wn" }],
  [
    "path",
    {
      d: "M18.657 21.485a2 2 0 1 1-2.829-2.828l-1.767 1.768a2 2 0 1 1-2.829-2.829l6.364-6.364a2 2 0 1 1 2.829 2.829l-1.768 1.767a2 2 0 1 1 2.828 2.829z",
      key: "nnl7wr"
    }
  ],
  ["path", { d: "m21.5 21.5-1.4-1.4", key: "1f1ice" }],
  ["path", { d: "M3.9 3.9 2.5 2.5", key: "1evmna" }],
  [
    "path",
    {
      d: "M6.404 12.768a2 2 0 1 1-2.829-2.829l1.768-1.767a2 2 0 1 1-2.828-2.829l2.828-2.828a2 2 0 1 1 2.829 2.828l1.767-1.768a2 2 0 1 1 2.829 2.829z",
      key: "yhosts"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EarOff = createLucideIcon("EarOff", [
  ["path", { d: "M6 18.5a3.5 3.5 0 1 0 7 0c0-1.57.92-2.52 2.04-3.46", key: "1qngmn" }],
  ["path", { d: "M6 8.5c0-.75.13-1.47.36-2.14", key: "b06bma" }],
  ["path", { d: "M8.8 3.15A6.5 6.5 0 0 1 19 8.5c0 1.63-.44 2.81-1.09 3.76", key: "g10hsz" }],
  ["path", { d: "M12.5 6A2.5 2.5 0 0 1 15 8.5M10 13a2 2 0 0 0 1.82-1.18", key: "ygzou7" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ear = createLucideIcon("Ear", [
  ["path", { d: "M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 6-6 10a3.5 3.5 0 1 1-7 0", key: "1dfaln" }],
  ["path", { d: "M15 8.5a2.5 2.5 0 0 0-5 0v1a2 2 0 1 1 0 4", key: "1qnva7" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EarthLock = createLucideIcon("EarthLock", [
  ["path", { d: "M7 3.34V5a3 3 0 0 0 3 3", key: "w732o8" }],
  ["path", { d: "M11 21.95V18a2 2 0 0 0-2-2 2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05", key: "f02343" }],
  ["path", { d: "M21.54 15H17a2 2 0 0 0-2 2v4.54", key: "1djwo0" }],
  ["path", { d: "M12 2a10 10 0 1 0 9.54 13", key: "zjsr6q" }],
  ["path", { d: "M20 6V4a2 2 0 1 0-4 0v2", key: "1of5e8" }],
  ["rect", { width: "8", height: "5", x: "14", y: "6", rx: "1", key: "1fmf51" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Earth = createLucideIcon("Earth", [
  ["path", { d: "M21.54 15H17a2 2 0 0 0-2 2v4.54", key: "1djwo0" }],
  [
    "path",
    {
      d: "M7 3.34V5a3 3 0 0 0 3 3a2 2 0 0 1 2 2c0 1.1.9 2 2 2a2 2 0 0 0 2-2c0-1.1.9-2 2-2h3.17",
      key: "1tzkfa"
    }
  ],
  ["path", { d: "M11 21.95V18a2 2 0 0 0-2-2a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05", key: "14pb5j" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eclipse = createLucideIcon("Eclipse", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a7 7 0 1 0 10 10", key: "1yuj32" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EggFried = createLucideIcon("EggFried", [
  ["circle", { cx: "11.5", cy: "12.5", r: "3.5", key: "1cl1mi" }],
  [
    "path",
    {
      d: "M3 8c0-3.5 2.5-6 6.5-6 5 0 4.83 3 7.5 5s5 2 5 6c0 4.5-2.5 6.5-7 6.5-2.5 0-2.5 2.5-6 2.5s-7-2-7-5.5c0-3 1.5-3 1.5-5C3.5 10 3 9 3 8Z",
      key: "165ef9"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EggOff = createLucideIcon("EggOff", [
  [
    "path",
    {
      d: "M6.399 6.399C5.362 8.157 4.65 10.189 4.5 12c-.37 4.43 1.27 9.95 7.5 10 3.256-.026 5.259-1.547 6.375-3.625",
      key: "6et380"
    }
  ],
  [
    "path",
    {
      d: "M19.532 13.875A14.07 14.07 0 0 0 19.5 12c-.36-4.34-3.95-9.96-7.5-10-1.04.012-2.082.502-3.046 1.297",
      key: "gcdc3f"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Egg = createLucideIcon("Egg", [
  [
    "path",
    {
      d: "M12 22c6.23-.05 7.87-5.57 7.5-10-.36-4.34-3.95-9.96-7.5-10-3.55.04-7.14 5.66-7.5 10-.37 4.43 1.27 9.95 7.5 10z",
      key: "1c39pg"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EllipsisVertical = createLucideIcon("EllipsisVertical", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ellipsis = createLucideIcon("Ellipsis", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EqualNot = createLucideIcon("EqualNot", [
  ["line", { x1: "5", x2: "19", y1: "9", y2: "9", key: "1nwqeh" }],
  ["line", { x1: "5", x2: "19", y1: "15", y2: "15", key: "g8yjpy" }],
  ["line", { x1: "19", x2: "5", y1: "5", y2: "19", key: "1x9vlm" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Equal = createLucideIcon("Equal", [
  ["line", { x1: "5", x2: "19", y1: "9", y2: "9", key: "1nwqeh" }],
  ["line", { x1: "5", x2: "19", y1: "15", y2: "15", key: "g8yjpy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eraser = createLucideIcon("Eraser", [
  [
    "path",
    {
      d: "m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21",
      key: "182aya"
    }
  ],
  ["path", { d: "M22 21H7", key: "t4ddhn" }],
  ["path", { d: "m5 11 9 9", key: "1mo9qw" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EthernetPort = createLucideIcon("EthernetPort", [
  [
    "path",
    {
      d: "m15 20 3-3h2a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h2l3 3z",
      key: "rbahqx"
    }
  ],
  ["path", { d: "M6 8v1", key: "1636ez" }],
  ["path", { d: "M10 8v1", key: "1talb4" }],
  ["path", { d: "M14 8v1", key: "1rsfgr" }],
  ["path", { d: "M18 8v1", key: "gnkwox" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Euro = createLucideIcon("Euro", [
  ["path", { d: "M4 10h12", key: "1y6xl8" }],
  ["path", { d: "M4 14h9", key: "1loblj" }],
  [
    "path",
    {
      d: "M19 6a7.7 7.7 0 0 0-5.2-2A7.9 7.9 0 0 0 6 12c0 4.4 3.5 8 7.8 8 2 0 3.8-.8 5.2-2",
      key: "1j6lzo"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Expand = createLucideIcon("Expand", [
  ["path", { d: "m21 21-6-6m6 6v-4.8m0 4.8h-4.8", key: "1c15vz" }],
  ["path", { d: "M3 16.2V21m0 0h4.8M3 21l6-6", key: "1fsnz2" }],
  ["path", { d: "M21 7.8V3m0 0h-4.8M21 3l-6 6", key: "hawz9i" }],
  ["path", { d: "M3 7.8V3m0 0h4.8M3 3l6 6", key: "u9ee12" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ExternalLink = createLucideIcon("ExternalLink", [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "M10 14 21 3", key: "gplh6r" }],
  ["path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6", key: "a6xqqp" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EyeClosed = createLucideIcon("EyeClosed", [
  ["path", { d: "m15 18-.722-3.25", key: "1j64jw" }],
  ["path", { d: "M2 8a10.645 10.645 0 0 0 20 0", key: "1e7gxb" }],
  ["path", { d: "m20 15-1.726-2.05", key: "1cnuld" }],
  ["path", { d: "m4 15 1.726-2.05", key: "1dsqqd" }],
  ["path", { d: "m9 18 .722-3.25", key: "ypw2yx" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const EyeOff = createLucideIcon("EyeOff", [
  [
    "path",
    {
      d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
      key: "ct8e1f"
    }
  ],
  ["path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242", key: "151rxh" }],
  [
    "path",
    {
      d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
      key: "13bj9a"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Eye = createLucideIcon("Eye", [
  [
    "path",
    {
      d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
      key: "1nclc0"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Facebook = createLucideIcon("Facebook", [
  [
    "path",
    { d: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z", key: "1jg4f8" }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Factory = createLucideIcon("Factory", [
  [
    "path",
    {
      d: "M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "159hny"
    }
  ],
  ["path", { d: "M17 18h1", key: "uldtlt" }],
  ["path", { d: "M12 18h1", key: "s9uhes" }],
  ["path", { d: "M7 18h1", key: "1neino" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fan = createLucideIcon("Fan", [
  [
    "path",
    {
      d: "M10.827 16.379a6.082 6.082 0 0 1-8.618-7.002l5.412 1.45a6.082 6.082 0 0 1 7.002-8.618l-1.45 5.412a6.082 6.082 0 0 1 8.618 7.002l-5.412-1.45a6.082 6.082 0 0 1-7.002 8.618l1.45-5.412Z",
      key: "484a7f"
    }
  ],
  ["path", { d: "M12 12v.01", key: "u5ubse" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FastForward = createLucideIcon("FastForward", [
  ["polygon", { points: "13 19 22 12 13 5 13 19", key: "587y9g" }],
  ["polygon", { points: "2 19 11 12 2 5 2 19", key: "3pweh0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Feather = createLucideIcon("Feather", [
  [
    "path",
    {
      d: "M12.67 19a2 2 0 0 0 1.416-.588l6.154-6.172a6 6 0 0 0-8.49-8.49L5.586 9.914A2 2 0 0 0 5 11.328V18a1 1 0 0 0 1 1z",
      key: "18jl4k"
    }
  ],
  ["path", { d: "M16 8 2 22", key: "vp34q" }],
  ["path", { d: "M17.5 15H9", key: "1oz8nu" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fence = createLucideIcon("Fence", [
  ["path", { d: "M4 3 2 5v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "1n2rgs" }],
  ["path", { d: "M6 8h4", key: "utf9t1" }],
  ["path", { d: "M6 18h4", key: "12yh4b" }],
  ["path", { d: "m12 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "3ha7mj" }],
  ["path", { d: "M14 8h4", key: "1r8wg2" }],
  ["path", { d: "M14 18h4", key: "1t3kbu" }],
  ["path", { d: "m20 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "dfd4e2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FerrisWheel = createLucideIcon("FerrisWheel", [
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m6.8 15-3.5 2", key: "hjy98k" }],
  ["path", { d: "m20.7 7-3.5 2", key: "f08gto" }],
  ["path", { d: "M6.8 9 3.3 7", key: "1aevh4" }],
  ["path", { d: "m20.7 17-3.5-2", key: "1liqo3" }],
  ["path", { d: "m9 22 3-8 3 8", key: "wees03" }],
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M18 18.7a9 9 0 1 0-12 0", key: "dhzg4g" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Figma = createLucideIcon("Figma", [
  ["path", { d: "M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z", key: "1340ok" }],
  ["path", { d: "M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z", key: "1hz3m3" }],
  ["path", { d: "M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z", key: "1oz8n2" }],
  ["path", { d: "M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z", key: "1ff65i" }],
  ["path", { d: "M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z", key: "pdip6e" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileArchive = createLucideIcon("FileArchive", [
  ["path", { d: "M10 12v-1", key: "v7bkov" }],
  ["path", { d: "M10 18v-2", key: "1cjy8d" }],
  ["path", { d: "M10 7V6", key: "dljcrl" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M15.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 .274 1.01", key: "gkbcor" }
  ],
  ["circle", { cx: "10", cy: "20", r: "2", key: "1xzdoj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileAudio2 = createLucideIcon("FileAudio2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2", key: "17k7jt" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "3", cy: "17", r: "1", key: "vo6nti" }],
  ["path", { d: "M2 17v-3a4 4 0 0 1 8 0v3", key: "1ggdre" }],
  ["circle", { cx: "9", cy: "17", r: "1", key: "bc1fq4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileAudio = createLucideIcon("FileAudio", [
  ["path", { d: "M17.5 22h.5a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "rslqgf" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M2 19a2 2 0 1 1 4 0v1a2 2 0 1 1-4 0v-4a6 6 0 0 1 12 0v4a2 2 0 1 1-4 0v-1a2 2 0 1 1 4 0",
      key: "9f7x3i"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileAxis3d = createLucideIcon("FileAxis3d", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m8 18 4-4", key: "12zab0" }],
  ["path", { d: "M8 10v8h8", key: "tlaukw" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileBadge2 = createLucideIcon("FileBadge2", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m14 12.5 1 5.5-3-1-3 1 1-5.5", key: "14xlky" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileBadge = createLucideIcon("FileBadge", [
  ["path", { d: "M12 22h6a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "12ixgl" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M5 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z", key: "u0c8gj" }],
  ["path", { d: "M7 16.5 8 22l-3-1-3 1 1-5.5", key: "5gm2nr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileBox = createLucideIcon("FileBox", [
  ["path", { d: "M14.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "16lz6z" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M3 13.1a2 2 0 0 0-1 1.76v3.24a2 2 0 0 0 .97 1.78L6 21.7a2 2 0 0 0 2.03.01L11 19.9a2 2 0 0 0 1-1.76V14.9a2 2 0 0 0-.97-1.78L8 11.3a2 2 0 0 0-2.03-.01Z",
      key: "99pj1s"
    }
  ],
  ["path", { d: "M7 17v5", key: "1yj1jh" }],
  ["path", { d: "M11.7 14.2 7 17l-4.7-2.8", key: "1yk8tc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileChartColumnIncreasing = createLucideIcon("FileChartColumnIncreasing", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 18v-2", key: "qcmpov" }],
  ["path", { d: "M12 18v-4", key: "q1q25u" }],
  ["path", { d: "M16 18v-6", key: "15y0np" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileChartColumn = createLucideIcon("FileChartColumn", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 18v-1", key: "zg0ygc" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }],
  ["path", { d: "M16 18v-3", key: "j5jt4h" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileChartLine = createLucideIcon("FileChartLine", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m16 13-3.5 3.5-2-2L8 17", key: "zz7yod" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileChartPie = createLucideIcon("FileChartPie", [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3.5", key: "13ddob" }],
  ["path", { d: "M4.017 11.512a6 6 0 1 0 8.466 8.475", key: "s6vs5t" }],
  [
    "path",
    {
      d: "M9 16a1 1 0 0 1-1-1v-4c0-.552.45-1.008.995-.917a6 6 0 0 1 4.922 4.922c.091.544-.365.995-.917.995z",
      key: "1dl6s6"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileCheck2 = createLucideIcon("FileCheck2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m3 15 2 2 4-4", key: "1lhrkk" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileCheck = createLucideIcon("FileCheck", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m9 15 2 2 4-4", key: "1grp1n" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileClock = createLucideIcon("FileClock", [
  ["path", { d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "37hlfg" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "8", cy: "16", r: "6", key: "10v15b" }],
  ["path", { d: "M9.5 17.5 8 16.25V14", key: "1o80t2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileCode2 = createLucideIcon("FileCode2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m5 12-3 3 3 3", key: "oke12k" }],
  ["path", { d: "m9 18 3-3-3-3", key: "112psh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileCode = createLucideIcon("FileCode", [
  ["path", { d: "M10 12.5 8 15l2 2.5", key: "1tg20x" }],
  ["path", { d: "m14 12.5 2 2.5-2 2.5", key: "yinavb" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z", key: "1mlx9k" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileCog = createLucideIcon("FileCog", [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m3.2 12.9-.9-.4", key: "1i3dj5" }],
  ["path", { d: "m3.2 15.1-.9.4", key: "1fvgj0" }],
  [
    "path",
    {
      d: "M4.677 21.5a2 2 0 0 0 1.313.5H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2.5",
      key: "1yo3oz"
    }
  ],
  ["path", { d: "m4.9 11.2-.4-.9", key: "otmhb9" }],
  ["path", { d: "m4.9 16.8-.4.9", key: "1b8z07" }],
  ["path", { d: "m7.5 10.3-.4.9", key: "11k65u" }],
  ["path", { d: "m7.5 17.7-.4-.9", key: "431x55" }],
  ["path", { d: "m9.7 12.5-.9.4", key: "87sjan" }],
  ["path", { d: "m9.7 15.5-.9-.4", key: "khqm91" }],
  ["circle", { cx: "6", cy: "14", r: "3", key: "a1xfv6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileDiff = createLucideIcon("FileDiff", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileDigit = createLucideIcon("FileDigit", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["rect", { width: "4", height: "6", x: "2", y: "12", rx: "2", key: "jm304g" }],
  ["path", { d: "M10 12h2v6", key: "12zw74" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileDown = createLucideIcon("FileDown", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }],
  ["path", { d: "m9 15 3 3 3-3", key: "1npd3o" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileHeart = createLucideIcon("FileHeart", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2", key: "17k7jt" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M10.29 10.7a2.43 2.43 0 0 0-2.66-.52c-.29.12-.56.3-.78.53l-.35.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L6.5 18l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z",
      key: "1c1fso"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileImage = createLucideIcon("FileImage", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "10", cy: "12", r: "2", key: "737tya" }],
  ["path", { d: "m20 17-1.296-1.296a2.41 2.41 0 0 0-3.408 0L9 22", key: "wt3hpn" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileInput = createLucideIcon("FileInput", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M2 15h10", key: "jfw4w8" }],
  ["path", { d: "m9 18 3-3-3-3", key: "112psh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileJson2 = createLucideIcon("FileJson2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M4 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1", key: "fq0c9t" }
  ],
  [
    "path",
    { d: "M8 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1", key: "4gibmv" }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileJson = createLucideIcon("FileJson", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M10 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1", key: "1oajmo" }
  ],
  [
    "path",
    { d: "M14 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1", key: "mpwhp6" }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileKey2 = createLucideIcon("FileKey2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v6", key: "rc0qvx" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "4", cy: "16", r: "2", key: "1ehqvc" }],
  ["path", { d: "m10 10-4.5 4.5", key: "7fwrp6" }],
  ["path", { d: "m9 11 1 1", key: "wa6s5q" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileKey = createLucideIcon("FileKey", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["circle", { cx: "10", cy: "16", r: "2", key: "4ckbqe" }],
  ["path", { d: "m16 10-4.5 4.5", key: "7p3ebg" }],
  ["path", { d: "m15 11 1 1", key: "1bsyx3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileLock2 = createLucideIcon("FileLock2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v1", key: "jmtmu2" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["rect", { width: "8", height: "5", x: "2", y: "13", rx: "1", key: "10y5wo" }],
  ["path", { d: "M8 13v-2a2 2 0 1 0-4 0v2", key: "1pdxzg" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileLock = createLucideIcon("FileLock", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["rect", { width: "8", height: "6", x: "8", y: "12", rx: "1", key: "3yr8at" }],
  ["path", { d: "M10 12v-2a2 2 0 1 1 4 0v2", key: "j4i8d" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileMinus2 = createLucideIcon("FileMinus2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M3 15h6", key: "4e2qda" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileMinus = createLucideIcon("FileMinus", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileMusic = createLucideIcon("FileMusic", [
  ["circle", { cx: "14", cy: "16", r: "2", key: "1bzzi3" }],
  ["circle", { cx: "6", cy: "18", r: "2", key: "1fncim" }],
  ["path", { d: "M4 12.4V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2h-7.5", key: "skc018" }],
  ["path", { d: "M8 18v-7.7L16 9v7", key: "1oie6o" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileOutput = createLucideIcon("FileOutput", [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M4 7V4a2 2 0 0 1 2-2 2 2 0 0 0-2 2", key: "1vk7w2" }],
  ["path", { d: "M4.063 20.999a2 2 0 0 0 2 1L18 22a2 2 0 0 0 2-2V7l-5-5H6", key: "1jink5" }],
  ["path", { d: "m5 11-3 3", key: "1dgrs4" }],
  ["path", { d: "m5 17-3-3h10", key: "1mvvaf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FilePenLine = createLucideIcon("FilePenLine", [
  [
    "path",
    {
      d: "m18 5-2.414-2.414A2 2 0 0 0 14.172 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2",
      key: "142zxg"
    }
  ],
  [
    "path",
    {
      d: "M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "2t3380"
    }
  ],
  ["path", { d: "M8 18h1", key: "13wk12" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FilePen = createLucideIcon("FilePen", [
  ["path", { d: "M12.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v9.5", key: "1couwa" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M13.378 15.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1y4qbx"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FilePlus2 = createLucideIcon("FilePlus2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M3 15h6", key: "4e2qda" }],
  ["path", { d: "M6 12v6", key: "1u72j0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FilePlus = createLucideIcon("FilePlus", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileQuestion = createLucideIcon("FileQuestion", [
  ["path", { d: "M12 17h.01", key: "p32p05" }],
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z", key: "1mlx9k" }],
  ["path", { d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3", key: "mhlwft" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileScan = createLucideIcon("FileScan", [
  ["path", { d: "M20 10V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4", key: "1rdf37" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M16 14a2 2 0 0 0-2 2", key: "ceaadl" }],
  ["path", { d: "M20 14a2 2 0 0 1 2 2", key: "1ny6zw" }],
  ["path", { d: "M20 22a2 2 0 0 0 2-2", key: "1l9q4k" }],
  ["path", { d: "M16 22a2 2 0 0 1-2-2", key: "1wqh5n" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileSearch2 = createLucideIcon("FileSearch2", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "11.5", cy: "14.5", r: "2.5", key: "1bq0ko" }],
  ["path", { d: "M13.3 16.3 15 18", key: "2quom7" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileSearch = createLucideIcon("FileSearch", [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M4.268 21a2 2 0 0 0 1.727 1H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "ms7g94" }
  ],
  ["path", { d: "m9 18-1.5-1.5", key: "1j6qii" }],
  ["circle", { cx: "5", cy: "14", r: "3", key: "ufru5t" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileSliders = createLucideIcon("FileSliders", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M10 11v2", key: "1s651w" }],
  ["path", { d: "M8 17h8", key: "wh5c61" }],
  ["path", { d: "M14 16v2", key: "12fp5e" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileSpreadsheet = createLucideIcon("FileSpreadsheet", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 13h2", key: "yr2amv" }],
  ["path", { d: "M14 13h2", key: "un5t4a" }],
  ["path", { d: "M8 17h2", key: "2yhykz" }],
  ["path", { d: "M14 17h2", key: "10kma7" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileStack = createLucideIcon("FileStack", [
  ["path", { d: "M21 7h-3a2 2 0 0 1-2-2V2", key: "9rb54x" }],
  [
    "path",
    {
      d: "M21 6v6.5c0 .8-.7 1.5-1.5 1.5h-7c-.8 0-1.5-.7-1.5-1.5v-9c0-.8.7-1.5 1.5-1.5H17Z",
      key: "1059l0"
    }
  ],
  ["path", { d: "M7 8v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H15", key: "16874u" }],
  ["path", { d: "M3 12v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H11", key: "k2ox98" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileSymlink = createLucideIcon("FileSymlink", [
  ["path", { d: "m10 18 3-3-3-3", key: "18f6ys" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M4 11V4a2 2 0 0 1 2-2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7",
      key: "50q2rw"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileTerminal = createLucideIcon("FileTerminal", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m8 16 2-2-2-2", key: "10vzyd" }],
  ["path", { d: "M12 18h4", key: "1wd2n7" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileText = createLucideIcon("FileText", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M10 9H8", key: "b1mrlr" }],
  ["path", { d: "M16 13H8", key: "t4e002" }],
  ["path", { d: "M16 17H8", key: "z1uh3a" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileType2 = createLucideIcon("FileType2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M2 13v-1h6v1", key: "1dh9dg" }],
  ["path", { d: "M5 12v6", key: "150t9c" }],
  ["path", { d: "M4 18h2", key: "1xrofg" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileType = createLucideIcon("FileType", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M9 13v-1h6v1", key: "1bb014" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "M11 18h2", key: "12mj7e" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileUp = createLucideIcon("FileUp", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "m15 15-3-3-3 3", key: "15xj92" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileUser = createLucideIcon("FileUser", [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M15 18a3 3 0 1 0-6 0", key: "16awa0" }],
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z", key: "1mlx9k" }],
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileVideo2 = createLucideIcon("FileVideo2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["rect", { width: "8", height: "6", x: "2", y: "12", rx: "1", key: "1a6c1e" }],
  ["path", { d: "m10 15.5 4 2.5v-6l-4 2.5", key: "t7cp39" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileVideo = createLucideIcon("FileVideo", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m10 11 5 3-5 3v-6Z", key: "7ntvm4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileVolume2 = createLucideIcon("FileVolume2", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M11.5 13.5a2.5 2.5 0 0 1 0 3", key: "1fccat" }],
  ["path", { d: "M15 12a5 5 0 0 1 0 6", key: "ps46cm" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileVolume = createLucideIcon("FileVolume", [
  ["path", { d: "M11 11a5 5 0 0 1 0 6", key: "193qb2" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M4 6.765V4a2 2 0 0 1 2-2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-.93-.23", key: "ifyjnl" }
  ],
  [
    "path",
    {
      d: "M7 10.51a.5.5 0 0 0-.826-.38l-1.893 1.628A1 1 0 0 1 3.63 12H2.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h1.129a1 1 0 0 1 .652.242l1.893 1.63a.5.5 0 0 0 .826-.38z",
      key: "mk8rxu"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileWarning = createLucideIcon("FileWarning", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileX2 = createLucideIcon("FileX2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m8 12.5-5 5", key: "b853mi" }],
  ["path", { d: "m3 12.5 5 5", key: "1qls4r" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FileX = createLucideIcon("FileX", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m14.5 12.5-5 5", key: "b62r18" }],
  ["path", { d: "m9.5 12.5 5 5", key: "1rk7el" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const File = createLucideIcon("File", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Files = createLucideIcon("Files", [
  ["path", { d: "M20 7h-3a2 2 0 0 1-2-2V2", key: "x099mo" }],
  ["path", { d: "M9 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h7l4 4v10a2 2 0 0 1-2 2Z", key: "18t6ie" }],
  ["path", { d: "M3 7.6v12.8A1.6 1.6 0 0 0 4.6 22h9.8", key: "1nja0z" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Film = createLucideIcon("Film", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 3v18", key: "bbkbws" }],
  ["path", { d: "M3 7.5h4", key: "zfgn84" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M3 16.5h4", key: "1230mu" }],
  ["path", { d: "M17 3v18", key: "in4fa5" }],
  ["path", { d: "M17 7.5h4", key: "myr1c1" }],
  ["path", { d: "M17 16.5h4", key: "go4c1d" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FilterX = createLucideIcon("FilterX", [
  ["path", { d: "M13.013 3H2l8 9.46V19l4 2v-8.54l.9-1.055", key: "1fi1da" }],
  ["path", { d: "m22 3-5 5", key: "12jva0" }],
  ["path", { d: "m17 3 5 5", key: "k36vhe" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Filter = createLucideIcon("Filter", [
  ["polygon", { points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3", key: "1yg77f" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fingerprint = createLucideIcon("Fingerprint", [
  ["path", { d: "M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4", key: "1nerag" }],
  ["path", { d: "M14 13.12c0 2.38 0 6.38-1 8.88", key: "o46ks0" }],
  ["path", { d: "M17.29 21.02c.12-.6.43-2.3.5-3.02", key: "ptglia" }],
  ["path", { d: "M2 12a10 10 0 0 1 18-6", key: "ydlgp0" }],
  ["path", { d: "M2 16h.01", key: "1gqxmh" }],
  ["path", { d: "M21.8 16c.2-2 .131-5.354 0-6", key: "drycrb" }],
  ["path", { d: "M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2", key: "1tidbn" }],
  ["path", { d: "M8.65 22c.21-.66.45-1.32.57-2", key: "13wd9y" }],
  ["path", { d: "M9 6.8a6 6 0 0 1 9 5.2v2", key: "1fr1j5" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FireExtinguisher = createLucideIcon("FireExtinguisher", [
  ["path", { d: "M15 6.5V3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3.5", key: "sqyvz" }],
  ["path", { d: "M9 18h8", key: "i7pszb" }],
  ["path", { d: "M18 3h-3", key: "7idoqj" }],
  ["path", { d: "M11 3a6 6 0 0 0-6 6v11", key: "1v5je3" }],
  ["path", { d: "M5 13h4", key: "svpcxo" }],
  ["path", { d: "M17 10a4 4 0 0 0-8 0v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2Z", key: "vsjego" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FishOff = createLucideIcon("FishOff", [
  [
    "path",
    {
      d: "M18 12.47v.03m0-.5v.47m-.475 5.056A6.744 6.744 0 0 1 15 18c-3.56 0-7.56-2.53-8.5-6 .348-1.28 1.114-2.433 2.121-3.38m3.444-2.088A8.802 8.802 0 0 1 15 6c3.56 0 6.06 2.54 7 6-.309 1.14-.786 2.177-1.413 3.058",
      key: "1j1hse"
    }
  ],
  [
    "path",
    {
      d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33m7.48-4.372A9.77 9.77 0 0 1 16 6.07m0 11.86a9.77 9.77 0 0 1-1.728-3.618",
      key: "1q46z8"
    }
  ],
  [
    "path",
    {
      d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98M8.53 3h5.27a2 2 0 0 1 1.98 1.67l.23 1.4M2 2l20 20",
      key: "1407gh"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FishSymbol = createLucideIcon("FishSymbol", [
  ["path", { d: "M2 16s9-15 20-4C11 23 2 8 2 8", key: "h4oh4o" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fish = createLucideIcon("Fish", [
  [
    "path",
    {
      d: "M6.5 12c.94-3.46 4.94-6 8.5-6 3.56 0 6.06 2.54 7 6-.94 3.47-3.44 6-7 6s-7.56-2.53-8.5-6Z",
      key: "15baut"
    }
  ],
  ["path", { d: "M18 12v.5", key: "18hhni" }],
  ["path", { d: "M16 17.93a9.77 9.77 0 0 1 0-11.86", key: "16dt7o" }],
  [
    "path",
    {
      d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33",
      key: "l9di03"
    }
  ],
  [
    "path",
    { d: "M10.46 7.26C10.2 5.88 9.17 4.24 8 3h5.8a2 2 0 0 1 1.98 1.67l.23 1.4", key: "1kjonw" }
  ],
  [
    "path",
    { d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98", key: "1zlm23" }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FlagOff = createLucideIcon("FlagOff", [
  ["path", { d: "M8 2c3 0 5 2 8 2s4-1 4-1v11", key: "9rwyz9" }],
  ["path", { d: "M4 22V4", key: "1plyxx" }],
  ["path", { d: "M4 15s1-1 4-1 5 2 8 2", key: "1myooe" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FlagTriangleLeft = createLucideIcon("FlagTriangleLeft", [
  ["path", { d: "M17 22V2L7 7l10 5", key: "1rmf0r" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FlagTriangleRight = createLucideIcon("FlagTriangleRight", [
  ["path", { d: "M7 22V2l10 5-10 5", key: "17n18y" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Flag = createLucideIcon("Flag", [
  ["path", { d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z", key: "i9b6wo" }],
  ["line", { x1: "4", x2: "4", y1: "22", y2: "15", key: "1cm3nv" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FlameKindling = createLucideIcon("FlameKindling", [
  [
    "path",
    {
      d: "M12 2c1 3 2.5 3.5 3.5 4.5A5 5 0 0 1 17 10a5 5 0 1 1-10 0c0-.3 0-.6.1-.9a2 2 0 1 0 3.3-2C8 4.5 11 2 12 2Z",
      key: "1ir223"
    }
  ],
  ["path", { d: "m5 22 14-4", key: "1brv4h" }],
  ["path", { d: "m5 18 14 4", key: "lgyyje" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Flame = createLucideIcon("Flame", [
  [
    "path",
    {
      d: "M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z",
      key: "96xj49"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FlashlightOff = createLucideIcon("FlashlightOff", [
  ["path", { d: "M16 16v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4", key: "1r120k" }],
  ["path", { d: "M7 2h11v4c0 2-2 2-2 4v1", key: "dz1920" }],
  ["line", { x1: "11", x2: "18", y1: "6", y2: "6", key: "bi1vpe" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Flashlight = createLucideIcon("Flashlight", [
  [
    "path",
    {
      d: "M18 6c0 2-2 2-2 4v10a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4V2h12z",
      key: "1orkel"
    }
  ],
  ["line", { x1: "6", x2: "18", y1: "6", y2: "6", key: "1z11jq" }],
  ["line", { x1: "12", x2: "12", y1: "12", y2: "12", key: "1f4yc1" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FlaskConicalOff = createLucideIcon("FlaskConicalOff", [
  [
    "path",
    {
      d: "M10 10 4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-1.272-2.542",
      key: "59ek9y"
    }
  ],
  ["path", { d: "M10 2v2.343", key: "15t272" }],
  ["path", { d: "M14 2v6.343", key: "sxr80q" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }],
  ["path", { d: "M7 16h9", key: "t5njau" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FlaskConical = createLucideIcon("FlaskConical", [
  [
    "path",
    {
      d: "M10 2v7.527a2 2 0 0 1-.211.896L4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-5.069-10.127A2 2 0 0 1 14 9.527V2",
      key: "pzvekw"
    }
  ],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }],
  ["path", { d: "M7 16h10", key: "wp8him" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FlaskRound = createLucideIcon("FlaskRound", [
  ["path", { d: "M10 2v7.31", key: "5d1hyh" }],
  ["path", { d: "M14 9.3V1.99", key: "14k4l0" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }],
  ["path", { d: "M14 9.3a6.5 6.5 0 1 1-4 0", key: "1r8fvy" }],
  ["path", { d: "M5.52 16h12.96", key: "46hh1i" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FlipHorizontal2 = createLucideIcon("FlipHorizontal2", [
  ["path", { d: "m3 7 5 5-5 5V7", key: "couhi7" }],
  ["path", { d: "m21 7-5 5 5 5V7", key: "6ouia7" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 2v2", key: "tus03m" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FlipHorizontal = createLucideIcon("FlipHorizontal", [
  ["path", { d: "M8 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h3", key: "1i73f7" }],
  ["path", { d: "M16 3h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3", key: "saxlbk" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 2v2", key: "tus03m" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FlipVertical2 = createLucideIcon("FlipVertical2", [
  ["path", { d: "m17 3-5 5-5-5h10", key: "1ftt6x" }],
  ["path", { d: "m17 21-5-5-5 5h10", key: "1m0wmu" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FlipVertical = createLucideIcon("FlipVertical", [
  ["path", { d: "M21 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3", key: "14bfxa" }],
  ["path", { d: "M21 16v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3", key: "14rx03" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Flower2 = createLucideIcon("Flower2", [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 1 3 3m-3-3a3 3 0 1 0-3 3m3-3v1M9 8a3 3 0 1 0 3 3M9 8h1m5 0a3 3 0 1 1-3 3m3-3h-1m-2 3v-1",
      key: "3pnvol"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  ["path", { d: "M12 10v12", key: "6ubwww" }],
  ["path", { d: "M12 22c4.2 0 7-1.667 7-5-4.2 0-7 1.667-7 5Z", key: "9hd38g" }],
  ["path", { d: "M12 22c-4.2 0-7-1.667-7-5 4.2 0 7 1.667 7 5Z", key: "ufn41s" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Flower = createLucideIcon("Flower", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  [
    "path",
    {
      d: "M12 16.5A4.5 4.5 0 1 1 7.5 12 4.5 4.5 0 1 1 12 7.5a4.5 4.5 0 1 1 4.5 4.5 4.5 4.5 0 1 1-4.5 4.5",
      key: "14wa3c"
    }
  ],
  ["path", { d: "M12 7.5V9", key: "1oy5b0" }],
  ["path", { d: "M7.5 12H9", key: "eltsq1" }],
  ["path", { d: "M16.5 12H15", key: "vk5kw4" }],
  ["path", { d: "M12 16.5V15", key: "k7eayi" }],
  ["path", { d: "m8 8 1.88 1.88", key: "nxy4qf" }],
  ["path", { d: "M14.12 9.88 16 8", key: "1lst6k" }],
  ["path", { d: "m8 16 1.88-1.88", key: "h2eex1" }],
  ["path", { d: "M14.12 14.12 16 16", key: "uqkrx3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Focus = createLucideIcon("Focus", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FoldHorizontal = createLucideIcon("FoldHorizontal", [
  ["path", { d: "M2 12h6", key: "1wqiqv" }],
  ["path", { d: "M22 12h-6", key: "1eg9hc" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m19 9-3 3 3 3", key: "12ol22" }],
  ["path", { d: "m5 15 3-3-3-3", key: "1kdhjc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FoldVertical = createLucideIcon("FoldVertical", [
  ["path", { d: "M12 22v-6", key: "6o8u61" }],
  ["path", { d: "M12 8V2", key: "1wkif3" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }],
  ["path", { d: "m15 19-3-3-3 3", key: "e37ymu" }],
  ["path", { d: "m15 5-3 3-3-3", key: "19d6lf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderArchive = createLucideIcon("FolderArchive", [
  ["circle", { cx: "15", cy: "19", r: "2", key: "u2pros" }],
  [
    "path",
    {
      d: "M20.9 19.8A2 2 0 0 0 22 18V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h5.1",
      key: "1jj40k"
    }
  ],
  ["path", { d: "M15 11v-1", key: "cntcp" }],
  ["path", { d: "M15 17v-2", key: "1279jj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderCheck = createLucideIcon("FolderCheck", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "m9 13 2 2 4-4", key: "6343dt" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderClock = createLucideIcon("FolderClock", [
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }],
  [
    "path",
    {
      d: "M7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2",
      key: "1urifu"
    }
  ],
  ["path", { d: "M16 14v2l1 1", key: "xth2jh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderClosed = createLucideIcon("FolderClosed", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M2 10h20", key: "1ir3d8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderCode = createLucideIcon("FolderCode", [
  ["path", { d: "M10 10.5 8 13l2 2.5", key: "m4t9c1" }],
  ["path", { d: "m14 10.5 2 2.5-2 2.5", key: "14w2eb" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2z",
      key: "1u1bxd"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderCog = createLucideIcon("FolderCog", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  [
    "path",
    {
      d: "M10.3 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v3.3",
      key: "1k8050"
    }
  ],
  ["path", { d: "m21.7 19.4-.9-.3", key: "1qgwi9" }],
  ["path", { d: "m15.2 16.9-.9-.3", key: "1t7mvx" }],
  ["path", { d: "m16.6 21.7.3-.9", key: "1j67ps" }],
  ["path", { d: "m19.1 15.2.3-.9", key: "18r7jp" }],
  ["path", { d: "m19.6 21.7-.4-1", key: "z2vh2" }],
  ["path", { d: "m16.8 15.3-.4-1", key: "1ei7r6" }],
  ["path", { d: "m14.3 19.6 1-.4", key: "11sv9r" }],
  ["path", { d: "m20.7 16.8 1-.4", key: "19m87a" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderDot = createLucideIcon("FolderDot", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "1", key: "49l61u" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderDown = createLucideIcon("FolderDown", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "m15 13-3 3-3-3", key: "6j2sf0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderGit2 = createLucideIcon("FolderGit2", [
  [
    "path",
    {
      d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v5",
      key: "1w6njk"
    }
  ],
  ["circle", { cx: "13", cy: "12", r: "2", key: "1j92g6" }],
  ["path", { d: "M18 19c-2.8 0-5-2.2-5-5v8", key: "pkpw2h" }],
  ["circle", { cx: "20", cy: "19", r: "2", key: "1obnsp" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderGit = createLucideIcon("FolderGit", [
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M14 13h3", key: "1dgedf" }],
  ["path", { d: "M7 13h3", key: "1pygq7" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderHeart = createLucideIcon("FolderHeart", [
  [
    "path",
    {
      d: "M11 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v1.5",
      key: "6hud8k"
    }
  ],
  [
    "path",
    {
      d: "M13.9 17.45c-1.2-1.2-1.14-2.8-.2-3.73a2.43 2.43 0 0 1 3.44 0l.36.34.34-.34a2.43 2.43 0 0 1 3.45-.01c.95.95 1 2.53-.2 3.74L17.5 21Z",
      key: "wpff58"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderInput = createLucideIcon("FolderInput", [
  [
    "path",
    {
      d: "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1",
      key: "fm4g5t"
    }
  ],
  ["path", { d: "M2 13h10", key: "pgb2dq" }],
  ["path", { d: "m9 16 3-3-3-3", key: "6m91ic" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderKanban = createLucideIcon("FolderKanban", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["path", { d: "M8 10v4", key: "tgpxqk" }],
  ["path", { d: "M12 10v2", key: "hh53o1" }],
  ["path", { d: "M16 10v6", key: "1d6xys" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderKey = createLucideIcon("FolderKey", [
  ["circle", { cx: "16", cy: "20", r: "2", key: "1vifvg" }],
  [
    "path",
    {
      d: "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2",
      key: "3hgo9p"
    }
  ],
  ["path", { d: "m22 14-4.5 4.5", key: "1ef6z8" }],
  ["path", { d: "m21 15 1 1", key: "1ejcpy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderLock = createLucideIcon("FolderLock", [
  ["rect", { width: "8", height: "5", x: "14", y: "17", rx: "1", key: "19aais" }],
  [
    "path",
    {
      d: "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2.5",
      key: "1w6v7t"
    }
  ],
  ["path", { d: "M20 17v-2a2 2 0 1 0-4 0v2", key: "pwaxnr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderMinus = createLucideIcon("FolderMinus", [
  ["path", { d: "M9 13h6", key: "1uhe8q" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderOpenDot = createLucideIcon("FolderOpenDot", [
  [
    "path",
    {
      d: "m6 14 1.45-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.55 6a2 2 0 0 1-1.94 1.5H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H18a2 2 0 0 1 2 2v2",
      key: "1nmvlm"
    }
  ],
  ["circle", { cx: "14", cy: "15", r: "1", key: "1gm4qj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderOpen = createLucideIcon("FolderOpen", [
  [
    "path",
    {
      d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
      key: "usdka0"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderOutput = createLucideIcon("FolderOutput", [
  [
    "path",
    {
      d: "M2 7.5V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-1.5",
      key: "1yk7aj"
    }
  ],
  ["path", { d: "M2 13h10", key: "pgb2dq" }],
  ["path", { d: "m5 10-3 3 3 3", key: "1r8ie0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderPen = createLucideIcon("FolderPen", [
  [
    "path",
    {
      d: "M2 11.5V5a2 2 0 0 1 2-2h3.9c.7 0 1.3.3 1.7.9l.8 1.2c.4.6 1 .9 1.7.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-9.5",
      key: "a8xqs0"
    }
  ],
  [
    "path",
    {
      d: "M11.378 13.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1saktj"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderPlus = createLucideIcon("FolderPlus", [
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderRoot = createLucideIcon("FolderRoot", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }],
  ["path", { d: "M12 15v5", key: "11xva1" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderSearch2 = createLucideIcon("FolderSearch2", [
  ["circle", { cx: "11.5", cy: "12.5", r: "2.5", key: "1ea5ju" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M13.3 14.3 15 16", key: "1y4v1n" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderSearch = createLucideIcon("FolderSearch", [
  [
    "path",
    {
      d: "M10.7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v4.1",
      key: "1bw5m7"
    }
  ],
  ["path", { d: "m21 21-1.9-1.9", key: "1g2n9r" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderSymlink = createLucideIcon("FolderSymlink", [
  [
    "path",
    {
      d: "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7",
      key: "x1c07l"
    }
  ],
  ["path", { d: "m8 16 3-3-3-3", key: "rlqrt1" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderSync = createLucideIcon("FolderSync", [
  [
    "path",
    {
      d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v.5",
      key: "1dkoa9"
    }
  ],
  ["path", { d: "M12 10v4h4", key: "1czhmt" }],
  ["path", { d: "m12 14 1.535-1.605a5 5 0 0 1 8 1.5", key: "lvuxfi" }],
  ["path", { d: "M22 22v-4h-4", key: "1ewp4q" }],
  ["path", { d: "m22 18-1.535 1.605a5 5 0 0 1-8-1.5", key: "14ync0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderTree = createLucideIcon("FolderTree", [
  [
    "path",
    {
      d: "M20 10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2.5a1 1 0 0 1-.8-.4l-.9-1.2A1 1 0 0 0 15 3h-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
      key: "hod4my"
    }
  ],
  [
    "path",
    {
      d: "M20 21a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-2.9a1 1 0 0 1-.88-.55l-.42-.85a1 1 0 0 0-.92-.6H13a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
      key: "w4yl2u"
    }
  ],
  ["path", { d: "M3 5a2 2 0 0 0 2 2h3", key: "f2jnh7" }],
  ["path", { d: "M3 3v13a2 2 0 0 0 2 2h3", key: "k8epm1" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderUp = createLucideIcon("FolderUp", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "m9 13 3-3 3 3", key: "1pxg3c" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FolderX = createLucideIcon("FolderX", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "m9.5 10.5 5 5", key: "ra9qjz" }],
  ["path", { d: "m14.5 10.5-5 5", key: "l2rkpq" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Folder = createLucideIcon("Folder", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Folders = createLucideIcon("Folders", [
  [
    "path",
    {
      d: "M20 17a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3.9a2 2 0 0 1-1.69-.9l-.81-1.2a2 2 0 0 0-1.67-.9H8a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2Z",
      key: "4u7rpt"
    }
  ],
  ["path", { d: "M2 8v11a2 2 0 0 0 2 2h14", key: "1eicx1" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Footprints = createLucideIcon("Footprints", [
  [
    "path",
    {
      d: "M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z",
      key: "1dudjm"
    }
  ],
  [
    "path",
    {
      d: "M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z",
      key: "l2t8xc"
    }
  ],
  ["path", { d: "M16 17h4", key: "1dejxt" }],
  ["path", { d: "M4 13h4", key: "1bwh8b" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Forklift = createLucideIcon("Forklift", [
  ["path", { d: "M12 12H5a2 2 0 0 0-2 2v5", key: "7zsz91" }],
  ["circle", { cx: "13", cy: "19", r: "2", key: "wjnkru" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M8 19h3m5-17v17h6M6 12V7c0-1.1.9-2 2-2h3l5 5", key: "13bk1p" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Forward = createLucideIcon("Forward", [
  ["polyline", { points: "15 17 20 12 15 7", key: "1w3sku" }],
  ["path", { d: "M4 18v-2a4 4 0 0 1 4-4h12", key: "jmiej9" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Frame = createLucideIcon("Frame", [
  ["line", { x1: "22", x2: "2", y1: "6", y2: "6", key: "15w7dq" }],
  ["line", { x1: "22", x2: "2", y1: "18", y2: "18", key: "1ip48p" }],
  ["line", { x1: "6", x2: "6", y1: "2", y2: "22", key: "a2lnyx" }],
  ["line", { x1: "18", x2: "18", y1: "2", y2: "22", key: "8vb6jd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Framer = createLucideIcon("Framer", [
  ["path", { d: "M5 16V9h14V2H5l14 14h-7m-7 0 7 7v-7m-7 0h7", key: "1a2nng" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Frown = createLucideIcon("Frown", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2", key: "epbg0q" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fuel = createLucideIcon("Fuel", [
  ["line", { x1: "3", x2: "15", y1: "22", y2: "22", key: "xegly4" }],
  ["line", { x1: "4", x2: "14", y1: "9", y2: "9", key: "xcnuvu" }],
  ["path", { d: "M14 22V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v18", key: "16j0yd" }],
  [
    "path",
    {
      d: "M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 2 2a2 2 0 0 0 2-2V9.83a2 2 0 0 0-.59-1.42L18 5",
      key: "7cu91f"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fullscreen = createLucideIcon("Fullscreen", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["rect", { width: "10", height: "8", x: "7", y: "8", rx: "1", key: "vys8me" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GalleryHorizontalEnd = createLucideIcon("GalleryHorizontalEnd", [
  ["path", { d: "M2 7v10", key: "a2pl2d" }],
  ["path", { d: "M6 5v14", key: "1kq3d7" }],
  ["rect", { width: "12", height: "18", x: "10", y: "3", rx: "2", key: "13i7bc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GalleryHorizontal = createLucideIcon("GalleryHorizontal", [
  ["path", { d: "M2 3v18", key: "pzttux" }],
  ["rect", { width: "12", height: "18", x: "6", y: "3", rx: "2", key: "btr8bg" }],
  ["path", { d: "M22 3v18", key: "6jf3v" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GalleryThumbnails = createLucideIcon("GalleryThumbnails", [
  ["rect", { width: "18", height: "14", x: "3", y: "3", rx: "2", key: "74y24f" }],
  ["path", { d: "M4 21h1", key: "16zlid" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M19 21h1", key: "edywat" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GalleryVerticalEnd = createLucideIcon("GalleryVerticalEnd", [
  ["path", { d: "M7 2h10", key: "nczekb" }],
  ["path", { d: "M5 6h14", key: "u2x4p" }],
  ["rect", { width: "18", height: "12", x: "3", y: "10", rx: "2", key: "l0tzu3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GalleryVertical = createLucideIcon("GalleryVertical", [
  ["path", { d: "M3 2h18", key: "15qxfx" }],
  ["rect", { width: "18", height: "12", x: "3", y: "6", rx: "2", key: "1439r6" }],
  ["path", { d: "M3 22h18", key: "8prr45" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gamepad2 = createLucideIcon("Gamepad2", [
  ["line", { x1: "6", x2: "10", y1: "11", y2: "11", key: "1gktln" }],
  ["line", { x1: "8", x2: "8", y1: "9", y2: "13", key: "qnk9ow" }],
  ["line", { x1: "15", x2: "15.01", y1: "12", y2: "12", key: "krot7o" }],
  ["line", { x1: "18", x2: "18.01", y1: "10", y2: "10", key: "1lcuu1" }],
  [
    "path",
    {
      d: "M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z",
      key: "mfqc10"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gamepad = createLucideIcon("Gamepad", [
  ["line", { x1: "6", x2: "10", y1: "12", y2: "12", key: "161bw2" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "15", x2: "15.01", y1: "13", y2: "13", key: "dqpgro" }],
  ["line", { x1: "18", x2: "18.01", y1: "11", y2: "11", key: "meh2c" }],
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gauge = createLucideIcon("Gauge", [
  ["path", { d: "m12 14 4-4", key: "9kzdfg" }],
  ["path", { d: "M3.34 19a10 10 0 1 1 17.32 0", key: "19p75a" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gavel = createLucideIcon("Gavel", [
  ["path", { d: "m14.5 12.5-8 8a2.119 2.119 0 1 1-3-3l8-8", key: "15492f" }],
  ["path", { d: "m16 16 6-6", key: "vzrcl6" }],
  ["path", { d: "m8 8 6-6", key: "18bi4p" }],
  ["path", { d: "m9 7 8 8", key: "5jnvq1" }],
  ["path", { d: "m21 11-8-8", key: "z4y7zo" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gem = createLucideIcon("Gem", [
  ["path", { d: "M6 3h12l4 6-10 13L2 9Z", key: "1pcd5k" }],
  ["path", { d: "M11 3 8 9l4 13 4-13-3-6", key: "1fcu3u" }],
  ["path", { d: "M2 9h20", key: "16fsjt" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ghost = createLucideIcon("Ghost", [
  ["path", { d: "M9 10h.01", key: "qbtxuw" }],
  ["path", { d: "M15 10h.01", key: "1qmjsl" }],
  [
    "path",
    {
      d: "M12 2a8 8 0 0 0-8 8v12l3-3 2.5 2.5L12 19l2.5 2.5L17 19l3 3V10a8 8 0 0 0-8-8z",
      key: "uwwb07"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gift = createLucideIcon("Gift", [
  ["rect", { x: "3", y: "8", width: "18", height: "4", rx: "1", key: "bkv52" }],
  ["path", { d: "M12 8v13", key: "1c76mn" }],
  ["path", { d: "M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7", key: "6wjy6b" }],
  [
    "path",
    {
      d: "M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5",
      key: "1ihvrl"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GitBranchPlus = createLucideIcon("GitBranchPlus", [
  ["path", { d: "M6 3v12", key: "qpgusn" }],
  ["path", { d: "M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", key: "1d02ji" }],
  ["path", { d: "M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", key: "chk6ph" }],
  ["path", { d: "M15 6a9 9 0 0 0-9 9", key: "or332x" }],
  ["path", { d: "M18 15v6", key: "9wciyi" }],
  ["path", { d: "M21 18h-6", key: "139f0c" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GitBranch = createLucideIcon("GitBranch", [
  ["line", { x1: "6", x2: "6", y1: "3", y2: "15", key: "17qcm7" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["path", { d: "M18 9a9 9 0 0 1-9 9", key: "n2h4wq" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GitCommitHorizontal = createLucideIcon("GitCommitHorizontal", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["line", { x1: "3", x2: "9", y1: "12", y2: "12", key: "1dyftd" }],
  ["line", { x1: "15", x2: "21", y1: "12", y2: "12", key: "oup4p8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GitCommitVertical = createLucideIcon("GitCommitVertical", [
  ["path", { d: "M12 3v6", key: "1holv5" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "M12 15v6", key: "a9ows0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GitCompareArrows = createLucideIcon("GitCompareArrows", [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M12 6h5a2 2 0 0 1 2 2v7", key: "1yj91y" }],
  ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
  ["circle", { cx: "19", cy: "18", r: "3", key: "1qljk2" }],
  ["path", { d: "M12 18H7a2 2 0 0 1-2-2V9", key: "16sdep" }],
  ["path", { d: "m9 15 3 3-3 3", key: "1m3kbl" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GitCompare = createLucideIcon("GitCompare", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v7", key: "1yeb86" }],
  ["path", { d: "M11 18H8a2 2 0 0 1-2-2V9", key: "19pyzm" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GitFork = createLucideIcon("GitFork", [
  ["circle", { cx: "12", cy: "18", r: "3", key: "1mpf1b" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }],
  ["path", { d: "M18 9v2c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V9", key: "1uq4wg" }],
  ["path", { d: "M12 12v3", key: "158kv8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GitGraph = createLucideIcon("GitGraph", [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M5 9v6", key: "158jrl" }],
  ["circle", { cx: "5", cy: "18", r: "3", key: "104gr9" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["circle", { cx: "19", cy: "6", r: "3", key: "108a5v" }],
  ["path", { d: "M16 15.7A9 9 0 0 0 19 9", key: "1e3vqb" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GitMerge = createLucideIcon("GitMerge", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 21V9a9 9 0 0 0 9 9", key: "7kw0sc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GitPullRequestArrow = createLucideIcon("GitPullRequestArrow", [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M5 9v12", key: "ih889a" }],
  ["circle", { cx: "19", cy: "18", r: "3", key: "1qljk2" }],
  ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
  ["path", { d: "M12 6h5a2 2 0 0 1 2 2v7", key: "1yj91y" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GitPullRequestClosed = createLucideIcon("GitPullRequestClosed", [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 9v12", key: "1sc30k" }],
  ["path", { d: "m21 3-6 6", key: "16nqsk" }],
  ["path", { d: "m21 9-6-6", key: "9j17rh" }],
  ["path", { d: "M18 11.5V15", key: "65xf6f" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GitPullRequestCreateArrow = createLucideIcon("GitPullRequestCreateArrow", [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M5 9v12", key: "ih889a" }],
  ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
  ["path", { d: "M12 6h5a2 2 0 0 1 2 2v3", key: "1rbwk6" }],
  ["path", { d: "M19 15v6", key: "10aioa" }],
  ["path", { d: "M22 18h-6", key: "1d5gi5" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GitPullRequestCreate = createLucideIcon("GitPullRequestCreate", [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 9v12", key: "1sc30k" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v3", key: "1jb6z3" }],
  ["path", { d: "M18 15v6", key: "9wciyi" }],
  ["path", { d: "M21 18h-6", key: "139f0c" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GitPullRequestDraft = createLucideIcon("GitPullRequestDraft", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M18 6V5", key: "1oao2s" }],
  ["path", { d: "M18 11v-1", key: "11c8tz" }],
  ["line", { x1: "6", x2: "6", y1: "9", y2: "21", key: "rroup" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GitPullRequest = createLucideIcon("GitPullRequest", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v7", key: "1yeb86" }],
  ["line", { x1: "6", x2: "6", y1: "9", y2: "21", key: "rroup" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Github = createLucideIcon("Github", [
  [
    "path",
    {
      d: "M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4",
      key: "tonef"
    }
  ],
  ["path", { d: "M9 18c-4.51 2-5-2-7-2", key: "9comsn" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gitlab = createLucideIcon("Gitlab", [
  [
    "path",
    {
      d: "m22 13.29-3.33-10a.42.42 0 0 0-.14-.18.38.38 0 0 0-.22-.11.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18l-2.26 6.67H8.32L6.1 3.26a.42.42 0 0 0-.1-.18.38.38 0 0 0-.26-.08.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18L2 13.29a.74.74 0 0 0 .27.83L12 21l9.69-6.88a.71.71 0 0 0 .31-.83Z",
      key: "148pdi"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GlassWater = createLucideIcon("GlassWater", [
  [
    "path",
    { d: "M15.2 22H8.8a2 2 0 0 1-2-1.79L5 3h14l-1.81 17.21A2 2 0 0 1 15.2 22Z", key: "48rfw3" }
  ],
  ["path", { d: "M6 12a5 5 0 0 1 6 0 5 5 0 0 0 6 0", key: "mjntcy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Glasses = createLucideIcon("Glasses", [
  ["circle", { cx: "6", cy: "15", r: "4", key: "vux9w4" }],
  ["circle", { cx: "18", cy: "15", r: "4", key: "18o8ve" }],
  ["path", { d: "M14 15a2 2 0 0 0-2-2 2 2 0 0 0-2 2", key: "1ag4bs" }],
  ["path", { d: "M2.5 13 5 7c.7-1.3 1.4-2 3-2", key: "1hm1gs" }],
  ["path", { d: "M21.5 13 19 7c-.7-1.3-1.5-2-3-2", key: "1r31ai" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GlobeLock = createLucideIcon("GlobeLock", [
  [
    "path",
    {
      d: "M15.686 15A14.5 14.5 0 0 1 12 22a14.5 14.5 0 0 1 0-20 10 10 0 1 0 9.542 13",
      key: "qkt0x6"
    }
  ],
  ["path", { d: "M2 12h8.5", key: "ovaggd" }],
  ["path", { d: "M20 6V4a2 2 0 1 0-4 0v2", key: "1of5e8" }],
  ["rect", { width: "8", height: "5", x: "14", y: "6", rx: "1", key: "1fmf51" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Globe = createLucideIcon("Globe", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20", key: "13o1zl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Goal = createLucideIcon("Goal", [
  ["path", { d: "M12 13V2l8 4-8 4", key: "5wlwwj" }],
  ["path", { d: "M20.561 10.222a9 9 0 1 1-12.55-5.29", key: "1c0wjv" }],
  ["path", { d: "M8.002 9.997a5 5 0 1 0 8.9 2.02", key: "gb1g7m" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Grab = createLucideIcon("Grab", [
  ["path", { d: "M18 11.5V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1.4", key: "edstyy" }],
  ["path", { d: "M14 10V8a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2", key: "19wdwo" }],
  ["path", { d: "M10 9.9V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v5", key: "1lugqo" }],
  ["path", { d: "M6 14a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1hbeus" }],
  [
    "path",
    { d: "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-4a8 8 0 0 1-8-8 2 2 0 1 1 4 0", key: "1etffm" }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GraduationCap = createLucideIcon("GraduationCap", [
  [
    "path",
    {
      d: "M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z",
      key: "j76jl0"
    }
  ],
  ["path", { d: "M22 10v6", key: "1lu8f3" }],
  ["path", { d: "M6 12.5V16a6 3 0 0 0 12 0v-3.5", key: "1r8lef" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Grape = createLucideIcon("Grape", [
  ["path", { d: "M22 5V2l-5.89 5.89", key: "1eenpo" }],
  ["circle", { cx: "16.6", cy: "15.89", r: "3", key: "xjtalx" }],
  ["circle", { cx: "8.11", cy: "7.4", r: "3", key: "u2fv6i" }],
  ["circle", { cx: "12.35", cy: "11.65", r: "3", key: "i6i8g7" }],
  ["circle", { cx: "13.91", cy: "5.85", r: "3", key: "6ye0dv" }],
  ["circle", { cx: "18.15", cy: "10.09", r: "3", key: "snx9no" }],
  ["circle", { cx: "6.56", cy: "13.2", r: "3", key: "17x4xg" }],
  ["circle", { cx: "10.8", cy: "17.44", r: "3", key: "1hogw9" }],
  ["circle", { cx: "5", cy: "19", r: "3", key: "1sn6vo" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Grid2x2Check = createLucideIcon("Grid2x2Check", [
  [
    "path",
    {
      d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
      key: "11za1p"
    }
  ],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Grid2x2Plus = createLucideIcon("Grid2x2Plus", [
  [
    "path",
    {
      d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
      key: "11za1p"
    }
  ],
  ["path", { d: "M16 19h6", key: "xwg31i" }],
  ["path", { d: "M19 22v-6", key: "qhmiwi" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Grid2x2X = createLucideIcon("Grid2x2X", [
  [
    "path",
    {
      d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
      key: "11za1p"
    }
  ],
  ["path", { d: "m16 16 5 5", key: "8tpb07" }],
  ["path", { d: "m16 21 5-5", key: "193jll" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Grid2x2 = createLucideIcon("Grid2x2", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M12 3v18", key: "108xh3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Grid3x3 = createLucideIcon("Grid3x3", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GripHorizontal = createLucideIcon("GripHorizontal", [
  ["circle", { cx: "12", cy: "9", r: "1", key: "124mty" }],
  ["circle", { cx: "19", cy: "9", r: "1", key: "1ruzo2" }],
  ["circle", { cx: "5", cy: "9", r: "1", key: "1a8b28" }],
  ["circle", { cx: "12", cy: "15", r: "1", key: "1e56xg" }],
  ["circle", { cx: "19", cy: "15", r: "1", key: "1a92ep" }],
  ["circle", { cx: "5", cy: "15", r: "1", key: "5r1jwy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GripVertical = createLucideIcon("GripVertical", [
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }],
  ["circle", { cx: "9", cy: "5", r: "1", key: "hp0tcf" }],
  ["circle", { cx: "9", cy: "19", r: "1", key: "fkjjf6" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["circle", { cx: "15", cy: "19", r: "1", key: "f4zoj3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Grip = createLucideIcon("Grip", [
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "19", cy: "5", r: "1", key: "w8mnmm" }],
  ["circle", { cx: "5", cy: "5", r: "1", key: "lttvr7" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }],
  ["circle", { cx: "19", cy: "19", r: "1", key: "shf9b7" }],
  ["circle", { cx: "5", cy: "19", r: "1", key: "bfqh0e" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Group = createLucideIcon("Group", [
  ["path", { d: "M3 7V5c0-1.1.9-2 2-2h2", key: "adw53z" }],
  ["path", { d: "M17 3h2c1.1 0 2 .9 2 2v2", key: "an4l38" }],
  ["path", { d: "M21 17v2c0 1.1-.9 2-2 2h-2", key: "144t0e" }],
  ["path", { d: "M7 21H5c-1.1 0-2-.9-2-2v-2", key: "rtnfgi" }],
  ["rect", { width: "7", height: "5", x: "7", y: "7", rx: "1", key: "1eyiv7" }],
  ["rect", { width: "7", height: "5", x: "10", y: "12", rx: "1", key: "1qlmkx" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Guitar = createLucideIcon("Guitar", [
  ["path", { d: "m11.9 12.1 4.514-4.514", key: "109xqo" }],
  [
    "path",
    {
      d: "M20.1 2.3a1 1 0 0 0-1.4 0l-1.114 1.114A2 2 0 0 0 17 4.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 17.828 7h1.344a2 2 0 0 0 1.414-.586L21.7 5.3a1 1 0 0 0 0-1.4z",
      key: "txyc8t"
    }
  ],
  ["path", { d: "m6 16 2 2", key: "16qmzd" }],
  [
    "path",
    {
      d: "M8.2 9.9C8.7 8.8 9.8 8 11 8c2.8 0 5 2.2 5 5 0 1.2-.8 2.3-1.9 2.8l-.9.4A2 2 0 0 0 12 18a4 4 0 0 1-4 4c-3.3 0-6-2.7-6-6a4 4 0 0 1 4-4 2 2 0 0 0 1.8-1.2z",
      key: "1u8q3z"
    }
  ],
  ["circle", { cx: "11.5", cy: "12.5", r: ".5", fill: "currentColor", key: "16onso" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ham = createLucideIcon("Ham", [
  ["path", { d: "M13.144 21.144A7.274 10.445 45 1 0 2.856 10.856", key: "1k1t7q" }],
  [
    "path",
    {
      d: "M13.144 21.144A7.274 4.365 45 0 0 2.856 10.856a7.274 4.365 45 0 0 10.288 10.288",
      key: "153t1g"
    }
  ],
  [
    "path",
    {
      d: "M16.565 10.435 18.6 8.4a2.501 2.501 0 1 0 1.65-4.65 2.5 2.5 0 1 0-4.66 1.66l-2.024 2.025",
      key: "gzrt0n"
    }
  ],
  ["path", { d: "m8.5 16.5-1-1", key: "otr954" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hammer = createLucideIcon("Hammer", [
  ["path", { d: "m15 12-8.373 8.373a1 1 0 1 1-3-3L12 9", key: "eefl8a" }],
  ["path", { d: "m18 15 4-4", key: "16gjal" }],
  [
    "path",
    {
      d: "m21.5 11.5-1.914-1.914A2 2 0 0 1 19 8.172V7l-2.26-2.26a6 6 0 0 0-4.202-1.756L9 2.96l.92.82A6.18 6.18 0 0 1 12 8.4V10l2 2h1.172a2 2 0 0 1 1.414.586L18.5 14.5",
      key: "b7pghm"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HandCoins = createLucideIcon("HandCoins", [
  ["path", { d: "M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17", key: "geh8rc" }],
  [
    "path",
    {
      d: "m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
      key: "1fto5m"
    }
  ],
  ["path", { d: "m2 16 6 6", key: "1pfhp9" }],
  ["circle", { cx: "16", cy: "9", r: "2.9", key: "1n0dlu" }],
  ["circle", { cx: "6", cy: "5", r: "3", key: "151irh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HandHeart = createLucideIcon("HandHeart", [
  ["path", { d: "M11 14h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 16", key: "1ifwr1" }],
  [
    "path",
    {
      d: "m7 20 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
      key: "17abbs"
    }
  ],
  ["path", { d: "m2 15 6 6", key: "10dquu" }],
  [
    "path",
    {
      d: "M19.5 8.5c.7-.7 1.5-1.6 1.5-2.7A2.73 2.73 0 0 0 16 4a2.78 2.78 0 0 0-5 1.8c0 1.2.8 2 1.5 2.8L16 12Z",
      key: "1h3036"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HandHelping = createLucideIcon("HandHelping", [
  ["path", { d: "M11 12h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 14", key: "1j4xps" }],
  [
    "path",
    {
      d: "m7 18 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
      key: "uospg8"
    }
  ],
  ["path", { d: "m2 13 6 6", key: "16e5sb" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HandMetal = createLucideIcon("HandMetal", [
  ["path", { d: "M18 12.5V10a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1.4", key: "wc6myp" }],
  ["path", { d: "M14 11V9a2 2 0 1 0-4 0v2", key: "94qvcw" }],
  ["path", { d: "M10 10.5V5a2 2 0 1 0-4 0v9", key: "m1ah89" }],
  [
    "path",
    {
      d: "m7 15-1.76-1.76a2 2 0 0 0-2.83 2.82l3.6 3.6C7.5 21.14 9.2 22 12 22h2a8 8 0 0 0 8-8V7a2 2 0 1 0-4 0v5",
      key: "t1skq1"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HandPlatter = createLucideIcon("HandPlatter", [
  ["path", { d: "M12 3V2", key: "ar7q03" }],
  ["path", { d: "M5 10a7.1 7.1 0 0 1 14 0", key: "1t9y3n" }],
  ["path", { d: "M4 10h16", key: "img6z1" }],
  ["path", { d: "M2 14h12a2 2 0 1 1 0 4h-2", key: "loyjft" }],
  [
    "path",
    {
      d: "m15.4 17.4 3.2-2.8a2 2 0 0 1 2.8 2.9l-3.6 3.3c-.7.8-1.7 1.2-2.8 1.2h-4c-1.1 0-2.1-.4-2.8-1.2L5 18",
      key: "1rixiy"
    }
  ],
  ["path", { d: "M5 14v7H2", key: "3mujks" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hand = createLucideIcon("Hand", [
  ["path", { d: "M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1fvzgz" }],
  ["path", { d: "M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2", key: "1kc0my" }],
  ["path", { d: "M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8", key: "10h0bg" }],
  [
    "path",
    {
      d: "M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
      key: "1s1gnw"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Handshake = createLucideIcon("Handshake", [
  ["path", { d: "m11 17 2 2a1 1 0 1 0 3-3", key: "efffak" }],
  [
    "path",
    {
      d: "m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4",
      key: "9pr0kb"
    }
  ],
  ["path", { d: "m21 3 1 11h-2", key: "1tisrp" }],
  ["path", { d: "M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3", key: "1uvwmv" }],
  ["path", { d: "M3 4h8", key: "1ep09j" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HardDriveDownload = createLucideIcon("HardDriveDownload", [
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["path", { d: "m16 6-4 4-4-4", key: "6wukr" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 18h.01", key: "h775k" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HardDriveUpload = createLucideIcon("HardDriveUpload", [
  ["path", { d: "m16 6-4-4-4 4", key: "13yo43" }],
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 18h.01", key: "h775k" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HardDrive = createLucideIcon("HardDrive", [
  ["line", { x1: "22", x2: "2", y1: "12", y2: "12", key: "1y58io" }],
  [
    "path",
    {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
      key: "oot6mr"
    }
  ],
  ["line", { x1: "6", x2: "6.01", y1: "16", y2: "16", key: "sgf278" }],
  ["line", { x1: "10", x2: "10.01", y1: "16", y2: "16", key: "1l4acy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HardHat = createLucideIcon("HardHat", [
  [
    "path",
    {
      d: "M2 18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v2z",
      key: "1dej2m"
    }
  ],
  ["path", { d: "M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5", key: "1p9q5i" }],
  ["path", { d: "M4 15v-3a6 6 0 0 1 6-6", key: "9ciidu" }],
  ["path", { d: "M14 6a6 6 0 0 1 6 6v3", key: "1hnv84" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hash = createLucideIcon("Hash", [
  ["line", { x1: "4", x2: "20", y1: "9", y2: "9", key: "4lhtct" }],
  ["line", { x1: "4", x2: "20", y1: "15", y2: "15", key: "vyu0kd" }],
  ["line", { x1: "10", x2: "8", y1: "3", y2: "21", key: "1ggp8o" }],
  ["line", { x1: "16", x2: "14", y1: "3", y2: "21", key: "weycgp" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Haze = createLucideIcon("Haze", [
  ["path", { d: "m5.2 6.2 1.4 1.4", key: "17imol" }],
  ["path", { d: "M2 13h2", key: "13gyu8" }],
  ["path", { d: "M20 13h2", key: "16rner" }],
  ["path", { d: "m17.4 7.6 1.4-1.4", key: "t4xlah" }],
  ["path", { d: "M22 17H2", key: "1gtaj3" }],
  ["path", { d: "M22 21H2", key: "1gy6en" }],
  ["path", { d: "M16 13a4 4 0 0 0-8 0", key: "1dyczq" }],
  ["path", { d: "M12 5V2.5", key: "1vytko" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HdmiPort = createLucideIcon("HdmiPort", [
  [
    "path",
    {
      d: "M22 9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1l2 2h12l2-2h1a1 1 0 0 0 1-1Z",
      key: "2128wb"
    }
  ],
  ["path", { d: "M7.5 12h9", key: "1t0ckc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Heading1 = createLucideIcon("Heading1", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "m17 12 3-2v8", key: "1hhhft" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Heading2 = createLucideIcon("Heading2", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M21 18h-4c0-4 4-3 4-6 0-1.5-2-2.5-4-1", key: "9jr5yi" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Heading3 = createLucideIcon("Heading3", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17.5 10.5c1.7-1 3.5 0 3.5 1.5a2 2 0 0 1-2 2", key: "68ncm8" }],
  ["path", { d: "M17 17.5c2 1.5 4 .3 4-1.5a2 2 0 0 0-2-2", key: "1ejuhz" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Heading4 = createLucideIcon("Heading4", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17 10v4h4", key: "13sv97" }],
  ["path", { d: "M21 10v8", key: "1kdml4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Heading5 = createLucideIcon("Heading5", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17 13v-3h4", key: "1nvgqp" }],
  [
    "path",
    { d: "M17 17.7c.4.2.8.3 1.3.3 1.5 0 2.7-1.1 2.7-2.5S19.8 13 18.3 13H17", key: "2nebdn" }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Heading6 = createLucideIcon("Heading6", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["circle", { cx: "19", cy: "16", r: "2", key: "15mx69" }],
  ["path", { d: "M20 10c-2 2-3 3.5-3 6", key: "f35dl0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Heading = createLucideIcon("Heading", [
  ["path", { d: "M6 12h12", key: "8npq4p" }],
  ["path", { d: "M6 20V4", key: "1w1bmo" }],
  ["path", { d: "M18 20V4", key: "o2hl4u" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HeadphoneOff = createLucideIcon("HeadphoneOff", [
  ["path", { d: "M21 14h-1.343", key: "1jdnxi" }],
  ["path", { d: "M9.128 3.47A9 9 0 0 1 21 12v3.343", key: "6kipu2" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M20.414 20.414A2 2 0 0 1 19 21h-1a2 2 0 0 1-2-2v-3", key: "9x50f4" }],
  [
    "path",
    {
      d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 2.636-6.364",
      key: "1bkxnm"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Headphones = createLucideIcon("Headphones", [
  [
    "path",
    {
      d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3",
      key: "1xhozi"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Headset = createLucideIcon("Headset", [
  [
    "path",
    {
      d: "M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z",
      key: "12oyoe"
    }
  ],
  ["path", { d: "M21 16v2a4 4 0 0 1-4 4h-5", key: "1x7m43" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HeartCrack = createLucideIcon("HeartCrack", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  ["path", { d: "m12 13-1-1 2-2-3-3 2-2", key: "xjdxli" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HeartHandshake = createLucideIcon("HeartHandshake", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  [
    "path",
    {
      d: "M12 5 9.04 7.96a2.17 2.17 0 0 0 0 3.08c.82.82 2.13.85 3 .07l2.07-1.9a2.82 2.82 0 0 1 3.79 0l2.96 2.66",
      key: "4oyue0"
    }
  ],
  ["path", { d: "m18 15-2-2", key: "60u0ii" }],
  ["path", { d: "m15 18-2-2", key: "6p76be" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HeartOff = createLucideIcon("HeartOff", [
  ["line", { x1: "2", y1: "2", x2: "22", y2: "22", key: "1w4vcy" }],
  [
    "path",
    { d: "M16.5 16.5 12 21l-7-7c-1.5-1.45-3-3.2-3-5.5a5.5 5.5 0 0 1 2.14-4.35", key: "3mpagl" }
  ],
  [
    "path",
    {
      d: "M8.76 3.1c1.15.22 2.13.78 3.24 1.9 1.5-1.5 2.74-2 4.5-2A5.5 5.5 0 0 1 22 8.5c0 2.12-1.3 3.78-2.67 5.17",
      key: "1gh3v3"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HeartPulse = createLucideIcon("HeartPulse", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  ["path", { d: "M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27", key: "1uw2ng" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Heart = createLucideIcon("Heart", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Heater = createLucideIcon("Heater", [
  ["path", { d: "M11 8c2-3-2-3 0-6", key: "1ldv5m" }],
  ["path", { d: "M15.5 8c2-3-2-3 0-6", key: "1otqoz" }],
  ["path", { d: "M6 10h.01", key: "1lbq93" }],
  ["path", { d: "M6 14h.01", key: "zudwn7" }],
  ["path", { d: "M10 16v-4", key: "1c25yv" }],
  ["path", { d: "M14 16v-4", key: "1dkbt8" }],
  ["path", { d: "M18 16v-4", key: "1yg9me" }],
  [
    "path",
    { d: "M20 6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3", key: "1ubg90" }
  ],
  ["path", { d: "M5 20v2", key: "1abpe8" }],
  ["path", { d: "M19 20v2", key: "kqn6ft" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hexagon = createLucideIcon("Hexagon", [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Highlighter = createLucideIcon("Highlighter", [
  ["path", { d: "m9 11-6 6v3h9l3-3", key: "1a3l36" }],
  ["path", { d: "m22 12-4.6 4.6a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L14 4", key: "14a9rk" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const History = createLucideIcon("History", [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M12 7v5l4 2", key: "1fdv2h" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HopOff = createLucideIcon("HopOff", [
  ["path", { d: "M10.82 16.12c1.69.6 3.91.79 5.18.85.28.01.53-.09.7-.27", key: "qyzcap" }],
  [
    "path",
    {
      d: "M11.14 20.57c.52.24 2.44 1.12 4.08 1.37.46.06.86-.25.9-.71.12-1.52-.3-3.43-.5-4.28",
      key: "y078lb"
    }
  ],
  ["path", { d: "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .7-.26", key: "1utre3" }],
  [
    "path",
    {
      d: "M17.99 5.52a20.83 20.83 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-1.17.1-2.5.02-3.9-.25",
      key: "17o9hm"
    }
  ],
  ["path", { d: "M20.57 11.14c.24.52 1.12 2.44 1.37 4.08.04.3-.08.59-.31.75", key: "1d1n4p" }],
  [
    "path",
    {
      d: "M4.93 4.93a10 10 0 0 0-.67 13.4c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.85.85 0 0 0 .48-.24",
      key: "9uv3tt"
    }
  ],
  [
    "path",
    {
      d: "M5.52 17.99c1.05.95 2.91 2.42 4.5 3.15a.8.8 0 0 0 1.13-.68c.2-2.34-.33-5.3-1.57-8.28",
      key: "1292wz"
    }
  ],
  [
    "path",
    {
      d: "M8.35 2.68a10 10 0 0 1 9.98 1.58c.43.35.4.96-.12 1.17-1.5.6-4.3.98-6.07 1.05",
      key: "7ozu9p"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hop = createLucideIcon("Hop", [
  [
    "path",
    {
      d: "M10.82 16.12c1.69.6 3.91.79 5.18.85.55.03 1-.42.97-.97-.06-1.27-.26-3.5-.85-5.18",
      key: "18lxf1"
    }
  ],
  [
    "path",
    {
      d: "M11.5 6.5c1.64 0 5-.38 6.71-1.07.52-.2.55-.82.12-1.17A10 10 0 0 0 4.26 18.33c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.88.88 0 0 0 .73-.74c.3-2.14-.15-3.5-.61-4.88",
      key: "vtfxrw"
    }
  ],
  [
    "path",
    {
      d: "M15.62 16.95c.2.85.62 2.76.5 4.28a.77.77 0 0 1-.9.7 16.64 16.64 0 0 1-4.08-1.36",
      key: "13hl71"
    }
  ],
  [
    "path",
    {
      d: "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .96-.96 17.68 17.68 0 0 0-.9-4.87",
      key: "1sl8oj"
    }
  ],
  [
    "path",
    {
      d: "M16.94 15.62c.86.2 2.77.62 4.29.5a.77.77 0 0 0 .7-.9 16.64 16.64 0 0 0-1.36-4.08",
      key: "19c6kt"
    }
  ],
  [
    "path",
    {
      d: "M17.99 5.52a20.82 20.82 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-2.33.2-5.3-.32-8.27-1.57",
      key: "85ghs3"
    }
  ],
  ["path", { d: "M4.93 4.93 3 3a.7.7 0 0 1 0-1", key: "x087yj" }],
  [
    "path",
    {
      d: "M9.58 12.18c1.24 2.98 1.77 5.95 1.57 8.28a.8.8 0 0 1-1.13.68 20.82 20.82 0 0 1-4.5-3.15",
      key: "11xdqo"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hospital = createLucideIcon("Hospital", [
  ["path", { d: "M12 6v4", key: "16clxf" }],
  ["path", { d: "M14 14h-4", key: "esezmu" }],
  ["path", { d: "M14 18h-4", key: "16mqa2" }],
  ["path", { d: "M14 8h-4", key: "z8ypaz" }],
  [
    "path",
    {
      d: "M18 12h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h2",
      key: "b1k337"
    }
  ],
  ["path", { d: "M18 22V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v18", key: "16g51d" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hotel = createLucideIcon("Hotel", [
  ["path", { d: "M10 22v-6.57", key: "1wmca3" }],
  ["path", { d: "M12 11h.01", key: "z322tv" }],
  ["path", { d: "M12 7h.01", key: "1ivr5q" }],
  ["path", { d: "M14 15.43V22", key: "1q2vjd" }],
  ["path", { d: "M15 16a5 5 0 0 0-6 0", key: "o9wqvi" }],
  ["path", { d: "M16 11h.01", key: "xkw8gn" }],
  ["path", { d: "M16 7h.01", key: "1kdx03" }],
  ["path", { d: "M8 11h.01", key: "1dfujw" }],
  ["path", { d: "M8 7h.01", key: "1vti4s" }],
  ["rect", { x: "4", y: "2", width: "16", height: "20", rx: "2", key: "1uxh74" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hourglass = createLucideIcon("Hourglass", [
  ["path", { d: "M5 22h14", key: "ehvnwv" }],
  ["path", { d: "M5 2h14", key: "pdyrp9" }],
  [
    "path",
    {
      d: "M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22",
      key: "1d314k"
    }
  ],
  [
    "path",
    { d: "M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2", key: "1vvvr6" }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HousePlug = createLucideIcon("HousePlug", [
  ["path", { d: "M10 12V8.964", key: "1vll13" }],
  ["path", { d: "M14 12V8.964", key: "1x3qvg" }],
  [
    "path",
    { d: "M15 12a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-2a1 1 0 0 1 1-1z", key: "ppykja" }
  ],
  [
    "path",
    {
      d: "M8.5 21H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-2",
      key: "1gvg2z"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HousePlus = createLucideIcon("HousePlus", [
  [
    "path",
    {
      d: "M13.22 2.416a2 2 0 0 0-2.511.057l-7 5.999A2 2 0 0 0 3 10v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7.354",
      key: "5phn05"
    }
  ],
  ["path", { d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8", key: "5wwlr5" }],
  ["path", { d: "M15 6h6", key: "1jlkvy" }],
  ["path", { d: "M18 3v6", key: "x1uolp" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const House = createLucideIcon("House", [
  ["path", { d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8", key: "5wwlr5" }],
  [
    "path",
    {
      d: "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
      key: "1d0kgt"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IceCreamBowl = createLucideIcon("IceCreamBowl", [
  [
    "path",
    {
      d: "M12 17c5 0 8-2.69 8-6H4c0 3.31 3 6 8 6m-4 4h8m-4-3v3M5.14 11a3.5 3.5 0 1 1 6.71 0",
      key: "1uxfcu"
    }
  ],
  ["path", { d: "M12.14 11a3.5 3.5 0 1 1 6.71 0", key: "4k3m1s" }],
  ["path", { d: "M15.5 6.5a3.5 3.5 0 1 0-7 0", key: "zmuahr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IceCreamCone = createLucideIcon("IceCreamCone", [
  ["path", { d: "m7 11 4.08 10.35a1 1 0 0 0 1.84 0L17 11", key: "1v6356" }],
  ["path", { d: "M17 7A5 5 0 0 0 7 7", key: "151p3v" }],
  ["path", { d: "M17 7a2 2 0 0 1 0 4H7a2 2 0 0 1 0-4", key: "1sdaij" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IdCard = createLucideIcon("IdCard", [
  ["path", { d: "M16 10h2", key: "8sgtl7" }],
  ["path", { d: "M16 14h2", key: "epxaof" }],
  ["path", { d: "M6.17 15a3 3 0 0 1 5.66 0", key: "n6f512" }],
  ["circle", { cx: "9", cy: "11", r: "2", key: "yxgjnd" }],
  ["rect", { x: "2", y: "5", width: "20", height: "14", rx: "2", key: "qneu4z" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ImageDown = createLucideIcon("ImageDown", [
  [
    "path",
    {
      d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21",
      key: "9csbqa"
    }
  ],
  ["path", { d: "m14 19 3 3v-5.5", key: "9ldu5r" }],
  ["path", { d: "m17 22 3-3", key: "1nkfve" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ImageMinus = createLucideIcon("ImageMinus", [
  ["path", { d: "M21 9v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7", key: "m87ecr" }],
  ["line", { x1: "16", x2: "22", y1: "5", y2: "5", key: "ez7e4s" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ImageOff = createLucideIcon("ImageOff", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M10.41 10.41a2 2 0 1 1-2.83-2.83", key: "1bzlo9" }],
  ["line", { x1: "13.5", x2: "6", y1: "13.5", y2: "21", key: "1q0aeu" }],
  ["line", { x1: "18", x2: "21", y1: "12", y2: "15", key: "5mozeu" }],
  [
    "path",
    {
      d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59",
      key: "mmje98"
    }
  ],
  ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ImagePlay = createLucideIcon("ImagePlay", [
  ["path", { d: "m11 16-5 5", key: "j5f7ct" }],
  ["path", { d: "M11 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6.5", key: "7s81lt" }],
  [
    "path",
    {
      d: "M15.765 22a.5.5 0 0 1-.765-.424V13.38a.5.5 0 0 1 .765-.424l5.878 3.674a1 1 0 0 1 0 1.696z",
      key: "1omb6s"
    }
  ],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ImagePlus = createLucideIcon("ImagePlus", [
  ["path", { d: "M16 5h6", key: "1vod17" }],
  ["path", { d: "M19 2v6", key: "4bpg5p" }],
  ["path", { d: "M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5", key: "1ue2ih" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ImageUp = createLucideIcon("ImageUp", [
  [
    "path",
    {
      d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21",
      key: "9csbqa"
    }
  ],
  ["path", { d: "m14 19.5 3-3 3 3", key: "9vmjn0" }],
  ["path", { d: "M17 22v-5.5", key: "1aa6fl" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Image = createLucideIcon("Image", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Images = createLucideIcon("Images", [
  ["path", { d: "M18 22H4a2 2 0 0 1-2-2V6", key: "pblm9e" }],
  ["path", { d: "m22 13-1.296-1.296a2.41 2.41 0 0 0-3.408 0L11 18", key: "nf6bnh" }],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  ["rect", { width: "16", height: "16", x: "6", y: "2", rx: "2", key: "12espp" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Import = createLucideIcon("Import", [
  ["path", { d: "M12 3v12", key: "1x0j5s" }],
  ["path", { d: "m8 11 4 4 4-4", key: "1dohi6" }],
  [
    "path",
    {
      d: "M8 5H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4",
      key: "1ywtjm"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Inbox = createLucideIcon("Inbox", [
  ["polyline", { points: "22 12 16 12 14 15 10 15 8 12 2 12", key: "o97t9d" }],
  [
    "path",
    {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
      key: "oot6mr"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IndentDecrease = createLucideIcon("IndentDecrease", [
  ["path", { d: "M21 12H11", key: "wd7e0v" }],
  ["path", { d: "M21 18H11", key: "4wu86t" }],
  ["path", { d: "M21 6H11", key: "6dy1d6" }],
  ["path", { d: "m7 8-4 4 4 4", key: "o5hrat" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IndentIncrease = createLucideIcon("IndentIncrease", [
  ["path", { d: "M21 12H11", key: "wd7e0v" }],
  ["path", { d: "M21 18H11", key: "4wu86t" }],
  ["path", { d: "M21 6H11", key: "6dy1d6" }],
  ["path", { d: "m3 8 4 4-4 4", key: "1a3j6y" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IndianRupee = createLucideIcon("IndianRupee", [
  ["path", { d: "M6 3h12", key: "ggurg9" }],
  ["path", { d: "M6 8h12", key: "6g4wlu" }],
  ["path", { d: "m6 13 8.5 8", key: "u1kupk" }],
  ["path", { d: "M6 13h3", key: "wdp6ag" }],
  ["path", { d: "M9 13c6.667 0 6.667-10 0-10", key: "1nkvk2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Infinity = createLucideIcon("Infinity", [
  [
    "path",
    {
      d: "M12 12c-2-2.67-4-4-6-4a4 4 0 1 0 0 8c2 0 4-1.33 6-4Zm0 0c2 2.67 4 4 6 4a4 4 0 0 0 0-8c-2 0-4 1.33-6 4Z",
      key: "1z0uae"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Info = createLucideIcon("Info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const InspectionPanel = createLucideIcon("InspectionPanel", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 7h.01", key: "7u93v4" }],
  ["path", { d: "M17 7h.01", key: "14a9sn" }],
  ["path", { d: "M7 17h.01", key: "19xn7k" }],
  ["path", { d: "M17 17h.01", key: "1sd3ek" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Instagram = createLucideIcon("Instagram", [
  ["rect", { width: "20", height: "20", x: "2", y: "2", rx: "5", ry: "5", key: "2e1cvw" }],
  ["path", { d: "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z", key: "9exkf1" }],
  ["line", { x1: "17.5", x2: "17.51", y1: "6.5", y2: "6.5", key: "r4j83e" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Italic = createLucideIcon("Italic", [
  ["line", { x1: "19", x2: "10", y1: "4", y2: "4", key: "15jd3p" }],
  ["line", { x1: "14", x2: "5", y1: "20", y2: "20", key: "bu0au3" }],
  ["line", { x1: "15", x2: "9", y1: "4", y2: "20", key: "uljnxc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IterationCcw = createLucideIcon("IterationCcw", [
  ["path", { d: "M20 10c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8h8", key: "4znkd0" }],
  ["polyline", { points: "16 14 20 18 16 22", key: "11njsm" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IterationCw = createLucideIcon("IterationCw", [
  ["path", { d: "M4 10c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8H4", key: "tuf4su" }],
  ["polyline", { points: "8 22 4 18 8 14", key: "evkj9s" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JapaneseYen = createLucideIcon("JapaneseYen", [
  ["path", { d: "M12 9.5V21m0-11.5L6 3m6 6.5L18 3", key: "2ej80x" }],
  ["path", { d: "M6 15h12", key: "1hwgt5" }],
  ["path", { d: "M6 11h12", key: "wf4gp6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Joystick = createLucideIcon("Joystick", [
  [
    "path",
    {
      d: "M21 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2Z",
      key: "jg2n2t"
    }
  ],
  ["path", { d: "M6 15v-2", key: "gd6mvg" }],
  ["path", { d: "M12 15V9", key: "8c7uyn" }],
  ["circle", { cx: "12", cy: "6", r: "3", key: "1gm2ql" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kanban = createLucideIcon("Kanban", [
  ["path", { d: "M6 5v11", key: "mdvv1e" }],
  ["path", { d: "M12 5v6", key: "14ar3b" }],
  ["path", { d: "M18 5v14", key: "7ji314" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KeyRound = createLucideIcon("KeyRound", [
  [
    "path",
    {
      d: "M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z",
      key: "1s6t7t"
    }
  ],
  ["circle", { cx: "16.5", cy: "7.5", r: ".5", fill: "currentColor", key: "w0ekpg" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KeySquare = createLucideIcon("KeySquare", [
  [
    "path",
    {
      d: "M12.4 2.7a2.5 2.5 0 0 1 3.4 0l5.5 5.5a2.5 2.5 0 0 1 0 3.4l-3.7 3.7a2.5 2.5 0 0 1-3.4 0L8.7 9.8a2.5 2.5 0 0 1 0-3.4z",
      key: "165ttr"
    }
  ],
  ["path", { d: "m14 7 3 3", key: "1r5n42" }],
  [
    "path",
    {
      d: "m9.4 10.6-6.814 6.814A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814",
      key: "1ubxi2"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Key = createLucideIcon("Key", [
  ["path", { d: "m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4", key: "g0fldk" }],
  ["path", { d: "m21 2-9.6 9.6", key: "1j0ho8" }],
  ["circle", { cx: "7.5", cy: "15.5", r: "5.5", key: "yqb3hr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KeyboardMusic = createLucideIcon("KeyboardMusic", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M6 8h4", key: "utf9t1" }],
  ["path", { d: "M14 8h.01", key: "1primd" }],
  ["path", { d: "M18 8h.01", key: "emo2bl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M6 12v4", key: "dy92yo" }],
  ["path", { d: "M10 12v4", key: "1fxnav" }],
  ["path", { d: "M14 12v4", key: "1hft58" }],
  ["path", { d: "M18 12v4", key: "tjjnbz" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KeyboardOff = createLucideIcon("KeyboardOff", [
  ["path", { d: "M 20 4 A2 2 0 0 1 22 6", key: "1g1fkt" }],
  ["path", { d: "M 22 6 L 22 16.41", key: "1qjg3w" }],
  ["path", { d: "M 7 16 L 16 16", key: "n0yqwb" }],
  ["path", { d: "M 9.69 4 L 20 4", key: "kbpcgx" }],
  ["path", { d: "M14 8h.01", key: "1primd" }],
  ["path", { d: "M18 8h.01", key: "emo2bl" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M20 20H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2", key: "s23sx2" }],
  ["path", { d: "M6 8h.01", key: "x9i8wu" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Keyboard = createLucideIcon("Keyboard", [
  ["path", { d: "M10 8h.01", key: "1r9ogq" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M14 8h.01", key: "1primd" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }],
  ["path", { d: "M18 8h.01", key: "emo2bl" }],
  ["path", { d: "M6 8h.01", key: "x9i8wu" }],
  ["path", { d: "M7 16h10", key: "wp8him" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LampCeiling = createLucideIcon("LampCeiling", [
  ["path", { d: "M12 2v5", key: "nd4vlx" }],
  ["path", { d: "M6 7h12l4 9H2l4-9Z", key: "123d64" }],
  ["path", { d: "M9.17 16a3 3 0 1 0 5.66 0", key: "1061mw" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LampDesk = createLucideIcon("LampDesk", [
  ["path", { d: "m14 5-3 3 2 7 8-8-7-2Z", key: "1b0msb" }],
  ["path", { d: "m14 5-3 3-3-3 3-3 3 3Z", key: "1uemms" }],
  ["path", { d: "M9.5 6.5 4 12l3 6", key: "1bx08v" }],
  ["path", { d: "M3 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H3Z", key: "wap775" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LampFloor = createLucideIcon("LampFloor", [
  ["path", { d: "M9 2h6l3 7H6l3-7Z", key: "wcx6mj" }],
  ["path", { d: "M12 9v13", key: "3n1su1" }],
  ["path", { d: "M9 22h6", key: "1rlq3v" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LampWallDown = createLucideIcon("LampWallDown", [
  ["path", { d: "M11 13h6l3 7H8l3-7Z", key: "9n3qlo" }],
  ["path", { d: "M14 13V8a2 2 0 0 0-2-2H8", key: "1hu4hb" }],
  ["path", { d: "M4 9h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4v6Z", key: "s053bc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LampWallUp = createLucideIcon("LampWallUp", [
  ["path", { d: "M11 4h6l3 7H8l3-7Z", key: "11x1ee" }],
  ["path", { d: "M14 11v5a2 2 0 0 1-2 2H8", key: "eutp5o" }],
  ["path", { d: "M4 15h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4v-6Z", key: "1iuthr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lamp = createLucideIcon("Lamp", [
  ["path", { d: "M8 2h8l4 10H4L8 2Z", key: "9dma5w" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "M8 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H8Z", key: "mwf4oh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LandPlot = createLucideIcon("LandPlot", [
  ["path", { d: "m12 8 6-3-6-3v10", key: "mvpnpy" }],
  [
    "path",
    {
      d: "m8 11.99-5.5 3.14a1 1 0 0 0 0 1.74l8.5 4.86a2 2 0 0 0 2 0l8.5-4.86a1 1 0 0 0 0-1.74L16 12",
      key: "ek95tt"
    }
  ],
  ["path", { d: "m6.49 12.85 11.02 6.3", key: "1kt42w" }],
  ["path", { d: "M17.51 12.85 6.5 19.15", key: "v55bdg" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Landmark = createLucideIcon("Landmark", [
  ["line", { x1: "3", x2: "21", y1: "22", y2: "22", key: "j8o0r" }],
  ["line", { x1: "6", x2: "6", y1: "18", y2: "11", key: "10tf0k" }],
  ["line", { x1: "10", x2: "10", y1: "18", y2: "11", key: "54lgf6" }],
  ["line", { x1: "14", x2: "14", y1: "18", y2: "11", key: "380y" }],
  ["line", { x1: "18", x2: "18", y1: "18", y2: "11", key: "1kevvc" }],
  ["polygon", { points: "12 2 20 7 4 7", key: "jkujk7" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Languages = createLucideIcon("Languages", [
  ["path", { d: "m5 8 6 6", key: "1wu5hv" }],
  ["path", { d: "m4 14 6-6 2-3", key: "1k1g8d" }],
  ["path", { d: "M2 5h12", key: "or177f" }],
  ["path", { d: "M7 2h1", key: "1t2jsx" }],
  ["path", { d: "m22 22-5-10-5 10", key: "don7ne" }],
  ["path", { d: "M14 18h6", key: "1m8k6r" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LaptopMinimal = createLucideIcon("LaptopMinimal", [
  ["rect", { width: "18", height: "12", x: "3", y: "4", rx: "2", ry: "2", key: "1qhy41" }],
  ["line", { x1: "2", x2: "22", y1: "20", y2: "20", key: "ni3hll" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Laptop = createLucideIcon("Laptop", [
  [
    "path",
    {
      d: "M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16",
      key: "tarvll"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LassoSelect = createLucideIcon("LassoSelect", [
  ["path", { d: "M7 22a5 5 0 0 1-2-4", key: "umushi" }],
  ["path", { d: "M7 16.93c.96.43 1.96.74 2.99.91", key: "ybbtv3" }],
  [
    "path",
    {
      d: "M3.34 14A6.8 6.8 0 0 1 2 10c0-4.42 4.48-8 10-8s10 3.58 10 8a7.19 7.19 0 0 1-.33 2",
      key: "gt5e1w"
    }
  ],
  ["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", key: "bq3ynw" }],
  [
    "path",
    {
      d: "M14.33 22h-.09a.35.35 0 0 1-.24-.32v-10a.34.34 0 0 1 .33-.34c.08 0 .15.03.21.08l7.34 6a.33.33 0 0 1-.21.59h-4.49l-2.57 3.85a.35.35 0 0 1-.28.14z",
      key: "72q637"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lasso = createLucideIcon("Lasso", [
  ["path", { d: "M7 22a5 5 0 0 1-2-4", key: "umushi" }],
  [
    "path",
    {
      d: "M3.3 14A6.8 6.8 0 0 1 2 10c0-4.4 4.5-8 10-8s10 3.6 10 8-4.5 8-10 8a12 12 0 0 1-5-1",
      key: "146dds"
    }
  ],
  ["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", key: "bq3ynw" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Laugh = createLucideIcon("Laugh", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M18 13a6 6 0 0 1-6 5 6 6 0 0 1-6-5h12Z", key: "b2q4dd" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Layers2 = createLucideIcon("Layers2", [
  [
    "path",
    {
      d: "m16.02 12 5.48 3.13a1 1 0 0 1 0 1.74L13 21.74a2 2 0 0 1-2 0l-8.5-4.87a1 1 0 0 1 0-1.74L7.98 12",
      key: "1cuww1"
    }
  ],
  [
    "path",
    {
      d: "M13 13.74a2 2 0 0 1-2 0L2.5 8.87a1 1 0 0 1 0-1.74L11 2.26a2 2 0 0 1 2 0l8.5 4.87a1 1 0 0 1 0 1.74Z",
      key: "pdlvxu"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Layers3 = createLucideIcon("Layers3", [
  [
    "path",
    {
      d: "m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z",
      key: "8b97xw"
    }
  ],
  [
    "path",
    {
      d: "m6.08 9.5-3.5 1.6a1 1 0 0 0 0 1.81l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9a1 1 0 0 0 0-1.83l-3.5-1.59",
      key: "1e5n1m"
    }
  ],
  [
    "path",
    {
      d: "m6.08 14.5-3.5 1.6a1 1 0 0 0 0 1.81l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9a1 1 0 0 0 0-1.83l-3.5-1.59",
      key: "1iwflc"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Layers = createLucideIcon("Layers", [
  [
    "path",
    {
      d: "m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z",
      key: "8b97xw"
    }
  ],
  ["path", { d: "m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65", key: "dd6zsq" }],
  ["path", { d: "m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65", key: "ep9fru" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LayoutDashboard = createLucideIcon("LayoutDashboard", [
  ["rect", { width: "7", height: "9", x: "3", y: "3", rx: "1", key: "10lvy0" }],
  ["rect", { width: "7", height: "5", x: "14", y: "3", rx: "1", key: "16une8" }],
  ["rect", { width: "7", height: "9", x: "14", y: "12", rx: "1", key: "1hutg5" }],
  ["rect", { width: "7", height: "5", x: "3", y: "16", rx: "1", key: "ldoo1y" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LayoutGrid = createLucideIcon("LayoutGrid", [
  ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LayoutList = createLucideIcon("LayoutList", [
  ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }],
  ["path", { d: "M14 4h7", key: "3xa0d5" }],
  ["path", { d: "M14 9h7", key: "1icrd9" }],
  ["path", { d: "M14 15h7", key: "1mj8o2" }],
  ["path", { d: "M14 20h7", key: "11slyb" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LayoutPanelLeft = createLucideIcon("LayoutPanelLeft", [
  ["rect", { width: "7", height: "18", x: "3", y: "3", rx: "1", key: "2obqm" }],
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LayoutPanelTop = createLucideIcon("LayoutPanelTop", [
  ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LayoutTemplate = createLucideIcon("LayoutTemplate", [
  ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }],
  ["rect", { width: "9", height: "7", x: "3", y: "14", rx: "1", key: "jqznyg" }],
  ["rect", { width: "5", height: "7", x: "16", y: "14", rx: "1", key: "q5h2i8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Leaf = createLucideIcon("Leaf", [
  [
    "path",
    {
      d: "M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z",
      key: "nnexq3"
    }
  ],
  ["path", { d: "M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12", key: "mt58a7" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LeafyGreen = createLucideIcon("LeafyGreen", [
  [
    "path",
    {
      d: "M2 22c1.25-.987 2.27-1.975 3.9-2.2a5.56 5.56 0 0 1 3.8 1.5 4 4 0 0 0 6.187-2.353 3.5 3.5 0 0 0 3.69-5.116A3.5 3.5 0 0 0 20.95 8 3.5 3.5 0 1 0 16 3.05a3.5 3.5 0 0 0-5.831 1.373 3.5 3.5 0 0 0-5.116 3.69 4 4 0 0 0-2.348 6.155C3.499 15.42 4.409 16.712 4.2 18.1 3.926 19.743 3.014 20.732 2 22",
      key: "1134nt"
    }
  ],
  ["path", { d: "M2 22 17 7", key: "1q7jp2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lectern = createLucideIcon("Lectern", [
  [
    "path",
    {
      d: "M16 12h3a2 2 0 0 0 1.902-1.38l1.056-3.333A1 1 0 0 0 21 6H3a1 1 0 0 0-.958 1.287l1.056 3.334A2 2 0 0 0 5 12h3",
      key: "13jjxg"
    }
  ],
  ["path", { d: "M18 6V3a1 1 0 0 0-1-1h-3", key: "1550fe" }],
  ["rect", { width: "8", height: "12", x: "8", y: "10", rx: "1", key: "qmu8b6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LetterText = createLucideIcon("LetterText", [
  ["path", { d: "M15 12h6", key: "upa0zy" }],
  ["path", { d: "M15 6h6", key: "1jlkvy" }],
  ["path", { d: "m3 13 3.553-7.724a.5.5 0 0 1 .894 0L11 13", key: "blevx4" }],
  ["path", { d: "M3 18h18", key: "1h113x" }],
  ["path", { d: "M4 11h6", key: "olkgv1" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LibraryBig = createLucideIcon("LibraryBig", [
  ["rect", { width: "8", height: "18", x: "3", y: "3", rx: "1", key: "oynpb5" }],
  ["path", { d: "M7 3v18", key: "bbkbws" }],
  [
    "path",
    {
      d: "M20.4 18.9c.2.5-.1 1.1-.6 1.3l-1.9.7c-.5.2-1.1-.1-1.3-.6L11.1 5.1c-.2-.5.1-1.1.6-1.3l1.9-.7c.5-.2 1.1.1 1.3.6Z",
      key: "1qboyk"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Library = createLucideIcon("Library", [
  ["path", { d: "m16 6 4 14", key: "ji33uf" }],
  ["path", { d: "M12 6v14", key: "1n7gus" }],
  ["path", { d: "M8 8v12", key: "1gg7y9" }],
  ["path", { d: "M4 4v16", key: "6qkkli" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LifeBuoy = createLucideIcon("LifeBuoy", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m4.93 4.93 4.24 4.24", key: "1ymg45" }],
  ["path", { d: "m14.83 9.17 4.24-4.24", key: "1cb5xl" }],
  ["path", { d: "m14.83 14.83 4.24 4.24", key: "q42g0n" }],
  ["path", { d: "m9.17 14.83-4.24 4.24", key: "bqpfvv" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ligature = createLucideIcon("Ligature", [
  ["path", { d: "M8 20V8c0-2.2 1.8-4 4-4 1.5 0 2.8.8 3.5 2", key: "1rtphz" }],
  ["path", { d: "M6 12h4", key: "a4o3ry" }],
  ["path", { d: "M14 12h2v8", key: "c1fccl" }],
  ["path", { d: "M6 20h4", key: "1i6q5t" }],
  ["path", { d: "M14 20h4", key: "lzx1xo" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LightbulbOff = createLucideIcon("LightbulbOff", [
  ["path", { d: "M16.8 11.2c.8-.9 1.2-2 1.2-3.2a6 6 0 0 0-9.3-5", key: "1fkcox" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M6.3 6.3a4.67 4.67 0 0 0 1.2 5.2c.7.7 1.3 1.5 1.5 2.5", key: "10m8kw" }],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["path", { d: "M10 22h4", key: "ceow96" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lightbulb = createLucideIcon("Lightbulb", [
  [
    "path",
    {
      d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
      key: "1gvzjb"
    }
  ],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["path", { d: "M10 22h4", key: "ceow96" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Link2Off = createLucideIcon("Link2Off", [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7", key: "10o201" }],
  ["path", { d: "M15 7h2a5 5 0 0 1 4 8", key: "1d3206" }],
  ["line", { x1: "8", x2: "12", y1: "12", y2: "12", key: "rvw6j4" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Link2 = createLucideIcon("Link2", [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7h2", key: "8i5ue5" }],
  ["path", { d: "M15 7h2a5 5 0 1 1 0 10h-2", key: "1b9ql8" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Link = createLucideIcon("Link", [
  ["path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71", key: "1cjeqo" }],
  ["path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71", key: "19qd67" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Linkedin = createLucideIcon("Linkedin", [
  [
    "path",
    {
      d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z",
      key: "c2jq9f"
    }
  ],
  ["rect", { width: "4", height: "12", x: "2", y: "9", key: "mk3on5" }],
  ["circle", { cx: "4", cy: "4", r: "2", key: "bt5ra8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ListCheck = createLucideIcon("ListCheck", [
  ["path", { d: "M11 18H3", key: "n3j2dh" }],
  ["path", { d: "m15 18 2 2 4-4", key: "1szwhi" }],
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ListChecks = createLucideIcon("ListChecks", [
  ["path", { d: "m3 17 2 2 4-4", key: "1jhpwq" }],
  ["path", { d: "m3 7 2 2 4-4", key: "1obspn" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ListCollapse = createLucideIcon("ListCollapse", [
  ["path", { d: "m3 10 2.5-2.5L3 5", key: "i6eama" }],
  ["path", { d: "m3 19 2.5-2.5L3 14", key: "w2gmor" }],
  ["path", { d: "M10 6h11", key: "c7qv1k" }],
  ["path", { d: "M10 12h11", key: "6m4ad9" }],
  ["path", { d: "M10 18h11", key: "11hvi2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ListEnd = createLucideIcon("ListEnd", [
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M10 18H3", key: "13769t" }],
  ["path", { d: "M21 6v10a2 2 0 0 1-2 2h-5", key: "ilrcs8" }],
  ["path", { d: "m16 16-2 2 2 2", key: "kkc6pm" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ListFilter = createLucideIcon("ListFilter", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ListMinus = createLucideIcon("ListMinus", [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M21 12h-6", key: "bt1uis" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ListMusic = createLucideIcon("ListMusic", [
  ["path", { d: "M21 15V6", key: "h1cx4g" }],
  ["path", { d: "M18.5 18a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z", key: "8saifv" }],
  ["path", { d: "M12 12H3", key: "18klou" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M12 18H3", key: "11ftsu" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ListOrdered = createLucideIcon("ListOrdered", [
  ["path", { d: "M10 12h11", key: "6m4ad9" }],
  ["path", { d: "M10 18h11", key: "11hvi2" }],
  ["path", { d: "M10 6h11", key: "c7qv1k" }],
  ["path", { d: "M4 10h2", key: "16xx2s" }],
  ["path", { d: "M4 6h1v4", key: "cnovpq" }],
  ["path", { d: "M6 18H4c0-1 2-2 2-3s-1-1.5-2-1", key: "m9a95d" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ListPlus = createLucideIcon("ListPlus", [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M18 9v6", key: "1twb98" }],
  ["path", { d: "M21 12h-6", key: "bt1uis" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ListRestart = createLucideIcon("ListRestart", [
  ["path", { d: "M21 6H3", key: "1jwq7v" }],
  ["path", { d: "M7 12H3", key: "13ou7f" }],
  ["path", { d: "M7 18H3", key: "1sijw9" }],
  [
    "path",
    {
      d: "M12 18a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L11 14",
      key: "qth677"
    }
  ],
  ["path", { d: "M11 10v4h4", key: "172dkj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ListStart = createLucideIcon("ListStart", [
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M10 6H3", key: "lf8lx7" }],
  ["path", { d: "M21 18V8a2 2 0 0 0-2-2h-5", key: "1hghli" }],
  ["path", { d: "m16 8-2-2 2-2", key: "160uvd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ListTodo = createLucideIcon("ListTodo", [
  ["rect", { x: "3", y: "5", width: "6", height: "6", rx: "1", key: "1defrl" }],
  ["path", { d: "m3 17 2 2 4-4", key: "1jhpwq" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ListTree = createLucideIcon("ListTree", [
  ["path", { d: "M21 12h-8", key: "1bmf0i" }],
  ["path", { d: "M21 6H8", key: "1pqkrb" }],
  ["path", { d: "M21 18h-8", key: "1tm79t" }],
  ["path", { d: "M3 6v4c0 1.1.9 2 2 2h3", key: "1ywdgy" }],
  ["path", { d: "M3 10v6c0 1.1.9 2 2 2h3", key: "2wc746" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ListVideo = createLucideIcon("ListVideo", [
  ["path", { d: "M12 12H3", key: "18klou" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M12 18H3", key: "11ftsu" }],
  ["path", { d: "m16 12 5 3-5 3v-6Z", key: "zpskkp" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ListX = createLucideIcon("ListX", [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "m19 10-4 4", key: "1tz659" }],
  ["path", { d: "m15 10 4 4", key: "1n7nei" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const List = createLucideIcon("List", [
  ["path", { d: "M3 12h.01", key: "nlz23k" }],
  ["path", { d: "M3 18h.01", key: "1tta3j" }],
  ["path", { d: "M3 6h.01", key: "1rqtza" }],
  ["path", { d: "M8 12h13", key: "1za7za" }],
  ["path", { d: "M8 18h13", key: "1lx6n3" }],
  ["path", { d: "M8 6h13", key: "ik3vkj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LoaderCircle = createLucideIcon("LoaderCircle", [
  ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LoaderPinwheel = createLucideIcon("LoaderPinwheel", [
  ["path", { d: "M22 12a1 1 0 0 1-10 0 1 1 0 0 0-10 0", key: "1lzz15" }],
  ["path", { d: "M7 20.7a1 1 0 1 1 5-8.7 1 1 0 1 0 5-8.6", key: "1gnrpi" }],
  ["path", { d: "M7 3.3a1 1 0 1 1 5 8.6 1 1 0 1 0 5 8.6", key: "u9yy5q" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Loader = createLucideIcon("Loader", [
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m16.2 7.8 2.9-2.9", key: "r700ao" }],
  ["path", { d: "M18 12h4", key: "wj9ykh" }],
  ["path", { d: "m16.2 16.2 2.9 2.9", key: "1bxg5t" }],
  ["path", { d: "M12 18v4", key: "jadmvz" }],
  ["path", { d: "m4.9 19.1 2.9-2.9", key: "bwix9q" }],
  ["path", { d: "M2 12h4", key: "j09sii" }],
  ["path", { d: "m4.9 4.9 2.9 2.9", key: "giyufr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LocateFixed = createLucideIcon("LocateFixed", [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  ["circle", { cx: "12", cy: "12", r: "7", key: "fim9np" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LocateOff = createLucideIcon("LocateOff", [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  [
    "path",
    {
      d: "M7.11 7.11C5.83 8.39 5 10.1 5 12c0 3.87 3.13 7 7 7 1.9 0 3.61-.83 4.89-2.11",
      key: "1oh7ia"
    }
  ],
  [
    "path",
    {
      d: "M18.71 13.96c.19-.63.29-1.29.29-1.96 0-3.87-3.13-7-7-7-.67 0-1.33.1-1.96.29",
      key: "3qdecy"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Locate = createLucideIcon("Locate", [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  ["circle", { cx: "12", cy: "12", r: "7", key: "fim9np" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LockKeyholeOpen = createLucideIcon("LockKeyholeOpen", [
  ["circle", { cx: "12", cy: "16", r: "1", key: "1au0dj" }],
  ["rect", { width: "18", height: "12", x: "3", y: "10", rx: "2", key: "l0tzu3" }],
  ["path", { d: "M7 10V7a5 5 0 0 1 9.33-2.5", key: "car5b7" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LockKeyhole = createLucideIcon("LockKeyhole", [
  ["circle", { cx: "12", cy: "16", r: "1", key: "1au0dj" }],
  ["rect", { x: "3", y: "10", width: "18", height: "12", rx: "2", key: "6s8ecr" }],
  ["path", { d: "M7 10V7a5 5 0 0 1 10 0v3", key: "1pqi11" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LockOpen = createLucideIcon("LockOpen", [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 9.9-1", key: "1mm8w8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lock = createLucideIcon("Lock", [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LogIn = createLucideIcon("LogIn", [
  ["path", { d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4", key: "u53s6r" }],
  ["polyline", { points: "10 17 15 12 10 7", key: "1ail0h" }],
  ["line", { x1: "15", x2: "3", y1: "12", y2: "12", key: "v6grx8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LogOut = createLucideIcon("LogOut", [
  ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }],
  ["polyline", { points: "16 17 21 12 16 7", key: "1gabdz" }],
  ["line", { x1: "21", x2: "9", y1: "12", y2: "12", key: "1uyos4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Logs = createLucideIcon("Logs", [
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M3 12h1", key: "lp3yf2" }],
  ["path", { d: "M3 18h1", key: "1eiwyy" }],
  ["path", { d: "M3 6h1", key: "rgxa97" }],
  ["path", { d: "M8 12h1", key: "1con00" }],
  ["path", { d: "M8 18h1", key: "13wk12" }],
  ["path", { d: "M8 6h1", key: "tn6mkg" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lollipop = createLucideIcon("Lollipop", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }],
  ["path", { d: "M11 11a2 2 0 0 0 4 0 4 4 0 0 0-8 0 6 6 0 0 0 12 0", key: "107gwy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Luggage = createLucideIcon("Luggage", [
  [
    "path",
    { d: "M6 20a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2", key: "1m57jg" }
  ],
  ["path", { d: "M8 18V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v14", key: "1l99gc" }],
  ["path", { d: "M10 20h4", key: "ni2waw" }],
  ["circle", { cx: "16", cy: "20", r: "2", key: "1vifvg" }],
  ["circle", { cx: "8", cy: "20", r: "2", key: "ckkr5m" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Magnet = createLucideIcon("Magnet", [
  [
    "path",
    {
      d: "m6 15-4-4 6.75-6.77a7.79 7.79 0 0 1 11 11L13 22l-4-4 6.39-6.36a2.14 2.14 0 0 0-3-3L6 15",
      key: "1i3lhw"
    }
  ],
  ["path", { d: "m5 8 4 4", key: "j6kj7e" }],
  ["path", { d: "m12 15 4 4", key: "lnac28" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MailCheck = createLucideIcon("MailCheck", [
  ["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8", key: "12jkf8" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MailMinus = createLucideIcon("MailMinus", [
  ["path", { d: "M22 15V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8", key: "fuxbkv" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MailOpen = createLucideIcon("MailOpen", [
  [
    "path",
    {
      d: "M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z",
      key: "1jhwl8"
    }
  ],
  ["path", { d: "m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10", key: "1qfld7" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MailPlus = createLucideIcon("MailPlus", [
  ["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8", key: "12jkf8" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MailQuestion = createLucideIcon("MailQuestion", [
  ["path", { d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5", key: "e61zoh" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  [
    "path",
    {
      d: "M18 15.28c.2-.4.5-.8.9-1a2.1 2.1 0 0 1 2.6.4c.3.4.5.8.5 1.3 0 1.3-2 2-2 2",
      key: "7z9rxb"
    }
  ],
  ["path", { d: "M20 22v.01", key: "12bgn6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MailSearch = createLucideIcon("MailSearch", [
  ["path", { d: "M22 12.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h7.5", key: "w80f2v" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M18 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z", key: "8lzu5m" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m22 22-1.5-1.5", key: "1x83k4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MailWarning = createLucideIcon("MailWarning", [
  ["path", { d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5", key: "e61zoh" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M20 14v4", key: "1hm744" }],
  ["path", { d: "M20 22v.01", key: "12bgn6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MailX = createLucideIcon("MailX", [
  ["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h9", key: "1j9vog" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "m17 17 4 4", key: "1b3523" }],
  ["path", { d: "m21 17-4 4", key: "uinynz" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mail = createLucideIcon("Mail", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mailbox = createLucideIcon("Mailbox", [
  [
    "path",
    {
      d: "M22 17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.5C2 7 4 5 6.5 5H18c2.2 0 4 1.8 4 4v8Z",
      key: "1lbycx"
    }
  ],
  ["polyline", { points: "15,9 18,9 18,11", key: "1pm9c0" }],
  ["path", { d: "M6.5 5C9 5 11 7 11 9.5V17a2 2 0 0 1-2 2", key: "15i455" }],
  ["line", { x1: "6", x2: "7", y1: "10", y2: "10", key: "1e2scm" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mails = createLucideIcon("Mails", [
  ["rect", { width: "16", height: "13", x: "6", y: "4", rx: "2", key: "1drq3f" }],
  ["path", { d: "m22 7-7.1 3.78c-.57.3-1.23.3-1.8 0L6 7", key: "xn252p" }],
  ["path", { d: "M2 8v11c0 1.1.9 2 2 2h14", key: "n13cji" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MapPinCheckInside = createLucideIcon("MapPinCheckInside", [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MapPinCheck = createLucideIcon("MapPinCheck", [
  [
    "path",
    {
      d: "M19.43 12.935c.357-.967.57-1.955.57-2.935a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32.197 32.197 0 0 0 .813-.728",
      key: "1dq61d"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "m16 18 2 2 4-4", key: "1mkfmb" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MapPinHouse = createLucideIcon("MapPinHouse", [
  [
    "path",
    {
      d: "M15 22a1 1 0 0 1-1-1v-4a1 1 0 0 1 .445-.832l3-2a1 1 0 0 1 1.11 0l3 2A1 1 0 0 1 22 17v4a1 1 0 0 1-1 1z",
      key: "1p1rcz"
    }
  ],
  [
    "path",
    {
      d: "M18 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 .601.2",
      key: "mcbcs9"
    }
  ],
  ["path", { d: "M18 22v-3", key: "1t1ugv" }],
  ["circle", { cx: "10", cy: "10", r: "3", key: "1ns7v1" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MapPinMinusInside = createLucideIcon("MapPinMinusInside", [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MapPinMinus = createLucideIcon("MapPinMinus", [
  [
    "path",
    {
      d: "M18.977 14C19.6 12.701 20 11.343 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738",
      key: "11uxia"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M16 18h6", key: "987eiv" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MapPinOff = createLucideIcon("MapPinOff", [
  ["path", { d: "M12.75 7.09a3 3 0 0 1 2.16 2.16", key: "1d4wjd" }],
  [
    "path",
    {
      d: "M17.072 17.072c-1.634 2.17-3.527 3.912-4.471 4.727a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 1.432-4.568",
      key: "12yil7"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M8.475 2.818A8 8 0 0 1 20 10c0 1.183-.31 2.377-.81 3.533", key: "lhrkcz" }],
  ["path", { d: "M9.13 9.13a3 3 0 0 0 3.74 3.74", key: "13wojd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MapPinPlusInside = createLucideIcon("MapPinPlusInside", [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MapPinPlus = createLucideIcon("MapPinPlus", [
  [
    "path",
    {
      d: "M19.914 11.105A7.298 7.298 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738",
      key: "fcdtly"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M16 18h6", key: "987eiv" }],
  ["path", { d: "M19 15v6", key: "10aioa" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MapPinXInside = createLucideIcon("MapPinXInside", [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
  ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MapPinX = createLucideIcon("MapPinX", [
  [
    "path",
    {
      d: "M19.752 11.901A7.78 7.78 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 19 19 0 0 0 .09-.077",
      key: "y0ewhp"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "m21.5 15.5-5 5", key: "11iqnx" }],
  ["path", { d: "m21.5 20.5-5-5", key: "1bylgx" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MapPin = createLucideIcon("MapPin", [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MapPinned = createLucideIcon("MapPinned", [
  [
    "path",
    {
      d: "M18 8c0 3.613-3.869 7.429-5.393 8.795a1 1 0 0 1-1.214 0C9.87 15.429 6 11.613 6 8a6 6 0 0 1 12 0",
      key: "11u0oz"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  [
    "path",
    {
      d: "M8.714 14h-3.71a1 1 0 0 0-.948.683l-2.004 6A1 1 0 0 0 3 22h18a1 1 0 0 0 .948-1.316l-2-6a1 1 0 0 0-.949-.684h-3.712",
      key: "q8zwxj"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Map$1 = createLucideIcon("Map", [
  [
    "path",
    {
      d: "M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z",
      key: "169xi5"
    }
  ],
  ["path", { d: "M15 5.764v15", key: "1pn4in" }],
  ["path", { d: "M9 3.236v15", key: "1uimfh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Martini = createLucideIcon("Martini", [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M12 11v11", key: "ur9y6a" }],
  ["path", { d: "m19 3-7 8-7-8Z", key: "1sgpiw" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Maximize2 = createLucideIcon("Maximize2", [
  ["polyline", { points: "15 3 21 3 21 9", key: "mznyad" }],
  ["polyline", { points: "9 21 3 21 3 15", key: "1avn1i" }],
  ["line", { x1: "21", x2: "14", y1: "3", y2: "10", key: "ota7mn" }],
  ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Maximize = createLucideIcon("Maximize", [
  ["path", { d: "M8 3H5a2 2 0 0 0-2 2v3", key: "1dcmit" }],
  ["path", { d: "M21 8V5a2 2 0 0 0-2-2h-3", key: "1e4gt3" }],
  ["path", { d: "M3 16v3a2 2 0 0 0 2 2h3", key: "wsl5sc" }],
  ["path", { d: "M16 21h3a2 2 0 0 0 2-2v-3", key: "18trek" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Medal = createLucideIcon("Medal", [
  [
    "path",
    {
      d: "M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15",
      key: "143lza"
    }
  ],
  ["path", { d: "M11 12 5.12 2.2", key: "qhuxz6" }],
  ["path", { d: "m13 12 5.88-9.8", key: "hbye0f" }],
  ["path", { d: "M8 7h8", key: "i86dvs" }],
  ["circle", { cx: "12", cy: "17", r: "5", key: "qbz8iq" }],
  ["path", { d: "M12 18v-2h-.5", key: "fawc4q" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MegaphoneOff = createLucideIcon("MegaphoneOff", [
  ["path", { d: "M9.26 9.26 3 11v3l14.14 3.14", key: "3429n" }],
  ["path", { d: "M21 15.34V6l-7.31 2.03", key: "4o1dh8" }],
  ["path", { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6", key: "1yl0tm" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Megaphone = createLucideIcon("Megaphone", [
  ["path", { d: "m3 11 18-5v12L3 14v-3z", key: "n962bs" }],
  ["path", { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6", key: "1yl0tm" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Meh = createLucideIcon("Meh", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "8", x2: "16", y1: "15", y2: "15", key: "1xb1d9" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MemoryStick = createLucideIcon("MemoryStick", [
  ["path", { d: "M6 19v-3", key: "1nvgqn" }],
  ["path", { d: "M10 19v-3", key: "iu8nkm" }],
  ["path", { d: "M14 19v-3", key: "kcehxu" }],
  ["path", { d: "M18 19v-3", key: "1vh91z" }],
  ["path", { d: "M8 11V9", key: "63erz4" }],
  ["path", { d: "M16 11V9", key: "fru6f3" }],
  ["path", { d: "M12 11V9", key: "ha00sb" }],
  ["path", { d: "M2 15h20", key: "16ne18" }],
  [
    "path",
    {
      d: "M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1.1a2 2 0 0 0 0 3.837V17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5.1a2 2 0 0 0 0-3.837Z",
      key: "lhddv3"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Menu = createLucideIcon("Menu", [
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }],
  ["line", { x1: "4", x2: "20", y1: "6", y2: "6", key: "1owob3" }],
  ["line", { x1: "4", x2: "20", y1: "18", y2: "18", key: "yk5zj1" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Merge = createLucideIcon("Merge", [
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }],
  ["path", { d: "M12 2v10.3a4 4 0 0 1-1.172 2.872L4 22", key: "1hyw0i" }],
  ["path", { d: "m20 22-5-5", key: "1m27yz" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageCircleCode = createLucideIcon("MessageCircleCode", [
  ["path", { d: "M10 9.5 8 12l2 2.5", key: "3mjy60" }],
  ["path", { d: "m14 9.5 2 2.5-2 2.5", key: "1bir2l" }],
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22z", key: "k85zhp" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageCircleDashed = createLucideIcon("MessageCircleDashed", [
  ["path", { d: "M13.5 3.1c-.5 0-1-.1-1.5-.1s-1 .1-1.5.1", key: "16ll65" }],
  ["path", { d: "M19.3 6.8a10.45 10.45 0 0 0-2.1-2.1", key: "1nq77a" }],
  ["path", { d: "M20.9 13.5c.1-.5.1-1 .1-1.5s-.1-1-.1-1.5", key: "1sf7wn" }],
  ["path", { d: "M17.2 19.3a10.45 10.45 0 0 0 2.1-2.1", key: "x1hs5g" }],
  ["path", { d: "M10.5 20.9c.5.1 1 .1 1.5.1s1-.1 1.5-.1", key: "19m18z" }],
  ["path", { d: "M3.5 17.5 2 22l4.5-1.5", key: "1f36qi" }],
  ["path", { d: "M3.1 10.5c0 .5-.1 1-.1 1.5s.1 1 .1 1.5", key: "1vz3ju" }],
  ["path", { d: "M6.8 4.7a10.45 10.45 0 0 0-2.1 2.1", key: "19f9do" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageCircleHeart = createLucideIcon("MessageCircleHeart", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  [
    "path",
    {
      d: "M15.8 9.2a2.5 2.5 0 0 0-3.5 0l-.3.4-.35-.3a2.42 2.42 0 1 0-3.2 3.6l3.6 3.5 3.6-3.5c1.2-1.2 1.1-2.7.2-3.7",
      key: "43lnbm"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageCircleMore = createLucideIcon("MessageCircleMore", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageCircleOff = createLucideIcon("MessageCircleOff", [
  ["path", { d: "M20.5 14.9A9 9 0 0 0 9.1 3.5", key: "1iebmn" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M5.6 5.6C3 8.3 2.2 12.5 4 16l-2 6 6-2c3.4 1.8 7.6 1.1 10.3-1.7", key: "1ov8ce" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageCirclePlus = createLucideIcon("MessageCirclePlus", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageCircleQuestion = createLucideIcon("MessageCircleQuestion", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageCircleReply = createLucideIcon("MessageCircleReply", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "m10 15-3-3 3-3", key: "1pgupc" }],
  ["path", { d: "M7 12h7a2 2 0 0 1 2 2v1", key: "1gheu4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageCircleWarning = createLucideIcon("MessageCircleWarning", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  ["path", { d: "M12 16h.01", key: "1drbdi" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageCircleX = createLucideIcon("MessageCircleX", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageCircle = createLucideIcon("MessageCircle", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageSquareCode = createLucideIcon("MessageSquareCode", [
  ["path", { d: "M10 7.5 8 10l2 2.5", key: "xb17xw" }],
  ["path", { d: "m14 7.5 2 2.5-2 2.5", key: "5rap1v" }],
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageSquareDashed = createLucideIcon("MessageSquareDashed", [
  ["path", { d: "M10 17H7l-4 4v-7", key: "1r71xu" }],
  ["path", { d: "M14 17h1", key: "nufu4t" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 14v1a2 2 0 0 1-2 2", key: "29akq3" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M9 3h1", key: "1yesri" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageSquareDiff = createLucideIcon("MessageSquareDiff", [
  ["path", { d: "m5 19-2 2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2", key: "1xuzuj" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }],
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageSquareDot = createLucideIcon("MessageSquareDot", [
  ["path", { d: "M11.7 3H5a2 2 0 0 0-2 2v16l4-4h12a2 2 0 0 0 2-2v-2.7", key: "uodpkb" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageSquareHeart = createLucideIcon("MessageSquareHeart", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  [
    "path",
    {
      d: "M14.8 7.5a1.84 1.84 0 0 0-2.6 0l-.2.3-.3-.3a1.84 1.84 0 1 0-2.4 2.8L12 13l2.7-2.7c.9-.9.8-2.1.1-2.8",
      key: "1blaws"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageSquareLock = createLucideIcon("MessageSquareLock", [
  ["path", { d: "M19 15v-2a2 2 0 1 0-4 0v2", key: "h3d1vz" }],
  ["path", { d: "M9 17H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3.5", key: "xsnnhn" }],
  ["rect", { x: "13", y: "15", width: "8", height: "5", rx: "1", key: "1ccwuk" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageSquareMore = createLucideIcon("MessageSquareMore", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageSquareOff = createLucideIcon("MessageSquareOff", [
  ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M3.6 3.6c-.4.3-.6.8-.6 1.4v16l4-4h10", key: "pwpm4a" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageSquarePlus = createLucideIcon("MessageSquarePlus", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageSquareQuote = createLucideIcon("MessageSquareQuote", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M8 12a2 2 0 0 0 2-2V8H8", key: "1jfesj" }],
  ["path", { d: "M14 12a2 2 0 0 0 2-2V8h-2", key: "1dq9mh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageSquareReply = createLucideIcon("MessageSquareReply", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "m10 7-3 3 3 3", key: "1eugdv" }],
  ["path", { d: "M17 13v-1a2 2 0 0 0-2-2H7", key: "ernfh3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageSquareShare = createLucideIcon("MessageSquareShare", [
  ["path", { d: "M21 12v3a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h7", key: "tqtdkg" }],
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "m16 8 5-5", key: "15mbrl" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageSquareText = createLucideIcon("MessageSquareText", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M13 8H7", key: "14i4kc" }],
  ["path", { d: "M17 12H7", key: "16if0g" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageSquareWarning = createLucideIcon("MessageSquareWarning", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M12 7v2", key: "stiyo7" }],
  ["path", { d: "M12 13h.01", key: "y0uutt" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageSquareX = createLucideIcon("MessageSquareX", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
  ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessageSquare = createLucideIcon("MessageSquare", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MessagesSquare = createLucideIcon("MessagesSquare", [
  ["path", { d: "M14 9a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z", key: "p1xzt8" }],
  ["path", { d: "M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1", key: "1cx29u" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MicOff = createLucideIcon("MicOff", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M18.89 13.23A7.12 7.12 0 0 0 19 12v-2", key: "80xlxr" }],
  ["path", { d: "M5 10v2a7 7 0 0 0 12 5", key: "p2k8kg" }],
  ["path", { d: "M15 9.34V5a3 3 0 0 0-5.68-1.33", key: "1gzdoj" }],
  ["path", { d: "M9 9v3a3 3 0 0 0 5.12 2.12", key: "r2i35w" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MicVocal = createLucideIcon("MicVocal", [
  [
    "path",
    {
      d: "m11 7.601-5.994 8.19a1 1 0 0 0 .1 1.298l.817.818a1 1 0 0 0 1.314.087L15.09 12",
      key: "80a601"
    }
  ],
  [
    "path",
    {
      d: "M16.5 21.174C15.5 20.5 14.372 20 13 20c-2.058 0-3.928 2.356-6 2-2.072-.356-2.775-3.369-1.5-4.5",
      key: "j0ngtp"
    }
  ],
  ["circle", { cx: "16", cy: "7", r: "5", key: "d08jfb" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mic = createLucideIcon("Mic", [
  ["path", { d: "M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z", key: "131961" }],
  ["path", { d: "M19 10v2a7 7 0 0 1-14 0v-2", key: "1vc78b" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Microchip = createLucideIcon("Microchip", [
  ["path", { d: "M18 12h2", key: "quuxs7" }],
  ["path", { d: "M18 16h2", key: "zsn3lv" }],
  ["path", { d: "M18 20h2", key: "9x5y9y" }],
  ["path", { d: "M18 4h2", key: "1luxfb" }],
  ["path", { d: "M18 8h2", key: "nxqzg" }],
  ["path", { d: "M4 12h2", key: "1ltxp0" }],
  ["path", { d: "M4 16h2", key: "8a5zha" }],
  ["path", { d: "M4 20h2", key: "27dk57" }],
  ["path", { d: "M4 4h2", key: "10groj" }],
  ["path", { d: "M4 8h2", key: "18vq6w" }],
  [
    "path",
    {
      d: "M8 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-1.5c-.276 0-.494.227-.562.495a2 2 0 0 1-3.876 0C9.994 2.227 9.776 2 9.5 2z",
      key: "1681fp"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Microscope = createLucideIcon("Microscope", [
  ["path", { d: "M6 18h8", key: "1borvv" }],
  ["path", { d: "M3 22h18", key: "8prr45" }],
  ["path", { d: "M14 22a7 7 0 1 0 0-14h-1", key: "1jwaiy" }],
  ["path", { d: "M9 14h2", key: "197e7h" }],
  ["path", { d: "M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2Z", key: "1bmzmy" }],
  ["path", { d: "M12 6V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3", key: "1drr47" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Microwave = createLucideIcon("Microwave", [
  ["rect", { width: "20", height: "15", x: "2", y: "4", rx: "2", key: "2no95f" }],
  ["rect", { width: "8", height: "7", x: "6", y: "8", rx: "1", key: "zh9wx" }],
  ["path", { d: "M18 8v7", key: "o5zi4n" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["path", { d: "M18 19v2", key: "1dawf0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Milestone = createLucideIcon("Milestone", [
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M12 3v3", key: "1n5kay" }],
  [
    "path",
    {
      d: "M4 6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h13a2 2 0 0 0 1.152-.365l3.424-2.317a1 1 0 0 0 0-1.635l-3.424-2.318A2 2 0 0 0 17 6z",
      key: "1btarq"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MilkOff = createLucideIcon("MilkOff", [
  ["path", { d: "M8 2h8", key: "1ssgc1" }],
  [
    "path",
    {
      d: "M9 2v1.343M15 2v2.789a4 4 0 0 0 .672 2.219l.656.984a4 4 0 0 1 .672 2.22v1.131M7.8 7.8l-.128.192A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-3",
      key: "y0ejgx"
    }
  ],
  ["path", { d: "M7 15a6.47 6.47 0 0 1 5 0 6.472 6.472 0 0 0 3.435.435", key: "iaxqsy" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Milk = createLucideIcon("Milk", [
  ["path", { d: "M8 2h8", key: "1ssgc1" }],
  [
    "path",
    {
      d: "M9 2v2.789a4 4 0 0 1-.672 2.219l-.656.984A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-9.789a4 4 0 0 0-.672-2.219l-.656-.984A4 4 0 0 1 15 4.788V2",
      key: "qtp12x"
    }
  ],
  ["path", { d: "M7 15a6.472 6.472 0 0 1 5 0 6.47 6.47 0 0 0 5 0", key: "ygeh44" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Minimize2 = createLucideIcon("Minimize2", [
  ["polyline", { points: "4 14 10 14 10 20", key: "11kfnr" }],
  ["polyline", { points: "20 10 14 10 14 4", key: "rlmsce" }],
  ["line", { x1: "14", x2: "21", y1: "10", y2: "3", key: "o5lafz" }],
  ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Minimize = createLucideIcon("Minimize", [
  ["path", { d: "M8 3v3a2 2 0 0 1-2 2H3", key: "hohbtr" }],
  ["path", { d: "M21 8h-3a2 2 0 0 1-2-2V3", key: "5jw1f3" }],
  ["path", { d: "M3 16h3a2 2 0 0 1 2 2v3", key: "198tvr" }],
  ["path", { d: "M16 21v-3a2 2 0 0 1 2-2h3", key: "ph8mxp" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Minus = createLucideIcon("Minus", [["path", { d: "M5 12h14", key: "1ays0h" }]]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MonitorCheck = createLucideIcon("MonitorCheck", [
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MonitorCog = createLucideIcon("MonitorCog", [
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m15.2 4.9-.9-.4", key: "12wd2u" }],
  ["path", { d: "m15.2 7.1-.9.4", key: "1r2vl7" }],
  ["path", { d: "m16.9 3.2-.4-.9", key: "3zbo91" }],
  ["path", { d: "m16.9 8.8-.4.9", key: "1qr2dn" }],
  ["path", { d: "m19.5 2.3-.4.9", key: "1rjrkq" }],
  ["path", { d: "m19.5 9.7-.4-.9", key: "heryx5" }],
  ["path", { d: "m21.7 4.5-.9.4", key: "17fqt1" }],
  ["path", { d: "m21.7 7.5-.9-.4", key: "14zyni" }],
  ["path", { d: "M22 13v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7", key: "1tnzv8" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MonitorDot = createLucideIcon("MonitorDot", [
  ["circle", { cx: "19", cy: "6", r: "3", key: "108a5v" }],
  ["path", { d: "M22 12v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9", key: "1fet9y" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MonitorDown = createLucideIcon("MonitorDown", [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "m15 10-3 3-3-3", key: "lzhmyn" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MonitorOff = createLucideIcon("MonitorOff", [
  ["path", { d: "M17 17H4a2 2 0 0 1-2-2V5c0-1.5 1-2 1-2", key: "k0q8oc" }],
  ["path", { d: "M22 15V5a2 2 0 0 0-2-2H9", key: "cp1ac0" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MonitorPause = createLucideIcon("MonitorPause", [
  ["path", { d: "M10 13V7", key: "1u13u9" }],
  ["path", { d: "M14 13V7", key: "1vj9om" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MonitorPlay = createLucideIcon("MonitorPlay", [
  [
    "path",
    {
      d: "M10 7.75a.75.75 0 0 1 1.142-.638l3.664 2.249a.75.75 0 0 1 0 1.278l-3.664 2.25a.75.75 0 0 1-1.142-.64z",
      key: "1pctta"
    }
  ],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["rect", { x: "2", y: "3", width: "20", height: "14", rx: "2", key: "x3v2xh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MonitorSmartphone = createLucideIcon("MonitorSmartphone", [
  ["path", { d: "M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8", key: "10dyio" }],
  ["path", { d: "M10 19v-3.96 3.15", key: "1irgej" }],
  ["path", { d: "M7 19h5", key: "qswx4l" }],
  ["rect", { width: "6", height: "10", x: "16", y: "12", rx: "2", key: "1egngj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MonitorSpeaker = createLucideIcon("MonitorSpeaker", [
  ["path", { d: "M5.5 20H8", key: "1k40s5" }],
  ["path", { d: "M17 9h.01", key: "1j24nn" }],
  ["rect", { width: "10", height: "16", x: "12", y: "4", rx: "2", key: "ixliua" }],
  ["path", { d: "M8 6H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4", key: "1mp6e1" }],
  ["circle", { cx: "17", cy: "15", r: "1", key: "tqvash" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MonitorStop = createLucideIcon("MonitorStop", [
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["rect", { x: "2", y: "3", width: "20", height: "14", rx: "2", key: "x3v2xh" }],
  ["rect", { x: "9", y: "7", width: "6", height: "6", rx: "1", key: "5m2oou" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MonitorUp = createLucideIcon("MonitorUp", [
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MonitorX = createLucideIcon("MonitorX", [
  ["path", { d: "m14.5 12.5-5-5", key: "1jahn5" }],
  ["path", { d: "m9.5 12.5 5-5", key: "1k2t7b" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Monitor = createLucideIcon("Monitor", [
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["line", { x1: "8", x2: "16", y1: "21", y2: "21", key: "1svkeh" }],
  ["line", { x1: "12", x2: "12", y1: "17", y2: "21", key: "vw1qmm" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MoonStar = createLucideIcon("MoonStar", [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9", key: "4ay0iu" }],
  ["path", { d: "M20 3v4", key: "1olli1" }],
  ["path", { d: "M22 5h-4", key: "1gvqau" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Moon = createLucideIcon("Moon", [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z", key: "a7tn18" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MountainSnow = createLucideIcon("MountainSnow", [
  ["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }],
  [
    "path",
    { d: "M4.14 15.08c2.62-1.57 5.24-1.43 7.86.42 2.74 1.94 5.49 2 8.23.19", key: "1pvmmp" }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mountain = createLucideIcon("Mountain", [
  ["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MouseOff = createLucideIcon("MouseOff", [
  ["path", { d: "M12 6v.343", key: "1gyhex" }],
  ["path", { d: "M18.218 18.218A7 7 0 0 1 5 15V9a7 7 0 0 1 .782-3.218", key: "ukzz01" }],
  ["path", { d: "M19 13.343V9A7 7 0 0 0 8.56 2.902", key: "104jy9" }],
  ["path", { d: "M22 22 2 2", key: "1r8tn9" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MousePointer2 = createLucideIcon("MousePointer2", [
  [
    "path",
    {
      d: "M4.037 4.688a.495.495 0 0 1 .651-.651l16 6.5a.5.5 0 0 1-.063.947l-6.124 1.58a2 2 0 0 0-1.438 1.435l-1.579 6.126a.5.5 0 0 1-.947.063z",
      key: "edeuup"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MousePointerBan = createLucideIcon("MousePointerBan", [
  [
    "path",
    {
      d: "M2.034 2.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.944L8.204 7.545a1 1 0 0 0-.66.66l-1.066 3.443a.5.5 0 0 1-.944.033z",
      key: "11pp1i"
    }
  ],
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }],
  ["path", { d: "m11.8 11.8 8.4 8.4", key: "oogvdj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MousePointerClick = createLucideIcon("MousePointerClick", [
  ["path", { d: "M14 4.1 12 6", key: "ita8i4" }],
  ["path", { d: "m5.1 8-2.9-.8", key: "1go3kf" }],
  ["path", { d: "m6 12-1.9 2", key: "mnht97" }],
  ["path", { d: "M7.2 2.2 8 5.1", key: "1cfko1" }],
  [
    "path",
    {
      d: "M9.037 9.69a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z",
      key: "s0h3yz"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MousePointer = createLucideIcon("MousePointer", [
  ["path", { d: "M12.586 12.586 19 19", key: "ea5xo7" }],
  [
    "path",
    {
      d: "M3.688 3.037a.497.497 0 0 0-.651.651l6.5 15.999a.501.501 0 0 0 .947-.062l1.569-6.083a2 2 0 0 1 1.448-1.479l6.124-1.579a.5.5 0 0 0 .063-.947z",
      key: "277e5u"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mouse = createLucideIcon("Mouse", [
  ["rect", { x: "5", y: "2", width: "14", height: "20", rx: "7", key: "11ol66" }],
  ["path", { d: "M12 6v4", key: "16clxf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Move3d = createLucideIcon("Move3d", [
  ["path", { d: "M5 3v16h16", key: "1mqmf9" }],
  ["path", { d: "m5 19 6-6", key: "jh6hbb" }],
  ["path", { d: "m2 6 3-3 3 3", key: "tkyvxa" }],
  ["path", { d: "m18 16 3 3-3 3", key: "1d4glt" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MoveDiagonal2 = createLucideIcon("MoveDiagonal2", [
  ["path", { d: "M19 13v6h-6", key: "1hxl6d" }],
  ["path", { d: "M5 11V5h6", key: "12e2xe" }],
  ["path", { d: "m5 5 14 14", key: "11anup" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MoveDiagonal = createLucideIcon("MoveDiagonal", [
  ["path", { d: "M11 19H5v-6", key: "8awifj" }],
  ["path", { d: "M13 5h6v6", key: "7voy1q" }],
  ["path", { d: "M19 5 5 19", key: "wwaj1z" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MoveDownLeft = createLucideIcon("MoveDownLeft", [
  ["path", { d: "M11 19H5V13", key: "1akmht" }],
  ["path", { d: "M19 5L5 19", key: "72u4yj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MoveDownRight = createLucideIcon("MoveDownRight", [
  ["path", { d: "M19 13V19H13", key: "10vkzq" }],
  ["path", { d: "M5 5L19 19", key: "5zm2fv" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MoveDown = createLucideIcon("MoveDown", [
  ["path", { d: "M8 18L12 22L16 18", key: "cskvfv" }],
  ["path", { d: "M12 2V22", key: "r89rzk" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MoveHorizontal = createLucideIcon("MoveHorizontal", [
  ["path", { d: "m18 8 4 4-4 4", key: "1ak13k" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "m6 8-4 4 4 4", key: "15zrgr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MoveLeft = createLucideIcon("MoveLeft", [
  ["path", { d: "M6 8L2 12L6 16", key: "kyvwex" }],
  ["path", { d: "M2 12H22", key: "1m8cig" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MoveRight = createLucideIcon("MoveRight", [
  ["path", { d: "M18 8L22 12L18 16", key: "1r0oui" }],
  ["path", { d: "M2 12H22", key: "1m8cig" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MoveUpLeft = createLucideIcon("MoveUpLeft", [
  ["path", { d: "M5 11V5H11", key: "3q78g9" }],
  ["path", { d: "M5 5L19 19", key: "5zm2fv" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MoveUpRight = createLucideIcon("MoveUpRight", [
  ["path", { d: "M13 5H19V11", key: "1n1gyv" }],
  ["path", { d: "M19 5L5 19", key: "72u4yj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MoveUp = createLucideIcon("MoveUp", [
  ["path", { d: "M8 6L12 2L16 6", key: "1yvkyx" }],
  ["path", { d: "M12 2V22", key: "r89rzk" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MoveVertical = createLucideIcon("MoveVertical", [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "m8 18 4 4 4-4", key: "bh5tu3" }],
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Move = createLucideIcon("Move", [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "m15 19-3 3-3-3", key: "11eu04" }],
  ["path", { d: "m19 9 3 3-3 3", key: "1mg7y2" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "m5 9-3 3 3 3", key: "j64kie" }],
  ["path", { d: "m9 5 3-3 3 3", key: "l8vdw6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Music2 = createLucideIcon("Music2", [
  ["circle", { cx: "8", cy: "18", r: "4", key: "1fc0mg" }],
  ["path", { d: "M12 18V2l7 4", key: "g04rme" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Music3 = createLucideIcon("Music3", [
  ["circle", { cx: "12", cy: "18", r: "4", key: "m3r9ws" }],
  ["path", { d: "M16 18V2", key: "40x2m5" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Music4 = createLucideIcon("Music4", [
  ["path", { d: "M9 18V5l12-2v13", key: "1jmyc2" }],
  ["path", { d: "m9 9 12-2", key: "1e64n2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["circle", { cx: "18", cy: "16", r: "3", key: "1hluhg" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Music = createLucideIcon("Music", [
  ["path", { d: "M9 18V5l12-2v13", key: "1jmyc2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["circle", { cx: "18", cy: "16", r: "3", key: "1hluhg" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Navigation2Off = createLucideIcon("Navigation2Off", [
  ["path", { d: "M9.31 9.31 5 21l7-4 7 4-1.17-3.17", key: "qoq2o2" }],
  ["path", { d: "M14.53 8.88 12 2l-1.17 3.17", key: "k3sjzy" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Navigation2 = createLucideIcon("Navigation2", [
  ["polygon", { points: "12 2 19 21 12 17 5 21 12 2", key: "x8c0qg" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NavigationOff = createLucideIcon("NavigationOff", [
  ["path", { d: "M8.43 8.43 3 11l8 2 2 8 2.57-5.43", key: "1vdtb7" }],
  ["path", { d: "M17.39 11.73 22 2l-9.73 4.61", key: "tya3r6" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Navigation = createLucideIcon("Navigation", [
  ["polygon", { points: "3 11 22 2 13 21 11 13 3 11", key: "1ltx0t" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Network = createLucideIcon("Network", [
  ["rect", { x: "16", y: "16", width: "6", height: "6", rx: "1", key: "4q2zg0" }],
  ["rect", { x: "2", y: "16", width: "6", height: "6", rx: "1", key: "8cvhb9" }],
  ["rect", { x: "9", y: "2", width: "6", height: "6", rx: "1", key: "1egb70" }],
  ["path", { d: "M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3", key: "1jsf9p" }],
  ["path", { d: "M12 12V8", key: "2874zd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Newspaper = createLucideIcon("Newspaper", [
  [
    "path",
    {
      d: "M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2",
      key: "7pis2x"
    }
  ],
  ["path", { d: "M18 14h-8", key: "sponae" }],
  ["path", { d: "M15 18h-5", key: "95g1m2" }],
  ["path", { d: "M10 6h8v4h-8V6Z", key: "smlsk5" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nfc = createLucideIcon("Nfc", [
  ["path", { d: "M6 8.32a7.43 7.43 0 0 1 0 7.36", key: "9iaqei" }],
  ["path", { d: "M9.46 6.21a11.76 11.76 0 0 1 0 11.58", key: "1yha7l" }],
  ["path", { d: "M12.91 4.1a15.91 15.91 0 0 1 .01 15.8", key: "4iu2gk" }],
  ["path", { d: "M16.37 2a20.16 20.16 0 0 1 0 20", key: "sap9u2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NotebookPen = createLucideIcon("NotebookPen", [
  ["path", { d: "M13.4 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.4", key: "re6nr2" }],
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  [
    "path",
    {
      d: "M21.378 5.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "pqwjuv"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NotebookTabs = createLucideIcon("NotebookTabs", [
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M15 2v20", key: "dcj49h" }],
  ["path", { d: "M15 7h5", key: "1xj5lc" }],
  ["path", { d: "M15 12h5", key: "w5shd9" }],
  ["path", { d: "M15 17h5", key: "1qaofu" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NotebookText = createLucideIcon("NotebookText", [
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M9.5 8h5", key: "11mslq" }],
  ["path", { d: "M9.5 12H16", key: "ktog6x" }],
  ["path", { d: "M9.5 16H14", key: "p1seyn" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Notebook = createLucideIcon("Notebook", [
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M16 2v20", key: "rotuqe" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NotepadTextDashed = createLucideIcon("NotepadTextDashed", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v2", key: "j91f56" }],
  ["path", { d: "M20 12v2", key: "w8o0tu" }],
  ["path", { d: "M20 18v2a2 2 0 0 1-2 2h-1", key: "1c9ggx" }],
  ["path", { d: "M13 22h-2", key: "191ugt" }],
  ["path", { d: "M7 22H6a2 2 0 0 1-2-2v-2", key: "1rt9px" }],
  ["path", { d: "M4 14v-2", key: "1v0sqh" }],
  ["path", { d: "M4 8V6a2 2 0 0 1 2-2h2", key: "1mwabg" }],
  ["path", { d: "M8 10h6", key: "3oa6kw" }],
  ["path", { d: "M8 14h8", key: "1fgep2" }],
  ["path", { d: "M8 18h5", key: "17enja" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NotepadText = createLucideIcon("NotepadText", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "16", height: "18", x: "4", y: "4", rx: "2", key: "1u9h20" }],
  ["path", { d: "M8 10h6", key: "3oa6kw" }],
  ["path", { d: "M8 14h8", key: "1fgep2" }],
  ["path", { d: "M8 18h5", key: "17enja" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NutOff = createLucideIcon("NutOff", [
  ["path", { d: "M12 4V2", key: "1k5q1u" }],
  [
    "path",
    {
      d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592a7.01 7.01 0 0 0 4.125-2.939",
      key: "1xcvy9"
    }
  ],
  ["path", { d: "M19 10v3.343", key: "163tfc" }],
  [
    "path",
    {
      d: "M12 12c-1.349-.573-1.905-1.005-2.5-2-.546.902-1.048 1.353-2.5 2-1.018-.644-1.46-1.08-2-2-1.028.71-1.69.918-3 1 1.081-1.048 1.757-2.03 2-3 .194-.776.84-1.551 1.79-2.21m11.654 5.997c.887-.457 1.28-.891 1.556-1.787 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4-.74 0-1.461.068-2.15.192",
      key: "17914v"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nut = createLucideIcon("Nut", [
  ["path", { d: "M12 4V2", key: "1k5q1u" }],
  [
    "path",
    {
      d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592A7.003 7.003 0 0 0 19 14v-4",
      key: "1tgyif"
    }
  ],
  [
    "path",
    {
      d: "M12 4C8 4 4.5 6 4 8c-.243.97-.919 1.952-2 3 1.31-.082 1.972-.29 3-1 .54.92.982 1.356 2 2 1.452-.647 1.954-1.098 2.5-2 .595.995 1.151 1.427 2.5 2 1.31-.621 1.862-1.058 2.5-2 .629.977 1.162 1.423 2.5 2 1.209-.548 1.68-.967 2-2 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4Z",
      key: "tnsqj"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OctagonAlert = createLucideIcon("OctagonAlert", [
  ["path", { d: "M12 16h.01", key: "1drbdi" }],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  [
    "path",
    {
      d: "M15.312 2a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586l-4.688-4.688A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2z",
      key: "1fd625"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OctagonMinus = createLucideIcon("OctagonMinus", [
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OctagonPause = createLucideIcon("OctagonPause", [
  ["path", { d: "M10 15V9", key: "1lckn7" }],
  ["path", { d: "M14 15V9", key: "1muqhk" }],
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OctagonX = createLucideIcon("OctagonX", [
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Octagon = createLucideIcon("Octagon", [
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Omega = createLucideIcon("Omega", [
  [
    "path",
    {
      d: "M3 20h4.5a.5.5 0 0 0 .5-.5v-.282a.52.52 0 0 0-.247-.437 8 8 0 1 1 8.494-.001.52.52 0 0 0-.247.438v.282a.5.5 0 0 0 .5.5H21",
      key: "1x94xo"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Option = createLucideIcon("Option", [
  ["path", { d: "M3 3h6l6 18h6", key: "ph9rgk" }],
  ["path", { d: "M14 3h7", key: "16f0ms" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Orbit = createLucideIcon("Orbit", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["circle", { cx: "19", cy: "5", r: "2", key: "mhkx31" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M10.4 21.9a10 10 0 0 0 9.941-15.416", key: "eohfx2" }],
  ["path", { d: "M13.5 2.1a10 10 0 0 0-9.841 15.416", key: "19pvbm" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Origami = createLucideIcon("Origami", [
  ["path", { d: "M12 12V4a1 1 0 0 1 1-1h6.297a1 1 0 0 1 .651 1.759l-4.696 4.025", key: "1bx4vc" }],
  [
    "path",
    {
      d: "m12 21-7.414-7.414A2 2 0 0 1 4 12.172V6.415a1.002 1.002 0 0 1 1.707-.707L20 20.009",
      key: "1h3km6"
    }
  ],
  [
    "path",
    {
      d: "m12.214 3.381 8.414 14.966a1 1 0 0 1-.167 1.199l-1.168 1.163a1 1 0 0 1-.706.291H6.351a1 1 0 0 1-.625-.219L3.25 18.8a1 1 0 0 1 .631-1.781l4.165.027",
      key: "1hj4wg"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Package2 = createLucideIcon("Package2", [
  ["path", { d: "M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z", key: "1ront0" }],
  ["path", { d: "m3 9 2.45-4.9A2 2 0 0 1 7.24 3h9.52a2 2 0 0 1 1.8 1.1L21 9", key: "19h2x1" }],
  ["path", { d: "M12 3v6", key: "1holv5" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PackageCheck = createLucideIcon("PackageCheck", [
  ["path", { d: "m16 16 2 2 4-4", key: "gfu2re" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PackageMinus = createLucideIcon("PackageMinus", [
  ["path", { d: "M16 16h6", key: "100bgy" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PackageOpen = createLucideIcon("PackageOpen", [
  ["path", { d: "M12 22v-9", key: "x3hkom" }],
  [
    "path",
    {
      d: "M15.17 2.21a1.67 1.67 0 0 1 1.63 0L21 4.57a1.93 1.93 0 0 1 0 3.36L8.82 14.79a1.655 1.655 0 0 1-1.64 0L3 12.43a1.93 1.93 0 0 1 0-3.36z",
      key: "2ntwy6"
    }
  ],
  [
    "path",
    {
      d: "M20 13v3.87a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13",
      key: "1pmm1c"
    }
  ],
  [
    "path",
    {
      d: "M21 12.43a1.93 1.93 0 0 0 0-3.36L8.83 2.2a1.64 1.64 0 0 0-1.63 0L3 4.57a1.93 1.93 0 0 0 0 3.36l12.18 6.86a1.636 1.636 0 0 0 1.63 0z",
      key: "12ttoo"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PackagePlus = createLucideIcon("PackagePlus", [
  ["path", { d: "M16 16h6", key: "100bgy" }],
  ["path", { d: "M19 13v6", key: "85cyf1" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PackageSearch = createLucideIcon("PackageSearch", [
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }],
  ["circle", { cx: "18.5", cy: "15.5", r: "2.5", key: "b5zd12" }],
  ["path", { d: "M20.27 17.27 22 19", key: "1l4muz" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PackageX = createLucideIcon("PackageX", [
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }],
  ["path", { d: "m17 13 5 5m-5 0 5-5", key: "im3w4b" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Package = createLucideIcon("Package", [
  [
    "path",
    {
      d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
      key: "1a0edw"
    }
  ],
  ["path", { d: "M12 22V12", key: "d0xqtd" }],
  ["path", { d: "m3.3 7 7.703 4.734a2 2 0 0 0 1.994 0L20.7 7", key: "yx3hmr" }],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PaintBucket = createLucideIcon("PaintBucket", [
  [
    "path",
    { d: "m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z", key: "irua1i" }
  ],
  ["path", { d: "m5 2 5 5", key: "1lls2c" }],
  ["path", { d: "M2 13h15", key: "1hkzvu" }],
  ["path", { d: "M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z", key: "xk76lq" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PaintRoller = createLucideIcon("PaintRoller", [
  ["rect", { width: "16", height: "6", x: "2", y: "2", rx: "2", key: "jcyz7m" }],
  ["path", { d: "M10 16v-2a2 2 0 0 1 2-2h8a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2", key: "1b9h7c" }],
  ["rect", { width: "4", height: "6", x: "8", y: "16", rx: "1", key: "d6e7yl" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PaintbrushVertical = createLucideIcon("PaintbrushVertical", [
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M14 2v4", key: "qmzblu" }],
  ["path", { d: "M17 2a1 1 0 0 1 1 1v9H6V3a1 1 0 0 1 1-1z", key: "ycvu00" }],
  [
    "path",
    {
      d: "M6 12a1 1 0 0 0-1 1v1a2 2 0 0 0 2 2h2a1 1 0 0 1 1 1v2.9a2 2 0 1 0 4 0V17a1 1 0 0 1 1-1h2a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1",
      key: "iw4wnp"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Paintbrush = createLucideIcon("Paintbrush", [
  ["path", { d: "m14.622 17.897-10.68-2.913", key: "vj2p1u" }],
  [
    "path",
    {
      d: "M18.376 2.622a1 1 0 1 1 3.002 3.002L17.36 9.643a.5.5 0 0 0 0 .707l.944.944a2.41 2.41 0 0 1 0 3.408l-.944.944a.5.5 0 0 1-.707 0L8.354 7.348a.5.5 0 0 1 0-.707l.944-.944a2.41 2.41 0 0 1 3.408 0l.944.944a.5.5 0 0 0 .707 0z",
      key: "18tc5c"
    }
  ],
  [
    "path",
    {
      d: "M9 8c-1.804 2.71-3.97 3.46-6.583 3.948a.507.507 0 0 0-.302.819l7.32 8.883a1 1 0 0 0 1.185.204C12.735 20.405 16 16.792 16 15",
      key: "ytzfxy"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Palette = createLucideIcon("Palette", [
  ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
  ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
  ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }],
  ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
  [
    "path",
    {
      d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z",
      key: "12rzf8"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PanelBottomClose = createLucideIcon("PanelBottomClose", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "m15 8-3 3-3-3", key: "1oxy1z" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PanelBottomDashed = createLucideIcon("PanelBottomDashed", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M14 15h1", key: "171nev" }],
  ["path", { d: "M19 15h2", key: "1vnucp" }],
  ["path", { d: "M3 15h2", key: "8bym0q" }],
  ["path", { d: "M9 15h1", key: "1tg3ks" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PanelBottomOpen = createLucideIcon("PanelBottomOpen", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PanelBottom = createLucideIcon("PanelBottom", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h18", key: "5xshup" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PanelLeftClose = createLucideIcon("PanelLeftClose", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m16 15-3-3 3-3", key: "14y99z" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PanelLeftDashed = createLucideIcon("PanelLeftDashed", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 14v1", key: "askpd8" }],
  ["path", { d: "M9 19v2", key: "16tejx" }],
  ["path", { d: "M9 3v2", key: "1noubl" }],
  ["path", { d: "M9 9v1", key: "19ebxg" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PanelLeftOpen = createLucideIcon("PanelLeftOpen", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m14 9 3 3-3 3", key: "8010ee" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PanelLeft = createLucideIcon("PanelLeft", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PanelRightClose = createLucideIcon("PanelRightClose", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["path", { d: "m8 9 3 3-3 3", key: "12hl5m" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PanelRightDashed = createLucideIcon("PanelRightDashed", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 14v1", key: "ilsfch" }],
  ["path", { d: "M15 19v2", key: "1fst2f" }],
  ["path", { d: "M15 3v2", key: "z204g4" }],
  ["path", { d: "M15 9v1", key: "z2a8b1" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PanelRightOpen = createLucideIcon("PanelRightOpen", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["path", { d: "m10 15-3-3 3-3", key: "1pgupc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PanelRight = createLucideIcon("PanelRight", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PanelTopClose = createLucideIcon("PanelTopClose", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "m9 16 3-3 3 3", key: "1idcnm" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PanelTopDashed = createLucideIcon("PanelTopDashed", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M14 9h1", key: "l0svgy" }],
  ["path", { d: "M19 9h2", key: "te2zfg" }],
  ["path", { d: "M3 9h2", key: "1h4ldw" }],
  ["path", { d: "M9 9h1", key: "15jzuz" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PanelTopOpen = createLucideIcon("PanelTopOpen", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "m15 14-3 3-3-3", key: "g215vf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PanelTop = createLucideIcon("PanelTop", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PanelsLeftBottom = createLucideIcon("PanelsLeftBottom", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M9 15h12", key: "5ijen5" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PanelsRightBottom = createLucideIcon("PanelsRightBottom", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h12", key: "1wkqb3" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PanelsTopLeft = createLucideIcon("PanelsTopLeft", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M9 21V9", key: "1oto5p" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Paperclip = createLucideIcon("Paperclip", [
  [
    "path",
    {
      d: "m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48",
      key: "1u3ebp"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Parentheses = createLucideIcon("Parentheses", [
  ["path", { d: "M8 21s-4-3-4-9 4-9 4-9", key: "uto9ud" }],
  ["path", { d: "M16 3s4 3 4 9-4 9-4 9", key: "4w2vsq" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ParkingMeter = createLucideIcon("ParkingMeter", [
  ["path", { d: "M11 15h2", key: "199qp6" }],
  ["path", { d: "M12 12v3", key: "158kv8" }],
  ["path", { d: "M12 19v3", key: "npa21l" }],
  [
    "path",
    {
      d: "M15.282 19a1 1 0 0 0 .948-.68l2.37-6.988a7 7 0 1 0-13.2 0l2.37 6.988a1 1 0 0 0 .948.68z",
      key: "1jofit"
    }
  ],
  ["path", { d: "M9 9a3 3 0 1 1 6 0", key: "jdoeu8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PartyPopper = createLucideIcon("PartyPopper", [
  ["path", { d: "M5.8 11.3 2 22l10.7-3.79", key: "gwxi1d" }],
  ["path", { d: "M4 3h.01", key: "1vcuye" }],
  ["path", { d: "M22 8h.01", key: "1mrtc2" }],
  ["path", { d: "M15 2h.01", key: "1cjtqr" }],
  ["path", { d: "M22 20h.01", key: "1mrys2" }],
  [
    "path",
    {
      d: "m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10",
      key: "hbicv8"
    }
  ],
  [
    "path",
    { d: "m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11c-.11.7-.72 1.22-1.43 1.22H17", key: "1i94pl" }
  ],
  ["path", { d: "m11 2 .33.82c.34.86-.2 1.82-1.11 1.98C9.52 4.9 9 5.52 9 6.23V7", key: "1cofks" }],
  [
    "path",
    {
      d: "M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z",
      key: "4kbmks"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pause = createLucideIcon("Pause", [
  ["rect", { x: "14", y: "4", width: "4", height: "16", rx: "1", key: "zuxfzm" }],
  ["rect", { x: "6", y: "4", width: "4", height: "16", rx: "1", key: "1okwgv" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PawPrint = createLucideIcon("PawPrint", [
  ["circle", { cx: "11", cy: "4", r: "2", key: "vol9p0" }],
  ["circle", { cx: "18", cy: "8", r: "2", key: "17gozi" }],
  ["circle", { cx: "20", cy: "16", r: "2", key: "1v9bxh" }],
  [
    "path",
    {
      d: "M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z",
      key: "1ydw1z"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PcCase = createLucideIcon("PcCase", [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", key: "1uq1d7" }],
  ["path", { d: "M15 14h.01", key: "1kp3bh" }],
  ["path", { d: "M9 6h6", key: "dgm16u" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PenLine = createLucideIcon("PenLine", [
  ["path", { d: "M12 20h9", key: "t2du7b" }],
  [
    "path",
    {
      d: "M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z",
      key: "1ykcvy"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PenOff = createLucideIcon("PenOff", [
  [
    "path",
    {
      d: "m10 10-6.157 6.162a2 2 0 0 0-.5.833l-1.322 4.36a.5.5 0 0 0 .622.624l4.358-1.323a2 2 0 0 0 .83-.5L14 13.982",
      key: "bjo8r8"
    }
  ],
  ["path", { d: "m12.829 7.172 4.359-4.346a1 1 0 1 1 3.986 3.986l-4.353 4.353", key: "16h5ne" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PenTool = createLucideIcon("PenTool", [
  [
    "path",
    {
      d: "M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z",
      key: "nt11vn"
    }
  ],
  [
    "path",
    {
      d: "m18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18",
      key: "15qc1e"
    }
  ],
  ["path", { d: "m2.3 2.3 7.286 7.286", key: "1wuzzi" }],
  ["circle", { cx: "11", cy: "11", r: "2", key: "xmgehs" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pen = createLucideIcon("Pen", [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PencilLine = createLucideIcon("PencilLine", [
  ["path", { d: "M12 20h9", key: "t2du7b" }],
  [
    "path",
    {
      d: "M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z",
      key: "1ykcvy"
    }
  ],
  ["path", { d: "m15 5 3 3", key: "1w25hb" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PencilOff = createLucideIcon("PencilOff", [
  [
    "path",
    {
      d: "m10 10-6.157 6.162a2 2 0 0 0-.5.833l-1.322 4.36a.5.5 0 0 0 .622.624l4.358-1.323a2 2 0 0 0 .83-.5L14 13.982",
      key: "bjo8r8"
    }
  ],
  ["path", { d: "m12.829 7.172 4.359-4.346a1 1 0 1 1 3.986 3.986l-4.353 4.353", key: "16h5ne" }],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PencilRuler = createLucideIcon("PencilRuler", [
  [
    "path",
    { d: "M13 7 8.7 2.7a2.41 2.41 0 0 0-3.4 0L2.7 5.3a2.41 2.41 0 0 0 0 3.4L7 13", key: "orapub" }
  ],
  ["path", { d: "m8 6 2-2", key: "115y1s" }],
  ["path", { d: "m18 16 2-2", key: "ee94s4" }],
  [
    "path",
    {
      d: "m17 11 4.3 4.3c.94.94.94 2.46 0 3.4l-2.6 2.6c-.94.94-2.46.94-3.4 0L11 17",
      key: "cfq27r"
    }
  ],
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pencil = createLucideIcon("Pencil", [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pentagon = createLucideIcon("Pentagon", [
  [
    "path",
    {
      d: "M10.83 2.38a2 2 0 0 1 2.34 0l8 5.74a2 2 0 0 1 .73 2.25l-3.04 9.26a2 2 0 0 1-1.9 1.37H7.04a2 2 0 0 1-1.9-1.37L2.1 10.37a2 2 0 0 1 .73-2.25z",
      key: "2hea0t"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Percent = createLucideIcon("Percent", [
  ["line", { x1: "19", x2: "5", y1: "5", y2: "19", key: "1x9vlm" }],
  ["circle", { cx: "6.5", cy: "6.5", r: "2.5", key: "4mh3h7" }],
  ["circle", { cx: "17.5", cy: "17.5", r: "2.5", key: "1mdrzq" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PersonStanding = createLucideIcon("PersonStanding", [
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["path", { d: "m9 20 3-6 3 6", key: "se2kox" }],
  ["path", { d: "m6 8 6 2 6-2", key: "4o3us4" }],
  ["path", { d: "M12 10v4", key: "1kjpxc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PhilippinePeso = createLucideIcon("PhilippinePeso", [
  ["path", { d: "M20 11H4", key: "6ut86h" }],
  ["path", { d: "M20 7H4", key: "zbl0bi" }],
  ["path", { d: "M7 21V4a1 1 0 0 1 1-1h4a1 1 0 0 1 0 12H7", key: "1ana5r" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PhoneCall = createLucideIcon("PhoneCall", [
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ],
  ["path", { d: "M14.05 2a9 9 0 0 1 8 7.94", key: "vmijpz" }],
  ["path", { d: "M14.05 6A5 5 0 0 1 18 10", key: "13nbpp" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PhoneForwarded = createLucideIcon("PhoneForwarded", [
  ["polyline", { points: "18 2 22 6 18 10", key: "6vjanh" }],
  ["line", { x1: "14", x2: "22", y1: "6", y2: "6", key: "1jsywh" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PhoneIncoming = createLucideIcon("PhoneIncoming", [
  ["polyline", { points: "16 2 16 8 22 8", key: "1ygljm" }],
  ["line", { x1: "22", x2: "16", y1: "2", y2: "8", key: "1xzwqn" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PhoneMissed = createLucideIcon("PhoneMissed", [
  ["line", { x1: "22", x2: "16", y1: "2", y2: "8", key: "1xzwqn" }],
  ["line", { x1: "16", x2: "22", y1: "2", y2: "8", key: "13zxdn" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PhoneOff = createLucideIcon("PhoneOff", [
  [
    "path",
    {
      d: "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91",
      key: "z86iuo"
    }
  ],
  ["line", { x1: "22", x2: "2", y1: "2", y2: "22", key: "11kh81" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PhoneOutgoing = createLucideIcon("PhoneOutgoing", [
  ["polyline", { points: "22 8 22 2 16 2", key: "1g204g" }],
  ["line", { x1: "16", x2: "22", y1: "8", y2: "2", key: "1ggias" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Phone = createLucideIcon("Phone", [
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pi = createLucideIcon("Pi", [
  ["line", { x1: "9", x2: "9", y1: "4", y2: "20", key: "ovs5a5" }],
  ["path", { d: "M4 7c0-1.7 1.3-3 3-3h13", key: "10pag4" }],
  ["path", { d: "M18 20c-1.7 0-3-1.3-3-3V4", key: "1gaosr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Piano = createLucideIcon("Piano", [
  [
    "path",
    {
      d: "M18.5 8c-1.4 0-2.6-.8-3.2-2A6.87 6.87 0 0 0 2 9v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8.5C22 9.6 20.4 8 18.5 8",
      key: "lag0yf"
    }
  ],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M6 14v4", key: "9ng0ue" }],
  ["path", { d: "M10 14v4", key: "1v8uk5" }],
  ["path", { d: "M14 14v4", key: "1tqops" }],
  ["path", { d: "M18 14v4", key: "18uqwm" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pickaxe = createLucideIcon("Pickaxe", [
  ["path", { d: "M14.531 12.469 6.619 20.38a1 1 0 1 1-3-3l7.912-7.912", key: "we99rg" }],
  [
    "path",
    {
      d: "M15.686 4.314A12.5 12.5 0 0 0 5.461 2.958 1 1 0 0 0 5.58 4.71a22 22 0 0 1 6.318 3.393",
      key: "1w6hck"
    }
  ],
  [
    "path",
    {
      d: "M17.7 3.7a1 1 0 0 0-1.4 0l-4.6 4.6a1 1 0 0 0 0 1.4l2.6 2.6a1 1 0 0 0 1.4 0l4.6-4.6a1 1 0 0 0 0-1.4z",
      key: "15hgfx"
    }
  ],
  [
    "path",
    {
      d: "M19.686 8.314a12.501 12.501 0 0 1 1.356 10.225 1 1 0 0 1-1.751-.119 22 22 0 0 0-3.393-6.319",
      key: "452b4h"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PictureInPicture2 = createLucideIcon("PictureInPicture2", [
  ["path", { d: "M21 9V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h4", key: "daa4of" }],
  ["rect", { width: "10", height: "7", x: "12", y: "13", rx: "2", key: "1nb8gs" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PictureInPicture = createLucideIcon("PictureInPicture", [
  [
    "path",
    {
      d: "M8 4.5v5H3m-1-6 6 6m13 0v-3c0-1.16-.84-2-2-2h-7m-9 9v2c0 1.05.95 2 2 2h3",
      key: "bcd8fb"
    }
  ],
  ["rect", { width: "10", height: "7", x: "12", y: "13.5", ry: "2", key: "136fx3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PiggyBank = createLucideIcon("PiggyBank", [
  [
    "path",
    {
      d: "M19 5c-1.5 0-2.8 1.4-3 2-3.5-1.5-11-.3-11 5 0 1.8 0 3 2 4.5V20h4v-2h3v2h4v-4c1-.5 1.7-1 2-2h2v-4h-2c0-1-.5-1.5-1-2V5z",
      key: "1ivx2i"
    }
  ],
  ["path", { d: "M2 9v1c0 1.1.9 2 2 2h1", key: "nm575m" }],
  ["path", { d: "M16 11h.01", key: "xkw8gn" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PilcrowLeft = createLucideIcon("PilcrowLeft", [
  ["path", { d: "M14 3v11", key: "mlfb7b" }],
  ["path", { d: "M14 9h-3a3 3 0 0 1 0-6h9", key: "1ulc19" }],
  ["path", { d: "M18 3v11", key: "1phi0r" }],
  ["path", { d: "M22 18H2l4-4", key: "yt65j9" }],
  ["path", { d: "m6 22-4-4", key: "6jgyf5" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PilcrowRight = createLucideIcon("PilcrowRight", [
  ["path", { d: "M10 3v11", key: "o3l5kj" }],
  ["path", { d: "M10 9H7a1 1 0 0 1 0-6h8", key: "1wb1nc" }],
  ["path", { d: "M14 3v11", key: "mlfb7b" }],
  ["path", { d: "m18 14 4 4H2", key: "4r8io1" }],
  ["path", { d: "m22 18-4 4", key: "1hjjrd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pilcrow = createLucideIcon("Pilcrow", [
  ["path", { d: "M13 4v16", key: "8vvj80" }],
  ["path", { d: "M17 4v16", key: "7dpous" }],
  ["path", { d: "M19 4H9.5a4.5 4.5 0 0 0 0 9H13", key: "sh4n9v" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PillBottle = createLucideIcon("PillBottle", [
  ["path", { d: "M18 11h-4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4", key: "17ldeb" }],
  ["path", { d: "M6 7v13a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7", key: "nc37y6" }],
  ["rect", { width: "16", height: "5", x: "4", y: "2", rx: "1", key: "3jeezo" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pill = createLucideIcon("Pill", [
  [
    "path",
    { d: "m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z", key: "wa1lgi" }
  ],
  ["path", { d: "m8.5 8.5 7 7", key: "rvfmvr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PinOff = createLucideIcon("PinOff", [
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  ["path", { d: "M15 9.34V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H7.89", key: "znwnzq" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "M9 9v1.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h11",
      key: "c9qhm2"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pin = createLucideIcon("Pin", [
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  [
    "path",
    {
      d: "M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z",
      key: "1nkz8b"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pipette = createLucideIcon("Pipette", [
  ["path", { d: "m2 22 1-1h3l9-9", key: "1sre89" }],
  ["path", { d: "M3 21v-3l9-9", key: "hpe2y6" }],
  [
    "path",
    {
      d: "m15 6 3.4-3.4a2.1 2.1 0 1 1 3 3L18 9l.4.4a2.1 2.1 0 1 1-3 3l-3.8-3.8a2.1 2.1 0 1 1 3-3l.4.4Z",
      key: "196du1"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pizza = createLucideIcon("Pizza", [
  ["path", { d: "m12 14-1 1", key: "11onhr" }],
  ["path", { d: "m13.75 18.25-1.25 1.42", key: "1yisr3" }],
  ["path", { d: "M17.775 5.654a15.68 15.68 0 0 0-12.121 12.12", key: "1qtqk6" }],
  ["path", { d: "M18.8 9.3a1 1 0 0 0 2.1 7.7", key: "fbbbr2" }],
  [
    "path",
    {
      d: "M21.964 20.732a1 1 0 0 1-1.232 1.232l-18-5a1 1 0 0 1-.695-1.232A19.68 19.68 0 0 1 15.732 2.037a1 1 0 0 1 1.232.695z",
      key: "1hyfdd"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PlaneLanding = createLucideIcon("PlaneLanding", [
  ["path", { d: "M2 22h20", key: "272qi7" }],
  [
    "path",
    {
      d: "M3.77 10.77 2 9l2-4.5 1.1.55c.55.28.9.84.9 1.45s.35 1.17.9 1.45L8 8.5l3-6 1.05.53a2 2 0 0 1 1.09 1.52l.72 5.4a2 2 0 0 0 1.09 1.52l4.4 2.2c.42.22.78.55 1.01.96l.6 1.03c.49.88-.06 1.98-1.06 2.1l-1.18.15c-.47.06-.95-.02-1.37-.24L4.29 11.15a2 2 0 0 1-.52-.38Z",
      key: "1ma21e"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PlaneTakeoff = createLucideIcon("PlaneTakeoff", [
  ["path", { d: "M2 22h20", key: "272qi7" }],
  [
    "path",
    {
      d: "M6.36 17.4 4 17l-2-4 1.1-.55a2 2 0 0 1 1.8 0l.17.1a2 2 0 0 0 1.8 0L8 12 5 6l.9-.45a2 2 0 0 1 2.09.2l4.02 3a2 2 0 0 0 2.1.2l4.19-2.06a2.41 2.41 0 0 1 1.73-.17L21 7a1.4 1.4 0 0 1 .87 1.99l-.38.76c-.23.46-.6.84-1.07 1.08L7.58 17.2a2 2 0 0 1-1.22.18Z",
      key: "fkigj9"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Plane = createLucideIcon("Plane", [
  [
    "path",
    {
      d: "M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z",
      key: "1v9wt8"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Play = createLucideIcon("Play", [
  ["polygon", { points: "6 3 20 12 6 21 6 3", key: "1oa8hb" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Plug2 = createLucideIcon("Plug2", [
  ["path", { d: "M9 2v6", key: "17ngun" }],
  ["path", { d: "M15 2v6", key: "s7yy2p" }],
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  ["path", { d: "M5 8h14", key: "pcz4l3" }],
  ["path", { d: "M6 11V8h12v3a6 6 0 1 1-12 0Z", key: "wtfw2c" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PlugZap = createLucideIcon("PlugZap", [
  [
    "path",
    { d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z", key: "goz73y" }
  ],
  ["path", { d: "m2 22 3-3", key: "19mgm9" }],
  ["path", { d: "M7.5 13.5 10 11", key: "7xgeeb" }],
  ["path", { d: "M10.5 16.5 13 14", key: "10btkg" }],
  ["path", { d: "m18 3-4 4h6l-4 4", key: "16psg9" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Plug = createLucideIcon("Plug", [
  ["path", { d: "M12 22v-5", key: "1ega77" }],
  ["path", { d: "M9 8V2", key: "14iosj" }],
  ["path", { d: "M15 8V2", key: "18g5xt" }],
  ["path", { d: "M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z", key: "osxo6l" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Plus = createLucideIcon("Plus", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PocketKnife = createLucideIcon("PocketKnife", [
  ["path", { d: "M3 2v1c0 1 2 1 2 2S3 6 3 7s2 1 2 2-2 1-2 2 2 1 2 2", key: "19w3oe" }],
  ["path", { d: "M18 6h.01", key: "1v4wsw" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M20.83 8.83a4 4 0 0 0-5.66-5.66l-12 12a4 4 0 1 0 5.66 5.66Z", key: "6fykxj" }],
  ["path", { d: "M18 11.66V22a4 4 0 0 0 4-4V6", key: "1utzek" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pocket = createLucideIcon("Pocket", [
  [
    "path",
    {
      d: "M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z",
      key: "1mz881"
    }
  ],
  ["polyline", { points: "8 10 12 14 16 10", key: "w4mbv5" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Podcast = createLucideIcon("Podcast", [
  ["path", { d: "M16.85 18.58a9 9 0 1 0-9.7 0", key: "d71mpg" }],
  ["path", { d: "M8 14a5 5 0 1 1 8 0", key: "fc81rn" }],
  ["circle", { cx: "12", cy: "11", r: "1", key: "1gvufo" }],
  ["path", { d: "M13 17a1 1 0 1 0-2 0l.5 4.5a.5.5 0 1 0 1 0Z", key: "za5kbj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PointerOff = createLucideIcon("PointerOff", [
  ["path", { d: "M10 4.5V4a2 2 0 0 0-2.41-1.957", key: "jsi14n" }],
  ["path", { d: "M13.9 8.4a2 2 0 0 0-1.26-1.295", key: "hirc7f" }],
  [
    "path",
    { d: "M21.7 16.2A8 8 0 0 0 22 14v-3a2 2 0 1 0-4 0v-1a2 2 0 0 0-3.63-1.158", key: "1jxb2e" }
  ],
  [
    "path",
    {
      d: "m7 15-1.8-1.8a2 2 0 0 0-2.79 2.86L6 19.7a7.74 7.74 0 0 0 6 2.3h2a8 8 0 0 0 5.657-2.343",
      key: "10r7hm"
    }
  ],
  ["path", { d: "M6 6v8", key: "tv5xkp" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pointer = createLucideIcon("Pointer", [
  ["path", { d: "M22 14a8 8 0 0 1-8 8", key: "56vcr3" }],
  ["path", { d: "M18 11v-1a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1agjmk" }],
  ["path", { d: "M14 10V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1", key: "wdbh2u" }],
  ["path", { d: "M10 9.5V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v10", key: "1ibuk9" }],
  [
    "path",
    {
      d: "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
      key: "g6ys72"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Popcorn = createLucideIcon("Popcorn", [
  [
    "path",
    {
      d: "M18 8a2 2 0 0 0 0-4 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0 0 4",
      key: "10td1f"
    }
  ],
  ["path", { d: "M10 22 9 8", key: "yjptiv" }],
  ["path", { d: "m14 22 1-14", key: "8jwc8b" }],
  [
    "path",
    {
      d: "M20 8c.5 0 .9.4.8 1l-2.6 12c-.1.5-.7 1-1.2 1H7c-.6 0-1.1-.4-1.2-1L3.2 9c-.1-.6.3-1 .8-1Z",
      key: "1qo33t"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Popsicle = createLucideIcon("Popsicle", [
  [
    "path",
    {
      d: "M18.6 14.4c.8-.8.8-2 0-2.8l-8.1-8.1a4.95 4.95 0 1 0-7.1 7.1l8.1 8.1c.9.7 2.1.7 2.9-.1Z",
      key: "1o68ps"
    }
  ],
  ["path", { d: "m22 22-5.5-5.5", key: "17o70y" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PoundSterling = createLucideIcon("PoundSterling", [
  ["path", { d: "M18 7c0-5.333-8-5.333-8 0", key: "1prm2n" }],
  ["path", { d: "M10 7v14", key: "18tmcs" }],
  ["path", { d: "M6 21h12", key: "4dkmi1" }],
  ["path", { d: "M6 13h10", key: "ybwr4a" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PowerOff = createLucideIcon("PowerOff", [
  ["path", { d: "M18.36 6.64A9 9 0 0 1 20.77 15", key: "dxknvb" }],
  ["path", { d: "M6.16 6.16a9 9 0 1 0 12.68 12.68", key: "1x7qb5" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Power = createLucideIcon("Power", [
  ["path", { d: "M12 2v10", key: "mnfbl" }],
  ["path", { d: "M18.4 6.6a9 9 0 1 1-12.77.04", key: "obofu9" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Presentation = createLucideIcon("Presentation", [
  ["path", { d: "M2 3h20", key: "91anmk" }],
  ["path", { d: "M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3", key: "2k9sn8" }],
  ["path", { d: "m7 21 5-5 5 5", key: "bip4we" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PrinterCheck = createLucideIcon("PrinterCheck", [
  ["path", { d: "M13.5 22H7a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v.5", key: "qeb09x" }],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }],
  ["path", { d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2", key: "1md90i" }],
  ["path", { d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6", key: "1itne7" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Printer = createLucideIcon("Printer", [
  [
    "path",
    {
      d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
      key: "143wyd"
    }
  ],
  ["path", { d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6", key: "1itne7" }],
  ["rect", { x: "6", y: "14", width: "12", height: "8", rx: "1", key: "1ue0tg" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Projector = createLucideIcon("Projector", [
  ["path", { d: "M5 7 3 5", key: "1yys58" }],
  ["path", { d: "M9 6V3", key: "1ptz9u" }],
  ["path", { d: "m13 7 2-2", key: "1w3vmq" }],
  ["circle", { cx: "9", cy: "13", r: "3", key: "1mma13" }],
  [
    "path",
    {
      d: "M11.83 12H20a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.17",
      key: "2frwzc"
    }
  ],
  ["path", { d: "M16 16h2", key: "dnq2od" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Proportions = createLucideIcon("Proportions", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M12 9v11", key: "1fnkrn" }],
  ["path", { d: "M2 9h13a2 2 0 0 1 2 2v9", key: "11z3ex" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Puzzle = createLucideIcon("Puzzle", [
  [
    "path",
    {
      d: "M19.439 7.85c-.049.322.059.648.289.878l1.568 1.568c.47.47.706 1.087.706 1.704s-.235 1.233-.706 1.704l-1.611 1.611a.98.98 0 0 1-.837.276c-.47-.07-.802-.48-.968-.925a2.501 2.501 0 1 0-3.214 3.214c.446.166.855.497.925.968a.979.979 0 0 1-.276.837l-1.61 1.61a2.404 2.404 0 0 1-1.705.707 2.402 2.402 0 0 1-1.704-.706l-1.568-1.568a1.026 1.026 0 0 0-.877-.29c-.493.074-.84.504-1.02.968a2.5 2.5 0 1 1-3.237-3.237c.464-.18.894-.527.967-1.02a1.026 1.026 0 0 0-.289-.877l-1.568-1.568A2.402 2.402 0 0 1 1.998 12c0-.617.236-1.234.706-1.704L4.23 8.77c.24-.24.581-.353.917-.303.515.077.877.528 1.073 1.01a2.5 2.5 0 1 0 3.259-3.259c-.482-.196-.933-.558-1.01-1.073-.05-.336.062-.676.303-.917l1.525-1.525A2.402 2.402 0 0 1 12 1.998c.617 0 1.234.236 1.704.706l1.568 1.568c.23.23.556.338.877.29.493-.074.84-.504 1.02-.968a2.5 2.5 0 1 1 3.237 3.237c-.464.18-.894.527-.967 1.02Z",
      key: "i0oyt7"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pyramid = createLucideIcon("Pyramid", [
  [
    "path",
    {
      d: "M2.5 16.88a1 1 0 0 1-.32-1.43l9-13.02a1 1 0 0 1 1.64 0l9 13.01a1 1 0 0 1-.32 1.44l-8.51 4.86a2 2 0 0 1-1.98 0Z",
      key: "aenxs0"
    }
  ],
  ["path", { d: "M12 2v20", key: "t6zp3m" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QrCode = createLucideIcon("QrCode", [
  ["rect", { width: "5", height: "5", x: "3", y: "3", rx: "1", key: "1tu5fj" }],
  ["rect", { width: "5", height: "5", x: "16", y: "3", rx: "1", key: "1v8r4q" }],
  ["rect", { width: "5", height: "5", x: "3", y: "16", rx: "1", key: "1x03jg" }],
  ["path", { d: "M21 16h-3a2 2 0 0 0-2 2v3", key: "177gqh" }],
  ["path", { d: "M21 21v.01", key: "ents32" }],
  ["path", { d: "M12 7v3a2 2 0 0 1-2 2H7", key: "8crl2c" }],
  ["path", { d: "M3 12h.01", key: "nlz23k" }],
  ["path", { d: "M12 3h.01", key: "n36tog" }],
  ["path", { d: "M12 16v.01", key: "133mhm" }],
  ["path", { d: "M16 12h1", key: "1slzba" }],
  ["path", { d: "M21 12v.01", key: "1lwtk9" }],
  ["path", { d: "M12 21v-1", key: "1880an" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Quote = createLucideIcon("Quote", [
  [
    "path",
    {
      d: "M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z",
      key: "rib7q0"
    }
  ],
  [
    "path",
    {
      d: "M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z",
      key: "1ymkrd"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rabbit = createLucideIcon("Rabbit", [
  ["path", { d: "M13 16a3 3 0 0 1 2.24 5", key: "1epib5" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }],
  [
    "path",
    {
      d: "M18 21h-8a4 4 0 0 1-4-4 7 7 0 0 1 7-7h.2L9.6 6.4a1 1 0 1 1 2.8-2.8L15.8 7h.2c3.3 0 6 2.7 6 6v1a2 2 0 0 1-2 2h-1a3 3 0 0 0-3 3",
      key: "ue9ozu"
    }
  ],
  ["path", { d: "M20 8.54V4a2 2 0 1 0-4 0v3", key: "49iql8" }],
  ["path", { d: "M7.612 12.524a3 3 0 1 0-1.6 4.3", key: "1e33i0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Radar = createLucideIcon("Radar", [
  ["path", { d: "M19.07 4.93A10 10 0 0 0 6.99 3.34", key: "z3du51" }],
  ["path", { d: "M4 6h.01", key: "oypzma" }],
  ["path", { d: "M2.29 9.62A10 10 0 1 0 21.31 8.35", key: "qzzz0" }],
  ["path", { d: "M16.24 7.76A6 6 0 1 0 8.23 16.67", key: "1yjesh" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M17.99 11.66A6 6 0 0 1 15.77 16.67", key: "1u2y91" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "m13.41 10.59 5.66-5.66", key: "mhq4k0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Radiation = createLucideIcon("Radiation", [
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  [
    "path",
    {
      d: "M7.5 4.2c-.3-.5-.9-.7-1.3-.4C3.9 5.5 2.3 8.1 2 11c-.1.5.4 1 1 1h5c0-1.5.8-2.8 2-3.4-1.1-1.9-2-3.5-2.5-4.4z",
      key: "wy49g3"
    }
  ],
  [
    "path",
    {
      d: "M21 12c.6 0 1-.4 1-1-.3-2.9-1.8-5.5-4.1-7.1-.4-.3-1.1-.2-1.3.3-.6.9-1.5 2.5-2.6 4.3 1.2.7 2 2 2 3.5h5z",
      key: "vklnvr"
    }
  ],
  [
    "path",
    {
      d: "M7.5 19.8c-.3.5-.1 1.1.4 1.3 2.6 1.2 5.6 1.2 8.2 0 .5-.2.7-.8.4-1.3-.5-.9-1.4-2.5-2.5-4.3-1.2.7-2.8.7-4 0-1.1 1.8-2 3.4-2.5 4.3z",
      key: "wkdf1o"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Radical = createLucideIcon("Radical", [
  [
    "path",
    {
      d: "M3 12h3.28a1 1 0 0 1 .948.684l2.298 7.934a.5.5 0 0 0 .96-.044L13.82 4.771A1 1 0 0 1 14.792 4H21",
      key: "1mqj8i"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RadioReceiver = createLucideIcon("RadioReceiver", [
  ["path", { d: "M5 16v2", key: "g5qcv5" }],
  ["path", { d: "M19 16v2", key: "1gbaio" }],
  ["rect", { width: "20", height: "8", x: "2", y: "8", rx: "2", key: "vjsjur" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RadioTower = createLucideIcon("RadioTower", [
  ["path", { d: "M4.9 16.1C1 12.2 1 5.8 4.9 1.9", key: "s0qx1y" }],
  ["path", { d: "M7.8 4.7a6.14 6.14 0 0 0-.8 7.5", key: "1idnkw" }],
  ["circle", { cx: "12", cy: "9", r: "2", key: "1092wv" }],
  ["path", { d: "M16.2 4.8c2 2 2.26 5.11.8 7.47", key: "ojru2q" }],
  ["path", { d: "M19.1 1.9a9.96 9.96 0 0 1 0 14.1", key: "rhi7fg" }],
  ["path", { d: "M9.5 18h5", key: "mfy3pd" }],
  ["path", { d: "m8 22 4-11 4 11", key: "25yftu" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Radio = createLucideIcon("Radio", [
  ["path", { d: "M4.9 19.1C1 15.2 1 8.8 4.9 4.9", key: "1vaf9d" }],
  ["path", { d: "M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5", key: "u1ii0m" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5", key: "1j5fej" }],
  ["path", { d: "M19.1 4.9C23 8.8 23 15.1 19.1 19", key: "10b0cb" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Radius = createLucideIcon("Radius", [
  ["path", { d: "M20.34 17.52a10 10 0 1 0-2.82 2.82", key: "fydyku" }],
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["path", { d: "m13.41 13.41 4.18 4.18", key: "1gqbwc" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RailSymbol = createLucideIcon("RailSymbol", [
  ["path", { d: "M5 15h14", key: "m0yey3" }],
  ["path", { d: "M5 9h14", key: "7tsvo6" }],
  ["path", { d: "m14 20-5-5 6-6-5-5", key: "1jo42i" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rainbow = createLucideIcon("Rainbow", [
  ["path", { d: "M22 17a10 10 0 0 0-20 0", key: "ozegv" }],
  ["path", { d: "M6 17a6 6 0 0 1 12 0", key: "5giftw" }],
  ["path", { d: "M10 17a2 2 0 0 1 4 0", key: "gnsikk" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rat = createLucideIcon("Rat", [
  [
    "path",
    {
      d: "M17 5c0-1.7-1.3-3-3-3s-3 1.3-3 3c0 .8.3 1.5.8 2H11c-3.9 0-7 3.1-7 7c0 2.2 1.8 4 4 4",
      key: "1wq71c"
    }
  ],
  [
    "path",
    {
      d: "M16.8 3.9c.3-.3.6-.5 1-.7 1.5-.6 3.3.1 3.9 1.6.6 1.5-.1 3.3-1.6 3.9l1.6 2.8c.2.3.2.7.2 1-.2.8-.9 1.2-1.7 1.1 0 0-1.6-.3-2.7-.6H17c-1.7 0-3 1.3-3 3",
      key: "1crdmb"
    }
  ],
  ["path", { d: "M13.2 18a3 3 0 0 0-2.2-5", key: "1ol3lk" }],
  ["path", { d: "M13 22H4a2 2 0 0 1 0-4h12", key: "bt3f23" }],
  ["path", { d: "M16 9h.01", key: "1bdo4e" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ratio = createLucideIcon("Ratio", [
  ["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2", key: "1oxtiu" }],
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ReceiptCent = createLucideIcon("ReceiptCent", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M12 6.5v11", key: "ecfhkf" }],
  ["path", { d: "M15 9.4a4 4 0 1 0 0 5.2", key: "1makmb" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ReceiptEuro = createLucideIcon("ReceiptEuro", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 12h5", key: "1g6qi8" }],
  ["path", { d: "M16 9.5a4 4 0 1 0 0 5.2", key: "b2px4r" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ReceiptIndianRupee = createLucideIcon("ReceiptIndianRupee", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 7h8", key: "i86dvs" }],
  ["path", { d: "M12 17.5 8 15h1a4 4 0 0 0 0-8", key: "grpkl4" }],
  ["path", { d: "M8 11h8", key: "vwpz6n" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ReceiptJapaneseYen = createLucideIcon("ReceiptJapaneseYen", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "m12 10 3-3", key: "1mc12w" }],
  ["path", { d: "m9 7 3 3v7.5", key: "39i0xv" }],
  ["path", { d: "M9 11h6", key: "1fldmi" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ReceiptPoundSterling = createLucideIcon("ReceiptPoundSterling", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 13h5", key: "1k9z8w" }],
  ["path", { d: "M10 17V9.5a2.5 2.5 0 0 1 5 0", key: "1dzgp0" }],
  ["path", { d: "M8 17h7", key: "8mjdqu" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ReceiptRussianRuble = createLucideIcon("ReceiptRussianRuble", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 15h5", key: "vxg57a" }],
  ["path", { d: "M8 11h5a2 2 0 1 0 0-4h-3v10", key: "1usi5u" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ReceiptSwissFranc = createLucideIcon("ReceiptSwissFranc", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M10 17V7h5", key: "k7jq18" }],
  ["path", { d: "M10 11h4", key: "1i0mka" }],
  ["path", { d: "M8 15h5", key: "vxg57a" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ReceiptText = createLucideIcon("ReceiptText", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M14 8H8", key: "1l3xfs" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "M13 16H8", key: "wsln4y" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Receipt = createLucideIcon("Receipt", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 17.5v-11", key: "1jc1ny" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RectangleEllipsis = createLucideIcon("RectangleEllipsis", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M17 12h.01", key: "1m0b6t" }],
  ["path", { d: "M7 12h.01", key: "eqddd0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RectangleHorizontal = createLucideIcon("RectangleHorizontal", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RectangleVertical = createLucideIcon("RectangleVertical", [
  ["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2", key: "1oxtiu" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Recycle = createLucideIcon("Recycle", [
  [
    "path",
    {
      d: "M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.785 1.785 0 0 1-.004-1.784L7.196 9.5",
      key: "x6z5xu"
    }
  ],
  [
    "path",
    {
      d: "M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.784 1.784 0 0 0 0-1.775l-1.226-2.12",
      key: "1x4zh5"
    }
  ],
  ["path", { d: "m14 16-3 3 3 3", key: "f6jyew" }],
  ["path", { d: "M8.293 13.596 7.196 9.5 3.1 10.598", key: "wf1obh" }],
  [
    "path",
    {
      d: "m9.344 5.811 1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.784 1.784 0 0 1 1.546.888l3.943 6.843",
      key: "9tzpgr"
    }
  ],
  ["path", { d: "m13.378 9.633 4.096 1.098 1.097-4.096", key: "1oe83g" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Redo2 = createLucideIcon("Redo2", [
  ["path", { d: "m15 14 5-5-5-5", key: "12vg1m" }],
  ["path", { d: "M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13", key: "6uklza" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RedoDot = createLucideIcon("RedoDot", [
  ["circle", { cx: "12", cy: "17", r: "1", key: "1ixnty" }],
  ["path", { d: "M21 7v6h-6", key: "3ptur4" }],
  ["path", { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7", key: "1kgawr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Redo = createLucideIcon("Redo", [
  ["path", { d: "M21 7v6h-6", key: "3ptur4" }],
  ["path", { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7", key: "1kgawr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RefreshCcwDot = createLucideIcon("RefreshCcwDot", [
  ["path", { d: "M3 2v6h6", key: "18ldww" }],
  ["path", { d: "M21 12A9 9 0 0 0 6 5.3L3 8", key: "1pbrqz" }],
  ["path", { d: "M21 22v-6h-6", key: "usdfbe" }],
  ["path", { d: "M3 12a9 9 0 0 0 15 6.7l3-2.7", key: "1hosoe" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RefreshCcw = createLucideIcon("RefreshCcw", [
  ["path", { d: "M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "14sxne" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16", key: "1hlbsb" }],
  ["path", { d: "M16 16h5v5", key: "ccwih5" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RefreshCwOff = createLucideIcon("RefreshCwOff", [
  ["path", { d: "M21 8L18.74 5.74A9.75 9.75 0 0 0 12 3C11 3 10.03 3.16 9.13 3.47", key: "1krf6h" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }],
  ["path", { d: "M3 12C3 9.51 4 7.26 5.64 5.64", key: "ruvoct" }],
  ["path", { d: "m3 16 2.26 2.26A9.75 9.75 0 0 0 12 21c2.49 0 4.74-1 6.36-2.64", key: "19q130" }],
  ["path", { d: "M21 12c0 1-.16 1.97-.47 2.87", key: "4w8emr" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M22 22 2 2", key: "1r8tn9" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RefreshCw = createLucideIcon("RefreshCw", [
  ["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Refrigerator = createLucideIcon("Refrigerator", [
  [
    "path",
    { d: "M5 6a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6Z", key: "fpq118" }
  ],
  ["path", { d: "M5 10h14", key: "elsbfy" }],
  ["path", { d: "M15 7v6", key: "1nx30x" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Regex = createLucideIcon("Regex", [
  ["path", { d: "M17 3v10", key: "15fgeh" }],
  ["path", { d: "m12.67 5.5 8.66 5", key: "1gpheq" }],
  ["path", { d: "m12.67 10.5 8.66-5", key: "1dkfa6" }],
  [
    "path",
    { d: "M9 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2z", key: "swwfx4" }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RemoveFormatting = createLucideIcon("RemoveFormatting", [
  ["path", { d: "M4 7V4h16v3", key: "9msm58" }],
  ["path", { d: "M5 20h6", key: "1h6pxn" }],
  ["path", { d: "M13 4 8 20", key: "kqq6aj" }],
  ["path", { d: "m15 15 5 5", key: "me55sn" }],
  ["path", { d: "m20 15-5 5", key: "11p7ol" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Repeat1 = createLucideIcon("Repeat1", [
  ["path", { d: "m17 2 4 4-4 4", key: "nntrym" }],
  ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14", key: "84bu3i" }],
  ["path", { d: "m7 22-4-4 4-4", key: "1wqhfi" }],
  ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3", key: "1rx37r" }],
  ["path", { d: "M11 10h1v4", key: "70cz1p" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Repeat2 = createLucideIcon("Repeat2", [
  ["path", { d: "m2 9 3-3 3 3", key: "1ltn5i" }],
  ["path", { d: "M13 18H7a2 2 0 0 1-2-2V6", key: "1r6tfw" }],
  ["path", { d: "m22 15-3 3-3-3", key: "4rnwn2" }],
  ["path", { d: "M11 6h6a2 2 0 0 1 2 2v10", key: "2f72bc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Repeat = createLucideIcon("Repeat", [
  ["path", { d: "m17 2 4 4-4 4", key: "nntrym" }],
  ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14", key: "84bu3i" }],
  ["path", { d: "m7 22-4-4 4-4", key: "1wqhfi" }],
  ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3", key: "1rx37r" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ReplaceAll = createLucideIcon("ReplaceAll", [
  ["path", { d: "M14 14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2", key: "1yyzbs" }],
  ["path", { d: "M14 4a2 2 0 0 1 2-2", key: "1w2hp7" }],
  ["path", { d: "M16 10a2 2 0 0 1-2-2", key: "shjach" }],
  ["path", { d: "M20 14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2", key: "zfj4xr" }],
  ["path", { d: "M20 2a2 2 0 0 1 2 2", key: "188mtx" }],
  ["path", { d: "M22 8a2 2 0 0 1-2 2", key: "ddf4tu" }],
  ["path", { d: "m3 7 3 3 3-3", key: "x25e72" }],
  ["path", { d: "M6 10V5a 3 3 0 0 1 3-3h1", key: "1ageje" }],
  ["rect", { x: "2", y: "14", width: "8", height: "8", rx: "2", key: "4rksxw" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Replace = createLucideIcon("Replace", [
  ["path", { d: "M14 4a2 2 0 0 1 2-2", key: "1w2hp7" }],
  ["path", { d: "M16 10a2 2 0 0 1-2-2", key: "shjach" }],
  ["path", { d: "M20 2a2 2 0 0 1 2 2", key: "188mtx" }],
  ["path", { d: "M22 8a2 2 0 0 1-2 2", key: "ddf4tu" }],
  ["path", { d: "m3 7 3 3 3-3", key: "x25e72" }],
  ["path", { d: "M6 10V5a3 3 0 0 1 3-3h1", key: "3y3t5z" }],
  ["rect", { x: "2", y: "14", width: "8", height: "8", rx: "2", key: "4rksxw" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ReplyAll = createLucideIcon("ReplyAll", [
  ["polyline", { points: "7 17 2 12 7 7", key: "t83bqg" }],
  ["polyline", { points: "12 17 7 12 12 7", key: "1g4ajm" }],
  ["path", { d: "M22 18v-2a4 4 0 0 0-4-4H7", key: "1fcyog" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Reply = createLucideIcon("Reply", [
  ["polyline", { points: "9 17 4 12 9 7", key: "hvgpf2" }],
  ["path", { d: "M20 18v-2a4 4 0 0 0-4-4H4", key: "5vmcpk" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rewind = createLucideIcon("Rewind", [
  ["polygon", { points: "11 19 2 12 11 5 11 19", key: "14yba5" }],
  ["polygon", { points: "22 19 13 12 22 5 22 19", key: "1pi1cj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ribbon = createLucideIcon("Ribbon", [
  [
    "path",
    { d: "M12 11.22C11 9.997 10 9 10 8a2 2 0 0 1 4 0c0 1-.998 2.002-2.01 3.22", key: "1rnhq3" }
  ],
  ["path", { d: "m12 18 2.57-3.5", key: "116vt7" }],
  ["path", { d: "M6.243 9.016a7 7 0 0 1 11.507-.009", key: "10dq0b" }],
  ["path", { d: "M9.35 14.53 12 11.22", key: "tdsyp2" }],
  [
    "path",
    {
      d: "M9.35 14.53C7.728 12.246 6 10.221 6 7a6 5 0 0 1 12 0c-.005 3.22-1.778 5.235-3.43 7.5l3.557 4.527a1 1 0 0 1-.203 1.43l-1.894 1.36a1 1 0 0 1-1.384-.215L12 18l-2.679 3.593a1 1 0 0 1-1.39.213l-1.865-1.353a1 1 0 0 1-.203-1.422z",
      key: "nmifey"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rocket = createLucideIcon("Rocket", [
  [
    "path",
    {
      d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z",
      key: "m3kijz"
    }
  ],
  [
    "path",
    {
      d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z",
      key: "1fmvmk"
    }
  ],
  ["path", { d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0", key: "1f8sc4" }],
  ["path", { d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5", key: "qeys4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RockingChair = createLucideIcon("RockingChair", [
  ["polyline", { points: "3.5 2 6.5 12.5 18 12.5", key: "y3iy52" }],
  ["line", { x1: "9.5", x2: "5.5", y1: "12.5", y2: "20", key: "19vg5i" }],
  ["line", { x1: "15", x2: "18.5", y1: "12.5", y2: "20", key: "1inpmv" }],
  ["path", { d: "M2.75 18a13 13 0 0 0 18.5 0", key: "1nquas" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RollerCoaster = createLucideIcon("RollerCoaster", [
  ["path", { d: "M6 19V5", key: "1r845m" }],
  ["path", { d: "M10 19V6.8", key: "9j2tfs" }],
  ["path", { d: "M14 19v-7.8", key: "10s8qv" }],
  ["path", { d: "M18 5v4", key: "1tajlv" }],
  ["path", { d: "M18 19v-6", key: "ielfq3" }],
  ["path", { d: "M22 19V9", key: "158nzp" }],
  ["path", { d: "M2 19V9a4 4 0 0 1 4-4c2 0 4 1.33 6 4s4 4 6 4a4 4 0 1 0-3-6.65", key: "1930oh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rotate3d = createLucideIcon("Rotate3d", [
  [
    "path",
    {
      d: "M16.466 7.5C15.643 4.237 13.952 2 12 2 9.239 2 7 6.477 7 12s2.239 10 5 10c.342 0 .677-.069 1-.2",
      key: "10n0gc"
    }
  ],
  ["path", { d: "m15.194 13.707 3.814 1.86-1.86 3.814", key: "16shm9" }],
  [
    "path",
    {
      d: "M19 15.57c-1.804.885-4.274 1.43-7 1.43-5.523 0-10-2.239-10-5s4.477-5 10-5c4.838 0 8.873 1.718 9.8 4",
      key: "1lxi77"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RotateCcwSquare = createLucideIcon("RotateCcwSquare", [
  ["path", { d: "M20 9V7a2 2 0 0 0-2-2h-6", key: "19z8uc" }],
  ["path", { d: "m15 2-3 3 3 3", key: "177bxs" }],
  ["path", { d: "M20 13v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2", key: "d36hnl" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RotateCcw = createLucideIcon("RotateCcw", [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RotateCwSquare = createLucideIcon("RotateCwSquare", [
  ["path", { d: "M12 5H6a2 2 0 0 0-2 2v3", key: "l96uqu" }],
  ["path", { d: "m9 8 3-3-3-3", key: "1gzgc3" }],
  ["path", { d: "M4 14v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2", key: "1w2k5h" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RotateCw = createLucideIcon("RotateCw", [
  ["path", { d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8", key: "1p45f6" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RouteOff = createLucideIcon("RouteOff", [
  ["circle", { cx: "6", cy: "19", r: "3", key: "1kj8tv" }],
  ["path", { d: "M9 19h8.5c.4 0 .9-.1 1.3-.2", key: "1effex" }],
  ["path", { d: "M5.2 5.2A3.5 3.53 0 0 0 6.5 12H12", key: "k9y2ds" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M21 15.3a3.5 3.5 0 0 0-3.3-3.3", key: "11nlu2" }],
  ["path", { d: "M15 5h-4.3", key: "6537je" }],
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Route = createLucideIcon("Route", [
  ["circle", { cx: "6", cy: "19", r: "3", key: "1kj8tv" }],
  ["path", { d: "M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15", key: "1d8sl" }],
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Router = createLucideIcon("Router", [
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6.01 18H6", key: "19vcac" }],
  ["path", { d: "M10.01 18H10", key: "uamcmx" }],
  ["path", { d: "M15 10v4", key: "qjz1xs" }],
  ["path", { d: "M17.84 7.17a4 4 0 0 0-5.66 0", key: "1rif40" }],
  ["path", { d: "M20.66 4.34a8 8 0 0 0-11.31 0", key: "6a5xfq" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rows2 = createLucideIcon("Rows2", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rows3 = createLucideIcon("Rows3", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 9H3", key: "1338ky" }],
  ["path", { d: "M21 15H3", key: "9uk58r" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rows4 = createLucideIcon("Rows4", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 7.5H3", key: "1hm9pq" }],
  ["path", { d: "M21 12H3", key: "2avoz0" }],
  ["path", { d: "M21 16.5H3", key: "n7jzkj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rss = createLucideIcon("Rss", [
  ["path", { d: "M4 11a9 9 0 0 1 9 9", key: "pv89mb" }],
  ["path", { d: "M4 4a16 16 0 0 1 16 16", key: "k0647b" }],
  ["circle", { cx: "5", cy: "19", r: "1", key: "bfqh0e" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ruler = createLucideIcon("Ruler", [
  [
    "path",
    {
      d: "M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z",
      key: "icamh8"
    }
  ],
  ["path", { d: "m14.5 12.5 2-2", key: "inckbg" }],
  ["path", { d: "m11.5 9.5 2-2", key: "fmmyf7" }],
  ["path", { d: "m8.5 6.5 2-2", key: "vc6u1g" }],
  ["path", { d: "m17.5 15.5 2-2", key: "wo5hmg" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RussianRuble = createLucideIcon("RussianRuble", [
  ["path", { d: "M6 11h8a4 4 0 0 0 0-8H9v18", key: "18ai8t" }],
  ["path", { d: "M6 15h8", key: "1y8f6l" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sailboat = createLucideIcon("Sailboat", [
  ["path", { d: "M22 18H2a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4Z", key: "1404fh" }],
  ["path", { d: "M21 14 10 2 3 14h18Z", key: "1nzg7v" }],
  ["path", { d: "M10 2v16", key: "1labyt" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Salad = createLucideIcon("Salad", [
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z", key: "4rw317" }],
  [
    "path",
    {
      d: "M11.38 12a2.4 2.4 0 0 1-.4-4.77 2.4 2.4 0 0 1 3.2-2.77 2.4 2.4 0 0 1 3.47-.63 2.4 2.4 0 0 1 3.37 3.37 2.4 2.4 0 0 1-1.1 3.7 2.51 2.51 0 0 1 .03 1.1",
      key: "10xrj0"
    }
  ],
  ["path", { d: "m13 12 4-4", key: "1hckqy" }],
  ["path", { d: "M10.9 7.25A3.99 3.99 0 0 0 4 10c0 .73.2 1.41.54 2", key: "1p4srx" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sandwich = createLucideIcon("Sandwich", [
  ["path", { d: "m2.37 11.223 8.372-6.777a2 2 0 0 1 2.516 0l8.371 6.777", key: "f1wd0e" }],
  ["path", { d: "M21 15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-5.25", key: "1pfu07" }],
  ["path", { d: "M3 15a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h9", key: "1oq9qw" }],
  ["path", { d: "m6.67 15 6.13 4.6a2 2 0 0 0 2.8-.4l3.15-4.2", key: "1fnwu5" }],
  ["rect", { width: "20", height: "4", x: "2", y: "11", rx: "1", key: "itshg" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SatelliteDish = createLucideIcon("SatelliteDish", [
  ["path", { d: "M4 10a7.31 7.31 0 0 0 10 10Z", key: "1fzpp3" }],
  ["path", { d: "m9 15 3-3", key: "88sc13" }],
  ["path", { d: "M17 13a6 6 0 0 0-6-6", key: "15cc6u" }],
  ["path", { d: "M21 13A10 10 0 0 0 11 3", key: "11nf8s" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Satellite = createLucideIcon("Satellite", [
  ["path", { d: "M13 7 9 3 5 7l4 4", key: "vyckw6" }],
  ["path", { d: "m17 11 4 4-4 4-4-4", key: "rchckc" }],
  ["path", { d: "m8 12 4 4 6-6-4-4Z", key: "1sshf7" }],
  ["path", { d: "m16 8 3-3", key: "x428zp" }],
  ["path", { d: "M9 21a6 6 0 0 0-6-6", key: "1iajcf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SaveAll = createLucideIcon("SaveAll", [
  ["path", { d: "M10 2v3a1 1 0 0 0 1 1h5", key: "1xspal" }],
  ["path", { d: "M18 18v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6", key: "1ra60u" }],
  ["path", { d: "M18 22H4a2 2 0 0 1-2-2V6", key: "pblm9e" }],
  [
    "path",
    {
      d: "M8 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9.172a2 2 0 0 1 1.414.586l2.828 2.828A2 2 0 0 1 22 6.828V16a2 2 0 0 1-2.01 2z",
      key: "1yve0x"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SaveOff = createLucideIcon("SaveOff", [
  ["path", { d: "M13 13H8a1 1 0 0 0-1 1v7", key: "h8g396" }],
  ["path", { d: "M14 8h1", key: "1lfen6" }],
  ["path", { d: "M17 21v-4", key: "1yknxs" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    { d: "M20.41 20.41A2 2 0 0 1 19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 .59-1.41", key: "1t4vdl" }
  ],
  ["path", { d: "M29.5 11.5s5 5 4 5", key: "zzn4i6" }],
  ["path", { d: "M9 3h6.2a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V15", key: "24cby9" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Save = createLucideIcon("Save", [
  [
    "path",
    {
      d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
      key: "1c8476"
    }
  ],
  ["path", { d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7", key: "1ydtos" }],
  ["path", { d: "M7 3v4a1 1 0 0 0 1 1h7", key: "t51u73" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Scale3d = createLucideIcon("Scale3d", [
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["circle", { cx: "5", cy: "5", r: "2", key: "1gwv83" }],
  ["path", { d: "M5 7v12h12", key: "vtaa4r" }],
  ["path", { d: "m5 19 6-6", key: "jh6hbb" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Scale = createLucideIcon("Scale", [
  ["path", { d: "m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z", key: "7g6ntu" }],
  ["path", { d: "m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z", key: "ijws7r" }],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["path", { d: "M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2", key: "3gwbw2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Scaling = createLucideIcon("Scaling", [
  ["path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7", key: "1m0v6g" }],
  ["path", { d: "M14 15H9v-5", key: "pi4jk9" }],
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M21 3 9 15", key: "15kdhq" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ScanBarcode = createLucideIcon("ScanBarcode", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M8 7v10", key: "23sfjj" }],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M17 7v10", key: "578dap" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ScanEye = createLucideIcon("ScanEye", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  [
    "path",
    {
      d: "M18.944 12.33a1 1 0 0 0 0-.66 7.5 7.5 0 0 0-13.888 0 1 1 0 0 0 0 .66 7.5 7.5 0 0 0 13.888 0",
      key: "11ak4c"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ScanFace = createLucideIcon("ScanFace", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ScanLine = createLucideIcon("ScanLine", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ScanQrCode = createLucideIcon("ScanQrCode", [
  ["path", { d: "M17 12v4a1 1 0 0 1-1 1h-4", key: "uk4fdo" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M17 8V7", key: "q2g9wo" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M7 17h.01", key: "19xn7k" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["rect", { x: "7", y: "7", width: "5", height: "5", rx: "1", key: "m9kyts" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ScanSearch = createLucideIcon("ScanSearch", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m16 16-1.9-1.9", key: "1dq9hf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ScanText = createLucideIcon("ScanText", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M7 8h8", key: "1jbsf9" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M7 16h6", key: "1vyc9m" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Scan = createLucideIcon("Scan", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const School = createLucideIcon("School", [
  ["path", { d: "M14 22v-4a2 2 0 1 0-4 0v4", key: "hhkicm" }],
  ["path", { d: "m18 10 4 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8l4-2", key: "1vwozw" }],
  ["path", { d: "M18 5v17", key: "1sw6gf" }],
  ["path", { d: "m4 6 8-4 8 4", key: "1q0ilc" }],
  ["path", { d: "M6 5v17", key: "1xfsm0" }],
  ["circle", { cx: "12", cy: "9", r: "2", key: "1092wv" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ScissorsLineDashed = createLucideIcon("ScissorsLineDashed", [
  ["path", { d: "M5.42 9.42 8 12", key: "12pkuq" }],
  ["circle", { cx: "4", cy: "8", r: "2", key: "107mxr" }],
  ["path", { d: "m14 6-8.58 8.58", key: "gvzu5l" }],
  ["circle", { cx: "4", cy: "16", r: "2", key: "1ehqvc" }],
  ["path", { d: "M10.8 14.8 14 18", key: "ax7m9r" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Scissors = createLucideIcon("Scissors", [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M8.12 8.12 12 12", key: "1alkpv" }],
  ["path", { d: "M20 4 8.12 15.88", key: "xgtan2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["path", { d: "M14.8 14.8 20 20", key: "ptml3r" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ScreenShareOff = createLucideIcon("ScreenShareOff", [
  ["path", { d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3", key: "i8wdob" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m22 3-5 5", key: "12jva0" }],
  ["path", { d: "m17 3 5 5", key: "k36vhe" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ScreenShare = createLucideIcon("ScreenShare", [
  ["path", { d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3", key: "i8wdob" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m17 8 5-5", key: "fqif7o" }],
  ["path", { d: "M17 3h5v5", key: "1o3tu8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ScrollText = createLucideIcon("ScrollText", [
  ["path", { d: "M15 12h-5", key: "r7krc0" }],
  ["path", { d: "M15 8h-5", key: "1khuty" }],
  ["path", { d: "M19 17V5a2 2 0 0 0-2-2H4", key: "zz82l3" }],
  [
    "path",
    {
      d: "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3",
      key: "1ph1d7"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Scroll = createLucideIcon("Scroll", [
  ["path", { d: "M19 17V5a2 2 0 0 0-2-2H4", key: "zz82l3" }],
  [
    "path",
    {
      d: "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3",
      key: "1ph1d7"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SearchCheck = createLucideIcon("SearchCheck", [
  ["path", { d: "m8 11 2 2 4-4", key: "1sed1v" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SearchCode = createLucideIcon("SearchCode", [
  ["path", { d: "m13 13.5 2-2.5-2-2.5", key: "1rvxrh" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }],
  ["path", { d: "M9 8.5 7 11l2 2.5", key: "6ffwbx" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SearchSlash = createLucideIcon("SearchSlash", [
  ["path", { d: "m13.5 8.5-5 5", key: "1cs55j" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SearchX = createLucideIcon("SearchX", [
  ["path", { d: "m13.5 8.5-5 5", key: "1cs55j" }],
  ["path", { d: "m8.5 8.5 5 5", key: "a8mexj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Search = createLucideIcon("Search", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Section = createLucideIcon("Section", [
  ["path", { d: "M16 5a4 3 0 0 0-8 0c0 4 8 3 8 7a4 3 0 0 1-8 0", key: "vqan6v" }],
  ["path", { d: "M8 19a4 3 0 0 0 8 0c0-4-8-3-8-7a4 3 0 0 1 8 0", key: "wdjd8o" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SendHorizontal = createLucideIcon("SendHorizontal", [
  [
    "path",
    {
      d: "M3.714 3.048a.498.498 0 0 0-.683.627l2.843 7.627a2 2 0 0 1 0 1.396l-2.842 7.627a.498.498 0 0 0 .682.627l18-8.5a.5.5 0 0 0 0-.904z",
      key: "117uat"
    }
  ],
  ["path", { d: "M6 12h16", key: "s4cdu5" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SendToBack = createLucideIcon("SendToBack", [
  ["rect", { x: "14", y: "14", width: "8", height: "8", rx: "2", key: "1b0bso" }],
  ["rect", { x: "2", y: "2", width: "8", height: "8", rx: "2", key: "1x09vl" }],
  ["path", { d: "M7 14v1a2 2 0 0 0 2 2h1", key: "pao6x6" }],
  ["path", { d: "M14 7h1a2 2 0 0 1 2 2v1", key: "19tdru" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Send = createLucideIcon("Send", [
  [
    "path",
    {
      d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
      key: "1ffxy3"
    }
  ],
  ["path", { d: "m21.854 2.147-10.94 10.939", key: "12cjpa" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SeparatorHorizontal = createLucideIcon("SeparatorHorizontal", [
  ["line", { x1: "3", x2: "21", y1: "12", y2: "12", key: "10d38w" }],
  ["polyline", { points: "8 8 12 4 16 8", key: "zo8t4w" }],
  ["polyline", { points: "16 16 12 20 8 16", key: "1oyrid" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SeparatorVertical = createLucideIcon("SeparatorVertical", [
  ["line", { x1: "12", x2: "12", y1: "3", y2: "21", key: "1efggb" }],
  ["polyline", { points: "8 8 4 12 8 16", key: "bnfmv4" }],
  ["polyline", { points: "16 16 20 12 16 8", key: "u90052" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ServerCog = createLucideIcon("ServerCog", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  [
    "path",
    {
      d: "M4.5 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-.5",
      key: "tn8das"
    }
  ],
  [
    "path",
    {
      d: "M4.5 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-.5",
      key: "1g2pve"
    }
  ],
  ["path", { d: "M6 6h.01", key: "1utrut" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m15.7 13.4-.9-.3", key: "1jwmzr" }],
  ["path", { d: "m9.2 10.9-.9-.3", key: "qapnim" }],
  ["path", { d: "m10.6 15.7.3-.9", key: "quwk0k" }],
  ["path", { d: "m13.6 15.7-.4-1", key: "cb9xp7" }],
  ["path", { d: "m10.8 9.3-.4-1", key: "1uaiz5" }],
  ["path", { d: "m8.3 13.6 1-.4", key: "s6srou" }],
  ["path", { d: "m14.7 10.8 1-.4", key: "4d31cq" }],
  ["path", { d: "m13.4 8.3-.3.9", key: "1bm987" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ServerCrash = createLucideIcon("ServerCrash", [
  [
    "path",
    {
      d: "M6 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2",
      key: "4b9dqc"
    }
  ],
  [
    "path",
    {
      d: "M6 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2",
      key: "22nnkd"
    }
  ],
  ["path", { d: "M6 6h.01", key: "1utrut" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m13 6-4 6h6l-4 6", key: "14hqih" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ServerOff = createLucideIcon("ServerOff", [
  ["path", { d: "M7 2h13a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5", key: "bt2siv" }],
  ["path", { d: "M10 10 2.5 2.5C2 2 2 2.5 2 5v3a2 2 0 0 0 2 2h6z", key: "1hjrv1" }],
  ["path", { d: "M22 17v-1a2 2 0 0 0-2-2h-1", key: "1iynyr" }],
  ["path", { d: "M4 14a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16.5l1-.5.5.5-8-8H4z", key: "161ggg" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Server = createLucideIcon("Server", [
  ["rect", { width: "20", height: "8", x: "2", y: "2", rx: "2", ry: "2", key: "ngkwjq" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", ry: "2", key: "iecqi9" }],
  ["line", { x1: "6", x2: "6.01", y1: "6", y2: "6", key: "16zg32" }],
  ["line", { x1: "6", x2: "6.01", y1: "18", y2: "18", key: "nzw8ys" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Settings2 = createLucideIcon("Settings2", [
  ["path", { d: "M20 7h-9", key: "3s1dr2" }],
  ["path", { d: "M14 17H5", key: "gfn3mx" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
  ["circle", { cx: "7", cy: "7", r: "3", key: "dfmy0x" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Settings$1 = createLucideIcon("Settings", [
  [
    "path",
    {
      d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
      key: "1qme2f"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Shapes = createLucideIcon("Shapes", [
  [
    "path",
    {
      d: "M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1Z",
      key: "1bo67w"
    }
  ],
  ["rect", { x: "3", y: "14", width: "7", height: "7", rx: "1", key: "1bkyp8" }],
  ["circle", { cx: "17.5", cy: "17.5", r: "3.5", key: "w3z12y" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Share2 = createLucideIcon("Share2", [
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }],
  ["circle", { cx: "6", cy: "12", r: "3", key: "w7nqdw" }],
  ["circle", { cx: "18", cy: "19", r: "3", key: "1xt0gg" }],
  ["line", { x1: "8.59", x2: "15.42", y1: "13.51", y2: "17.49", key: "47mynk" }],
  ["line", { x1: "15.41", x2: "8.59", y1: "6.51", y2: "10.49", key: "1n3mei" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Share = createLucideIcon("Share", [
  ["path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8", key: "1b2hhj" }],
  ["polyline", { points: "16 6 12 2 8 6", key: "m901s6" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "15", key: "1p0rca" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sheet = createLucideIcon("Sheet", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["line", { x1: "3", x2: "21", y1: "9", y2: "9", key: "1vqk6q" }],
  ["line", { x1: "3", x2: "21", y1: "15", y2: "15", key: "o2sbyz" }],
  ["line", { x1: "9", x2: "9", y1: "9", y2: "21", key: "1ib60c" }],
  ["line", { x1: "15", x2: "15", y1: "9", y2: "21", key: "1n26ft" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Shell = createLucideIcon("Shell", [
  [
    "path",
    {
      d: "M14 11a2 2 0 1 1-4 0 4 4 0 0 1 8 0 6 6 0 0 1-12 0 8 8 0 0 1 16 0 10 10 0 1 1-20 0 11.93 11.93 0 0 1 2.42-7.22 2 2 0 1 1 3.16 2.44",
      key: "1cn552"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ShieldAlert = createLucideIcon("ShieldAlert", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  ["path", { d: "M12 16h.01", key: "1drbdi" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ShieldBan = createLucideIcon("ShieldBan", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m4.243 5.21 14.39 12.472", key: "1c9a7c" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ShieldCheck = createLucideIcon("ShieldCheck", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ShieldEllipsis = createLucideIcon("ShieldEllipsis", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ShieldHalf = createLucideIcon("ShieldHalf", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M12 22V2", key: "zs6s6o" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ShieldMinus = createLucideIcon("ShieldMinus", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ShieldOff = createLucideIcon("ShieldOff", [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "M5 5a1 1 0 0 0-1 1v7c0 5 3.5 7.5 7.67 8.94a1 1 0 0 0 .67.01c2.35-.82 4.48-1.97 5.9-3.71",
      key: "1jlk70"
    }
  ],
  [
    "path",
    {
      d: "M9.309 3.652A12.252 12.252 0 0 0 11.24 2.28a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v7a9.784 9.784 0 0 1-.08 1.264",
      key: "18rp1v"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ShieldPlus = createLucideIcon("ShieldPlus", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M12 9v6", key: "199k2o" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ShieldQuestion = createLucideIcon("ShieldQuestion", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3", key: "mhlwft" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ShieldX = createLucideIcon("ShieldX", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m14.5 9.5-5 5", key: "17q4r4" }],
  ["path", { d: "m9.5 9.5 5 5", key: "18nt4w" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Shield = createLucideIcon("Shield", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ShipWheel = createLucideIcon("ShipWheel", [
  ["circle", { cx: "12", cy: "12", r: "8", key: "46899m" }],
  ["path", { d: "M12 2v7.5", key: "1e5rl5" }],
  ["path", { d: "m19 5-5.23 5.23", key: "1ezxxf" }],
  ["path", { d: "M22 12h-7.5", key: "le1719" }],
  ["path", { d: "m19 19-5.23-5.23", key: "p3fmgn" }],
  ["path", { d: "M12 14.5V22", key: "dgcmos" }],
  ["path", { d: "M10.23 13.77 5 19", key: "qwopd4" }],
  ["path", { d: "M9.5 12H2", key: "r7bup8" }],
  ["path", { d: "M10.23 10.23 5 5", key: "k2y7lj" }],
  ["circle", { cx: "12", cy: "12", r: "2.5", key: "ix0uyj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ship = createLucideIcon("Ship", [
  [
    "path",
    {
      d: "M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1 .6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "iegodh"
    }
  ],
  [
    "path",
    { d: "M19.38 20A11.6 11.6 0 0 0 21 14l-9-4-9 4c0 2.9.94 5.34 2.81 7.76", key: "fp8vka" }
  ],
  ["path", { d: "M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6", key: "qpkstq" }],
  ["path", { d: "M12 10v4", key: "1kjpxc" }],
  ["path", { d: "M12 2v3", key: "qbqxhf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Shirt = createLucideIcon("Shirt", [
  [
    "path",
    {
      d: "M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z",
      key: "1wgbhj"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ShoppingBag = createLucideIcon("ShoppingBag", [
  ["path", { d: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z", key: "hou9p0" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M16 10a4 4 0 0 1-8 0", key: "1ltviw" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ShoppingBasket = createLucideIcon("ShoppingBasket", [
  ["path", { d: "m15 11-1 9", key: "5wnq3a" }],
  ["path", { d: "m19 11-4-7", key: "cnml18" }],
  ["path", { d: "M2 11h20", key: "3eubbj" }],
  ["path", { d: "m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4", key: "yiazzp" }],
  ["path", { d: "M4.5 15.5h15", key: "13mye1" }],
  ["path", { d: "m5 11 4-7", key: "116ra9" }],
  ["path", { d: "m9 11 1 9", key: "1ojof7" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ShoppingCart = createLucideIcon("ShoppingCart", [
  ["circle", { cx: "8", cy: "21", r: "1", key: "jimo8o" }],
  ["circle", { cx: "19", cy: "21", r: "1", key: "13723u" }],
  [
    "path",
    {
      d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
      key: "9zh506"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Shovel = createLucideIcon("Shovel", [
  ["path", { d: "M2 22v-5l5-5 5 5-5 5z", key: "1fh25c" }],
  ["path", { d: "M9.5 14.5 16 8", key: "1smz5x" }],
  [
    "path",
    { d: "m17 2 5 5-.5.5a3.53 3.53 0 0 1-5 0s0 0 0 0a3.53 3.53 0 0 1 0-5L17 2", key: "1q8uv5" }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ShowerHead = createLucideIcon("ShowerHead", [
  ["path", { d: "m4 4 2.5 2.5", key: "uv2vmf" }],
  ["path", { d: "M13.5 6.5a4.95 4.95 0 0 0-7 7", key: "frdkwv" }],
  ["path", { d: "M15 5 5 15", key: "1ag8rq" }],
  ["path", { d: "M14 17v.01", key: "eokfpp" }],
  ["path", { d: "M10 16v.01", key: "14uyyl" }],
  ["path", { d: "M13 13v.01", key: "1v1k97" }],
  ["path", { d: "M16 10v.01", key: "5169yg" }],
  ["path", { d: "M11 20v.01", key: "cj92p8" }],
  ["path", { d: "M17 14v.01", key: "11cswd" }],
  ["path", { d: "M20 11v.01", key: "19e0od" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Shrink = createLucideIcon("Shrink", [
  ["path", { d: "m15 15 6 6m-6-6v4.8m0-4.8h4.8", key: "17vawe" }],
  ["path", { d: "M9 19.8V15m0 0H4.2M9 15l-6 6", key: "chjx8e" }],
  ["path", { d: "M15 4.2V9m0 0h4.8M15 9l6-6", key: "lav6yq" }],
  ["path", { d: "M9 4.2V9m0 0H4.2M9 9 3 3", key: "1pxi2q" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Shrub = createLucideIcon("Shrub", [
  ["path", { d: "M12 22v-7l-2-2", key: "eqv9mc" }],
  ["path", { d: "M17 8v.8A6 6 0 0 1 13.8 20H10A6.5 6.5 0 0 1 7 8a5 5 0 0 1 10 0Z", key: "ubcgy" }],
  ["path", { d: "m14 14-2 2", key: "847xa2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Shuffle = createLucideIcon("Shuffle", [
  ["path", { d: "M2 18h1.4c1.3 0 2.5-.6 3.3-1.7l6.1-8.6c.7-1.1 2-1.7 3.3-1.7H22", key: "1wmou1" }],
  ["path", { d: "m18 2 4 4-4 4", key: "pucp1d" }],
  ["path", { d: "M2 6h1.9c1.5 0 2.9.9 3.6 2.2", key: "10bdb2" }],
  ["path", { d: "M22 18h-5.9c-1.3 0-2.6-.7-3.3-1.8l-.5-.8", key: "vgxac0" }],
  ["path", { d: "m18 14 4 4-4 4", key: "10pe0f" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sigma = createLucideIcon("Sigma", [
  [
    "path",
    {
      d: "M18 7V5a1 1 0 0 0-1-1H6.5a.5.5 0 0 0-.4.8l4.5 6a2 2 0 0 1 0 2.4l-4.5 6a.5.5 0 0 0 .4.8H17a1 1 0 0 0 1-1v-2",
      key: "wuwx1p"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SignalHigh = createLucideIcon("SignalHigh", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M17 20V8", key: "1tkaf5" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SignalLow = createLucideIcon("SignalLow", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SignalMedium = createLucideIcon("SignalMedium", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SignalZero = createLucideIcon("SignalZero", [["path", { d: "M2 20h.01", key: "4haj6o" }]]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Signal = createLucideIcon("Signal", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M17 20V8", key: "1tkaf5" }],
  ["path", { d: "M22 4v16", key: "sih9yq" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Signature = createLucideIcon("Signature", [
  [
    "path",
    {
      d: "m21 17-2.156-1.868A.5.5 0 0 0 18 15.5v.5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1c0-2.545-3.991-3.97-8.5-4a1 1 0 0 0 0 5c4.153 0 4.745-11.295 5.708-13.5a2.5 2.5 0 1 1 3.31 3.284",
      key: "y32ogt"
    }
  ],
  ["path", { d: "M3 21h18", key: "itz85i" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SignpostBig = createLucideIcon("SignpostBig", [
  ["path", { d: "M10 9H4L2 7l2-2h6", key: "1hq7x2" }],
  ["path", { d: "M14 5h6l2 2-2 2h-6", key: "bv62ej" }],
  ["path", { d: "M10 22V4a2 2 0 1 1 4 0v18", key: "eqpcf2" }],
  ["path", { d: "M8 22h8", key: "rmew8v" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Signpost = createLucideIcon("Signpost", [
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M12 3v3", key: "1n5kay" }],
  [
    "path",
    {
      d: "M18 6a2 2 0 0 1 1.387.56l2.307 2.22a1 1 0 0 1 0 1.44l-2.307 2.22A2 2 0 0 1 18 13H6a2 2 0 0 1-1.387-.56l-2.306-2.22a1 1 0 0 1 0-1.44l2.306-2.22A2 2 0 0 1 6 6z",
      key: "gqqp9m"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Siren = createLucideIcon("Siren", [
  ["path", { d: "M7 18v-6a5 5 0 1 1 10 0v6", key: "pcx96s" }],
  [
    "path",
    { d: "M5 21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2z", key: "1b4s83" }
  ],
  ["path", { d: "M21 12h1", key: "jtio3y" }],
  ["path", { d: "M18.5 4.5 18 5", key: "g5sp9y" }],
  ["path", { d: "M2 12h1", key: "1uaihz" }],
  ["path", { d: "M12 2v1", key: "11qlp1" }],
  ["path", { d: "m4.929 4.929.707.707", key: "1i51kw" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SkipBack = createLucideIcon("SkipBack", [
  ["polygon", { points: "19 20 9 12 19 4 19 20", key: "o2sva" }],
  ["line", { x1: "5", x2: "5", y1: "19", y2: "5", key: "1ocqjk" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SkipForward = createLucideIcon("SkipForward", [
  ["polygon", { points: "5 4 15 12 5 20 5 4", key: "16p6eg" }],
  ["line", { x1: "19", x2: "19", y1: "5", y2: "19", key: "futhcm" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Skull = createLucideIcon("Skull", [
  ["path", { d: "m12.5 17-.5-1-.5 1h1z", key: "3me087" }],
  [
    "path",
    {
      d: "M15 22a1 1 0 0 0 1-1v-1a2 2 0 0 0 1.56-3.25 8 8 0 1 0-11.12 0A2 2 0 0 0 8 20v1a1 1 0 0 0 1 1z",
      key: "1o5pge"
    }
  ],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Slack = createLucideIcon("Slack", [
  ["rect", { width: "3", height: "8", x: "13", y: "2", rx: "1.5", key: "diqz80" }],
  ["path", { d: "M19 8.5V10h1.5A1.5 1.5 0 1 0 19 8.5", key: "183iwg" }],
  ["rect", { width: "3", height: "8", x: "8", y: "14", rx: "1.5", key: "hqg7r1" }],
  ["path", { d: "M5 15.5V14H3.5A1.5 1.5 0 1 0 5 15.5", key: "76g71w" }],
  ["rect", { width: "8", height: "3", x: "14", y: "13", rx: "1.5", key: "1kmz0a" }],
  ["path", { d: "M15.5 19H14v1.5a1.5 1.5 0 1 0 1.5-1.5", key: "jc4sz0" }],
  ["rect", { width: "8", height: "3", x: "2", y: "8", rx: "1.5", key: "1omvl4" }],
  ["path", { d: "M8.5 5H10V3.5A1.5 1.5 0 1 0 8.5 5", key: "16f3cl" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Slash = createLucideIcon("Slash", [["path", { d: "M22 2 2 22", key: "y4kqgn" }]]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Slice = createLucideIcon("Slice", [
  ["path", { d: "m8 14-6 6h9v-3", key: "zo3j9a" }],
  ["path", { d: "M18.37 3.63 8 14l3 3L21.37 6.63a2.12 2.12 0 1 0-3-3Z", key: "1dzx0j" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SlidersHorizontal = createLucideIcon("SlidersHorizontal", [
  ["line", { x1: "21", x2: "14", y1: "4", y2: "4", key: "obuewd" }],
  ["line", { x1: "10", x2: "3", y1: "4", y2: "4", key: "1q6298" }],
  ["line", { x1: "21", x2: "12", y1: "12", y2: "12", key: "1iu8h1" }],
  ["line", { x1: "8", x2: "3", y1: "12", y2: "12", key: "ntss68" }],
  ["line", { x1: "21", x2: "16", y1: "20", y2: "20", key: "14d8ph" }],
  ["line", { x1: "12", x2: "3", y1: "20", y2: "20", key: "m0wm8r" }],
  ["line", { x1: "14", x2: "14", y1: "2", y2: "6", key: "14e1ph" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "16", x2: "16", y1: "18", y2: "22", key: "1lctlv" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SlidersVertical = createLucideIcon("SlidersVertical", [
  ["line", { x1: "4", x2: "4", y1: "21", y2: "14", key: "1p332r" }],
  ["line", { x1: "4", x2: "4", y1: "10", y2: "3", key: "gb41h5" }],
  ["line", { x1: "12", x2: "12", y1: "21", y2: "12", key: "hf2csr" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "3", key: "1kfi7u" }],
  ["line", { x1: "20", x2: "20", y1: "21", y2: "16", key: "1lhrwl" }],
  ["line", { x1: "20", x2: "20", y1: "12", y2: "3", key: "16vvfq" }],
  ["line", { x1: "2", x2: "6", y1: "14", y2: "14", key: "1uebub" }],
  ["line", { x1: "10", x2: "14", y1: "8", y2: "8", key: "1yglbp" }],
  ["line", { x1: "18", x2: "22", y1: "16", y2: "16", key: "1jxqpz" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SmartphoneCharging = createLucideIcon("SmartphoneCharging", [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12.667 8 10 12h4l-2.667 4", key: "h9lk2d" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SmartphoneNfc = createLucideIcon("SmartphoneNfc", [
  ["rect", { width: "7", height: "12", x: "2", y: "6", rx: "1", key: "5nje8w" }],
  ["path", { d: "M13 8.32a7.43 7.43 0 0 1 0 7.36", key: "1g306n" }],
  ["path", { d: "M16.46 6.21a11.76 11.76 0 0 1 0 11.58", key: "uqvjvo" }],
  ["path", { d: "M19.91 4.1a15.91 15.91 0 0 1 .01 15.8", key: "ujntz3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Smartphone = createLucideIcon("Smartphone", [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SmilePlus = createLucideIcon("SmilePlus", [
  ["path", { d: "M22 11v1a10 10 0 1 1-9-10", key: "ew0xw9" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }],
  ["path", { d: "M16 5h6", key: "1vod17" }],
  ["path", { d: "M19 2v6", key: "4bpg5p" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Smile = createLucideIcon("Smile", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Snail = createLucideIcon("Snail", [
  ["path", { d: "M2 13a6 6 0 1 0 12 0 4 4 0 1 0-8 0 2 2 0 0 0 4 0", key: "hneq2s" }],
  ["circle", { cx: "10", cy: "13", r: "8", key: "194lz3" }],
  ["path", { d: "M2 21h12c4.4 0 8-3.6 8-8V7a2 2 0 1 0-4 0v6", key: "ixqyt7" }],
  ["path", { d: "M18 3 19.1 5.2", key: "9tjm43" }],
  ["path", { d: "M22 3 20.9 5.2", key: "j3odrs" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Snowflake = createLucideIcon("Snowflake", [
  ["line", { x1: "2", x2: "22", y1: "12", y2: "12", key: "1dnqot" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }],
  ["path", { d: "m20 16-4-4 4-4", key: "rquw4f" }],
  ["path", { d: "m4 8 4 4-4 4", key: "12s3z9" }],
  ["path", { d: "m16 4-4 4-4-4", key: "1tumq1" }],
  ["path", { d: "m8 20 4-4 4 4", key: "9p200w" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sofa = createLucideIcon("Sofa", [
  ["path", { d: "M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3", key: "1dgpiv" }],
  [
    "path",
    {
      d: "M2 16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z",
      key: "xacw8m"
    }
  ],
  ["path", { d: "M4 18v2", key: "jwo5n2" }],
  ["path", { d: "M20 18v2", key: "1ar1qi" }],
  ["path", { d: "M12 4v9", key: "oqhhn3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Soup = createLucideIcon("Soup", [
  ["path", { d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z", key: "4rw317" }],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M19.5 12 22 6", key: "shfsr5" }],
  [
    "path",
    {
      d: "M16.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.73 1.62",
      key: "rpc6vp"
    }
  ],
  [
    "path",
    {
      d: "M11.25 3c.27.1.8.53.74 1.36-.05.83-.93 1.2-.98 2.02-.06.78.33 1.24.72 1.62",
      key: "1lf63m"
    }
  ],
  [
    "path",
    { d: "M6.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.74 1.62", key: "97tijn" }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Space = createLucideIcon("Space", [
  ["path", { d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1", key: "lt2kga" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Spade = createLucideIcon("Spade", [
  [
    "path",
    {
      d: "M5 9c-1.5 1.5-3 3.2-3 5.5A5.5 5.5 0 0 0 7.5 20c1.8 0 3-.5 4.5-2 1.5 1.5 2.7 2 4.5 2a5.5 5.5 0 0 0 5.5-5.5c0-2.3-1.5-4-3-5.5l-7-7-7 7Z",
      key: "40bo9n"
    }
  ],
  ["path", { d: "M12 18v4", key: "jadmvz" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sparkle = createLucideIcon("Sparkle", [
  [
    "path",
    {
      d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
      key: "4pj2yx"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sparkles = createLucideIcon("Sparkles", [
  [
    "path",
    {
      d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
      key: "4pj2yx"
    }
  ],
  ["path", { d: "M20 3v4", key: "1olli1" }],
  ["path", { d: "M22 5h-4", key: "1gvqau" }],
  ["path", { d: "M4 17v2", key: "vumght" }],
  ["path", { d: "M5 18H3", key: "zchphs" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Speaker = createLucideIcon("Speaker", [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M12 6h.01", key: "1vi96p" }],
  ["circle", { cx: "12", cy: "14", r: "4", key: "1jruaj" }],
  ["path", { d: "M12 14h.01", key: "1etili" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Speech = createLucideIcon("Speech", [
  [
    "path",
    {
      d: "M8.8 20v-4.1l1.9.2a2.3 2.3 0 0 0 2.164-2.1V8.3A5.37 5.37 0 0 0 2 8.25c0 2.8.656 3.054 1 4.55a5.77 5.77 0 0 1 .029 2.758L2 20",
      key: "11atix"
    }
  ],
  ["path", { d: "M19.8 17.8a7.5 7.5 0 0 0 .003-10.603", key: "yol142" }],
  ["path", { d: "M17 15a3.5 3.5 0 0 0-.025-4.975", key: "ssbmkc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SpellCheck2 = createLucideIcon("SpellCheck2", [
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  [
    "path",
    {
      d: "M4 21c1.1 0 1.1-1 2.3-1s1.1 1 2.3 1c1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1",
      key: "8mdmtu"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SpellCheck = createLucideIcon("SpellCheck", [
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m16 20 2 2 4-4", key: "13tcca" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Spline = createLucideIcon("Spline", [
  ["circle", { cx: "19", cy: "5", r: "2", key: "mhkx31" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M5 17A12 12 0 0 1 17 5", key: "1okkup" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Split = createLucideIcon("Split", [
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M8 3H3v5", key: "15dfkv" }],
  ["path", { d: "M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3", key: "1qrqzj" }],
  ["path", { d: "m15 9 6-6", key: "ko1vev" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SprayCan = createLucideIcon("SprayCan", [
  ["path", { d: "M3 3h.01", key: "159qn6" }],
  ["path", { d: "M7 5h.01", key: "1hq22a" }],
  ["path", { d: "M11 7h.01", key: "1osv80" }],
  ["path", { d: "M3 7h.01", key: "1xzrh3" }],
  ["path", { d: "M7 9h.01", key: "19b3jx" }],
  ["path", { d: "M3 11h.01", key: "1eifu7" }],
  ["rect", { width: "4", height: "4", x: "15", y: "5", key: "mri9e4" }],
  ["path", { d: "m19 9 2 2v10c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1V11l2-2", key: "aib6hk" }],
  ["path", { d: "m13 14 8-2", key: "1d7bmk" }],
  ["path", { d: "m13 19 8-2", key: "1y2vml" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sprout = createLucideIcon("Sprout", [
  ["path", { d: "M7 20h10", key: "e6iznv" }],
  ["path", { d: "M10 20c5.5-2.5.8-6.4 3-10", key: "161w41" }],
  [
    "path",
    {
      d: "M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z",
      key: "9gtqwd"
    }
  ],
  [
    "path",
    {
      d: "M14.1 6a7 7 0 0 0-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2z",
      key: "bkxnd2"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareActivity = createLucideIcon("SquareActivity", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M17 12h-2l-2 5-2-10-2 5H7", key: "15hlnc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareArrowDownLeft = createLucideIcon("SquareArrowDownLeft", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m16 8-8 8", key: "166keh" }],
  ["path", { d: "M16 16H8V8", key: "1w2ppm" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareArrowDownRight = createLucideIcon("SquareArrowDownRight", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m8 8 8 8", key: "1imecy" }],
  ["path", { d: "M16 8v8H8", key: "1lbpgo" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareArrowDown = createLucideIcon("SquareArrowDown", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8 12 4 4 4-4", key: "k98ssh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareArrowLeft = createLucideIcon("SquareArrowLeft", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m12 8-4 4 4 4", key: "15vm53" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareArrowOutDownLeft = createLucideIcon("SquareArrowOutDownLeft", [
  ["path", { d: "M13 21h6a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6", key: "14qz4y" }],
  ["path", { d: "m3 21 9-9", key: "1jfql5" }],
  ["path", { d: "M9 21H3v-6", key: "wtvkvv" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareArrowOutDownRight = createLucideIcon("SquareArrowOutDownRight", [
  ["path", { d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6", key: "14rsvq" }],
  ["path", { d: "m21 21-9-9", key: "1et2py" }],
  ["path", { d: "M21 15v6h-6", key: "1jko0i" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareArrowOutUpLeft = createLucideIcon("SquareArrowOutUpLeft", [
  ["path", { d: "M13 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6", key: "14mv1t" }],
  ["path", { d: "m3 3 9 9", key: "rks13r" }],
  ["path", { d: "M3 9V3h6", key: "ira0h2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareArrowOutUpRight = createLucideIcon("SquareArrowOutUpRight", [
  ["path", { d: "M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6", key: "y09zxi" }],
  ["path", { d: "m21 3-9 9", key: "mpx6sq" }],
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareArrowRight = createLucideIcon("SquareArrowRight", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m12 16 4-4-4-4", key: "1i9zcv" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareArrowUpLeft = createLucideIcon("SquareArrowUpLeft", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 16V8h8", key: "19xb1h" }],
  ["path", { d: "M16 16 8 8", key: "1qdy8n" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareArrowUpRight = createLucideIcon("SquareArrowUpRight", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 8h8v8", key: "b65dnt" }],
  ["path", { d: "m8 16 8-8", key: "13b9ih" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareArrowUp = createLucideIcon("SquareArrowUp", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareAsterisk = createLucideIcon("SquareAsterisk", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8.5 14 7-4", key: "12hpby" }],
  ["path", { d: "m8.5 10 7 4", key: "wwy2dy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareBottomDashedScissors = createLucideIcon("SquareBottomDashedScissors", [
  [
    "path",
    { d: "M4 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2", key: "1vzg26" }
  ],
  ["path", { d: "M10 22H8", key: "euku7a" }],
  ["path", { d: "M16 22h-2", key: "18d249" }],
  ["circle", { cx: "8", cy: "8", r: "2", key: "14cg06" }],
  ["path", { d: "M9.414 9.414 12 12", key: "qz4lzr" }],
  ["path", { d: "M14.8 14.8 18 18", key: "11flf1" }],
  ["circle", { cx: "8", cy: "16", r: "2", key: "1acxsx" }],
  ["path", { d: "m18 6-8.586 8.586", key: "11kzk1" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareChartGantt = createLucideIcon("SquareChartGantt", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 8h7", key: "kbo1nt" }],
  ["path", { d: "M8 12h6", key: "ikassy" }],
  ["path", { d: "M11 16h5", key: "oq65wt" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareCheckBig = createLucideIcon("SquareCheckBig", [
  ["path", { d: "M21 10.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.5", key: "1uzm8b" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareCheck = createLucideIcon("SquareCheck", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareChevronDown = createLucideIcon("SquareChevronDown", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m16 10-4 4-4-4", key: "894hmk" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareChevronLeft = createLucideIcon("SquareChevronLeft", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m14 16-4-4 4-4", key: "ojs7w8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareChevronRight = createLucideIcon("SquareChevronRight", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m10 8 4 4-4 4", key: "1wy4r4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareChevronUp = createLucideIcon("SquareChevronUp", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m8 14 4-4 4 4", key: "fy2ptz" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareCode = createLucideIcon("SquareCode", [
  ["path", { d: "M10 9.5 8 12l2 2.5", key: "3mjy60" }],
  ["path", { d: "m14 9.5 2 2.5-2 2.5", key: "1bir2l" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareDashedBottomCode = createLucideIcon("SquareDashedBottomCode", [
  ["path", { d: "M10 9.5 8 12l2 2.5", key: "3mjy60" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "m14 9.5 2 2.5-2 2.5", key: "1bir2l" }],
  [
    "path",
    { d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2", key: "as5y1o" }
  ],
  ["path", { d: "M9 21h1", key: "15o7lz" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareDashedBottom = createLucideIcon("SquareDashedBottom", [
  [
    "path",
    { d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2", key: "as5y1o" }
  ],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareDashedKanban = createLucideIcon("SquareDashedKanban", [
  ["path", { d: "M8 7v7", key: "1x2jlm" }],
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M16 7v9", key: "1hp2iy" }],
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M21 14v1", key: "169vum" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareDashedMousePointer = createLucideIcon("SquareDashedMousePointer", [
  [
    "path",
    {
      d: "M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z",
      key: "xwnzip"
    }
  ],
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h2", key: "1qve2z" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v2", key: "p14lih" }],
  ["path", { d: "M3 14v1", key: "vnatye" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareDashed = createLucideIcon("SquareDashed", [
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M21 14v1", key: "169vum" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareDivide = createLucideIcon("SquareDivide", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "16", key: "aqc6ln" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "8", key: "1mkcni" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareDot = createLucideIcon("SquareDot", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareEqual = createLucideIcon("SquareEqual", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M7 14h10", key: "1mhdw3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareFunction = createLucideIcon("SquareFunction", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M9 17c2 0 2.8-1 2.8-2.8V10c0-2 1-3.3 3.2-3", key: "m1af9g" }],
  ["path", { d: "M9 11.2h5.7", key: "3zgcl2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareKanban = createLucideIcon("SquareKanban", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 7v7", key: "1x2jlm" }],
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M16 7v9", key: "1hp2iy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareLibrary = createLucideIcon("SquareLibrary", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 7v10", key: "d5nglc" }],
  ["path", { d: "M11 7v10", key: "pptsnr" }],
  ["path", { d: "m15 7 2 10", key: "1m7qm5" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareM = createLucideIcon("SquareM", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 16V8l4 4 4-4v8", key: "141u4e" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareMenu = createLucideIcon("SquareMenu", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 8h10", key: "1jw688" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M7 16h10", key: "wp8him" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareMinus = createLucideIcon("SquareMinus", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareMousePointer = createLucideIcon("SquareMousePointer", [
  [
    "path",
    {
      d: "M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z",
      key: "xwnzip"
    }
  ],
  ["path", { d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6", key: "14rsvq" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareParkingOff = createLucideIcon("SquareParkingOff", [
  ["path", { d: "M3.6 3.6A2 2 0 0 1 5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-.59 1.41", key: "9l1ft6" }],
  ["path", { d: "M3 8.7V19a2 2 0 0 0 2 2h10.3", key: "17knke" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M13 13a3 3 0 1 0 0-6H9v2", key: "uoagbd" }],
  ["path", { d: "M9 17v-2.3", key: "1jxgo2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareParking = createLucideIcon("SquareParking", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9", key: "1dfk2c" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquarePen = createLucideIcon("SquarePen", [
  ["path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7", key: "1m0v6g" }],
  [
    "path",
    {
      d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z",
      key: "ohrbg2"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquarePercent = createLucideIcon("SquarePercent", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquarePi = createLucideIcon("SquarePi", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 7h10", key: "udp07y" }],
  ["path", { d: "M10 7v10", key: "i1d9ee" }],
  ["path", { d: "M16 17a2 2 0 0 1-2-2V7", key: "ftwdc7" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquarePilcrow = createLucideIcon("SquarePilcrow", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 12H9.5a2.5 2.5 0 0 1 0-5H17", key: "1l9586" }],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M16 7v10", key: "lavkr4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquarePlay = createLucideIcon("SquarePlay", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m9 8 6 4-6 4Z", key: "f1r3lt" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquarePlus = createLucideIcon("SquarePlus", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquarePower = createLucideIcon("SquarePower", [
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M7.998 9.003a5 5 0 1 0 8-.005", key: "1pek45" }],
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareRadical = createLucideIcon("SquareRadical", [
  ["path", { d: "M7 12h2l2 5 2-10h4", key: "1fxv6h" }],
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareScissors = createLucideIcon("SquareScissors", [
  ["rect", { width: "20", height: "20", x: "2", y: "2", rx: "2", key: "1btzen" }],
  ["circle", { cx: "8", cy: "8", r: "2", key: "14cg06" }],
  ["path", { d: "M9.414 9.414 12 12", key: "qz4lzr" }],
  ["path", { d: "M14.8 14.8 18 18", key: "11flf1" }],
  ["circle", { cx: "8", cy: "16", r: "2", key: "1acxsx" }],
  ["path", { d: "m18 6-8.586 8.586", key: "11kzk1" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareSigma = createLucideIcon("SquareSigma", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M16 8.9V7H8l4 5-4 5h8v-1.9", key: "9nih0i" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareSlash = createLucideIcon("SquareSlash", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["line", { x1: "9", x2: "15", y1: "15", y2: "9", key: "1dfufj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareSplitHorizontal = createLucideIcon("SquareSplitHorizontal", [
  ["path", { d: "M8 19H5c-1 0-2-1-2-2V7c0-1 1-2 2-2h3", key: "lubmu8" }],
  ["path", { d: "M16 5h3c1 0 2 1 2 2v10c0 1-1 2-2 2h-3", key: "1ag34g" }],
  ["line", { x1: "12", x2: "12", y1: "4", y2: "20", key: "1tx1rr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareSplitVertical = createLucideIcon("SquareSplitVertical", [
  ["path", { d: "M5 8V5c0-1 1-2 2-2h10c1 0 2 1 2 2v3", key: "1pi83i" }],
  ["path", { d: "M19 16v3c0 1-1 2-2 2H7c-1 0-2-1-2-2v-3", key: "ido5k7" }],
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareSquare = createLucideIcon("SquareSquare", [
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }],
  ["rect", { x: "8", y: "8", width: "8", height: "8", rx: "1", key: "z9xiuo" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareStack = createLucideIcon("SquareStack", [
  ["path", { d: "M4 10c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2", key: "4i38lg" }],
  ["path", { d: "M10 16c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2", key: "mlte4a" }],
  ["rect", { width: "8", height: "8", x: "14", y: "14", rx: "2", key: "1fa9i4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareTerminal = createLucideIcon("SquareTerminal", [
  ["path", { d: "m7 11 2-2-2-2", key: "1lz0vl" }],
  ["path", { d: "M11 13h4", key: "1p7l4v" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareUserRound = createLucideIcon("SquareUserRound", [
  ["path", { d: "M18 21a6 6 0 0 0-12 0", key: "kaz2du" }],
  ["circle", { cx: "12", cy: "11", r: "4", key: "1gt34v" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareUser = createLucideIcon("SquareUser", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 21v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2", key: "1m6ac2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SquareX = createLucideIcon("SquareX", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Square = createLucideIcon("Square", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Squircle = createLucideIcon("Squircle", [
  ["path", { d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9-9 9-9-1.8-9-9 1.8-9 9-9", key: "garfkc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Squirrel = createLucideIcon("Squirrel", [
  ["path", { d: "M15.236 22a3 3 0 0 0-2.2-5", key: "21bitc" }],
  ["path", { d: "M16 20a3 3 0 0 1 3-3h1a2 2 0 0 0 2-2v-2a4 4 0 0 0-4-4V4", key: "oh0fg0" }],
  ["path", { d: "M18 13h.01", key: "9veqaj" }],
  [
    "path",
    {
      d: "M18 6a4 4 0 0 0-4 4 7 7 0 0 0-7 7c0-5 4-5 4-10.5a4.5 4.5 0 1 0-9 0 2.5 2.5 0 0 0 5 0C7 10 3 11 3 17c0 2.8 2.2 5 5 5h10",
      key: "980v8a"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Stamp = createLucideIcon("Stamp", [
  ["path", { d: "M5 22h14", key: "ehvnwv" }],
  [
    "path",
    {
      d: "M19.27 13.73A2.5 2.5 0 0 0 17.5 13h-11A2.5 2.5 0 0 0 4 15.5V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1.5c0-.66-.26-1.3-.73-1.77Z",
      key: "1sy9ra"
    }
  ],
  [
    "path",
    { d: "M14 13V8.5C14 7 15 7 15 5a3 3 0 0 0-3-3c-1.66 0-3 1-3 3s1 2 1 3.5V13", key: "cnxgux" }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const StarHalf = createLucideIcon("StarHalf", [
  [
    "path",
    {
      d: "M12 18.338a2.1 2.1 0 0 0-.987.244L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16l2.309-4.679A.53.53 0 0 1 12 2",
      key: "2ksp49"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const StarOff = createLucideIcon("StarOff", [
  ["path", { d: "M8.34 8.34 2 9.27l5 4.87L5.82 21 12 17.77 18.18 21l-.59-3.43", key: "16m0ql" }],
  ["path", { d: "M18.42 12.76 22 9.27l-6.91-1L12 2l-1.44 2.91", key: "1vt8nq" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Star = createLucideIcon("Star", [
  [
    "path",
    {
      d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
      key: "r04s7s"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const StepBack = createLucideIcon("StepBack", [
  ["line", { x1: "18", x2: "18", y1: "20", y2: "4", key: "cun8e5" }],
  ["polygon", { points: "14,20 4,12 14,4", key: "ypakod" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const StepForward = createLucideIcon("StepForward", [
  ["line", { x1: "6", x2: "6", y1: "4", y2: "20", key: "fy8qot" }],
  ["polygon", { points: "10,4 20,12 10,20", key: "1mc1pf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Stethoscope = createLucideIcon("Stethoscope", [
  ["path", { d: "M11 2v2", key: "1539x4" }],
  ["path", { d: "M5 2v2", key: "1yf1q8" }],
  ["path", { d: "M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1", key: "rb5t3r" }],
  ["path", { d: "M8 15a6 6 0 0 0 12 0v-3", key: "x18d4x" }],
  ["circle", { cx: "20", cy: "10", r: "2", key: "ts1r5v" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sticker = createLucideIcon("Sticker", [
  [
    "path",
    { d: "M15.5 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V8.5L15.5 3Z", key: "1wis1t" }
  ],
  ["path", { d: "M14 3v4a2 2 0 0 0 2 2h4", key: "36rjfy" }],
  ["path", { d: "M8 13h.01", key: "1sbv64" }],
  ["path", { d: "M16 13h.01", key: "wip0gl" }],
  ["path", { d: "M10 16s.8 1 2 1c1.3 0 2-1 2-1", key: "1vvgv3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const StickyNote = createLucideIcon("StickyNote", [
  ["path", { d: "M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8Z", key: "qazsjp" }],
  ["path", { d: "M15 3v4a2 2 0 0 0 2 2h4", key: "40519r" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Store = createLucideIcon("Store", [
  ["path", { d: "m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7", key: "ztvudi" }],
  ["path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8", key: "1b2hhj" }],
  ["path", { d: "M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4", key: "2ebpfo" }],
  ["path", { d: "M2 7h20", key: "1fcdvo" }],
  [
    "path",
    {
      d: "M22 7v3a2 2 0 0 1-2 2a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7",
      key: "6c3vgh"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const StretchHorizontal = createLucideIcon("StretchHorizontal", [
  ["rect", { width: "20", height: "6", x: "2", y: "4", rx: "2", key: "qdearl" }],
  ["rect", { width: "20", height: "6", x: "2", y: "14", rx: "2", key: "1xrn6j" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const StretchVertical = createLucideIcon("StretchVertical", [
  ["rect", { width: "6", height: "20", x: "4", y: "2", rx: "2", key: "19qu7m" }],
  ["rect", { width: "6", height: "20", x: "14", y: "2", rx: "2", key: "24v0nk" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Strikethrough = createLucideIcon("Strikethrough", [
  ["path", { d: "M16 4H9a3 3 0 0 0-2.83 4", key: "43sutm" }],
  ["path", { d: "M14 12a4 4 0 0 1 0 8H6", key: "nlfj13" }],
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Subscript = createLucideIcon("Subscript", [
  ["path", { d: "m4 5 8 8", key: "1eunvl" }],
  ["path", { d: "m12 5-8 8", key: "1ah0jp" }],
  [
    "path",
    {
      d: "M20 19h-4c0-1.5.44-2 1.5-2.5S20 15.33 20 14c0-.47-.17-.93-.48-1.29a2.11 2.11 0 0 0-2.62-.44c-.42.24-.74.62-.9 1.07",
      key: "e8ta8j"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SunDim = createLucideIcon("SunDim", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 4h.01", key: "1ujb9j" }],
  ["path", { d: "M20 12h.01", key: "1ykeid" }],
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M4 12h.01", key: "158zrr" }],
  ["path", { d: "M17.657 6.343h.01", key: "31pqzk" }],
  ["path", { d: "M17.657 17.657h.01", key: "jehnf4" }],
  ["path", { d: "M6.343 17.657h.01", key: "gdk6ow" }],
  ["path", { d: "M6.343 6.343h.01", key: "1uurf0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SunMedium = createLucideIcon("SunMedium", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 3v1", key: "1asbbs" }],
  ["path", { d: "M12 20v1", key: "1wcdkc" }],
  ["path", { d: "M3 12h1", key: "lp3yf2" }],
  ["path", { d: "M20 12h1", key: "1vloll" }],
  ["path", { d: "m18.364 5.636-.707.707", key: "1hakh0" }],
  ["path", { d: "m6.343 17.657-.707.707", key: "18m9nf" }],
  ["path", { d: "m5.636 5.636.707.707", key: "1xv1c5" }],
  ["path", { d: "m17.657 17.657.707.707", key: "vl76zb" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SunMoon = createLucideIcon("SunMoon", [
  ["path", { d: "M12 8a2.83 2.83 0 0 0 4 4 4 4 0 1 1-4-4", key: "1fu5g2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.9 4.9 1.4 1.4", key: "b9915j" }],
  ["path", { d: "m17.7 17.7 1.4 1.4", key: "qc3ed3" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.3 17.7-1.4 1.4", key: "5gca6" }],
  ["path", { d: "m19.1 4.9-1.4 1.4", key: "wpu9u6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SunSnow = createLucideIcon("SunSnow", [
  ["path", { d: "M10 9a3 3 0 1 0 0 6", key: "6zmtdl" }],
  ["path", { d: "M2 12h1", key: "1uaihz" }],
  ["path", { d: "M14 21V3", key: "1llu3z" }],
  ["path", { d: "M10 4V3", key: "pkzwkn" }],
  ["path", { d: "M10 21v-1", key: "1u8rkd" }],
  ["path", { d: "m3.64 18.36.7-.7", key: "105rm9" }],
  ["path", { d: "m4.34 6.34-.7-.7", key: "d3unjp" }],
  ["path", { d: "M14 12h8", key: "4f43i9" }],
  ["path", { d: "m17 4-3 3", key: "15jcng" }],
  ["path", { d: "m14 17 3 3", key: "6tlq38" }],
  ["path", { d: "m21 15-3-3 3-3", key: "1nlnje" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sun = createLucideIcon("Sun", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "m17.66 17.66 1.41 1.41", key: "ptbguv" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.34 17.66-1.41 1.41", key: "1m8zz5" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sunrise = createLucideIcon("Sunrise", [
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["path", { d: "m4.93 10.93 1.41 1.41", key: "2a7f42" }],
  ["path", { d: "M2 18h2", key: "j10viu" }],
  ["path", { d: "M20 18h2", key: "wocana" }],
  ["path", { d: "m19.07 10.93-1.41 1.41", key: "15zs5n" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }],
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }],
  ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sunset = createLucideIcon("Sunset", [
  ["path", { d: "M12 10V2", key: "16sf7g" }],
  ["path", { d: "m4.93 10.93 1.41 1.41", key: "2a7f42" }],
  ["path", { d: "M2 18h2", key: "j10viu" }],
  ["path", { d: "M20 18h2", key: "wocana" }],
  ["path", { d: "m19.07 10.93-1.41 1.41", key: "15zs5n" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }],
  ["path", { d: "m16 6-4 4-4-4", key: "6wukr" }],
  ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Superscript = createLucideIcon("Superscript", [
  ["path", { d: "m4 19 8-8", key: "hr47gm" }],
  ["path", { d: "m12 19-8-8", key: "1dhhmo" }],
  [
    "path",
    {
      d: "M20 12h-4c0-1.5.442-2 1.5-2.5S20 8.334 20 7.002c0-.472-.17-.93-.484-1.29a2.105 2.105 0 0 0-2.617-.436c-.42.239-.738.614-.899 1.06",
      key: "1dfcux"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SwatchBook = createLucideIcon("SwatchBook", [
  ["path", { d: "M11 17a4 4 0 0 1-8 0V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2Z", key: "1ldrpk" }],
  ["path", { d: "M16.7 13H19a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7", key: "11i5po" }],
  ["path", { d: "M 7 17h.01", key: "1euzgo" }],
  [
    "path",
    {
      d: "m11 8 2.3-2.3a2.4 2.4 0 0 1 3.404.004L18.6 7.6a2.4 2.4 0 0 1 .026 3.434L9.9 19.8",
      key: "o2gii7"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SwissFranc = createLucideIcon("SwissFranc", [
  ["path", { d: "M10 21V3h8", key: "br2l0g" }],
  ["path", { d: "M6 16h9", key: "2py0wn" }],
  ["path", { d: "M10 9.5h7", key: "13dmhz" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SwitchCamera = createLucideIcon("SwitchCamera", [
  ["path", { d: "M11 19H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h5", key: "mtk2lu" }],
  ["path", { d: "M13 5h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5", key: "120jsl" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m18 22-3-3 3-3", key: "kgdoj7" }],
  ["path", { d: "m6 2 3 3-3 3", key: "1fnbkv" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sword = createLucideIcon("Sword", [
  ["polyline", { points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5", key: "1hfsw2" }],
  ["line", { x1: "13", x2: "19", y1: "19", y2: "13", key: "1vrmhu" }],
  ["line", { x1: "16", x2: "20", y1: "16", y2: "20", key: "1bron3" }],
  ["line", { x1: "19", x2: "21", y1: "21", y2: "19", key: "13pww6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Swords = createLucideIcon("Swords", [
  ["polyline", { points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5", key: "1hfsw2" }],
  ["line", { x1: "13", x2: "19", y1: "19", y2: "13", key: "1vrmhu" }],
  ["line", { x1: "16", x2: "20", y1: "16", y2: "20", key: "1bron3" }],
  ["line", { x1: "19", x2: "21", y1: "21", y2: "19", key: "13pww6" }],
  ["polyline", { points: "14.5 6.5 18 3 21 3 21 6 17.5 9.5", key: "hbey2j" }],
  ["line", { x1: "5", x2: "9", y1: "14", y2: "18", key: "1hf58s" }],
  ["line", { x1: "7", x2: "4", y1: "17", y2: "20", key: "pidxm4" }],
  ["line", { x1: "3", x2: "5", y1: "19", y2: "21", key: "1pehsh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Syringe = createLucideIcon("Syringe", [
  ["path", { d: "m18 2 4 4", key: "22kx64" }],
  ["path", { d: "m17 7 3-3", key: "1w1zoj" }],
  ["path", { d: "M19 9 8.7 19.3c-1 1-2.5 1-3.4 0l-.6-.6c-1-1-1-2.5 0-3.4L15 5", key: "1exhtz" }],
  ["path", { d: "m9 11 4 4", key: "rovt3i" }],
  ["path", { d: "m5 19-3 3", key: "59f2uf" }],
  ["path", { d: "m14 4 6 6", key: "yqp9t2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Table2 = createLucideIcon("Table2", [
  [
    "path",
    {
      d: "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18",
      key: "gugj83"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TableCellsMerge = createLucideIcon("TableCellsMerge", [
  ["path", { d: "M12 21v-6", key: "lihzve" }],
  ["path", { d: "M12 9V3", key: "da5inc" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TableCellsSplit = createLucideIcon("TableCellsSplit", [
  ["path", { d: "M12 15V9", key: "8c7uyn" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TableColumnsSplit = createLucideIcon("TableColumnsSplit", [
  ["path", { d: "M14 14v2", key: "w2a1xv" }],
  ["path", { d: "M14 20v2", key: "1lq872" }],
  ["path", { d: "M14 2v2", key: "6buw04" }],
  ["path", { d: "M14 8v2", key: "i67w9a" }],
  ["path", { d: "M2 15h8", key: "82wtch" }],
  ["path", { d: "M2 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2", key: "up0l64" }],
  ["path", { d: "M2 9h8", key: "yelfik" }],
  ["path", { d: "M22 15h-4", key: "1es58f" }],
  ["path", { d: "M22 3h-2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2", key: "pdjoqf" }],
  ["path", { d: "M22 9h-4", key: "1luja7" }],
  ["path", { d: "M5 3v18", key: "14hmio" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TableOfContents = createLucideIcon("TableOfContents", [
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M21 12h.01", key: "msek7k" }],
  ["path", { d: "M21 18h.01", key: "1e8rq1" }],
  ["path", { d: "M21 6h.01", key: "1koanj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TableProperties = createLucideIcon("TableProperties", [
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 9H3", key: "1338ky" }],
  ["path", { d: "M21 15H3", key: "9uk58r" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TableRowsSplit = createLucideIcon("TableRowsSplit", [
  ["path", { d: "M14 10h2", key: "1lstlu" }],
  ["path", { d: "M15 22v-8", key: "1fwwgm" }],
  ["path", { d: "M15 2v4", key: "1044rn" }],
  ["path", { d: "M2 10h2", key: "1r8dkt" }],
  ["path", { d: "M20 10h2", key: "1ug425" }],
  ["path", { d: "M3 19h18", key: "awlh7x" }],
  ["path", { d: "M3 22v-6a2 2 135 0 1 2-2h14a2 2 45 0 1 2 2v6", key: "ibqhof" }],
  ["path", { d: "M3 2v2a2 2 45 0 0 2 2h14a2 2 135 0 0 2-2V2", key: "1uenja" }],
  ["path", { d: "M8 10h2", key: "66od0" }],
  ["path", { d: "M9 22v-8", key: "fmnu31" }],
  ["path", { d: "M9 2v4", key: "j1yeou" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Table = createLucideIcon("Table", [
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M3 15h18", key: "5xshup" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TabletSmartphone = createLucideIcon("TabletSmartphone", [
  ["rect", { width: "10", height: "14", x: "3", y: "8", rx: "2", key: "1vrsiq" }],
  ["path", { d: "M5 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2.4", key: "1j4zmg" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tablet = createLucideIcon("Tablet", [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", ry: "2", key: "76otgf" }],
  ["line", { x1: "12", x2: "12.01", y1: "18", y2: "18", key: "1dp563" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tablets = createLucideIcon("Tablets", [
  ["circle", { cx: "7", cy: "7", r: "5", key: "x29byf" }],
  ["circle", { cx: "17", cy: "17", r: "5", key: "1op1d2" }],
  ["path", { d: "M12 17h10", key: "ls21zv" }],
  ["path", { d: "m3.46 10.54 7.08-7.08", key: "1rehiu" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tag = createLucideIcon("Tag", [
  [
    "path",
    {
      d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
      key: "vktsd0"
    }
  ],
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tags = createLucideIcon("Tags", [
  ["path", { d: "m15 5 6.3 6.3a2.4 2.4 0 0 1 0 3.4L17 19", key: "1cbfv1" }],
  [
    "path",
    {
      d: "M9.586 5.586A2 2 0 0 0 8.172 5H3a1 1 0 0 0-1 1v5.172a2 2 0 0 0 .586 1.414L8.29 18.29a2.426 2.426 0 0 0 3.42 0l3.58-3.58a2.426 2.426 0 0 0 0-3.42z",
      key: "135mg7"
    }
  ],
  ["circle", { cx: "6.5", cy: "9.5", r: ".5", fill: "currentColor", key: "5pm5xn" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tally1 = createLucideIcon("Tally1", [["path", { d: "M4 4v16", key: "6qkkli" }]]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tally2 = createLucideIcon("Tally2", [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tally3 = createLucideIcon("Tally3", [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tally4 = createLucideIcon("Tally4", [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }],
  ["path", { d: "M19 4v16", key: "8ij5ei" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tally5 = createLucideIcon("Tally5", [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }],
  ["path", { d: "M19 4v16", key: "8ij5ei" }],
  ["path", { d: "M22 6 2 18", key: "h9moai" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tangent = createLucideIcon("Tangent", [
  ["circle", { cx: "17", cy: "4", r: "2", key: "y5j2s2" }],
  ["path", { d: "M15.59 5.41 5.41 15.59", key: "l0vprr" }],
  ["circle", { cx: "4", cy: "17", r: "2", key: "9p4efm" }],
  ["path", { d: "M12 22s-4-9-1.5-11.5S22 12 22 12", key: "1twk4o" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Target = createLucideIcon("Target", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Telescope = createLucideIcon("Telescope", [
  [
    "path",
    {
      d: "m10.065 12.493-6.18 1.318a.934.934 0 0 1-1.108-.702l-.537-2.15a1.07 1.07 0 0 1 .691-1.265l13.504-4.44",
      key: "k4qptu"
    }
  ],
  ["path", { d: "m13.56 11.747 4.332-.924", key: "19l80z" }],
  ["path", { d: "m16 21-3.105-6.21", key: "7oh9d" }],
  [
    "path",
    {
      d: "M16.485 5.94a2 2 0 0 1 1.455-2.425l1.09-.272a1 1 0 0 1 1.212.727l1.515 6.06a1 1 0 0 1-.727 1.213l-1.09.272a2 2 0 0 1-2.425-1.455z",
      key: "m7xp4m"
    }
  ],
  ["path", { d: "m6.158 8.633 1.114 4.456", key: "74o979" }],
  ["path", { d: "m8 21 3.105-6.21", key: "1fvxut" }],
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TentTree = createLucideIcon("TentTree", [
  ["circle", { cx: "4", cy: "4", r: "2", key: "bt5ra8" }],
  ["path", { d: "m14 5 3-3 3 3", key: "1sorif" }],
  ["path", { d: "m14 10 3-3 3 3", key: "1jyi9h" }],
  ["path", { d: "M17 14V2", key: "8ymqnk" }],
  ["path", { d: "M17 14H7l-5 8h20Z", key: "13ar7p" }],
  ["path", { d: "M8 14v8", key: "1ghmqk" }],
  ["path", { d: "m9 14 5 8", key: "13pgi6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tent = createLucideIcon("Tent", [
  ["path", { d: "M3.5 21 14 3", key: "1szst5" }],
  ["path", { d: "M20.5 21 10 3", key: "1310c3" }],
  ["path", { d: "M15.5 21 12 15l-3.5 6", key: "1ddtfw" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Terminal = createLucideIcon("Terminal", [
  ["polyline", { points: "4 17 10 11 4 5", key: "akl6gq" }],
  ["line", { x1: "12", x2: "20", y1: "19", y2: "19", key: "q2wloq" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TestTubeDiagonal = createLucideIcon("TestTubeDiagonal", [
  [
    "path",
    { d: "M21 7 6.82 21.18a2.83 2.83 0 0 1-3.99-.01a2.83 2.83 0 0 1 0-4L17 3", key: "1ub6xw" }
  ],
  ["path", { d: "m16 2 6 6", key: "1gw87d" }],
  ["path", { d: "M12 16H4", key: "1cjfip" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TestTube = createLucideIcon("TestTube", [
  ["path", { d: "M14.5 2v17.5c0 1.4-1.1 2.5-2.5 2.5c-1.4 0-2.5-1.1-2.5-2.5V2", key: "125lnx" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }],
  ["path", { d: "M14.5 16h-5", key: "1ox875" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TestTubes = createLucideIcon("TestTubes", [
  ["path", { d: "M9 2v17.5A2.5 2.5 0 0 1 6.5 22A2.5 2.5 0 0 1 4 19.5V2", key: "1hjrqt" }],
  ["path", { d: "M20 2v17.5a2.5 2.5 0 0 1-2.5 2.5a2.5 2.5 0 0 1-2.5-2.5V2", key: "16lc8n" }],
  ["path", { d: "M3 2h7", key: "7s29d5" }],
  ["path", { d: "M14 2h7", key: "7sicin" }],
  ["path", { d: "M9 16H4", key: "1bfye3" }],
  ["path", { d: "M20 16h-5", key: "ddnjpe" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TextCursorInput = createLucideIcon("TextCursorInput", [
  ["path", { d: "M5 4h1a3 3 0 0 1 3 3 3 3 0 0 1 3-3h1", key: "18xjzo" }],
  ["path", { d: "M13 20h-1a3 3 0 0 1-3-3 3 3 0 0 1-3 3H5", key: "fj48gi" }],
  ["path", { d: "M5 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1", key: "1n9rhb" }],
  ["path", { d: "M13 8h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7", key: "13ksps" }],
  ["path", { d: "M9 7v10", key: "1vc8ob" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TextCursor = createLucideIcon("TextCursor", [
  ["path", { d: "M17 22h-1a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h1", key: "uvaxm9" }],
  ["path", { d: "M7 22h1a4 4 0 0 0 4-4v-1", key: "11xy8d" }],
  ["path", { d: "M7 2h1a4 4 0 0 1 4 4v1", key: "1uw06m" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TextQuote = createLucideIcon("TextQuote", [
  ["path", { d: "M17 6H3", key: "16j9eg" }],
  ["path", { d: "M21 12H8", key: "scolzb" }],
  ["path", { d: "M21 18H8", key: "1wfozv" }],
  ["path", { d: "M3 12v6", key: "fv4c87" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TextSearch = createLucideIcon("TextSearch", [
  ["path", { d: "M21 6H3", key: "1jwq7v" }],
  ["path", { d: "M10 12H3", key: "1ulcyk" }],
  ["path", { d: "M10 18H3", key: "13769t" }],
  ["circle", { cx: "17", cy: "15", r: "3", key: "1upz2a" }],
  ["path", { d: "m21 19-1.9-1.9", key: "dwi7p8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TextSelect = createLucideIcon("TextSelect", [
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M21 14v1", key: "169vum" }],
  ["line", { x1: "7", x2: "15", y1: "8", y2: "8", key: "1758g8" }],
  ["line", { x1: "7", x2: "17", y1: "12", y2: "12", key: "197423" }],
  ["line", { x1: "7", x2: "13", y1: "16", y2: "16", key: "37cgm6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Text = createLucideIcon("Text", [
  ["path", { d: "M17 6.1H3", key: "wptmhv" }],
  ["path", { d: "M21 12.1H3", key: "1j38uz" }],
  ["path", { d: "M15.1 18H3", key: "1nb16a" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Theater = createLucideIcon("Theater", [
  ["path", { d: "M2 10s3-3 3-8", key: "3xiif0" }],
  ["path", { d: "M22 10s-3-3-3-8", key: "ioaa5q" }],
  ["path", { d: "M10 2c0 4.4-3.6 8-8 8", key: "16fkpi" }],
  ["path", { d: "M14 2c0 4.4 3.6 8 8 8", key: "b9eulq" }],
  ["path", { d: "M2 10s2 2 2 5", key: "1au1lb" }],
  ["path", { d: "M22 10s-2 2-2 5", key: "qi2y5e" }],
  ["path", { d: "M8 15h8", key: "45n4r" }],
  ["path", { d: "M2 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1", key: "1vsc2m" }],
  ["path", { d: "M14 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1", key: "hrha4u" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ThermometerSnowflake = createLucideIcon("ThermometerSnowflake", [
  ["path", { d: "M2 12h10", key: "19562f" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "m3 9 3 3-3 3", key: "1sas0l" }],
  ["path", { d: "M12 6 9 9 6 6", key: "pfrgxu" }],
  ["path", { d: "m6 18 3-3 1.5 1.5", key: "1e277p" }],
  ["path", { d: "M20 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "iof6y5" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ThermometerSun = createLucideIcon("ThermometerSun", [
  ["path", { d: "M12 9a4 4 0 0 0-2 7.5", key: "1jvsq6" }],
  ["path", { d: "M12 3v2", key: "1w22ol" }],
  ["path", { d: "m6.6 18.4-1.4 1.4", key: "w2yidj" }],
  ["path", { d: "M20 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "iof6y5" }],
  ["path", { d: "M4 13H2", key: "118le4" }],
  ["path", { d: "M6.34 7.34 4.93 5.93", key: "1brd51" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Thermometer = createLucideIcon("Thermometer", [
  ["path", { d: "M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "17jzev" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ThumbsDown = createLucideIcon("ThumbsDown", [
  ["path", { d: "M17 14V2", key: "8ymqnk" }],
  [
    "path",
    {
      d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z",
      key: "m61m77"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ThumbsUp = createLucideIcon("ThumbsUp", [
  ["path", { d: "M7 10v12", key: "1qc93n" }],
  [
    "path",
    {
      d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z",
      key: "emmmcr"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TicketCheck = createLucideIcon("TicketCheck", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TicketMinus = createLucideIcon("TicketMinus", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TicketPercent = createLucideIcon("TicketPercent", [
  [
    "path",
    {
      d: "M2 9a3 3 0 1 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 1 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "1l48ns"
    }
  ],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TicketPlus = createLucideIcon("TicketPlus", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M12 9v6", key: "199k2o" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TicketSlash = createLucideIcon("TicketSlash", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "m9.5 14.5 5-5", key: "qviqfa" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TicketX = createLucideIcon("TicketX", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "m9.5 14.5 5-5", key: "qviqfa" }],
  ["path", { d: "m9.5 9.5 5 5", key: "18nt4w" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ticket = createLucideIcon("Ticket", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M13 5v2", key: "dyzc3o" }],
  ["path", { d: "M13 17v2", key: "1ont0d" }],
  ["path", { d: "M13 11v2", key: "1wjjxi" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TicketsPlane = createLucideIcon("TicketsPlane", [
  ["path", { d: "M10.5 17h1.227a2 2 0 0 0 1.345-.52L18 12", key: "16muxl" }],
  ["path", { d: "m12 13.5 3.75.5", key: "1i9qhk" }],
  ["path", { d: "m4.5 8 10.58-5.06a1 1 0 0 1 1.342.488L18.5 8", key: "12lg5p" }],
  ["path", { d: "M6 10V8", key: "1y41hn" }],
  ["path", { d: "M6 14v1", key: "cao2tf" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["rect", { x: "2", y: "8", width: "20", height: "13", rx: "2", key: "p3bz5l" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tickets = createLucideIcon("Tickets", [
  ["path", { d: "m4.5 8 10.58-5.06a1 1 0 0 1 1.342.488L18.5 8", key: "12lg5p" }],
  ["path", { d: "M6 10V8", key: "1y41hn" }],
  ["path", { d: "M6 14v1", key: "cao2tf" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["rect", { x: "2", y: "8", width: "20", height: "13", rx: "2", key: "p3bz5l" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TimerOff = createLucideIcon("TimerOff", [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  ["path", { d: "M4.6 11a8 8 0 0 0 1.7 8.7 8 8 0 0 0 8.7 1.7", key: "10he05" }],
  ["path", { d: "M7.4 7.4a8 8 0 0 1 10.3 1 8 8 0 0 1 .9 10.2", key: "15f7sh" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M12 12v-2", key: "fwoke6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TimerReset = createLucideIcon("TimerReset", [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  ["path", { d: "M12 14v-4", key: "1evpnu" }],
  ["path", { d: "M4 13a8 8 0 0 1 8-7 8 8 0 1 1-5.3 14L4 17.6", key: "1ts96g" }],
  ["path", { d: "M9 17H4v5", key: "8t5av" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Timer = createLucideIcon("Timer", [
  ["line", { x1: "10", x2: "14", y1: "2", y2: "2", key: "14vaq8" }],
  ["line", { x1: "12", x2: "15", y1: "14", y2: "11", key: "17fdiu" }],
  ["circle", { cx: "12", cy: "14", r: "8", key: "1e1u0o" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ToggleLeft = createLucideIcon("ToggleLeft", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "6", ry: "6", key: "f2vt7d" }],
  ["circle", { cx: "8", cy: "12", r: "2", key: "1nvbw3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ToggleRight = createLucideIcon("ToggleRight", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "6", ry: "6", key: "f2vt7d" }],
  ["circle", { cx: "16", cy: "12", r: "2", key: "4ma0v8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tornado = createLucideIcon("Tornado", [
  ["path", { d: "M21 4H3", key: "1hwok0" }],
  ["path", { d: "M18 8H6", key: "41n648" }],
  ["path", { d: "M19 12H9", key: "1g4lpz" }],
  ["path", { d: "M16 16h-6", key: "1j5d54" }],
  ["path", { d: "M11 20H9", key: "39obr8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Torus = createLucideIcon("Torus", [
  ["ellipse", { cx: "12", cy: "11", rx: "3", ry: "2", key: "1b2qxu" }],
  ["ellipse", { cx: "12", cy: "12.5", rx: "10", ry: "8.5", key: "h8emeu" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TouchpadOff = createLucideIcon("TouchpadOff", [
  ["path", { d: "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16", key: "lnt0bk" }],
  ["path", { d: "M2 14h12", key: "d8icqz" }],
  ["path", { d: "M22 14h-2", key: "jrx26d" }],
  ["path", { d: "M12 20v-6", key: "1rm09r" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M22 16V6a2 2 0 0 0-2-2H10", key: "11y8e4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Touchpad = createLucideIcon("Touchpad", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M12 20v-6", key: "1rm09r" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TowerControl = createLucideIcon("TowerControl", [
  [
    "path",
    { d: "M18.2 12.27 20 6H4l1.8 6.27a1 1 0 0 0 .95.73h10.5a1 1 0 0 0 .96-.73Z", key: "1pledb" }
  ],
  ["path", { d: "M8 13v9", key: "hmv0ci" }],
  ["path", { d: "M16 22v-9", key: "ylnf1u" }],
  ["path", { d: "m9 6 1 7", key: "dpdgam" }],
  ["path", { d: "m15 6-1 7", key: "ls7zgu" }],
  ["path", { d: "M12 6V2", key: "1pj48d" }],
  ["path", { d: "M13 2h-2", key: "mj6ths" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ToyBrick = createLucideIcon("ToyBrick", [
  ["rect", { width: "18", height: "12", x: "3", y: "8", rx: "1", key: "158fvp" }],
  ["path", { d: "M10 8V5c0-.6-.4-1-1-1H6a1 1 0 0 0-1 1v3", key: "s0042v" }],
  ["path", { d: "M19 8V5c0-.6-.4-1-1-1h-3a1 1 0 0 0-1 1v3", key: "9wmeh2" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tractor = createLucideIcon("Tractor", [
  ["path", { d: "m10 11 11 .9a1 1 0 0 1 .8 1.1l-.665 4.158a1 1 0 0 1-.988.842H20", key: "she1j9" }],
  ["path", { d: "M16 18h-5", key: "bq60fd" }],
  ["path", { d: "M18 5a1 1 0 0 0-1 1v5.573", key: "1kv8ia" }],
  ["path", { d: "M3 4h8.129a1 1 0 0 1 .99.863L13 11.246", key: "1q1ert" }],
  ["path", { d: "M4 11V4", key: "9ft8pt" }],
  ["path", { d: "M7 15h.01", key: "k5ht0j" }],
  ["path", { d: "M8 10.1V4", key: "1jgyzo" }],
  ["circle", { cx: "18", cy: "18", r: "2", key: "1emm8v" }],
  ["circle", { cx: "7", cy: "15", r: "5", key: "ddtuc" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TrafficCone = createLucideIcon("TrafficCone", [
  ["path", { d: "M9.3 6.2a4.55 4.55 0 0 0 5.4 0", key: "flyxqv" }],
  ["path", { d: "M7.9 10.7c.9.8 2.4 1.3 4.1 1.3s3.2-.5 4.1-1.3", key: "1nlxxg" }],
  [
    "path",
    {
      d: "M13.9 3.5a1.93 1.93 0 0 0-3.8-.1l-3 10c-.1.2-.1.4-.1.6 0 1.7 2.2 3 5 3s5-1.3 5-3c0-.2 0-.4-.1-.5Z",
      key: "vz7x1l"
    }
  ],
  [
    "path",
    {
      d: "m7.5 12.2-4.7 2.7c-.5.3-.8.7-.8 1.1s.3.8.8 1.1l7.6 4.5c.9.5 2.1.5 3 0l7.6-4.5c.7-.3 1-.7 1-1.1s-.3-.8-.8-1.1l-4.7-2.8",
      key: "1xfzlw"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TrainFrontTunnel = createLucideIcon("TrainFrontTunnel", [
  ["path", { d: "M2 22V12a10 10 0 1 1 20 0v10", key: "o0fyp0" }],
  ["path", { d: "M15 6.8v1.4a3 2.8 0 1 1-6 0V6.8", key: "m8q3n9" }],
  ["path", { d: "M10 15h.01", key: "44in9x" }],
  ["path", { d: "M14 15h.01", key: "5mohn5" }],
  ["path", { d: "M10 19a4 4 0 0 1-4-4v-3a6 6 0 1 1 12 0v3a4 4 0 0 1-4 4Z", key: "hckbmu" }],
  ["path", { d: "m9 19-2 3", key: "iij7hm" }],
  ["path", { d: "m15 19 2 3", key: "npx8sa" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TrainFront = createLucideIcon("TrainFront", [
  ["path", { d: "M8 3.1V7a4 4 0 0 0 8 0V3.1", key: "1v71zp" }],
  ["path", { d: "m9 15-1-1", key: "1yrq24" }],
  ["path", { d: "m15 15 1-1", key: "1t0d6s" }],
  ["path", { d: "M9 19c-2.8 0-5-2.2-5-5v-4a8 8 0 0 1 16 0v4c0 2.8-2.2 5-5 5Z", key: "1p0hjs" }],
  ["path", { d: "m8 19-2 3", key: "13i0xs" }],
  ["path", { d: "m16 19 2 3", key: "xo31yx" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TrainTrack = createLucideIcon("TrainTrack", [
  ["path", { d: "M2 17 17 2", key: "18b09t" }],
  ["path", { d: "m2 14 8 8", key: "1gv9hu" }],
  ["path", { d: "m5 11 8 8", key: "189pqp" }],
  ["path", { d: "m8 8 8 8", key: "1imecy" }],
  ["path", { d: "m11 5 8 8", key: "ummqn6" }],
  ["path", { d: "m14 2 8 8", key: "1vk7dn" }],
  ["path", { d: "M7 22 22 7", key: "15mb1i" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TramFront = createLucideIcon("TramFront", [
  ["rect", { width: "16", height: "16", x: "4", y: "3", rx: "2", key: "1wxw4b" }],
  ["path", { d: "M4 11h16", key: "mpoxn0" }],
  ["path", { d: "M12 3v8", key: "1h2ygw" }],
  ["path", { d: "m8 19-2 3", key: "13i0xs" }],
  ["path", { d: "m18 22-2-3", key: "1p0ohu" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Trash2 = createLucideIcon("Trash2", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "17", key: "1uufr5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "17", key: "xtxkd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Trash = createLucideIcon("Trash", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TreeDeciduous = createLucideIcon("TreeDeciduous", [
  [
    "path",
    {
      d: "M8 19a4 4 0 0 1-2.24-7.32A3.5 3.5 0 0 1 9 6.03V6a3 3 0 1 1 6 0v.04a3.5 3.5 0 0 1 3.24 5.65A4 4 0 0 1 16 19Z",
      key: "oadzkq"
    }
  ],
  ["path", { d: "M12 19v3", key: "npa21l" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TreePalm = createLucideIcon("TreePalm", [
  ["path", { d: "M13 8c0-2.76-2.46-5-5.5-5S2 5.24 2 8h2l1-1 1 1h4", key: "foxbe7" }],
  [
    "path",
    { d: "M13 7.14A5.82 5.82 0 0 1 16.5 6c3.04 0 5.5 2.24 5.5 5h-3l-1-1-1 1h-3", key: "18arnh" }
  ],
  [
    "path",
    {
      d: "M5.89 9.71c-2.15 2.15-2.3 5.47-.35 7.43l4.24-4.25.7-.7.71-.71 2.12-2.12c-1.95-1.96-5.27-1.8-7.42.35",
      key: "ywahnh"
    }
  ],
  ["path", { d: "M11 15.5c.5 2.5-.17 4.5-1 6.5h4c2-5.5-.5-12-1-14", key: "ft0feo" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TreePine = createLucideIcon("TreePine", [
  [
    "path",
    {
      d: "m17 14 3 3.3a1 1 0 0 1-.7 1.7H4.7a1 1 0 0 1-.7-1.7L7 14h-.3a1 1 0 0 1-.7-1.7L9 9h-.2A1 1 0 0 1 8 7.3L12 3l4 4.3a1 1 0 0 1-.8 1.7H15l3 3.3a1 1 0 0 1-.7 1.7H17Z",
      key: "cpyugq"
    }
  ],
  ["path", { d: "M12 22v-3", key: "kmzjlo" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Trees = createLucideIcon("Trees", [
  ["path", { d: "M10 10v.2A3 3 0 0 1 8.9 16H5a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0Z", key: "1l6gj6" }],
  ["path", { d: "M7 16v6", key: "1a82de" }],
  ["path", { d: "M13 19v3", key: "13sx9i" }],
  [
    "path",
    {
      d: "M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5",
      key: "1sj9kv"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Trello = createLucideIcon("Trello", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["rect", { width: "3", height: "9", x: "7", y: "7", key: "14n3xi" }],
  ["rect", { width: "3", height: "5", x: "14", y: "7", key: "s4azjd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TrendingDown = createLucideIcon("TrendingDown", [
  ["polyline", { points: "22 17 13.5 8.5 8.5 13.5 2 7", key: "1r2t7k" }],
  ["polyline", { points: "16 17 22 17 22 11", key: "11uiuu" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TrendingUpDown = createLucideIcon("TrendingUpDown", [
  ["path", { d: "M14.828 14.828 21 21", key: "ar5fw7" }],
  ["path", { d: "M21 16v5h-5", key: "1ck2sf" }],
  ["path", { d: "m21 3-9 9-4-4-6 6", key: "1h02xo" }],
  ["path", { d: "M21 8V3h-5", key: "1qoq8a" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TrendingUp = createLucideIcon("TrendingUp", [
  ["polyline", { points: "22 7 13.5 15.5 8.5 10.5 2 17", key: "126l90" }],
  ["polyline", { points: "16 7 22 7 22 13", key: "kwv8wd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TriangleAlert = createLucideIcon("TriangleAlert", [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TriangleRight = createLucideIcon("TriangleRight", [
  [
    "path",
    {
      d: "M22 18a2 2 0 0 1-2 2H3c-1.1 0-1.3-.6-.4-1.3L20.4 4.3c.9-.7 1.6-.4 1.6.7Z",
      key: "183wce"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Triangle = createLucideIcon("Triangle", [
  [
    "path",
    { d: "M13.73 4a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z", key: "14u9p9" }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Trophy = createLucideIcon("Trophy", [
  ["path", { d: "M6 9H4.5a2.5 2.5 0 0 1 0-5H6", key: "17hqa7" }],
  ["path", { d: "M18 9h1.5a2.5 2.5 0 0 0 0-5H18", key: "lmptdp" }],
  ["path", { d: "M4 22h16", key: "57wxv0" }],
  ["path", { d: "M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22", key: "1nw9bq" }],
  ["path", { d: "M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22", key: "1np0yb" }],
  ["path", { d: "M18 2H6v7a6 6 0 0 0 12 0V2Z", key: "u46fv3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Truck = createLucideIcon("Truck", [
  ["path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2", key: "wrbu53" }],
  ["path", { d: "M15 18H9", key: "1lyqi6" }],
  [
    "path",
    {
      d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14",
      key: "lysw3i"
    }
  ],
  ["circle", { cx: "17", cy: "18", r: "2", key: "332jqn" }],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Turtle = createLucideIcon("Turtle", [
  [
    "path",
    {
      d: "m12 10 2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a8 8 0 1 0-16 0v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3l2-4h4Z",
      key: "1lbbv7"
    }
  ],
  ["path", { d: "M4.82 7.9 8 10", key: "m9wose" }],
  ["path", { d: "M15.18 7.9 12 10", key: "p8dp2u" }],
  ["path", { d: "M16.93 10H20a2 2 0 0 1 0 4H2", key: "12nsm7" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TvMinimalPlay = createLucideIcon("TvMinimalPlay", [
  [
    "path",
    {
      d: "M10 7.75a.75.75 0 0 1 1.142-.638l3.664 2.249a.75.75 0 0 1 0 1.278l-3.664 2.25a.75.75 0 0 1-1.142-.64z",
      key: "1pctta"
    }
  ],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TvMinimal = createLucideIcon("TvMinimal", [
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tv = createLucideIcon("Tv", [
  ["rect", { width: "20", height: "15", x: "2", y: "7", rx: "2", ry: "2", key: "10ag99" }],
  ["polyline", { points: "17 2 12 7 7 2", key: "11pgbg" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Twitch = createLucideIcon("Twitch", [
  ["path", { d: "M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7", key: "c0yzno" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Twitter = createLucideIcon("Twitter", [
  [
    "path",
    {
      d: "M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z",
      key: "pff0z6"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TypeOutline = createLucideIcon("TypeOutline", [
  [
    "path",
    {
      d: "M14 16.5a.5.5 0 0 0 .5.5h.5a2 2 0 0 1 0 4H9a2 2 0 0 1 0-4h.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V8a2 2 0 0 1-4 0V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v3a2 2 0 0 1-4 0v-.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5Z",
      key: "1reda3"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Type = createLucideIcon("Type", [
  ["polyline", { points: "4 7 4 4 20 4 20 7", key: "1nosan" }],
  ["line", { x1: "9", x2: "15", y1: "20", y2: "20", key: "swin9y" }],
  ["line", { x1: "12", x2: "12", y1: "4", y2: "20", key: "1tx1rr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UmbrellaOff = createLucideIcon("UmbrellaOff", [
  ["path", { d: "M12 2v1", key: "11qlp1" }],
  ["path", { d: "M15.5 21a1.85 1.85 0 0 1-3.5-1v-8H2a10 10 0 0 1 3.428-6.575", key: "eki10q" }],
  ["path", { d: "M17.5 12H22A10 10 0 0 0 9.004 3.455", key: "n2ayka" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Umbrella = createLucideIcon("Umbrella", [
  ["path", { d: "M22 12a10.06 10.06 1 0 0-20 0Z", key: "1teyop" }],
  ["path", { d: "M12 12v8a2 2 0 0 0 4 0", key: "ulpmoc" }],
  ["path", { d: "M12 2v1", key: "11qlp1" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Underline = createLucideIcon("Underline", [
  ["path", { d: "M6 4v6a6 6 0 0 0 12 0V4", key: "9kb039" }],
  ["line", { x1: "4", x2: "20", y1: "20", y2: "20", key: "nun2al" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Undo2 = createLucideIcon("Undo2", [
  ["path", { d: "M9 14 4 9l5-5", key: "102s5s" }],
  ["path", { d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11", key: "f3b9sd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UndoDot = createLucideIcon("UndoDot", [
  ["circle", { cx: "12", cy: "17", r: "1", key: "1ixnty" }],
  ["path", { d: "M3 7v6h6", key: "1v2h90" }],
  ["path", { d: "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13", key: "1r6uu6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Undo = createLucideIcon("Undo", [
  ["path", { d: "M3 7v6h6", key: "1v2h90" }],
  ["path", { d: "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13", key: "1r6uu6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UnfoldHorizontal = createLucideIcon("UnfoldHorizontal", [
  ["path", { d: "M16 12h6", key: "15xry1" }],
  ["path", { d: "M8 12H2", key: "1jqql6" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m19 15 3-3-3-3", key: "wjy7rq" }],
  ["path", { d: "m5 9-3 3 3 3", key: "j64kie" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UnfoldVertical = createLucideIcon("UnfoldVertical", [
  ["path", { d: "M12 22v-6", key: "6o8u61" }],
  ["path", { d: "M12 8V2", key: "1wkif3" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }],
  ["path", { d: "m15 19-3 3-3-3", key: "11eu04" }],
  ["path", { d: "m15 5-3-3-3 3", key: "itvq4r" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ungroup = createLucideIcon("Ungroup", [
  ["rect", { width: "8", height: "6", x: "5", y: "4", rx: "1", key: "nzclkv" }],
  ["rect", { width: "8", height: "6", x: "11", y: "14", rx: "1", key: "4tytwb" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const University = createLucideIcon("University", [
  ["circle", { cx: "12", cy: "10", r: "1", key: "1gnqs8" }],
  ["path", { d: "M22 20V8h-4l-6-4-6 4H2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2", key: "1qj5sn" }],
  ["path", { d: "M6 17v.01", key: "roodi6" }],
  ["path", { d: "M6 13v.01", key: "67c122" }],
  ["path", { d: "M18 17v.01", key: "12ktxm" }],
  ["path", { d: "M18 13v.01", key: "tn1rt1" }],
  ["path", { d: "M14 22v-5a2 2 0 0 0-2-2a2 2 0 0 0-2 2v5", key: "11g7fi" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Unlink2 = createLucideIcon("Unlink2", [
  ["path", { d: "M15 7h2a5 5 0 0 1 0 10h-2m-6 0H7A5 5 0 0 1 7 7h2", key: "1re2ne" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Unlink = createLucideIcon("Unlink", [
  [
    "path",
    {
      d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71",
      key: "yqzxt4"
    }
  ],
  [
    "path",
    {
      d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71",
      key: "4qinb0"
    }
  ],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "5", key: "1041cp" }],
  ["line", { x1: "2", x2: "5", y1: "8", y2: "8", key: "14m1p5" }],
  ["line", { x1: "16", x2: "16", y1: "19", y2: "22", key: "rzdirn" }],
  ["line", { x1: "19", x2: "22", y1: "16", y2: "16", key: "ox905f" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Unplug = createLucideIcon("Unplug", [
  ["path", { d: "m19 5 3-3", key: "yk6iyv" }],
  ["path", { d: "m2 22 3-3", key: "19mgm9" }],
  [
    "path",
    { d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z", key: "goz73y" }
  ],
  ["path", { d: "M7.5 13.5 10 11", key: "7xgeeb" }],
  ["path", { d: "M10.5 16.5 13 14", key: "10btkg" }],
  [
    "path",
    { d: "m12 6 6 6 2.3-2.3a2.4 2.4 0 0 0 0-3.4l-2.6-2.6a2.4 2.4 0 0 0-3.4 0Z", key: "1snsnr" }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Upload = createLucideIcon("Upload", [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "17 8 12 3 7 8", key: "t8dd8p" }],
  ["line", { x1: "12", x2: "12", y1: "3", y2: "15", key: "widbto" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Usb = createLucideIcon("Usb", [
  ["circle", { cx: "10", cy: "7", r: "1", key: "dypaad" }],
  ["circle", { cx: "4", cy: "20", r: "1", key: "22iqad" }],
  ["path", { d: "M4.7 19.3 19 5", key: "1enqfc" }],
  ["path", { d: "m21 3-3 1 2 2Z", key: "d3ov82" }],
  ["path", { d: "M9.26 7.68 5 12l2 5", key: "1esawj" }],
  ["path", { d: "m10 14 5 2 3.5-3.5", key: "v8oal5" }],
  ["path", { d: "m18 12 1-1 1 1-1 1Z", key: "1bh22v" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UserCheck = createLucideIcon("UserCheck", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["polyline", { points: "16 11 18 13 22 9", key: "1pwet4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UserCog = createLucideIcon("UserCog", [
  ["circle", { cx: "18", cy: "15", r: "3", key: "gjjjvw" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["path", { d: "M10 15H6a4 4 0 0 0-4 4v2", key: "1nfge6" }],
  ["path", { d: "m21.7 16.4-.9-.3", key: "12j9ji" }],
  ["path", { d: "m15.2 13.9-.9-.3", key: "1fdjdi" }],
  ["path", { d: "m16.6 18.7.3-.9", key: "heedtr" }],
  ["path", { d: "m19.1 12.2.3-.9", key: "1af3ki" }],
  ["path", { d: "m19.6 18.7-.4-1", key: "1x9vze" }],
  ["path", { d: "m16.8 12.3-.4-1", key: "vqeiwj" }],
  ["path", { d: "m14.3 16.6 1-.4", key: "1qlj63" }],
  ["path", { d: "m20.7 13.8 1-.4", key: "1v5t8k" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UserMinus = createLucideIcon("UserMinus", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UserPen = createLucideIcon("UserPen", [
  ["path", { d: "M11.5 15H7a4 4 0 0 0-4 4v2", key: "15lzij" }],
  [
    "path",
    {
      d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1817ys"
    }
  ],
  ["circle", { cx: "10", cy: "7", r: "4", key: "e45bow" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UserPlus = createLucideIcon("UserPlus", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "19", x2: "19", y1: "8", y2: "14", key: "1bvyxn" }],
  ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UserRoundCheck = createLucideIcon("UserRoundCheck", [
  ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UserRoundCog = createLucideIcon("UserRoundCog", [
  ["path", { d: "M2 21a8 8 0 0 1 10.434-7.62", key: "1yezr2" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m19.5 14.3-.4.9", key: "1eb35c" }],
  ["path", { d: "m16.9 20.8-.4.9", key: "dfjc4z" }],
  ["path", { d: "m21.7 19.5-.9-.4", key: "q4dx6b" }],
  ["path", { d: "m15.2 16.9-.9-.4", key: "1r0w5f" }],
  ["path", { d: "m21.7 16.5-.9.4", key: "1knoei" }],
  ["path", { d: "m15.2 19.1-.9.4", key: "j188fs" }],
  ["path", { d: "m19.5 21.7-.4-.9", key: "1tonu5" }],
  ["path", { d: "m16.9 15.2-.4-.9", key: "699xu" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UserRoundMinus = createLucideIcon("UserRoundMinus", [
  ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M22 19h-6", key: "vcuq98" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UserRoundPen = createLucideIcon("UserRoundPen", [
  ["path", { d: "M2 21a8 8 0 0 1 10.821-7.487", key: "1c8h7z" }],
  [
    "path",
    {
      d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1817ys"
    }
  ],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UserRoundPlus = createLucideIcon("UserRoundPlus", [
  ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }],
  ["path", { d: "M22 19h-6", key: "vcuq98" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UserRoundSearch = createLucideIcon("UserRoundSearch", [
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M2 21a8 8 0 0 1 10.434-7.62", key: "1yezr2" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m22 22-1.9-1.9", key: "1e5ubv" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UserRoundX = createLucideIcon("UserRoundX", [
  ["path", { d: "M2 21a8 8 0 0 1 11.873-7", key: "74fkxq" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "m17 17 5 5", key: "p7ous7" }],
  ["path", { d: "m22 17-5 5", key: "gqnmv0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UserRound = createLucideIcon("UserRound", [
  ["circle", { cx: "12", cy: "8", r: "5", key: "1hypcn" }],
  ["path", { d: "M20 21a8 8 0 0 0-16 0", key: "rfgkzh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UserSearch = createLucideIcon("UserSearch", [
  ["circle", { cx: "10", cy: "7", r: "4", key: "e45bow" }],
  ["path", { d: "M10.3 15H7a4 4 0 0 0-4 4v2", key: "3bnktk" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
  ["path", { d: "m21 21-1.9-1.9", key: "1g2n9r" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UserX = createLucideIcon("UserX", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "17", x2: "22", y1: "8", y2: "13", key: "3nzzx3" }],
  ["line", { x1: "22", x2: "17", y1: "8", y2: "13", key: "1swrse" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const User = createLucideIcon("User", [
  ["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2", key: "975kel" }],
  ["circle", { cx: "12", cy: "7", r: "4", key: "17ys0d" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UsersRound = createLucideIcon("UsersRound", [
  ["path", { d: "M18 21a8 8 0 0 0-16 0", key: "3ypg7q" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3", key: "10s06x" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Users = createLucideIcon("Users", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87", key: "kshegd" }],
  ["path", { d: "M16 3.13a4 4 0 0 1 0 7.75", key: "1da9ce" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UtensilsCrossed = createLucideIcon("UtensilsCrossed", [
  ["path", { d: "m16 2-2.3 2.3a3 3 0 0 0 0 4.2l1.8 1.8a3 3 0 0 0 4.2 0L22 8", key: "n7qcjb" }],
  [
    "path",
    { d: "M15 15 3.3 3.3a4.2 4.2 0 0 0 0 6l7.3 7.3c.7.7 2 .7 2.8 0L15 15Zm0 0 7 7", key: "d0u48b" }
  ],
  ["path", { d: "m2.1 21.8 6.4-6.3", key: "yn04lh" }],
  ["path", { d: "m19 5-7 7", key: "194lzd" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Utensils = createLucideIcon("Utensils", [
  ["path", { d: "M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2", key: "cjf0a3" }],
  ["path", { d: "M7 2v20", key: "1473qp" }],
  ["path", { d: "M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7", key: "j28e5" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const UtilityPole = createLucideIcon("UtilityPole", [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "M2 5h20", key: "1fs1ex" }],
  ["path", { d: "M3 3v2", key: "9imdir" }],
  ["path", { d: "M7 3v2", key: "n0os7" }],
  ["path", { d: "M17 3v2", key: "1l2re6" }],
  ["path", { d: "M21 3v2", key: "1duuac" }],
  ["path", { d: "m19 5-7 7-7-7", key: "133zxf" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Variable = createLucideIcon("Variable", [
  ["path", { d: "M8 21s-4-3-4-9 4-9 4-9", key: "uto9ud" }],
  ["path", { d: "M16 3s4 3 4 9-4 9-4 9", key: "4w2vsq" }],
  ["line", { x1: "15", x2: "9", y1: "9", y2: "15", key: "f7djnv" }],
  ["line", { x1: "9", x2: "15", y1: "9", y2: "15", key: "1shsy8" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vault = createLucideIcon("Vault", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }],
  ["path", { d: "m7.9 7.9 2.7 2.7", key: "hpeyl3" }],
  ["circle", { cx: "16.5", cy: "7.5", r: ".5", fill: "currentColor", key: "w0ekpg" }],
  ["path", { d: "m13.4 10.6 2.7-2.7", key: "264c1n" }],
  ["circle", { cx: "7.5", cy: "16.5", r: ".5", fill: "currentColor", key: "nkw3mc" }],
  ["path", { d: "m7.9 16.1 2.7-2.7", key: "p81g5e" }],
  ["circle", { cx: "16.5", cy: "16.5", r: ".5", fill: "currentColor", key: "fubopw" }],
  ["path", { d: "m13.4 13.4 2.7 2.7", key: "abhel3" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vegan = createLucideIcon("Vegan", [
  ["path", { d: "M2 2a26.6 26.6 0 0 1 10 20c.9-6.82 1.5-9.5 4-14", key: "qiv7li" }],
  ["path", { d: "M16 8c4 0 6-2 6-6-4 0-6 2-6 6", key: "n7eohy" }],
  ["path", { d: "M17.41 3.6a10 10 0 1 0 3 3", key: "1dion0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VenetianMask = createLucideIcon("VenetianMask", [
  [
    "path",
    {
      d: "M2 12a5 5 0 0 0 5 5 8 8 0 0 1 5 2 8 8 0 0 1 5-2 5 5 0 0 0 5-5V7h-5a8 8 0 0 0-5 2 8 8 0 0 0-5-2H2Z",
      key: "1g6z3j"
    }
  ],
  ["path", { d: "M6 11c1.5 0 3 .5 3 2-2 0-3 0-3-2Z", key: "c2lwnf" }],
  ["path", { d: "M18 11c-1.5 0-3 .5-3 2 2 0 3 0 3-2Z", key: "njd9zo" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VibrateOff = createLucideIcon("VibrateOff", [
  ["path", { d: "m2 8 2 2-2 2 2 2-2 2", key: "sv1b1" }],
  ["path", { d: "m22 8-2 2 2 2-2 2 2 2", key: "101i4y" }],
  ["path", { d: "M8 8v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2", key: "1hbad5" }],
  ["path", { d: "M16 10.34V6c0-.55-.45-1-1-1h-4.34", key: "1x5tf0" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vibrate = createLucideIcon("Vibrate", [
  ["path", { d: "m2 8 2 2-2 2 2 2-2 2", key: "sv1b1" }],
  ["path", { d: "m22 8-2 2 2 2-2 2 2 2", key: "101i4y" }],
  ["rect", { width: "8", height: "14", x: "8", y: "5", rx: "1", key: "1oyrl4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VideoOff = createLucideIcon("VideoOff", [
  [
    "path",
    { d: "M10.66 6H14a2 2 0 0 1 2 2v2.5l5.248-3.062A.5.5 0 0 1 22 7.87v8.196", key: "w8jjjt" }
  ],
  ["path", { d: "M16 16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2", key: "1xawa7" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Video = createLucideIcon("Video", [
  [
    "path",
    {
      d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5",
      key: "ftymec"
    }
  ],
  ["rect", { x: "2", y: "6", width: "14", height: "12", rx: "2", key: "158x01" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Videotape = createLucideIcon("Videotape", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["circle", { cx: "8", cy: "14", r: "2", key: "1k2qr5" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["circle", { cx: "16", cy: "14", r: "2", key: "14k7lr" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const View = createLucideIcon("View", [
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2", key: "mrq65r" }],
  ["path", { d: "M21 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2", key: "be3xqs" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  [
    "path",
    {
      d: "M18.944 12.33a1 1 0 0 0 0-.66 7.5 7.5 0 0 0-13.888 0 1 1 0 0 0 0 .66 7.5 7.5 0 0 0 13.888 0",
      key: "11ak4c"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Voicemail = createLucideIcon("Voicemail", [
  ["circle", { cx: "6", cy: "12", r: "4", key: "1ehtga" }],
  ["circle", { cx: "18", cy: "12", r: "4", key: "4vafl8" }],
  ["line", { x1: "6", x2: "18", y1: "16", y2: "16", key: "pmt8us" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Volleyball = createLucideIcon("Volleyball", [
  ["path", { d: "M11.1 7.1a16.55 16.55 0 0 1 10.9 4", key: "2880wi" }],
  ["path", { d: "M12 12a12.6 12.6 0 0 1-8.7 5", key: "113sja" }],
  ["path", { d: "M16.8 13.6a16.55 16.55 0 0 1-9 7.5", key: "1qmsgl" }],
  ["path", { d: "M20.7 17a12.8 12.8 0 0 0-8.7-5 13.3 13.3 0 0 1 0-10", key: "1bmeqp" }],
  ["path", { d: "M6.3 3.8a16.55 16.55 0 0 0 1.9 11.5", key: "iekzv9" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Volume1 = createLucideIcon("Volume1", [
  [
    "path",
    {
      d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
      key: "uqj9uw"
    }
  ],
  ["path", { d: "M16 9a5 5 0 0 1 0 6", key: "1q6k2b" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Volume2 = createLucideIcon("Volume2", [
  [
    "path",
    {
      d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
      key: "uqj9uw"
    }
  ],
  ["path", { d: "M16 9a5 5 0 0 1 0 6", key: "1q6k2b" }],
  ["path", { d: "M19.364 18.364a9 9 0 0 0 0-12.728", key: "ijwkga" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VolumeOff = createLucideIcon("VolumeOff", [
  ["path", { d: "M16 9a5 5 0 0 1 .95 2.293", key: "1fgyg8" }],
  ["path", { d: "M19.364 5.636a9 9 0 0 1 1.889 9.96", key: "l3zxae" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "m7 7-.587.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298V11",
      key: "1gbwow"
    }
  ],
  ["path", { d: "M9.828 4.172A.686.686 0 0 1 11 4.657v.686", key: "s2je0y" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VolumeX = createLucideIcon("VolumeX", [
  [
    "path",
    {
      d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
      key: "uqj9uw"
    }
  ],
  ["line", { x1: "22", x2: "16", y1: "9", y2: "15", key: "1ewh16" }],
  ["line", { x1: "16", x2: "22", y1: "9", y2: "15", key: "5ykzw1" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Volume = createLucideIcon("Volume", [
  [
    "path",
    {
      d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
      key: "uqj9uw"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vote = createLucideIcon("Vote", [
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }],
  ["path", { d: "M5 7c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v12H5V7Z", key: "1ezoue" }],
  ["path", { d: "M22 19H2", key: "nuriw5" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WalletCards = createLucideIcon("WalletCards", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2", key: "4125el" }],
  [
    "path",
    {
      d: "M3 11h3c.8 0 1.6.3 2.1.9l1.1.9c1.6 1.6 4.1 1.6 5.7 0l1.1-.9c.5-.5 1.3-.9 2.1-.9H21",
      key: "1dpki6"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WalletMinimal = createLucideIcon("WalletMinimal", [
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  [
    "path",
    {
      d: "M7 7h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14",
      key: "u1rqew"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wallet = createLucideIcon("Wallet", [
  [
    "path",
    {
      d: "M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1",
      key: "18etb6"
    }
  ],
  ["path", { d: "M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4", key: "xoc0q4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wallpaper = createLucideIcon("Wallpaper", [
  ["circle", { cx: "8", cy: "9", r: "2", key: "gjzl9d" }],
  [
    "path",
    {
      d: "m9 17 6.1-6.1a2 2 0 0 1 2.81.01L22 15V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2",
      key: "69xh40"
    }
  ],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WandSparkles = createLucideIcon("WandSparkles", [
  [
    "path",
    {
      d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
      key: "ul74o6"
    }
  ],
  ["path", { d: "m14 7 3 3", key: "1r5n42" }],
  ["path", { d: "M5 6v4", key: "ilb8ba" }],
  ["path", { d: "M19 14v4", key: "blhpug" }],
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M7 8H3", key: "zfb6yr" }],
  ["path", { d: "M21 16h-4", key: "1cnmox" }],
  ["path", { d: "M11 3H9", key: "1obp7u" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wand = createLucideIcon("Wand", [
  ["path", { d: "M15 4V2", key: "z1p9b7" }],
  ["path", { d: "M15 16v-2", key: "px0unx" }],
  ["path", { d: "M8 9h2", key: "1g203m" }],
  ["path", { d: "M20 9h2", key: "19tzq7" }],
  ["path", { d: "M17.8 11.8 19 13", key: "yihg8r" }],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }],
  ["path", { d: "M17.8 6.2 19 5", key: "fd4us0" }],
  ["path", { d: "m3 21 9-9", key: "1jfql5" }],
  ["path", { d: "M12.2 6.2 11 5", key: "i3da3b" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Warehouse = createLucideIcon("Warehouse", [
  [
    "path",
    {
      d: "M22 8.35V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.35A2 2 0 0 1 3.26 6.5l8-3.2a2 2 0 0 1 1.48 0l8 3.2A2 2 0 0 1 22 8.35Z",
      key: "gksnxg"
    }
  ],
  ["path", { d: "M6 18h12", key: "9pbo8z" }],
  ["path", { d: "M6 14h12", key: "4cwo0f" }],
  ["rect", { width: "12", height: "12", x: "6", y: "10", key: "apd30q" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WashingMachine = createLucideIcon("WashingMachine", [
  ["path", { d: "M3 6h3", key: "155dbl" }],
  ["path", { d: "M17 6h.01", key: "e2y6kg" }],
  ["rect", { width: "18", height: "20", x: "3", y: "2", rx: "2", key: "od3kk9" }],
  ["circle", { cx: "12", cy: "13", r: "5", key: "nlbqau" }],
  ["path", { d: "M12 18a2.5 2.5 0 0 0 0-5 2.5 2.5 0 0 1 0-5", key: "17lach" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Watch = createLucideIcon("Watch", [
  ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }],
  ["polyline", { points: "12 10 12 12 13 13", key: "19dquz" }],
  [
    "path",
    { d: "m16.13 7.66-.81-4.05a2 2 0 0 0-2-1.61h-2.68a2 2 0 0 0-2 1.61l-.78 4.05", key: "18k57s" }
  ],
  ["path", { d: "m7.88 16.36.8 4a2 2 0 0 0 2 1.61h2.72a2 2 0 0 0 2-1.61l.81-4.05", key: "16ny36" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Waves = createLucideIcon("Waves", [
  [
    "path",
    {
      d: "M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "knzxuh"
    }
  ],
  [
    "path",
    {
      d: "M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "2jd2cc"
    }
  ],
  [
    "path",
    {
      d: "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "rd2r6e"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Waypoints = createLucideIcon("Waypoints", [
  ["circle", { cx: "12", cy: "4.5", r: "2.5", key: "r5ysbb" }],
  ["path", { d: "m10.2 6.3-3.9 3.9", key: "1nzqf6" }],
  ["circle", { cx: "4.5", cy: "12", r: "2.5", key: "jydg6v" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["circle", { cx: "19.5", cy: "12", r: "2.5", key: "1piiel" }],
  ["path", { d: "m13.8 17.7 3.9-3.9", key: "1wyg1y" }],
  ["circle", { cx: "12", cy: "19.5", r: "2.5", key: "13o1pw" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Webcam = createLucideIcon("Webcam", [
  ["circle", { cx: "12", cy: "10", r: "8", key: "1gshiw" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 22h10", key: "10w4w3" }],
  ["path", { d: "M12 22v-4", key: "1utk9m" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WebhookOff = createLucideIcon("WebhookOff", [
  ["path", { d: "M17 17h-5c-1.09-.02-1.94.92-2.5 1.9A3 3 0 1 1 2.57 15", key: "1tvl6x" }],
  ["path", { d: "M9 3.4a4 4 0 0 1 6.52.66", key: "q04jfq" }],
  ["path", { d: "m6 17 3.1-5.8a2.5 2.5 0 0 0 .057-2.05", key: "azowf0" }],
  ["path", { d: "M20.3 20.3a4 4 0 0 1-2.3.7", key: "5joiws" }],
  ["path", { d: "M18.6 13a4 4 0 0 1 3.357 3.414", key: "cangb8" }],
  ["path", { d: "m12 6 .6 1", key: "tpjl1n" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Webhook = createLucideIcon("Webhook", [
  [
    "path",
    {
      d: "M18 16.98h-5.99c-1.1 0-1.95.94-2.48 1.9A4 4 0 0 1 2 17c.01-.7.2-1.4.57-2",
      key: "q3hayz"
    }
  ],
  ["path", { d: "m6 17 3.13-5.78c.53-.97.1-2.18-.5-3.1a4 4 0 1 1 6.89-4.06", key: "1go1hn" }],
  ["path", { d: "m12 6 3.13 5.73C15.66 12.7 16.9 13 18 13a4 4 0 0 1 0 8", key: "qlwsc0" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Weight = createLucideIcon("Weight", [
  ["circle", { cx: "12", cy: "5", r: "3", key: "rqqgnr" }],
  [
    "path",
    {
      d: "M6.5 8a2 2 0 0 0-1.905 1.46L2.1 18.5A2 2 0 0 0 4 21h16a2 2 0 0 0 1.925-2.54L19.4 9.5A2 2 0 0 0 17.48 8Z",
      key: "56o5sh"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WheatOff = createLucideIcon("WheatOff", [
  ["path", { d: "m2 22 10-10", key: "28ilpk" }],
  ["path", { d: "m16 8-1.17 1.17", key: "1qqm82" }],
  [
    "path",
    {
      d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1rdhi6"
    }
  ],
  [
    "path",
    { d: "m8 8-.53.53a3.5 3.5 0 0 0 0 4.94L9 15l1.53-1.53c.55-.55.88-1.25.98-1.97", key: "4wz8re" }
  ],
  [
    "path",
    { d: "M10.91 5.26c.15-.26.34-.51.56-.73L13 3l1.53 1.53a3.5 3.5 0 0 1 .28 4.62", key: "rves66" }
  ],
  ["path", { d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z", key: "19rau1" }],
  [
    "path",
    {
      d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "tc8ph9"
    }
  ],
  [
    "path",
    {
      d: "m16 16-.53.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.49 3.49 0 0 1 1.97-.98",
      key: "ak46r"
    }
  ],
  [
    "path",
    {
      d: "M18.74 13.09c.26-.15.51-.34.73-.56L21 11l-1.53-1.53a3.5 3.5 0 0 0-4.62-.28",
      key: "1tw520"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wheat = createLucideIcon("Wheat", [
  ["path", { d: "M2 22 16 8", key: "60hf96" }],
  [
    "path",
    {
      d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1rdhi6"
    }
  ],
  [
    "path",
    {
      d: "M7.47 8.53 9 7l1.53 1.53a3.5 3.5 0 0 1 0 4.94L9 15l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1sdzmb"
    }
  ],
  [
    "path",
    {
      d: "M11.47 4.53 13 3l1.53 1.53a3.5 3.5 0 0 1 0 4.94L13 11l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "eoatbi"
    }
  ],
  ["path", { d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z", key: "19rau1" }],
  [
    "path",
    {
      d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "tc8ph9"
    }
  ],
  [
    "path",
    {
      d: "M15.47 13.47 17 15l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "2m8kc5"
    }
  ],
  [
    "path",
    {
      d: "M19.47 9.47 21 11l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L13 11l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "vex3ng"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WholeWord = createLucideIcon("WholeWord", [
  ["circle", { cx: "7", cy: "12", r: "3", key: "12clwm" }],
  ["path", { d: "M10 9v6", key: "17i7lo" }],
  ["circle", { cx: "17", cy: "12", r: "3", key: "gl7c2s" }],
  ["path", { d: "M14 7v8", key: "dl84cr" }],
  ["path", { d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1", key: "lt2kga" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WifiHigh = createLucideIcon("WifiHigh", [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M5 12.859a10 10 0 0 1 14 0", key: "1x1e6c" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WifiLow = createLucideIcon("WifiLow", [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WifiOff = createLucideIcon("WifiOff", [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }],
  ["path", { d: "M5 12.859a10 10 0 0 1 5.17-2.69", key: "1dl1wf" }],
  ["path", { d: "M19 12.859a10 10 0 0 0-2.007-1.523", key: "4k23kn" }],
  ["path", { d: "M2 8.82a15 15 0 0 1 4.177-2.643", key: "1grhjp" }],
  ["path", { d: "M22 8.82a15 15 0 0 0-11.288-3.764", key: "z3jwby" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WifiZero = createLucideIcon("WifiZero", [["path", { d: "M12 20h.01", key: "zekei9" }]]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wifi = createLucideIcon("Wifi", [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M2 8.82a15 15 0 0 1 20 0", key: "dnpr2z" }],
  ["path", { d: "M5 12.859a10 10 0 0 1 14 0", key: "1x1e6c" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wind = createLucideIcon("Wind", [
  ["path", { d: "M17.7 7.7a2.5 2.5 0 1 1 1.8 4.3H2", key: "1k4u03" }],
  ["path", { d: "M9.6 4.6A2 2 0 1 1 11 8H2", key: "b7d0fd" }],
  ["path", { d: "M12.6 19.4A2 2 0 1 0 14 16H2", key: "1p5cb3" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WineOff = createLucideIcon("WineOff", [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M7 10h3m7 0h-1.343", key: "v48bem" }],
  ["path", { d: "M12 15v7", key: "t2xh3l" }],
  [
    "path",
    {
      d: "M7.307 7.307A12.33 12.33 0 0 0 7 10a5 5 0 0 0 7.391 4.391M8.638 2.981C8.75 2.668 8.872 2.34 9 2h6c1.5 4 2 6 2 8 0 .407-.05.809-.145 1.198",
      key: "1ymjlu"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wine = createLucideIcon("Wine", [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M12 15v7", key: "t2xh3l" }],
  [
    "path",
    { d: "M12 15a5 5 0 0 0 5-5c0-2-.5-4-2-8H9c-1.5 4-2 6-2 8a5 5 0 0 0 5 5Z", key: "10ffi3" }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Workflow = createLucideIcon("Workflow", [
  ["rect", { width: "8", height: "8", x: "3", y: "3", rx: "2", key: "by2w9f" }],
  ["path", { d: "M7 11v4a2 2 0 0 0 2 2h4", key: "xkn7yn" }],
  ["rect", { width: "8", height: "8", x: "13", y: "13", rx: "2", key: "1cgmvn" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Worm = createLucideIcon("Worm", [
  ["path", { d: "m19 12-1.5 3", key: "9bcu4o" }],
  ["path", { d: "M19.63 18.81 22 20", key: "121v98" }],
  [
    "path",
    {
      d: "M6.47 8.23a1.68 1.68 0 0 1 2.44 1.93l-.64 2.08a6.76 6.76 0 0 0 10.16 7.67l.42-.27a1 1 0 1 0-2.73-4.21l-.42.27a1.76 1.76 0 0 1-2.63-1.99l.64-2.08A6.66 6.66 0 0 0 3.94 3.9l-.7.4a1 1 0 1 0 2.55 4.34z",
      key: "1tij6q"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WrapText = createLucideIcon("WrapText", [
  ["line", { x1: "3", x2: "21", y1: "6", y2: "6", key: "4m8b97" }],
  ["path", { d: "M3 12h15a3 3 0 1 1 0 6h-4", key: "1cl7v7" }],
  ["polyline", { points: "16 16 14 18 16 20", key: "1jznyi" }],
  ["line", { x1: "3", x2: "10", y1: "18", y2: "18", key: "1h33wv" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wrench = createLucideIcon("Wrench", [
  [
    "path",
    {
      d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z",
      key: "cbrjhi"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X = createLucideIcon("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Youtube = createLucideIcon("Youtube", [
  [
    "path",
    {
      d: "M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17",
      key: "1q2vi4"
    }
  ],
  ["path", { d: "m10 15 5-3-5-3z", key: "1jp15x" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZapOff = createLucideIcon("ZapOff", [
  ["path", { d: "M10.513 4.856 13.12 2.17a.5.5 0 0 1 .86.46l-1.377 4.317", key: "193nxd" }],
  ["path", { d: "M15.656 10H20a1 1 0 0 1 .78 1.63l-1.72 1.773", key: "27a7lr" }],
  [
    "path",
    {
      d: "M16.273 16.273 10.88 21.83a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14H4a1 1 0 0 1-.78-1.63l4.507-4.643",
      key: "1e0qe9"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zap = createLucideIcon("Zap", [
  [
    "path",
    {
      d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
      key: "1xq2db"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZoomIn = createLucideIcon("ZoomIn", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
  ["line", { x1: "11", x2: "11", y1: "8", y2: "14", key: "1vmskp" }],
  ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZoomOut = createLucideIcon("ZoomOut", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
  ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iconsLucide = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AArrowDown,
  AArrowUp,
  ALargeSmall,
  Accessibility,
  Activity,
  AirVent,
  Airplay,
  AlarmClock,
  AlarmClockCheck,
  AlarmClockMinus,
  AlarmClockOff,
  AlarmClockPlus,
  AlarmSmoke,
  Album,
  AlignCenter,
  AlignCenterHorizontal,
  AlignCenterVertical,
  AlignEndHorizontal,
  AlignEndVertical,
  AlignHorizontalDistributeCenter,
  AlignHorizontalDistributeEnd,
  AlignHorizontalDistributeStart,
  AlignHorizontalJustifyCenter,
  AlignHorizontalJustifyEnd,
  AlignHorizontalJustifyStart,
  AlignHorizontalSpaceAround,
  AlignHorizontalSpaceBetween,
  AlignJustify,
  AlignLeft,
  AlignRight,
  AlignStartHorizontal,
  AlignStartVertical,
  AlignVerticalDistributeCenter,
  AlignVerticalDistributeEnd,
  AlignVerticalDistributeStart,
  AlignVerticalJustifyCenter,
  AlignVerticalJustifyEnd,
  AlignVerticalJustifyStart,
  AlignVerticalSpaceAround,
  AlignVerticalSpaceBetween,
  Ambulance,
  Ampersand,
  Ampersands,
  Amphora,
  Anchor,
  Angry,
  Annoyed,
  Antenna,
  Anvil,
  Aperture,
  AppWindow,
  AppWindowMac,
  Apple,
  Archive,
  ArchiveRestore,
  ArchiveX,
  Armchair,
  ArrowBigDown,
  ArrowBigDownDash,
  ArrowBigLeft,
  ArrowBigLeftDash,
  ArrowBigRight,
  ArrowBigRightDash,
  ArrowBigUp,
  ArrowBigUpDash,
  ArrowDown,
  ArrowDown01,
  ArrowDown10,
  ArrowDownAZ,
  ArrowDownFromLine,
  ArrowDownLeft,
  ArrowDownNarrowWide,
  ArrowDownRight,
  ArrowDownToDot,
  ArrowDownToLine,
  ArrowDownUp,
  ArrowDownWideNarrow,
  ArrowDownZA,
  ArrowLeft,
  ArrowLeftFromLine,
  ArrowLeftRight,
  ArrowLeftToLine,
  ArrowRight,
  ArrowRightFromLine,
  ArrowRightLeft,
  ArrowRightToLine,
  ArrowUp,
  ArrowUp01,
  ArrowUp10,
  ArrowUpAZ,
  ArrowUpDown,
  ArrowUpFromDot,
  ArrowUpFromLine,
  ArrowUpLeft,
  ArrowUpNarrowWide,
  ArrowUpRight,
  ArrowUpToLine,
  ArrowUpWideNarrow,
  ArrowUpZA,
  ArrowsUpFromLine,
  Asterisk,
  AtSign,
  Atom,
  AudioLines,
  AudioWaveform,
  Award,
  Axe,
  Axis3d,
  Baby,
  Backpack,
  Badge,
  BadgeAlert,
  BadgeCent,
  BadgeCheck,
  BadgeDollarSign,
  BadgeEuro,
  BadgeHelp,
  BadgeIndianRupee,
  BadgeInfo,
  BadgeJapaneseYen,
  BadgeMinus,
  BadgePercent,
  BadgePlus,
  BadgePoundSterling,
  BadgeRussianRuble,
  BadgeSwissFranc,
  BadgeX,
  BaggageClaim,
  Ban,
  Banana,
  Bandage,
  Banknote,
  Barcode,
  Baseline,
  Bath,
  Battery,
  BatteryCharging,
  BatteryFull,
  BatteryLow,
  BatteryMedium,
  BatteryWarning,
  Beaker,
  Bean,
  BeanOff,
  Bed,
  BedDouble,
  BedSingle,
  Beef,
  Beer,
  BeerOff,
  Bell,
  BellDot,
  BellElectric,
  BellMinus,
  BellOff,
  BellPlus,
  BellRing,
  BetweenHorizontalEnd,
  BetweenHorizontalStart,
  BetweenVerticalEnd,
  BetweenVerticalStart,
  BicepsFlexed,
  Bike,
  Binary,
  Binoculars,
  Biohazard,
  Bird,
  Bitcoin,
  Blend,
  Blinds,
  Blocks,
  Bluetooth,
  BluetoothConnected,
  BluetoothOff,
  BluetoothSearching,
  Bold,
  Bolt,
  Bomb,
  Bone,
  Book,
  BookA,
  BookAudio,
  BookCheck,
  BookCopy,
  BookDashed,
  BookDown,
  BookHeadphones,
  BookHeart,
  BookImage,
  BookKey,
  BookLock,
  BookMarked,
  BookMinus,
  BookOpen,
  BookOpenCheck,
  BookOpenText,
  BookPlus,
  BookText,
  BookType,
  BookUp,
  BookUp2,
  BookUser,
  BookX,
  Bookmark,
  BookmarkCheck,
  BookmarkMinus,
  BookmarkPlus,
  BookmarkX,
  BoomBox,
  Bot,
  BotMessageSquare,
  BotOff,
  Box,
  Boxes,
  Braces,
  Brackets,
  Brain,
  BrainCircuit,
  BrainCog,
  BrickWall,
  Briefcase,
  BriefcaseBusiness,
  BriefcaseConveyorBelt,
  BriefcaseMedical,
  BringToFront,
  Brush,
  Bug,
  BugOff,
  BugPlay,
  Building,
  Building2,
  Bus,
  BusFront,
  Cable,
  CableCar,
  Cake,
  CakeSlice,
  Calculator,
  Calendar,
  Calendar1,
  CalendarArrowDown,
  CalendarArrowUp,
  CalendarCheck,
  CalendarCheck2,
  CalendarClock,
  CalendarCog,
  CalendarDays,
  CalendarFold,
  CalendarHeart,
  CalendarMinus,
  CalendarMinus2,
  CalendarOff,
  CalendarPlus,
  CalendarPlus2,
  CalendarRange,
  CalendarSearch,
  CalendarX,
  CalendarX2,
  Camera: Camera$1,
  CameraOff,
  Candy,
  CandyCane,
  CandyOff,
  Cannabis,
  Captions,
  CaptionsOff,
  Car,
  CarFront,
  CarTaxiFront,
  Caravan,
  Carrot,
  CaseLower,
  CaseSensitive,
  CaseUpper,
  CassetteTape,
  Cast,
  Castle,
  Cat,
  Cctv,
  ChartArea,
  ChartBar,
  ChartBarBig,
  ChartBarDecreasing,
  ChartBarIncreasing,
  ChartBarStacked,
  ChartCandlestick,
  ChartColumn,
  ChartColumnBig,
  ChartColumnDecreasing,
  ChartColumnIncreasing,
  ChartColumnStacked,
  ChartGantt,
  ChartLine,
  ChartNetwork,
  ChartNoAxesColumn,
  ChartNoAxesColumnDecreasing,
  ChartNoAxesColumnIncreasing,
  ChartNoAxesCombined,
  ChartNoAxesGantt,
  ChartPie,
  ChartScatter,
  ChartSpline,
  Check,
  CheckCheck,
  ChefHat,
  Cherry,
  ChevronDown,
  ChevronFirst,
  ChevronLast,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsDown,
  ChevronsDownUp,
  ChevronsLeft,
  ChevronsLeftRight,
  ChevronsLeftRightEllipsis,
  ChevronsRight,
  ChevronsRightLeft,
  ChevronsUp,
  ChevronsUpDown,
  Chrome,
  Church,
  Cigarette,
  CigaretteOff,
  Circle,
  CircleAlert,
  CircleArrowDown,
  CircleArrowLeft,
  CircleArrowOutDownLeft,
  CircleArrowOutDownRight,
  CircleArrowOutUpLeft,
  CircleArrowOutUpRight,
  CircleArrowRight,
  CircleArrowUp,
  CircleCheck,
  CircleCheckBig,
  CircleChevronDown,
  CircleChevronLeft,
  CircleChevronRight,
  CircleChevronUp,
  CircleDashed,
  CircleDivide,
  CircleDollarSign,
  CircleDot,
  CircleDotDashed,
  CircleEllipsis,
  CircleEqual,
  CircleFadingArrowUp,
  CircleFadingPlus,
  CircleGauge,
  CircleHelp,
  CircleMinus,
  CircleOff,
  CircleParking,
  CircleParkingOff,
  CirclePause,
  CirclePercent,
  CirclePlay,
  CirclePlus,
  CirclePower,
  CircleSlash,
  CircleSlash2,
  CircleStop,
  CircleUser,
  CircleUserRound,
  CircleX,
  CircuitBoard,
  Citrus,
  Clapperboard,
  Clipboard,
  ClipboardCheck,
  ClipboardCopy,
  ClipboardList,
  ClipboardMinus,
  ClipboardPaste,
  ClipboardPen,
  ClipboardPenLine,
  ClipboardPlus,
  ClipboardType,
  ClipboardX,
  Clock,
  Clock1,
  Clock10,
  Clock11,
  Clock12,
  Clock2,
  Clock3,
  Clock4,
  Clock5,
  Clock6,
  Clock7,
  Clock8,
  Clock9,
  ClockAlert,
  ClockArrowDown,
  ClockArrowUp,
  Cloud,
  CloudCog,
  CloudDownload,
  CloudDrizzle,
  CloudFog,
  CloudHail,
  CloudLightning,
  CloudMoon,
  CloudMoonRain,
  CloudOff,
  CloudRain,
  CloudRainWind,
  CloudSnow,
  CloudSun,
  CloudSunRain,
  CloudUpload,
  Cloudy,
  Clover,
  Club,
  Code,
  CodeXml,
  Codepen,
  Codesandbox,
  Coffee,
  Cog,
  Coins,
  Columns2,
  Columns3,
  Columns4,
  Combine,
  Command,
  Compass,
  Component,
  Computer,
  ConciergeBell,
  Cone,
  Construction,
  Contact,
  ContactRound,
  Container,
  Contrast,
  Cookie,
  CookingPot,
  Copy,
  CopyCheck,
  CopyMinus,
  CopyPlus,
  CopySlash,
  CopyX,
  Copyleft,
  Copyright,
  CornerDownLeft,
  CornerDownRight,
  CornerLeftDown,
  CornerLeftUp,
  CornerRightDown,
  CornerRightUp,
  CornerUpLeft,
  CornerUpRight,
  Cpu,
  CreativeCommons,
  CreditCard,
  Croissant,
  Crop,
  Cross,
  Crosshair,
  Crown,
  Cuboid,
  CupSoda,
  Currency,
  Cylinder,
  Dam,
  Database,
  DatabaseBackup,
  DatabaseZap,
  Delete,
  Dessert,
  Diameter,
  Diamond,
  DiamondMinus,
  DiamondPercent,
  DiamondPlus,
  Dice1,
  Dice2,
  Dice3,
  Dice4,
  Dice5,
  Dice6,
  Dices,
  Diff,
  Disc,
  Disc2,
  Disc3,
  DiscAlbum,
  Divide,
  Dna,
  DnaOff,
  Dock,
  Dog,
  DollarSign,
  Donut,
  DoorClosed,
  DoorOpen,
  Dot,
  Download,
  DraftingCompass,
  Drama,
  Dribbble,
  Drill,
  Droplet,
  Droplets,
  Drum,
  Drumstick,
  Dumbbell,
  Ear,
  EarOff,
  Earth,
  EarthLock,
  Eclipse,
  Egg,
  EggFried,
  EggOff,
  Ellipsis,
  EllipsisVertical,
  Equal,
  EqualNot,
  Eraser,
  EthernetPort,
  Euro,
  Expand,
  ExternalLink,
  Eye,
  EyeClosed,
  EyeOff,
  Facebook,
  Factory,
  Fan,
  FastForward,
  Feather,
  Fence,
  FerrisWheel,
  Figma,
  File,
  FileArchive,
  FileAudio,
  FileAudio2,
  FileAxis3d,
  FileBadge,
  FileBadge2,
  FileBox,
  FileChartColumn,
  FileChartColumnIncreasing,
  FileChartLine,
  FileChartPie,
  FileCheck,
  FileCheck2,
  FileClock,
  FileCode,
  FileCode2,
  FileCog,
  FileDiff,
  FileDigit,
  FileDown,
  FileHeart,
  FileImage,
  FileInput,
  FileJson,
  FileJson2,
  FileKey,
  FileKey2,
  FileLock,
  FileLock2,
  FileMinus,
  FileMinus2,
  FileMusic,
  FileOutput,
  FilePen,
  FilePenLine,
  FilePlus,
  FilePlus2,
  FileQuestion,
  FileScan,
  FileSearch,
  FileSearch2,
  FileSliders,
  FileSpreadsheet,
  FileStack,
  FileSymlink,
  FileTerminal,
  FileText,
  FileType,
  FileType2,
  FileUp,
  FileUser,
  FileVideo,
  FileVideo2,
  FileVolume,
  FileVolume2,
  FileWarning,
  FileX,
  FileX2,
  Files,
  Film,
  Filter,
  FilterX,
  Fingerprint,
  FireExtinguisher,
  Fish,
  FishOff,
  FishSymbol,
  Flag,
  FlagOff,
  FlagTriangleLeft,
  FlagTriangleRight,
  Flame,
  FlameKindling,
  Flashlight,
  FlashlightOff,
  FlaskConical,
  FlaskConicalOff,
  FlaskRound,
  FlipHorizontal,
  FlipHorizontal2,
  FlipVertical,
  FlipVertical2,
  Flower,
  Flower2,
  Focus,
  FoldHorizontal,
  FoldVertical,
  Folder,
  FolderArchive,
  FolderCheck,
  FolderClock,
  FolderClosed,
  FolderCode,
  FolderCog,
  FolderDot,
  FolderDown,
  FolderGit,
  FolderGit2,
  FolderHeart,
  FolderInput,
  FolderKanban,
  FolderKey,
  FolderLock,
  FolderMinus,
  FolderOpen,
  FolderOpenDot,
  FolderOutput,
  FolderPen,
  FolderPlus,
  FolderRoot,
  FolderSearch,
  FolderSearch2,
  FolderSymlink,
  FolderSync,
  FolderTree,
  FolderUp,
  FolderX,
  Folders,
  Footprints,
  Forklift,
  Forward,
  Frame,
  Framer,
  Frown,
  Fuel,
  Fullscreen,
  GalleryHorizontal,
  GalleryHorizontalEnd,
  GalleryThumbnails,
  GalleryVertical,
  GalleryVerticalEnd,
  Gamepad,
  Gamepad2,
  Gauge,
  Gavel,
  Gem,
  Ghost,
  Gift,
  GitBranch,
  GitBranchPlus,
  GitCommitHorizontal,
  GitCommitVertical,
  GitCompare,
  GitCompareArrows,
  GitFork,
  GitGraph,
  GitMerge,
  GitPullRequest,
  GitPullRequestArrow,
  GitPullRequestClosed,
  GitPullRequestCreate,
  GitPullRequestCreateArrow,
  GitPullRequestDraft,
  Github,
  Gitlab,
  GlassWater,
  Glasses,
  Globe,
  GlobeLock,
  Goal,
  Grab,
  GraduationCap,
  Grape,
  Grid2x2,
  Grid2x2Check,
  Grid2x2Plus,
  Grid2x2X,
  Grid3x3,
  Grip,
  GripHorizontal,
  GripVertical,
  Group,
  Guitar,
  Ham,
  Hammer,
  Hand,
  HandCoins,
  HandHeart,
  HandHelping,
  HandMetal,
  HandPlatter,
  Handshake,
  HardDrive,
  HardDriveDownload,
  HardDriveUpload,
  HardHat,
  Hash,
  Haze,
  HdmiPort,
  Heading,
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Heading5,
  Heading6,
  HeadphoneOff,
  Headphones,
  Headset,
  Heart,
  HeartCrack,
  HeartHandshake,
  HeartOff,
  HeartPulse,
  Heater,
  Hexagon,
  Highlighter,
  History,
  Hop,
  HopOff,
  Hospital,
  Hotel,
  Hourglass,
  House,
  HousePlug,
  HousePlus,
  IceCreamBowl,
  IceCreamCone,
  IdCard,
  Image,
  ImageDown,
  ImageMinus,
  ImageOff,
  ImagePlay,
  ImagePlus,
  ImageUp,
  Images,
  Import,
  Inbox,
  IndentDecrease,
  IndentIncrease,
  IndianRupee,
  Infinity,
  Info,
  InspectionPanel,
  Instagram,
  Italic,
  IterationCcw,
  IterationCw,
  JapaneseYen,
  Joystick,
  Kanban,
  Key,
  KeyRound,
  KeySquare,
  Keyboard,
  KeyboardMusic,
  KeyboardOff,
  Lamp,
  LampCeiling,
  LampDesk,
  LampFloor,
  LampWallDown,
  LampWallUp,
  LandPlot,
  Landmark,
  Languages,
  Laptop,
  LaptopMinimal,
  Lasso,
  LassoSelect,
  Laugh,
  Layers,
  Layers2,
  Layers3,
  LayoutDashboard,
  LayoutGrid,
  LayoutList,
  LayoutPanelLeft,
  LayoutPanelTop,
  LayoutTemplate,
  Leaf,
  LeafyGreen,
  Lectern,
  LetterText,
  Library,
  LibraryBig,
  LifeBuoy,
  Ligature,
  Lightbulb,
  LightbulbOff,
  Link,
  Link2,
  Link2Off,
  Linkedin,
  List,
  ListCheck,
  ListChecks,
  ListCollapse,
  ListEnd,
  ListFilter,
  ListMinus,
  ListMusic,
  ListOrdered,
  ListPlus,
  ListRestart,
  ListStart,
  ListTodo,
  ListTree,
  ListVideo,
  ListX,
  Loader,
  LoaderCircle,
  LoaderPinwheel,
  Locate,
  LocateFixed,
  LocateOff,
  Lock,
  LockKeyhole,
  LockKeyholeOpen,
  LockOpen,
  LogIn,
  LogOut,
  Logs,
  Lollipop,
  Luggage,
  Magnet,
  Mail,
  MailCheck,
  MailMinus,
  MailOpen,
  MailPlus,
  MailQuestion,
  MailSearch,
  MailWarning,
  MailX,
  Mailbox,
  Mails,
  Map: Map$1,
  MapPin,
  MapPinCheck,
  MapPinCheckInside,
  MapPinHouse,
  MapPinMinus,
  MapPinMinusInside,
  MapPinOff,
  MapPinPlus,
  MapPinPlusInside,
  MapPinX,
  MapPinXInside,
  MapPinned,
  Martini,
  Maximize,
  Maximize2,
  Medal,
  Megaphone,
  MegaphoneOff,
  Meh,
  MemoryStick,
  Menu,
  Merge,
  MessageCircle,
  MessageCircleCode,
  MessageCircleDashed,
  MessageCircleHeart,
  MessageCircleMore,
  MessageCircleOff,
  MessageCirclePlus,
  MessageCircleQuestion,
  MessageCircleReply,
  MessageCircleWarning,
  MessageCircleX,
  MessageSquare,
  MessageSquareCode,
  MessageSquareDashed,
  MessageSquareDiff,
  MessageSquareDot,
  MessageSquareHeart,
  MessageSquareLock,
  MessageSquareMore,
  MessageSquareOff,
  MessageSquarePlus,
  MessageSquareQuote,
  MessageSquareReply,
  MessageSquareShare,
  MessageSquareText,
  MessageSquareWarning,
  MessageSquareX,
  MessagesSquare,
  Mic,
  MicOff,
  MicVocal,
  Microchip,
  Microscope,
  Microwave,
  Milestone,
  Milk,
  MilkOff,
  Minimize,
  Minimize2,
  Minus,
  Monitor,
  MonitorCheck,
  MonitorCog,
  MonitorDot,
  MonitorDown,
  MonitorOff,
  MonitorPause,
  MonitorPlay,
  MonitorSmartphone,
  MonitorSpeaker,
  MonitorStop,
  MonitorUp,
  MonitorX,
  Moon,
  MoonStar,
  Mountain,
  MountainSnow,
  Mouse,
  MouseOff,
  MousePointer,
  MousePointer2,
  MousePointerBan,
  MousePointerClick,
  Move,
  Move3d,
  MoveDiagonal,
  MoveDiagonal2,
  MoveDown,
  MoveDownLeft,
  MoveDownRight,
  MoveHorizontal,
  MoveLeft,
  MoveRight,
  MoveUp,
  MoveUpLeft,
  MoveUpRight,
  MoveVertical,
  Music,
  Music2,
  Music3,
  Music4,
  Navigation,
  Navigation2,
  Navigation2Off,
  NavigationOff,
  Network,
  Newspaper,
  Nfc,
  Notebook,
  NotebookPen,
  NotebookTabs,
  NotebookText,
  NotepadText,
  NotepadTextDashed,
  Nut,
  NutOff,
  Octagon,
  OctagonAlert,
  OctagonMinus,
  OctagonPause,
  OctagonX,
  Omega,
  Option,
  Orbit,
  Origami,
  Package,
  Package2,
  PackageCheck,
  PackageMinus,
  PackageOpen,
  PackagePlus,
  PackageSearch,
  PackageX,
  PaintBucket,
  PaintRoller,
  Paintbrush,
  PaintbrushVertical,
  Palette,
  PanelBottom,
  PanelBottomClose,
  PanelBottomDashed,
  PanelBottomOpen,
  PanelLeft,
  PanelLeftClose,
  PanelLeftDashed,
  PanelLeftOpen,
  PanelRight,
  PanelRightClose,
  PanelRightDashed,
  PanelRightOpen,
  PanelTop,
  PanelTopClose,
  PanelTopDashed,
  PanelTopOpen,
  PanelsLeftBottom,
  PanelsRightBottom,
  PanelsTopLeft,
  Paperclip,
  Parentheses,
  ParkingMeter,
  PartyPopper,
  Pause,
  PawPrint,
  PcCase,
  Pen,
  PenLine,
  PenOff,
  PenTool,
  Pencil,
  PencilLine,
  PencilOff,
  PencilRuler,
  Pentagon,
  Percent,
  PersonStanding,
  PhilippinePeso,
  Phone,
  PhoneCall,
  PhoneForwarded,
  PhoneIncoming,
  PhoneMissed,
  PhoneOff,
  PhoneOutgoing,
  Pi,
  Piano,
  Pickaxe,
  PictureInPicture,
  PictureInPicture2,
  PiggyBank,
  Pilcrow,
  PilcrowLeft,
  PilcrowRight,
  Pill,
  PillBottle,
  Pin,
  PinOff,
  Pipette,
  Pizza,
  Plane,
  PlaneLanding,
  PlaneTakeoff,
  Play,
  Plug,
  Plug2,
  PlugZap,
  Plus,
  Pocket,
  PocketKnife,
  Podcast,
  Pointer,
  PointerOff,
  Popcorn,
  Popsicle,
  PoundSterling,
  Power,
  PowerOff,
  Presentation,
  Printer,
  PrinterCheck,
  Projector,
  Proportions,
  Puzzle,
  Pyramid,
  QrCode,
  Quote,
  Rabbit,
  Radar,
  Radiation,
  Radical,
  Radio,
  RadioReceiver,
  RadioTower,
  Radius,
  RailSymbol,
  Rainbow,
  Rat,
  Ratio,
  Receipt,
  ReceiptCent,
  ReceiptEuro,
  ReceiptIndianRupee,
  ReceiptJapaneseYen,
  ReceiptPoundSterling,
  ReceiptRussianRuble,
  ReceiptSwissFranc,
  ReceiptText,
  RectangleEllipsis,
  RectangleHorizontal,
  RectangleVertical,
  Recycle,
  Redo,
  Redo2,
  RedoDot,
  RefreshCcw,
  RefreshCcwDot,
  RefreshCw,
  RefreshCwOff,
  Refrigerator,
  Regex,
  RemoveFormatting,
  Repeat,
  Repeat1,
  Repeat2,
  Replace,
  ReplaceAll,
  Reply,
  ReplyAll,
  Rewind,
  Ribbon,
  Rocket,
  RockingChair,
  RollerCoaster,
  Rotate3d,
  RotateCcw,
  RotateCcwSquare,
  RotateCw,
  RotateCwSquare,
  Route,
  RouteOff,
  Router,
  Rows2,
  Rows3,
  Rows4,
  Rss,
  Ruler,
  RussianRuble,
  Sailboat,
  Salad,
  Sandwich,
  Satellite,
  SatelliteDish,
  Save,
  SaveAll,
  SaveOff,
  Scale,
  Scale3d,
  Scaling,
  Scan,
  ScanBarcode,
  ScanEye,
  ScanFace,
  ScanLine,
  ScanQrCode,
  ScanSearch,
  ScanText,
  School,
  Scissors,
  ScissorsLineDashed,
  ScreenShare,
  ScreenShareOff,
  Scroll,
  ScrollText,
  Search,
  SearchCheck,
  SearchCode,
  SearchSlash,
  SearchX,
  Section,
  Send,
  SendHorizontal,
  SendToBack,
  SeparatorHorizontal,
  SeparatorVertical,
  Server,
  ServerCog,
  ServerCrash,
  ServerOff,
  Settings: Settings$1,
  Settings2,
  Shapes,
  Share,
  Share2,
  Sheet,
  Shell,
  Shield,
  ShieldAlert,
  ShieldBan,
  ShieldCheck,
  ShieldEllipsis,
  ShieldHalf,
  ShieldMinus,
  ShieldOff,
  ShieldPlus,
  ShieldQuestion,
  ShieldX,
  Ship,
  ShipWheel,
  Shirt,
  ShoppingBag,
  ShoppingBasket,
  ShoppingCart,
  Shovel,
  ShowerHead,
  Shrink,
  Shrub,
  Shuffle,
  Sigma,
  Signal,
  SignalHigh,
  SignalLow,
  SignalMedium,
  SignalZero,
  Signature,
  Signpost,
  SignpostBig,
  Siren,
  SkipBack,
  SkipForward,
  Skull,
  Slack,
  Slash,
  Slice,
  SlidersHorizontal,
  SlidersVertical,
  Smartphone,
  SmartphoneCharging,
  SmartphoneNfc,
  Smile,
  SmilePlus,
  Snail,
  Snowflake,
  Sofa,
  Soup,
  Space,
  Spade,
  Sparkle,
  Sparkles,
  Speaker,
  Speech,
  SpellCheck,
  SpellCheck2,
  Spline,
  Split,
  SprayCan,
  Sprout,
  Square,
  SquareActivity,
  SquareArrowDown,
  SquareArrowDownLeft,
  SquareArrowDownRight,
  SquareArrowLeft,
  SquareArrowOutDownLeft,
  SquareArrowOutDownRight,
  SquareArrowOutUpLeft,
  SquareArrowOutUpRight,
  SquareArrowRight,
  SquareArrowUp,
  SquareArrowUpLeft,
  SquareArrowUpRight,
  SquareAsterisk,
  SquareBottomDashedScissors,
  SquareChartGantt,
  SquareCheck,
  SquareCheckBig,
  SquareChevronDown,
  SquareChevronLeft,
  SquareChevronRight,
  SquareChevronUp,
  SquareCode,
  SquareDashed,
  SquareDashedBottom,
  SquareDashedBottomCode,
  SquareDashedKanban,
  SquareDashedMousePointer,
  SquareDivide,
  SquareDot,
  SquareEqual,
  SquareFunction,
  SquareKanban,
  SquareLibrary,
  SquareM,
  SquareMenu,
  SquareMinus,
  SquareMousePointer,
  SquareParking,
  SquareParkingOff,
  SquarePen,
  SquarePercent,
  SquarePi,
  SquarePilcrow,
  SquarePlay,
  SquarePlus,
  SquarePower,
  SquareRadical,
  SquareScissors,
  SquareSigma,
  SquareSlash,
  SquareSplitHorizontal,
  SquareSplitVertical,
  SquareSquare,
  SquareStack,
  SquareTerminal,
  SquareUser,
  SquareUserRound,
  SquareX,
  Squircle,
  Squirrel,
  Stamp,
  Star,
  StarHalf,
  StarOff,
  StepBack,
  StepForward,
  Stethoscope,
  Sticker,
  StickyNote,
  Store,
  StretchHorizontal,
  StretchVertical,
  Strikethrough,
  Subscript,
  Sun,
  SunDim,
  SunMedium,
  SunMoon,
  SunSnow,
  Sunrise,
  Sunset,
  Superscript,
  SwatchBook,
  SwissFranc,
  SwitchCamera,
  Sword,
  Swords,
  Syringe,
  Table,
  Table2,
  TableCellsMerge,
  TableCellsSplit,
  TableColumnsSplit,
  TableOfContents,
  TableProperties,
  TableRowsSplit,
  Tablet,
  TabletSmartphone,
  Tablets,
  Tag,
  Tags,
  Tally1,
  Tally2,
  Tally3,
  Tally4,
  Tally5,
  Tangent,
  Target,
  Telescope,
  Tent,
  TentTree,
  Terminal,
  TestTube,
  TestTubeDiagonal,
  TestTubes,
  Text,
  TextCursor,
  TextCursorInput,
  TextQuote,
  TextSearch,
  TextSelect,
  Theater,
  Thermometer,
  ThermometerSnowflake,
  ThermometerSun,
  ThumbsDown,
  ThumbsUp,
  Ticket,
  TicketCheck,
  TicketMinus,
  TicketPercent,
  TicketPlus,
  TicketSlash,
  TicketX,
  Tickets,
  TicketsPlane,
  Timer,
  TimerOff,
  TimerReset,
  ToggleLeft,
  ToggleRight,
  Tornado,
  Torus,
  Touchpad,
  TouchpadOff,
  TowerControl,
  ToyBrick,
  Tractor,
  TrafficCone,
  TrainFront,
  TrainFrontTunnel,
  TrainTrack,
  TramFront,
  Trash,
  Trash2,
  TreeDeciduous,
  TreePalm,
  TreePine,
  Trees,
  Trello,
  TrendingDown,
  TrendingUp,
  TrendingUpDown,
  Triangle,
  TriangleAlert,
  TriangleRight,
  Trophy,
  Truck,
  Turtle,
  Tv,
  TvMinimal,
  TvMinimalPlay,
  Twitch,
  Twitter,
  Type,
  TypeOutline,
  Umbrella,
  UmbrellaOff,
  Underline,
  Undo,
  Undo2,
  UndoDot,
  UnfoldHorizontal,
  UnfoldVertical,
  Ungroup,
  University,
  Unlink,
  Unlink2,
  Unplug,
  Upload,
  Usb,
  User,
  UserCheck,
  UserCog,
  UserMinus,
  UserPen,
  UserPlus,
  UserRound,
  UserRoundCheck,
  UserRoundCog,
  UserRoundMinus,
  UserRoundPen,
  UserRoundPlus,
  UserRoundSearch,
  UserRoundX,
  UserSearch,
  UserX,
  Users,
  UsersRound,
  Utensils,
  UtensilsCrossed,
  UtilityPole,
  Variable,
  Vault,
  Vegan,
  VenetianMask,
  Vibrate,
  VibrateOff,
  Video,
  VideoOff,
  Videotape,
  View,
  Voicemail,
  Volleyball,
  Volume,
  Volume1,
  Volume2,
  VolumeOff,
  VolumeX,
  Vote,
  Wallet,
  WalletCards,
  WalletMinimal,
  Wallpaper,
  Wand,
  WandSparkles,
  Warehouse,
  WashingMachine,
  Watch,
  Waves,
  Waypoints,
  Webcam,
  Webhook,
  WebhookOff,
  Weight,
  Wheat,
  WheatOff,
  WholeWord,
  Wifi,
  WifiHigh,
  WifiLow,
  WifiOff,
  WifiZero,
  Wind,
  Wine,
  WineOff,
  Workflow,
  Worm,
  WrapText,
  Wrench,
  X,
  Youtube,
  Zap,
  ZapOff,
  ZoomIn,
  ZoomOut
}, Symbol.toStringTag, { value: "Module" }));
const parseCamelCaseToKebabCase = (name) => {
  return name.split(/(?=[A-Z])/).join("-").toLowerCase();
};
const kebabToCamelCase = (name) => name.split("-").map((part, index) => index === 0 ? part.charAt(0).toUpperCase() + part.slice(1) : part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()).join("");
const ArrowDropDownCb = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-arrow-drop-down-cb",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "m4.697 7.315 2.597 2.597a1 1 0 0 0 1.414 0l2.597-2.597c.632-.632.18-1.715-.712-1.715H5.4c-.892 0-1.333 1.083-.702 1.715"
      }
    )
  }
);
const ArrowDropUpCb = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-arrow-drop-up-cb",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "m4.697 8.49 2.597-2.597a1 1 0 0 1 1.414 0l2.597 2.597c.632.632.18 1.715-.712 1.715H5.4c-.892 0-1.333-1.083-.702-1.715"
      }
    )
  }
);
const Camera = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-camera",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17",
    ...props,
    children: [
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1774F0",
          d: "M11.889 7.25V4.333c0-.458-.35-.833-.778-.833H1.778C1.35 3.5 1 3.875 1 4.333v8.334c0 .458.35.833.778.833h9.333c.428 0 .778-.375.778-.833V9.75L15 13.083V3.917z"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 .5h16v16H0z" }) }) })
    ]
  }
);
const CarCrash = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-car-crash",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 -960 960 960",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M168-240v-168zM96-417.89q0-6.7 1.5-13.41Q99-438 101-445l73-182q8-20 26-32.5t41-12.5h131q15.3 0 25.65 10.29t10.35 25.5-10.35 25.71T372-600H241l-48 120h300q14.88 0 24.94 10.29t10.06 25.5-10.35 25.71T492-408H168v168h528v-132q0-15.3 10.29-25.65t25.5-10.35 25.71 10.35T768-372v228q0 20-14 34t-34 14-34-14-14-34v-24H192v24q0 20-14 34t-34 14-34-14-14-34zM600-276q20 0 34-14t14-34-14-34-34-14-34 14-14 34 14 34 34 14m-336 0q20 0 34-14t14-34-14-34-34-14-34 14-14 34 14 34 34 14m407.77-204Q592-480 536-536.16T480-672q0-80 56-136t136.45-56q79.49 0 135.52 56.23 56.03 56.22 56.03 136Q864-592 807.77-536q-56.22 56-136 56m.23-192q9.6 0 16.8-7.2T696-696v-48q0-9.6-7.2-16.8T672-768t-16.8 7.2T648-744v48q0 9.6 7.2 16.8T672-672m0 96q9.6 0 16.8-7.2T696-600t-7.2-16.8T672-624t-16.8 7.2T648-600t7.2 16.8T672-576" })
  }
);
const DeviceStatusIndicatorsDisablePendingIndicator = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-device-status-indicators-disable-pending-indicator",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 25 24",
    ...props,
    children: [
      /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#FCF0DE",
            fillRule: "evenodd",
            stroke: "#F9D199",
            d: "M12.002 22.8c5.965 0 10.808-4.836 10.815-10.8.009-5.964-4.821-10.8-10.786-10.8S1.224 6.036 1.216 12s4.822 10.8 10.786 10.8Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#F08C00",
            fillRule: "evenodd",
            d: "M15.62 9.9h-.6l.001-1.2c.003-1.656-1.34-3-2.996-3a3.006 3.006 0 0 0-3.004 3l-.002 1.2h-.6c-.66 0-1.2.54-1.201 1.2l-.008 6c-.001.66.538 1.2 1.198 1.2h7.2c.66 0 1.201-.54 1.202-1.2l.008-6c.001-.66-.538-1.2-1.198-1.2m-3.608 5.4c-.66 0-1.199-.54-1.198-1.2 0-.66.542-1.2 1.202-1.2s1.199.54 1.198 1.2c0 .66-.542 1.2-1.202 1.2m1.868-5.4h-3.72l.001-1.2a1.865 1.865 0 0 1 1.863-1.86c1.026 0 1.859.834 1.857 1.86z",
            clipRule: "evenodd"
          }
        )
      ] }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M.032 0h24.002l-.032 24H0z" }) }) })
    ]
  }
);
const DeviceStatusIndicatorsDisabledIndicator = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-device-status-indicators-disabled-indicator",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 18",
    ...props,
    children: [
      /* @__PURE__ */ jsxs("g", { fillRule: "evenodd", clipPath: "url(#a)", clipRule: "evenodd", children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#FCEDEB",
            stroke: "#F5B7B1",
            d: "M9 17.1A8.1 8.1 0 1 0 8.999.899a8.1 8.1 0 0 0 0 16.2Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#E74C3C",
            d: "M11.7 7.425h-.45v-.9a2.25 2.25 0 0 0-4.5 0v.9H6.3c-.495 0-.9.405-.9.9v4.5c0 .495.405.9.9.9h5.4c.495 0 .9-.405.9-.9v-4.5c0-.495-.405-.9-.9-.9M9 11.475a.903.903 0 0 1-.9-.9c0-.495.405-.9.9-.9s.9.405.9.9-.405.9-.9.9m1.395-4.05h-2.79v-.9a1.396 1.396 0 0 1 2.79 0z"
          }
        )
      ] }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h18v18H0z" }) }) })
    ]
  }
);
const DeviceStatusIndicatorsEnablePendingIndicator = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-device-status-indicators-enable-pending-indicator",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 25 24",
    ...props,
    children: [
      /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#CFDEF2",
            fillRule: "evenodd",
            stroke: "#8AB9F7",
            d: "M12.002 22.8c5.965 0 10.808-4.836 10.816-10.8S17.996 1.2 12.03 1.2C6.067 1.2 1.224 6.036 1.216 12s4.822 10.8 10.786 10.8Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#1774F0",
            fillRule: "evenodd",
            d: "M12.013 15c.66 0 1.2-.54 1.202-1.2 0-.66-.539-1.2-1.199-1.2s-1.2.54-1.201 1.2.538 1.2 1.198 1.2m3.608-5.4h-.6l.001-1.2c.002-1.656-1.34-3-2.996-3a3.006 3.006 0 0 0-3.004 3h1.14a1.865 1.865 0 0 1 1.862-1.86c1.026 0 1.86.834 1.858 1.86l-.002 1.2H8.42c-.66 0-1.2.54-1.202 1.2l-.008 6c0 .66.539 1.2 1.199 1.2h7.2c.66 0 1.201-.54 1.202-1.2l.008-6c0-.66-.538-1.2-1.198-1.2m-.01 7.2h-7.2l.007-6h7.2z",
            clipRule: "evenodd"
          }
        )
      ] }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M.032 0h24.002l-.032 24H0z" }) }) })
    ]
  }
);
const DeviceStatusIndicatorsLostData = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-device-status-indicators-lost-data",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 12 13",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "M6 11.75q-.464 0-.795-.343a1.15 1.15 0 0 1-.33-.824q0-.48.33-.824.33-.342.795-.342.464 0 .795.342.33.343.33.824 0 .482-.33.824-.33.343-.795.343m0-3.5q-.464 0-.795-.343a1.15 1.15 0 0 1-.33-.824V2.417q0-.482.33-.824.33-.343.795-.343.464 0 .795.343.33.342.33.824v4.666q0 .482-.33.824-.33.343-.795.343"
      }
    )
  }
);
const DeviceStatusIndicatorsNew = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-device-status-indicators-new",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 12 13",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m11.5 6.5-1.22-1.39.17-1.84-1.805-.41L7.7 1.27 6 2l-1.7-.73-.945 1.59-1.805.405.17 1.84L.5 6.5l1.22 1.39-.17 1.845 1.805.41.945 1.59L6 11l1.7.73.945-1.59 1.805-.41-.17-1.84zM5.5 9V8h1v1zm0-2h1V4h-1z",
        clipRule: "evenodd"
      }
    )
  }
);
const DeviceStatusIndicatorsNoSignalIndicator = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-device-status-indicators-no-signal-indicator",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 18",
    ...props,
    children: [
      /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#F4F7F9",
            stroke: "#9DA9B6",
            strokeLinejoin: "round",
            d: "M8.293 1.707a1 1 0 0 1 1.414 0l6.586 6.586a1 1 0 0 1 0 1.414l-6.586 6.586a1 1 0 0 1-1.414 0L1.707 9.707a1 1 0 0 1 0-1.414z"
          }
        ),
        /* @__PURE__ */ jsx("g", { clipPath: "url(#b)", children: /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#5D7186",
            d: "M11.815 5.734a.347.347 0 0 0-.591-.245L8.943 7.77l2.872 2.873zm.152 6.04L6.5 6.303a.344.344 0 1 0-.488.488L7.968 8.75l-2.475 2.475a.346.346 0 0 0 .242.59h5.295l.446.447a.344.344 0 0 0 .488 0 .34.34 0 0 0 .003-.488"
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxs("defs", { children: [
        /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h18v18H0z" }) }),
        /* @__PURE__ */ jsx("clipPath", { id: "b", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M4.556 4.555h8.296v8.296H4.556z" }) })
      ] })
    ]
  }
);
const DeviceStatusIndicatorsSynchronizingIndicator = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-device-status-indicators-synchronizing-indicator",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 18",
    ...props,
    children: [
      /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#179EEE",
            fillRule: "evenodd",
            stroke: "#F4F7F9",
            d: "M9 17.1A8.1 8.1 0 1 0 8.999.899a8.1 8.1 0 0 0 0 16.2Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "M5.85 9.026q0 .591.223 1.149t.696 1.03l.13.131v-.761q0-.223.152-.374.15-.15.374-.151.223 0 .374.151.15.15.15.374v2.1q0 .223-.15.374-.15.15-.374.151h-2.1a.5.5 0 0 1-.374-.15.5.5 0 0 1-.151-.375q0-.223.15-.374.152-.15.375-.151h.919l-.21-.184q-.683-.604-.959-1.378A4.6 4.6 0 0 1 4.8 9.026q0-1.233.63-2.238.63-1.003 1.693-1.542a.4.4 0 0 1 .387-.013.47.47 0 0 1 .27.302.58.58 0 0 1-.007.394.56.56 0 0 1-.256.302q-.762.42-1.214 1.161a3.1 3.1 0 0 0-.453 1.634m6.3-.052q0-.591-.223-1.149a3.1 3.1 0 0 0-.696-1.03l-.131-.131v.761q0 .223-.151.374-.15.15-.374.151a.5.5 0 0 1-.374-.15.5.5 0 0 1-.151-.375v-2.1q0-.223.15-.374.152-.15.375-.15h2.1q.223 0 .374.15.15.15.15.374 0 .223-.15.374-.15.15-.374.151h-.919l.21.184q.644.643.939 1.398t.295 1.542q0 1.233-.63 2.238a4.2 4.2 0 0 1-1.693 1.542.4.4 0 0 1-.388.013.47.47 0 0 1-.269-.302.58.58 0 0 1 .007-.394.56.56 0 0 1 .256-.302q.76-.42 1.214-1.161.453-.743.453-1.634"
          }
        )
      ] }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h18v18H0z" }) }) })
    ]
  }
);
const DeviceStatusIndicatorsUnavailableIndicator = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-device-status-indicators-unavailable-indicator",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 18",
    ...props,
    children: [
      /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#E74C3C",
            stroke: "#fff",
            strokeLinejoin: "round",
            d: "M1.7 1.8h14.6a1 1 0 0 1 .873 1.486l-7.3 13.12a1 1 0 0 1-1.747 0l-7.3-13.12A1 1 0 0 1 1.702 1.8Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "M9 12.075a.75.75 0 0 1-.556-.24.8.8 0 0 1-.232-.577q0-.336.232-.577t.556-.24.556.24.231.577a.8.8 0 0 1-.23.577.75.75 0 0 1-.557.24m0-2.45a.75.75 0 0 1-.556-.24.8.8 0 0 1-.232-.577V5.542q0-.337.232-.577T9 4.725t.556.24.231.577v3.266a.8.8 0 0 1-.23.577.75.75 0 0 1-.557.24"
          }
        )
      ] }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h18v18H0z" }) }) })
    ]
  }
);
const DeviceStatusIndicatorsUnpluggedIndicator = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-device-status-indicators-unplugged-indicator",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 18",
    ...props,
    children: [
      /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#F08C00",
            stroke: "#fff",
            strokeLinejoin: "round",
            d: "M1.7 1.8h14.6a1 1 0 0 1 .873 1.486l-7.3 13.12a1 1 0 0 1-1.747 0l-7.3-13.12A1 1 0 0 1 1.702 1.8Z"
          }
        ),
        /* @__PURE__ */ jsx("g", { clipPath: "url(#b)", children: /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M10.469 5.018a.286.286 0 0 0-.278-.293.286.286 0 0 0-.28.293v1.917H8.089V5.018a.286.286 0 0 0-.278-.293.286.286 0 0 0-.279.293v1.917H6.9v1.176c.003 1.046.705 1.946 1.68 2.154v1.81h.84v-1.81c.975-.208 1.677-1.108 1.68-2.154v-1.18h-.631z",
            clipRule: "evenodd"
          }
        ) })
      ] }),
      /* @__PURE__ */ jsxs("defs", { children: [
        /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h18v18H0z" }) }),
        /* @__PURE__ */ jsx("clipPath", { id: "b", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M4.8 4.2h8.4v8.4H4.8z" }) })
      ] })
    ]
  }
);
const DoubleCheck = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-double-check",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#03D8A9",
        fillRule: "evenodd",
        d: "M14.827 4.227 7.773 11.28 4.987 8.5l-.94.94 3.726 3.727 8-8zM12 5.167l-.94-.94-4.227 4.226.94.94zm-8 8L.273 9.44l.947-.94 3.72 3.727z",
        clipRule: "evenodd"
      }
    )
  }
);
const EtaCb = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-eta-cb",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 17 16",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#5D7186",
        fillRule: "evenodd",
        d: "M10.694 3.66c.297 0 .54.234.54.525l-.038 3.544 1.595 1.254a.52.52 0 0 1 .08.743.54.54 0 0 1-.419.193.54.54 0 0 1-.338-.117l-1.96-1.588V4.185c0-.29.243-.526.54-.526m-6.537 6.67c0-.29.242-.525.539-.525h3.576c.298 0 .54.235.54.527a.533.533 0 0 1-.54.525H4.696a.53.53 0 0 1-.54-.526m5.997 1.743v-.047c0-.291.242-.526.54-.526.296 0 .538.235.538.526v.047a.533.533 0 0 1-.539.526.533.533 0 0 1-.539-.526m4.91-3.492h-.047c-.287 0-.517-.247-.517-.548 0-.3.23-.548.517-.548h.046c.287 0 .517.247.517.548s-.23.548-.517.548m-9.46.115a.53.53 0 0 1-.535.6.536.536 0 0 1-.534-.455 5 5 0 0 1-.046-.495H1.482a.533.533 0 0 1-.54-.526c0-.29.243-.525.54-.525H7.18c.297 0 .539.235.539.526a.533.533 0 0 1-.54.526H5.57c.009.129.02.242.035.35m5.09-6.719c3.428 0 6.218 2.706 6.218 6.034s-2.79 6.033-6.218 6.033a6.26 6.26 0 0 1-4.473-1.843.516.516 0 0 1 .013-.745.55.55 0 0 1 .76.012 5.18 5.18 0 0 0 3.7 1.523c2.834 0 5.138-2.235 5.14-4.98 0-2.746-2.305-4.981-5.14-4.981-1.925 0-3.657 1.02-4.541 2.648a.5.5 0 0 1-.04.115l-.335.68a.54.54 0 0 1-.718.247.52.52 0 0 1-.256-.704l.104-.21H3.262a.53.53 0 0 1-.539-.525c0-.291.242-.526.54-.526h2.195c1.147-1.736 3.099-2.778 5.236-2.778M3.05 9.805c.297 0 .54.235.54.526a.533.533 0 0 1-.54.526h-.44a.533.533 0 0 1-.538-.526c0-.291.242-.526.539-.526z",
        clipRule: "evenodd"
      }
    )
  }
);
const FiltersBrokenLink = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-filters-broken-link",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 17 18",
    ...props,
    children: [
      /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "currentColor",
            d: "M7.768 13.792a2.55 2.55 0 0 1-3.584.3 2.547 2.547 0 0 1-.302-3.582L6.207 7.76a2.55 2.55 0 0 1 3.67-.226q.024.016.047.036.066.056.11.123.007.004.011.011a.61.61 0 0 1-.76.89c-.013.017-.186-.127-.28-.205a1.32 1.32 0 0 0-1.866.153L4.81 11.3a1.323 1.323 0 0 0 .158 1.867 1.323 1.323 0 0 0 1.867-.158L8.2 11.392c.608.365.95.41 1.349.288l-1.783 2.111z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "currentColor",
            d: "M14.217 9.524 10.93 11a2.547 2.547 0 0 1-3.36-1.28c-.013-.034-.03-.07-.042-.105q-.015-.026-.027-.053a.7.7 0 0 1-.047-.157L7.45 9.39a.61.61 0 0 1 1.067-.473c.021-.01.114.196.164.306.3.67 1.077.969 1.746.67L13.72 8.42c.669-.3.968-1.082.667-1.751A1.323 1.323 0 0 0 12.636 6l-2.37 1.003c-.441-.356-.918-.639-1.51-.6l3.38-1.515a2.54 2.54 0 1 1 2.08 4.638z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeMiterlimit: 10,
            strokeWidth: 0.859,
            d: "M8.365 5.387 9.858 2.4M6.792 6.187 3.967 4.404"
          }
        )
      ] }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M5.063.143 16.88 4.519l-4.702 12.696L.361 12.838z"
        }
      ) }) })
    ]
  }
);
const FiltersDirectionsCarCb = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-filters-directions-car-cb",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "M12.613 3.34a1 1 0 0 0-.946-.673H4.333c-.44 0-.806.28-.946.673L2.073 7.12c-.046.14-.073.287-.073.44v4.773c0 .554.447 1 1 1s1-.446 1-1V12h8v.333c0 .547.447 1 1 1 .547 0 1-.446 1-1V7.56c0-.147-.027-.3-.073-.44zM4.333 10c-.553 0-1-.447-1-1s.447-1 1-1c.554 0 1 .447 1 1s-.446 1-1 1m7.334 0c-.554 0-1-.447-1-1s.446-1 1-1c.553 0 1 .447 1 1s-.447 1-1 1M3.333 6.667 4.18 4.12a.68.68 0 0 1 .633-.453h6.374c.286 0 .54.186.633.453l.847 2.547z"
      }
    )
  }
);
const FiltersDriverCb = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-filters-driver-cb",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M11.92 5.587c0 2.097-1.637 3.797-3.657 3.797s-3.657-1.7-3.657-3.797S6.243 1.79 8.263 1.79s3.657 1.7 3.657 3.797M10.083 9.534c.523.116 4.467 1.182 5.023 4.43.286 1.365.168 2.564-.556 2.78-.405.134-1.079-.05-1.838-.266a1.13 1.13 0 0 1-.792-1.065v-.05c0-.417.236-.766.573-.966a4.52 4.52 0 0 0-4.247-2.981c-1.972 0-3.64 1.232-4.23 2.964.337.183.573.55.573.966v.05c0 .483-.32.9-.775 1.05h-.017c-.017.016-.017.016-.034.016-.741.233-1.432.4-1.854.266-.707-.233-.792-1.399-.505-2.764.556-3.264 4.415-4.314 4.938-4.43 1.095.85 2.646.85 3.741 0" }),
      /* @__PURE__ */ jsx("path", { d: "M9.41 15.196a1.28 1.28 0 0 1-.085 1.449c.927-.05 1.702-.167 2.36-.317a3.442 3.442 0 0 0-.725-2.631zM5.55 13.714l1.533 1.482a1.24 1.24 0 0 0-.185.666c0 .283.101.566.27.783-.927-.05-1.703-.15-2.36-.3a4 4 0 0 1-.034-.483c0-.816.287-1.565.776-2.148M8.246 15.196c-.37 0-.674.3-.674.666s.304.666.674.666.674-.3.674-.666a.67.67 0 0 0-.674-.666M6.005 13.248a3.43 3.43 0 0 1 2.241-.816c.86 0 1.635.316 2.259.832l-1.55 1.482a1.3 1.3 0 0 0-.709-.2c-.252 0-.488.067-.69.184z" })
    ]
  }
);
const FiltersFaceRecognition = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-filters-face-recognition",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32",
    ...props,
    children: [
      /* @__PURE__ */ jsxs("g", { fill: "#1774F0", clipPath: "url(#a)", children: [
        /* @__PURE__ */ jsx("path", { d: "M12 19a1.667 1.667 0 1 0 0-3.333A1.667 1.667 0 0 0 12 19" }),
        /* @__PURE__ */ jsx("path", { d: "m27.693 11.44-1.226 2.68c.12.613.2 1.24.2 1.88 0 5.88-4.787 10.667-10.667 10.667S5.333 21.88 5.333 16c0-.067.014-.133 0-.187 3.467-1.306 6.254-3.986 7.654-7.4 2.453 3 6.173 4.92 10.346 4.92.6 0 1.187-.053 1.774-.133l-.8-1.76-1.174-2.573-2.573-1.174L16.84 6l3.72-1.693.947-.427A13.15 13.15 0 0 0 16 2.667C8.64 2.667 2.667 8.64 2.667 16S8.64 29.333 16 29.333 29.333 23.36 29.333 16c0-1.96-.44-3.827-1.2-5.507z" }),
        /* @__PURE__ */ jsx("path", { d: "M20 19a1.667 1.667 0 1 0 0-3.333A1.667 1.667 0 0 0 20 19M27.467 7.467 26 10.667l-1.467-3.2L21.333 6l3.2-1.467L26 1.333l1.467 3.2L30.667 6z" })
      ] }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h32v32H0z" }) }) })
    ]
  }
);
const FiltersFilterAltCb = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-filters-filter-alt-cb",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4.221 3.5h7.5L7.964 8.225zM2.16 3.208C3.674 5.15 6.47 8.75 6.47 8.75v4.5c0 .412.338.75.75.75h1.5c.413 0 .75-.338.75-.75v-4.5s2.79-3.6 4.305-5.542A.748.748 0 0 0 13.184 2H2.75a.748.748 0 0 0-.592 1.208"
      }
    )
  }
);
const FiltersHourglass = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-filters-hourglass",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ...props,
    children: /* @__PURE__ */ jsxs("g", { fill: "none", fillRule: "evenodd", children: [
      /* @__PURE__ */ jsx("path", { d: "M0 0h16v16H0z" }),
      /* @__PURE__ */ jsx("use", { fill: "currentColor" })
    ] })
  }
);
const FiltersLink = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-filters-link",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ...props,
    children: /* @__PURE__ */ jsxs("g", { fill: "none", fillRule: "evenodd", children: [
      /* @__PURE__ */ jsx("path", { d: "M0 0h16v16H0z" }),
      /* @__PURE__ */ jsx("use", { fill: "currentColor" })
    ] })
  }
);
const FiltersSpeed = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-filters-speed",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 8 12",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3.113 12a.384.384 0 0 1-.38-.44l.6-4.227H1c-.587 0-.22-.5-.207-.52.84-1.486 2.1-3.686 3.767-6.62a.384.384 0 0 1 .713.247l-.6 4.227h2.34c.267 0 .414.126.267.44-2.193 3.826-3.467 6.06-3.833 6.7a.38.38 0 0 1-.334.193"
      }
    )
  }
);
const FiltersTag = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-filters-tag",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 14 14",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M8.955 13.66a1.173 1.173 0 0 1-1.653 0L.862 7.633c-.36-.337-.79-.975-.82-1.467C-.041 4.837.018 2.292.058.943A.956.956 0 0 1 .981.027c1.728-.04 5.39-.083 5.73.257l7.091 6.4c.456.455.043 1.604-.415 2.062zM3.312 1.981a.99.99 0 0 0-1.397 0 .984.984 0 0 0 0 1.393.99.99 0 0 0 1.397 0 .984.984 0 0 0 0-1.393",
        clipRule: "evenodd"
      }
    )
  }
);
const FiltersVehicleGroupCb = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-filters-vehicle-group-cb",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.613.673A1 1 0 0 0 9.667 0H2.333c-.44 0-.806.28-.946.673L.073 4.453q-.071.21-.073.44v4.774c0 .553.447 1 1 1s1-.447 1-1v-.334h.84q.018-.08.043-.156l1.489-4.394A1.14 1.14 0 0 1 5.444 4h-4.11l.846-2.547A.68.68 0 0 1 2.813 1h6.374c.286 0 .54.187.633.453L10.667 4h1.102zm-8.28 6.66c-.553 0-1-.446-1-1 0-.553.447-1 1-1 .554 0 1 .447 1 1 0 .554-.446 1-1 1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M13.667 5.2c.44 0 .813.28.946.673l1.314 3.78c.046.14.073.294.073.44v4.774c0 .553-.453 1-1 1-.553 0-1-.454-1-1v-.334H6v.334c0 .553-.447 1-1 1s-1-.447-1-1v-4.774q.002-.23.073-.44l1.314-3.78c.14-.393.506-.673.946-.673zm-8.334 6.333c0 .554.447 1 1 1 .554 0 1-.446 1-1 0-.553-.446-1-1-1-.553 0-1 .447-1 1m7.334 0c0 .554.446 1 1 1 .553 0 1-.446 1-1 0-.553-.447-1-1-1-.554 0-1 .447-1 1M6.18 6.653 5.333 9.2h9.334l-.847-2.547a.68.68 0 0 0-.633-.453H6.813a.68.68 0 0 0-.633.453",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const GeofencesBase = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-geofences-base",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17",
    ...props,
    children: [
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M13.333 2.5c.367 0 .667.3.667.667v10.666c0 .367-.3.667-.667.667h-2v-1.333h1.334v-1.334h-1.334V10.5h1.334V9.167h-1.334v-.434c0-.566-.24-1.113-.66-1.486l-3.333-3-.007-.007V3.167c0-.367.3-.667.667-.667zM6 5.067c.16 0 .32.053.447.173l3.333 3c.14.127.22.307.22.493v5.1c0 .367-.3.667-.667.667H8a.67.67 0 0 1-.667-.667v-2.666H4.667v2.666c0 .367-.3.667-.667.667H2.667A.67.67 0 0 1 2 13.833v-5.1c0-.193.08-.373.22-.493l3.333-3A.67.67 0 0 1 6 5.067M12.667 6.5h-1.334v1.333h1.334zM10 3.833H8.667v1.334H10zm2.667 0h-1.334v1.334h1.334z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 .5h16v16H0z" }) }) })
    ]
  }
);
const GeofencesClient = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-geofences-client",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "M10.667 5.833a2.666 2.666 0 1 1-5.334 0 2.666 2.666 0 1 1 5.333 0M2.667 12.5c0-1.773 3.553-2.667 5.333-2.667s5.333.894 5.333 2.667v.667c0 .366-.3.666-.667.666H3.333a.67.67 0 0 1-.667-.666z"
      }
    )
  }
);
const GeofencesFuel = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-geofences-fuel",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17",
    ...props,
    children: [
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m13.18 5.32.007-.007-2.127-2.126a.503.503 0 0 0-.707 0 .503.503 0 0 0 0 .706l1.053 1.054c-.7.266-1.173.98-1.053 1.806A1.69 1.69 0 0 0 11.82 8.16c.313.033.586-.02.846-.133v4.806c0 .367-.3.667-.666.667a.67.67 0 0 1-.667-.667v-3c0-.733-.6-1.333-1.333-1.333h-.667V3.833C9.333 3.1 8.733 2.5 8 2.5H4c-.733 0-1.333.6-1.333 1.333v10c0 .367.3.667.666.667h5.333c.367 0 .667-.3.667-.667V9.5h1v3.24c0 .873.627 1.667 1.493 1.753 1 .1 1.84-.68 1.84-1.66V6.5c0-.46-.186-.88-.486-1.18M8 7.167H4V4.5c0-.367.3-.667.667-.667h2.666c.367 0 .667.3.667.667zm4 0a.67.67 0 0 1-.667-.667c0-.367.3-.667.667-.667s.666.3.666.667-.3.667-.666.667",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 .5h16v16H0z" }) }) })
    ]
  }
);
const GeofencesHome = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-geofences-home",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 12 13",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.333.5c.367 0 .667.3.667.667v10.666c0 .367-.3.667-.667.667h-2v-1.333h1.334V9.833H9.333V8.5h1.334V7.167H9.333v-.434c0-.566-.24-1.113-.66-1.486l-3.333-3-.007-.007V1.167C5.333.8 5.633.5 6 .5zM4 3.067c.16 0 .32.053.447.173l3.333 3c.14.127.22.307.22.493v5.1c0 .367-.3.667-.667.667H6a.67.67 0 0 1-.667-.667V9.167H2.667v2.666c0 .367-.3.667-.667.667H.667A.67.67 0 0 1 0 11.833v-5.1c0-.193.08-.373.22-.493l3.333-3A.67.67 0 0 1 4 3.067M10.667 4.5H9.333v1.333h1.334zM8 1.833H6.667v1.334H8zm2.667 0H9.333v1.334h1.334z",
        clipRule: "evenodd"
      }
    )
  }
);
const GeofencesMaintenance = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-geofences-maintenance",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentColor",
          d: "m5.414 7.617 1.02 1.04 1.933-1.97-.801-.815.428-1.042-.983-2.284L4.724 1.5l-.671.24 2.192 2.232-2 1.9-2.283-2.325-.388.944.983 2.284 2.288 1.046z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m6.168 11.347 6.85-6.939c.526.074.96-.253.96-.253l.815-1.544-.978-.924-1.59.813s-.347.472-.211 1.011L5.19 10.423l-.958-.905-3.137 3.177s-.49.861.75 2.033c1.24 1.17 2.104.662 2.104.662l3.136-3.177zm-.29.819-.571-.54-2.365 2.396.57.54zM4.8 11.223l-.57-.539-2.366 2.396.57.54z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentColor",
          d: "m7.889 10.138 4.72 4.808a1.407 1.407 0 0 0 1.966.033 1.35 1.35 0 0 0 .035-1.933L9.821 8.169z"
        }
      )
    ]
  }
);
const GeofencesOther = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-geofences-other",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 16 17",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M8 8.5c.733 0 1.333-.6 1.333-1.333 0-.734-.6-1.334-1.333-1.334-.734 0-1.333.6-1.333 1.334C6.667 7.9 7.267 8.5 8 8.5m0-6.667c2.8 0 5.333 2.147 5.333 5.467 0 2.12-1.633 4.613-4.893 7.487a.68.68 0 0 1-.887 0C4.3 11.913 2.667 9.42 2.667 7.3 2.667 3.98 5.2 1.833 8 1.833" })
  }
);
const GeofencesSede = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-geofences-sede",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 16 17",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M6.667 13.833v-4h2.667v4h3.333V8.5h2L8 2.5l-6.666 6h2v5.333z" })
  }
);
const Gravity = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-gravity",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 12 13",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2.235 11h7.53a1 1 0 0 0 .865-1.5L6.865 2.995a1 1 0 0 0-1.73 0L1.37 9.5a1 1 0 0 0 .865 1.5M6 7.5a.5.5 0 0 1-.5-.5V6c0-.275.225-.5.5-.5s.5.225.5.5v1c0 .275-.225.5-.5.5m.5 2h-1v-1h1z"
      }
    )
  }
);
const HeavyVehicle = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-heavy-vehicle",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 9",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          d: "M9.334.78a.28.28 0 0 0-.28-.28H.28A.28.28 0 0 0 0 .78v4.146c0 .155.126.28.28.28h8.774a.28.28 0 0 0 .28-.28z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M4.2 5.857h5.597a.28.28 0 0 0 .28-.28V2.194a.28.28 0 0 1 .303-.28l2.556.208c.102.009.19.07.232.164.208.472.832 1.913.832 2.22v2.271c0 .172-.13.311-.29.311h-.2c0-.86-.654-1.558-1.46-1.558s-1.459.698-1.459 1.558H4.766c0-.5-.222-.946-.566-1.23m9.37-1.315-.672-1.863-1.655-.135V4.23z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M12.04 8.17a1.17 1.17 0 0 1-1.166-1.176c0-.65.522-1.176 1.166-1.176.645 0 1.167.526 1.167 1.176s-.522 1.177-1.167 1.177m.56-1.188a.53.53 0 0 0-.524-.535.53.53 0 0 0-.524.535.53.53 0 0 0 .524.535.53.53 0 0 0 .524-.535M2.077 6.994c0 .65.522 1.177 1.167 1.177.644 0 1.166-.527 1.166-1.177s-.522-1.176-1.166-1.176c-.645 0-1.167.526-1.167 1.176m1.197-.547c.29 0 .524.24.524.535a.53.53 0 0 1-.524.535.53.53 0 0 1-.524-.535.53.53 0 0 1 .524-.535",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          d: "M.282 5.818a.28.28 0 0 0-.28.279L0 6.668a.28.28 0 0 0 .167.257l.633.28a.3.3 0 0 0 .114.024h.866c0-.574.217-1.085.554-1.411z"
        }
      )
    ]
  }
);
const Help = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-help",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    className: "lucide lucide-circle-help",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("circle", { cx: 12, cy: 12, r: 10 }),
      /* @__PURE__ */ jsx("path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3M12 17h.01" })
    ]
  }
);
const Ibutton = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-ibutton",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "M9.333 8.433A3.99 3.99 0 0 0 12 4.667c0-2.207-1.793-4-4-4s-4 1.793-4 4c0 1.74 1.113 3.22 2.667 3.766V14a1.333 1.333 0 1 0 2.666 0zM6.667 4.667c0-.734.6-1.334 1.333-1.334s1.333.6 1.333 1.334C9.333 5.4 8.733 6 8 6s-1.333-.6-1.333-1.333"
      }
    )
  }
);
const Integrations = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-integrations",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 35 35",
    ...props,
    children: [
      /* @__PURE__ */ jsx("circle", { cx: 17.537, cy: 17.251, r: 17 }),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentColor",
          d: "M17.537 9.376c1.186 0 2.148 1.008 2.148 2.25 0 .98-.598 1.813-1.432 2.123v1.972c1.235.333 2.148 1.509 2.148 2.905 0 .467-.102.909-.284 1.303l1.76 1.23a2.08 2.08 0 0 1 1.387-.533c1.186 0 2.148 1.008 2.148 2.25 0 1.243-.962 2.25-2.148 2.25s-2.147-1.007-2.147-2.25q0-.215.037-.42l-1.97-1.375a2.76 2.76 0 0 1-3.295 0l-1.969 1.375q.038.205.038.42c0 1.243-.962 2.25-2.148 2.25s-2.148-1.007-2.148-2.25c0-1.242.961-2.25 2.148-2.25.528 0 1.012.2 1.386.532l1.76-1.229a3.1 3.1 0 0 1-.282-1.303c0-1.398.912-2.572 2.147-2.905l.001-1.973c-.835-.308-1.433-1.141-1.433-2.122 0-1.242.962-2.25 2.148-2.25m-5.727 12.75c-.396 0-.716.337-.716.75 0 .415.32.75.716.75s.716-.336.716-.75c0-.413-.322-.75-.716-.75m11.454 0c-.395 0-.715.337-.715.75 0 .415.32.75.715.75.396 0 .716-.336.716-.75 0-.413-.321-.75-.716-.75m-5.727-11.25c-.395 0-.716.337-.716.75 0 .415.32.75.716.75s.716-.336.716-.75c0-.413-.321-.75-.716-.75"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M8.537 8.251h18v18h-18z" }) }) })
    ]
  }
);
const Lan = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-lan",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 -960 960 960",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M144-168v-96q0-29.7 21.15-50.85T216-336h36v-108q0-29.7 21.15-50.85T324-516h120v-108h-36q-29.7 0-50.85-21.15T336-696v-96q0-29.7 21.18-50.85Q378.35-864 408.09-864h144.17Q582-864 603-842.85T624-792v96q0 29.7-21.15 50.85T552-624h-36v108h120q29.7 0 50.85 21.15T708-444v108h36.16Q774-336 795-314.85T816-264v96q0 29.7-21.18 50.85Q773.65-96 743.91-96H599.74Q570-96 549-117.15T528-168v-96q0-29.7 21.15-50.85T600-336h36v-108H324v108h36.16Q390-336 411-314.85T432-264v96q0 29.7-21.18 50.85Q389.65-96 359.91-96H215.74Q186-96 165-117.15T144-168m264-528h144v-96H408zM216-168h144v-96H216zm384 0h144v-96H600zm0-96" })
  }
);
const Leading = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-leading",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "M4.71 5.3H3.306A.303.303 0 0 0 3 5.598l.013 8.618c-.004.168.127.28.292.284h9.388a.303.303 0 0 0 .307-.298V5.598a.305.305 0 0 0-.294-.313h-1.399V2.9c.003-.216-.154-.394-.352-.399l-5.877.012c-.2-.005-.366.169-.369.387z"
      }
    )
  }
);
const LightVehicle = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-light-vehicle",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M12.888 10.675a.583.583 0 1 0-1.166 0 .583.583 0 0 0 1.166 0m-2.04 0a1.458 1.458 0 1 1 2.917 0 1.458 1.458 0 0 1-2.917 0m-6.01 0a.583.583 0 1 0-1.166 0 .583.583 0 0 0 1.166 0m-2.041 0a1.458 1.458 0 1 1 2.916 0 1.458 1.458 0 0 1-2.916 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M2.441 10.733h-1.03A.423.423 0 0 1 1 10.3V7.7c0-.24.184-.434.412-.434h10.294q.03 0 .058.005l2.883.433c.202.03.353.214.353.43V10.3c0 .24-.184.433-.412.433h-.411c0-1.077-.83-1.95-1.854-1.95-1.023 0-1.852.873-1.852 1.95H6.147c0-1.077-.83-1.95-1.853-1.95s-1.853.873-1.853 1.95",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M9.647 5.533H4.054L1.703 8.006a.397.397 0 0 1-.582 0 .45.45 0 0 1 0-.613l2.47-2.6a.4.4 0 0 1 .291-.127h5.97c.13 0 .253.065.33.174l1.853 2.6c.137.191.1.463-.082.606a.4.4 0 0 1-.576-.086z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const LoadingSpin = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-loading-spin",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("style", { children: "@keyframes spinner_AtaB{to{transform:rotate(360deg)}}" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentColor",
          d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1m0 19a8 8 0 1 1 8-8 8 8 0 0 1-8 8",
          opacity: 0.25
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10.14 1.16a11 11 0 0 0-9 8.92A1.59 1.59 0 0 0 2.46 12a1.52 1.52 0 0 0 1.65-1.3 8 8 0 0 1 6.66-6.61A1.42 1.42 0 0 0 12 2.69a1.57 1.57 0 0 0-1.86-1.53",
          style: {
            transformOrigin: "center",
            animation: "spinner_AtaB .75s infinite linear"
          }
        }
      )
    ]
  }
);
const LogoCobliName = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-logo-cobli-name",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 95 41",
    ...props,
    children: [
      /* @__PURE__ */ jsxs("g", { fill: "currentColor", children: [
        /* @__PURE__ */ jsx("path", { d: "M17.729 13.383a7.4 7.4 0 0 1 2.284-.455 7.3 7.3 0 0 1 3.413.688.923.923 0 1 0 .783-1.673 9.25 9.25 0 0 0-7.122-.292.924.924 0 0 0 .643 1.731zM26.756 9.112a.923.923 0 0 0-.923 1.599 11.2 11.2 0 0 1 3.534 3.237.926.926 0 0 0 1.294.237.924.924 0 0 0 .216-1.299 13.1 13.1 0 0 0-4.12-3.774" }),
        /* @__PURE__ */ jsx("path", { d: "M31.986 25.969a4.6 4.6 0 0 0-3.089 1.355 1 1 0 0 0-.141.133 11.067 11.067 0 0 1-19.21-9.728 11.07 11.07 0 0 1 7.845-8.107 11.06 11.06 0 0 1 5.847.002.922.922 0 0 0 .55-1.76 13 13 0 0 0-2.34-.43h-.011q-.15-.013-.301-.023h-.026a13 13 0 0 0-.622-.023h-.387q-.143.001-.287.008H19.8a12.83 12.83 0 0 0-8.983 4.135l-.019.022q-.099.105-.194.215l-.127.148-.08.091-.163.201-.035.044q-.092.115-.181.231l-.011.015q-.38.498-.706 1.026a12.84 12.84 0 0 0-1.91 7.287.924.924 0 0 1-.885.958h-.037a.923.923 0 0 1-.921-.887 14.67 14.67 0 0 1 3.061-9.594l.015-.02q.133-.173.275-.343l.055-.067.086-.1.09-.107.04-.044.247-.279.046-.05.058-.062.147-.155.1-.104.149-.15.11-.108.269-.255.116-.107.159-.142.082-.07q.1-.087.199-.17l.033-.028a14.6 14.6 0 0 1 7.08-3.206l.024-.004q.158-.024.317-.046l.067-.009q.138-.018.278-.033h.007a.922.922 0 0 0-.184-1.837l-.142.017-.112.013a16.54 16.54 0 0 0-9.525 4.6l-.036.033a17 17 0 0 0-.578.598l-.13.142a16 16 0 0 0-.531.621l-.132.165-.045.056-.11.143-.065.083-.091.122-.083.112-.07.098-.101.14-.053.075q-.058.083-.115.168l-.035.055-.124.186q-.394.603-.735 1.24a.924.924 0 1 1-1.626-.873 18.57 18.57 0 0 1 6.355-6.854 18.4 18.4 0 0 1 3.945-1.896l.054-.018q.09-.032.183-.061l.145-.047.105-.034.256-.077h.005a18.3 18.3 0 0 1 3.276-.65h.007q.141-.014.284-.027l.024-.002.27-.022.036-.003.272-.017.03-.002a21 21 0 0 1 .753-.026h.448q.11.001.219.004a21 21 0 0 1 .446.015q.123.004.247.012.093.005.185.012.143.009.286.021l.141.013.345.033.08.01q.212.023.425.053h.002l.149.02a.922.922 0 0 0 .267-1.827 20.5 20.5 0 0 0-3.76-.2A20.17 20.17 0 0 0 5.402 6.516a20.18 20.18 0 0 0-5.387 14.58 20.18 20.18 0 0 0 6.499 14.118c3.783 3.5 8.642 5.401 13.765 5.401q.403 0 .809-.016a20.23 20.23 0 0 0 14.337-6.75 4.617 4.617 0 0 0-3.44-7.881" }),
        /* @__PURE__ */ jsx("path", { d: "M15.022 13.827a.92.92 0 0 0-1.304.012 9.27 9.27 0 0 0-2.637 6.827c.192 4.965 4.29 8.873 9.214 8.873q.18 0 .364-.007a9.1 9.1 0 0 0 4.105-1.143.923.923 0 1 0-.894-1.616 7.38 7.38 0 0 1-9.448-1.998 7.39 7.39 0 0 1 .612-9.642.923.923 0 0 0-.012-1.306M32.72 11.91c.1.136.22.262.326.395a.924.924 0 1 0 1.443-1.151c-.119-.15-.248-.294-.367-.444-3.078-3.91-7.949-6.544-12.257-6.946a.923.923 0 1 0-.172 1.84c3.828.356 8.48 2.87 11.027 6.305M25.964 2.584c2.244.745 5.301 2.415 7.649 4.779a.84.84 0 0 0 .578.227.92.92 0 0 0 .724-.315c.334-.384.264-.934-.088-1.303-2.036-2.135-5.825-4.271-8.248-5.128a.923.923 0 0 0-1.177.562.917.917 0 0 0 .562 1.178M17.796 13.383a7.4 7.4 0 0 1 2.293-.455 7.34 7.34 0 0 1 3.426.688.923.923 0 1 0 .786-1.673 9.32 9.32 0 0 0-7.149-.291.922.922 0 0 0-.353 1.494.92.92 0 0 0 .998.237zM26.858 9.112a.923.923 0 1 0-.928 1.599 11.2 11.2 0 0 1 3.548 3.237.926.926 0 1 0 1.517-1.062 13.1 13.1 0 0 0-4.137-3.774" }),
        /* @__PURE__ */ jsx("path", { d: "M36.917 30.403a4.63 4.63 0 0 0-4.81-4.434 4.62 4.62 0 0 0-3.1 1.355 1 1 0 0 0-.142.133 11.14 11.14 0 0 1-12.22 3.283 11.1 11.1 0 0 1-3.816-2.302 10.99 10.99 0 0 1-3.558-7.7 10.99 10.99 0 0 1 2.947-7.954 11.05 11.05 0 0 1 7.727-3.546c1.14-.045 2.28.085 3.38.386a.922.922 0 0 0 .554-1.76 13 13 0 0 0-2.35-.43h-.01q-.15-.013-.304-.023h-.026q-.31-.019-.624-.023h-.39q-.144.001-.288.007h-.014a12.9 12.9 0 0 0-9.015 4.138l-.019.021a8 8 0 0 0-.195.216l-.128.148-.079.091-.164.2-.036.044q-.092.115-.18.232l-.013.015q-.381.495-.708 1.023A12.8 12.8 0 0 0 7.42 20.81a.924.924 0 0 1-.89.958h-.036a.924.924 0 0 1-.925-.887 14.63 14.63 0 0 1 3.073-9.594l.014-.02q.135-.173.277-.343l.055-.067.086-.1q.045-.052.09-.107l.04-.044.118-.134.131-.145.046-.05.058-.062a17 17 0 0 1 .397-.409l.111-.108.14-.134c.046-.045.086-.081.13-.121l.116-.107.16-.142.082-.07.2-.17.034-.028a14.7 14.7 0 0 1 7.108-3.206l.023-.004q.158-.024.319-.046l.066-.009.279-.033h.007a.923.923 0 0 0-.184-1.837l-.142.017-.113.013a16.62 16.62 0 0 0-9.563 4.6l-.036.034a17 17 0 0 0-.58.598q-.066.07-.13.142a15 15 0 0 0-.511.593l-.024.028-.133.165-.045.056-.176.226-.091.122-.083.112-.072.098-.1.14-.053.075-.115.168-.038.055-.124.186q-.396.603-.74 1.24a.926.926 0 0 1-1.63-.873 18.5 18.5 0 0 1 10.34-8.75l.054-.018.183-.061.146-.047.106-.034.256-.077h.005a18.5 18.5 0 0 1 3.29-.65h.006q.142-.014.286-.027l.024-.002.27-.022.037-.003.273-.017.03-.002a22 22 0 0 1 .756-.026h.45q.11.001.22.004a21 21 0 0 1 .446.015q.126.004.248.012.094.005.186.012.144.009.286.021l.143.013q.173.016.346.033l.08.01q.214.023.426.053h.002l.15.02A.923.923 0 1 0 23.36.216a20.6 20.6 0 0 0-3.776-.2 20.27 20.27 0 0 0-14.164 6.5c-3.696 3.982-5.615 9.16-5.403 14.58.211 5.421 2.528 10.435 6.523 14.119A20.27 20.27 0 0 0 21.17 40.6a20.34 20.34 0 0 0 14.39-6.75 4.6 4.6 0 0 0 1.358-3.447" }),
        /* @__PURE__ */ jsx("path", { d: "M15.08 13.827a.93.93 0 0 0-1.31.012 9.25 9.25 0 0 0-2.647 6.827c.194 4.965 4.308 8.873 9.25 8.873q.182 0 .365-.007a9.2 9.2 0 0 0 4.12-1.143.92.92 0 0 0 .359-1.257.924.924 0 0 0-1.256-.359 7.406 7.406 0 0 1-10.988-6.178 7.3 7.3 0 0 1 2.118-5.462.92.92 0 0 0-.012-1.306M32.844 11.91c.1.136.221.262.328.395a.924.924 0 0 0 1.448-1.151c-.12-.15-.249-.294-.368-.444-3.09-3.91-7.98-6.544-12.305-6.946a.922.922 0 0 0-.797 1.509.92.92 0 0 0 .625.33c3.843.357 8.512 2.871 11.07 6.307M26.062 2.584C28.315 3.33 31.384 5 33.74 7.363a.85.85 0 0 0 .58.227.93.93 0 0 0 .727-.315c.337-.384.265-.934-.088-1.303-2.044-2.135-5.847-4.271-8.278-5.128a.927.927 0 0 0-1.183.562.917.917 0 0 0 .564 1.178" })
      ] }),
      /* @__PURE__ */ jsx("g", { fill: "currentColor", children: /* @__PURE__ */ jsx("path", { d: "M61.744 14.423c-3.233 0-5.864 2.621-5.864 5.844 0 3.222 2.63 5.843 5.864 5.843s5.864-2.622 5.864-5.843-2.631-5.844-5.864-5.844m0 9.545a3.713 3.713 0 0 1-3.715-3.702 3.713 3.713 0 0 1 3.715-3.702 3.71 3.71 0 0 1 3.714 3.702 3.713 3.713 0 0 1-3.714 3.702M48.286 16.565a3.7 3.7 0 0 1 3.167 1.766 1.072 1.072 0 1 0 1.83-1.121 5.83 5.83 0 0 0-4.997-2.787c-3.233 0-5.864 2.621-5.864 5.844 0 3.222 2.63 5.843 5.864 5.843a5.83 5.83 0 0 0 4.997-2.784 1.074 1.074 0 0 0-1.83-1.122 3.7 3.7 0 0 1-3.167 1.766 3.71 3.71 0 0 1-3.714-3.701 3.714 3.714 0 0 1 3.714-3.704M88.818 23.968h-4.525v-8.474a1.075 1.075 0 0 0-2.149 0v9.544a1.073 1.073 0 0 0 1.075 1.071h5.599a1.07 1.07 0 0 0 0-2.142zM93.746 14.423a1.073 1.073 0 0 0-1.075 1.071v9.544a1.075 1.075 0 0 0 2.149 0v-9.544a1.073 1.073 0 0 0-1.074-1.07M77.574 19.977a3.43 3.43 0 0 0 .713-2.097 3.47 3.47 0 0 0-3.47-3.458H71.12a1.07 1.07 0 0 0-1.075 1.07v9.545a1.073 1.073 0 0 0 1.075 1.07h4.26a3.47 3.47 0 0 0 3.47-3.458 3.45 3.45 0 0 0-1.276-2.672m-5.38-3.412h2.623a1.315 1.315 0 0 1 0 2.63h-2.623zm3.186 7.403h-3.186v-2.63h3.186a1.315 1.315 0 0 1 0 2.63" }) })
    ]
  }
);
const Maintenance = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-maintenance",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 -960 960 960",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M735-96q-7 0-13.5-2.5T710-106L520-296q-5-5-8-12t-3-14 3-13.5 8-11.5l93-93q5-5 11.5-8t13.5-3 14 3 12 8l190 190q5 5 7.5 11.5T864-225t-2.5 14-7.5 12l-94 93q-5 5-11.5 7.5T735-96m0-87 42-42-139-139-42 42zM226-96q-8 0-15-3.5t-12-8.5l-93-93q-5-5-7.5-11.5T96-226t3-13.5 8-11.5l181-181h93l48-48-144-144h-57L96-755l108-109 132 132v57l144 144 112-112-40-41 60-60H512l-32-32 136-136 32 32v100l36-36 144 144q17 17 26.5 40t9.5 47-9.5 46.5T828-499l-98-98-46 45-40-40-212 211v93L252-107q-5 5-11.5 8T226-96m-1-87 135-135v-42h-43L184-226zm0 0-41-43 21 21zm510 0 42-42z" })
  }
);
const MediumVehicle = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-medium-vehicle",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 9",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M11.324 5.7c.796 0 1.44.627 1.44 1.4s-.644 1.4-1.44 1.4-1.442-.627-1.442-1.4.646-1.4 1.441-1.4m0 .8a.61.61 0 0 0-.618.6c0 .331.276.6.617.6a.61.61 0 0 0 .618-.6.61.61 0 0 0-.618-.6M2.676 5.7c.796 0 1.442.627 1.442 1.4s-.646 1.4-1.442 1.4-1.44-.627-1.44-1.4.645-1.4 1.44-1.4m0 .8a.61.61 0 0 0-.617.6c0 .331.276.6.617.6a.61.61 0 0 0 .618-.6c0-.331-.276-.6-.618-.6",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "m12.38 3.37-.005-.003-.557-.361L10.5 1.3C10.15.846 9.437.5 8.853.5H.618a.406.406 0 0 0-.412.4c0 .198.148.362.342.394L.005 4.638A.4.4 0 0 0 0 4.7v2c0 .22.184.4.412.4h.412c0-.994.83-1.8 1.852-1.8 1.024 0 1.853.806 1.853 1.8h4.942c0-.994.83-1.8 1.852-1.8 1.024 0 1.854.806 1.854 1.8h.411c.228 0 .412-.18.412-.4V5.5c0-.572-.367-1.258-.85-1.586a28 28 0 0 0-.437-.312q-.209-.148-.328-.229zM8.646 3.3c-.25 0-.497-.208-.532-.448L7.887 1.3h.966c.325 0 .793.228.988.48l1.174 1.52z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const NewRelease = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-new-release",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#179EEE",
        fillRule: "evenodd",
        d: "m15.333 8.5-1.626-1.853.226-2.454-2.406-.546-1.26-2.12L8 2.5l-2.267-.973-1.26 2.12-2.406.54.226 2.453L.667 8.5l1.626 1.853-.226 2.46 2.406.547 1.26 2.12L8 14.5l2.267.973 1.26-2.12 2.406-.546-.226-2.454zm-8 3.333V10.5h1.334v1.333zm0-2.666h1.334v-4H7.333z",
        clipRule: "evenodd"
      }
    )
  }
);
const Obd = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-obd",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 10 13",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "M1.71 3.3H.306A.303.303 0 0 0 0 3.598l.013 8.618c-.004.168.127.28.292.284h9.388a.303.303 0 0 0 .307-.298V3.598a.305.305 0 0 0-.294-.313H8.307V.9C8.31.683 8.153.505 7.955.5L2.078.512c-.2-.005-.366.169-.369.387z"
      }
    )
  }
);
const PlaceholderCar = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-placeholder-car",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    ...props,
    children: /* @__PURE__ */ jsxs("g", { fill: "none", fillRule: "evenodd", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "nonzero",
          d: "M24 48c13.254 0 24-10.746 24-24S37.254 0 24 0 0 10.746 0 24s10.746 24 24 24"
        }
      ),
      /* @__PURE__ */ jsxs("g", { transform: "matrix(-1 0 0 1 40.533 8.533)", children: [
        /* @__PURE__ */ jsx("path", { d: "M0 0h32v32H0z" }),
        /* @__PURE__ */ jsx("use", { fill: "#DDE5ED" })
      ] })
    ] })
  }
);
const PlaceholderChecklists = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-placeholder-checklists",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 100 100",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M50 100c27.614 0 50-22.386 50-50S77.614 0 50 0 0 22.386 0 50s22.386 50 50 50",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#DDE5ED",
          fillRule: "evenodd",
          d: "M66.667 31.25H33.333a4.18 4.18 0 0 0-4.166 4.167v29.166a4.18 4.18 0 0 0 4.166 4.167h33.334a4.18 4.18 0 0 0 4.166-4.167V35.417a4.18 4.18 0 0 0-4.166-4.167M43.75 60.417H37.5a2.09 2.09 0 0 1-2.083-2.084A2.09 2.09 0 0 1 37.5 56.25h6.25a2.09 2.09 0 0 1 2.083 2.083 2.09 2.09 0 0 1-2.083 2.084m0-8.334H37.5A2.09 2.09 0 0 1 35.417 50a2.09 2.09 0 0 1 2.083-2.083h6.25A2.09 2.09 0 0 1 45.833 50a2.09 2.09 0 0 1-2.083 2.083m0-8.333H37.5a2.09 2.09 0 0 1-2.083-2.083 2.09 2.09 0 0 1 2.083-2.084h6.25a2.09 2.09 0 0 1 2.083 2.084 2.09 2.09 0 0 1-2.083 2.083m20.208 4.417-6.604 6.604a2.1 2.1 0 0 1-2.958 0l-2.938-2.959a2.075 2.075 0 0 1 0-2.937 2.075 2.075 0 0 1 2.938 0l1.479 1.48 5.146-5.147a2.075 2.075 0 0 1 2.937 0l.021.021c.792.813.792 2.146-.02 2.938",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const PlaceholderVehicleGroup = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-placeholder-vehicle-group",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 100 100",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M50 100c27.614 0 50-22.386 50-50S77.614 0 50 0 0 22.386 0 50s22.386 50 50 50",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#DDE5ED",
          fillRule: "evenodd",
          d: "M58.167 27.104A3.11 3.11 0 0 0 55.208 25H32.292c-1.375 0-2.521.875-2.959 2.104L25.23 38.917c-.146.437-.229.895-.229 1.375v14.916a3.12 3.12 0 0 0 3.125 3.125 3.12 3.12 0 0 0 3.125-3.125v-1.041h2.625a6 6 0 0 1 .135-.489l4.651-13.732c.496-1.429 1.795-2.446 3.353-2.446H29.167l2.645-7.958a2.11 2.11 0 0 1 1.98-1.417h19.916c.896 0 1.688.583 1.98 1.417l2.645 7.958h3.446zM32.292 47.917a3.12 3.12 0 0 1-3.125-3.125 3.12 3.12 0 0 1 3.125-3.125 3.12 3.12 0 0 1 3.125 3.125 3.12 3.12 0 0 1-3.125 3.125",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#DDE5ED",
          fillRule: "evenodd",
          d: "M67.708 41.25c1.375 0 2.542.875 2.959 2.104l4.104 11.813c.146.437.229.916.229 1.375v14.916a3.134 3.134 0 0 1-3.125 3.125 3.134 3.134 0 0 1-3.125-3.125v-1.041h-25v1.041a3.12 3.12 0 0 1-3.125 3.125 3.12 3.12 0 0 1-3.125-3.125V56.542c0-.48.083-.938.23-1.375l4.103-11.813c.438-1.229 1.584-2.104 2.959-2.104zM41.667 61.042a3.12 3.12 0 0 0 3.125 3.125 3.12 3.12 0 0 0 3.125-3.125 3.12 3.12 0 0 0-3.125-3.125 3.12 3.12 0 0 0-3.125 3.125m22.916 0a3.12 3.12 0 0 0 3.125 3.125 3.12 3.12 0 0 0 3.125-3.125 3.12 3.12 0 0 0-3.125-3.125 3.12 3.12 0 0 0-3.125 3.125m-20.27-15.25-2.646 7.958h29.166l-2.645-7.958a2.11 2.11 0 0 0-1.98-1.417H46.292c-.896 0-1.688.583-1.98 1.417",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const Preferences = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-preferences",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 12 12",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M8 4h1.333V2.667H12V1.333H9.333V0H8zM2.667 4v1.333H0v1.334h2.667V8H4V4zm4 6.667V12H5.333V8h1.334v1.333H12v1.334zm-6.667 0V9.333h4v1.334zm12-5.334v1.334H5.333V5.333zm-5.333-4H0V2.66h6.667z",
        clipRule: "evenodd"
      }
    )
  }
);
const ReportLock = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-report-lock",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 69 69",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#DDE5ED",
          d: "M46.595 25.644h-2.082v-4.155c0-5.733-4.664-10.385-10.41-10.385s-10.41 4.652-10.41 10.385v4.155h-2.081c-2.29 0-4.164 1.87-4.164 4.154V50.57c0 2.285 1.874 4.154 4.164 4.154h24.983c2.29 0 4.164-1.87 4.164-4.154V29.798c0-2.285-1.874-4.154-4.164-4.154M34.103 44.338c-2.29 0-4.163-1.87-4.163-4.154 0-2.285 1.873-4.154 4.163-4.154s4.164 1.869 4.164 4.154-1.873 4.154-4.164 4.154m-6.245-18.694v-4.155a6.23 6.23 0 0 1 6.245-6.231 6.23 6.23 0 0 1 6.246 6.231v4.155z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          stroke: "#DDE5ED",
          d: "M49.512 20.535c-5.496 0-9.97 4.227-9.97 9.422 0 5.214 4.474 9.44 9.97 9.44 5.516 0 9.97-4.226 9.97-9.44 0-5.195-4.454-9.422-9.97-9.422Z"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#9DA9B6",
          fillRule: "evenodd",
          d: "M47.637 34.549v-3.48a.82.82 0 0 0-.811-.83.82.82 0 0 0-.811.83v3.48c0 .458.363.83.81.83a.82.82 0 0 0 .812-.83m3.65 0v-6.86a.82.82 0 0 0-.81-.829.82.82 0 0 0-.812.83v6.859c0 .458.363.83.811.83a.82.82 0 0 0 .811-.83m2.839.83a.82.82 0 0 1-.811-.83V24.312a.82.82 0 0 1 .81-.83.82.82 0 0 1 .812.83V34.55a.82.82 0 0 1-.811.83",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx(
        "ellipse",
        {
          cx: 34.445,
          cy: 54.724,
          fill: "#DDE5ED",
          fillOpacity: 0.4,
          rx: 28.893,
          ry: 7.931
        }
      ),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M39.542 20.535h19.941v18.863H39.542z" }) }) })
    ]
  }
);
const SearchSignal = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-search-signal",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1.181 8.883a.7.7 0 0 0 .527.222q.315 0 .527-.212a.87.87 0 0 0 .25-.527Q2.743 6.035 4.39 4.39q1.645-1.647 3.976-1.905a.84.84 0 0 0 .527-.259.73.73 0 0 0 .212-.518.7.7 0 0 0-.222-.527.6.6 0 0 0-.517-.176q-2.94.26-5.021 2.34t-2.34 5.02a.6.6 0 0 0 .176.518m2.968 0a.67.67 0 0 0 .518.222q.296 0 .518-.203a1 1 0 0 0 .296-.518A3.63 3.63 0 0 1 6.489 6.49 3.63 3.63 0 0 1 8.384 5.48a1 1 0 0 0 .518-.296.74.74 0 0 0 .203-.518.67.67 0 0 0-.222-.518.62.62 0 0 0-.517-.166 5.02 5.02 0 0 0-2.932 1.451 5.02 5.02 0 0 0-1.451 2.932.62.62 0 0 0 .166.517m7.702 4.236 1.657 1.638a.84.84 0 0 0 .619.243q.375 0 .618-.243a.83.83 0 0 0 .255-.63.87.87 0 0 0-.255-.61l-1.634-1.659q.243-.398.364-.84.122-.443.122-.952 0-1.504-1.017-2.522t-2.519-1.018q-1.501 0-2.518 1.018t-1.017 2.522q0 1.505 1.017 2.522 1.016 1.018 2.518 1.018.51 0 .95-.121a3.3 3.3 0 0 0 .84-.366m-.53-1.792q-.508.51-1.26.51-.75 0-1.259-.51a1.71 1.71 0 0 1-.508-1.26q0-.753.508-1.262a1.7 1.7 0 0 1 1.26-.509q.75 0 1.259.51.508.508.508 1.26 0 .753-.508 1.261",
        clipRule: "evenodd"
      }
    )
  }
);
const Settings = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-settings",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 12 12",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#1774F0",
        fillRule: "evenodd",
        d: "M8 4h1.333V2.667H12V1.333H9.333V0H8zM2.667 4v1.333H0v1.334h2.667V8H4V4zm4 6.667V12H5.333V8h1.334v1.333H12v1.334zm-6.667 0V9.333h4v1.334zm12-5.334v1.334H5.333V5.333zm-5.333-4H0V2.66h6.667z",
        clipRule: "evenodd"
      }
    )
  }
);
const SignalCellular0 = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-signal-cellular-0",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 -960 960 960",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M183-96q-24.19 0-33.59-22-9.41-22 7.59-39l646-646q17-17 39-7.59 22 9.4 22 33.59v627q0 22.5-15.75 38.25T810-96zm87-72h522v-522z" })
  }
);
const SignalCellular4 = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-signal-cellular-4",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 -960 960 960",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M183-96q-17 0-26.5-10.75t-9.5-25.08q0-7.17 2.5-13.47T157-157l646-646q5.32-5 11.52-7.5 6.21-2.5 13.3-2.5 14.18 0 25.18 9.5t11 26.5v627q0 22.5-15.75 38.25T810-96z" })
  }
);
const SignalCellularOff = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-signal-cellular-off",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 -960 960 960",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M270-168h420L480-378zm-87 72q-24.19 0-33.59-22-9.41-22 7.59-39l272-272-266-266q-11-11-11-25.5t10.52-25.5q11.48-11 26.15-11 14.66 0 25.33 11l627.9 626.92Q853-108 853-93.5t-11 25.98Q831-57 816-57t-26-11l-28-28zm681-681v492q0 18-11.25 27T828-249t-24.75-9.22T792-285v-405L607.35-505.35Q596-494 582-494.5t-25-11.02q-11-11.48-11-26.15 0-14.66 11-25.33l246-246q17-17 39-7.59 22 9.4 22 33.59M585-273" })
  }
);
const SignalDisconnected = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-signal-disconnected",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "mask",
        {
          id: "a",
          width: 16,
          height: 17,
          x: 0,
          y: 0,
          maskUnits: "userSpaceOnUse",
          style: {
            maskType: "alpha"
          },
          children: /* @__PURE__ */ jsx("path", { fill: "#D9D9D9", d: "M0 .5h16v16H0z" })
        }
      ),
      /* @__PURE__ */ jsx("g", { mask: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          d: "M2.822 3h10.356a1 1 0 0 1 .844 1.537l-5.178 8.137a1 1 0 0 1-1.688 0L1.978 4.537A1 1 0 0 1 2.822 3"
        }
      ) })
    ]
  }
);
const SignalNodata = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-signal-nodata",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17",
    ...props,
    children: [
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx("path", { fill: "#1E2535", d: "M0 .5h16v16H0z" }) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 .5h16v16H0z" }) }) })
    ]
  }
);
const SignalNormal = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-signal-normal",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "mask",
        {
          id: "a",
          width: 16,
          height: 17,
          x: 0,
          y: 0,
          maskUnits: "userSpaceOnUse",
          style: {
            maskType: "alpha"
          },
          children: /* @__PURE__ */ jsx("path", { fill: "#D9D9D9", d: "M0 .5h16v16H0z" })
        }
      ),
      /* @__PURE__ */ jsx("g", { mask: "url(#a)", children: /* @__PURE__ */ jsx("path", { fill: "#1774F0", d: "M8 15.5a7 7 0 1 0 0-14 7 7 0 0 0 0 14" }) })
    ]
  }
);
const SignalNosignal = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-signal-nosignal",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "mask",
        {
          id: "a",
          width: 16,
          height: 17,
          x: 0,
          y: 0,
          maskUnits: "userSpaceOnUse",
          style: {
            maskType: "alpha"
          },
          children: /* @__PURE__ */ jsx("path", { fill: "#D9D9D9", d: "M0 .5h16v16H0z" })
        }
      ),
      /* @__PURE__ */ jsx("g", { mask: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#9DA9B6",
          stroke: "#9DA9B6",
          strokeLinejoin: "round",
          d: "M7.646 2.56a.5.5 0 0 1 .708 0l5.585 5.586a.5.5 0 0 1 0 .708l-5.585 5.585a.5.5 0 0 1-.708 0L2.061 8.854a.5.5 0 0 1 0-.708z"
        }
      ) })
    ]
  }
);
const SignalUnavailable = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-signal-unavailable",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "mask",
        {
          id: "a",
          width: 16,
          height: 17,
          x: 0,
          y: 0,
          maskUnits: "userSpaceOnUse",
          style: {
            maskType: "alpha"
          },
          children: /* @__PURE__ */ jsx("path", { fill: "#D9D9D9", d: "M0 .5h16v16H0z" })
        }
      ),
      /* @__PURE__ */ jsx("g", { mask: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          d: "M2.822 3h10.356a1 1 0 0 1 .844 1.537l-5.178 8.137a1 1 0 0 1-1.688 0L1.978 4.537A1 1 0 0 1 2.822 3"
        }
      ) })
    ]
  }
);
const SortMenuAsc = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-sort-menu-asc",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 10",
    ...props,
    children: /* @__PURE__ */ jsxs("g", { fill: "none", fillRule: "evenodd", children: [
      /* @__PURE__ */ jsx("path", { d: "M0-3h16v16H0z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentColor",
          d: "M9.376.032a.66.66 0 0 1 .667.652c0 .36-.299.65-.667.65H.692a.66.66 0 0 1-.667-.65.66.66 0 0 1 .667-.652zM7.454 4.294c.369 0 .667.29.667.651 0 .36-.298.651-.667.651H.692a.66.66 0 0 1-.667-.651c0-.36.298-.651.667-.651zm-1.755 4.26a.66.66 0 0 1 .666.652c0 .36-.298.651-.667.651H.692a.66.66 0 0 1-.667-.651c0-.36.298-.651.667-.651zm10.08-1.562a.64.64 0 0 1 0 .92l-1.908 1.865a.674.674 0 0 1-.943 0l-1.906-1.864a.64.64 0 0 1 0-.92.677.677 0 0 1 .942 0l.77.752V.7c0-.36.297-.65.666-.65s.667.29.667.65v7.043l.77-.752a.677.677 0 0 1 .942 0z"
        }
      )
    ] })
  }
);
const SpeedLock = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-speed-lock",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 69 69",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#DDE5ED",
          d: "M46.595 25.644h-2.082v-4.155c0-5.733-4.664-10.385-10.41-10.385s-10.41 4.652-10.41 10.385v4.155h-2.081c-2.29 0-4.164 1.87-4.164 4.154V50.57c0 2.285 1.874 4.154 4.164 4.154h24.983c2.29 0 4.164-1.87 4.164-4.154V29.798c0-2.285-1.874-4.154-4.164-4.154M34.103 44.338c-2.29 0-4.163-1.87-4.163-4.154 0-2.285 1.873-4.154 4.163-4.154s4.164 1.869 4.164 4.154-1.873 4.154-4.164 4.154m-6.245-18.694v-4.155a6.23 6.23 0 0 1 6.245-6.231 6.23 6.23 0 0 1 6.246 6.231v4.155z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          stroke: "#DDE5ED",
          d: "M49.512 20.535c-5.496 0-9.97 4.227-9.97 9.422 0 5.214 4.474 9.441 9.97 9.441 5.516 0 9.97-4.227 9.97-9.44 0-5.196-4.454-9.423-9.97-9.423Z"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsxs("g", { fill: "#9DA9B6", clipPath: "url(#b)", children: [
        /* @__PURE__ */ jsx("path", { d: "M53.945 28.904a4 4 0 0 0-.578-.052 3.473 3.473 0 0 0-3.47 3.47c0 .74.237 1.428.636 1.995-.3.133-.607.243-.925.318-2.487-.595-4.337-3.053-4.337-5.679v-2.84l4.337-1.89 4.337 1.89z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M51.054 32.322a2.312 2.312 0 1 1 4.625-.001 2.312 2.312 0 0 1-4.625.001m2.96-.867a.65.65 0 0 0-.647-.648.65.65 0 0 0-.648.648c0 .352.295.647.648.647a.654.654 0 0 0 .648-.647m-1.943 1.78c.29.411.758.677 1.296.677s1.006-.266 1.295-.676c-.029-.417-.873-.625-1.295-.625s-1.267.208-1.296.625",
            clipRule: "evenodd"
          }
        )
      ] }) }),
      /* @__PURE__ */ jsx(
        "ellipse",
        {
          cx: 34.445,
          cy: 54.724,
          fill: "#DDE5ED",
          fillOpacity: 0.4,
          rx: 28.893,
          ry: 7.931
        }
      ),
      /* @__PURE__ */ jsxs("defs", { children: [
        /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M39.542 20.535h19.941v18.863H39.542z" }) }),
        /* @__PURE__ */ jsx("clipPath", { id: "b", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M44.527 23.482h11.897V35.38H44.527z" }) })
      ] })
    ]
  }
);
const StatusDanger = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-status-danger",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17",
    ...props,
    children: [
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10.213 2.5H5.787a.67.67 0 0 0-.467.193L2.193 5.82A.67.67 0 0 0 2 6.287v4.42c0 .18.073.346.193.473l3.12 3.12c.127.127.3.2.474.2h4.42c.18 0 .346-.073.473-.193l3.12-3.12a.66.66 0 0 0 .193-.474V6.287a.7.7 0 0 0-.193-.474l-3.12-3.12a.67.67 0 0 0-.467-.193M8 12.033a.865.865 0 0 1-.867-.866c0-.48.387-.867.867-.867s.867.387.867.867-.387.866-.867.866m0-2.866a.67.67 0 0 1-.667-.667V5.833c0-.366.3-.666.667-.666s.667.3.667.666V8.5c0 .367-.3.667-.667.667"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 .5h16v16H0z" }) }) })
    ]
  }
);
const StatusInfo = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-status-info",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 1.833A6.67 6.67 0 0 0 1.333 8.5 6.67 6.67 0 0 0 8 15.167 6.67 6.67 0 0 0 14.667 8.5 6.67 6.67 0 0 0 8 1.833m0 10a.67.67 0 0 1-.667-.666V8.5c0-.367.3-.667.667-.667s.667.3.667.667v2.667c0 .366-.3.666-.667.666M8.667 6.5H7.333V5.167h1.334z"
      }
    )
  }
);
const StatusInstallation = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-status-installation",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17",
    ...props,
    children: /* @__PURE__ */ jsxs("g", { fill: "currentColor", children: [
      /* @__PURE__ */ jsx("path", { d: "m5.414 7.617 1.02 1.04 1.933-1.97-.801-.815.428-1.042-.983-2.284L4.724 1.5l-.671.24 2.192 2.232-2 1.9-2.283-2.325-.388.944.983 2.284 2.288 1.046z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "m6.168 11.347 6.85-6.939c.526.074.96-.253.96-.253l.815-1.544-.978-.924-1.59.813s-.347.472-.211 1.011L5.19 10.423l-.958-.905-3.137 3.177s-.49.861.75 2.033c1.24 1.17 2.104.662 2.104.662l3.136-3.177zm-.29.819-.571-.54-2.365 2.396.57.54zM4.8 11.223l-.57-.539-2.366 2.396.57.54z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "m7.889 10.138 4.72 4.808a1.407 1.407 0 0 0 1.966.033 1.35 1.35 0 0 0 .035-1.933L9.821 8.169z" })
    ] })
  }
);
const StatusProcessing = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-status-processing",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "M3.5 8.538q0 .843.319 1.64a4.4 4.4 0 0 0 .994 1.472l.187.188V10.75q0-.319.216-.534A.73.73 0 0 1 5.75 10q.319 0 .534.216a.73.73 0 0 1 .216.534v3q0 .319-.216.534a.73.73 0 0 1-.534.216h-3a.73.73 0 0 1-.534-.216A.73.73 0 0 1 2 13.75q0-.319.216-.534A.73.73 0 0 1 2.75 13h1.313l-.3-.262q-.975-.863-1.37-1.97A6.6 6.6 0 0 1 2 8.539q0-1.764.9-3.197a6 6 0 0 1 2.419-2.203q.263-.15.553-.02a.68.68 0 0 1 .384.432.83.83 0 0 1-.01.563.8.8 0 0 1-.365.43q-1.088.6-1.734 1.66A4.4 4.4 0 0 0 3.5 8.537m9-.075a4.4 4.4 0 0 0-.319-1.641 4.4 4.4 0 0 0-.993-1.472L11 5.163V6.25q0 .319-.216.534A.73.73 0 0 1 10.25 7a.73.73 0 0 1-.534-.216.73.73 0 0 1-.216-.534v-3q0-.318.216-.534a.73.73 0 0 1 .534-.216h3q.319 0 .534.216A.73.73 0 0 1 14 3.25q0 .318-.216.534A.73.73 0 0 1 13.25 4h-1.312l.3.263q.918.918 1.34 1.996Q14 7.34 14 8.463q0 1.762-.9 3.196a6 6 0 0 1-2.419 2.204.58.58 0 0 1-.553.018.68.68 0 0 1-.384-.431.83.83 0 0 1 .01-.562.8.8 0 0 1 .365-.432 4.6 4.6 0 0 0 1.734-1.66 4.4 4.4 0 0 0 .647-2.333"
      }
    )
  }
);
const StatusSuccess = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-status-success",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "M8 1.833A6.67 6.67 0 0 0 1.333 8.5 6.67 6.67 0 0 0 8 15.167 6.67 6.67 0 0 0 14.667 8.5 6.67 6.67 0 0 0 8 1.833M6.193 11.36 3.8 8.967a.664.664 0 1 1 .94-.94l1.927 1.92 4.586-4.587a.664.664 0 1 1 .94.94l-5.06 5.06a.664.664 0 0 1-.94 0"
      }
    )
  }
);
const StatusTracking = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-status-tracking",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17",
    ...props,
    children: /* @__PURE__ */ jsxs("g", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", children: [
      /* @__PURE__ */ jsx("path", { d: "M12.324 9.7c.796 0 1.44.627 1.44 1.4s-.644 1.4-1.44 1.4-1.442-.627-1.442-1.4.646-1.4 1.441-1.4m0 .8a.61.61 0 0 0-.618.6c0 .331.276.6.617.6a.61.61 0 0 0 .618-.6.61.61 0 0 0-.618-.6M3.676 9.7c.796 0 1.442.627 1.442 1.4s-.646 1.4-1.442 1.4-1.44-.627-1.44-1.4.645-1.4 1.44-1.4m0 .8a.61.61 0 0 0-.617.6c0 .331.276.6.617.6a.61.61 0 0 0 .618-.6c0-.331-.276-.6-.618-.6" }),
      /* @__PURE__ */ jsx("path", { d: "m13.38 7.37-.005-.003-.557-.361L11.5 5.3c-.35-.454-1.063-.8-1.647-.8H1.618a.406.406 0 0 0-.412.4c0 .198.148.362.342.394l-.543 3.344A.4.4 0 0 0 1 8.7v2c0 .22.184.4.412.4h.412c0-.994.83-1.8 1.852-1.8 1.024 0 1.853.806 1.853 1.8h4.942c0-.994.83-1.8 1.852-1.8 1.024 0 1.854.806 1.854 1.8h.411c.228 0 .412-.18.412-.4V9.5c0-.572-.367-1.258-.85-1.586a28 28 0 0 0-.437-.312q-.209-.148-.328-.229zM9.646 7.3c-.25 0-.497-.208-.532-.448L8.887 5.3h.966c.325 0 .793.228.988.48l1.174 1.52z" })
    ] })
  }
);
const StatusWarning = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-status-warning",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        d: "M2.98 14.5h10.04a1.333 1.333 0 0 0 1.153-2l-5.02-8.673a1.333 1.333 0 0 0-2.306 0L1.827 12.5c-.514.887.126 2 1.153 2M8 9.833a.67.67 0 0 1-.667-.666V7.833c0-.366.3-.666.667-.666s.667.3.667.666v1.334c0 .366-.3.666-.667.666m.667 2.667H7.333v-1.333h1.334z"
      }
    )
  }
);
const SteeringWheel = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-steering-wheel",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 15.343A7.35 7.35 0 0 1 .657 8a7.344 7.344 0 0 1 12.535-5.192A7.344 7.344 0 0 1 8 15.343M8 9.7a1.637 1.637 0 1 0 0-3.274A1.637 1.637 0 0 0 8 9.7m5.327-.046a.656.656 0 0 0-.622-.854 3.877 3.877 0 0 0-3.88 3.734v.156a.658.658 0 0 0 .865.636 5.6 5.6 0 0 0 3.637-3.672M3 5.512a.674.674 0 0 0 .598.974.7.7 0 0 0 .36-.104c.943-.587 2.428-.948 4.041-.948 1.619 0 3.102.359 4.04.948a.7.7 0 0 0 .354.104.676.676 0 0 0 .606-.974 5.585 5.585 0 0 0-9.999 0m2.982 4.373A3.88 3.88 0 0 0 3.29 8.8a.655.655 0 0 0-.617.852 5.61 5.61 0 0 0 3.636 3.674.66.66 0 0 0 .857-.647v-.133a3.88 3.88 0 0 0-1.183-2.66"
      }
    )
  }
);
const TrafficLight = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-traffic-light",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M14 6.444h-2.25v-.886C13.04 5.208 14 4.002 14 2.556h-2.25v-.778C11.75 1.35 11.412 1 11 1H5c-.412 0-.75.35-.75.778v.778H2c0 1.446.96 2.652 2.25 3.002v.886H2c0 1.447.96 2.653 2.25 3.003v.886H2c0 1.447.96 2.653 2.25 3.003v.886c0 .428.338.778.75.778h6c.412 0 .75-.35.75-.778v-.886c1.29-.35 2.25-1.556 2.25-3.003h-2.25v-.886C13.04 9.097 14 7.89 14 6.444m-6 7c-.832 0-1.5-.7-1.5-1.555 0-.856.668-1.556 1.5-1.556.825 0 1.5.7 1.5 1.556 0 .855-.668 1.555-1.5 1.555m0-3.888c-.832 0-1.5-.7-1.5-1.556S7.168 6.444 8 6.444c.825 0 1.5.7 1.5 1.556S8.832 9.556 8 9.556m0-3.89c-.832 0-1.5-.7-1.5-1.555 0-.863.668-1.555 1.5-1.555.825 0 1.5.692 1.5 1.555 0 .856-.668 1.556-1.5 1.556",
        clipRule: "evenodd"
      }
    )
  }
);
const Unplugged = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-unplugged",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ...props,
    children: /* @__PURE__ */ jsxs("g", { fill: "none", fillRule: "evenodd", children: [
      /* @__PURE__ */ jsx("path", { d: "M0 0h16v16H0z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentColor",
          d: "M10.798 1.558a.545.545 0 0 0-.53-.558c-.294 0-.531.25-.531.558V5.21H6.263V1.558A.545.545 0 0 0 5.733 1c-.293 0-.531.25-.531.558V5.21H4v2.24c.006 1.993 1.343 3.706 3.2 4.103V15h1.6v-3.447c1.857-.397 3.194-2.11 3.2-4.103V5.202h-1.202z"
        }
      )
    ] })
  }
);
const VehicleSBoatDisablePending = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-boat-disable-pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M12.905 39.469c3.437-9.9 3.878-20.809 3.878-26.635S11.331.217 9.774.217c-1.556 0-7.173 7.272-6.942 12.617.23 5.344.537 16.681 3.568 26.635.463 1.522 1.686 1.27 3.374 1.27 1.335 0 2.58.316 3.131-1.27"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M10.403.7c-.29-.191-.501-.266-.629-.266-.124 0-.335.079-.631.284a7 7 0 0 0-.987.87c-.73.752-1.561 1.816-2.34 3.049-1.562 2.474-2.88 5.582-2.768 8.187l.042.994c.234 5.67.671 16.243 3.517 25.588.108.353.254.586.425.744s.382.256.643.313c.263.059.57.075.925.075q.257 0 .541-.007h.018q.295-.007.615-.008c.194 0 .396.007.59.013q.205.008.388.011c.31.005.587-.006.836-.06.245-.053.457-.149.639-.312.181-.163.345-.407.473-.777 3.425-9.866 3.867-20.744 3.867-26.564 0-2.854-1.34-5.967-2.887-8.376-.772-1.203-1.59-2.22-2.307-2.936a6.6 6.6 0 0 0-.97-.821m3.642 3.523C15.613 6.665 17 9.861 17 12.833c0 5.834-.441 16.771-3.89 26.707-.146.423-.345.735-.593.958a1.8 1.8 0 0 1-.837.413 4 4 0 0 1-.934.07q-.212-.004-.414-.012c-.183-.006-.364-.013-.558-.013q-.312.001-.606.008h-.02q-.283.007-.548.008c-.363 0-.708-.016-1.02-.085a1.77 1.77 0 0 1-.842-.418c-.241-.223-.422-.529-.546-.937-2.862-9.4-3.301-20.024-3.535-25.69l-.042-.999c-.118-2.74 1.257-5.94 2.834-8.438.792-1.253 1.641-2.341 2.395-3.12A7.4 7.4 0 0 1 8.896.363C9.204.148 9.509 0 9.774 0c.261 0 .562.137.868.34.314.207.666.505 1.037.875.743.74 1.58 1.785 2.366 3.008",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M14.254 29.656c.526-2.243.956-8.427 1.205-11.231.124-1.402-1.39-3.927-5.14-3.927s-6.206 2.525-6.206 3.927c.22 3.066.877 9.72 1.184 11.231.284 1.402 1.423 1.402 2.036 1.402s3.504.044 4.599 0 1.993 0 2.322-1.402"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M15.243 18.405c.11-1.25-1.275-3.69-4.924-3.69-1.826 0-3.332.614-4.38 1.395-.524.39-.93.82-1.203 1.23s-.404.786-.406 1.077c.22 3.073.876 9.702 1.18 11.196.128.634.439.925.77 1.071.348.154.741.157 1.053.157.153 0 .443.002.808.006 1.122.01 2.96.027 3.782-.006l.165-.006c.492-.019.887-.033 1.208-.169.325-.137.594-.41.747-1.06.259-1.104.497-3.195.701-5.376.129-1.369.244-2.762.342-3.957.058-.707.11-1.345.157-1.868m-4.924-4.124c3.85 0 5.493 2.61 5.356 4.163-.046.517-.098 1.152-.156 1.858-.099 1.198-.214 2.6-.343 3.969-.204 2.173-.444 4.296-.71 5.434-.177.752-.52 1.158-1.001 1.36-.4.17-.88.186-1.354.203l-.17.006c-.834.034-2.704.017-3.823.006-.358-.003-.639-.006-.785-.006h-.012c-.302 0-.778 0-1.217-.193-.463-.205-.864-.614-1.02-1.382-.31-1.528-.968-8.195-1.187-11.26v-.015c0-.409.176-.871.478-1.325a5.6 5.6 0 0 1 1.305-1.337c1.118-.833 2.715-1.48 4.639-1.48",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M15.437 18.44s.179-1.245.179-5.813c0-4.569-4.602-11.008-5.825-11.008S4 8.18 4 12.627s.118 5.814.118 5.814 1.527-3.993 5.673-3.993 5.646 3.993 5.646 3.993"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M9.965 1.888a.4.4 0 0 0-.174-.052.4.4 0 0 0-.171.052q-.125.06-.296.193c-.227.176-.495.439-.79.775-.59.673-1.268 1.62-1.91 2.71-1.29 2.186-2.407 4.897-2.407 7.061a142 142 0 0 0 .074 4.981c.213-.37.525-.84.948-1.309.928-1.029 2.401-2.068 4.552-2.068 2.152 0 3.618 1.04 4.54 2.069.43.482.745.964.956 1.34l.023-.404c.044-.878.089-2.327.089-4.609 0-2.225-1.126-4.936-2.423-7.106-.646-1.081-1.328-2.017-1.92-2.68a6 6 0 0 0-.795-.764 1.8 1.8 0 0 0-.296-.19m5.269 16.63v-.002l-.003-.007a2 2 0 0 0-.064-.15 7.243 7.243 0 0 0-1.16-1.77c-.865-.966-2.222-1.924-4.216-1.924s-3.358.958-4.23 1.925a7.3 7.3 0 0 0-1.172 1.77l-.065.15-.003.007v.002m-.203-.078-.216.019a.217.217 0 0 0 .418.059m-.202-.078-.216.019v-.005L3.9 18.44a7 7 0 0 1-.017-.271c-.011-.2-.026-.511-.04-.961-.03-.9-.06-2.357-.06-4.582 0-2.282 1.166-5.076 2.467-7.282.653-1.107 1.346-2.078 1.957-2.775.305-.347.594-.632.851-.832q.194-.151.371-.24a.84.84 0 0 1 .362-.096c.121 0 .244.039.36.095.12.056.244.137.373.235.258.196.548.477.855.82.614.687 1.312 1.647 1.97 2.746 1.31 2.192 2.484 4.986 2.484 7.329 0 2.287-.045 3.744-.09 4.631a25 25 0 0 1-.083 1.145l-.006.05-.002.014v.004l-.215-.03.215.03a.217.217 0 0 1-.418.046",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m15.722 16.51-.197.091c-.197.091-.196.092-.196.092v-.001l-.004-.006a2 2 0 0 0-.064-.123 5 5 0 0 0-.223-.361 6.3 6.3 0 0 0-.953-1.106c-.873-.803-2.246-1.608-4.255-1.608s-3.417.806-4.324 1.61a6.7 6.7 0 0 0-1 1.109 5 5 0 0 0-.306.485l-.003.006-.194-.097-.194-.098v-.001l.002-.003.005-.008.016-.031q.022-.04.065-.113c.056-.096.142-.23.257-.392a7 7 0 0 1 1.064-1.181c.97-.86 2.476-1.72 4.612-1.72s3.611.86 4.549 1.723a6.7 6.7 0 0 1 1.02 1.183 5 5 0 0 1 .301.505l.016.032.004.009.001.002z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.974 36.666c.06 0 .108.048.108.108v4.564c0 .06-.048.109-.108.109H7.376a.11.11 0 0 1-.109-.109v-4.564c0-.06.049-.108.109-.108z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M11.649 37.1H7.7v3.913h3.948zm.433-.326a.11.11 0 0 0-.108-.108H7.376a.11.11 0 0 0-.109.108v4.564c0 .06.049.109.109.109h4.598c.06 0 .108-.049.108-.109z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCF0DE",
          fillRule: "evenodd",
          stroke: "#F9D199",
          d: "M10 46.973A8.527 8.527 0 1 0 10 29.919 8.527 8.527 0 0 0 10 46.973Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F9D199",
          fillRule: "evenodd",
          d: "M1 38.447a9 9 0 1 1 18.001.001 9 9 0 0 1-18-.001m9-8.053a8.053 8.053 0 1 0 .002 16.107A8.053 8.053 0 0 0 10 30.394",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          fillRule: "evenodd",
          d: "M12.924 36.789h-.473v-.947a2.37 2.37 0 0 0-4.737 0v.947H7.24a.95.95 0 0 0-.947.947v4.737a.95.95 0 0 0 .947.947h5.684a.95.95 0 0 0 .948-.947v-4.737a.95.95 0 0 0-.948-.947m-2.842 4.263a.95.95 0 0 1-.947-.947.95.95 0 0 1 .947-.948.95.95 0 0 1 .948.948.95.95 0 0 1-.948.947m1.469-4.263H8.614v-.947c0-.81.658-1.469 1.468-1.469s1.469.659 1.469 1.469z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSBoatDisabled = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-boat-disabled",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M12.905 39.469c3.437-9.9 3.878-20.809 3.878-26.635S11.33.217 9.773.217 2.602 7.489 2.833 12.834c.23 5.344.536 16.681 3.568 26.635.463 1.522 1.686 1.27 3.374 1.27 1.335 0 2.58.316 3.131-1.27"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M10.402.7c-.29-.191-.5-.266-.628-.266-.124 0-.335.079-.631.284a7 7 0 0 0-.987.87c-.73.752-1.562 1.816-2.34 3.049-1.562 2.474-2.88 5.582-2.768 8.187l.042.994c.234 5.67.671 16.243 3.517 25.588.107.353.254.586.425.744s.382.256.642.313c.264.059.57.075.926.075q.256 0 .541-.007h.018q.294-.007.615-.008c.193 0 .396.007.59.013q.205.008.388.011c.309.005.587-.006.835-.06.246-.053.458-.149.64-.312.181-.163.345-.407.473-.777 3.425-9.866 3.866-20.744 3.866-26.564 0-2.854-1.339-5.967-2.886-8.376-.772-1.203-1.59-2.22-2.307-2.936a6.6 6.6 0 0 0-.97-.821m3.643 3.523C15.613 6.665 17 9.861 17 12.833c0 5.834-.441 16.771-3.89 26.707-.147.423-.345.735-.594.958a1.8 1.8 0 0 1-.836.413 4 4 0 0 1-.934.07q-.212-.004-.414-.012c-.183-.006-.364-.013-.558-.013q-.313.001-.606.008h-.02a27 27 0 0 1-.548.008c-.363 0-.708-.016-1.02-.085a1.77 1.77 0 0 1-.842-.418c-.241-.223-.422-.529-.546-.937-2.863-9.4-3.301-20.024-3.535-25.69l-.042-.999c-.118-2.74 1.257-5.94 2.834-8.438.791-1.253 1.641-2.341 2.395-3.12A7.4 7.4 0 0 1 8.896.363C9.204.148 9.509 0 9.774 0c.261 0 .562.137.868.34.314.207.665.505 1.037.875.743.74 1.58 1.785 2.366 3.008",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M14.254 29.656c.525-2.243.956-8.427 1.204-11.231.124-1.402-1.39-3.927-5.14-3.927s-6.205 2.525-6.205 3.927c.219 3.066.877 9.72 1.184 11.231.284 1.402 1.422 1.402 2.036 1.402.613 0 3.503.044 4.599 0 1.095-.044 1.993 0 2.322-1.402"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M15.242 18.405c.111-1.25-1.275-3.69-4.923-3.69-1.826 0-3.332.614-4.38 1.395-.524.39-.93.82-1.203 1.23s-.404.786-.406 1.077c.22 3.073.876 9.702 1.18 11.196.128.634.439.925.77 1.071.348.154.74.157 1.053.157.153 0 .442.002.808.006 1.122.01 2.96.027 3.782-.006l.165-.006c.492-.019.886-.033 1.208-.169.324-.137.594-.41.747-1.06.258-1.104.496-3.195.701-5.376.129-1.369.243-2.762.341-3.957.059-.707.111-1.345.157-1.868m-4.923-4.124c3.85 0 5.493 2.61 5.355 4.163-.045.517-.098 1.152-.156 1.858-.098 1.198-.213 2.6-.342 3.969-.204 2.173-.444 4.296-.711 5.434-.176.752-.52 1.158-1 1.36-.4.17-.881.186-1.354.203l-.17.006c-.835.034-2.704.017-3.823.006-.358-.003-.639-.006-.785-.006H7.32c-.302 0-.778 0-1.217-.193-.463-.205-.864-.614-1.02-1.382-.31-1.528-.968-8.195-1.187-11.26v-.015c0-.409.176-.871.478-1.325a5.6 5.6 0 0 1 1.305-1.337c1.118-.833 2.714-1.48 4.639-1.48",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M15.437 18.44s.179-1.245.179-5.813c0-4.569-4.602-11.008-5.825-11.008S3.999 8.18 3.999 12.627s.119 5.814.119 5.814 1.527-3.993 5.673-3.993c4.145 0 5.646 3.993 5.646 3.993"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M9.964 1.888a.4.4 0 0 0-.173-.052.4.4 0 0 0-.171.052q-.126.06-.296.193c-.227.176-.496.439-.79.775-.59.673-1.268 1.62-1.91 2.71-1.29 2.186-2.408 4.897-2.408 7.061a142 142 0 0 0 .074 4.981c.214-.37.526-.84.949-1.309.928-1.029 2.4-2.068 4.552-2.068s3.617 1.04 4.539 2.069c.432.482.745.964.957 1.34l.023-.404c.044-.878.089-2.327.089-4.609 0-2.225-1.126-4.936-2.423-7.106-.646-1.081-1.328-2.017-1.92-2.68a6 6 0 0 0-.795-.764 1.8 1.8 0 0 0-.297-.19m5.27 16.63v-.002l-.004-.007-.012-.03-.052-.12a7.24 7.24 0 0 0-1.16-1.77c-.864-.966-2.22-1.924-4.215-1.924s-3.358.958-4.23 1.925a7.3 7.3 0 0 0-1.172 1.77l-.065.15-.003.007v.002m-.203-.078-.216.019a.217.217 0 0 0 .418.059m-.202-.078-.216.019v-.005L3.9 18.44a7 7 0 0 1-.017-.271c-.012-.2-.026-.511-.041-.961-.03-.9-.06-2.357-.06-4.582 0-2.282 1.167-5.076 2.468-7.282.652-1.107 1.346-2.078 1.957-2.775.305-.347.594-.632.85-.832q.195-.151.372-.24a.84.84 0 0 1 .362-.096.85.85 0 0 1 .36.095c.119.056.244.137.373.235.258.196.548.477.855.82.614.687 1.312 1.647 1.97 2.746 1.309 2.192 2.483 4.986 2.483 7.329 0 2.287-.044 3.744-.09 4.631a25 25 0 0 1-.082 1.145l-.006.05-.002.014v.004l-.215-.03.214.03a.217.217 0 0 1-.417.046",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M15.721 16.51a19 19 0 0 1-.393.183v-.001l-.003-.006-.012-.024-.052-.099a5 5 0 0 0-.223-.361 6.3 6.3 0 0 0-.953-1.106c-.873-.803-2.247-1.608-4.255-1.608-2.01 0-3.417.806-4.325 1.61a6.7 6.7 0 0 0-.998 1.109 5 5 0 0 0-.308.485l-.002.006h-.001l-.194-.097-.193-.098v-.001l.002-.003.004-.008a2 2 0 0 1 .081-.144c.057-.096.142-.23.257-.392a7 7 0 0 1 1.065-1.181c.97-.86 2.475-1.72 4.612-1.72s3.611.86 4.549 1.723c.468.43.802.86 1.019 1.183a5 5 0 0 1 .317.537l.005.009v.002h.001z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.974 36.666c.06 0 .108.048.108.108v4.564c0 .06-.049.109-.108.109H7.376a.11.11 0 0 1-.109-.109v-4.564c0-.06.049-.108.109-.108z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M11.648 37.1H7.701v3.913h3.947zm.434-.326a.11.11 0 0 0-.108-.108H7.376a.11.11 0 0 0-.109.108v4.564c0 .06.049.109.109.109h4.598c.06 0 .108-.049.108-.109z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCEDEB",
          fillRule: "evenodd",
          stroke: "#F5B7B1",
          d: "M10 46.973a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F5B7B1",
          fillRule: "evenodd",
          d: "M1 38.447a9 9 0 1 1 18.001.001A9 9 0 0 1 1 38.447m9-8.053a8.053 8.053 0 1 0 .002 16.107A8.053 8.053 0 0 0 10 30.394",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          fillRule: "evenodd",
          d: "M12.924 36.789h-.474v-.947a2.37 2.37 0 0 0-4.736 0v.947H7.24a.95.95 0 0 0-.948.947v4.737a.95.95 0 0 0 .948.947h5.684a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.947m-2.842 4.263a.95.95 0 0 1-.947-.947.95.95 0 0 1 .947-.948.95.95 0 0 1 .947.948.95.95 0 0 1-.947.947m1.468-4.263H8.614v-.947c0-.81.658-1.469 1.468-1.469s1.468.659 1.468 1.469z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSBoatEnablePending = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-boat-enable-pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M12.905 39.469c3.437-9.9 3.878-20.809 3.878-26.635S11.33.217 9.773.217 2.602 7.489 2.833 12.834c.23 5.344.536 16.681 3.568 26.635.463 1.522 1.686 1.27 3.374 1.27 1.335 0 2.58.316 3.131-1.27"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M10.402.7c-.29-.191-.5-.266-.628-.266-.124 0-.335.079-.631.284a7 7 0 0 0-.987.87c-.73.752-1.562 1.816-2.34 3.049-1.562 2.474-2.88 5.582-2.768 8.187l.042.994c.234 5.67.671 16.243 3.517 25.588.107.353.254.586.425.744s.382.256.642.313c.264.059.57.075.926.075q.256 0 .541-.007h.018q.294-.007.615-.008c.193 0 .396.007.59.013q.205.008.388.011c.309.005.587-.006.835-.06.246-.053.458-.149.64-.312.181-.163.345-.407.473-.777 3.425-9.866 3.866-20.744 3.866-26.564 0-2.854-1.339-5.967-2.886-8.376-.772-1.203-1.59-2.22-2.307-2.936a6.6 6.6 0 0 0-.97-.821m3.643 3.523C15.613 6.665 17 9.861 17 12.833c0 5.834-.441 16.771-3.89 26.707-.147.423-.345.735-.594.958a1.8 1.8 0 0 1-.836.413 4 4 0 0 1-.934.07q-.212-.004-.414-.012c-.183-.006-.364-.013-.558-.013q-.313.001-.606.008h-.02a27 27 0 0 1-.548.008c-.363 0-.708-.016-1.02-.085a1.77 1.77 0 0 1-.842-.418c-.241-.223-.422-.529-.546-.937-2.863-9.4-3.301-20.024-3.535-25.69l-.042-.999c-.118-2.74 1.257-5.94 2.834-8.438.791-1.253 1.641-2.341 2.395-3.12A7.4 7.4 0 0 1 8.896.363C9.204.148 9.509 0 9.774 0c.261 0 .562.137.868.34.314.207.665.505 1.037.875.743.74 1.58 1.785 2.366 3.008",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M14.254 29.656c.525-2.243.956-8.427 1.204-11.231.124-1.402-1.39-3.927-5.14-3.927s-6.205 2.525-6.205 3.927c.219 3.066.877 9.72 1.184 11.231.284 1.402 1.422 1.402 2.036 1.402.613 0 3.503.044 4.599 0 1.095-.044 1.993 0 2.322-1.402"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M15.242 18.405c.111-1.25-1.275-3.69-4.923-3.69-1.826 0-3.332.614-4.38 1.395-.524.39-.93.82-1.203 1.23s-.404.786-.406 1.077c.22 3.073.876 9.702 1.18 11.196.128.634.439.925.77 1.071.348.154.74.157 1.053.157.153 0 .442.002.808.006 1.122.01 2.96.027 3.782-.006l.165-.006c.492-.019.886-.033 1.208-.169.324-.137.594-.41.747-1.06.258-1.104.496-3.195.701-5.376.129-1.369.243-2.762.341-3.957.059-.707.111-1.345.157-1.868m-4.923-4.124c3.85 0 5.493 2.61 5.355 4.163-.045.517-.098 1.152-.156 1.858-.098 1.198-.213 2.6-.342 3.969-.204 2.173-.444 4.296-.711 5.434-.176.752-.52 1.158-1 1.36-.4.17-.881.186-1.354.203l-.17.006c-.835.034-2.704.017-3.823.006-.358-.003-.639-.006-.785-.006H7.32c-.302 0-.778 0-1.217-.193-.463-.205-.864-.614-1.02-1.382-.31-1.528-.968-8.195-1.187-11.26v-.015c0-.409.176-.871.478-1.325a5.6 5.6 0 0 1 1.305-1.337c1.118-.833 2.714-1.48 4.639-1.48",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M15.437 18.44s.179-1.245.179-5.813c0-4.569-4.602-11.008-5.825-11.008S3.999 8.18 3.999 12.627s.119 5.814.119 5.814 1.527-3.993 5.673-3.993c4.145 0 5.646 3.993 5.646 3.993"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M9.964 1.888a.4.4 0 0 0-.173-.052.4.4 0 0 0-.171.052q-.126.06-.296.193c-.227.176-.496.439-.79.775-.59.673-1.268 1.62-1.91 2.71-1.29 2.186-2.408 4.897-2.408 7.061a142 142 0 0 0 .074 4.981c.214-.37.526-.84.949-1.309.928-1.029 2.4-2.068 4.552-2.068s3.617 1.04 4.539 2.069c.432.482.745.964.957 1.34l.023-.404c.044-.878.089-2.327.089-4.609 0-2.225-1.126-4.936-2.423-7.106-.646-1.081-1.328-2.017-1.92-2.68a6 6 0 0 0-.795-.764 1.8 1.8 0 0 0-.297-.19m5.27 16.63v-.002l-.004-.007-.012-.03-.052-.12a7.24 7.24 0 0 0-1.16-1.77c-.864-.966-2.22-1.924-4.215-1.924s-3.358.958-4.23 1.925a7.3 7.3 0 0 0-1.172 1.77l-.065.15-.003.007v.002m-.203-.078-.216.019a.217.217 0 0 0 .418.059m-.202-.078-.216.019v-.005L3.9 18.44a7 7 0 0 1-.017-.271c-.012-.2-.026-.511-.041-.961-.03-.9-.06-2.357-.06-4.582 0-2.282 1.167-5.076 2.468-7.282.652-1.107 1.346-2.078 1.957-2.775.305-.347.594-.632.85-.832q.195-.151.372-.24a.84.84 0 0 1 .362-.096.85.85 0 0 1 .36.095c.119.056.244.137.373.235.258.196.548.477.855.82.614.687 1.312 1.647 1.97 2.746 1.309 2.192 2.483 4.986 2.483 7.329 0 2.287-.044 3.744-.09 4.631a25 25 0 0 1-.082 1.145l-.006.05-.002.014v.004l-.215-.03.214.03a.217.217 0 0 1-.417.046",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M15.721 16.51a19 19 0 0 1-.393.183v-.001l-.003-.006-.012-.024-.052-.099a5 5 0 0 0-.223-.361 6.3 6.3 0 0 0-.953-1.106c-.873-.803-2.247-1.608-4.255-1.608-2.01 0-3.417.806-4.325 1.61a6.7 6.7 0 0 0-.998 1.109 5 5 0 0 0-.308.485l-.002.006h-.001l-.194-.097-.193-.098v-.001l.002-.003.004-.008a2 2 0 0 1 .081-.144c.057-.096.142-.23.257-.392a7 7 0 0 1 1.065-1.181c.97-.86 2.475-1.72 4.612-1.72s3.611.86 4.549 1.723c.468.43.802.86 1.019 1.183a5 5 0 0 1 .317.537l.005.009v.002h.001z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.974 36.666c.06 0 .108.048.108.108v4.564c0 .06-.049.109-.108.109H7.376a.11.11 0 0 1-.109-.109v-4.564c0-.06.049-.108.109-.108z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M11.648 37.1H7.701v3.913h3.947zm.434-.326a.11.11 0 0 0-.108-.108H7.376a.11.11 0 0 0-.109.108v4.564c0 .06.049.109.109.109h4.598c.06 0 .108-.049.108-.109z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#CFDEF2",
          fillRule: "evenodd",
          stroke: "#F5B7B1",
          d: "M10 46.973a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#8AB9F7",
          fillRule: "evenodd",
          d: "M1 38.447a9 9 0 1 1 18.001.001A9 9 0 0 1 1 38.447m9-8.053a8.053 8.053 0 1 0 .002 16.107A8.053 8.053 0 0 0 10 30.394",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1774F0",
          fillRule: "evenodd",
          d: "M10.082 40.815a.95.95 0 0 0 .947-.947.95.95 0 0 0-.947-.948.95.95 0 0 0-.947.948.95.95 0 0 0 .947.947m2.842-4.263h-.474v-.947a2.37 2.37 0 0 0-4.736 0h.9a1.47 1.47 0 0 1 2.936 0v.947H7.24a.95.95 0 0 0-.948.947v4.737a.95.95 0 0 0 .948.948h5.684a.95.95 0 0 0 .947-.948V37.5a.95.95 0 0 0-.947-.948m0 5.684H7.24V37.5h5.684z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSBoatNoSignal = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-boat-no-signal",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M11.905 39.469c3.437-9.9 3.878-20.809 3.878-26.635S10.331.217 8.774.217c-1.556 0-7.173 7.272-6.942 12.617.23 5.344.537 16.681 3.568 26.635.463 1.522 1.686 1.27 3.374 1.27 1.335 0 2.58.316 3.131-1.27"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M9.403.7C9.113.51 8.902.435 8.774.435c-.124 0-.335.079-.631.284a7 7 0 0 0-.987.87c-.73.752-1.561 1.816-2.34 3.049-1.562 2.474-2.88 5.582-2.768 8.187l.042.994c.234 5.67.671 16.243 3.517 25.588.108.353.254.586.425.744s.382.256.643.313c.263.059.57.075.925.075q.257 0 .541-.007h.018q.295-.007.615-.008c.194 0 .396.007.59.013q.205.008.388.011c.31.005.587-.006.836-.06.245-.053.457-.149.639-.312.181-.163.345-.407.473-.777 3.425-9.866 3.867-20.744 3.867-26.564 0-2.854-1.34-5.967-2.887-8.376-.772-1.203-1.59-2.22-2.307-2.936a6.6 6.6 0 0 0-.97-.821m3.642 3.523C14.613 6.665 16 9.861 16 12.833c0 5.834-.441 16.771-3.89 26.707-.146.423-.345.735-.593.958a1.8 1.8 0 0 1-.837.413 4 4 0 0 1-.934.07q-.211-.004-.414-.012c-.183-.006-.364-.013-.558-.013q-.312.001-.606.008h-.02q-.283.007-.548.008c-.363 0-.708-.016-1.02-.085a1.77 1.77 0 0 1-.842-.418c-.241-.223-.422-.529-.546-.937-2.862-9.4-3.301-20.024-3.535-25.69l-.042-.999c-.118-2.74 1.257-5.94 2.834-8.438.792-1.253 1.641-2.341 2.395-3.12A7.4 7.4 0 0 1 7.896.363C8.204.148 8.509 0 8.774 0c.261 0 .562.137.868.34a7 7 0 0 1 1.037.875c.743.74 1.58 1.785 2.366 3.008",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M13.254 29.656c.526-2.243.956-8.427 1.205-11.231.124-1.402-1.39-3.927-5.14-3.927s-6.206 2.525-6.206 3.927c.22 3.066.877 9.72 1.184 11.231.284 1.402 1.423 1.402 2.036 1.402s3.504.044 4.599 0 1.993 0 2.322-1.402"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.243 18.405c.11-1.25-1.275-3.69-4.924-3.69-1.826 0-3.332.614-4.38 1.395-.524.39-.93.82-1.203 1.23s-.404.786-.406 1.077c.22 3.073.876 9.702 1.18 11.196.128.634.439.925.77 1.071.348.154.741.157 1.053.157.153 0 .443.002.808.006 1.122.01 2.96.027 3.782-.006l.165-.006c.492-.019.887-.033 1.208-.169.325-.137.594-.41.747-1.06.259-1.104.497-3.195.701-5.376.129-1.369.244-2.762.342-3.957.058-.707.11-1.345.157-1.868m-4.924-4.124c3.85 0 5.493 2.61 5.356 4.163-.046.517-.098 1.152-.156 1.858-.099 1.198-.214 2.6-.343 3.969-.204 2.173-.444 4.296-.71 5.434-.177.752-.52 1.158-1.001 1.36-.4.17-.88.186-1.354.203l-.17.006c-.834.034-2.704.017-3.823.006-.358-.003-.639-.006-.785-.006h-.012c-.302 0-.778 0-1.217-.193-.463-.205-.864-.614-1.02-1.382-.31-1.528-.968-8.195-1.187-11.26v-.015c0-.409.176-.871.478-1.325a5.6 5.6 0 0 1 1.305-1.337c1.118-.833 2.715-1.48 4.639-1.48",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M14.437 18.44s.179-1.245.179-5.813c0-4.569-4.602-11.008-5.825-11.008S3 8.18 3 12.627s.118 5.814.118 5.814 1.527-3.993 5.673-3.993 5.646 3.993 5.646 3.993"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M8.965 1.888a.4.4 0 0 0-.174-.052.4.4 0 0 0-.171.052q-.125.06-.296.193c-.227.176-.495.439-.79.775-.59.673-1.268 1.62-1.91 2.71-1.29 2.186-2.407 4.897-2.407 7.061a142 142 0 0 0 .074 4.981c.213-.37.525-.84.948-1.309.928-1.029 2.401-2.068 4.552-2.068 2.152 0 3.618 1.04 4.54 2.069.43.482.745.964.956 1.34l.023-.404c.044-.878.089-2.327.089-4.609 0-2.225-1.126-4.936-2.423-7.106-.646-1.081-1.328-2.017-1.92-2.68a6 6 0 0 0-.795-.764 1.8 1.8 0 0 0-.296-.19m5.269 16.63v-.002l-.003-.007a2 2 0 0 0-.064-.15 7.243 7.243 0 0 0-1.16-1.77c-.865-.966-2.222-1.924-4.216-1.924s-3.358.958-4.23 1.925a7.3 7.3 0 0 0-1.172 1.77l-.065.15-.003.007v.002m-.203-.078-.216.019a.217.217 0 0 0 .418.059m-.202-.078-.216.019v-.005L2.9 18.44a7 7 0 0 1-.017-.271c-.011-.2-.026-.511-.04-.961-.03-.9-.06-2.357-.06-4.582 0-2.282 1.166-5.076 2.467-7.282.653-1.107 1.346-2.078 1.957-2.775.305-.347.594-.632.851-.832q.194-.151.371-.24a.84.84 0 0 1 .362-.096.85.85 0 0 1 .36.095c.12.056.244.137.373.235.258.196.548.477.855.82.614.687 1.312 1.647 1.97 2.746 1.31 2.192 2.484 4.986 2.484 7.329 0 2.287-.045 3.744-.09 4.631a25 25 0 0 1-.083 1.145l-.006.05-.002.014v.004l-.215-.03.215.03a.217.217 0 0 1-.418.046",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m14.722 16.51-.197.091c-.197.091-.196.092-.196.092v-.001l-.004-.006a2 2 0 0 0-.064-.123 5 5 0 0 0-.223-.361 6.3 6.3 0 0 0-.953-1.106c-.873-.803-2.246-1.608-4.255-1.608s-3.417.806-4.324 1.61a6.7 6.7 0 0 0-1 1.109 5 5 0 0 0-.306.485l-.003.006-.194-.097-.194-.098v-.001l.002-.003.005-.008.016-.031q.022-.04.065-.113c.056-.096.142-.23.257-.392a7 7 0 0 1 1.064-1.181c.97-.86 2.476-1.72 4.612-1.72s3.611.86 4.549 1.723a6.7 6.7 0 0 1 1.02 1.183 5 5 0 0 1 .301.505l.016.032.004.009.001.002z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M10.974 36.666c.06 0 .108.048.108.108v4.564c0 .06-.048.109-.108.109H6.376a.11.11 0 0 1-.109-.109v-4.564c0-.06.049-.108.109-.108z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M10.649 37.1H6.7v3.913h3.948zm.433-.326a.11.11 0 0 0-.108-.108H6.376a.11.11 0 0 0-.109.108v4.564c0 .06.049.109.109.109h4.598c.06 0 .108-.049.108-.109z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M8.3 30.232a.99.99 0 0 1 1.4 0l7.515 7.514a.99.99 0 0 1 0 1.401L9.7 46.661a.99.99 0 0 1-1.401 0L.786 39.147a.99.99 0 0 1 0-1.4z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#9DA9B6",
          fillRule: "evenodd",
          d: "M7.95 29.882c.58-.58 1.52-.58 2.1 0l7.515 7.514c.58.58.58 1.521 0 2.101l-7.514 7.515c-.58.58-1.521.58-2.101 0L.435 39.497a1.486 1.486 0 0 1 0-2.1zm1.4.7a.495.495 0 0 0-.7 0l-7.514 7.515a.495.495 0 0 0 0 .7l7.514 7.514a.495.495 0 0 0 .7 0l7.515-7.514a.495.495 0 0 0 0-.7z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          d: "M12.137 34.808a.386.386 0 0 0-.659-.274l-2.542 2.543 3.201 3.2zm.17 6.73-6.095-6.095a.383.383 0 1 0-.543.543l2.18 2.18-2.758 2.759a.385.385 0 0 0 .27.659h5.902l.497.497c.15.15.393.15.543 0a.38.38 0 0 0 .004-.544"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M4.048 33.494h9.245v9.245H4.048z" }) }) })
    ]
  }
);
const VehicleSBoatOff = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-boat-off",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M11.905 39.469c3.437-9.9 3.878-20.809 3.878-26.635S10.33.217 8.773.217 1.602 7.489 1.833 12.834c.23 5.344.536 16.681 3.568 26.635.463 1.522 1.686 1.27 3.374 1.27 1.335 0 2.58.316 3.131-1.27"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M9.402.7c-.29-.191-.5-.266-.628-.266-.124 0-.335.079-.631.284a7 7 0 0 0-.987.87c-.73.752-1.562 1.816-2.34 3.049-1.562 2.474-2.88 5.582-2.768 8.187l.042.994c.234 5.67.671 16.243 3.517 25.588.107.353.254.586.425.744s.382.256.642.313c.264.059.57.075.926.075q.256 0 .541-.007h.018q.294-.007.615-.008c.193 0 .396.007.59.013q.205.008.388.011c.309.005.587-.006.835-.06.246-.053.458-.149.64-.312.181-.163.345-.407.473-.777 3.425-9.866 3.866-20.744 3.866-26.564 0-2.854-1.339-5.967-2.886-8.376-.772-1.203-1.59-2.22-2.307-2.936a6.6 6.6 0 0 0-.97-.821m3.643 3.523C14.613 6.665 16 9.861 16 12.833c0 5.834-.441 16.771-3.89 26.707-.147.423-.345.735-.594.958a1.8 1.8 0 0 1-.836.413 4 4 0 0 1-.934.07q-.212-.004-.414-.012c-.183-.006-.364-.013-.558-.013q-.313.001-.606.008h-.02a27 27 0 0 1-.548.008c-.363 0-.708-.016-1.02-.085a1.77 1.77 0 0 1-.842-.418c-.241-.223-.422-.529-.546-.937-2.863-9.4-3.301-20.024-3.535-25.69l-.042-.999c-.118-2.74 1.257-5.94 2.834-8.438.791-1.253 1.641-2.341 2.395-3.12A7.4 7.4 0 0 1 7.896.363C8.204.148 8.509 0 8.774 0c.261 0 .562.137.868.34.314.207.665.505 1.037.875.743.74 1.58 1.785 2.366 3.008",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M13.254 29.656c.525-2.243.956-8.427 1.204-11.231.124-1.402-1.39-3.927-5.14-3.927s-6.205 2.525-6.205 3.927c.22 3.066.877 9.72 1.184 11.231.284 1.402 1.422 1.402 2.036 1.402.613 0 3.504.044 4.599 0s1.993 0 2.322-1.402"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.242 18.405c.111-1.25-1.275-3.69-4.923-3.69-1.826 0-3.332.614-4.38 1.395-.524.39-.93.82-1.203 1.23s-.404.786-.406 1.077c.22 3.073.876 9.702 1.18 11.196.128.634.439.925.77 1.071.348.154.74.157 1.053.157.153 0 .442.002.808.006 1.122.01 2.96.027 3.782-.006l.165-.006c.492-.019.886-.033 1.208-.169.324-.137.594-.41.747-1.06.258-1.104.496-3.195.701-5.376.129-1.369.243-2.762.341-3.957.059-.707.111-1.345.157-1.868M9.32 14.281c3.85 0 5.493 2.61 5.355 4.163-.045.517-.098 1.152-.156 1.858-.098 1.198-.213 2.6-.342 3.969-.204 2.173-.444 4.296-.711 5.434-.176.752-.52 1.158-1 1.36-.4.17-.881.186-1.354.203l-.17.006c-.835.034-2.704.017-3.823.006-.358-.003-.639-.006-.785-.006H6.32c-.302 0-.778 0-1.217-.193-.463-.205-.864-.614-1.02-1.382-.31-1.528-.968-8.195-1.187-11.26v-.015c0-.409.176-.871.478-1.325a5.6 5.6 0 0 1 1.305-1.337c1.118-.833 2.714-1.48 4.639-1.48",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M14.437 18.44s.179-1.245.179-5.813c0-4.569-4.602-11.008-5.825-11.008S2.999 8.18 2.999 12.627s.119 5.814.119 5.814 1.527-3.993 5.673-3.993c4.145 0 5.646 3.993 5.646 3.993"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M8.964 1.888a.4.4 0 0 0-.173-.052.4.4 0 0 0-.171.052q-.126.06-.296.193c-.227.176-.496.439-.79.775-.59.673-1.268 1.62-1.91 2.71-1.29 2.186-2.408 4.897-2.408 7.061a142 142 0 0 0 .074 4.981c.214-.37.526-.84.949-1.309.928-1.029 2.4-2.068 4.552-2.068s3.617 1.04 4.539 2.069c.432.482.745.964.957 1.34l.023-.404c.044-.878.089-2.327.089-4.609 0-2.225-1.126-4.936-2.423-7.106-.646-1.081-1.328-2.017-1.92-2.68a6 6 0 0 0-.795-.764 1.8 1.8 0 0 0-.297-.19m5.27 16.63v-.002l-.004-.007-.012-.03-.052-.12a7.24 7.24 0 0 0-1.16-1.77c-.864-.966-2.22-1.924-4.215-1.924s-3.358.958-4.23 1.925a7.3 7.3 0 0 0-1.172 1.77l-.065.15-.003.007v.002m-.203-.078-.216.019a.217.217 0 0 0 .418.059m-.202-.078-.216.019v-.005L2.9 18.44a7 7 0 0 1-.017-.271c-.012-.2-.026-.511-.041-.961-.03-.9-.06-2.357-.06-4.582 0-2.282 1.167-5.076 2.468-7.282.652-1.107 1.346-2.078 1.957-2.775.305-.347.594-.632.85-.832q.195-.151.372-.24a.84.84 0 0 1 .362-.096.85.85 0 0 1 .36.095c.119.056.244.137.373.235.258.196.548.477.855.82.614.687 1.312 1.647 1.97 2.746 1.309 2.192 2.483 4.986 2.483 7.329 0 2.287-.044 3.744-.09 4.631a25 25 0 0 1-.082 1.145l-.006.05-.002.014v.004l-.215-.03.214.03a.217.217 0 0 1-.417.046",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.721 16.51a19 19 0 0 1-.393.183v-.001l-.003-.006-.012-.024-.052-.099a5 5 0 0 0-.223-.361 6.3 6.3 0 0 0-.953-1.106c-.873-.803-2.247-1.608-4.255-1.608-2.01 0-3.417.806-4.325 1.61a6.7 6.7 0 0 0-.998 1.109 5 5 0 0 0-.308.485l-.002.006h-.001l-.194-.097-.193-.098v-.001l.002-.003.004-.008a2 2 0 0 1 .081-.144c.057-.096.142-.23.257-.392a7 7 0 0 1 1.065-1.181c.97-.86 2.475-1.72 4.612-1.72s3.611.86 4.549 1.723c.468.43.802.86 1.019 1.183a5 5 0 0 1 .317.537l.005.009v.002h.001z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M10.974 36.666c.06 0 .108.048.108.108v4.564c0 .06-.049.109-.108.109H6.376a.11.11 0 0 1-.109-.109v-4.564c0-.06.049-.108.109-.108z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M10.648 37.1H6.701v3.913h3.947zm.434-.326a.11.11 0 0 0-.108-.108H6.376a.11.11 0 0 0-.109.108v4.564c0 .06.049.109.109.109h4.598c.06 0 .108-.049.108-.109z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M9 46.973a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M0 38.447a9 9 0 1 1 18.001.001A9 9 0 0 1 0 38.447m9-8.053a8.053 8.053 0 1 0 .002 16.107A8.053 8.053 0 0 0 9 30.394",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M5.472 38.447a3.528 3.528 0 1 0 7.056 0 3.528 3.528 0 0 0-7.056 0m-.893 0a4.421 4.421 0 1 0 8.842 0 4.421 4.421 0 0 0-8.842 0m2.615-.3a.55.55 0 0 0-.11.35q0 .207.11.35a.33.33 0 0 0 .273.14h3.066q.162 0 .273-.14a.55.55 0 0 0 .11-.35.55.55 0 0 0-.11-.35.33.33 0 0 0-.273-.142H7.467q-.163 0-.273.141",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSBoatOn = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-boat-on",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M11.905 39.469c3.437-9.9 3.878-20.809 3.878-26.635S10.33.217 8.773.217 1.602 7.489 1.833 12.834c.23 5.344.536 16.681 3.568 26.635.463 1.522 1.686 1.27 3.374 1.27 1.335 0 2.58.316 3.131-1.27"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M9.402.7c-.29-.191-.5-.266-.628-.266-.124 0-.335.079-.631.284a7 7 0 0 0-.987.87c-.73.752-1.562 1.816-2.34 3.049-1.562 2.474-2.88 5.582-2.768 8.187l.042.994c.234 5.67.671 16.243 3.517 25.588.107.353.254.586.425.744s.382.256.642.313c.264.059.57.075.926.075q.256 0 .541-.007h.018q.294-.007.615-.008c.193 0 .396.007.59.013q.205.008.388.011c.309.005.587-.006.835-.06.246-.053.458-.149.64-.312.181-.163.345-.407.473-.777 3.425-9.866 3.866-20.744 3.866-26.564 0-2.854-1.339-5.967-2.886-8.376-.772-1.203-1.59-2.22-2.307-2.936a6.6 6.6 0 0 0-.97-.821m3.643 3.523C14.613 6.665 16 9.861 16 12.833c0 5.834-.441 16.771-3.89 26.707-.147.423-.345.735-.594.958a1.8 1.8 0 0 1-.836.413 4 4 0 0 1-.934.07q-.212-.004-.414-.012c-.183-.006-.364-.013-.558-.013q-.313.001-.606.008h-.02a27 27 0 0 1-.548.008c-.363 0-.708-.016-1.02-.085a1.77 1.77 0 0 1-.842-.418c-.241-.223-.422-.529-.546-.937-2.863-9.4-3.301-20.024-3.535-25.69l-.042-.999c-.118-2.74 1.257-5.94 2.834-8.438.791-1.253 1.641-2.341 2.395-3.12A7.4 7.4 0 0 1 7.896.363C8.204.148 8.509 0 8.774 0c.261 0 .562.137.868.34.314.207.665.505 1.037.875.743.74 1.58 1.785 2.366 3.008",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M13.254 29.656c.525-2.243.956-8.427 1.204-11.231.124-1.402-1.39-3.927-5.14-3.927s-6.205 2.525-6.205 3.927c.22 3.066.877 9.72 1.184 11.231.284 1.402 1.422 1.402 2.036 1.402.613 0 3.504.044 4.599 0s1.993 0 2.322-1.402"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.242 18.405c.111-1.25-1.275-3.69-4.923-3.69-1.826 0-3.332.614-4.38 1.395-.524.39-.93.82-1.203 1.23s-.404.786-.406 1.077c.22 3.073.876 9.702 1.18 11.196.128.634.439.925.77 1.071.348.154.74.157 1.053.157.153 0 .442.002.808.006 1.122.01 2.96.027 3.782-.006l.165-.006c.492-.019.886-.033 1.208-.169.324-.137.594-.41.747-1.06.258-1.104.496-3.195.701-5.376.129-1.369.243-2.762.341-3.957.059-.707.111-1.345.157-1.868M9.32 14.281c3.85 0 5.493 2.61 5.355 4.163-.045.517-.098 1.152-.156 1.858-.098 1.198-.213 2.6-.342 3.969-.204 2.173-.444 4.296-.711 5.434-.176.752-.52 1.158-1 1.36-.4.17-.881.186-1.354.203l-.17.006c-.835.034-2.704.017-3.823.006-.358-.003-.639-.006-.785-.006H6.32c-.302 0-.778 0-1.217-.193-.463-.205-.864-.614-1.02-1.382-.31-1.528-.968-8.195-1.187-11.26v-.015c0-.409.176-.871.478-1.325a5.6 5.6 0 0 1 1.305-1.337c1.118-.833 2.714-1.48 4.639-1.48",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M14.437 18.44s.179-1.245.179-5.813c0-4.569-4.602-11.008-5.825-11.008S2.999 8.18 2.999 12.627s.119 5.814.119 5.814 1.527-3.993 5.673-3.993c4.145 0 5.646 3.993 5.646 3.993"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M8.964 1.888a.4.4 0 0 0-.173-.052.4.4 0 0 0-.171.052q-.126.06-.296.193c-.227.176-.496.439-.79.775-.59.673-1.268 1.62-1.91 2.71-1.29 2.186-2.408 4.897-2.408 7.061a142 142 0 0 0 .074 4.981c.214-.37.526-.84.949-1.309.928-1.029 2.4-2.068 4.552-2.068s3.617 1.04 4.539 2.069c.432.482.745.964.957 1.34l.023-.404c.044-.878.089-2.327.089-4.609 0-2.225-1.126-4.936-2.423-7.106-.646-1.081-1.328-2.017-1.92-2.68a6 6 0 0 0-.795-.764 1.8 1.8 0 0 0-.297-.19m5.27 16.63v-.002l-.004-.007-.012-.03-.052-.12a7.24 7.24 0 0 0-1.16-1.77c-.864-.966-2.22-1.924-4.215-1.924s-3.358.958-4.23 1.925a7.3 7.3 0 0 0-1.172 1.77l-.065.15-.003.007v.002m-.203-.078-.216.019a.217.217 0 0 0 .418.059m-.202-.078-.216.019v-.005L2.9 18.44a7 7 0 0 1-.017-.271c-.012-.2-.026-.511-.041-.961-.03-.9-.06-2.357-.06-4.582 0-2.282 1.167-5.076 2.468-7.282.652-1.107 1.346-2.078 1.957-2.775.305-.347.594-.632.85-.832q.195-.151.372-.24a.84.84 0 0 1 .362-.096.85.85 0 0 1 .36.095c.119.056.244.137.373.235.258.196.548.477.855.82.614.687 1.312 1.647 1.97 2.746 1.309 2.192 2.483 4.986 2.483 7.329 0 2.287-.044 3.744-.09 4.631a25 25 0 0 1-.082 1.145l-.006.05-.002.014v.004l-.215-.03.214.03a.217.217 0 0 1-.417.046",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.721 16.51a19 19 0 0 1-.393.183v-.001l-.003-.006-.012-.024-.052-.099a5 5 0 0 0-.223-.361 6.3 6.3 0 0 0-.953-1.106c-.873-.803-2.247-1.608-4.255-1.608-2.01 0-3.417.806-4.325 1.61a6.7 6.7 0 0 0-.998 1.109 5 5 0 0 0-.308.485l-.002.006h-.001l-.194-.097-.193-.098v-.001l.002-.003.004-.008a2 2 0 0 1 .081-.144c.057-.096.142-.23.257-.392a7 7 0 0 1 1.065-1.181c.97-.86 2.475-1.72 4.612-1.72s3.611.86 4.549 1.723c.468.43.802.86 1.019 1.183a5 5 0 0 1 .317.537l.005.009v.002h.001z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M10.974 36.666c.06 0 .108.048.108.108v4.564c0 .06-.049.109-.108.109H6.376a.11.11 0 0 1-.109-.109v-4.564c0-.06.049-.108.109-.108z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M10.648 37.1H6.701v3.913h3.947zm.434-.326a.11.11 0 0 0-.108-.108H6.376a.11.11 0 0 0-.109.108v4.564c0 .06.049.109.109.109h4.598c.06 0 .108-.049.108-.109z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#03D8A9",
          fillRule: "evenodd",
          d: "M9 46.973a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M0 38.447a9 9 0 1 1 18.001.001A9 9 0 0 1 0 38.447m9-8.053a8.053 8.053 0 1 0 .002 16.107A8.053 8.053 0 0 0 9 30.394",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M9 38.938a.48.48 0 0 1-.35-.142.48.48 0 0 1-.142-.35v-3.93q0-.208.142-.35a.48.48 0 0 1 .35-.14q.209 0 .35.14.14.142.14.35v3.93q0 .21-.14.35a.48.48 0 0 1-.35.142m0 3.93q-.921 0-1.726-.35a4.5 4.5 0 0 1-1.4-.946 4.5 4.5 0 0 1-.945-1.4 4.3 4.3 0 0 1-.35-1.726q0-.847.307-1.62.306-.774.884-1.4a.45.45 0 0 1 .344-.148q.209 0 .356.147a.42.42 0 0 1 .123.338.6.6 0 0 1-.148.362q-.429.48-.657 1.075a3.5 3.5 0 0 0-.227 1.246q0 1.437 1.001 2.438 1 1 2.438 1.001 1.437 0 2.437-1 1.001-1.001 1.001-2.439 0-.65-.233-1.258a3.5 3.5 0 0 0-.663-1.087.52.52 0 0 1-.142-.344.43.43 0 0 1 .13-.332.49.49 0 0 1 .356-.147q.208 0 .344.147.576.627.884 1.4.307.774.307 1.621 0 .921-.35 1.726a4.5 4.5 0 0 1-.946 1.4 4.5 4.5 0 0 1-1.4.945 4.3 4.3 0 0 1-1.725.35"
        }
      )
    ]
  }
);
const VehicleSBoatUnavailable = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-boat-unavailable",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M11.905 39.465c3.437-9.901 3.878-20.81 3.878-26.636S10.33.212 8.773.212 1.602 7.485 1.833 12.83 2.368 29.511 5.4 39.465c.463 1.521 1.686 1.27 3.374 1.27 1.335 0 2.58.316 3.131-1.27"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M9.402.697c-.29-.192-.5-.268-.628-.268-.124 0-.335.08-.631.285a7 7 0 0 0-.987.87c-.73.752-1.562 1.816-2.34 3.048-1.562 2.475-2.88 5.582-2.768 8.188l.042.994c.234 5.67.671 16.243 3.517 25.588.107.353.254.586.425.744s.382.255.642.313c.264.058.57.074.926.075q.256-.001.541-.008h.018q.294-.007.615-.008c.193 0 .396.007.59.014q.205.007.388.01c.309.005.587-.005.835-.06.246-.053.458-.148.64-.311.181-.164.345-.407.473-.777 3.425-9.866 3.866-20.745 3.866-26.565 0-2.854-1.339-5.966-2.886-8.376-.772-1.202-1.59-2.22-2.307-2.935a6.6 6.6 0 0 0-.97-.821m3.643 3.522C14.613 6.66 16 9.857 16 12.829c0 5.833-.441 16.771-3.89 26.707-.147.422-.345.734-.594.957a1.8 1.8 0 0 1-.836.413 4 4 0 0 1-.934.07q-.212-.004-.414-.011c-.183-.007-.364-.013-.558-.013q-.313.001-.606.008h-.02q-.283.007-.548.008c-.363 0-.708-.017-1.02-.086a1.77 1.77 0 0 1-.842-.417c-.241-.223-.422-.53-.546-.937-2.863-9.4-3.301-20.025-3.535-25.69l-.042-1C1.497 10.1 2.872 6.9 4.449 4.402 5.24 3.148 6.09 2.059 6.844 1.28A7.4 7.4 0 0 1 7.896.357c.308-.213.613-.361.878-.361.261 0 .562.137.868.339.314.207.665.506 1.037.876.743.74 1.58 1.784 2.366 3.008",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M13.254 29.652c.525-2.243.956-8.428 1.204-11.231.124-1.402-1.39-3.927-5.14-3.927s-6.205 2.525-6.205 3.927c.22 3.066.877 9.72 1.184 11.23.284 1.403 1.422 1.403 2.036 1.403.613 0 3.504.044 4.599 0s1.993 0 2.322-1.402"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.242 18.4c.111-1.25-1.275-3.69-4.923-3.69-1.826 0-3.332.615-4.38 1.395-.524.39-.93.82-1.203 1.23s-.404.787-.406 1.078c.22 3.073.876 9.701 1.18 11.195.128.635.439.926.77 1.072.348.154.74.156 1.053.156.153 0 .442.003.808.006 1.122.01 2.96.027 3.782-.005l.165-.007c.492-.018.886-.033 1.208-.168.324-.137.594-.41.747-1.06.258-1.104.496-3.196.701-5.376.129-1.369.243-2.762.341-3.957.059-.707.111-1.345.157-1.868M9.32 14.278c3.85 0 5.493 2.609 5.355 4.162-.045.517-.098 1.153-.156 1.858-.098 1.199-.213 2.6-.342 3.97-.204 2.173-.444 4.295-.711 5.434-.176.752-.52 1.158-1 1.36-.4.17-.881.186-1.354.203l-.17.006c-.835.033-2.704.016-3.823.006-.358-.003-.639-.006-.785-.006H6.32c-.302 0-.778 0-1.217-.194-.463-.204-.864-.614-1.02-1.381-.31-1.528-.968-8.196-1.187-11.26v-.015c0-.409.176-.872.478-1.325a5.6 5.6 0 0 1 1.305-1.338c1.118-.832 2.714-1.48 4.639-1.48",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M14.437 18.437s.179-1.246.179-5.814c0-4.569-4.602-11.009-5.825-11.009S2.999 8.176 2.999 12.623c0 4.446.119 5.814.119 5.814s1.527-3.993 5.673-3.993c4.145 0 5.646 3.993 5.646 3.993"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M8.964 1.883a.4.4 0 0 0-.173-.052.4.4 0 0 0-.171.053q-.126.06-.296.192c-.227.177-.496.44-.79.776-.59.672-1.268 1.62-1.91 2.71-1.29 2.186-2.408 4.896-2.408 7.06a142 142 0 0 0 .074 4.982c.214-.371.526-.84.949-1.309.928-1.03 2.4-2.068 4.552-2.068s3.617 1.039 4.539 2.069c.432.482.745.963.957 1.34l.023-.404c.044-.878.089-2.328.089-4.61 0-2.224-1.126-4.935-2.423-7.105-.646-1.082-1.328-2.018-1.92-2.68a6 6 0 0 0-.795-.765 1.8 1.8 0 0 0-.297-.189m5.27 16.63v-.002l-.004-.007-.012-.03-.052-.12a7.24 7.24 0 0 0-1.16-1.77c-.864-.966-2.22-1.923-4.215-1.923s-3.358.958-4.23 1.925a7.3 7.3 0 0 0-1.172 1.77l-.065.15-.003.007v.001m-.203-.077-.216.018a.217.217 0 0 0 .418.06m-.202-.078-.216.018v-.005l-.002-.013a8 8 0 0 1-.017-.271c-.012-.2-.026-.512-.041-.962-.03-.9-.06-2.356-.06-4.581 0-2.283 1.167-5.076 2.468-7.282.652-1.107 1.346-2.078 1.957-2.775a6.5 6.5 0 0 1 .85-.832q.195-.151.372-.24a.84.84 0 0 1 .362-.097.85.85 0 0 1 .36.095q.179.087.373.235c.258.197.548.477.855.82.614.688 1.312 1.647 1.97 2.747 1.309 2.192 2.483 4.985 2.483 7.329 0 2.287-.044 3.744-.09 4.63a25 25 0 0 1-.082 1.146l-.006.05-.002.013v.005l-.215-.03.214.03a.217.217 0 0 1-.417.046",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.721 16.505a19 19 0 0 1-.393.183l-.003-.006-.012-.025-.052-.098a5 5 0 0 0-.223-.362 6.3 6.3 0 0 0-.953-1.105c-.873-.803-2.247-1.608-4.255-1.608-2.01 0-3.417.805-4.325 1.61a6.7 6.7 0 0 0-.998 1.108 5 5 0 0 0-.308.486l-.002.006h-.001l-.194-.097-.193-.098v-.002l.002-.002.004-.009a3 3 0 0 1 .081-.143c.057-.096.142-.231.257-.393a7 7 0 0 1 1.065-1.18c.97-.86 2.475-1.72 4.612-1.72s3.611.86 4.549 1.722c.468.43.802.86 1.019 1.183a5 5 0 0 1 .317.537l.005.01v.002z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M10.974 36.661c.06 0 .108.049.108.109v4.564c0 .06-.049.108-.108.108H6.376a.11.11 0 0 1-.109-.108V36.77c0-.06.049-.109.109-.109z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M10.648 37.095H6.701v3.914h3.947zm.434-.325a.11.11 0 0 0-.108-.109H6.376a.11.11 0 0 0-.109.109v4.564c0 .06.049.108.109.108h4.598c.06 0 .108-.048.108-.108z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          d: "M1.536 31.474h14.928c.78 0 1.273.837.894 1.519L9.894 46.406c-.39.7-1.398.7-1.788 0L.643 32.993c-.38-.682.113-1.52.893-1.52"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M10.34 46.654a1.534 1.534 0 0 1-2.68 0L.196 33.241a1.533 1.533 0 0 1 1.34-2.279h14.928c1.17 0 1.91 1.257 1.34 2.28zm-1.787-.497c.195.35.699.35.894 0l7.464-13.413a.51.51 0 0 0-.447-.76H1.536a.51.51 0 0 0-.447.76z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M9 41.978a.76.76 0 0 1-.569-.246.82.82 0 0 1-.236-.59q0-.343.236-.589a.76.76 0 0 1 .57-.245q.33 0 .568.245.236.245.236.59a.82.82 0 0 1-.236.59.76.76 0 0 1-.569.245m0-2.505a.76.76 0 0 1-.569-.245.82.82 0 0 1-.236-.59v-3.34a.82.82 0 0 1 .236-.59.76.76 0 0 1 .57-.245q.33 0 .568.246a.82.82 0 0 1 .236.59v3.339q0 .344-.236.59a.76.76 0 0 1-.569.245"
        }
      )
    ]
  }
);
const VehicleSBoatUnplugged = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-boat-unplugged",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M11.905 39.465c3.437-9.901 3.878-20.81 3.878-26.636S10.33.212 8.773.212 1.602 7.485 1.833 12.83 2.368 29.511 5.4 39.465c.463 1.521 1.686 1.27 3.374 1.27 1.335 0 2.58.316 3.131-1.27"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M9.402.697c-.29-.192-.5-.268-.628-.268-.124 0-.335.08-.631.285a7 7 0 0 0-.987.87c-.73.752-1.562 1.816-2.34 3.048-1.562 2.475-2.88 5.582-2.768 8.188l.042.994c.234 5.67.671 16.243 3.517 25.588.107.353.254.586.425.744s.382.255.642.313c.264.058.57.074.926.075q.256-.001.541-.008h.018q.294-.007.615-.008c.193 0 .396.007.59.014q.205.007.388.01c.309.005.587-.005.835-.06.246-.053.458-.148.64-.311.181-.164.345-.407.473-.777 3.425-9.866 3.866-20.745 3.866-26.565 0-2.854-1.339-5.966-2.886-8.376-.772-1.202-1.59-2.22-2.307-2.935a6.6 6.6 0 0 0-.97-.821m3.643 3.522C14.613 6.66 16 9.857 16 12.829c0 5.833-.441 16.771-3.89 26.707-.147.422-.345.734-.594.957a1.8 1.8 0 0 1-.836.413 4 4 0 0 1-.934.07q-.212-.004-.414-.011c-.183-.007-.364-.013-.558-.013q-.313.001-.606.008h-.02q-.283.007-.548.008c-.363 0-.708-.017-1.02-.086a1.77 1.77 0 0 1-.842-.417c-.241-.223-.422-.53-.546-.937-2.863-9.4-3.301-20.025-3.535-25.69l-.042-1C1.497 10.1 2.872 6.9 4.449 4.402 5.24 3.148 6.09 2.059 6.844 1.28A7.4 7.4 0 0 1 7.896.357c.308-.213.613-.361.878-.361.261 0 .562.137.868.339.314.207.665.506 1.037.876.743.74 1.58 1.784 2.366 3.008",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M13.254 29.652c.525-2.243.956-8.428 1.204-11.231.124-1.402-1.39-3.927-5.14-3.927s-6.205 2.525-6.205 3.927c.22 3.066.877 9.72 1.184 11.23.284 1.403 1.422 1.403 2.036 1.403.613 0 3.504.044 4.599 0s1.993 0 2.322-1.402"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.242 18.4c.111-1.25-1.275-3.69-4.923-3.69-1.826 0-3.332.615-4.38 1.395-.524.39-.93.82-1.203 1.23s-.404.787-.406 1.078c.22 3.073.876 9.701 1.18 11.195.128.635.439.926.77 1.072.348.154.74.156 1.053.156.153 0 .442.003.808.006 1.122.01 2.96.027 3.782-.005l.165-.007c.492-.018.886-.033 1.208-.168.324-.137.594-.41.747-1.06.258-1.104.496-3.196.701-5.376.129-1.369.243-2.762.341-3.957.059-.707.111-1.345.157-1.868M9.32 14.278c3.85 0 5.493 2.609 5.355 4.162-.045.517-.098 1.153-.156 1.858-.098 1.199-.213 2.6-.342 3.97-.204 2.173-.444 4.295-.711 5.434-.176.752-.52 1.158-1 1.36-.4.17-.881.186-1.354.203l-.17.006c-.835.033-2.704.016-3.823.006-.358-.003-.639-.006-.785-.006H6.32c-.302 0-.778 0-1.217-.194-.463-.204-.864-.614-1.02-1.381-.31-1.528-.968-8.196-1.187-11.26v-.015c0-.409.176-.872.478-1.325a5.6 5.6 0 0 1 1.305-1.338c1.118-.832 2.714-1.48 4.639-1.48",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M14.437 18.437s.179-1.246.179-5.814c0-4.569-4.602-11.009-5.825-11.009S2.999 8.176 2.999 12.623c0 4.446.119 5.814.119 5.814s1.527-3.993 5.673-3.993c4.145 0 5.646 3.993 5.646 3.993"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M8.964 1.883a.4.4 0 0 0-.173-.052.4.4 0 0 0-.171.053q-.126.06-.296.192c-.227.177-.496.44-.79.776-.59.672-1.268 1.62-1.91 2.71-1.29 2.186-2.408 4.896-2.408 7.06a142 142 0 0 0 .074 4.982c.214-.371.526-.84.949-1.309.928-1.03 2.4-2.068 4.552-2.068s3.617 1.039 4.539 2.069c.432.482.745.963.957 1.34l.023-.404c.044-.878.089-2.328.089-4.61 0-2.224-1.126-4.935-2.423-7.105-.646-1.082-1.328-2.018-1.92-2.68a6 6 0 0 0-.795-.765 1.8 1.8 0 0 0-.297-.189m5.27 16.63v-.002l-.004-.007-.012-.03-.052-.12a7.24 7.24 0 0 0-1.16-1.77c-.864-.966-2.22-1.923-4.215-1.923s-3.358.958-4.23 1.925a7.3 7.3 0 0 0-1.172 1.77l-.065.15-.003.007v.001m-.203-.077-.216.018a.217.217 0 0 0 .418.06m-.202-.078-.216.018v-.005l-.002-.013a8 8 0 0 1-.017-.271c-.012-.2-.026-.512-.041-.962-.03-.9-.06-2.356-.06-4.581 0-2.283 1.167-5.076 2.468-7.282.652-1.107 1.346-2.078 1.957-2.775a6.5 6.5 0 0 1 .85-.832q.195-.151.372-.24a.84.84 0 0 1 .362-.097.85.85 0 0 1 .36.095q.179.087.373.235c.258.197.548.477.855.82.614.688 1.312 1.647 1.97 2.747 1.309 2.192 2.483 4.985 2.483 7.329 0 2.287-.044 3.744-.09 4.63a25 25 0 0 1-.082 1.146l-.006.05-.002.013v.005l-.215-.03.214.03a.217.217 0 0 1-.417.046",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.721 16.505a19 19 0 0 1-.393.183l-.003-.006-.012-.025-.052-.098a5 5 0 0 0-.223-.362 6.3 6.3 0 0 0-.953-1.105c-.873-.803-2.247-1.608-4.255-1.608-2.01 0-3.417.805-4.325 1.61a6.7 6.7 0 0 0-.998 1.108 5 5 0 0 0-.308.486l-.002.006h-.001l-.194-.097-.193-.098v-.002l.002-.002.004-.009a3 3 0 0 1 .081-.143c.057-.096.142-.231.257-.393a7 7 0 0 1 1.065-1.18c.97-.86 2.475-1.72 4.612-1.72s3.611.86 4.549 1.722c.468.43.802.86 1.019 1.183a5 5 0 0 1 .317.537l.005.01v.002z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M10.974 36.661c.06 0 .108.049.108.109v4.564c0 .06-.049.108-.108.108H6.376a.11.11 0 0 1-.109-.108V36.77c0-.06.049-.109.109-.109z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M10.648 37.095H6.701v3.914h3.947zm.434-.325a.11.11 0 0 0-.108-.109H6.376a.11.11 0 0 0-.109.109v4.564c0 .06.049.108.109.108h4.598c.06 0 .108-.048.108-.108z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          d: "M1.536 31.458h14.928c.78 0 1.273.84.894 1.521L9.894 46.405a1.022 1.022 0 0 1-1.788 0L.643 32.979c-.38-.682.113-1.52.893-1.52"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M10.34 46.653a1.533 1.533 0 0 1-2.68 0L.196 33.228a1.535 1.535 0 0 1 1.34-2.282h14.928c1.17 0 1.91 1.258 1.34 2.281zm-1.787-.497c.195.35.699.35.894 0L16.91 32.73a.512.512 0 0 0-.447-.76H1.536c-.39 0-.636.419-.447.76z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M10.502 34.75c0-.164-.128-.299-.285-.299a.29.29 0 0 0-.285.3v1.962H8.067V34.75c0-.165-.127-.3-.284-.3a.293.293 0 0 0-.285.3v1.962h-.645v1.203c.003 1.071.72 1.991 1.717 2.205v1.851h.86v-1.851c.996-.214 1.714-1.134 1.717-2.205V36.71h-.645z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M4.705 33.914h8.59v8.596h-8.59z" }) }) })
    ]
  }
);
const VehicleSBoat = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-boat",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 15 42",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M10.298 39.469c3.436-9.9 3.877-20.809 3.877-26.635S8.724.217 7.166.217C5.61.217-.007 7.489.224 12.834c.23 5.344.537 16.681 3.568 26.635.463 1.522 1.687 1.27 3.374 1.27 1.335 0 2.581.316 3.131-1.27"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M7.795.7C7.505.51 7.294.435 7.166.435c-.124 0-.335.079-.631.284a7 7 0 0 0-.987.87c-.73.752-1.561 1.816-2.34 3.049C1.646 7.11.328 10.219.441 12.824l.041.994c.235 5.67.672 16.243 3.517 25.588.108.353.254.586.425.744s.382.256.643.313c.263.059.57.075.925.075q.258 0 .541-.007h.018q.295-.007.615-.008c.194 0 .396.007.59.013q.206.008.389.011c.308.005.586-.006.835-.06.245-.053.457-.149.639-.312s.345-.407.473-.777c3.425-9.866 3.867-20.744 3.867-26.564 0-2.854-1.34-5.967-2.887-8.376-.772-1.203-1.59-2.22-2.307-2.936a6.6 6.6 0 0 0-.97-.821m3.642 3.523c1.568 2.442 2.955 5.638 2.955 8.61 0 5.834-.441 16.771-3.89 26.707-.146.423-.345.735-.593.958a1.8 1.8 0 0 1-.837.413 4 4 0 0 1-.934.07q-.212-.004-.414-.012c-.182-.006-.364-.013-.558-.013q-.312.001-.606.008h-.02q-.283.007-.548.008c-.363 0-.708-.016-1.019-.085a1.77 1.77 0 0 1-.843-.418c-.24-.223-.421-.529-.546-.937C.722 30.132.283 19.508.05 13.842l-.042-.999c-.118-2.74 1.257-5.94 2.834-8.438.792-1.253 1.641-2.341 2.396-3.12A7.4 7.4 0 0 1 6.288.363C6.596.148 6.901 0 7.166 0c.261 0 .562.137.868.34.314.207.666.505 1.037.875.743.74 1.58 1.785 2.366 3.008",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.646 29.656c.526-2.243.956-8.427 1.205-11.231.124-1.402-1.39-3.927-5.14-3.927s-6.206 2.525-6.206 3.927c.22 3.066.877 9.72 1.184 11.231.285 1.402 1.423 1.402 2.036 1.402s3.504.044 4.6 0c1.094-.044 1.992 0 2.32-1.402"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M12.635 18.405c.11-1.25-1.275-3.69-4.924-3.69-1.826 0-3.332.614-4.38 1.395-.524.39-.93.82-1.203 1.23s-.404.786-.406 1.077c.22 3.073.877 9.702 1.18 11.196.128.634.44.925.77 1.071.348.154.741.157 1.053.157.153 0 .443.002.808.006 1.122.01 2.96.027 3.782-.006l.165-.006c.492-.019.887-.033 1.208-.169.325-.137.595-.41.747-1.06.259-1.104.497-3.195.701-5.376.129-1.369.244-2.762.342-3.957.058-.707.11-1.345.157-1.868M7.71 14.281c3.851 0 5.493 2.61 5.356 4.163-.046.517-.098 1.152-.156 1.858-.099 1.198-.214 2.6-.343 3.969-.204 2.173-.444 4.296-.71 5.434-.177.752-.52 1.158-1.001 1.36-.4.17-.88.186-1.353.203l-.171.006c-.834.034-2.703.017-3.823.006-.357-.003-.639-.006-.785-.006h-.012c-.302 0-.778 0-1.217-.193-.463-.205-.864-.614-1.02-1.382-.31-1.528-.968-8.195-1.187-11.26v-.015c0-.409.176-.871.478-1.325a5.6 5.6 0 0 1 1.305-1.337c1.118-.833 2.715-1.48 4.639-1.48",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M12.829 18.44s.179-1.245.179-5.813c0-4.569-4.602-11.008-5.825-11.008S1.392 8.18 1.392 12.627s.118 5.814.118 5.814 1.527-3.993 5.673-3.993 5.646 3.993 5.646 3.993"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M7.357 1.888a.4.4 0 0 0-.174-.052.4.4 0 0 0-.171.052q-.125.06-.296.193c-.227.176-.495.439-.79.775-.59.673-1.268 1.62-1.91 2.71-1.29 2.186-2.407 4.897-2.407 7.061a142 142 0 0 0 .074 4.981c.213-.37.525-.84.948-1.309.928-1.029 2.401-2.068 4.552-2.068 2.152 0 3.618 1.04 4.54 2.069.43.482.745.964.956 1.34q.011-.178.023-.404c.044-.878.09-2.327.09-4.609 0-2.225-1.127-4.936-2.424-7.106-.646-1.081-1.328-2.017-1.92-2.68a6 6 0 0 0-.795-.764 1.8 1.8 0 0 0-.296-.19m5.269 16.63v-.002l-.003-.007a2 2 0 0 0-.064-.15 7.243 7.243 0 0 0-1.16-1.77c-.865-.966-2.221-1.924-4.216-1.924-1.994 0-3.358.958-4.23 1.925a7.3 7.3 0 0 0-1.172 1.77l-.065.15-.003.007v.002m-.203-.078-.216.019a.217.217 0 0 0 .419.059m-.203-.078-.216.019v-.005l-.002-.014a7 7 0 0 1-.017-.271c-.011-.2-.026-.511-.04-.961-.03-.9-.06-2.357-.06-4.582 0-2.282 1.166-5.076 2.467-7.282C4.295 4.238 4.988 3.267 5.6 2.57c.305-.347.594-.632.851-.832q.193-.151.372-.24a.84.84 0 0 1 .361-.096.85.85 0 0 1 .36.095c.12.056.244.137.373.235.258.196.548.477.855.82.614.687 1.312 1.647 1.97 2.746 1.31 2.192 2.484 4.986 2.484 7.329 0 2.287-.045 3.744-.09 4.631a25 25 0 0 1-.083 1.145l-.006.05-.002.014v.004l-.215-.03.215.03a.217.217 0 0 1-.418.046",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m13.114 16.51-.197.091-.196.092v-.001l-.003-.006a2 2 0 0 0-.065-.123 5 5 0 0 0-.223-.361 6.3 6.3 0 0 0-.952-1.106c-.874-.803-2.247-1.608-4.256-1.608s-3.417.806-4.324 1.61a6.7 6.7 0 0 0-.999 1.109 5 5 0 0 0-.307.485l-.003.006-.194-.097-.194-.098v-.001l.002-.003.005-.008.016-.031q.022-.04.065-.113c.057-.096.142-.23.257-.392a7 7 0 0 1 1.064-1.181c.97-.86 2.476-1.72 4.612-1.72s3.612.86 4.55 1.723c.467.43.8.86 1.018 1.183a5 5 0 0 1 .318.537l.004.009.001.002z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M9.366 36.666c.06 0 .108.048.108.108v4.564c0 .06-.048.109-.108.109H4.768a.11.11 0 0 1-.108-.109v-4.564c0-.06.048-.108.108-.108z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M9.04 37.1H5.094v3.913h3.948zm.434-.326a.11.11 0 0 0-.108-.108H4.768a.11.11 0 0 0-.108.108v4.564c0 .06.048.109.108.109h4.598c.06 0 .108-.049.108-.109z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSCarDisablePending = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-car-disable-pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 46",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M3.183 7.421c-.012.857.072 1.857.066 3.038l-.001.72c-.052.026-.149.086-.266.158-.172.106-.384.239-.55.326-.306.168-.392.38-.427.648-.013.083 0 .122.028.146.041.033.101.023.16.007.038-.01.153-.05.292-.096.234-.077.556-.183.632-.203a.7.7 0 0 0 .13-.045c-.005 7 .064 16.93.165 18.425.157 2.25.689 4.737 1.1 5.218C4.928 36.25 6.793 37 10 37s5.072-.75 5.484-1.237c.416-.481.942-2.967 1.099-5.218.106-1.496.171-11.426.167-18.425a.6.6 0 0 0 .129.045c.082.02.412.13.653.21l.27.09c.062.015.124.024.164-.008Q18 12.43 18 12.37c-.039-.326-.125-.54-.436-.707a10 10 0 0 1-.525-.311 5 5 0 0 0-.291-.174l-.002-.718c0-1.182.079-2.182.073-3.038-.018-1.77-.31-5.633-1.602-6.345C14.547.706 12.124 0 9.997 0c-2.12 0-4.542.707-5.213 1.076-1.3.712-1.583 4.576-1.601 6.345",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "m3.739 11.648.33.254c.377 2.589.671 4.961.713 7.283a7 7 0 0 1-.965-.656 360 360 0 0 1-.078-6.881m9.35 22.982c-.958.215-1.955.314-3.093.314-1.132 0-2.128-.098-3.086-.314-.28-.065-.388-.18-.388-.536v-2.77c0-.37.153-.511.437-.488 1.04.093 1.905.123 3.038.123 1.138 0 2.004-.03 3.043-.124.284-.022.438.117.438.49v2.769c0 .356-.11.471-.39.536m2.448-8.351c.114.244.125.368.101.625-.028.27-.059.514-.1.758-.018.068-.06.282-.119.544-.065.301-.107.314-.125-.012-.03-.708-.06-1.477-.077-2.34 0-.201.047-.214.13-.026zM4.786 28.194c-.012.325-.06.313-.125.013a9.128 9.128 0 0 1-.214-1.303 1 1 0 0 1 .095-.626l.19-.45c.09-.188.137-.175.131.025a81 81 0 0 1-.076 2.34zm-.004-8.311a558 558 0 0 1-.032 5.348l-.394.249-.367.214c-.112-1.77-.19-3.968-.25-6.166.31.138.68.259 1.043.355m10.84 5.585-.371-.238c-.027-1.45-.034-3.179-.034-5.347a7 7 0 0 0 1.044-.355c-.054 2.198-.14 4.396-.253 6.166zm-.405-6.283c.042-2.323.33-4.694.708-7.283l.336-.254a406 406 0 0 1-.079 6.88 7 7 0 0 1-.965.657m.348-10.632c0 .121-.014.273-.034.465-.08.736-.205 1.628-.351 2.664-.094.662-.19 1.347-.285 2.068-.067.496-.266.673-.71.633a36 36 0 0 0-4.188-.253c-1.335 0-2.74.085-4.18.253-.453.04-.651-.138-.711-.633-.095-.711-.19-1.387-.283-2.041a77 77 0 0 1-.354-2.692 5 5 0 0 1-.034-.47c0-.365.123-.441.515-.627 1.44-.676 2.727-1.068 5.047-1.068 2.327 0 3.614.392 5.053 1.069.391.187.515.263.515.632m-.753-6.456c.425.261.55.488.63.815.097.408.123 1.305.123 1.77 0 .077-.038.103-.07.11-.077.02-.177-.047-.225-.1-.154-.165-.613-.562-.887-.8-.1-.087-.172-.152-.199-.174q-.034-.029-.076-.055c-.082-.054-.177-.116-.245-.288-.32-.874-.684-1.539-1.027-1.876-.063-.064-.066-.1-.031-.12.025-.014.064-.011.131.01.871.225 1.468.451 1.876.708m-7.595-.684c0 .022-.018.048-.059.086-.34.337-.703 1-1.021 1.87-.067.177-.162.24-.246.294q-.043.025-.079.055l-.184.16c-.258.226-.741.645-.892.813-.048.054-.151.122-.23.101-.032-.008-.071-.034-.071-.11 0-.63.04-1.42.13-1.77.08-.327.202-.553.62-.815.422-.26 1.02-.486 1.882-.71.065-.019.104-.022.13-.008q.02.012.02.034",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCF0DE",
          fillRule: "evenodd",
          stroke: "#F9D199",
          d: "M10 44.526a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F9D199",
          fillRule: "evenodd",
          d: "M1 36a9 9 0 1 1 18.001.001A9 9 0 0 1 1 36m9-8.053a8.053 8.053 0 1 0 .001 16.107A8.053 8.053 0 0 0 10 27.947",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          fillRule: "evenodd",
          d: "M12.924 34.342h-.474v-.947a2.37 2.37 0 0 0-4.737 0v.947h-.474a.95.95 0 0 0-.947.947v4.737a.95.95 0 0 0 .947.948h5.685a.95.95 0 0 0 .947-.948V35.29a.95.95 0 0 0-.947-.947m-2.842 4.263a.95.95 0 0 1-.948-.947.95.95 0 0 1 .947-.947.95.95 0 0 1 .948.947.95.95 0 0 1-.947.947m1.468-4.263H8.613v-.947a1.47 1.47 0 0 1 2.937 0z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSCarDisabled = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-car-disabled",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 46",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M3.183 7.421c-.012.857.072 1.857.066 3.038l-.001.72c-.052.026-.149.086-.266.158-.172.106-.384.239-.55.326-.306.168-.392.38-.427.648-.013.083 0 .122.028.146.041.033.101.023.16.007.038-.01.153-.05.292-.096.234-.077.556-.183.632-.203a.7.7 0 0 0 .13-.045c-.005 7 .064 16.93.165 18.425.157 2.25.689 4.737 1.1 5.218C4.928 36.25 6.793 37 10 37s5.072-.75 5.484-1.237c.416-.481.942-2.967 1.099-5.218.106-1.496.171-11.426.167-18.425a.6.6 0 0 0 .129.045c.082.02.412.13.653.21l.27.09c.062.015.124.024.164-.008Q18 12.43 18 12.37c-.039-.326-.125-.54-.436-.707a10 10 0 0 1-.525-.311 5 5 0 0 0-.291-.174l-.002-.718c0-1.182.079-2.182.073-3.038-.018-1.77-.31-5.633-1.602-6.345C14.547.706 12.124 0 9.997 0c-2.12 0-4.542.707-5.213 1.076-1.3.712-1.583 4.576-1.601 6.345",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "m3.739 11.648.33.254c.377 2.589.671 4.961.713 7.283a7 7 0 0 1-.965-.656 360 360 0 0 1-.078-6.881m9.35 22.982c-.958.215-1.955.314-3.093.314-1.132 0-2.128-.098-3.086-.314-.28-.065-.388-.18-.388-.536v-2.77c0-.37.153-.511.437-.488 1.04.093 1.905.123 3.038.123 1.138 0 2.004-.03 3.043-.124.284-.022.438.117.438.49v2.769c0 .356-.11.471-.39.536m2.448-8.351c.114.244.125.368.101.625-.028.27-.059.514-.1.758-.018.068-.06.282-.119.544-.065.301-.107.314-.125-.012-.03-.708-.06-1.477-.077-2.34 0-.201.047-.214.13-.026zM4.786 28.194c-.012.325-.06.313-.125.013a9.128 9.128 0 0 1-.214-1.303 1 1 0 0 1 .095-.626l.19-.45c.09-.188.137-.175.131.025a81 81 0 0 1-.076 2.34zm-.004-8.311a558 558 0 0 1-.032 5.348l-.394.249-.367.214c-.112-1.77-.19-3.968-.25-6.166.31.138.68.259 1.043.355m10.84 5.585-.371-.238c-.027-1.45-.034-3.179-.034-5.347a7 7 0 0 0 1.044-.355c-.054 2.198-.14 4.396-.253 6.166zm-.405-6.283c.042-2.323.33-4.694.708-7.283l.336-.254a406 406 0 0 1-.079 6.88 7 7 0 0 1-.965.657m.348-10.632c0 .121-.014.273-.034.465-.08.736-.205 1.628-.351 2.664-.094.662-.19 1.347-.285 2.068-.067.496-.266.673-.71.633a36 36 0 0 0-4.188-.253c-1.335 0-2.74.085-4.18.253-.453.04-.651-.138-.711-.633-.095-.711-.19-1.387-.283-2.041a77 77 0 0 1-.354-2.692 5 5 0 0 1-.034-.47c0-.365.123-.441.515-.627 1.44-.676 2.727-1.068 5.047-1.068 2.327 0 3.614.392 5.053 1.069.391.187.515.263.515.632m-.753-6.456c.425.261.55.488.63.815.097.408.123 1.305.123 1.77 0 .077-.038.103-.07.11-.077.02-.177-.047-.225-.1-.154-.165-.613-.562-.887-.8-.1-.087-.172-.152-.199-.174q-.034-.029-.076-.055c-.082-.054-.177-.116-.245-.288-.32-.874-.684-1.539-1.027-1.876-.063-.064-.066-.1-.031-.12.025-.014.064-.011.131.01.871.225 1.468.451 1.876.708m-7.595-.684c0 .022-.018.048-.059.086-.34.337-.703 1-1.021 1.87-.067.177-.162.24-.246.294q-.043.025-.079.055l-.184.16c-.258.226-.741.645-.892.813-.048.054-.151.122-.23.101-.032-.008-.071-.034-.071-.11 0-.63.04-1.42.13-1.77.08-.327.202-.553.62-.815.422-.26 1.02-.486 1.882-.71.065-.019.104-.022.13-.008q.02.012.02.034",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCEDEB",
          fillRule: "evenodd",
          stroke: "#F5B7B1",
          d: "M10 44.526a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F5B7B1",
          fillRule: "evenodd",
          d: "M1 36a9 9 0 1 1 18.001.001A9 9 0 0 1 1 36m9-8.053a8.053 8.053 0 1 0 .001 16.107A8.053 8.053 0 0 0 10 27.947",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          fillRule: "evenodd",
          d: "M12.924 34.342h-.474v-.947a2.37 2.37 0 0 0-4.737 0v.947h-.474a.95.95 0 0 0-.947.947v4.737a.95.95 0 0 0 .947.948h5.685a.95.95 0 0 0 .947-.948V35.29a.95.95 0 0 0-.947-.947m-2.842 4.263a.95.95 0 0 1-.948-.947.95.95 0 0 1 .947-.947.95.95 0 0 1 .948.947.95.95 0 0 1-.947.947m1.468-4.263H8.613v-.947a1.47 1.47 0 0 1 2.937 0z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSCarEnablePending = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-car-enable-pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 46",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M3.183 7.421c-.012.857.072 1.857.066 3.038l-.001.72c-.052.026-.149.086-.266.158-.172.106-.384.239-.55.326-.306.168-.392.38-.427.648-.013.083 0 .122.028.146.041.033.101.023.16.007.038-.01.153-.05.292-.096.234-.077.556-.183.632-.203a.7.7 0 0 0 .13-.045c-.005 7 .064 16.93.165 18.425.157 2.25.689 4.737 1.1 5.218C4.928 36.25 6.793 37 10 37s5.072-.75 5.484-1.237c.416-.481.942-2.967 1.099-5.218.106-1.496.171-11.426.167-18.425a.6.6 0 0 0 .129.045c.082.02.412.13.653.21l.27.09c.062.015.124.024.164-.008Q18 12.43 18 12.37c-.039-.326-.125-.54-.436-.707a10 10 0 0 1-.525-.311 5 5 0 0 0-.291-.174l-.002-.718c0-1.182.079-2.182.073-3.038-.018-1.77-.31-5.633-1.602-6.345C14.547.706 12.124 0 9.997 0c-2.12 0-4.542.707-5.213 1.076-1.3.712-1.583 4.576-1.601 6.345",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "m3.739 11.648.33.254c.377 2.589.671 4.961.713 7.283a7 7 0 0 1-.965-.656 360 360 0 0 1-.078-6.881m9.35 22.982c-.958.215-1.955.314-3.093.314-1.132 0-2.128-.098-3.086-.314-.28-.065-.388-.18-.388-.536v-2.77c0-.37.153-.511.437-.488 1.04.093 1.905.123 3.038.123 1.138 0 2.004-.03 3.043-.124.284-.022.438.117.438.49v2.769c0 .356-.11.471-.39.536m2.448-8.351c.114.244.125.368.101.625-.028.27-.059.514-.1.758-.018.068-.06.282-.119.544-.065.301-.107.314-.125-.012-.03-.708-.06-1.477-.077-2.34 0-.201.047-.214.13-.026zM4.786 28.194c-.012.325-.06.313-.125.013a9.128 9.128 0 0 1-.214-1.303 1 1 0 0 1 .095-.626l.19-.45c.09-.188.137-.175.131.025a81 81 0 0 1-.076 2.34zm-.004-8.311a558 558 0 0 1-.032 5.348l-.394.249-.367.214c-.112-1.77-.19-3.968-.25-6.166.31.138.68.259 1.043.355m10.84 5.585-.371-.238c-.027-1.45-.034-3.179-.034-5.347a7 7 0 0 0 1.044-.355c-.054 2.198-.14 4.396-.253 6.166zm-.405-6.283c.042-2.323.33-4.694.708-7.283l.336-.254a406 406 0 0 1-.079 6.88 7 7 0 0 1-.965.657m.348-10.632c0 .121-.014.273-.034.465-.08.736-.205 1.628-.351 2.664-.094.662-.19 1.347-.285 2.068-.067.496-.266.673-.71.633a36 36 0 0 0-4.188-.253c-1.335 0-2.74.085-4.18.253-.453.04-.651-.138-.711-.633-.095-.711-.19-1.387-.283-2.041a77 77 0 0 1-.354-2.692 5 5 0 0 1-.034-.47c0-.365.123-.441.515-.627 1.44-.676 2.727-1.068 5.047-1.068 2.327 0 3.614.392 5.053 1.069.391.187.515.263.515.632m-.753-6.456c.425.261.55.488.63.815.097.408.123 1.305.123 1.77 0 .077-.038.103-.07.11-.077.02-.177-.047-.225-.1-.154-.165-.613-.562-.887-.8-.1-.087-.172-.152-.199-.174q-.034-.029-.076-.055c-.082-.054-.177-.116-.245-.288-.32-.874-.684-1.539-1.027-1.876-.063-.064-.066-.1-.031-.12.025-.014.064-.011.131.01.871.225 1.468.451 1.876.708m-7.595-.684c0 .022-.018.048-.059.086-.34.337-.703 1-1.021 1.87-.067.177-.162.24-.246.294q-.043.025-.079.055l-.184.16c-.258.226-.741.645-.892.813-.048.054-.151.122-.23.101-.032-.008-.071-.034-.071-.11 0-.63.04-1.42.13-1.77.08-.327.202-.553.62-.815.422-.26 1.02-.486 1.882-.71.065-.019.104-.022.13-.008q.02.012.02.034",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#CFDEF2",
          fillRule: "evenodd",
          stroke: "#F5B7B1",
          d: "M10 44.526a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#8AB9F7",
          fillRule: "evenodd",
          d: "M1 36a9 9 0 1 1 18.001.001A9 9 0 0 1 1 36m9-8.053a8.053 8.053 0 1 0 .001 16.107A8.053 8.053 0 0 0 10 27.947",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1774F0",
          fillRule: "evenodd",
          d: "M10.082 38.369a.95.95 0 0 0 .947-.948.95.95 0 0 0-.947-.947.95.95 0 0 0-.948.947.95.95 0 0 0 .947.947m2.842-4.264h-.474v-.947a2.37 2.37 0 0 0-4.737 0h.9a1.47 1.47 0 0 1 2.937 0v.947H7.24a.95.95 0 0 0-.948.948v4.737a.95.95 0 0 0 .947.947h5.685a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.948m0 5.685H7.239v-4.737h5.685z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSCarNoSignal = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-car-no-signal",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 45",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M2.183 7.421c-.012.857.072 1.857.066 3.038l-.001.72c-.052.026-.149.086-.266.158-.172.106-.384.239-.55.326-.306.168-.392.38-.427.648-.013.083 0 .122.028.146.041.033.101.023.16.007.038-.01.153-.05.292-.096.234-.077.556-.183.631-.203a.7.7 0 0 0 .13-.045c-.004 7 .065 16.93.166 18.425.157 2.25.689 4.737 1.1 5.218C3.928 36.25 5.793 37 9 37s5.072-.75 5.484-1.237c.416-.481.942-2.967 1.099-5.218.106-1.496.171-11.426.167-18.425a.6.6 0 0 0 .129.045c.082.02.412.13.653.21l.27.09c.062.015.124.024.164-.008Q17 12.43 17 12.37c-.039-.326-.125-.54-.436-.707a10 10 0 0 1-.525-.311 5 5 0 0 0-.291-.174l-.002-.718c0-1.182.079-2.182.073-3.038-.018-1.77-.31-5.633-1.602-6.345C13.547.706 11.124 0 8.997 0c-2.12 0-4.542.707-5.213 1.076-1.3.712-1.583 4.576-1.601 6.345",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "m2.739 11.648.33.254c.377 2.589.671 4.961.713 7.283a7 7 0 0 1-.965-.656 360 360 0 0 1-.078-6.881m9.35 22.982c-.958.215-1.955.314-3.093.314-1.132 0-2.128-.098-3.086-.314-.28-.065-.388-.18-.388-.536v-2.77c0-.37.153-.511.437-.488 1.04.093 1.905.123 3.038.123 1.138 0 2.004-.03 3.043-.124.284-.022.438.117.438.49v2.769c0 .356-.11.471-.39.536m2.448-8.351c.114.244.125.368.101.625-.028.27-.059.514-.1.758-.018.068-.06.282-.119.544-.065.301-.107.314-.125-.012-.03-.708-.06-1.477-.077-2.34 0-.201.047-.214.13-.026zM3.786 28.194c-.012.325-.06.313-.125.013a9.128 9.128 0 0 1-.214-1.303 1 1 0 0 1 .095-.626l.19-.45c.09-.188.137-.175.131.025a81 81 0 0 1-.076 2.34zm-.004-8.311a558 558 0 0 1-.032 5.348l-.394.249-.367.214c-.112-1.77-.19-3.968-.25-6.166.31.138.68.259 1.043.355m10.84 5.585-.371-.238c-.027-1.45-.034-3.179-.034-5.347a7 7 0 0 0 1.044-.355c-.054 2.198-.14 4.396-.253 6.166zm-.405-6.283c.042-2.323.33-4.694.708-7.283l.336-.254a406 406 0 0 1-.079 6.88 7 7 0 0 1-.965.657m.348-10.632c0 .121-.014.273-.034.465-.08.736-.205 1.628-.351 2.664-.094.662-.19 1.347-.285 2.068-.067.496-.266.673-.71.633a36 36 0 0 0-4.188-.253c-1.335 0-2.74.085-4.18.253-.453.04-.651-.138-.711-.633-.095-.711-.19-1.387-.283-2.041a77 77 0 0 1-.354-2.692 5 5 0 0 1-.034-.47c0-.365.123-.441.515-.627 1.44-.676 2.727-1.068 5.047-1.068 2.327 0 3.614.392 5.053 1.069.391.187.515.263.515.632m-.753-6.456c.425.261.55.488.63.815.097.408.123 1.305.123 1.77 0 .077-.038.103-.07.11-.077.02-.177-.047-.225-.1-.154-.165-.613-.562-.887-.8-.1-.087-.172-.152-.199-.174q-.034-.029-.076-.055c-.082-.054-.177-.116-.245-.288-.32-.874-.684-1.539-1.027-1.876-.063-.064-.066-.1-.031-.12.025-.014.064-.011.131.01.871.225 1.468.451 1.876.708m-7.595-.684c0 .022-.018.048-.059.086-.34.337-.703 1-1.021 1.87-.067.177-.162.24-.246.294q-.042.025-.079.055l-.184.16c-.258.226-.741.645-.892.813-.048.054-.151.122-.23.101-.032-.008-.071-.034-.071-.11 0-.63.04-1.42.13-1.77.08-.327.202-.553.62-.815.422-.26 1.02-.486 1.882-.71.065-.019.104-.022.13-.008q.02.012.02.034",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M8.3 27.785a.99.99 0 0 1 1.4 0l7.514 7.514a.99.99 0 0 1 0 1.401L9.7 44.214a.99.99 0 0 1-1.4 0L.784 36.7a.99.99 0 0 1 0-1.4z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#9DA9B6",
          fillRule: "evenodd",
          d: "M7.95 27.435c.58-.58 1.52-.58 2.1 0l7.515 7.514c.58.58.58 1.521 0 2.102l-7.514 7.514c-.58.58-1.521.58-2.102 0L.435 37.05a1.486 1.486 0 0 1 0-2.102zm1.4.7a.495.495 0 0 0-.7 0L1.136 35.65a.495.495 0 0 0 0 .7l7.514 7.514a.495.495 0 0 0 .7 0l7.514-7.514a.495.495 0 0 0 0-.7z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          d: "M12.136 32.36a.386.386 0 0 0-.658-.273L8.935 34.63l3.201 3.201zm.17 6.73-6.094-6.094a.384.384 0 1 0-.543.544l2.18 2.18-2.758 2.758a.385.385 0 0 0 .27.659h5.9l.498.497c.15.15.393.15.543 0a.38.38 0 0 0 .004-.543"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M4.047 31.047h9.245v9.245H4.047z" }) }) })
    ]
  }
);
const VehicleSCarOff = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-car-off",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 45",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M2.183 7.421c-.012.857.072 1.857.066 3.038l-.001.72c-.052.026-.149.086-.266.158-.172.106-.384.239-.55.326-.306.168-.392.38-.427.648-.013.083 0 .122.028.146.041.033.101.023.16.007.038-.01.153-.05.292-.096.234-.077.556-.183.631-.203a.7.7 0 0 0 .13-.045c-.004 7 .065 16.93.166 18.425.157 2.25.689 4.737 1.1 5.218C3.928 36.25 5.793 37 9 37s5.072-.75 5.484-1.237c.416-.481.942-2.967 1.099-5.218.106-1.496.171-11.426.167-18.425a.6.6 0 0 0 .129.045c.082.02.412.13.653.21l.27.09c.062.015.124.024.164-.008Q17 12.43 17 12.37c-.039-.326-.125-.54-.436-.707a10 10 0 0 1-.525-.311 5 5 0 0 0-.291-.174l-.002-.718c0-1.182.079-2.182.073-3.038-.018-1.77-.31-5.633-1.602-6.345C13.547.706 11.124 0 8.997 0c-2.12 0-4.542.707-5.213 1.076-1.3.712-1.583 4.576-1.601 6.345",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "m2.739 11.648.33.254c.377 2.589.671 4.961.713 7.283a7 7 0 0 1-.965-.656 360 360 0 0 1-.078-6.881m9.35 22.982c-.958.215-1.955.314-3.093.314-1.132 0-2.128-.098-3.086-.314-.28-.065-.388-.18-.388-.536v-2.77c0-.37.153-.511.437-.488 1.04.093 1.905.123 3.038.123 1.138 0 2.004-.03 3.043-.124.284-.022.438.117.438.49v2.769c0 .356-.11.471-.39.536m2.448-8.351c.114.244.125.368.101.625-.028.27-.059.514-.1.758-.018.068-.06.282-.119.544-.065.301-.107.314-.125-.012-.03-.708-.06-1.477-.077-2.34 0-.201.047-.214.13-.026zM3.786 28.194c-.012.325-.06.313-.125.013a9.128 9.128 0 0 1-.214-1.303 1 1 0 0 1 .095-.626l.19-.45c.09-.188.137-.175.131.025a81 81 0 0 1-.076 2.34zm-.004-8.311a558 558 0 0 1-.032 5.348l-.394.249-.367.214c-.112-1.77-.19-3.968-.25-6.166.31.138.68.259 1.043.355m10.84 5.585-.371-.238c-.027-1.45-.034-3.179-.034-5.347a7 7 0 0 0 1.044-.355c-.054 2.198-.14 4.396-.253 6.166zm-.405-6.283c.042-2.323.33-4.694.708-7.283l.336-.254a406 406 0 0 1-.079 6.88 7 7 0 0 1-.965.657m.348-10.632c0 .121-.014.273-.034.465-.08.736-.205 1.628-.351 2.664-.094.662-.19 1.347-.285 2.068-.067.496-.266.673-.71.633a36 36 0 0 0-4.188-.253c-1.335 0-2.74.085-4.18.253-.453.04-.651-.138-.711-.633-.095-.711-.19-1.387-.283-2.041a77 77 0 0 1-.354-2.692 5 5 0 0 1-.034-.47c0-.365.123-.441.515-.627 1.44-.676 2.727-1.068 5.047-1.068 2.327 0 3.614.392 5.053 1.069.391.187.515.263.515.632m-.753-6.456c.425.261.55.488.63.815.097.408.123 1.305.123 1.77 0 .077-.038.103-.07.11-.077.02-.177-.047-.225-.1-.154-.165-.613-.562-.887-.8-.1-.087-.172-.152-.199-.174q-.034-.029-.076-.055c-.082-.054-.177-.116-.245-.288-.32-.874-.684-1.539-1.027-1.876-.063-.064-.066-.1-.031-.12.025-.014.064-.011.131.01.871.225 1.468.451 1.876.708m-7.595-.684c0 .022-.018.048-.059.086-.34.337-.703 1-1.021 1.87-.067.177-.162.24-.246.294q-.042.025-.079.055l-.184.16c-.258.226-.741.645-.892.813-.048.054-.151.122-.23.101-.032-.008-.071-.034-.071-.11 0-.63.04-1.42.13-1.77.08-.327.202-.553.62-.815.422-.26 1.02-.486 1.882-.71.065-.019.104-.022.13-.008q.02.012.02.034",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M9 44.526a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M0 36a9 9 0 1 1 18.001.001A9 9 0 0 1 0 36m9-8.053a8.053 8.053 0 1 0 .001 16.107A8.053 8.053 0 0 0 9 27.947",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M5.472 36a3.528 3.528 0 1 0 7.056 0 3.528 3.528 0 0 0-7.056 0m-.893 0a4.421 4.421 0 1 0 8.842 0 4.421 4.421 0 0 0-8.842 0m2.615-.3a.55.55 0 0 0-.11.35q0 .208.11.35a.33.33 0 0 0 .273.14h3.066q.162 0 .273-.14a.55.55 0 0 0 .11-.35.55.55 0 0 0-.11-.35.33.33 0 0 0-.273-.142H7.467q-.163 0-.273.141",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSCarOn = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-car-on",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 45",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M2.183 7.421c-.012.857.072 1.857.066 3.038l-.001.72c-.052.026-.149.086-.266.158-.172.106-.384.239-.55.326-.306.168-.392.38-.427.648-.013.083 0 .122.028.146.041.033.101.023.16.007.038-.01.153-.05.292-.096.234-.077.556-.183.631-.203a.7.7 0 0 0 .13-.045c-.004 7 .065 16.93.166 18.425.157 2.25.689 4.737 1.1 5.218C3.928 36.25 5.793 37 9 37s5.072-.75 5.484-1.237c.416-.481.942-2.967 1.099-5.218.106-1.496.171-11.426.167-18.425a.6.6 0 0 0 .129.045c.082.02.412.13.653.21l.27.09c.062.015.124.024.164-.008Q17 12.43 17 12.37c-.039-.326-.125-.54-.436-.707a10 10 0 0 1-.525-.311 5 5 0 0 0-.291-.174l-.002-.718c0-1.182.079-2.182.073-3.038-.018-1.77-.31-5.633-1.602-6.345C13.547.706 11.124 0 8.997 0c-2.12 0-4.542.707-5.213 1.076-1.3.712-1.583 4.576-1.601 6.345",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "m2.739 11.648.33.254c.377 2.589.671 4.961.713 7.283a7 7 0 0 1-.965-.656 360 360 0 0 1-.078-6.881m9.35 22.982c-.958.215-1.955.314-3.093.314-1.132 0-2.128-.098-3.086-.314-.28-.065-.388-.18-.388-.536v-2.77c0-.37.153-.511.437-.488 1.04.093 1.905.123 3.038.123 1.138 0 2.004-.03 3.043-.124.284-.022.438.117.438.49v2.769c0 .356-.11.471-.39.536m2.448-8.351c.114.244.125.368.101.625-.028.27-.059.514-.1.758-.018.068-.06.282-.119.544-.065.301-.107.314-.125-.012-.03-.708-.06-1.477-.077-2.34 0-.201.047-.214.13-.026zM3.786 28.194c-.012.325-.06.313-.125.013a9.128 9.128 0 0 1-.214-1.303 1 1 0 0 1 .095-.626l.19-.45c.09-.188.137-.175.131.025a81 81 0 0 1-.076 2.34zm-.004-8.311a558 558 0 0 1-.032 5.348l-.394.249-.367.214c-.112-1.77-.19-3.968-.25-6.166.31.138.68.259 1.043.355m10.84 5.585-.371-.238c-.027-1.45-.034-3.179-.034-5.347a7 7 0 0 0 1.044-.355c-.054 2.198-.14 4.396-.253 6.166zm-.405-6.283c.042-2.323.33-4.694.708-7.283l.336-.254a406 406 0 0 1-.079 6.88 7 7 0 0 1-.965.657m.348-10.632c0 .121-.014.273-.034.465-.08.736-.205 1.628-.351 2.664-.094.662-.19 1.347-.285 2.068-.067.496-.266.673-.71.633a36 36 0 0 0-4.188-.253c-1.335 0-2.74.085-4.18.253-.453.04-.651-.138-.711-.633-.095-.711-.19-1.387-.283-2.041a77 77 0 0 1-.354-2.692 5 5 0 0 1-.034-.47c0-.365.123-.441.515-.627 1.44-.676 2.727-1.068 5.047-1.068 2.327 0 3.614.392 5.053 1.069.391.187.515.263.515.632m-.753-6.456c.425.261.55.488.63.815.097.408.123 1.305.123 1.77 0 .077-.038.103-.07.11-.077.02-.177-.047-.225-.1-.154-.165-.613-.562-.887-.8-.1-.087-.172-.152-.199-.174q-.034-.029-.076-.055c-.082-.054-.177-.116-.245-.288-.32-.874-.684-1.539-1.027-1.876-.063-.064-.066-.1-.031-.12.025-.014.064-.011.131.01.871.225 1.468.451 1.876.708m-7.595-.684c0 .022-.018.048-.059.086-.34.337-.703 1-1.021 1.87-.067.177-.162.24-.246.294q-.042.025-.079.055l-.184.16c-.258.226-.741.645-.892.813-.048.054-.151.122-.23.101-.032-.008-.071-.034-.071-.11 0-.63.04-1.42.13-1.77.08-.327.202-.553.62-.815.422-.26 1.02-.486 1.882-.71.065-.019.104-.022.13-.008q.02.012.02.034",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#03D8A9",
          fillRule: "evenodd",
          d: "M9 44.526a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M0 36a9 9 0 1 1 18.001.001A9 9 0 0 1 0 36m9-8.053a8.053 8.053 0 1 0 .001 16.107A8.053 8.053 0 0 0 9 27.947",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M9 36.49a.48.48 0 0 1-.35-.14.48.48 0 0 1-.141-.35v-3.93q0-.21.141-.35a.48.48 0 0 1 .35-.141q.21 0 .35.14.141.143.141.35V36q0 .21-.14.35a.48.48 0 0 1-.35.142m0 3.93q-.921 0-1.725-.35a4.5 4.5 0 0 1-1.4-.945 4.5 4.5 0 0 1-.946-1.4A4.3 4.3 0 0 1 4.58 36q0-.848.307-1.621.308-.774.884-1.4a.45.45 0 0 1 .344-.148q.21 0 .356.148a.42.42 0 0 1 .123.337.6.6 0 0 1-.147.363q-.43.478-.657 1.074A3.5 3.5 0 0 0 5.562 36q0 1.437 1 2.437Q7.564 39.438 9 39.438t2.438-1q1-1.001 1-2.438 0-.651-.233-1.26a3.5 3.5 0 0 0-.663-1.086.52.52 0 0 1-.141-.344.43.43 0 0 1 .129-.331.49.49 0 0 1 .356-.148q.21 0 .344.148.578.626.884 1.4t.307 1.62q0 .922-.35 1.726a4.5 4.5 0 0 1-.945 1.4 4.5 4.5 0 0 1-1.4.946A4.3 4.3 0 0 1 9 40.42"
        }
      )
    ]
  }
);
const VehicleSCarUnavailable = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-car-unavailable",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 45",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M2.183 7.421c-.012.857.072 1.857.066 3.038l-.001.72c-.052.026-.149.086-.266.158-.172.106-.384.239-.55.326-.306.168-.392.38-.427.648-.013.083 0 .122.028.146.041.033.101.023.16.007.038-.01.153-.05.292-.096.234-.077.556-.183.631-.203a.7.7 0 0 0 .13-.045c-.004 7 .065 16.93.166 18.425.157 2.25.689 4.737 1.1 5.218C3.928 36.25 5.793 37 9 37s5.072-.75 5.484-1.237c.416-.481.942-2.967 1.099-5.218.106-1.496.171-11.426.167-18.425a.6.6 0 0 0 .129.045c.082.02.412.13.653.21l.27.09c.062.015.124.024.164-.008Q17 12.43 17 12.37c-.039-.326-.125-.54-.436-.707a10 10 0 0 1-.525-.311 5 5 0 0 0-.291-.174l-.002-.718c0-1.182.079-2.182.073-3.038-.018-1.77-.31-5.633-1.602-6.345C13.547.706 11.124 0 8.997 0c-2.12 0-4.542.707-5.213 1.076-1.3.712-1.583 4.576-1.601 6.345",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "m2.739 11.648.33.254c.377 2.589.671 4.961.713 7.283a7 7 0 0 1-.965-.656 360 360 0 0 1-.078-6.881m9.35 22.982c-.958.215-1.955.314-3.093.314-1.132 0-2.128-.098-3.086-.314-.28-.065-.388-.18-.388-.536v-2.77c0-.37.153-.511.437-.488 1.04.093 1.905.123 3.038.123 1.138 0 2.004-.03 3.043-.124.284-.022.438.117.438.49v2.769c0 .356-.11.471-.39.536m2.448-8.351c.114.244.125.368.101.625-.028.27-.059.514-.1.758-.018.068-.06.282-.119.544-.065.301-.107.314-.125-.012-.03-.708-.06-1.477-.077-2.34 0-.201.047-.214.13-.026zM3.786 28.194c-.012.325-.06.313-.125.013a9.128 9.128 0 0 1-.214-1.303 1 1 0 0 1 .095-.626l.19-.45c.09-.188.137-.175.131.025a81 81 0 0 1-.076 2.34zm-.004-8.311a558 558 0 0 1-.032 5.348l-.394.249-.367.214c-.112-1.77-.19-3.968-.25-6.166.31.138.68.259 1.043.355m10.84 5.585-.371-.238c-.027-1.45-.034-3.179-.034-5.347a7 7 0 0 0 1.044-.355c-.054 2.198-.14 4.396-.253 6.166zm-.405-6.283c.042-2.323.33-4.694.708-7.283l.336-.254a406 406 0 0 1-.079 6.88 7 7 0 0 1-.965.657m.348-10.632c0 .121-.014.273-.034.465-.08.736-.205 1.628-.351 2.664-.094.662-.19 1.347-.285 2.068-.067.496-.266.673-.71.633a36 36 0 0 0-4.188-.253c-1.335 0-2.74.085-4.18.253-.453.04-.651-.138-.711-.633-.095-.711-.19-1.387-.283-2.041a77 77 0 0 1-.354-2.692 5 5 0 0 1-.034-.47c0-.365.123-.441.515-.627 1.44-.676 2.727-1.068 5.047-1.068 2.327 0 3.614.392 5.053 1.069.391.187.515.263.515.632m-.753-6.456c.425.261.55.488.63.815.097.408.123 1.305.123 1.77 0 .077-.038.103-.07.11-.077.02-.177-.047-.225-.1-.154-.165-.613-.562-.887-.8-.1-.087-.172-.152-.199-.174q-.034-.029-.076-.055c-.082-.054-.177-.116-.245-.288-.32-.874-.684-1.539-1.027-1.876-.063-.064-.066-.1-.031-.12.025-.014.064-.011.131.01.871.225 1.468.451 1.876.708m-7.595-.684c0 .022-.018.048-.059.086-.34.337-.703 1-1.021 1.87-.067.177-.162.24-.246.294q-.042.025-.079.055l-.184.16c-.258.226-.741.645-.892.813-.048.054-.151.122-.23.101-.032-.008-.071-.034-.071-.11 0-.63.04-1.42.13-1.77.08-.327.202-.553.62-.815.422-.26 1.02-.486 1.882-.71.065-.019.104-.022.13-.008q.02.012.02.034",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          d: "M1.536 29.031h14.928c.78 0 1.273.838.894 1.52L9.894 43.967c-.39.7-1.398.7-1.787 0L.643 30.55c-.38-.682.113-1.52.893-1.52"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M10.34 44.215a1.534 1.534 0 0 1-2.68 0L.196 30.8a1.534 1.534 0 0 1 1.34-2.28h14.928c1.17 0 1.91 1.258 1.34 2.28zm-1.787-.497c.195.35.699.35.894 0l7.464-13.416a.51.51 0 0 0-.447-.76H1.536c-.39 0-.636.42-.447.76z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M9 39.538a.76.76 0 0 1-.57-.245.82.82 0 0 1-.236-.59.82.82 0 0 1 .237-.59.76.76 0 0 1 .569-.245q.331 0 .568.245a.82.82 0 0 1 .237.59.82.82 0 0 1-.237.59.76.76 0 0 1-.568.245m0-2.505a.76.76 0 0 1-.57-.246.82.82 0 0 1-.236-.59v-3.34a.82.82 0 0 1 .237-.59.76.76 0 0 1 .569-.245q.331 0 .568.245a.82.82 0 0 1 .237.59v3.34a.82.82 0 0 1-.237.59.76.76 0 0 1-.568.245"
        }
      )
    ]
  }
);
const VehicleSCarUnplugged = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-car-unplugged",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 45",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M2.183 7.421c-.012.857.072 1.857.066 3.038l-.001.72c-.052.026-.149.086-.266.158-.172.106-.384.239-.55.326-.306.168-.392.38-.427.648-.013.083 0 .122.028.146.041.033.101.023.16.007.038-.01.153-.05.292-.096.234-.077.556-.183.631-.203a.7.7 0 0 0 .13-.045c-.004 7 .065 16.93.166 18.425.157 2.25.689 4.737 1.1 5.218C3.928 36.25 5.793 37 9 37s5.072-.75 5.484-1.237c.416-.481.942-2.967 1.099-5.218.106-1.496.171-11.426.167-18.425a.6.6 0 0 0 .129.045c.082.02.412.13.653.21l.27.09c.062.015.124.024.164-.008Q17 12.43 17 12.37c-.039-.326-.125-.54-.436-.707a10 10 0 0 1-.525-.311 5 5 0 0 0-.291-.174l-.002-.718c0-1.182.079-2.182.073-3.038-.018-1.77-.31-5.633-1.602-6.345C13.547.706 11.124 0 8.997 0c-2.12 0-4.542.707-5.213 1.076-1.3.712-1.583 4.576-1.601 6.345",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "m2.739 11.648.33.254c.377 2.589.671 4.961.713 7.283a7 7 0 0 1-.965-.656 360 360 0 0 1-.078-6.881m9.35 22.982c-.958.215-1.955.314-3.093.314-1.132 0-2.128-.098-3.086-.314-.28-.065-.388-.18-.388-.536v-2.77c0-.37.153-.511.437-.488 1.04.093 1.905.123 3.038.123 1.138 0 2.004-.03 3.043-.124.284-.022.438.117.438.49v2.769c0 .356-.11.471-.39.536m2.448-8.351c.114.244.125.368.101.625-.028.27-.059.514-.1.758-.018.068-.06.282-.119.544-.065.301-.107.314-.125-.012-.03-.708-.06-1.477-.077-2.34 0-.201.047-.214.13-.026zM3.786 28.194c-.012.325-.06.313-.125.013a9.128 9.128 0 0 1-.214-1.303 1 1 0 0 1 .095-.626l.19-.45c.09-.188.137-.175.131.025a81 81 0 0 1-.076 2.34zm-.004-8.311a558 558 0 0 1-.032 5.348l-.394.249-.367.214c-.112-1.77-.19-3.968-.25-6.166.31.138.68.259 1.043.355m10.84 5.585-.371-.238c-.027-1.45-.034-3.179-.034-5.347a7 7 0 0 0 1.044-.355c-.054 2.198-.14 4.396-.253 6.166zm-.405-6.283c.042-2.323.33-4.694.708-7.283l.336-.254a406 406 0 0 1-.079 6.88 7 7 0 0 1-.965.657m.348-10.632c0 .121-.014.273-.034.465-.08.736-.205 1.628-.351 2.664-.094.662-.19 1.347-.285 2.068-.067.496-.266.673-.71.633a36 36 0 0 0-4.188-.253c-1.335 0-2.74.085-4.18.253-.453.04-.651-.138-.711-.633-.095-.711-.19-1.387-.283-2.041a77 77 0 0 1-.354-2.692 5 5 0 0 1-.034-.47c0-.365.123-.441.515-.627 1.44-.676 2.727-1.068 5.047-1.068 2.327 0 3.614.392 5.053 1.069.391.187.515.263.515.632m-.753-6.456c.425.261.55.488.63.815.097.408.123 1.305.123 1.77 0 .077-.038.103-.07.11-.077.02-.177-.047-.225-.1-.154-.165-.613-.562-.887-.8-.1-.087-.172-.152-.199-.174q-.034-.029-.076-.055c-.082-.054-.177-.116-.245-.288-.32-.874-.684-1.539-1.027-1.876-.063-.064-.066-.1-.031-.12.025-.014.064-.011.131.01.871.225 1.468.451 1.876.708m-7.595-.684c0 .022-.018.048-.059.086-.34.337-.703 1-1.021 1.87-.067.177-.162.24-.246.294q-.042.025-.079.055l-.184.16c-.258.226-.741.645-.892.813-.048.054-.151.122-.23.101-.032-.008-.071-.034-.071-.11 0-.63.04-1.42.13-1.77.08-.327.202-.553.62-.815.422-.26 1.02-.486 1.882-.71.065-.019.104-.022.13-.008q.02.012.02.034",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          d: "M1.536 29.031h14.928c.78 0 1.273.838.894 1.52L9.894 43.967c-.39.7-1.398.7-1.787 0L.643 30.55c-.38-.682.113-1.52.893-1.52"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M10.34 44.215a1.534 1.534 0 0 1-2.68 0L.196 30.8a1.534 1.534 0 0 1 1.34-2.28h14.928c1.17 0 1.91 1.258 1.34 2.28zm-1.787-.497c.195.35.699.35.894 0l7.464-13.416a.51.51 0 0 0-.447-.76H1.536c-.39 0-.636.42-.447.76z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M10.502 32.322c0-.166-.128-.3-.285-.3a.29.29 0 0 0-.285.3v1.96H8.067v-1.96c0-.166-.127-.3-.284-.3a.293.293 0 0 0-.285.3v1.96h-.645v1.203c.003 1.07.72 1.99 1.717 2.202v1.85h.86v-1.85c.996-.213 1.714-1.133 1.717-2.202v-1.207h-.645z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M4.705 31.485h8.59v8.59h-8.59z" }) }) })
    ]
  }
);
const VehicleSCar = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-car",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 15 35",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M1.102 7.02c-.011.81.067 1.756.061 2.874v.68c-.049.025-.139.082-.248.15-.16.1-.358.226-.513.309-.285.158-.364.36-.397.613-.012.077 0 .115.026.138.038.03.094.021.15.006.034-.01.142-.046.27-.09.22-.073.52-.174.59-.193a.6.6 0 0 0 .12-.042c-.004 6.621.06 16.014.155 17.428.146 2.13.641 4.481 1.024 4.936.389.46 2.127 1.17 5.114 1.17s4.725-.71 5.109-1.17c.388-.455.878-2.806 1.024-4.936.098-1.415.16-10.808.155-17.428q.049.025.12.042c.077.02.385.123.61.2l.251.084c.058.014.115.023.152-.007q.033-.027.032-.084c-.036-.308-.116-.51-.406-.668a9 9 0 0 1-.49-.295 5 5 0 0 0-.27-.165l-.002-.679c0-1.117.073-2.064.068-2.874-.017-1.673-.288-5.327-1.492-6.002C11.69.668 9.432 0 7.45 0 5.476 0 3.219.669 2.594 1.017c-1.21.675-1.475 4.33-1.492 6.003",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "m1.62 11.018.308.24c.352 2.45.625 4.693.665 6.89a6.6 6.6 0 0 1-.9-.621c-.05-2.484-.072-4.874-.072-6.509m8.712 21.74c-.893.203-1.821.297-2.881.297-1.056 0-1.984-.093-2.876-.297-.26-.061-.362-.17-.362-.507v-2.62c0-.351.143-.484.408-.462a29 29 0 0 0 2.83.116c1.06 0 1.867-.028 2.835-.117.265-.021.409.111.409.463l-.001 2.62c0 .336-.102.446-.363.507m2.281-7.9c.106.23.117.349.094.592-.027.255-.055.486-.094.716-.016.065-.055.267-.11.515-.061.285-.1.297-.117-.011a100 100 0 0 1-.071-2.214c0-.19.043-.203.121-.024zM2.596 26.67c-.011.308-.055.296-.116.012a8.77 8.77 0 0 1-.2-1.232.97.97 0 0 1 .09-.592l.176-.427c.084-.178.128-.165.122.024a78 78 0 0 1-.071 2.215zm-.003-7.862c-.006 2.05-.013 3.686-.03 5.058l-.368.236-.341.203a175 175 0 0 1-.234-5.833c.289.13.634.245.972.336m10.1 5.283-.347-.225a292 292 0 0 1-.031-5.058c.334-.091.687-.205.972-.336-.05 2.08-.13 4.159-.235 5.833zm-.378-5.943c.039-2.197.307-4.44.659-6.89l.313-.24a391 391 0 0 1-.073 6.509c-.234.2-.575.434-.9.62m.324-10.057c0 .114-.013.258-.032.44-.074.695-.191 1.54-.327 2.52-.087.625-.177 1.273-.266 1.956-.061.469-.247.636-.661.599a33 33 0 0 0-3.902-.24 33 33 0 0 0-3.895.24c-.421.037-.606-.131-.662-.6a211 211 0 0 0-.264-1.93 74 74 0 0 1-.329-2.546 5 5 0 0 1-.032-.445c0-.346.115-.418.48-.593 1.34-.64 2.54-1.01 4.702-1.01 2.168 0 3.367.37 4.708 1.01.364.177.48.25.48.599m-.701-6.108c.395.248.512.462.585.772.091.386.116 1.234.116 1.673 0 .073-.036.099-.066.106-.07.018-.164-.045-.209-.096-.143-.156-.57-.532-.826-.757l-.186-.164q-.031-.028-.07-.052c-.077-.051-.166-.11-.23-.272-.297-.827-.636-1.456-.956-1.775-.058-.06-.061-.095-.029-.113.023-.013.06-.011.123.008.811.214 1.367.428 1.748.671M4.86 1.336q.001.03-.055.082c-.317.318-.655.946-.951 1.768-.063.169-.151.227-.23.279q-.04.024-.073.052l-.171.152c-.241.213-.691.61-.832.769-.044.051-.14.115-.214.095-.03-.008-.066-.032-.066-.105 0-.594.037-1.343.122-1.673.074-.31.187-.523.577-.772.393-.246.95-.459 1.753-.67.061-.019.097-.022.12-.008q.02.01.02.031",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSConveyorDisablePending = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-conveyor-disable-pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 51",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.762 40.925c.255 0 .461-.251.461-.56V1.356c0-.31-.206-.56-.46-.56H3.236c-.254 0-.46.25-.46.56v39.007c0 .31.206.561.46.561z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.855 1.357v39.007c0 .062-.042.112-.093.112H3.237c-.05 0-.092-.05-.092-.112V1.357c0-.062.042-.112.092-.112h15.525c.051 0 .093.05.093.112m.368 39.007c0 .31-.206.561-.46.561H3.236c-.254 0-.46-.251-.46-.56V1.356c0-.31.206-.56.46-.56h15.525c.255 0 .461.25.461.56z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.869.795c-.051 0-.093.05-.093.113v39.904c0 .062.042.112.093.112h1.733c.05 0 .092-.05.092-.112V.908c0-.062-.042-.113-.092-.113z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.145 1.244h1.18v39.231h-1.18zM2.776.908c0-.062.042-.113.093-.113h1.733c.05 0 .092.05.092.113v39.904c0 .062-.042.112-.092.112H2.869c-.051 0-.093-.05-.093-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.397.795c-.05 0-.092.05-.092.113v39.904c0 .062.041.112.092.112h1.733c.051 0 .093-.05.093-.112V.908c0-.062-.042-.113-.093-.113z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.674 1.244h1.18v39.231h-1.18zm-.369-.336c0-.062.041-.113.092-.113h1.733c.051 0 .093.05.093.113v39.904c0 .062-.042.112-.093.112h-1.733c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M4.693 1.031v39.676h12.612V1.03zM1.475 4.637C.66 4.637 0 5.297 0 6.112v5.855a1.475 1.475 0 1 0 2.95 0V6.112c0-.815-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 11.967V6.112a1.087 1.087 0 1 1 2.174 0v5.855a1.087 1.087 0 0 1-2.174 0M0 6.112a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 28.279c-.814 0-1.475.66-1.475 1.475v5.855a1.475 1.475 0 1 0 2.95 0v-5.855c0-.815-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 35.609v-5.855a1.087 1.087 0 1 1 2.174 0v5.855a1.087 1.087 0 0 1-2.174 0M0 29.754a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.526 4.637c-.815 0-1.475.66-1.475 1.475v5.855a1.475 1.475 0 1 0 2.95 0V6.112c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 11.967V6.112a1.087 1.087 0 0 1 2.173 0v5.855a1.087 1.087 0 0 1-2.173 0m-.388-5.855a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.526 28.279c-.815 0-1.475.66-1.475 1.475v5.855a1.475 1.475 0 1 0 2.95 0v-5.855c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 35.609v-5.855a1.087 1.087 0 1 1 2.173 0v5.855a1.087 1.087 0 0 1-2.173 0m-.388-5.855a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCF0DE",
          fillRule: "evenodd",
          stroke: "#F9D199",
          d: "M11 50.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F9D199",
          fillRule: "evenodd",
          d: "M2 41.795a9 9 0 1 1 18.001.002A9 9 0 0 1 2 41.795m9-8.052a8.053 8.053 0 1 0 .001 16.106A8.053 8.053 0 0 0 11 33.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          fillRule: "evenodd",
          d: "M13.924 40.138h-.474v-.948a2.37 2.37 0 0 0-4.736 0v.948H8.24a.95.95 0 0 0-.948.947v4.737a.95.95 0 0 0 .948.947h5.684a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.947M11.082 44.4a.95.95 0 0 1-.947-.948.95.95 0 0 1 .947-.947.95.95 0 0 1 .947.947.95.95 0 0 1-.947.948m1.468-4.263H9.614v-.948c0-.81.658-1.468 1.468-1.468s1.468.658 1.468 1.468z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSConveyorDisabled = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-conveyor-disabled",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 51",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.762 40.925c.255 0 .461-.251.461-.56V1.356c0-.31-.206-.56-.46-.56H3.236c-.254 0-.46.25-.46.56v39.007c0 .31.206.561.46.561z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.855 1.357v39.007c0 .062-.042.112-.093.112H3.237c-.05 0-.092-.05-.092-.112V1.357c0-.062.042-.112.092-.112h15.525c.051 0 .093.05.093.112m.368 39.007c0 .31-.206.561-.46.561H3.236c-.254 0-.46-.251-.46-.56V1.356c0-.31.206-.56.46-.56h15.525c.255 0 .461.25.461.56z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.869.795c-.051 0-.093.05-.093.113v39.904c0 .062.042.112.093.112h1.733c.05 0 .092-.05.092-.112V.908c0-.062-.042-.113-.092-.113z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.145 1.244h1.18v39.231h-1.18zM2.776.908c0-.062.042-.113.093-.113h1.733c.05 0 .092.05.092.113v39.904c0 .062-.042.112-.092.112H2.869c-.051 0-.093-.05-.093-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.397.795c-.05 0-.092.05-.092.113v39.904c0 .062.041.112.092.112h1.733c.051 0 .093-.05.093-.112V.908c0-.062-.042-.113-.093-.113z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.674 1.244h1.18v39.231h-1.18zm-.369-.336c0-.062.041-.113.092-.113h1.733c.051 0 .093.05.093.113v39.904c0 .062-.042.112-.093.112h-1.733c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M4.693 1.031v39.676h12.612V1.03zM1.475 4.637C.66 4.637 0 5.297 0 6.112v5.855a1.475 1.475 0 1 0 2.95 0V6.112c0-.815-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 11.967V6.112a1.087 1.087 0 1 1 2.174 0v5.855a1.087 1.087 0 0 1-2.174 0M0 6.112a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 28.279c-.814 0-1.475.66-1.475 1.475v5.855a1.475 1.475 0 1 0 2.95 0v-5.855c0-.815-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 35.609v-5.855a1.087 1.087 0 1 1 2.174 0v5.855a1.087 1.087 0 0 1-2.174 0M0 29.754a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.526 4.637c-.815 0-1.475.66-1.475 1.475v5.855a1.475 1.475 0 1 0 2.95 0V6.112c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 11.967V6.112a1.087 1.087 0 0 1 2.173 0v5.855a1.087 1.087 0 0 1-2.173 0m-.388-5.855a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.526 28.279c-.815 0-1.475.66-1.475 1.475v5.855a1.475 1.475 0 1 0 2.95 0v-5.855c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 35.609v-5.855a1.087 1.087 0 1 1 2.173 0v5.855a1.087 1.087 0 0 1-2.173 0m-.388-5.855a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCEDEB",
          fillRule: "evenodd",
          stroke: "#F5B7B1",
          d: "M11 50.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F5B7B1",
          fillRule: "evenodd",
          d: "M2 41.795a9 9 0 1 1 18.001.002A9 9 0 0 1 2 41.795m9-8.052a8.053 8.053 0 1 0 .001 16.106A8.053 8.053 0 0 0 11 33.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          fillRule: "evenodd",
          d: "M13.924 40.138h-.474v-.948a2.37 2.37 0 0 0-4.736 0v.948H8.24a.95.95 0 0 0-.948.947v4.737a.95.95 0 0 0 .948.947h5.684a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.947M11.082 44.4a.95.95 0 0 1-.947-.948.95.95 0 0 1 .947-.947.95.95 0 0 1 .947.947.95.95 0 0 1-.947.948m1.468-4.263H9.614v-.948c0-.81.658-1.468 1.468-1.468s1.468.658 1.468 1.468z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSConveyorEnablePending = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-conveyor-enable-pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 51",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.762 40.925c.255 0 .461-.251.461-.56V1.356c0-.31-.206-.56-.46-.56H3.236c-.254 0-.46.25-.46.56v39.007c0 .31.206.561.46.561z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.855 1.357v39.007c0 .062-.042.112-.093.112H3.237c-.05 0-.092-.05-.092-.112V1.357c0-.062.042-.112.092-.112h15.525c.051 0 .093.05.093.112m.368 39.007c0 .31-.206.561-.46.561H3.236c-.254 0-.46-.251-.46-.56V1.356c0-.31.206-.56.46-.56h15.525c.255 0 .461.25.461.56z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.869.795c-.051 0-.093.05-.093.113v39.904c0 .062.042.112.093.112h1.733c.05 0 .092-.05.092-.112V.908c0-.062-.042-.113-.092-.113z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.145 1.244h1.18v39.231h-1.18zM2.776.908c0-.062.042-.113.093-.113h1.733c.05 0 .092.05.092.113v39.904c0 .062-.042.112-.092.112H2.869c-.051 0-.093-.05-.093-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.397.795c-.05 0-.092.05-.092.113v39.904c0 .062.041.112.092.112h1.733c.051 0 .093-.05.093-.112V.908c0-.062-.042-.113-.093-.113z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.674 1.244h1.18v39.231h-1.18zm-.369-.336c0-.062.041-.113.092-.113h1.733c.051 0 .093.05.093.113v39.904c0 .062-.042.112-.093.112h-1.733c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M4.693 1.031v39.676h12.612V1.03zM1.475 4.637C.66 4.637 0 5.297 0 6.112v5.855a1.475 1.475 0 1 0 2.95 0V6.112c0-.815-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 11.967V6.112a1.087 1.087 0 1 1 2.174 0v5.855a1.087 1.087 0 0 1-2.174 0M0 6.112a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 28.279c-.814 0-1.475.66-1.475 1.475v5.855a1.475 1.475 0 1 0 2.95 0v-5.855c0-.815-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 35.609v-5.855a1.087 1.087 0 1 1 2.174 0v5.855a1.087 1.087 0 0 1-2.174 0M0 29.754a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.526 4.637c-.815 0-1.475.66-1.475 1.475v5.855a1.475 1.475 0 1 0 2.95 0V6.112c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 11.967V6.112a1.087 1.087 0 0 1 2.173 0v5.855a1.087 1.087 0 0 1-2.173 0m-.388-5.855a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.526 28.279c-.815 0-1.475.66-1.475 1.475v5.855a1.475 1.475 0 1 0 2.95 0v-5.855c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 35.609v-5.855a1.087 1.087 0 1 1 2.173 0v5.855a1.087 1.087 0 0 1-2.173 0m-.388-5.855a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#CFDEF2",
          fillRule: "evenodd",
          stroke: "#F5B7B1",
          d: "M11 50.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#8AB9F7",
          fillRule: "evenodd",
          d: "M2 41.795a9 9 0 1 1 18.001.002A9 9 0 0 1 2 41.795m9-8.052a8.053 8.053 0 1 0 .001 16.106A8.053 8.053 0 0 0 11 33.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1774F0",
          fillRule: "evenodd",
          d: "M11.082 44.164a.95.95 0 0 0 .947-.947.95.95 0 0 0-.947-.948.95.95 0 0 0-.947.948.95.95 0 0 0 .947.947m2.842-4.263h-.474v-.948a2.37 2.37 0 0 0-4.736 0h.9c0-.81.658-1.468 1.468-1.468s1.468.658 1.468 1.468v.948H8.24a.95.95 0 0 0-.948.947v4.737a.95.95 0 0 0 .948.947h5.684a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.947m0 5.684H8.24v-4.737h5.684z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSConveyorNoSignal = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-conveyor-no-signal",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 51",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.762 40.925c.255 0 .461-.251.461-.56V1.356c0-.31-.206-.56-.46-.56H3.236c-.254 0-.46.25-.46.56v39.007c0 .31.206.561.46.561z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.855 1.357v39.007c0 .062-.042.112-.093.112H3.237c-.05 0-.092-.05-.092-.112V1.357c0-.062.042-.112.092-.112h15.525c.051 0 .093.05.093.112m.368 39.007c0 .31-.206.561-.46.561H3.236c-.254 0-.46-.251-.46-.56V1.356c0-.31.206-.56.46-.56h15.525c.255 0 .461.25.461.56z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.869.795c-.051 0-.093.05-.093.113v39.904c0 .062.042.112.093.112h1.733c.05 0 .092-.05.092-.112V.908c0-.062-.042-.113-.092-.113z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.145 1.244h1.18v39.231h-1.18zM2.776.908c0-.062.042-.113.093-.113h1.733c.05 0 .092.05.092.113v39.904c0 .062-.042.112-.092.112H2.869c-.051 0-.093-.05-.093-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.397.795c-.05 0-.092.05-.092.113v39.904c0 .062.041.112.092.112h1.733c.051 0 .093-.05.093-.112V.908c0-.062-.042-.113-.093-.113z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.674 1.244h1.18v39.231h-1.18zm-.369-.336c0-.062.041-.113.092-.113h1.733c.051 0 .093.05.093.113v39.904c0 .062-.042.112-.093.112h-1.733c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M4.693 1.031v39.676h12.612V1.03zM1.475 4.637C.66 4.637 0 5.297 0 6.112v5.855a1.475 1.475 0 1 0 2.95 0V6.112c0-.815-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 11.967V6.112a1.087 1.087 0 1 1 2.174 0v5.855a1.087 1.087 0 0 1-2.174 0M0 6.112a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 28.279c-.814 0-1.475.66-1.475 1.475v5.855a1.475 1.475 0 1 0 2.95 0v-5.855c0-.815-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 35.609v-5.855a1.087 1.087 0 1 1 2.174 0v5.855a1.087 1.087 0 0 1-2.174 0M0 29.754a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.526 4.637c-.815 0-1.475.66-1.475 1.475v5.855a1.475 1.475 0 1 0 2.95 0V6.112c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 11.967V6.112a1.087 1.087 0 0 1 2.173 0v5.855a1.087 1.087 0 0 1-2.173 0m-.388-5.855a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.526 28.279c-.815 0-1.475.66-1.475 1.475v5.855a1.475 1.475 0 1 0 2.95 0v-5.855c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 35.609v-5.855a1.087 1.087 0 1 1 2.173 0v5.855a1.087 1.087 0 0 1-2.173 0m-.388-5.855a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M10.3 33.58a.99.99 0 0 1 1.4 0l7.515 7.515a.99.99 0 0 1 0 1.4L11.7 50.01a.99.99 0 0 1-1.401 0l-7.515-7.514a.99.99 0 0 1 0-1.401z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#9DA9B6",
          fillRule: "evenodd",
          d: "M9.95 33.23c.58-.58 1.52-.58 2.1 0l7.515 7.515c.58.58.58 1.52 0 2.101L12.05 50.36c-.58.58-1.521.58-2.102 0l-7.514-7.514a1.486 1.486 0 0 1 0-2.101zm1.4.701a.495.495 0 0 0-.7 0l-7.514 7.514a.495.495 0 0 0 0 .7l7.514 7.515a.495.495 0 0 0 .7 0l7.514-7.514a.495.495 0 0 0 0-.7z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          d: "M14.137 38.156a.386.386 0 0 0-.659-.273l-2.542 2.542 3.2 3.201zm.17 6.73-6.095-6.094a.384.384 0 1 0-.543.543l2.18 2.18-2.758 2.758a.385.385 0 0 0 .27.66h5.901l.497.496c.15.15.393.15.543 0a.38.38 0 0 0 .004-.543"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M6.047 36.843h9.245v9.245H6.047z" }) }) })
    ]
  }
);
const VehicleSConveyorOff = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-conveyor-off",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 51",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.762 40.925c.255 0 .461-.251.461-.56V1.356c0-.31-.206-.56-.46-.56H3.236c-.254 0-.46.25-.46.56v39.007c0 .31.206.561.46.561z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.855 1.357v39.007c0 .062-.042.112-.093.112H3.237c-.05 0-.092-.05-.092-.112V1.357c0-.062.042-.112.092-.112h15.525c.051 0 .093.05.093.112m.368 39.007c0 .31-.206.561-.46.561H3.236c-.254 0-.46-.251-.46-.56V1.356c0-.31.206-.56.46-.56h15.525c.255 0 .461.25.461.56z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.869.795c-.051 0-.093.05-.093.113v39.904c0 .062.042.112.093.112h1.733c.05 0 .092-.05.092-.112V.908c0-.062-.042-.113-.092-.113z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.145 1.244h1.18v39.231h-1.18zM2.776.908c0-.062.042-.113.093-.113h1.733c.05 0 .092.05.092.113v39.904c0 .062-.042.112-.092.112H2.869c-.051 0-.093-.05-.093-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.397.795c-.05 0-.092.05-.092.113v39.904c0 .062.041.112.092.112h1.733c.051 0 .093-.05.093-.112V.908c0-.062-.042-.113-.093-.113z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.674 1.244h1.18v39.231h-1.18zm-.369-.336c0-.062.041-.113.092-.113h1.733c.051 0 .093.05.093.113v39.904c0 .062-.042.112-.093.112h-1.733c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M4.693 1.031v39.676h12.612V1.03zM1.475 4.637C.66 4.637 0 5.297 0 6.112v5.855a1.475 1.475 0 1 0 2.95 0V6.112c0-.815-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 11.967V6.112a1.087 1.087 0 1 1 2.174 0v5.855a1.087 1.087 0 0 1-2.174 0M0 6.112a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 28.279c-.814 0-1.475.66-1.475 1.475v5.855a1.475 1.475 0 1 0 2.95 0v-5.855c0-.815-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 35.609v-5.855a1.087 1.087 0 1 1 2.174 0v5.855a1.087 1.087 0 0 1-2.174 0M0 29.754a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.526 4.637c-.815 0-1.475.66-1.475 1.475v5.855a1.475 1.475 0 1 0 2.95 0V6.112c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 11.967V6.112a1.087 1.087 0 0 1 2.173 0v5.855a1.087 1.087 0 0 1-2.173 0m-.388-5.855a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.526 28.279c-.815 0-1.475.66-1.475 1.475v5.855a1.475 1.475 0 1 0 2.95 0v-5.855c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 35.609v-5.855a1.087 1.087 0 1 1 2.173 0v5.855a1.087 1.087 0 0 1-2.173 0m-.388-5.855a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M11 50.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M2 41.795a9 9 0 1 1 18.001.002A9 9 0 0 1 2 41.795m9-8.052a8.053 8.053 0 1 0 .001 16.106A8.053 8.053 0 0 0 11 33.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M7.472 41.796a3.528 3.528 0 1 0 7.056 0 3.528 3.528 0 0 0-7.056 0m-.893 0a4.421 4.421 0 1 0 8.842 0 4.421 4.421 0 0 0-8.842 0m2.615-.301a.55.55 0 0 0-.11.35q0 .209.11.35a.33.33 0 0 0 .273.14h3.066q.162 0 .273-.14a.55.55 0 0 0 .11-.35.55.55 0 0 0-.11-.35.33.33 0 0 0-.273-.142H9.467q-.163 0-.273.142",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSConveyorOn = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-conveyor-on",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 51",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.762 40.925c.255 0 .461-.251.461-.56V1.356c0-.31-.206-.56-.46-.56H3.236c-.254 0-.46.25-.46.56v39.007c0 .31.206.561.46.561z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.855 1.357v39.007c0 .062-.042.112-.093.112H3.237c-.05 0-.092-.05-.092-.112V1.357c0-.062.042-.112.092-.112h15.525c.051 0 .093.05.093.112m.368 39.007c0 .31-.206.561-.46.561H3.236c-.254 0-.46-.251-.46-.56V1.356c0-.31.206-.56.46-.56h15.525c.255 0 .461.25.461.56z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.869.795c-.051 0-.093.05-.093.113v39.904c0 .062.042.112.093.112h1.733c.05 0 .092-.05.092-.112V.908c0-.062-.042-.113-.092-.113z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.145 1.244h1.18v39.231h-1.18zM2.776.908c0-.062.042-.113.093-.113h1.733c.05 0 .092.05.092.113v39.904c0 .062-.042.112-.092.112H2.869c-.051 0-.093-.05-.093-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.397.795c-.05 0-.092.05-.092.113v39.904c0 .062.041.112.092.112h1.733c.051 0 .093-.05.093-.112V.908c0-.062-.042-.113-.093-.113z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.674 1.244h1.18v39.231h-1.18zm-.369-.336c0-.062.041-.113.092-.113h1.733c.051 0 .093.05.093.113v39.904c0 .062-.042.112-.093.112h-1.733c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M4.693 1.031v39.676h12.612V1.03zM1.475 4.637C.66 4.637 0 5.297 0 6.112v5.855a1.475 1.475 0 1 0 2.95 0V6.112c0-.815-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 11.967V6.112a1.087 1.087 0 1 1 2.174 0v5.855a1.087 1.087 0 0 1-2.174 0M0 6.112a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 28.279c-.814 0-1.475.66-1.475 1.475v5.855a1.475 1.475 0 1 0 2.95 0v-5.855c0-.815-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 35.609v-5.855a1.087 1.087 0 1 1 2.174 0v5.855a1.087 1.087 0 0 1-2.174 0M0 29.754a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.526 4.637c-.815 0-1.475.66-1.475 1.475v5.855a1.475 1.475 0 1 0 2.95 0V6.112c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 11.967V6.112a1.087 1.087 0 0 1 2.173 0v5.855a1.087 1.087 0 0 1-2.173 0m-.388-5.855a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.526 28.279c-.815 0-1.475.66-1.475 1.475v5.855a1.475 1.475 0 1 0 2.95 0v-5.855c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 35.609v-5.855a1.087 1.087 0 1 1 2.173 0v5.855a1.087 1.087 0 0 1-2.173 0m-.388-5.855a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#03D8A9",
          fillRule: "evenodd",
          d: "M11 50.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M2 41.795a9 9 0 1 1 18.001.002A9 9 0 0 1 2 41.795m9-8.052a8.053 8.053 0 1 0 .001 16.106A8.053 8.053 0 0 0 11 33.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M11 42.286a.48.48 0 0 1-.35-.14.48.48 0 0 1-.142-.35v-3.93q0-.21.142-.35a.48.48 0 0 1 .35-.142q.208 0 .35.141.14.141.14.35v3.93q0 .21-.14.35a.48.48 0 0 1-.35.141m0 3.93q-.921 0-1.726-.35a4.5 4.5 0 0 1-1.4-.946 4.5 4.5 0 0 1-.945-1.4 4.3 4.3 0 0 1-.35-1.725q0-.847.307-1.621.306-.773.884-1.4a.45.45 0 0 1 .344-.147q.209 0 .356.147a.42.42 0 0 1 .123.338.6.6 0 0 1-.148.362q-.429.48-.657 1.075a3.5 3.5 0 0 0-.227 1.246q0 1.437 1 2.438 1.001 1 2.439 1 1.437 0 2.437-1 1.001-1 1.001-2.438 0-.65-.233-1.259a3.5 3.5 0 0 0-.663-1.087.52.52 0 0 1-.142-.343.43.43 0 0 1 .13-.332.49.49 0 0 1 .356-.147q.208 0 .344.147.576.627.884 1.4.307.774.307 1.621 0 .922-.35 1.725a4.5 4.5 0 0 1-.946 1.4 4.5 4.5 0 0 1-1.4.946 4.3 4.3 0 0 1-1.725.35"
        }
      )
    ]
  }
);
const VehicleSConveyorUnavailable = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-conveyor-unavailable",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 51",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.762 40.437c.255 0 .461-.252.461-.562V.87c0-.31-.206-.562-.46-.562H3.236c-.254 0-.46.252-.46.562v39.006c0 .31.206.562.46.562z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.855.869v39.006c0 .062-.042.113-.093.113H3.237c-.05 0-.092-.05-.092-.113V.87c0-.062.042-.113.092-.113h15.525c.051 0 .093.05.093.113m.368 39.006c0 .31-.206.562-.46.562H3.236c-.254 0-.46-.252-.46-.562V.87c0-.31.206-.562.46-.562h15.525c.255 0 .461.252.461.562z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.869.307c-.051 0-.093.05-.093.112v39.904c0 .062.042.113.093.113h1.733c.05 0 .092-.05.092-.113V.42c0-.062-.042-.112-.092-.112z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.145.756h1.18v39.23h-1.18zM2.776.419c0-.062.042-.112.093-.112h1.733c.05 0 .092.05.092.112v39.904c0 .062-.042.113-.092.113H2.869c-.051 0-.093-.05-.093-.113z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.397.307c-.05 0-.092.05-.092.112v39.904c0 .062.041.113.092.113h1.733c.051 0 .093-.05.093-.113V.42c0-.062-.042-.112-.093-.112z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.674.756h1.18v39.23h-1.18zm-.369-.337c0-.062.041-.112.092-.112h1.733c.051 0 .093.05.093.112v39.904c0 .062-.042.113-.093.113h-1.733c-.05 0-.092-.05-.092-.113z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M4.693.542v39.676h12.612V.542zM1.475 4.148C.66 4.148 0 4.808 0 5.623v5.856a1.475 1.475 0 1 0 2.95 0V5.623c0-.814-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 11.479V5.623a1.087 1.087 0 1 1 2.174 0v5.856a1.087 1.087 0 0 1-2.174 0M0 5.623a1.475 1.475 0 0 1 2.95 0v5.856a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 27.79C.661 27.79 0 28.45 0 29.265v5.855a1.475 1.475 0 1 0 2.95 0v-5.855c0-.815-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 35.12v-5.855a1.087 1.087 0 0 1 2.174 0v5.855a1.087 1.087 0 0 1-2.174 0M0 29.265a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.526 4.148c-.815 0-1.475.66-1.475 1.475v5.856a1.475 1.475 0 1 0 2.95 0V5.623c0-.814-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 11.479V5.623a1.087 1.087 0 0 1 2.173 0v5.856a1.087 1.087 0 0 1-2.173 0m-.388-5.856a1.475 1.475 0 1 1 2.95 0v5.856a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.526 27.79c-.815 0-1.475.66-1.475 1.475v5.855a1.475 1.475 0 1 0 2.95 0v-5.855c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 35.12v-5.855a1.087 1.087 0 0 1 2.173 0v5.855a1.087 1.087 0 0 1-2.173 0m-.388-5.855a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          d: "M3.536 34.822h14.928c.78 0 1.273.838.894 1.52l-7.464 13.413c-.39.7-1.398.7-1.787 0L2.643 36.342c-.38-.682.113-1.52.893-1.52"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M12.34 50.003a1.534 1.534 0 0 1-2.68 0L2.196 36.59a1.534 1.534 0 0 1 1.34-2.279h14.928c1.17 0 1.91 1.257 1.34 2.28zm-1.787-.497c.195.35.699.35.894 0l7.464-13.413a.51.51 0 0 0-.447-.76H3.536a.51.51 0 0 0-.447.76z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M11 45.326a.76.76 0 0 1-.569-.245.82.82 0 0 1-.236-.59q0-.344.236-.59a.76.76 0 0 1 .57-.245q.33 0 .568.246.236.245.236.59a.82.82 0 0 1-.236.589.76.76 0 0 1-.569.245m0-2.505a.76.76 0 0 1-.569-.245.82.82 0 0 1-.236-.59v-3.34q0-.343.236-.589a.76.76 0 0 1 .57-.245q.33 0 .568.245.236.245.236.59v3.34a.82.82 0 0 1-.236.59.76.76 0 0 1-.569.244"
        }
      )
    ]
  }
);
const VehicleSConveyorUnplugged = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-conveyor-unplugged",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 51",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.762 40.92c.255 0 .461-.25.461-.56V1.353c0-.31-.206-.561-.46-.561H3.236c-.254 0-.46.251-.46.561V40.36c0 .31.206.56.46.56z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.855 1.353V40.36c0 .062-.042.112-.093.112H3.237c-.05 0-.092-.05-.092-.112V1.353c0-.062.042-.112.092-.112h15.525c.051 0 .093.05.093.112m.368 39.007c0 .31-.206.56-.46.56H3.236c-.254 0-.46-.25-.46-.56V1.353c0-.31.206-.561.46-.561h15.525c.255 0 .461.251.461.561z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.869.791c-.051 0-.093.05-.093.112v39.905c0 .062.042.112.093.112h1.733c.05 0 .092-.05.092-.112V.903c0-.062-.042-.112-.092-.112z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.145 1.24h1.18v39.231h-1.18zM2.776.903c0-.062.042-.112.093-.112h1.733c.05 0 .092.05.092.112v39.905c0 .062-.042.112-.092.112H2.869c-.051 0-.093-.05-.093-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.397.791c-.05 0-.092.05-.092.112v39.905c0 .062.041.112.092.112h1.733c.051 0 .093-.05.093-.112V.903c0-.062-.042-.112-.093-.112z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.674 1.24h1.18v39.231h-1.18zm-.369-.337c0-.062.041-.112.092-.112h1.733c.051 0 .093.05.093.112v39.905c0 .062-.042.112-.093.112h-1.733c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M4.693 1.027v39.675h12.612V1.027zM1.475 4.633C.66 4.633 0 5.293 0 6.108v5.855a1.475 1.475 0 1 0 2.95 0V6.108c0-.815-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 11.963V6.108a1.087 1.087 0 0 1 2.174 0v5.855a1.087 1.087 0 0 1-2.174 0M0 6.108a1.475 1.475 0 0 1 2.95 0v5.855a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 28.274c-.814 0-1.475.66-1.475 1.475v5.856a1.475 1.475 0 1 0 2.95 0v-5.856c0-.814-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 35.605v-5.856a1.087 1.087 0 1 1 2.174 0v5.856a1.087 1.087 0 0 1-2.174 0M0 29.749a1.475 1.475 0 1 1 2.95 0v5.856a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.526 4.633c-.815 0-1.475.66-1.475 1.475v5.855a1.475 1.475 0 1 0 2.95 0V6.108c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 11.963V6.108a1.087 1.087 0 0 1 2.173 0v5.855a1.087 1.087 0 0 1-2.173 0m-.388-5.855a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.526 28.274c-.815 0-1.475.66-1.475 1.475v5.856a1.475 1.475 0 1 0 2.95 0v-5.856c0-.814-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 35.605v-5.856a1.087 1.087 0 1 1 2.173 0v5.856a1.087 1.087 0 0 1-2.173 0m-.388-5.856a1.475 1.475 0 1 1 2.95 0v5.856a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          d: "M3.536 34.807h14.928c.78 0 1.273.839.894 1.52l-7.464 13.427a1.022 1.022 0 0 1-1.787 0L2.643 36.328c-.38-.682.113-1.521.893-1.521"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M12.34 50.002a1.533 1.533 0 0 1-2.68 0L2.196 36.576a1.535 1.535 0 0 1 1.34-2.281h14.928c1.17 0 1.91 1.258 1.34 2.281zm-1.787-.498c.195.35.699.35.894 0L18.91 36.08a.512.512 0 0 0-.447-.76H3.536c-.39 0-.636.419-.447.76z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M12.502 38.1c0-.166-.128-.3-.285-.3a.29.29 0 0 0-.285.3v1.962h-1.865V38.1c0-.166-.127-.3-.284-.3a.293.293 0 0 0-.285.3v1.962h-.645v1.203c.003 1.07.72 1.99 1.717 2.204v1.852h.86v-1.852c.996-.213 1.714-1.133 1.717-2.204v-1.208h-.645z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M6.705 37.263h8.59v8.596h-8.59z" }) }) })
    ]
  }
);
const VehicleSConveyor = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-conveyor",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 41",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.762 40.795c.255 0 .461-.25.461-.56V1.227c0-.31-.206-.562-.46-.562H3.236c-.254 0-.46.252-.46.562v39.006c0 .31.206.561.46.561z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.855 1.228v39.006c0 .062-.042.112-.093.112H3.237c-.05 0-.092-.05-.092-.112V1.228c0-.062.042-.113.092-.113h15.525c.051 0 .093.05.093.113m.368 39.006c0 .31-.206.561-.46.561H3.236c-.254 0-.46-.25-.46-.56V1.227c0-.31.206-.562.46-.562h15.525c.255 0 .461.252.461.562z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.869.666c-.051 0-.093.05-.093.112v39.904c0 .062.042.113.093.113h1.733c.05 0 .092-.05.092-.113V.778c0-.062-.042-.112-.092-.112z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.145 1.114h1.18v39.232h-1.18zM2.776.778c0-.062.042-.112.093-.112h1.733c.05 0 .092.05.092.112v39.904c0 .062-.042.113-.092.113H2.869c-.051 0-.093-.05-.093-.113z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.397.666c-.05 0-.092.05-.092.112v39.904c0 .062.041.113.092.113h1.733c.051 0 .093-.05.093-.113V.778c0-.062-.042-.112-.093-.112z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.674 1.114h1.18v39.232h-1.18zm-.369-.336c0-.062.041-.112.092-.112h1.733c.051 0 .093.05.093.112v39.904c0 .062-.042.113-.093.113h-1.733c-.05 0-.092-.05-.092-.113z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M4.693.901v39.676h12.612V.9zM1.475 4.507C.66 4.507 0 5.167 0 5.982v5.856a1.475 1.475 0 1 0 2.95 0V5.982c0-.814-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 11.838V5.982a1.087 1.087 0 0 1 2.174 0v5.856a1.087 1.087 0 0 1-2.174 0M0 5.982a1.475 1.475 0 0 1 2.95 0v5.856a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 28.149c-.814 0-1.475.66-1.475 1.475v5.855a1.475 1.475 0 1 0 2.95 0v-5.855c0-.815-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 35.48v-5.856a1.087 1.087 0 0 1 2.174 0v5.855a1.087 1.087 0 0 1-2.174 0M0 29.623a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.526 4.507c-.815 0-1.475.66-1.475 1.475v5.856a1.475 1.475 0 1 0 2.95 0V5.982c0-.814-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 11.838V5.982a1.087 1.087 0 0 1 2.173 0v5.856a1.087 1.087 0 0 1-2.173 0m-.388-5.856a1.475 1.475 0 1 1 2.95 0v5.856a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.526 28.149c-.815 0-1.475.66-1.475 1.475v5.855a1.475 1.475 0 1 0 2.95 0v-5.855c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 35.48v-5.856a1.087 1.087 0 0 1 2.173 0v5.855a1.087 1.087 0 0 1-2.173 0m-.388-5.856a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSForkLiftDisablePending = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-fork-lift-disable-pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 52",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.968 41.59c1.087 0 1.968-.956 1.968-2.135V26.516c0-1.18-.881-2.136-1.968-2.136S0 25.336 0 26.516v12.939c0 1.18.881 2.136 1.968 2.136M20.032 41.59c1.087 0 1.968-.956 1.968-2.135V26.516c0-1.18-.881-2.136-1.968-2.136s-1.968.956-1.968 2.136v12.939c0 1.18.881 2.136 1.968 2.136M3.985.795a.487.487 0 0 0-.487.488v13.16c0 .27.218.488.487.488h1.482c.269 0 .487-.218.487-.488V1.283a.487.487 0 0 0-.487-.488z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.888 14.443V1.283c0-.054.043-.098.097-.098h1.482c.053 0 .097.044.097.098v13.16a.1.1 0 0 1-.097.098H3.985a.1.1 0 0 1-.097-.098m-.39-13.16c0-.27.218-.488.487-.488h1.482c.269 0 .487.219.487.488v13.16c0 .27-.218.488-.487.488H3.985a.487.487 0 0 1-.487-.488z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M16.094.795a.487.487 0 0 0-.487.488v13.16c0 .27.218.488.487.488h1.482c.27 0 .487-.218.487-.488V1.283a.487.487 0 0 0-.487-.488z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M15.997 14.443V1.283c0-.054.044-.098.097-.098h1.482c.054 0 .097.044.097.098v13.16a.097.097 0 0 1-.097.098h-1.482a.097.097 0 0 1-.097-.098m-.39-13.16c0-.27.218-.488.487-.488h1.482c.27 0 .487.219.487.488v13.16c0 .27-.218.488-.487.488h-1.482a.487.487 0 0 1-.487-.488z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M3.123 14.627a.487.487 0 0 0-.488.487v.404c0 .27.218.488.488.488h15.186c.269 0 .487-.219.487-.488v-.404a.487.487 0 0 0-.487-.488z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.025 15.518v-.404c0-.054.044-.098.098-.098h15.186c.053 0 .097.044.097.098v.404a.097.097 0 0 1-.097.098H3.123a.1.1 0 0 1-.098-.098m-.39-.404c0-.27.218-.488.488-.488h15.186c.269 0 .487.219.487.488v.404c0 .27-.218.488-.487.488H3.123a.487.487 0 0 1-.488-.488z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.576 15.822H3.985a.487.487 0 0 0-.487.487v22.973c0 .199.119.378.306.444 1.399.495 4.449 1.22 6.89 1.22 2.454 0 5.463-.732 7.038-1.228a.48.48 0 0 0 .332-.458V16.31a.487.487 0 0 0-.488-.488"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.693 16.31c0-.162.13-.293.292-.293h13.592c.161 0 .292.13.292.292v22.952c0 .126-.08.235-.195.272-1.568.493-4.554 1.219-6.98 1.219-2.413 0-5.44-.72-6.825-1.21l-.064.182.064-.182a.27.27 0 0 1-.176-.26zm.292-.683a.68.68 0 0 0-.682.682v22.973a.66.66 0 0 0 .436.628c1.414.5 4.486 1.232 6.956 1.232 2.483 0 5.513-.74 7.096-1.237a.67.67 0 0 0 .468-.644V16.309a.68.68 0 0 0-.682-.682z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M2.367 15.822a1.13 1.13 0 0 0-1.13 1.13v4.489a1.13 1.13 0 0 0 2.26 0v-4.489a1.13 1.13 0 0 0-1.13-1.13M19.195 15.822a1.13 1.13 0 0 0-1.13 1.13v4.489a1.13 1.13 0 0 0 2.26 0v-4.489a1.13 1.13 0 0 0-1.13-1.13"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCF0DE",
          fillRule: "evenodd",
          stroke: "#F9D199",
          d: "M11 51.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F9D199",
          fillRule: "evenodd",
          d: "M2 42.795a9 9 0 1 1 18.001.002A9 9 0 0 1 2 42.795m9-8.052a8.053 8.053 0 1 0 .001 16.106A8.053 8.053 0 0 0 11 34.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          fillRule: "evenodd",
          d: "M13.924 41.138h-.474v-.948a2.37 2.37 0 0 0-4.736 0v.948H8.24a.95.95 0 0 0-.948.947v4.737a.95.95 0 0 0 .948.947h5.684a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.947M11.082 45.4a.95.95 0 0 1-.947-.948.95.95 0 0 1 .947-.947.95.95 0 0 1 .947.947.95.95 0 0 1-.947.948m1.468-4.263H9.614v-.948c0-.81.658-1.468 1.468-1.468s1.468.658 1.468 1.468z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSForkLiftDisabled = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-fork-lift-disabled",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 52",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.968 41.59c1.087 0 1.968-.956 1.968-2.135V26.516c0-1.18-.881-2.136-1.968-2.136S0 25.336 0 26.516v12.939c0 1.18.881 2.136 1.968 2.136M20.032 41.59c1.087 0 1.968-.956 1.968-2.135V26.516c0-1.18-.881-2.136-1.968-2.136s-1.968.956-1.968 2.136v12.939c0 1.18.881 2.136 1.968 2.136M3.985.795a.487.487 0 0 0-.487.488v13.16c0 .27.218.488.487.488h1.482c.269 0 .487-.218.487-.488V1.283a.487.487 0 0 0-.487-.488z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.888 14.443V1.283c0-.054.043-.098.097-.098h1.482c.053 0 .097.044.097.098v13.16a.1.1 0 0 1-.097.098H3.985a.1.1 0 0 1-.097-.098m-.39-13.16c0-.27.218-.488.487-.488h1.482c.269 0 .487.219.487.488v13.16c0 .27-.218.488-.487.488H3.985a.487.487 0 0 1-.487-.488z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M16.094.795a.487.487 0 0 0-.487.488v13.16c0 .27.218.488.487.488h1.482c.27 0 .487-.218.487-.488V1.283a.487.487 0 0 0-.487-.488z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M15.997 14.443V1.283c0-.054.044-.098.097-.098h1.482c.054 0 .097.044.097.098v13.16a.097.097 0 0 1-.097.098h-1.482a.097.097 0 0 1-.097-.098m-.39-13.16c0-.27.218-.488.487-.488h1.482c.27 0 .487.219.487.488v13.16c0 .27-.218.488-.487.488h-1.482a.487.487 0 0 1-.487-.488z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M3.123 14.627a.487.487 0 0 0-.488.487v.404c0 .27.218.488.488.488h15.186c.269 0 .487-.219.487-.488v-.404a.487.487 0 0 0-.487-.488z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.025 15.518v-.404c0-.054.044-.098.098-.098h15.186c.053 0 .097.044.097.098v.404a.097.097 0 0 1-.097.098H3.123a.1.1 0 0 1-.098-.098m-.39-.404c0-.27.218-.488.488-.488h15.186c.269 0 .487.219.487.488v.404c0 .27-.218.488-.487.488H3.123a.487.487 0 0 1-.488-.488z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.576 15.822H3.985a.487.487 0 0 0-.487.487v22.973c0 .199.119.378.306.444 1.399.495 4.449 1.22 6.89 1.22 2.454 0 5.463-.732 7.038-1.228a.48.48 0 0 0 .332-.458V16.31a.487.487 0 0 0-.488-.488"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.693 16.31c0-.162.13-.293.292-.293h13.592c.161 0 .292.13.292.292v22.952c0 .126-.08.235-.195.272-1.568.493-4.554 1.219-6.98 1.219-2.413 0-5.44-.72-6.825-1.21l-.064.182.064-.182a.27.27 0 0 1-.176-.26zm.292-.683a.68.68 0 0 0-.682.682v22.973a.66.66 0 0 0 .436.628c1.414.5 4.486 1.232 6.956 1.232 2.483 0 5.513-.74 7.096-1.237a.67.67 0 0 0 .468-.644V16.309a.68.68 0 0 0-.682-.682z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M2.367 15.822a1.13 1.13 0 0 0-1.13 1.13v4.489a1.13 1.13 0 0 0 2.26 0v-4.489a1.13 1.13 0 0 0-1.13-1.13M19.195 15.822a1.13 1.13 0 0 0-1.13 1.13v4.489a1.13 1.13 0 0 0 2.26 0v-4.489a1.13 1.13 0 0 0-1.13-1.13"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCEDEB",
          fillRule: "evenodd",
          stroke: "#F5B7B1",
          d: "M11 51.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F5B7B1",
          fillRule: "evenodd",
          d: "M2 42.795a9 9 0 1 1 18.001.002A9 9 0 0 1 2 42.795m9-8.052a8.053 8.053 0 1 0 .001 16.106A8.053 8.053 0 0 0 11 34.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          fillRule: "evenodd",
          d: "M13.924 41.138h-.474v-.948a2.37 2.37 0 0 0-4.736 0v.948H8.24a.95.95 0 0 0-.948.947v4.737a.95.95 0 0 0 .948.947h5.684a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.947M11.082 45.4a.95.95 0 0 1-.947-.948.95.95 0 0 1 .947-.947.95.95 0 0 1 .947.947.95.95 0 0 1-.947.948m1.468-4.263H9.614v-.948c0-.81.658-1.468 1.468-1.468s1.468.658 1.468 1.468z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSForkLiftEnablePending = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-fork-lift-enable-pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 52",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.968 41.59c1.087 0 1.968-.956 1.968-2.135V26.516c0-1.18-.881-2.136-1.968-2.136S0 25.336 0 26.516v12.939c0 1.18.881 2.136 1.968 2.136M20.032 41.59c1.087 0 1.968-.956 1.968-2.135V26.516c0-1.18-.881-2.136-1.968-2.136s-1.968.956-1.968 2.136v12.939c0 1.18.881 2.136 1.968 2.136M3.985.795a.487.487 0 0 0-.487.488v13.16c0 .27.218.488.487.488h1.482c.269 0 .487-.218.487-.488V1.283a.487.487 0 0 0-.487-.488z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.888 14.443V1.283c0-.054.043-.098.097-.098h1.482c.053 0 .097.044.097.098v13.16a.1.1 0 0 1-.097.098H3.985a.1.1 0 0 1-.097-.098m-.39-13.16c0-.27.218-.488.487-.488h1.482c.269 0 .487.219.487.488v13.16c0 .27-.218.488-.487.488H3.985a.487.487 0 0 1-.487-.488z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M16.094.795a.487.487 0 0 0-.487.488v13.16c0 .27.218.488.487.488h1.482c.27 0 .487-.218.487-.488V1.283a.487.487 0 0 0-.487-.488z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M15.997 14.443V1.283c0-.054.044-.098.097-.098h1.482c.054 0 .097.044.097.098v13.16a.097.097 0 0 1-.097.098h-1.482a.097.097 0 0 1-.097-.098m-.39-13.16c0-.27.218-.488.487-.488h1.482c.27 0 .487.219.487.488v13.16c0 .27-.218.488-.487.488h-1.482a.487.487 0 0 1-.487-.488z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M3.123 14.627a.487.487 0 0 0-.488.487v.404c0 .27.218.488.488.488h15.186c.269 0 .487-.219.487-.488v-.404a.487.487 0 0 0-.487-.488z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.025 15.518v-.404c0-.054.044-.098.098-.098h15.186c.053 0 .097.044.097.098v.404a.097.097 0 0 1-.097.098H3.123a.1.1 0 0 1-.098-.098m-.39-.404c0-.27.218-.488.488-.488h15.186c.269 0 .487.219.487.488v.404c0 .27-.218.488-.487.488H3.123a.487.487 0 0 1-.488-.488z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.576 15.822H3.985a.487.487 0 0 0-.487.487v22.973c0 .199.119.378.306.444 1.399.495 4.449 1.22 6.89 1.22 2.454 0 5.463-.732 7.038-1.228a.48.48 0 0 0 .332-.458V16.31a.487.487 0 0 0-.488-.488"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.693 16.31c0-.162.13-.293.292-.293h13.592c.161 0 .292.13.292.292v22.952c0 .126-.08.235-.195.272-1.568.493-4.554 1.219-6.98 1.219-2.413 0-5.44-.72-6.825-1.21l-.064.182.064-.182a.27.27 0 0 1-.176-.26zm.292-.683a.68.68 0 0 0-.682.682v22.973a.66.66 0 0 0 .436.628c1.414.5 4.486 1.232 6.956 1.232 2.483 0 5.513-.74 7.096-1.237a.67.67 0 0 0 .468-.644V16.309a.68.68 0 0 0-.682-.682z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M2.367 15.822a1.13 1.13 0 0 0-1.13 1.13v4.489a1.13 1.13 0 0 0 2.26 0v-4.489a1.13 1.13 0 0 0-1.13-1.13M19.195 15.822a1.13 1.13 0 0 0-1.13 1.13v4.489a1.13 1.13 0 0 0 2.26 0v-4.489a1.13 1.13 0 0 0-1.13-1.13"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#CFDEF2",
          fillRule: "evenodd",
          stroke: "#F5B7B1",
          d: "M11 51.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#8AB9F7",
          fillRule: "evenodd",
          d: "M2 42.795a9 9 0 1 1 18.001.002A9 9 0 0 1 2 42.795m9-8.052a8.053 8.053 0 1 0 .001 16.106A8.053 8.053 0 0 0 11 34.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1774F0",
          fillRule: "evenodd",
          d: "M11.082 45.164a.95.95 0 0 0 .947-.947.95.95 0 0 0-.947-.948.95.95 0 0 0-.947.948.95.95 0 0 0 .947.947m2.842-4.263h-.474v-.948a2.37 2.37 0 0 0-4.736 0h.9c0-.81.658-1.468 1.468-1.468s1.468.658 1.468 1.468v.948H8.24a.95.95 0 0 0-.948.947v4.737a.95.95 0 0 0 .948.947h5.684a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.947m0 5.684H8.24v-4.737h5.684z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSForkLiftNoSignal = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-fork-lift-no-signal",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 52",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.878 41.59c1.038 0 1.879-.956 1.879-2.135V26.516c0-1.18-.841-2.136-1.879-2.136C.841 24.38 0 25.336 0 26.516v12.939c0 1.18.84 2.136 1.878 2.136M19.122 41.59c1.037 0 1.878-.956 1.878-2.135V26.516c0-1.18-.841-2.136-1.878-2.136-1.038 0-1.879.956-1.879 2.136v12.939c0 1.18.841 2.136 1.879 2.136M3.804.795a.477.477 0 0 0-.465.488v13.16c0 .27.208.488.465.488h1.414a.477.477 0 0 0 .465-.488V1.283a.477.477 0 0 0-.465-.488z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.71 14.443V1.283c0-.054.042-.098.094-.098h1.414c.052 0 .093.044.093.098v13.16a.095.095 0 0 1-.093.098H3.804a.095.095 0 0 1-.093-.098M3.34 1.283c0-.27.208-.488.465-.488h1.414c.257 0 .465.219.465.488v13.16c0 .27-.208.488-.465.488H3.804a.477.477 0 0 1-.465-.488z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M15.363.795a.477.477 0 0 0-.465.488v13.16c0 .27.208.488.465.488h1.414a.477.477 0 0 0 .465-.488V1.283a.477.477 0 0 0-.465-.488z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M15.27 14.443V1.283c0-.054.041-.098.093-.098h1.414c.051 0 .093.044.093.098v13.16a.095.095 0 0 1-.093.098h-1.414a.095.095 0 0 1-.093-.098m-.372-13.16c0-.27.208-.488.465-.488h1.414c.257 0 .465.219.465.488v13.16c0 .27-.208.488-.465.488h-1.414a.477.477 0 0 1-.465-.488z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.98 14.627a.477.477 0 0 0-.465.487v.404c0 .27.209.488.466.488h14.495a.477.477 0 0 0 .466-.488v-.404a.477.477 0 0 0-.466-.488z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.888 15.518v-.404c0-.054.041-.098.093-.098h14.495c.052 0 .093.044.093.098v.404a.095.095 0 0 1-.093.098H2.981a.095.095 0 0 1-.093-.098m-.373-.404c0-.27.209-.488.466-.488h14.495c.257 0 .466.219.466.488v.404c0 .27-.209.488-.466.488H2.981a.477.477 0 0 1-.466-.488z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.778 15.822H3.803a.477.477 0 0 0-.465.487v22.973c0 .199.113.378.292.444 1.335.495 4.247 1.22 6.577 1.22 2.343 0 5.214-.732 6.718-1.228a.48.48 0 0 0 .317-.458V16.31a.477.477 0 0 0-.465-.488"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.525 16.31c0-.162.125-.293.28-.293h12.973c.154 0 .279.13.279.292v22.952a.28.28 0 0 1-.187.272c-1.496.493-4.347 1.219-6.661 1.219-2.305 0-5.194-.72-6.516-1.21l-.061.182.061-.182a.27.27 0 0 1-.168-.26zm.28-.683c-.36 0-.652.305-.652.682v22.973a.66.66 0 0 0 .416.628c1.35.5 4.282 1.232 6.64 1.232 2.37 0 5.263-.74 6.773-1.237a.67.67 0 0 0 .447-.644V16.309c0-.377-.291-.682-.651-.682z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M2.26 15.822c-.596 0-1.08.506-1.08 1.13v4.489c0 .624.484 1.13 1.08 1.13s1.079-.506 1.079-1.13v-4.489c0-.624-.483-1.13-1.08-1.13M18.323 15.822c-.596 0-1.08.506-1.08 1.13v4.489c0 .624.484 1.13 1.08 1.13s1.079-.506 1.079-1.13v-4.489c0-.624-.483-1.13-1.08-1.13"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M9.832 34.58a.915.915 0 0 1 1.337 0l7.172 7.515c.37.387.37 1.014 0 1.4L11.17 51.01a.915.915 0 0 1-1.337 0l-7.173-7.514a1.024 1.024 0 0 1 0-1.401z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#9DA9B6",
          fillRule: "evenodd",
          d: "M9.497 34.23a1.373 1.373 0 0 1 2.006 0l7.173 7.515c.554.58.554 1.52 0 2.101l-7.173 7.514c-.554.58-1.452.58-2.006 0l-7.172-7.514a1.536 1.536 0 0 1 0-2.101zm1.338.701a.46.46 0 0 0-.669 0l-7.173 7.514a.51.51 0 0 0 0 .7l7.173 7.515a.46.46 0 0 0 .669 0l7.172-7.514a.51.51 0 0 0 0-.7z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          d: "M13.495 39.156c0-.343-.398-.516-.63-.273l-2.426 2.542 3.056 3.201zm.161 6.73L7.84 39.792a.355.355 0 0 0-.518 0 .397.397 0 0 0 0 .543l2.081 2.18-2.633 2.758c-.231.243-.07.66.258.66h5.633l.474.496c.144.15.375.15.519 0a.393.393 0 0 0 .003-.543"
        }
      )
    ]
  }
);
const VehicleSForkLiftOff = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-fork-lift-off",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 52",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.968 41.59c1.087 0 1.968-.956 1.968-2.135V26.516c0-1.18-.881-2.136-1.968-2.136S0 25.336 0 26.516v12.939c0 1.18.881 2.136 1.968 2.136M20.032 41.59c1.087 0 1.968-.956 1.968-2.135V26.516c0-1.18-.881-2.136-1.968-2.136s-1.968.956-1.968 2.136v12.939c0 1.18.881 2.136 1.968 2.136M3.985.795a.487.487 0 0 0-.487.488v13.16c0 .27.218.488.487.488h1.482c.269 0 .487-.218.487-.488V1.283a.487.487 0 0 0-.487-.488z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.888 14.443V1.283c0-.054.043-.098.097-.098h1.482c.053 0 .097.044.097.098v13.16a.1.1 0 0 1-.097.098H3.985a.1.1 0 0 1-.097-.098m-.39-13.16c0-.27.218-.488.487-.488h1.482c.269 0 .487.219.487.488v13.16c0 .27-.218.488-.487.488H3.985a.487.487 0 0 1-.487-.488z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M16.094.795a.487.487 0 0 0-.487.488v13.16c0 .27.218.488.487.488h1.482c.27 0 .487-.218.487-.488V1.283a.487.487 0 0 0-.487-.488z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M15.997 14.443V1.283c0-.054.044-.098.097-.098h1.482c.054 0 .097.044.097.098v13.16a.097.097 0 0 1-.097.098h-1.482a.097.097 0 0 1-.097-.098m-.39-13.16c0-.27.218-.488.487-.488h1.482c.27 0 .487.219.487.488v13.16c0 .27-.218.488-.487.488h-1.482a.487.487 0 0 1-.487-.488z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M3.123 14.627a.487.487 0 0 0-.488.487v.404c0 .27.218.488.488.488h15.186c.269 0 .487-.219.487-.488v-.404a.487.487 0 0 0-.487-.488z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.025 15.518v-.404c0-.054.044-.098.098-.098h15.186c.053 0 .097.044.097.098v.404a.097.097 0 0 1-.097.098H3.123a.1.1 0 0 1-.098-.098m-.39-.404c0-.27.218-.488.488-.488h15.186c.269 0 .487.219.487.488v.404c0 .27-.218.488-.487.488H3.123a.487.487 0 0 1-.488-.488z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.576 15.822H3.985a.487.487 0 0 0-.487.487v22.973c0 .199.119.378.306.444 1.399.495 4.449 1.22 6.89 1.22 2.454 0 5.463-.732 7.038-1.228a.48.48 0 0 0 .332-.458V16.31a.487.487 0 0 0-.488-.488"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.693 16.31c0-.162.13-.293.292-.293h13.592c.161 0 .292.13.292.292v22.952c0 .126-.08.235-.195.272-1.568.493-4.554 1.219-6.98 1.219-2.413 0-5.44-.72-6.825-1.21l-.064.182.064-.182a.27.27 0 0 1-.176-.26zm.292-.683a.68.68 0 0 0-.682.682v22.973a.66.66 0 0 0 .436.628c1.414.5 4.486 1.232 6.956 1.232 2.483 0 5.513-.74 7.096-1.237a.67.67 0 0 0 .468-.644V16.309a.68.68 0 0 0-.682-.682z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M2.367 15.822a1.13 1.13 0 0 0-1.13 1.13v4.489a1.13 1.13 0 0 0 2.26 0v-4.489a1.13 1.13 0 0 0-1.13-1.13M19.195 15.822a1.13 1.13 0 0 0-1.13 1.13v4.489a1.13 1.13 0 0 0 2.26 0v-4.489a1.13 1.13 0 0 0-1.13-1.13"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M11 51.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M2 42.795a9 9 0 1 1 18.001.002A9 9 0 0 1 2 42.795m9-8.052a8.053 8.053 0 1 0 .001 16.106A8.053 8.053 0 0 0 11 34.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M7.472 42.796a3.528 3.528 0 1 0 7.056 0 3.528 3.528 0 0 0-7.056 0m-.893 0a4.421 4.421 0 1 0 8.842 0 4.421 4.421 0 0 0-8.842 0m2.615-.301a.55.55 0 0 0-.11.35q0 .209.11.35a.33.33 0 0 0 .273.14h3.066q.162 0 .273-.14a.55.55 0 0 0 .11-.35.55.55 0 0 0-.11-.35.33.33 0 0 0-.273-.142H9.467q-.163 0-.273.142",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSForkLiftOn = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-fork-lift-on",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 52",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.968 41.59c1.087 0 1.968-.956 1.968-2.135V26.516c0-1.18-.881-2.136-1.968-2.136S0 25.336 0 26.516v12.939c0 1.18.881 2.136 1.968 2.136M20.032 41.59c1.087 0 1.968-.956 1.968-2.135V26.516c0-1.18-.881-2.136-1.968-2.136s-1.968.956-1.968 2.136v12.939c0 1.18.881 2.136 1.968 2.136M3.985.795a.487.487 0 0 0-.487.488v13.16c0 .27.218.488.487.488h1.482c.269 0 .487-.218.487-.488V1.283a.487.487 0 0 0-.487-.488z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.888 14.443V1.283c0-.054.043-.098.097-.098h1.482c.053 0 .097.044.097.098v13.16a.1.1 0 0 1-.097.098H3.985a.1.1 0 0 1-.097-.098m-.39-13.16c0-.27.218-.488.487-.488h1.482c.269 0 .487.219.487.488v13.16c0 .27-.218.488-.487.488H3.985a.487.487 0 0 1-.487-.488z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M16.094.795a.487.487 0 0 0-.487.488v13.16c0 .27.218.488.487.488h1.482c.27 0 .487-.218.487-.488V1.283a.487.487 0 0 0-.487-.488z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M15.997 14.443V1.283c0-.054.044-.098.097-.098h1.482c.054 0 .097.044.097.098v13.16a.097.097 0 0 1-.097.098h-1.482a.097.097 0 0 1-.097-.098m-.39-13.16c0-.27.218-.488.487-.488h1.482c.27 0 .487.219.487.488v13.16c0 .27-.218.488-.487.488h-1.482a.487.487 0 0 1-.487-.488z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M3.123 14.627a.487.487 0 0 0-.488.487v.404c0 .27.218.488.488.488h15.186c.269 0 .487-.219.487-.488v-.404a.487.487 0 0 0-.487-.488z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.025 15.518v-.404c0-.054.044-.098.098-.098h15.186c.053 0 .097.044.097.098v.404a.097.097 0 0 1-.097.098H3.123a.1.1 0 0 1-.098-.098m-.39-.404c0-.27.218-.488.488-.488h15.186c.269 0 .487.219.487.488v.404c0 .27-.218.488-.487.488H3.123a.487.487 0 0 1-.488-.488z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.576 15.822H3.985a.487.487 0 0 0-.487.487v22.973c0 .199.119.378.306.444 1.399.495 4.449 1.22 6.89 1.22 2.454 0 5.463-.732 7.038-1.228a.48.48 0 0 0 .332-.458V16.31a.487.487 0 0 0-.488-.488"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.693 16.31c0-.162.13-.293.292-.293h13.592c.161 0 .292.13.292.292v22.952c0 .126-.08.235-.195.272-1.568.493-4.554 1.219-6.98 1.219-2.413 0-5.44-.72-6.825-1.21l-.064.182.064-.182a.27.27 0 0 1-.176-.26zm.292-.683a.68.68 0 0 0-.682.682v22.973a.66.66 0 0 0 .436.628c1.414.5 4.486 1.232 6.956 1.232 2.483 0 5.513-.74 7.096-1.237a.67.67 0 0 0 .468-.644V16.309a.68.68 0 0 0-.682-.682z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M2.367 15.822a1.13 1.13 0 0 0-1.13 1.13v4.489a1.13 1.13 0 0 0 2.26 0v-4.489a1.13 1.13 0 0 0-1.13-1.13M19.195 15.822a1.13 1.13 0 0 0-1.13 1.13v4.489a1.13 1.13 0 0 0 2.26 0v-4.489a1.13 1.13 0 0 0-1.13-1.13"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#03D8A9",
          fillRule: "evenodd",
          d: "M11 51.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M2 42.795a9 9 0 1 1 18.001.002A9 9 0 0 1 2 42.795m9-8.052a8.053 8.053 0 1 0 .001 16.106A8.053 8.053 0 0 0 11 34.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M11 43.286a.48.48 0 0 1-.35-.14.48.48 0 0 1-.142-.35v-3.93q0-.21.142-.35a.48.48 0 0 1 .35-.142q.208 0 .35.141.14.141.14.35v3.93q0 .21-.14.35a.48.48 0 0 1-.35.141m0 3.93q-.921 0-1.726-.35a4.5 4.5 0 0 1-1.4-.946 4.5 4.5 0 0 1-.945-1.4 4.3 4.3 0 0 1-.35-1.725q0-.847.307-1.621.306-.773.884-1.4a.45.45 0 0 1 .344-.147q.209 0 .356.147a.42.42 0 0 1 .123.338.6.6 0 0 1-.148.362q-.429.48-.657 1.075a3.5 3.5 0 0 0-.227 1.246q0 1.437 1 2.438 1.001 1 2.439 1 1.437 0 2.437-1 1.001-1 1.001-2.438 0-.65-.233-1.259a3.5 3.5 0 0 0-.663-1.087.52.52 0 0 1-.142-.343.43.43 0 0 1 .13-.332.49.49 0 0 1 .356-.147q.208 0 .344.147.576.627.884 1.4.307.774.307 1.621 0 .922-.35 1.725a4.5 4.5 0 0 1-.946 1.4 4.5 4.5 0 0 1-1.4.946 4.3 4.3 0 0 1-1.725.35"
        }
      )
    ]
  }
);
const VehicleSForkLiftUnavailable = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-fork-lift-unavailable",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 52",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.968 41.586c1.087 0 1.968-.956 1.968-2.136V26.512c0-1.18-.881-2.136-1.968-2.136S0 25.332 0 26.512V39.45c0 1.18.881 2.136 1.968 2.136M20.032 41.586c1.087 0 1.968-.956 1.968-2.136V26.512c0-1.18-.88-2.136-1.968-2.136-1.087 0-1.968.956-1.968 2.136V39.45c0 1.18.881 2.136 1.968 2.136M3.985.791a.487.487 0 0 0-.487.487v13.16c0 .27.218.488.487.488h1.482c.269 0 .487-.218.487-.487V1.279A.487.487 0 0 0 5.467.79z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.888 14.439V1.279c0-.054.043-.098.097-.098h1.482c.054 0 .097.044.097.097v13.16a.1.1 0 0 1-.097.098H3.985a.1.1 0 0 1-.097-.097m-.39-13.16c0-.27.218-.488.487-.488h1.482c.269 0 .487.218.487.487v13.16c0 .27-.218.488-.487.488H3.985a.487.487 0 0 1-.487-.487z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M16.095.791a.487.487 0 0 0-.488.487v13.16c0 .27.218.488.488.488h1.481c.27 0 .488-.218.488-.487V1.279a.487.487 0 0 0-.488-.488z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M15.997 14.439V1.279c0-.054.044-.098.098-.098h1.481c.054 0 .098.044.098.097v13.16a.1.1 0 0 1-.098.098h-1.481a.1.1 0 0 1-.098-.097m-.39-13.16c0-.27.218-.488.488-.488h1.481c.27 0 .488.218.488.487v13.16c0 .27-.219.488-.488.488h-1.481a.487.487 0 0 1-.488-.487z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M3.123 14.622a.487.487 0 0 0-.488.488v.404c0 .269.219.487.488.487h15.186c.27 0 .487-.218.487-.487v-.404a.487.487 0 0 0-.487-.488z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.025 15.514v-.404c0-.054.044-.098.098-.098h15.186c.054 0 .097.044.097.098v.404a.097.097 0 0 1-.097.097H3.123a.1.1 0 0 1-.098-.097m-.39-.404c0-.27.219-.488.488-.488h15.186c.27 0 .487.218.487.488v.404c0 .269-.218.487-.487.487H3.123a.487.487 0 0 1-.488-.487z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.577 15.817H3.985a.487.487 0 0 0-.487.488v22.973c0 .198.119.377.306.443 1.399.496 4.449 1.221 6.89 1.221 2.455 0 5.463-.733 7.038-1.228a.48.48 0 0 0 .332-.458V16.305a.487.487 0 0 0-.487-.488"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.693 16.305c0-.162.131-.293.293-.293h13.591c.161 0 .292.131.292.293v22.951c0 .127-.08.236-.195.272-1.568.493-4.554 1.22-6.979 1.22-2.414 0-5.441-.72-6.825-1.21l-.065.182.065-.182a.27.27 0 0 1-.177-.26zm.293-.682a.68.68 0 0 0-.683.682v22.973a.66.66 0 0 0 .436.627c1.414.5 4.486 1.232 6.956 1.232 2.483 0 5.514-.739 7.096-1.237a.67.67 0 0 0 .468-.644V16.305a.68.68 0 0 0-.682-.682z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M2.368 15.817a1.13 1.13 0 0 0-1.13 1.13v4.49a1.13 1.13 0 0 0 2.26 0v-4.49a1.13 1.13 0 0 0-1.13-1.13M19.195 15.817a1.13 1.13 0 0 0-1.13 1.13v4.49a1.13 1.13 0 0 0 2.26 0v-4.49a1.13 1.13 0 0 0-1.13-1.13"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          d: "M3.536 35.822h14.928c.78 0 1.273.838.894 1.52l-7.464 13.413c-.39.7-1.398.7-1.787 0L2.643 37.342c-.38-.682.113-1.52.893-1.52"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M12.34 51.003a1.534 1.534 0 0 1-2.68 0L2.196 37.59a1.534 1.534 0 0 1 1.34-2.279h14.928c1.17 0 1.91 1.257 1.34 2.28zm-1.787-.497c.195.35.699.35.894 0l7.464-13.413a.51.51 0 0 0-.447-.76H3.536a.51.51 0 0 0-.447.76z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M11 46.326a.76.76 0 0 1-.569-.245.82.82 0 0 1-.236-.59q0-.344.236-.59a.76.76 0 0 1 .57-.245q.33 0 .568.246.236.245.236.59a.82.82 0 0 1-.236.589.76.76 0 0 1-.569.245m0-2.505a.76.76 0 0 1-.569-.245.82.82 0 0 1-.236-.59v-3.34q0-.343.236-.589a.76.76 0 0 1 .57-.245q.33 0 .568.245.236.245.236.59v3.34a.82.82 0 0 1-.236.59.76.76 0 0 1-.569.244"
        }
      )
    ]
  }
);
const VehicleSForkLiftUnplugged = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-fork-lift-unplugged",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 52",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.968 41.59c1.087 0 1.968-.956 1.968-2.135V26.516c0-1.18-.881-2.136-1.968-2.136S0 25.336 0 26.516v12.939c0 1.18.881 2.136 1.968 2.136M20.032 41.59c1.087 0 1.968-.956 1.968-2.135V26.516c0-1.18-.881-2.136-1.968-2.136s-1.968.956-1.968 2.136v12.939c0 1.18.881 2.136 1.968 2.136M3.985.795a.487.487 0 0 0-.487.488v13.16c0 .27.218.488.487.488h1.482c.269 0 .487-.218.487-.488V1.283a.487.487 0 0 0-.487-.488z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.888 14.443V1.283c0-.054.043-.098.097-.098h1.482c.053 0 .097.044.097.098v13.16a.1.1 0 0 1-.097.098H3.985a.1.1 0 0 1-.097-.098m-.39-13.16c0-.27.218-.488.487-.488h1.482c.269 0 .487.219.487.488v13.16c0 .27-.218.488-.487.488H3.985a.487.487 0 0 1-.487-.488z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M16.094.795a.487.487 0 0 0-.487.488v13.16c0 .27.218.488.487.488h1.482c.27 0 .487-.218.487-.488V1.283a.487.487 0 0 0-.487-.488z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M15.997 14.443V1.283c0-.054.044-.098.097-.098h1.482c.054 0 .097.044.097.098v13.16a.097.097 0 0 1-.097.098h-1.482a.097.097 0 0 1-.097-.098m-.39-13.16c0-.27.218-.488.487-.488h1.482c.27 0 .487.219.487.488v13.16c0 .27-.218.488-.487.488h-1.482a.487.487 0 0 1-.487-.488z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M3.123 14.627a.487.487 0 0 0-.488.487v.404c0 .27.218.488.488.488h15.186c.269 0 .487-.219.487-.488v-.404a.487.487 0 0 0-.487-.488z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.025 15.518v-.404c0-.054.044-.098.098-.098h15.186c.053 0 .097.044.097.098v.404a.097.097 0 0 1-.097.098H3.123a.1.1 0 0 1-.098-.098m-.39-.404c0-.27.218-.488.488-.488h15.186c.269 0 .487.219.487.488v.404c0 .27-.218.488-.487.488H3.123a.487.487 0 0 1-.488-.488z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.576 15.822H3.985a.487.487 0 0 0-.487.487v22.973c0 .199.119.378.306.444 1.399.495 4.449 1.22 6.89 1.22 2.454 0 5.463-.732 7.038-1.228a.48.48 0 0 0 .332-.458V16.31a.487.487 0 0 0-.488-.488"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.693 16.31c0-.162.13-.293.292-.293h13.592c.161 0 .292.13.292.292v22.952c0 .126-.08.235-.195.272-1.568.493-4.554 1.219-6.98 1.219-2.413 0-5.44-.72-6.825-1.21l-.064.182.064-.182a.27.27 0 0 1-.176-.26zm.292-.683a.68.68 0 0 0-.682.682v22.973a.66.66 0 0 0 .436.628c1.414.5 4.486 1.232 6.956 1.232 2.483 0 5.513-.74 7.096-1.237a.67.67 0 0 0 .468-.644V16.309a.68.68 0 0 0-.682-.682z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M2.367 15.822a1.13 1.13 0 0 0-1.13 1.13v4.489a1.13 1.13 0 0 0 2.26 0v-4.489a1.13 1.13 0 0 0-1.13-1.13M19.195 15.822a1.13 1.13 0 0 0-1.13 1.13v4.489a1.13 1.13 0 0 0 2.26 0v-4.489a1.13 1.13 0 0 0-1.13-1.13"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          d: "M3.536 35.807h14.928c.78 0 1.273.839.894 1.52l-7.464 13.427a1.022 1.022 0 0 1-1.787 0L2.643 37.328c-.38-.682.113-1.521.893-1.521"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M12.34 51.002a1.533 1.533 0 0 1-2.68 0L2.196 37.576a1.535 1.535 0 0 1 1.34-2.281h14.928c1.17 0 1.91 1.258 1.34 2.281zm-1.787-.498c.195.35.699.35.894 0L18.91 37.08a.512.512 0 0 0-.447-.76H3.536c-.39 0-.636.419-.447.76z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M12.502 39.1c0-.166-.128-.3-.285-.3a.29.29 0 0 0-.285.3v1.962h-1.865V39.1c0-.166-.127-.3-.284-.3a.293.293 0 0 0-.285.3v1.962h-.645v1.203c.003 1.07.72 1.99 1.717 2.204v1.852h.86v-1.852c.996-.213 1.714-1.133 1.717-2.204v-1.208h-.645z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M6.705 38.263h8.59v8.596h-8.59z" }) }) })
    ]
  }
);
const VehicleSForkLift = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-fork-lift",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 41",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.968 40.795c1.087 0 1.968-.956 1.968-2.136V25.721c0-1.18-.881-2.136-1.968-2.136S0 24.54 0 25.72v12.938c0 1.18.881 2.136 1.968 2.136M20.032 40.795c1.087 0 1.968-.956 1.968-2.136V25.721c0-1.18-.881-2.136-1.968-2.136s-1.968.956-1.968 2.136v12.938c0 1.18.881 2.136 1.968 2.136M3.985 0a.487.487 0 0 0-.487.487v13.16c0 .27.218.488.487.488h1.482c.269 0 .487-.218.487-.487V.488A.487.487 0 0 0 5.467 0z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.888 13.648V.488c0-.054.043-.098.097-.098h1.482c.053 0 .097.044.097.097v13.16a.1.1 0 0 1-.097.098H3.985a.1.1 0 0 1-.097-.097M3.498.488c0-.27.218-.488.487-.488h1.482c.269 0 .487.218.487.487v13.16c0 .27-.218.488-.487.488H3.985a.487.487 0 0 1-.487-.487z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M16.094 0a.487.487 0 0 0-.487.487v13.16c0 .27.218.488.487.488h1.482c.27 0 .487-.218.487-.487V.488A.487.487 0 0 0 17.576 0z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M15.997 13.648V.488c0-.054.044-.098.097-.098h1.482c.054 0 .097.044.097.097v13.16a.097.097 0 0 1-.097.098h-1.482a.097.097 0 0 1-.097-.097m-.39-13.16c0-.27.218-.488.487-.488h1.482c.27 0 .487.218.487.487v13.16c0 .27-.218.488-.487.488h-1.482a.487.487 0 0 1-.487-.487z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M3.123 13.831a.487.487 0 0 0-.488.488v.404c0 .269.218.487.488.487h15.186c.269 0 .487-.218.487-.487v-.405a.487.487 0 0 0-.487-.487z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.025 14.723v-.405c0-.053.044-.097.098-.097h15.186c.053 0 .097.044.097.098v.404a.097.097 0 0 1-.097.097H3.123a.1.1 0 0 1-.098-.097m-.39-.405c0-.269.218-.487.488-.487h15.186c.269 0 .487.218.487.488v.404c0 .269-.218.487-.487.487H3.123a.487.487 0 0 1-.488-.487z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.576 15.026H3.985a.487.487 0 0 0-.487.488v22.972c0 .199.119.378.306.444 1.399.496 4.449 1.221 6.89 1.221 2.454 0 5.463-.733 7.038-1.228a.48.48 0 0 0 .332-.458V15.514a.487.487 0 0 0-.488-.488"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.693 15.514c0-.162.13-.292.292-.292h13.592c.161 0 .292.13.292.292v22.951c0 .127-.08.236-.195.272-1.568.493-4.554 1.22-6.98 1.22-2.413 0-5.44-.72-6.825-1.21l-.064.182.064-.182a.27.27 0 0 1-.176-.26zm.292-.682a.68.68 0 0 0-.682.682v22.973a.66.66 0 0 0 .436.627c1.414.5 4.486 1.232 6.956 1.232 2.483 0 5.513-.739 7.096-1.237a.67.67 0 0 0 .468-.644V15.514a.68.68 0 0 0-.682-.682z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M2.367 15.026a1.13 1.13 0 0 0-1.13 1.13v4.49a1.13 1.13 0 1 0 2.26 0v-4.49a1.13 1.13 0 0 0-1.13-1.13M19.195 15.026a1.13 1.13 0 0 0-1.13 1.13v4.49a1.13 1.13 0 1 0 2.26 0v-4.49a1.13 1.13 0 0 0-1.13-1.13"
        }
      )
    ]
  }
);
const VehicleSGpuApuDisablePending = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-gpu-apu-disable-pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 43",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.758 32.628c.255 0 .461-.2.461-.445V1.24a.453.453 0 0 0-.46-.445H3.24c-.254 0-.46.2-.46.445v30.942c0 .246.206.445.46.445z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.85 1.241v30.942a.09.09 0 0 1-.092.089H3.241a.09.09 0 0 1-.092-.09V1.243a.09.09 0 0 1 .092-.09h15.517c.051 0 .093.04.093.09m.369 30.942a.453.453 0 0 1-.46.445H3.24c-.254 0-.46-.2-.46-.445V1.24c0-.245.206-.445.46-.445h15.517c.255 0 .461.2.461.445z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.872.795a.09.09 0 0 0-.092.09v31.653c0 .05.042.089.092.089h1.733a.09.09 0 0 0 .092-.089V.884a.09.09 0 0 0-.092-.089z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.149 1.152h1.18V32.27h-1.18zM2.78.884a.09.09 0 0 1 .092-.089h1.733c.05 0 .092.04.092.09v31.653a.09.09 0 0 1-.092.089H2.872a.09.09 0 0 1-.092-.089z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.394.795a.09.09 0 0 0-.092.09v31.653c0 .05.041.089.092.089h1.732a.09.09 0 0 0 .092-.089V.884a.09.09 0 0 0-.092-.089z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.67 1.152h1.18V32.27h-1.18zm-.368-.268a.09.09 0 0 1 .092-.089h1.732c.051 0 .092.04.092.09v31.653a.09.09 0 0 1-.092.089h-1.732a.09.09 0 0 1-.092-.089z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M6.25 14.716a.795.795 0 1 0 0 1.59h9.501a.795.795 0 0 0 0-1.59zM6.25 19.525a.795.795 0 1 0 0 1.59h9.501a.795.795 0 0 0 0-1.59zM6.25 12.312a.795.795 0 0 0 0 1.59h9.501a.795.795 0 1 0 0-1.59zM6.25 17.122a.795.795 0 1 0 0 1.59h9.501a.795.795 0 0 0 0-1.59zM1.474 2.23C.66 2.23 0 2.89 0 3.704v5.853a1.474 1.474 0 1 0 2.948 0V3.704c0-.814-.66-1.474-1.474-1.474M20.526 2.23c-.814 0-1.474.66-1.474 1.474v5.853a1.474 1.474 0 0 0 2.948 0V3.704c0-.814-.66-1.474-1.474-1.474M1.81 22.468c-.815 0-1.475.66-1.475 1.474v5.852a1.474 1.474 0 1 0 2.948 0v-5.852c0-.814-.66-1.474-1.474-1.474M20.526 22.468c-.814 0-1.474.66-1.474 1.474v5.852a1.474 1.474 0 0 0 2.948 0v-5.852c0-.814-.66-1.474-1.474-1.474"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCF0DE",
          fillRule: "evenodd",
          stroke: "#F9D199",
          d: "M11 42.322A8.527 8.527 0 1 0 11 25.268 8.527 8.527 0 0 0 11 42.322Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F9D199",
          fillRule: "evenodd",
          d: "M2 33.795a9 9 0 1 1 18.002.002A9 9 0 0 1 2 33.795m9-8.052a8.053 8.053 0 1 0 .002 16.106A8.053 8.053 0 0 0 11 25.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          fillRule: "evenodd",
          d: "M13.924 32.138h-.473v-.948a2.37 2.37 0 0 0-4.737 0v.948H8.24a.95.95 0 0 0-.947.947v4.737a.95.95 0 0 0 .947.947h5.684a.95.95 0 0 0 .948-.947v-4.737a.95.95 0 0 0-.948-.947M11.082 36.4a.95.95 0 0 1-.947-.948.95.95 0 0 1 .947-.947.95.95 0 0 1 .948.947.95.95 0 0 1-.948.948m1.469-4.263H9.614v-.948c0-.81.658-1.468 1.468-1.468s1.469.658 1.469 1.468z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSGpuApuDisabled = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-gpu-apu-disabled",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 43",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.758 32.628c.255 0 .46-.2.46-.445V1.24a.453.453 0 0 0-.46-.445H3.241c-.255 0-.46.2-.46.445v30.942c0 .246.205.445.46.445z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.85 1.241v30.942a.09.09 0 0 1-.092.089H3.241a.09.09 0 0 1-.092-.09V1.243a.09.09 0 0 1 .092-.09h15.517c.051 0 .092.04.092.09m.369 30.942a.453.453 0 0 1-.46.445H3.24c-.255 0-.46-.2-.46-.445V1.24c0-.245.205-.445.46-.445h15.517c.255 0 .46.2.46.445z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.872.795a.09.09 0 0 0-.092.09v31.653c0 .05.041.089.092.089h1.732a.09.09 0 0 0 .092-.089V.884a.09.09 0 0 0-.092-.089z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.149 1.152h1.179V32.27h-1.18zM2.78.884a.09.09 0 0 1 .092-.089h1.732c.051 0 .092.04.092.09v31.653a.09.09 0 0 1-.092.089H2.872a.09.09 0 0 1-.092-.089z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.394.795a.09.09 0 0 0-.092.09v31.653c0 .05.041.089.092.089h1.732a.09.09 0 0 0 .092-.089V.884a.09.09 0 0 0-.092-.089z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.67 1.152h1.18V32.27h-1.18zm-.368-.268a.09.09 0 0 1 .092-.089h1.732c.051 0 .092.04.092.09v31.653a.09.09 0 0 1-.092.089h-1.732a.09.09 0 0 1-.092-.089z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M6.249 14.716a.795.795 0 1 0 0 1.59h9.502a.795.795 0 0 0 0-1.59zM6.249 19.525a.795.795 0 1 0 0 1.59h9.502a.795.795 0 0 0 0-1.59zM6.249 12.312a.795.795 0 0 0 0 1.59h9.502a.795.795 0 1 0 0-1.59zM6.249 17.122a.795.795 0 1 0 0 1.59h9.502a.795.795 0 0 0 0-1.59zM1.474 2.23C.66 2.23 0 2.89 0 3.704v5.853a1.474 1.474 0 1 0 2.948 0V3.704c0-.814-.66-1.474-1.474-1.474M20.526 2.23c-.814 0-1.474.66-1.474 1.474v5.853a1.474 1.474 0 1 0 2.948 0V3.704c0-.814-.66-1.474-1.474-1.474M1.809 22.468c-.814 0-1.474.66-1.474 1.474v5.852a1.474 1.474 0 1 0 2.948 0v-5.852c0-.814-.66-1.474-1.474-1.474M20.526 22.468c-.814 0-1.474.66-1.474 1.474v5.852a1.474 1.474 0 1 0 2.948 0v-5.852c0-.814-.66-1.474-1.474-1.474"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCEDEB",
          fillRule: "evenodd",
          stroke: "#F5B7B1",
          d: "M11 42.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F5B7B1",
          fillRule: "evenodd",
          d: "M2 33.795a9 9 0 1 1 18.001.002A9 9 0 0 1 2 33.795m9-8.052a8.053 8.053 0 1 0 .001 16.106A8.053 8.053 0 0 0 11 25.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          fillRule: "evenodd",
          d: "M13.924 32.138h-.474v-.948a2.37 2.37 0 0 0-4.736 0v.948H8.24a.95.95 0 0 0-.948.947v4.737a.95.95 0 0 0 .948.947h5.684a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.947M11.082 36.4a.95.95 0 0 1-.947-.948.95.95 0 0 1 .947-.947.95.95 0 0 1 .947.947.95.95 0 0 1-.947.948m1.468-4.263H9.614v-.948c0-.81.658-1.468 1.468-1.468s1.468.658 1.468 1.468z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSGpuApuEnablePending = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-gpu-apu-enable-pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 43",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.758 32.628c.255 0 .46-.2.46-.445V1.24a.453.453 0 0 0-.46-.445H3.241c-.255 0-.46.2-.46.445v30.942c0 .246.205.445.46.445z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.85 1.241v30.942a.09.09 0 0 1-.092.089H3.241a.09.09 0 0 1-.092-.09V1.243a.09.09 0 0 1 .092-.09h15.517c.051 0 .092.04.092.09m.369 30.942a.453.453 0 0 1-.46.445H3.24c-.255 0-.46-.2-.46-.445V1.24c0-.245.205-.445.46-.445h15.517c.255 0 .46.2.46.445z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.872.795a.09.09 0 0 0-.092.09v31.653c0 .05.041.089.092.089h1.732a.09.09 0 0 0 .092-.089V.884a.09.09 0 0 0-.092-.089z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.149 1.152h1.179V32.27h-1.18zM2.78.884a.09.09 0 0 1 .092-.089h1.732c.051 0 .092.04.092.09v31.653a.09.09 0 0 1-.092.089H2.872a.09.09 0 0 1-.092-.089z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.394.795a.09.09 0 0 0-.092.09v31.653c0 .05.041.089.092.089h1.732a.09.09 0 0 0 .092-.089V.884a.09.09 0 0 0-.092-.089z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.67 1.152h1.18V32.27h-1.18zm-.368-.268a.09.09 0 0 1 .092-.089h1.732c.051 0 .092.04.092.09v31.653a.09.09 0 0 1-.092.089h-1.732a.09.09 0 0 1-.092-.089z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M6.249 14.716a.795.795 0 1 0 0 1.59h9.502a.795.795 0 0 0 0-1.59zM6.249 19.525a.795.795 0 1 0 0 1.59h9.502a.795.795 0 0 0 0-1.59zM6.249 12.312a.795.795 0 0 0 0 1.59h9.502a.795.795 0 1 0 0-1.59zM6.249 17.122a.795.795 0 1 0 0 1.59h9.502a.795.795 0 0 0 0-1.59zM1.474 2.23C.66 2.23 0 2.89 0 3.704v5.853a1.474 1.474 0 1 0 2.948 0V3.704c0-.814-.66-1.474-1.474-1.474M20.526 2.23c-.814 0-1.474.66-1.474 1.474v5.853a1.474 1.474 0 1 0 2.948 0V3.704c0-.814-.66-1.474-1.474-1.474M1.809 22.468c-.814 0-1.474.66-1.474 1.474v5.852a1.474 1.474 0 1 0 2.948 0v-5.852c0-.814-.66-1.474-1.474-1.474M20.526 22.468c-.814 0-1.474.66-1.474 1.474v5.852a1.474 1.474 0 1 0 2.948 0v-5.852c0-.814-.66-1.474-1.474-1.474"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#CFDEF2",
          fillRule: "evenodd",
          stroke: "#F5B7B1",
          d: "M11 42.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#8AB9F7",
          fillRule: "evenodd",
          d: "M2 33.795a9 9 0 1 1 18.001.002A9 9 0 0 1 2 33.795m9-8.052a8.053 8.053 0 1 0 .001 16.106A8.053 8.053 0 0 0 11 25.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1774F0",
          fillRule: "evenodd",
          d: "M11.082 36.164a.95.95 0 0 0 .947-.947.95.95 0 0 0-.947-.948.95.95 0 0 0-.947.948.95.95 0 0 0 .947.947m2.842-4.263h-.474v-.948a2.37 2.37 0 0 0-4.736 0h.9c0-.81.658-1.468 1.468-1.468s1.468.658 1.468 1.468v.948H8.24a.95.95 0 0 0-.948.947v4.737a.95.95 0 0 0 .948.947h5.684a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.947m0 5.684H8.24v-4.737h5.684z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSGpuApuNoSignal = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-gpu-apu-no-signal",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 43",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.758 32.628c.255 0 .461-.2.461-.445V1.24a.453.453 0 0 0-.46-.445H3.24c-.254 0-.46.2-.46.445v30.942c0 .246.206.445.46.445z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.85 1.241v30.942a.09.09 0 0 1-.092.089H3.241a.09.09 0 0 1-.092-.09V1.243a.09.09 0 0 1 .092-.09h15.517c.051 0 .093.04.093.09m.369 30.942a.453.453 0 0 1-.46.445H3.24c-.254 0-.46-.2-.46-.445V1.24c0-.245.206-.445.46-.445h15.517c.255 0 .461.2.461.445z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.872.795a.09.09 0 0 0-.092.09v31.653c0 .05.042.089.092.089h1.733a.09.09 0 0 0 .092-.089V.884a.09.09 0 0 0-.092-.089z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.149 1.152h1.18V32.27h-1.18zM2.78.884a.09.09 0 0 1 .092-.089h1.733c.05 0 .092.04.092.09v31.653a.09.09 0 0 1-.092.089H2.872a.09.09 0 0 1-.092-.089z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.394.795a.09.09 0 0 0-.092.09v31.653c0 .05.041.089.092.089h1.732a.09.09 0 0 0 .092-.089V.884a.09.09 0 0 0-.092-.089z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.67 1.152h1.18V32.27h-1.18zm-.368-.268a.09.09 0 0 1 .092-.089h1.732c.051 0 .092.04.092.09v31.653a.09.09 0 0 1-.092.089h-1.732a.09.09 0 0 1-.092-.089z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M6.25 14.716a.795.795 0 1 0 0 1.59h9.501a.795.795 0 0 0 0-1.59zM6.25 19.525a.795.795 0 1 0 0 1.59h9.501a.795.795 0 0 0 0-1.59zM6.25 12.312a.795.795 0 0 0 0 1.59h9.501a.795.795 0 1 0 0-1.59zM6.25 17.122a.795.795 0 1 0 0 1.59h9.501a.795.795 0 0 0 0-1.59zM1.474 2.23C.66 2.23 0 2.89 0 3.704v5.853a1.474 1.474 0 1 0 2.948 0V3.704c0-.814-.66-1.474-1.474-1.474M20.526 2.23c-.814 0-1.474.66-1.474 1.474v5.853a1.474 1.474 0 0 0 2.948 0V3.704c0-.814-.66-1.474-1.474-1.474M1.81 22.468c-.815 0-1.475.66-1.475 1.474v5.852a1.474 1.474 0 1 0 2.948 0v-5.852c0-.814-.66-1.474-1.474-1.474M20.526 22.468c-.814 0-1.474.66-1.474 1.474v5.852a1.474 1.474 0 0 0 2.948 0v-5.852c0-.814-.66-1.474-1.474-1.474"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M10.3 25.58a.99.99 0 0 1 1.4 0l7.515 7.515a.99.99 0 0 1 0 1.4L11.7 42.01a.99.99 0 0 1-1.401 0l-7.514-7.514a.99.99 0 0 1 0-1.401z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#9DA9B6",
          fillRule: "evenodd",
          d: "M9.95 25.23c.58-.58 1.52-.58 2.1 0l7.515 7.515c.58.58.58 1.52 0 2.101l-7.514 7.514c-.58.58-1.521.58-2.101 0l-7.515-7.514a1.486 1.486 0 0 1 0-2.101zm1.4.701a.495.495 0 0 0-.7 0l-7.514 7.514a.495.495 0 0 0 0 .7l7.514 7.515a.495.495 0 0 0 .7 0l7.515-7.514a.495.495 0 0 0 0-.7z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          d: "M14.137 30.156a.386.386 0 0 0-.659-.273l-2.542 2.542 3.201 3.201zm.17 6.73-6.095-6.094a.384.384 0 1 0-.543.543l2.18 2.18-2.758 2.758a.385.385 0 0 0 .27.66h5.902l.497.496c.15.15.393.15.543 0a.38.38 0 0 0 .004-.543"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M6.048 28.843h9.245v9.245H6.048z" }) }) })
    ]
  }
);
const VehicleSGpuApuOff = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-gpu-apu-off",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 43",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.758 32.628c.255 0 .46-.2.46-.445V1.24a.453.453 0 0 0-.46-.445H3.241c-.255 0-.46.2-.46.445v30.942c0 .246.205.445.46.445z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.85 1.241v30.942a.09.09 0 0 1-.092.089H3.241a.09.09 0 0 1-.092-.09V1.243a.09.09 0 0 1 .092-.09h15.517c.051 0 .092.04.092.09m.369 30.942a.453.453 0 0 1-.46.445H3.24c-.255 0-.46-.2-.46-.445V1.24c0-.245.205-.445.46-.445h15.517c.255 0 .46.2.46.445z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.872.795a.09.09 0 0 0-.092.09v31.653c0 .05.041.089.092.089h1.732a.09.09 0 0 0 .092-.089V.884a.09.09 0 0 0-.092-.089z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.149 1.152h1.179V32.27h-1.18zM2.78.884a.09.09 0 0 1 .092-.089h1.732c.051 0 .092.04.092.09v31.653a.09.09 0 0 1-.092.089H2.872a.09.09 0 0 1-.092-.089z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.394.795a.09.09 0 0 0-.092.09v31.653c0 .05.041.089.092.089h1.732a.09.09 0 0 0 .092-.089V.884a.09.09 0 0 0-.092-.089z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.67 1.152h1.18V32.27h-1.18zm-.368-.268a.09.09 0 0 1 .092-.089h1.732c.051 0 .092.04.092.09v31.653a.09.09 0 0 1-.092.089h-1.732a.09.09 0 0 1-.092-.089z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M6.249 14.716a.795.795 0 1 0 0 1.59h9.502a.795.795 0 0 0 0-1.59zM6.249 19.525a.795.795 0 1 0 0 1.59h9.502a.795.795 0 0 0 0-1.59zM6.249 12.312a.795.795 0 0 0 0 1.59h9.502a.795.795 0 1 0 0-1.59zM6.249 17.122a.795.795 0 1 0 0 1.59h9.502a.795.795 0 0 0 0-1.59zM1.474 2.23C.66 2.23 0 2.89 0 3.704v5.853a1.474 1.474 0 1 0 2.948 0V3.704c0-.814-.66-1.474-1.474-1.474M20.526 2.23c-.814 0-1.474.66-1.474 1.474v5.853a1.474 1.474 0 1 0 2.948 0V3.704c0-.814-.66-1.474-1.474-1.474M1.809 22.468c-.814 0-1.474.66-1.474 1.474v5.852a1.474 1.474 0 1 0 2.948 0v-5.852c0-.814-.66-1.474-1.474-1.474M20.526 22.468c-.814 0-1.474.66-1.474 1.474v5.852a1.474 1.474 0 1 0 2.948 0v-5.852c0-.814-.66-1.474-1.474-1.474"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M11 42.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M2 33.795a9 9 0 1 1 18.001.002A9 9 0 0 1 2 33.795m9-8.052a8.053 8.053 0 1 0 .001 16.106A8.053 8.053 0 0 0 11 25.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M7.472 33.796a3.528 3.528 0 1 0 7.056 0 3.528 3.528 0 0 0-7.056 0m-.893 0a4.421 4.421 0 1 0 8.842 0 4.421 4.421 0 0 0-8.842 0m2.615-.301a.55.55 0 0 0-.11.35q0 .209.11.35a.33.33 0 0 0 .273.14h3.066q.162 0 .273-.14a.55.55 0 0 0 .11-.35.55.55 0 0 0-.11-.35.33.33 0 0 0-.273-.142H9.467q-.163 0-.273.142",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSGpuApuOn = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-gpu-apu-on",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 43",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.758 32.628c.255 0 .46-.2.46-.445V1.24a.453.453 0 0 0-.46-.445H3.241c-.255 0-.46.2-.46.445v30.942c0 .246.205.445.46.445z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.85 1.241v30.942a.09.09 0 0 1-.092.089H3.241a.09.09 0 0 1-.092-.09V1.243a.09.09 0 0 1 .092-.09h15.517c.051 0 .092.04.092.09m.369 30.942a.453.453 0 0 1-.46.445H3.24c-.255 0-.46-.2-.46-.445V1.24c0-.245.205-.445.46-.445h15.517c.255 0 .46.2.46.445z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.872.795a.09.09 0 0 0-.092.09v31.653c0 .05.041.089.092.089h1.732a.09.09 0 0 0 .092-.089V.884a.09.09 0 0 0-.092-.089z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.149 1.152h1.179V32.27h-1.18zM2.78.884a.09.09 0 0 1 .092-.089h1.732c.051 0 .092.04.092.09v31.653a.09.09 0 0 1-.092.089H2.872a.09.09 0 0 1-.092-.089z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.394.795a.09.09 0 0 0-.092.09v31.653c0 .05.041.089.092.089h1.732a.09.09 0 0 0 .092-.089V.884a.09.09 0 0 0-.092-.089z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.67 1.152h1.18V32.27h-1.18zm-.368-.268a.09.09 0 0 1 .092-.089h1.732c.051 0 .092.04.092.09v31.653a.09.09 0 0 1-.092.089h-1.732a.09.09 0 0 1-.092-.089z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M6.249 14.716a.795.795 0 1 0 0 1.59h9.502a.795.795 0 0 0 0-1.59zM6.249 19.525a.795.795 0 1 0 0 1.59h9.502a.795.795 0 0 0 0-1.59zM6.249 12.312a.795.795 0 0 0 0 1.59h9.502a.795.795 0 1 0 0-1.59zM6.249 17.122a.795.795 0 1 0 0 1.59h9.502a.795.795 0 0 0 0-1.59zM1.474 2.23C.66 2.23 0 2.89 0 3.704v5.853a1.474 1.474 0 1 0 2.948 0V3.704c0-.814-.66-1.474-1.474-1.474M20.526 2.23c-.814 0-1.474.66-1.474 1.474v5.853a1.474 1.474 0 1 0 2.948 0V3.704c0-.814-.66-1.474-1.474-1.474M1.809 22.468c-.814 0-1.474.66-1.474 1.474v5.852a1.474 1.474 0 1 0 2.948 0v-5.852c0-.814-.66-1.474-1.474-1.474M20.526 22.468c-.814 0-1.474.66-1.474 1.474v5.852a1.474 1.474 0 1 0 2.948 0v-5.852c0-.814-.66-1.474-1.474-1.474"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#03D8A9",
          fillRule: "evenodd",
          d: "M11 42.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M2 33.795a9 9 0 1 1 18.001.002A9 9 0 0 1 2 33.795m9-8.052a8.053 8.053 0 1 0 .001 16.106A8.053 8.053 0 0 0 11 25.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M11 34.286a.48.48 0 0 1-.35-.14.48.48 0 0 1-.142-.35v-3.93q0-.21.142-.35a.48.48 0 0 1 .35-.142q.208 0 .35.141.14.141.14.35v3.93q0 .21-.14.35a.48.48 0 0 1-.35.141m0 3.93q-.921 0-1.726-.35a4.5 4.5 0 0 1-1.4-.946 4.5 4.5 0 0 1-.945-1.4 4.3 4.3 0 0 1-.35-1.725q0-.847.307-1.621.306-.773.884-1.4a.45.45 0 0 1 .344-.147q.209 0 .356.147a.42.42 0 0 1 .123.338.6.6 0 0 1-.148.362q-.429.479-.657 1.075a3.5 3.5 0 0 0-.227 1.246q0 1.437 1 2.438 1.001 1 2.439 1 1.437 0 2.437-1 1.001-1 1.001-2.438 0-.65-.233-1.259a3.5 3.5 0 0 0-.663-1.087.52.52 0 0 1-.142-.343.43.43 0 0 1 .13-.332.49.49 0 0 1 .356-.147q.208 0 .344.147.576.627.884 1.4.307.774.307 1.621 0 .922-.35 1.725a4.5 4.5 0 0 1-.946 1.4 4.5 4.5 0 0 1-1.4.946 4.3 4.3 0 0 1-1.725.35"
        }
      )
    ]
  }
);
const VehicleSGpuApuUnavailable = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-gpu-apu-unavailable",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 43",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.758 32.624c.255 0 .46-.2.46-.446V1.238a.453.453 0 0 0-.46-.446H3.241c-.255 0-.46.2-.46.445v30.941c0 .246.205.446.46.446z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.85 1.237v30.941a.09.09 0 0 1-.092.09H3.241a.09.09 0 0 1-.092-.09V1.238a.09.09 0 0 1 .092-.09h15.517c.051 0 .092.04.092.09m.369 30.941a.453.453 0 0 1-.46.446H3.24c-.255 0-.46-.2-.46-.446V1.238c0-.247.205-.446.46-.446h15.517c.255 0 .46.2.46.445z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.872.791A.09.09 0 0 0 2.78.88v31.654c0 .049.041.089.092.089h1.732a.09.09 0 0 0 .092-.09V.88a.09.09 0 0 0-.092-.089z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.149 1.147h1.179v31.12h-1.18zM2.78.88a.09.09 0 0 1 .092-.089h1.732c.051 0 .092.04.092.089v31.654a.09.09 0 0 1-.092.089H2.872a.09.09 0 0 1-.092-.09z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.394.791a.09.09 0 0 0-.092.089v31.654c0 .049.041.089.092.089h1.732a.09.09 0 0 0 .092-.09V.88a.09.09 0 0 0-.092-.089z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.67 1.147h1.18v31.12h-1.18zM17.302.88a.09.09 0 0 1 .092-.089h1.732c.051 0 .092.04.092.089v31.654a.09.09 0 0 1-.092.089h-1.732a.09.09 0 0 1-.092-.09z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M6.249 14.712a.795.795 0 0 0 0 1.59h9.502a.795.795 0 1 0 0-1.59zM6.249 19.52a.795.795 0 1 0 0 1.591h9.502a.795.795 0 0 0 0-1.59zM6.249 12.307a.795.795 0 0 0 0 1.59h9.502a.795.795 0 1 0 0-1.59zM6.249 17.117a.795.795 0 1 0 0 1.59h9.502a.795.795 0 0 0 0-1.59zM1.474 2.226C.66 2.226 0 2.886 0 3.7v5.852a1.474 1.474 0 1 0 2.948 0V3.7c0-.814-.66-1.474-1.474-1.474M20.526 2.226c-.814 0-1.474.66-1.474 1.474v5.852a1.474 1.474 0 1 0 2.948 0V3.7c0-.814-.66-1.474-1.474-1.474M1.809 22.463c-.814 0-1.474.66-1.474 1.474v5.853a1.474 1.474 0 1 0 2.948 0v-5.853c0-.814-.66-1.474-1.474-1.474M20.526 22.463c-.814 0-1.474.66-1.474 1.474v5.853a1.474 1.474 0 1 0 2.948 0v-5.853c0-.814-.66-1.474-1.474-1.474"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          d: "M3.536 26.822h14.928c.78 0 1.273.838.893 1.52l-7.464 13.413c-.39.7-1.397.7-1.787 0L2.642 28.34c-.379-.68.114-1.519.894-1.519"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M12.34 42.003a1.534 1.534 0 0 1-2.68 0L2.194 28.59a1.534 1.534 0 0 1 1.34-2.279h14.929c1.17 0 1.909 1.257 1.34 2.28zm-1.787-.497c.195.35.699.35.893 0l7.464-13.413a.51.51 0 0 0-.446-.76H3.536a.51.51 0 0 0-.447.76z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M11 37.326a.76.76 0 0 1-.569-.245.82.82 0 0 1-.236-.59q0-.344.236-.59a.76.76 0 0 1 .569-.245q.331 0 .569.246.236.245.236.59a.82.82 0 0 1-.236.589.76.76 0 0 1-.57.245m0-2.505a.76.76 0 0 1-.569-.245.82.82 0 0 1-.236-.59v-3.34q0-.343.236-.589a.76.76 0 0 1 .569-.245q.331 0 .569.245.236.246.236.59v3.34a.82.82 0 0 1-.236.59.76.76 0 0 1-.57.244"
        }
      )
    ]
  }
);
const VehicleSGpuApuUnplugged = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-gpu-apu-unplugged",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 43",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.758 32.624c.255 0 .46-.2.46-.446V1.238a.453.453 0 0 0-.46-.446H3.241c-.255 0-.46.2-.46.445v30.941c0 .246.205.446.46.446z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.85 1.237v30.941a.09.09 0 0 1-.092.09H3.241a.09.09 0 0 1-.092-.09V1.238a.09.09 0 0 1 .092-.09h15.517c.051 0 .092.04.092.09m.369 30.941a.453.453 0 0 1-.46.446H3.24c-.255 0-.46-.2-.46-.446V1.238c0-.247.205-.446.46-.446h15.517c.255 0 .46.2.46.445z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.872.791A.09.09 0 0 0 2.78.88v31.654c0 .049.041.089.092.089h1.732a.09.09 0 0 0 .092-.09V.88a.09.09 0 0 0-.092-.089z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.149 1.147h1.179v31.12h-1.18zM2.78.88a.09.09 0 0 1 .092-.089h1.732c.051 0 .092.04.092.089v31.654a.09.09 0 0 1-.092.089H2.872a.09.09 0 0 1-.092-.09z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.394.791a.09.09 0 0 0-.092.089v31.654c0 .049.041.089.092.089h1.732a.09.09 0 0 0 .092-.09V.88a.09.09 0 0 0-.092-.089z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.67 1.147h1.18v31.12h-1.18zM17.302.88a.09.09 0 0 1 .092-.089h1.732c.051 0 .092.04.092.089v31.654a.09.09 0 0 1-.092.089h-1.732a.09.09 0 0 1-.092-.09z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M6.249 14.712a.795.795 0 0 0 0 1.59h9.502a.795.795 0 1 0 0-1.59zM6.249 19.52a.795.795 0 1 0 0 1.591h9.502a.795.795 0 0 0 0-1.59zM6.249 12.307a.795.795 0 0 0 0 1.59h9.502a.795.795 0 1 0 0-1.59zM6.249 17.117a.795.795 0 1 0 0 1.59h9.502a.795.795 0 0 0 0-1.59zM1.474 2.226C.66 2.226 0 2.886 0 3.7v5.852a1.474 1.474 0 1 0 2.948 0V3.7c0-.814-.66-1.474-1.474-1.474M20.526 2.226c-.814 0-1.474.66-1.474 1.474v5.852a1.474 1.474 0 1 0 2.948 0V3.7c0-.814-.66-1.474-1.474-1.474M1.809 22.463c-.814 0-1.474.66-1.474 1.474v5.853a1.474 1.474 0 1 0 2.948 0v-5.853c0-.814-.66-1.474-1.474-1.474M20.526 22.463c-.814 0-1.474.66-1.474 1.474v5.853a1.474 1.474 0 1 0 2.948 0v-5.853c0-.814-.66-1.474-1.474-1.474"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          d: "M3.536 26.807h14.928c.78 0 1.273.839.894 1.52l-7.464 13.427a1.022 1.022 0 0 1-1.787 0L2.643 28.328c-.38-.682.113-1.521.893-1.521"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M12.34 42.002a1.533 1.533 0 0 1-2.68 0L2.196 28.576a1.535 1.535 0 0 1 1.34-2.281h14.928c1.17 0 1.91 1.258 1.34 2.281zm-1.787-.498c.195.35.699.35.894 0L18.91 28.08a.512.512 0 0 0-.447-.76H3.536c-.39 0-.636.419-.447.76z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M12.502 30.1c0-.166-.128-.3-.285-.3a.29.29 0 0 0-.285.3v1.962h-1.865V30.1c0-.166-.127-.3-.284-.3a.293.293 0 0 0-.285.3v1.962h-.645v1.203c.003 1.07.72 1.99 1.717 2.204v1.852h.86v-1.852c.996-.213 1.714-1.133 1.717-2.204v-1.208h-.645z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M6.705 29.263h8.59v8.596h-8.59z" }) }) })
    ]
  }
);
const VehicleSGpuApu = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-gpu-apu",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 33",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.758 32.795c.255 0 .46-.199.46-.445V1.41a.453.453 0 0 0-.46-.445H3.241c-.255 0-.46.2-.46.445V32.35c0 .246.205.445.46.445z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.85 1.409V32.35a.09.09 0 0 1-.092.09H3.241a.09.09 0 0 1-.092-.09V1.41a.09.09 0 0 1 .092-.09h15.517c.051 0 .092.04.092.09m.369 30.941a.453.453 0 0 1-.46.445H3.24c-.255 0-.46-.199-.46-.445V1.41c0-.246.205-.445.46-.445h15.517c.255 0 .46.2.46.445z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.872.963a.09.09 0 0 0-.092.089v31.654c0 .049.041.088.092.088h1.732a.09.09 0 0 0 .092-.088V1.052a.09.09 0 0 0-.092-.09z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.149 1.319h1.179v31.12h-1.18zm-.369-.267a.09.09 0 0 1 .092-.09h1.732c.051 0 .092.04.092.09v31.654a.09.09 0 0 1-.092.088H2.872a.09.09 0 0 1-.092-.088z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.394.963a.09.09 0 0 0-.092.089v31.654c0 .049.041.088.092.088h1.732a.09.09 0 0 0 .092-.088V1.052a.09.09 0 0 0-.092-.09z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.67 1.319h1.18v31.12h-1.18zm-.368-.267a.09.09 0 0 1 .092-.09h1.732c.051 0 .092.04.092.09v31.654a.09.09 0 0 1-.092.088h-1.732a.09.09 0 0 1-.092-.088z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M6.249 14.884a.795.795 0 1 0 0 1.59h9.502a.795.795 0 0 0 0-1.59zM6.249 19.692a.795.795 0 1 0 0 1.59h9.502a.795.795 0 0 0 0-1.59zM6.249 12.479a.795.795 0 1 0 0 1.59h9.502a.795.795 0 0 0 0-1.59zM6.249 17.29a.795.795 0 1 0 0 1.59h9.502a.795.795 0 1 0 0-1.59zM1.474 2.397C.66 2.397 0 3.057 0 3.871v5.853a1.474 1.474 0 1 0 2.948 0V3.871c0-.814-.66-1.474-1.474-1.474M20.526 2.397c-.814 0-1.474.66-1.474 1.474v5.853a1.474 1.474 0 1 0 2.948 0V3.871c0-.814-.66-1.474-1.474-1.474M1.809 22.635c-.814 0-1.474.66-1.474 1.474v5.853a1.474 1.474 0 1 0 2.948 0v-5.853c0-.814-.66-1.474-1.474-1.474M20.526 22.635c-.814 0-1.474.66-1.474 1.474v5.853a1.474 1.474 0 1 0 2.948 0v-5.853c0-.814-.66-1.474-1.474-1.474"
        }
      )
    ]
  }
);
const VehicleSLadderDisablePending = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-ladder-disable-pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 51",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.59 40.926c.254 0 .46-.251.46-.56V1.357c0-.31-.206-.561-.46-.561H3.065c-.255 0-.461.251-.461.561v39.007c0 .31.206.561.46.561z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.682 1.358v39.007c0 .062-.041.112-.092.112H3.065c-.051 0-.092-.05-.092-.112V1.358c0-.062.04-.112.092-.112H18.59c.05 0 .092.05.092.112m.369 39.007c0 .31-.207.561-.461.561H3.065c-.255 0-.461-.251-.461-.56V1.357c0-.31.206-.561.46-.561H18.59c.254 0 .46.251.46.561z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.696.795c-.05 0-.092.05-.092.113v39.905c0 .061.041.112.092.112H4.43c.051 0 .092-.05.092-.112V.907c0-.062-.04-.113-.092-.113z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.973 1.244h1.18v39.232h-1.18zM2.604.908c0-.062.041-.113.092-.113H4.43c.051 0 .092.05.092.113v39.905c0 .061-.04.112-.092.112H2.696c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.225.795c-.05 0-.092.05-.092.113v39.905c0 .061.041.112.092.112h1.733c.05 0 .092-.05.092-.112V.907c0-.062-.041-.113-.092-.113z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.502 1.244h1.18v39.232h-1.18zm-.37-.336c0-.062.042-.113.093-.113h1.733c.05 0 .092.05.092.113v39.905c0 .061-.041.112-.092.112h-1.733c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.133 31.398H4.52v.387h12.612zM17.133 29.047H4.52v.388h12.612zM17.133 26.698H4.52v.388h12.612zM17.133 24.348H4.52v.388h12.612zM17.133 21.998H4.52v.387h12.612zM17.133 19.648H4.52v.387h12.612zM17.133 17.297H4.52v.388h12.612zM17.133 14.947H4.52v.388h12.612zM17.133 12.597H4.52v.388h12.612zM17.133 10.248H4.52v.388h12.612zM17.133 7.897H4.52v.388h12.612zM17.133 5.547H4.52v.388h12.612zM17.133 3.197H4.52v.388h12.612z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 1.681C.66 1.681 0 2.341 0 3.156V9.01a1.475 1.475 0 0 0 2.95 0V3.156c0-.815-.66-1.475-1.475-1.475M20.196 1.681c-.814 0-1.474.66-1.474 1.475V9.01a1.475 1.475 0 0 0 2.95 0V3.156c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 9.011V3.156a1.087 1.087 0 0 1 2.174 0V9.01a1.087 1.087 0 1 1-2.174 0M0 3.156a1.475 1.475 0 1 1 2.95 0V9.01a1.475 1.475 0 0 1-2.95 0zM19.11 9.011V3.156a1.087 1.087 0 0 1 2.173 0V9.01a1.087 1.087 0 1 1-2.173 0m-.388-5.855a1.475 1.475 0 0 1 2.95 0V9.01a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 28.28C.66 28.28 0 28.94 0 29.753v5.855a1.475 1.475 0 1 0 2.95 0v-5.855c0-.814-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 35.61v-5.856a1.087 1.087 0 1 1 2.174 0v5.855a1.087 1.087 0 0 1-2.174 0M0 29.753a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.525 28.28c-.814 0-1.474.66-1.474 1.474v5.855a1.475 1.475 0 0 0 2.95 0v-5.855c0-.814-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 35.61v-5.856a1.087 1.087 0 1 1 2.173 0v5.855a1.087 1.087 0 0 1-2.173 0m-.389-5.856a1.475 1.475 0 0 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCF0DE",
          fillRule: "evenodd",
          stroke: "#F9D199",
          d: "M11 50.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F9D199",
          fillRule: "evenodd",
          d: "M2 41.795a9 9 0 1 1 18.001.002A9 9 0 0 1 2 41.795m9-8.052a8.053 8.053 0 1 0 .001 16.106A8.053 8.053 0 0 0 11 33.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          fillRule: "evenodd",
          d: "M13.924 40.138h-.474v-.948a2.37 2.37 0 0 0-4.736 0v.948H8.24a.95.95 0 0 0-.948.947v4.737a.95.95 0 0 0 .948.947h5.684a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.947M11.082 44.4a.95.95 0 0 1-.947-.948.95.95 0 0 1 .947-.947.95.95 0 0 1 .947.947.95.95 0 0 1-.947.948m1.468-4.263H9.614v-.948c0-.81.658-1.468 1.468-1.468s1.468.658 1.468 1.468z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSLadderDisabled = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-ladder-disabled",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 51",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.59 40.926c.254 0 .46-.251.46-.56V1.357c0-.31-.206-.561-.46-.561H3.065c-.255 0-.461.251-.461.561v39.007c0 .31.206.561.46.561z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.682 1.358v39.007c0 .062-.041.112-.092.112H3.065c-.051 0-.092-.05-.092-.112V1.358c0-.062.04-.112.092-.112H18.59c.05 0 .092.05.092.112m.369 39.007c0 .31-.207.561-.461.561H3.065c-.255 0-.461-.251-.461-.56V1.357c0-.31.206-.561.46-.561H18.59c.254 0 .46.251.46.561z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.696.795c-.05 0-.092.05-.092.113v39.905c0 .061.041.112.092.112H4.43c.051 0 .092-.05.092-.112V.907c0-.062-.04-.113-.092-.113z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.973 1.244h1.18v39.232h-1.18zM2.604.908c0-.062.041-.113.092-.113H4.43c.051 0 .092.05.092.113v39.905c0 .061-.04.112-.092.112H2.696c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.225.795c-.05 0-.092.05-.092.113v39.905c0 .061.041.112.092.112h1.733c.05 0 .092-.05.092-.112V.907c0-.062-.041-.113-.092-.113z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.502 1.244h1.18v39.232h-1.18zm-.37-.336c0-.062.042-.113.093-.113h1.733c.05 0 .092.05.092.113v39.905c0 .061-.041.112-.092.112h-1.733c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.133 31.398H4.52v.387h12.612zM17.133 29.047H4.52v.388h12.612zM17.133 26.698H4.52v.388h12.612zM17.133 24.348H4.52v.388h12.612zM17.133 21.998H4.52v.387h12.612zM17.133 19.648H4.52v.387h12.612zM17.133 17.297H4.52v.388h12.612zM17.133 14.947H4.52v.388h12.612zM17.133 12.597H4.52v.388h12.612zM17.133 10.248H4.52v.388h12.612zM17.133 7.897H4.52v.388h12.612zM17.133 5.547H4.52v.388h12.612zM17.133 3.197H4.52v.388h12.612z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 1.681C.66 1.681 0 2.341 0 3.156V9.01a1.475 1.475 0 0 0 2.95 0V3.156c0-.815-.66-1.475-1.475-1.475M20.196 1.681c-.814 0-1.474.66-1.474 1.475V9.01a1.475 1.475 0 0 0 2.95 0V3.156c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 9.011V3.156a1.087 1.087 0 0 1 2.174 0V9.01a1.087 1.087 0 1 1-2.174 0M0 3.156a1.475 1.475 0 1 1 2.95 0V9.01a1.475 1.475 0 0 1-2.95 0zM19.11 9.011V3.156a1.087 1.087 0 0 1 2.173 0V9.01a1.087 1.087 0 1 1-2.173 0m-.388-5.855a1.475 1.475 0 0 1 2.95 0V9.01a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 28.28C.66 28.28 0 28.94 0 29.753v5.855a1.475 1.475 0 1 0 2.95 0v-5.855c0-.814-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 35.61v-5.856a1.087 1.087 0 1 1 2.174 0v5.855a1.087 1.087 0 0 1-2.174 0M0 29.753a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.525 28.28c-.814 0-1.474.66-1.474 1.474v5.855a1.475 1.475 0 0 0 2.95 0v-5.855c0-.814-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 35.61v-5.856a1.087 1.087 0 1 1 2.173 0v5.855a1.087 1.087 0 0 1-2.173 0m-.389-5.856a1.475 1.475 0 0 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCEDEB",
          fillRule: "evenodd",
          stroke: "#F5B7B1",
          d: "M11 50.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F5B7B1",
          fillRule: "evenodd",
          d: "M2 41.795a9 9 0 1 1 18.001.002A9 9 0 0 1 2 41.795m9-8.052a8.053 8.053 0 1 0 .001 16.106A8.053 8.053 0 0 0 11 33.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          fillRule: "evenodd",
          d: "M13.924 40.138h-.474v-.948a2.37 2.37 0 0 0-4.736 0v.948H8.24a.95.95 0 0 0-.948.947v4.737a.95.95 0 0 0 .948.947h5.684a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.947M11.082 44.4a.95.95 0 0 1-.947-.948.95.95 0 0 1 .947-.947.95.95 0 0 1 .947.947.95.95 0 0 1-.947.948m1.468-4.263H9.614v-.948c0-.81.658-1.468 1.468-1.468s1.468.658 1.468 1.468z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSLadderEnablePending = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-ladder-enable-pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 51",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.59 40.926c.254 0 .46-.251.46-.56V1.357c0-.31-.206-.561-.46-.561H3.065c-.255 0-.461.251-.461.561v39.007c0 .31.206.561.46.561z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.682 1.358v39.007c0 .062-.041.112-.092.112H3.065c-.051 0-.092-.05-.092-.112V1.358c0-.062.04-.112.092-.112H18.59c.05 0 .092.05.092.112m.369 39.007c0 .31-.207.561-.461.561H3.065c-.255 0-.461-.251-.461-.56V1.357c0-.31.206-.561.46-.561H18.59c.254 0 .46.251.46.561z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.696.795c-.05 0-.092.05-.092.113v39.905c0 .061.041.112.092.112H4.43c.051 0 .092-.05.092-.112V.907c0-.062-.04-.113-.092-.113z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.973 1.244h1.18v39.232h-1.18zM2.604.908c0-.062.041-.113.092-.113H4.43c.051 0 .092.05.092.113v39.905c0 .061-.04.112-.092.112H2.696c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.225.795c-.05 0-.092.05-.092.113v39.905c0 .061.041.112.092.112h1.733c.05 0 .092-.05.092-.112V.907c0-.062-.041-.113-.092-.113z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.502 1.244h1.18v39.232h-1.18zm-.37-.336c0-.062.042-.113.093-.113h1.733c.05 0 .092.05.092.113v39.905c0 .061-.041.112-.092.112h-1.733c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.133 31.398H4.52v.387h12.612zM17.133 29.047H4.52v.388h12.612zM17.133 26.698H4.52v.388h12.612zM17.133 24.348H4.52v.388h12.612zM17.133 21.998H4.52v.387h12.612zM17.133 19.648H4.52v.387h12.612zM17.133 17.297H4.52v.388h12.612zM17.133 14.947H4.52v.388h12.612zM17.133 12.597H4.52v.388h12.612zM17.133 10.248H4.52v.388h12.612zM17.133 7.897H4.52v.388h12.612zM17.133 5.547H4.52v.388h12.612zM17.133 3.197H4.52v.388h12.612z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 1.681C.66 1.681 0 2.341 0 3.156V9.01a1.475 1.475 0 0 0 2.95 0V3.156c0-.815-.66-1.475-1.475-1.475M20.196 1.681c-.814 0-1.474.66-1.474 1.475V9.01a1.475 1.475 0 0 0 2.95 0V3.156c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 9.011V3.156a1.087 1.087 0 0 1 2.174 0V9.01a1.087 1.087 0 1 1-2.174 0M0 3.156a1.475 1.475 0 1 1 2.95 0V9.01a1.475 1.475 0 0 1-2.95 0zM19.11 9.011V3.156a1.087 1.087 0 0 1 2.173 0V9.01a1.087 1.087 0 1 1-2.173 0m-.388-5.855a1.475 1.475 0 0 1 2.95 0V9.01a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 28.28C.66 28.28 0 28.94 0 29.753v5.855a1.475 1.475 0 1 0 2.95 0v-5.855c0-.814-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 35.61v-5.856a1.087 1.087 0 1 1 2.174 0v5.855a1.087 1.087 0 0 1-2.174 0M0 29.753a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.525 28.28c-.814 0-1.474.66-1.474 1.474v5.855a1.475 1.475 0 0 0 2.95 0v-5.855c0-.814-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 35.61v-5.856a1.087 1.087 0 1 1 2.173 0v5.855a1.087 1.087 0 0 1-2.173 0m-.389-5.856a1.475 1.475 0 0 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#CFDEF2",
          fillRule: "evenodd",
          stroke: "#F5B7B1",
          d: "M11 50.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#8AB9F7",
          fillRule: "evenodd",
          d: "M2 41.795a9 9 0 1 1 18.001.002A9 9 0 0 1 2 41.795m9-8.052a8.053 8.053 0 1 0 .001 16.106A8.053 8.053 0 0 0 11 33.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1774F0",
          fillRule: "evenodd",
          d: "M11.082 44.164a.95.95 0 0 0 .947-.947.95.95 0 0 0-.947-.948.95.95 0 0 0-.947.948.95.95 0 0 0 .947.947m2.842-4.263h-.474v-.948a2.37 2.37 0 0 0-4.736 0h.9c0-.81.658-1.468 1.468-1.468s1.468.658 1.468 1.468v.948H8.24a.95.95 0 0 0-.948.947v4.737a.95.95 0 0 0 .948.947h5.684a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.947m0 5.684H8.24v-4.737h5.684z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSLadderNoSignal = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-ladder-no-signal",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 51",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.59 40.926c.254 0 .46-.251.46-.56V1.357c0-.31-.206-.561-.46-.561H3.065c-.255 0-.461.251-.461.561v39.007c0 .31.206.561.46.561z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.682 1.358v39.007c0 .062-.041.112-.092.112H3.065c-.051 0-.092-.05-.092-.112V1.358c0-.062.04-.112.092-.112H18.59c.05 0 .092.05.092.112m.369 39.007c0 .31-.207.561-.461.561H3.065c-.255 0-.461-.251-.461-.56V1.357c0-.31.206-.561.46-.561H18.59c.254 0 .46.251.46.561z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.696.795c-.05 0-.092.05-.092.113v39.905c0 .061.041.112.092.112H4.43c.051 0 .092-.05.092-.112V.907c0-.062-.04-.113-.092-.113z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.973 1.244h1.18v39.232h-1.18zM2.604.908c0-.062.041-.113.092-.113H4.43c.051 0 .092.05.092.113v39.905c0 .061-.04.112-.092.112H2.696c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.225.795c-.05 0-.092.05-.092.113v39.905c0 .061.041.112.092.112h1.733c.05 0 .092-.05.092-.112V.907c0-.062-.041-.113-.092-.113z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.502 1.244h1.18v39.232h-1.18zm-.37-.336c0-.062.042-.113.093-.113h1.733c.05 0 .092.05.092.113v39.905c0 .061-.041.112-.092.112h-1.733c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.133 31.398H4.52v.387h12.612zM17.133 29.047H4.52v.388h12.612zM17.133 26.698H4.52v.388h12.612zM17.133 24.348H4.52v.388h12.612zM17.133 21.998H4.52v.387h12.612zM17.133 19.648H4.52v.387h12.612zM17.133 17.297H4.52v.388h12.612zM17.133 14.947H4.52v.388h12.612zM17.133 12.597H4.52v.388h12.612zM17.133 10.248H4.52v.388h12.612zM17.133 7.897H4.52v.388h12.612zM17.133 5.547H4.52v.388h12.612zM17.133 3.197H4.52v.388h12.612z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 1.681C.66 1.681 0 2.341 0 3.156V9.01a1.475 1.475 0 0 0 2.95 0V3.156c0-.815-.66-1.475-1.475-1.475M20.196 1.681c-.814 0-1.474.66-1.474 1.475V9.01a1.475 1.475 0 0 0 2.95 0V3.156c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 9.011V3.156a1.087 1.087 0 0 1 2.174 0V9.01a1.087 1.087 0 1 1-2.174 0M0 3.156a1.475 1.475 0 1 1 2.95 0V9.01a1.475 1.475 0 0 1-2.95 0zM19.11 9.011V3.156a1.087 1.087 0 0 1 2.173 0V9.01a1.087 1.087 0 1 1-2.173 0m-.388-5.855a1.475 1.475 0 0 1 2.95 0V9.01a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 28.28C.66 28.28 0 28.94 0 29.753v5.855a1.475 1.475 0 1 0 2.95 0v-5.855c0-.814-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 35.61v-5.856a1.087 1.087 0 1 1 2.174 0v5.855a1.087 1.087 0 0 1-2.174 0M0 29.753a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.525 28.28c-.814 0-1.474.66-1.474 1.474v5.855a1.475 1.475 0 0 0 2.95 0v-5.855c0-.814-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 35.61v-5.856a1.087 1.087 0 1 1 2.173 0v5.855a1.087 1.087 0 0 1-2.173 0m-.389-5.856a1.475 1.475 0 0 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M10.3 33.58a.99.99 0 0 1 1.4 0l7.515 7.515a.99.99 0 0 1 0 1.4L11.7 50.01a.99.99 0 0 1-1.401 0l-7.515-7.514a.99.99 0 0 1 0-1.401z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#9DA9B6",
          fillRule: "evenodd",
          d: "M9.95 33.23c.58-.58 1.52-.58 2.1 0l7.515 7.515c.58.58.58 1.52 0 2.101L12.05 50.36c-.58.58-1.521.58-2.102 0l-7.514-7.514a1.486 1.486 0 0 1 0-2.101zm1.4.701a.495.495 0 0 0-.7 0l-7.514 7.514a.495.495 0 0 0 0 .7l7.514 7.515a.495.495 0 0 0 .7 0l7.514-7.514a.495.495 0 0 0 0-.7z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          d: "M14.137 38.156a.386.386 0 0 0-.659-.273l-2.542 2.542 3.2 3.201zm.17 6.73-6.095-6.094a.384.384 0 1 0-.543.543l2.18 2.18-2.758 2.758a.385.385 0 0 0 .27.66h5.901l.497.496c.15.15.393.15.543 0a.38.38 0 0 0 .004-.543"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M6.047 36.843h9.245v9.245H6.047z" }) }) })
    ]
  }
);
const VehicleSLadderOff = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-ladder-off",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 51",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.59 40.926c.254 0 .46-.251.46-.56V1.357c0-.31-.206-.561-.46-.561H3.065c-.255 0-.461.251-.461.561v39.007c0 .31.206.561.46.561z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.682 1.358v39.007c0 .062-.041.112-.092.112H3.065c-.051 0-.092-.05-.092-.112V1.358c0-.062.04-.112.092-.112H18.59c.05 0 .092.05.092.112m.369 39.007c0 .31-.207.561-.461.561H3.065c-.255 0-.461-.251-.461-.56V1.357c0-.31.206-.561.46-.561H18.59c.254 0 .46.251.46.561z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.696.795c-.05 0-.092.05-.092.113v39.905c0 .061.041.112.092.112H4.43c.051 0 .092-.05.092-.112V.907c0-.062-.04-.113-.092-.113z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.973 1.244h1.18v39.232h-1.18zM2.604.908c0-.062.041-.113.092-.113H4.43c.051 0 .092.05.092.113v39.905c0 .061-.04.112-.092.112H2.696c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.225.795c-.05 0-.092.05-.092.113v39.905c0 .061.041.112.092.112h1.733c.05 0 .092-.05.092-.112V.907c0-.062-.041-.113-.092-.113z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.502 1.244h1.18v39.232h-1.18zm-.37-.336c0-.062.042-.113.093-.113h1.733c.05 0 .092.05.092.113v39.905c0 .061-.041.112-.092.112h-1.733c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.133 31.398H4.52v.387h12.612zM17.133 29.047H4.52v.388h12.612zM17.133 26.698H4.52v.388h12.612zM17.133 24.348H4.52v.388h12.612zM17.133 21.998H4.52v.387h12.612zM17.133 19.648H4.52v.387h12.612zM17.133 17.297H4.52v.388h12.612zM17.133 14.947H4.52v.388h12.612zM17.133 12.597H4.52v.388h12.612zM17.133 10.248H4.52v.388h12.612zM17.133 7.897H4.52v.388h12.612zM17.133 5.547H4.52v.388h12.612zM17.133 3.197H4.52v.388h12.612z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 1.681C.66 1.681 0 2.341 0 3.156V9.01a1.475 1.475 0 0 0 2.95 0V3.156c0-.815-.66-1.475-1.475-1.475M20.196 1.681c-.814 0-1.474.66-1.474 1.475V9.01a1.475 1.475 0 0 0 2.95 0V3.156c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 9.011V3.156a1.087 1.087 0 0 1 2.174 0V9.01a1.087 1.087 0 1 1-2.174 0M0 3.156a1.475 1.475 0 1 1 2.95 0V9.01a1.475 1.475 0 0 1-2.95 0zM19.11 9.011V3.156a1.087 1.087 0 0 1 2.173 0V9.01a1.087 1.087 0 1 1-2.173 0m-.388-5.855a1.475 1.475 0 0 1 2.95 0V9.01a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 28.28C.66 28.28 0 28.94 0 29.753v5.855a1.475 1.475 0 1 0 2.95 0v-5.855c0-.814-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 35.61v-5.856a1.087 1.087 0 1 1 2.174 0v5.855a1.087 1.087 0 0 1-2.174 0M0 29.753a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.525 28.28c-.814 0-1.474.66-1.474 1.474v5.855a1.475 1.475 0 0 0 2.95 0v-5.855c0-.814-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 35.61v-5.856a1.087 1.087 0 1 1 2.173 0v5.855a1.087 1.087 0 0 1-2.173 0m-.389-5.856a1.475 1.475 0 0 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M11 50.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M2 41.795a9 9 0 1 1 18.001.002A9 9 0 0 1 2 41.795m9-8.052a8.053 8.053 0 1 0 .001 16.106A8.053 8.053 0 0 0 11 33.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M7.472 41.796a3.528 3.528 0 1 0 7.056 0 3.528 3.528 0 0 0-7.056 0m-.893 0a4.421 4.421 0 1 0 8.842 0 4.421 4.421 0 0 0-8.842 0m2.615-.301a.55.55 0 0 0-.11.35q0 .209.11.35a.33.33 0 0 0 .273.14h3.066q.162 0 .273-.14a.55.55 0 0 0 .11-.35.55.55 0 0 0-.11-.35.33.33 0 0 0-.273-.142H9.467q-.163 0-.273.142",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSLadderOn = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-ladder-on",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 51",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.59 40.926c.254 0 .46-.251.46-.56V1.357c0-.31-.206-.561-.46-.561H3.065c-.255 0-.461.251-.461.561v39.007c0 .31.206.561.46.561z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.682 1.358v39.007c0 .062-.041.112-.092.112H3.065c-.051 0-.092-.05-.092-.112V1.358c0-.062.04-.112.092-.112H18.59c.05 0 .092.05.092.112m.369 39.007c0 .31-.207.561-.461.561H3.065c-.255 0-.461-.251-.461-.56V1.357c0-.31.206-.561.46-.561H18.59c.254 0 .46.251.46.561z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.696.795c-.05 0-.092.05-.092.113v39.905c0 .061.041.112.092.112H4.43c.051 0 .092-.05.092-.112V.907c0-.062-.04-.113-.092-.113z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.973 1.244h1.18v39.232h-1.18zM2.604.908c0-.062.041-.113.092-.113H4.43c.051 0 .092.05.092.113v39.905c0 .061-.04.112-.092.112H2.696c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.225.795c-.05 0-.092.05-.092.113v39.905c0 .061.041.112.092.112h1.733c.05 0 .092-.05.092-.112V.907c0-.062-.041-.113-.092-.113z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.502 1.244h1.18v39.232h-1.18zm-.37-.336c0-.062.042-.113.093-.113h1.733c.05 0 .092.05.092.113v39.905c0 .061-.041.112-.092.112h-1.733c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.133 31.398H4.52v.387h12.612zM17.133 29.047H4.52v.388h12.612zM17.133 26.698H4.52v.388h12.612zM17.133 24.348H4.52v.388h12.612zM17.133 21.998H4.52v.387h12.612zM17.133 19.648H4.52v.387h12.612zM17.133 17.297H4.52v.388h12.612zM17.133 14.947H4.52v.388h12.612zM17.133 12.597H4.52v.388h12.612zM17.133 10.248H4.52v.388h12.612zM17.133 7.897H4.52v.388h12.612zM17.133 5.547H4.52v.388h12.612zM17.133 3.197H4.52v.388h12.612z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 1.681C.66 1.681 0 2.341 0 3.156V9.01a1.475 1.475 0 0 0 2.95 0V3.156c0-.815-.66-1.475-1.475-1.475M20.196 1.681c-.814 0-1.474.66-1.474 1.475V9.01a1.475 1.475 0 0 0 2.95 0V3.156c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 9.011V3.156a1.087 1.087 0 0 1 2.174 0V9.01a1.087 1.087 0 1 1-2.174 0M0 3.156a1.475 1.475 0 1 1 2.95 0V9.01a1.475 1.475 0 0 1-2.95 0zM19.11 9.011V3.156a1.087 1.087 0 0 1 2.173 0V9.01a1.087 1.087 0 1 1-2.173 0m-.388-5.855a1.475 1.475 0 0 1 2.95 0V9.01a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 28.28C.66 28.28 0 28.94 0 29.753v5.855a1.475 1.475 0 1 0 2.95 0v-5.855c0-.814-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 35.61v-5.856a1.087 1.087 0 1 1 2.174 0v5.855a1.087 1.087 0 0 1-2.174 0M0 29.753a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.525 28.28c-.814 0-1.474.66-1.474 1.474v5.855a1.475 1.475 0 0 0 2.95 0v-5.855c0-.814-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 35.61v-5.856a1.087 1.087 0 1 1 2.173 0v5.855a1.087 1.087 0 0 1-2.173 0m-.389-5.856a1.475 1.475 0 0 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#03D8A9",
          fillRule: "evenodd",
          d: "M11 50.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M2 41.795a9 9 0 1 1 18.001.002A9 9 0 0 1 2 41.795m9-8.052a8.053 8.053 0 1 0 .001 16.106A8.053 8.053 0 0 0 11 33.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M11 42.286a.48.48 0 0 1-.35-.14.48.48 0 0 1-.142-.35v-3.93q0-.21.142-.35a.48.48 0 0 1 .35-.142q.208 0 .35.141.14.141.14.35v3.93q0 .21-.14.35a.48.48 0 0 1-.35.141m0 3.93q-.921 0-1.726-.35a4.5 4.5 0 0 1-1.4-.946 4.5 4.5 0 0 1-.945-1.4 4.3 4.3 0 0 1-.35-1.725q0-.847.307-1.621.306-.773.884-1.4a.45.45 0 0 1 .344-.147q.209 0 .356.147a.42.42 0 0 1 .123.338.6.6 0 0 1-.148.362q-.429.48-.657 1.075a3.5 3.5 0 0 0-.227 1.246q0 1.437 1 2.438 1.001 1 2.439 1 1.437 0 2.437-1 1.001-1 1.001-2.438 0-.65-.233-1.259a3.5 3.5 0 0 0-.663-1.087.52.52 0 0 1-.142-.343.43.43 0 0 1 .13-.332.49.49 0 0 1 .356-.147q.208 0 .344.147.576.627.884 1.4.307.774.307 1.621 0 .922-.35 1.725a4.5 4.5 0 0 1-.946 1.4 4.5 4.5 0 0 1-1.4.946 4.3 4.3 0 0 1-1.725.35"
        }
      )
    ]
  }
);
const VehicleSLadderUnavailable = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-ladder-unavailable",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 51",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.59 40.922c.254 0 .46-.251.46-.561V1.354c0-.31-.206-.561-.46-.561H3.065c-.255 0-.461.25-.461.56v39.008c0 .31.206.56.46.56z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.682 1.354V40.36c0 .062-.041.112-.092.112H3.065c-.051 0-.092-.05-.092-.112V1.354c0-.062.04-.112.092-.112H18.59c.05 0 .092.05.092.112m.369 39.007c0 .31-.207.56-.461.56H3.065c-.255 0-.461-.25-.461-.56V1.354c0-.31.206-.561.46-.561H18.59c.254 0 .46.25.46.56z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.696.791c-.05 0-.092.05-.092.112v39.905c0 .062.041.112.092.112H4.43c.051 0 .092-.05.092-.112V.903c0-.062-.04-.112-.092-.112z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.973 1.24h1.18v39.231h-1.18zM2.604.903c0-.062.041-.112.092-.112H4.43c.051 0 .092.05.092.112v39.905c0 .062-.04.112-.092.112H2.696c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.225.791c-.05 0-.092.05-.092.112v39.905c0 .062.041.112.092.112h1.733c.05 0 .092-.05.092-.112V.903c0-.062-.041-.112-.092-.112z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.502 1.24h1.18v39.231h-1.18zm-.37-.337c0-.062.042-.112.093-.112h1.733c.05 0 .092.05.092.112v39.905c0 .062-.041.112-.092.112h-1.733c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.133 31.393H4.52v.388h12.612zM17.133 29.043H4.52v.387h12.612zM17.133 26.693H4.52v.388h12.612zM17.133 24.343H4.52v.388h12.612zM17.133 21.993H4.52v.388h12.612zM17.133 19.643H4.52v.388h12.612zM17.133 17.293H4.52v.388h12.612zM17.133 14.943H4.52v.388h12.612zM17.133 12.593H4.52v.388h12.612zM17.133 10.243H4.52v.388h12.612zM17.133 7.893H4.52v.388h12.612zM17.133 5.542H4.52v.388h12.612zM17.133 3.192H4.52v.388h12.612z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 1.677C.66 1.677 0 2.337 0 3.152v5.855a1.475 1.475 0 0 0 2.95 0V3.152c0-.815-.66-1.475-1.475-1.475M20.196 1.677c-.814 0-1.474.66-1.474 1.475v5.855a1.475 1.475 0 0 0 2.95 0V3.152c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 9.007V3.152a1.087 1.087 0 1 1 2.174 0v5.855a1.087 1.087 0 1 1-2.174 0M0 3.152a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0zM19.11 9.007V3.152a1.087 1.087 0 0 1 2.173 0v5.855a1.087 1.087 0 1 1-2.173 0m-.388-5.855a1.475 1.475 0 0 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 28.275C.66 28.275 0 28.935 0 29.75v5.855a1.475 1.475 0 1 0 2.95 0V29.75c0-.815-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 35.605V29.75a1.087 1.087 0 1 1 2.174 0v5.855a1.087 1.087 0 0 1-2.174 0M0 29.75a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.525 28.275c-.814 0-1.474.66-1.474 1.475v5.855a1.475 1.475 0 0 0 2.95 0V29.75c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 35.605V29.75a1.087 1.087 0 1 1 2.173 0v5.855a1.087 1.087 0 0 1-2.173 0m-.389-5.855a1.475 1.475 0 0 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          d: "M3.536 34.822h14.928c.78 0 1.273.838.894 1.52l-7.464 13.413c-.39.7-1.398.7-1.787 0L2.643 36.342c-.38-.682.113-1.52.893-1.52"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M12.34 50.003a1.534 1.534 0 0 1-2.68 0L2.196 36.59a1.534 1.534 0 0 1 1.34-2.279h14.928c1.17 0 1.91 1.257 1.34 2.28zm-1.787-.497c.195.35.699.35.894 0l7.464-13.413a.51.51 0 0 0-.447-.76H3.536a.51.51 0 0 0-.447.76z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M11 45.326a.76.76 0 0 1-.569-.245.82.82 0 0 1-.236-.59q0-.344.236-.59a.76.76 0 0 1 .57-.245q.33 0 .568.246.236.245.236.59a.82.82 0 0 1-.236.589.76.76 0 0 1-.569.245m0-2.505a.76.76 0 0 1-.569-.245.82.82 0 0 1-.236-.59v-3.34q0-.343.236-.589a.76.76 0 0 1 .57-.245q.33 0 .568.245.236.245.236.59v3.34a.82.82 0 0 1-.236.59.76.76 0 0 1-.569.244"
        }
      )
    ]
  }
);
const VehicleSLadderUnplugged = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-ladder-unplugged",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 51",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.59 40.93c.254 0 .46-.252.46-.562V1.354c0-.31-.206-.561-.46-.561H3.065c-.255 0-.461.25-.461.56v39.015c0 .31.206.561.46.561z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.682 1.354v39.014c0 .062-.041.112-.092.112H3.065c-.051 0-.092-.05-.092-.112V1.354c0-.062.04-.112.092-.112H18.59c.05 0 .092.05.092.112m.369 39.014c0 .31-.207.561-.461.561H3.065c-.255 0-.461-.251-.461-.561V1.354c0-.31.206-.561.46-.561H18.59c.254 0 .46.25.46.56z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.696.79c-.05 0-.092.05-.092.113v39.912c0 .062.041.112.092.112H4.43c.051 0 .092-.05.092-.112V.903c0-.062-.04-.112-.092-.112z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.973 1.24h1.18v39.238h-1.18zM2.604.903c0-.062.041-.112.092-.112H4.43c.051 0 .092.05.092.112v39.912c0 .062-.04.112-.092.112H2.696c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.225.79c-.05 0-.092.05-.092.113v39.912c0 .062.041.112.092.112h1.733c.05 0 .092-.05.092-.112V.903c0-.062-.041-.112-.092-.112z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.502 1.24h1.18v39.238h-1.18zm-.37-.337c0-.062.042-.112.093-.112h1.733c.05 0 .092.05.092.112v39.912c0 .062-.041.112-.092.112h-1.733c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.133 31.398H4.52v.389h12.612zM17.133 29.047H4.52v.388h12.612zM17.133 26.697H4.52v.388h12.612zM17.133 24.347H4.52v.388h12.612zM17.133 21.997H4.52v.388h12.612zM17.133 19.646H4.52v.388h12.612zM17.133 17.295H4.52v.388h12.612zM17.133 14.945H4.52v.388h12.612zM17.133 12.595H4.52v.388h12.612zM17.133 10.245H4.52v.388h12.612zM17.133 7.894H4.52v.388h12.612zM17.133 5.542H4.52v.389h12.612zM17.133 3.192H4.52v.388h12.612z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 1.677C.66 1.677 0 2.337 0 3.152v5.856a1.475 1.475 0 1 0 2.95 0V3.152c0-.815-.66-1.475-1.475-1.475M20.196 1.677c-.814 0-1.474.66-1.474 1.475v5.856a1.475 1.475 0 1 0 2.95 0V3.152c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 9.008V3.152a1.087 1.087 0 1 1 2.174 0v5.856a1.087 1.087 0 1 1-2.174 0M0 3.152a1.475 1.475 0 1 1 2.95 0v5.856a1.475 1.475 0 1 1-2.95 0zM19.11 9.008V3.152a1.087 1.087 0 1 1 2.173 0v5.856a1.087 1.087 0 1 1-2.173 0m-.388-5.856a1.475 1.475 0 1 1 2.95 0v5.856a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 28.28C.66 28.28 0 28.94 0 29.753v5.857a1.475 1.475 0 1 0 2.95 0v-5.857c0-.814-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 35.61v-5.856a1.087 1.087 0 1 1 2.174 0v5.857a1.087 1.087 0 1 1-2.174 0M0 29.755a1.475 1.475 0 1 1 2.95 0v5.857a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.525 28.28c-.814 0-1.474.66-1.474 1.474v5.857a1.475 1.475 0 1 0 2.95 0v-5.857c0-.814-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 35.61v-5.856a1.087 1.087 0 1 1 2.173 0v5.857a1.087 1.087 0 1 1-2.173 0m-.389-5.856a1.475 1.475 0 1 1 2.95 0v5.857a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          d: "M3.536 34.804h14.928c.78 0 1.273.84.894 1.521l-7.464 13.428a1.022 1.022 0 0 1-1.787 0L2.643 36.325a1.023 1.023 0 0 1 .893-1.52"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M12.34 50.002a1.533 1.533 0 0 1-2.68 0L2.196 36.574a1.535 1.535 0 0 1 1.34-2.282h14.928c1.17 0 1.91 1.259 1.34 2.282zm-1.787-.497c.195.35.699.35.894 0l7.464-13.428a.512.512 0 0 0-.447-.761H3.536c-.39 0-.636.42-.447.76z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M12.502 38.098c0-.166-.128-.3-.285-.3a.29.29 0 0 0-.285.3v1.962h-1.865v-1.962c0-.166-.127-.3-.284-.3a.293.293 0 0 0-.285.3v1.962h-.645v1.204c.003 1.07.72 1.991 1.717 2.204v1.852h.86v-1.852c.996-.213 1.714-1.134 1.717-2.204v-1.208h-.645z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M6.705 37.26h8.59v8.598h-8.59z" }) }) })
    ]
  }
);
const VehicleSLadder = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-ladder",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 41",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.59 40.796c.254 0 .46-.251.46-.561V1.228c0-.31-.206-.561-.46-.561H3.065c-.255 0-.461.25-.461.56v39.008c0 .31.206.56.46.56z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.682 1.228v39.007c0 .062-.041.112-.092.112H3.065c-.051 0-.092-.05-.092-.112V1.228c0-.062.04-.112.092-.112H18.59c.05 0 .092.05.092.112m.369 39.007c0 .31-.207.56-.461.56H3.065c-.255 0-.461-.25-.461-.56V1.228c0-.31.206-.561.46-.561H18.59c.254 0 .46.25.46.56z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.696.665c-.05 0-.092.05-.092.112v39.905c0 .062.041.112.092.112H4.43c.051 0 .092-.05.092-.112V.777c0-.062-.04-.112-.092-.112z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.973 1.114h1.18v39.231h-1.18zM2.604.777c0-.062.041-.112.092-.112H4.43c.051 0 .092.05.092.112v39.905c0 .062-.04.112-.092.112H2.696c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M17.225.665c-.05 0-.092.05-.092.112v39.905c0 .062.041.112.092.112h1.733c.05 0 .092-.05.092-.112V.777c0-.062-.041-.112-.092-.112z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.502 1.114h1.18v39.231h-1.18zm-.37-.337c0-.062.042-.112.093-.112h1.733c.05 0 .092.05.092.112v39.905c0 .062-.041.112-.092.112h-1.733c-.05 0-.092-.05-.092-.112z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.133 31.267H4.52v.388h12.612zM17.133 28.917H4.52v.387h12.612zM17.133 26.567H4.52v.388h12.612zM17.133 24.217H4.52v.388h12.612zM17.133 21.867H4.52v.388h12.612zM17.133 19.517H4.52v.388h12.612zM17.133 17.167H4.52v.388h12.612zM17.133 14.817H4.52v.388h12.612zM17.133 12.467H4.52v.388h12.612zM17.133 10.117H4.52v.388h12.612zM17.133 7.767H4.52v.388h12.612zM17.133 5.417H4.52v.387h12.612zM17.133 3.066H4.52v.388h12.612z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 1.55C.66 1.55 0 2.212 0 3.027V8.88a1.475 1.475 0 1 0 2.95 0V3.026c0-.815-.66-1.475-1.475-1.475M20.196 1.55c-.814 0-1.474.661-1.474 1.476V8.88a1.475 1.475 0 1 0 2.95 0V3.026c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 8.881V3.026a1.087 1.087 0 0 1 2.174 0V8.88a1.087 1.087 0 1 1-2.174 0M0 3.026a1.475 1.475 0 1 1 2.95 0V8.88a1.475 1.475 0 1 1-2.95 0zM19.11 8.881V3.026a1.087 1.087 0 0 1 2.173 0V8.88a1.087 1.087 0 1 1-2.173 0m-.388-5.855a1.475 1.475 0 0 1 2.95 0V8.88a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.475 28.149c-.815 0-1.475.66-1.475 1.475v5.855a1.475 1.475 0 1 0 2.95 0v-5.855c0-.815-.66-1.475-1.475-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.388 35.48v-5.856a1.087 1.087 0 0 1 2.174 0v5.855a1.087 1.087 0 1 1-2.174 0M0 29.623a1.475 1.475 0 1 1 2.95 0v5.855a1.475 1.475 0 1 1-2.95 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M20.525 28.149c-.814 0-1.474.66-1.474 1.475v5.855a1.475 1.475 0 0 0 2.95 0v-5.855c0-.815-.661-1.475-1.476-1.475"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.439 35.48v-5.856a1.087 1.087 0 0 1 2.173 0v5.855a1.087 1.087 0 1 1-2.173 0m-.389-5.856a1.475 1.475 0 0 1 2.95 0v5.855a1.475 1.475 0 0 1-2.95 0z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSLoaderDisablePending = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-loader-disable-pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 46",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.267 35.768a.477.477 0 0 0 .464-.49V1.285c0-.27-.208-.49-.464-.49H2.61a.477.477 0 0 0-.465.49v33.994c0 .27.208.489.465.489z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.36 1.285v33.994a.096.096 0 0 1-.093.097H2.61a.095.095 0 0 1-.093-.097V1.285c0-.054.042-.098.093-.098h15.657c.051 0 .093.044.093.098m.371 33.994c0 .27-.208.489-.464.489H2.61a.477.477 0 0 1-.465-.49V1.285c0-.27.208-.49.465-.49h15.657c.256 0 .464.22.464.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M6.754 3.176c-.443 0-.802.378-.802.844v28.307c0 .466.36.844.802.844s.802-.378.802-.844V4.02c0-.466-.359-.844-.802-.844M9.263 3.176c-.443 0-.802.378-.802.844v28.307c0 .466.359.844.802.844s.802-.378.802-.844V4.02c0-.466-.36-.844-.802-.844M11.693 3.176c-.443 0-.802.378-.802.844v28.307c0 .466.359.844.802.844s.802-.378.802-.844V4.02c0-.466-.36-.844-.802-.844M14.123 3.176c-.443 0-.802.378-.802.844v28.307c0 .466.359.844.802.844s.802-.378.802-.844V4.02c0-.466-.36-.844-.802-.844"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.238.796a.095.095 0 0 0-.093.098V35.67c0 .054.042.098.093.098h1.748a.095.095 0 0 0 .093-.098V.894a.095.095 0 0 0-.093-.098z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.517 1.187h1.19v34.19h-1.19zM2.145.894c0-.054.042-.098.093-.098h1.748c.051 0 .093.044.093.098V35.67a.095.095 0 0 1-.093.098H2.238a.095.095 0 0 1-.093-.098z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.891.796a.095.095 0 0 0-.093.098V35.67c0 .054.042.098.093.098h1.748a.095.095 0 0 0 .093-.098V.894a.095.095 0 0 0-.093-.098z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.17 1.187h1.19v34.19h-1.19zm-.372-.293c0-.054.042-.098.093-.098h1.748c.051 0 .093.044.093.098V35.67a.095.095 0 0 1-.093.098H16.89a.095.095 0 0 1-.093-.098z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 1.047C.508 1.047 0 1.555 0 2.18v4.504a1.134 1.134 0 0 0 2.269 0V2.181c0-.626-.508-1.134-1.135-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 6.685V2.181a.836.836 0 0 1 1.672 0v4.504a.836.836 0 0 1-1.672 0M0 2.181a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 8.37C.508 8.37 0 8.879 0 9.506v4.504a1.134 1.134 0 1 0 2.269 0V9.505c0-.627-.508-1.134-1.135-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 14.009V9.505a.836.836 0 0 1 1.672 0v4.504a.836.836 0 1 1-1.672 0M0 9.505a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 1 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 28.512C.508 28.512 0 29.02 0 29.646v4.504a1.134 1.134 0 1 0 2.269 0v-4.504c0-.626-.508-1.134-1.135-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 34.15v-4.504a.836.836 0 1 1 1.672 0v4.504a.836.836 0 1 1-1.672 0M0 29.646a1.134 1.134 0 1 1 2.269 0v4.504a1.134 1.134 0 1 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 1.047c-.627 0-1.135.508-1.135 1.134v4.504a1.134 1.134 0 0 0 2.269 0V2.181c0-.626-.508-1.134-1.134-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 6.685V2.181a.836.836 0 0 1 1.671 0v4.504a.836.836 0 0 1-1.671 0m-.299-4.504a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 8.37c-.627 0-1.135.508-1.135 1.135v4.504a1.134 1.134 0 1 0 2.269 0V9.505c0-.627-.508-1.134-1.134-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 14.009V9.505a.836.836 0 0 1 1.671 0v4.504a.836.836 0 0 1-1.671 0m-.299-4.504a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 28.512c-.627 0-1.135.508-1.135 1.134v4.504a1.134 1.134 0 1 0 2.269 0v-4.504c0-.626-.508-1.134-1.134-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 34.15v-4.504a.836.836 0 1 1 1.671 0v4.504a.836.836 0 0 1-1.671 0m-.299-4.504a1.134 1.134 0 1 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCF0DE",
          fillRule: "evenodd",
          stroke: "#F9D199",
          d: "M10.5 45.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F9D199",
          fillRule: "evenodd",
          d: "M1.5 36.795a9 9 0 1 1 18.001.002A9 9 0 0 1 1.5 36.795m9-8.052a8.053 8.053 0 1 0 .001 16.106 8.053 8.053 0 0 0-.001-16.106",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          fillRule: "evenodd",
          d: "M13.424 35.138h-.474v-.948a2.37 2.37 0 0 0-4.736 0v.948H7.74a.95.95 0 0 0-.948.947v4.737a.95.95 0 0 0 .948.947h5.684a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.947M10.582 39.4a.95.95 0 0 1-.947-.948.95.95 0 0 1 .947-.947.95.95 0 0 1 .947.947.95.95 0 0 1-.947.948m1.468-4.263H9.114v-.948a1.47 1.47 0 0 1 2.936 0z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSLoaderDisabled = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-loader-disabled",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 46",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.267 35.768a.477.477 0 0 0 .464-.49V1.285c0-.27-.208-.49-.464-.49H2.61a.477.477 0 0 0-.465.49v33.994c0 .27.208.489.465.489z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.36 1.285v33.994a.096.096 0 0 1-.093.097H2.61a.095.095 0 0 1-.093-.097V1.285c0-.054.042-.098.093-.098h15.657c.051 0 .093.044.093.098m.371 33.994c0 .27-.208.489-.464.489H2.61a.477.477 0 0 1-.465-.49V1.285c0-.27.208-.49.465-.49h15.657c.256 0 .464.22.464.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M6.754 3.176c-.443 0-.802.378-.802.844v28.307c0 .466.36.844.802.844s.802-.378.802-.844V4.02c0-.466-.359-.844-.802-.844M9.263 3.176c-.443 0-.802.378-.802.844v28.307c0 .466.359.844.802.844s.802-.378.802-.844V4.02c0-.466-.36-.844-.802-.844M11.693 3.176c-.443 0-.802.378-.802.844v28.307c0 .466.359.844.802.844s.802-.378.802-.844V4.02c0-.466-.36-.844-.802-.844M14.123 3.176c-.443 0-.802.378-.802.844v28.307c0 .466.359.844.802.844s.802-.378.802-.844V4.02c0-.466-.36-.844-.802-.844"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.238.796a.095.095 0 0 0-.093.098V35.67c0 .054.042.098.093.098h1.748a.095.095 0 0 0 .093-.098V.894a.095.095 0 0 0-.093-.098z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.517 1.187h1.19v34.19h-1.19zM2.145.894c0-.054.042-.098.093-.098h1.748c.051 0 .093.044.093.098V35.67a.095.095 0 0 1-.093.098H2.238a.095.095 0 0 1-.093-.098z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.891.796a.095.095 0 0 0-.093.098V35.67c0 .054.042.098.093.098h1.748a.095.095 0 0 0 .093-.098V.894a.095.095 0 0 0-.093-.098z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.17 1.187h1.19v34.19h-1.19zm-.372-.293c0-.054.042-.098.093-.098h1.748c.051 0 .093.044.093.098V35.67a.095.095 0 0 1-.093.098H16.89a.095.095 0 0 1-.093-.098z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 1.047C.508 1.047 0 1.555 0 2.18v4.504a1.134 1.134 0 0 0 2.269 0V2.181c0-.626-.508-1.134-1.135-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 6.685V2.181a.836.836 0 0 1 1.672 0v4.504a.836.836 0 0 1-1.672 0M0 2.181a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 8.37C.508 8.37 0 8.879 0 9.506v4.504a1.134 1.134 0 1 0 2.269 0V9.505c0-.627-.508-1.134-1.135-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 14.009V9.505a.836.836 0 0 1 1.672 0v4.504a.836.836 0 1 1-1.672 0M0 9.505a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 1 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 28.512C.508 28.512 0 29.02 0 29.646v4.504a1.134 1.134 0 1 0 2.269 0v-4.504c0-.626-.508-1.134-1.135-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 34.15v-4.504a.836.836 0 1 1 1.672 0v4.504a.836.836 0 1 1-1.672 0M0 29.646a1.134 1.134 0 1 1 2.269 0v4.504a1.134 1.134 0 1 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 1.047c-.627 0-1.135.508-1.135 1.134v4.504a1.134 1.134 0 0 0 2.269 0V2.181c0-.626-.508-1.134-1.134-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 6.685V2.181a.836.836 0 0 1 1.671 0v4.504a.836.836 0 0 1-1.671 0m-.299-4.504a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 8.37c-.627 0-1.135.508-1.135 1.135v4.504a1.134 1.134 0 1 0 2.269 0V9.505c0-.627-.508-1.134-1.134-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 14.009V9.505a.836.836 0 0 1 1.671 0v4.504a.836.836 0 0 1-1.671 0m-.299-4.504a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 28.512c-.627 0-1.135.508-1.135 1.134v4.504a1.134 1.134 0 1 0 2.269 0v-4.504c0-.626-.508-1.134-1.134-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 34.15v-4.504a.836.836 0 1 1 1.671 0v4.504a.836.836 0 0 1-1.671 0m-.299-4.504a1.134 1.134 0 1 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCEDEB",
          fillRule: "evenodd",
          stroke: "#F5B7B1",
          d: "M10.5 45.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F5B7B1",
          fillRule: "evenodd",
          d: "M1.5 36.795a9 9 0 1 1 18.001.002A9 9 0 0 1 1.5 36.795m9-8.052a8.053 8.053 0 1 0 .001 16.106 8.053 8.053 0 0 0-.001-16.106",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          fillRule: "evenodd",
          d: "M13.424 35.138h-.474v-.948a2.37 2.37 0 0 0-4.736 0v.948H7.74a.95.95 0 0 0-.948.947v4.737a.95.95 0 0 0 .948.947h5.684a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.947M10.582 39.4a.95.95 0 0 1-.947-.948.95.95 0 0 1 .947-.947.95.95 0 0 1 .947.947.95.95 0 0 1-.947.948m1.468-4.263H9.114v-.948a1.47 1.47 0 0 1 2.936 0z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSLoaderEnablePending = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-loader-enable-pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 46",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.267 35.768a.477.477 0 0 0 .464-.49V1.285c0-.27-.208-.49-.464-.49H2.61a.477.477 0 0 0-.465.49v33.994c0 .27.208.489.465.489z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.36 1.285v33.994a.096.096 0 0 1-.093.097H2.61a.095.095 0 0 1-.093-.097V1.285c0-.054.042-.098.093-.098h15.657c.051 0 .093.044.093.098m.371 33.994c0 .27-.208.489-.464.489H2.61a.477.477 0 0 1-.465-.49V1.285c0-.27.208-.49.465-.49h15.657c.256 0 .464.22.464.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M6.754 3.176c-.443 0-.802.378-.802.844v28.307c0 .466.36.844.802.844s.802-.378.802-.844V4.02c0-.466-.359-.844-.802-.844M9.263 3.176c-.443 0-.802.378-.802.844v28.307c0 .466.359.844.802.844s.802-.378.802-.844V4.02c0-.466-.36-.844-.802-.844M11.693 3.176c-.443 0-.802.378-.802.844v28.307c0 .466.359.844.802.844s.802-.378.802-.844V4.02c0-.466-.36-.844-.802-.844M14.123 3.176c-.443 0-.802.378-.802.844v28.307c0 .466.359.844.802.844s.802-.378.802-.844V4.02c0-.466-.36-.844-.802-.844"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.238.796a.095.095 0 0 0-.093.098V35.67c0 .054.042.098.093.098h1.748a.095.095 0 0 0 .093-.098V.894a.095.095 0 0 0-.093-.098z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.517 1.187h1.19v34.19h-1.19zM2.145.894c0-.054.042-.098.093-.098h1.748c.051 0 .093.044.093.098V35.67a.095.095 0 0 1-.093.098H2.238a.095.095 0 0 1-.093-.098z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.891.796a.095.095 0 0 0-.093.098V35.67c0 .054.042.098.093.098h1.748a.095.095 0 0 0 .093-.098V.894a.095.095 0 0 0-.093-.098z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.17 1.187h1.19v34.19h-1.19zm-.372-.293c0-.054.042-.098.093-.098h1.748c.051 0 .093.044.093.098V35.67a.095.095 0 0 1-.093.098H16.89a.095.095 0 0 1-.093-.098z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 1.047C.508 1.047 0 1.555 0 2.18v4.504a1.134 1.134 0 0 0 2.269 0V2.181c0-.626-.508-1.134-1.135-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 6.685V2.181a.836.836 0 0 1 1.672 0v4.504a.836.836 0 0 1-1.672 0M0 2.181a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 8.37C.508 8.37 0 8.879 0 9.506v4.504a1.134 1.134 0 1 0 2.269 0V9.505c0-.627-.508-1.134-1.135-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 14.009V9.505a.836.836 0 0 1 1.672 0v4.504a.836.836 0 1 1-1.672 0M0 9.505a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 1 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 28.512C.508 28.512 0 29.02 0 29.646v4.504a1.134 1.134 0 1 0 2.269 0v-4.504c0-.626-.508-1.134-1.135-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 34.15v-4.504a.836.836 0 1 1 1.672 0v4.504a.836.836 0 1 1-1.672 0M0 29.646a1.134 1.134 0 1 1 2.269 0v4.504a1.134 1.134 0 1 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 1.047c-.627 0-1.135.508-1.135 1.134v4.504a1.134 1.134 0 0 0 2.269 0V2.181c0-.626-.508-1.134-1.134-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 6.685V2.181a.836.836 0 0 1 1.671 0v4.504a.836.836 0 0 1-1.671 0m-.299-4.504a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 8.37c-.627 0-1.135.508-1.135 1.135v4.504a1.134 1.134 0 1 0 2.269 0V9.505c0-.627-.508-1.134-1.134-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 14.009V9.505a.836.836 0 0 1 1.671 0v4.504a.836.836 0 0 1-1.671 0m-.299-4.504a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 28.512c-.627 0-1.135.508-1.135 1.134v4.504a1.134 1.134 0 1 0 2.269 0v-4.504c0-.626-.508-1.134-1.134-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 34.15v-4.504a.836.836 0 1 1 1.671 0v4.504a.836.836 0 0 1-1.671 0m-.299-4.504a1.134 1.134 0 1 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#CFDEF2",
          fillRule: "evenodd",
          stroke: "#F5B7B1",
          d: "M10.5 45.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#8AB9F7",
          fillRule: "evenodd",
          d: "M1.5 36.795a9 9 0 1 1 18.001.002A9 9 0 0 1 1.5 36.795m9-8.052a8.053 8.053 0 1 0 .001 16.106 8.053 8.053 0 0 0-.001-16.106",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1774F0",
          fillRule: "evenodd",
          d: "M10.582 39.164a.95.95 0 0 0 .947-.947.95.95 0 0 0-.947-.948.95.95 0 0 0-.947.948.95.95 0 0 0 .947.947m2.842-4.263h-.474v-.948a2.37 2.37 0 0 0-4.736 0h.9a1.47 1.47 0 0 1 2.936 0v.948H7.74a.95.95 0 0 0-.948.947v4.737a.95.95 0 0 0 .948.947h5.684a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.947m0 5.684H7.74v-4.737h5.684z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSLoaderNoSignal = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-loader-no-signal",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 46",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.267 35.768a.477.477 0 0 0 .464-.49V1.285c0-.27-.208-.49-.464-.49H2.61a.477.477 0 0 0-.465.49v33.994c0 .27.208.489.465.489z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.36 1.285v33.994a.096.096 0 0 1-.093.097H2.61a.095.095 0 0 1-.093-.097V1.285c0-.054.042-.098.093-.098h15.657c.051 0 .093.044.093.098m.371 33.994c0 .27-.208.489-.464.489H2.61a.477.477 0 0 1-.465-.49V1.285c0-.27.208-.49.465-.49h15.657c.256 0 .464.22.464.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M6.754 3.176c-.443 0-.802.378-.802.844v28.307c0 .466.36.844.802.844s.802-.378.802-.844V4.02c0-.466-.359-.844-.802-.844M9.263 3.176c-.443 0-.802.378-.802.844v28.307c0 .466.359.844.802.844s.802-.378.802-.844V4.02c0-.466-.36-.844-.802-.844M11.693 3.176c-.443 0-.802.378-.802.844v28.307c0 .466.359.844.802.844s.802-.378.802-.844V4.02c0-.466-.36-.844-.802-.844M14.123 3.176c-.443 0-.802.378-.802.844v28.307c0 .466.359.844.802.844s.802-.378.802-.844V4.02c0-.466-.36-.844-.802-.844"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.238.796a.095.095 0 0 0-.093.098V35.67c0 .054.042.098.093.098h1.748a.095.095 0 0 0 .093-.098V.894a.095.095 0 0 0-.093-.098z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.517 1.187h1.19v34.19h-1.19zM2.145.894c0-.054.042-.098.093-.098h1.748c.051 0 .093.044.093.098V35.67a.095.095 0 0 1-.093.098H2.238a.095.095 0 0 1-.093-.098z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.891.796a.095.095 0 0 0-.093.098V35.67c0 .054.042.098.093.098h1.748a.095.095 0 0 0 .093-.098V.894a.095.095 0 0 0-.093-.098z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.17 1.187h1.19v34.19h-1.19zm-.372-.293c0-.054.042-.098.093-.098h1.748c.051 0 .093.044.093.098V35.67a.095.095 0 0 1-.093.098H16.89a.095.095 0 0 1-.093-.098z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 1.047C.508 1.047 0 1.555 0 2.18v4.504a1.134 1.134 0 0 0 2.269 0V2.181c0-.626-.508-1.134-1.135-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 6.685V2.181a.836.836 0 0 1 1.672 0v4.504a.836.836 0 0 1-1.672 0M0 2.181a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 8.37C.508 8.37 0 8.879 0 9.506v4.504a1.134 1.134 0 1 0 2.269 0V9.505c0-.627-.508-1.134-1.135-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 14.009V9.505a.836.836 0 0 1 1.672 0v4.504a.836.836 0 1 1-1.672 0M0 9.505a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 1 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 28.512C.508 28.512 0 29.02 0 29.646v4.504a1.134 1.134 0 1 0 2.269 0v-4.504c0-.626-.508-1.134-1.135-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 34.15v-4.504a.836.836 0 1 1 1.672 0v4.504a.836.836 0 1 1-1.672 0M0 29.646a1.134 1.134 0 1 1 2.269 0v4.504a1.134 1.134 0 1 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 1.047c-.627 0-1.135.508-1.135 1.134v4.504a1.134 1.134 0 0 0 2.269 0V2.181c0-.626-.508-1.134-1.134-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 6.685V2.181a.836.836 0 0 1 1.671 0v4.504a.836.836 0 0 1-1.671 0m-.299-4.504a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 8.37c-.627 0-1.135.508-1.135 1.135v4.504a1.134 1.134 0 1 0 2.269 0V9.505c0-.627-.508-1.134-1.134-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 14.009V9.505a.836.836 0 0 1 1.671 0v4.504a.836.836 0 0 1-1.671 0m-.299-4.504a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 28.512c-.627 0-1.135.508-1.135 1.134v4.504a1.134 1.134 0 1 0 2.269 0v-4.504c0-.626-.508-1.134-1.134-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 34.15v-4.504a.836.836 0 1 1 1.671 0v4.504a.836.836 0 0 1-1.671 0m-.299-4.504a1.134 1.134 0 1 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M9.8 28.58a.99.99 0 0 1 1.4 0l7.515 7.515a.99.99 0 0 1 0 1.4L11.2 45.01a.99.99 0 0 1-1.401 0l-7.515-7.514a.99.99 0 0 1 0-1.401z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#9DA9B6",
          fillRule: "evenodd",
          d: "M9.45 28.23c.58-.58 1.52-.58 2.1 0l7.515 7.515c.58.58.58 1.52 0 2.101L11.55 45.36c-.58.58-1.521.58-2.102 0l-7.514-7.514a1.486 1.486 0 0 1 0-2.101zm1.4.701a.495.495 0 0 0-.7 0l-7.514 7.514a.495.495 0 0 0 0 .7l7.514 7.515a.495.495 0 0 0 .7 0l7.514-7.514a.495.495 0 0 0 0-.7z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          d: "M13.637 33.156a.386.386 0 0 0-.659-.273l-2.542 2.542 3.2 3.201zm.17 6.73-6.095-6.094a.384.384 0 1 0-.543.543l2.18 2.18-2.758 2.758a.385.385 0 0 0 .27.66h5.901l.497.496c.15.15.393.15.543 0a.38.38 0 0 0 .004-.543"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M5.547 31.843h9.245v9.245H5.547z" }) }) })
    ]
  }
);
const VehicleSLoaderOff = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-loader-off",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 46",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.267 35.768a.477.477 0 0 0 .464-.49V1.285c0-.27-.208-.49-.464-.49H2.61a.477.477 0 0 0-.465.49v33.994c0 .27.208.489.465.489z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.36 1.285v33.994a.096.096 0 0 1-.093.097H2.61a.095.095 0 0 1-.093-.097V1.285c0-.054.042-.098.093-.098h15.657c.051 0 .093.044.093.098m.371 33.994c0 .27-.208.489-.464.489H2.61a.477.477 0 0 1-.465-.49V1.285c0-.27.208-.49.465-.49h15.657c.256 0 .464.22.464.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M6.754 3.176c-.443 0-.802.378-.802.844v28.307c0 .466.36.844.802.844s.802-.378.802-.844V4.02c0-.466-.359-.844-.802-.844M9.263 3.176c-.443 0-.802.378-.802.844v28.307c0 .466.359.844.802.844s.802-.378.802-.844V4.02c0-.466-.36-.844-.802-.844M11.693 3.176c-.443 0-.802.378-.802.844v28.307c0 .466.359.844.802.844s.802-.378.802-.844V4.02c0-.466-.36-.844-.802-.844M14.123 3.176c-.443 0-.802.378-.802.844v28.307c0 .466.359.844.802.844s.802-.378.802-.844V4.02c0-.466-.36-.844-.802-.844"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.238.796a.095.095 0 0 0-.093.098V35.67c0 .054.042.098.093.098h1.748a.095.095 0 0 0 .093-.098V.894a.095.095 0 0 0-.093-.098z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.517 1.187h1.19v34.19h-1.19zM2.145.894c0-.054.042-.098.093-.098h1.748c.051 0 .093.044.093.098V35.67a.095.095 0 0 1-.093.098H2.238a.095.095 0 0 1-.093-.098z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.891.796a.095.095 0 0 0-.093.098V35.67c0 .054.042.098.093.098h1.748a.095.095 0 0 0 .093-.098V.894a.095.095 0 0 0-.093-.098z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.17 1.187h1.19v34.19h-1.19zm-.372-.293c0-.054.042-.098.093-.098h1.748c.051 0 .093.044.093.098V35.67a.095.095 0 0 1-.093.098H16.89a.095.095 0 0 1-.093-.098z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 1.047C.508 1.047 0 1.555 0 2.18v4.504a1.134 1.134 0 0 0 2.269 0V2.181c0-.626-.508-1.134-1.135-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 6.685V2.181a.836.836 0 0 1 1.672 0v4.504a.836.836 0 0 1-1.672 0M0 2.181a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 8.37C.508 8.37 0 8.879 0 9.506v4.504a1.134 1.134 0 1 0 2.269 0V9.505c0-.627-.508-1.134-1.135-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 14.009V9.505a.836.836 0 0 1 1.672 0v4.504a.836.836 0 1 1-1.672 0M0 9.505a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 1 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 28.512C.508 28.512 0 29.02 0 29.646v4.504a1.134 1.134 0 1 0 2.269 0v-4.504c0-.626-.508-1.134-1.135-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 34.15v-4.504a.836.836 0 1 1 1.672 0v4.504a.836.836 0 1 1-1.672 0M0 29.646a1.134 1.134 0 1 1 2.269 0v4.504a1.134 1.134 0 1 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 1.047c-.627 0-1.135.508-1.135 1.134v4.504a1.134 1.134 0 0 0 2.269 0V2.181c0-.626-.508-1.134-1.134-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 6.685V2.181a.836.836 0 0 1 1.671 0v4.504a.836.836 0 0 1-1.671 0m-.299-4.504a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 8.37c-.627 0-1.135.508-1.135 1.135v4.504a1.134 1.134 0 1 0 2.269 0V9.505c0-.627-.508-1.134-1.134-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 14.009V9.505a.836.836 0 0 1 1.671 0v4.504a.836.836 0 0 1-1.671 0m-.299-4.504a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 28.512c-.627 0-1.135.508-1.135 1.134v4.504a1.134 1.134 0 1 0 2.269 0v-4.504c0-.626-.508-1.134-1.134-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 34.15v-4.504a.836.836 0 1 1 1.671 0v4.504a.836.836 0 0 1-1.671 0m-.299-4.504a1.134 1.134 0 1 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M10.5 45.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M1.5 36.795a9 9 0 1 1 18.001.002A9 9 0 0 1 1.5 36.795m9-8.052a8.053 8.053 0 1 0 .001 16.106 8.053 8.053 0 0 0-.001-16.106",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M6.972 36.796a3.528 3.528 0 1 0 7.056 0 3.528 3.528 0 0 0-7.056 0m-.893 0a4.421 4.421 0 1 0 8.842 0 4.421 4.421 0 0 0-8.842 0m2.615-.301a.55.55 0 0 0-.11.35q0 .209.11.35a.33.33 0 0 0 .273.14h3.066q.162 0 .273-.14a.55.55 0 0 0 .11-.35.55.55 0 0 0-.11-.35.33.33 0 0 0-.273-.142H8.967q-.163 0-.273.142",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSLoaderOn = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-loader-on",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 46",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.267 35.768a.477.477 0 0 0 .464-.49V1.285c0-.27-.208-.49-.464-.49H2.61a.477.477 0 0 0-.465.49v33.994c0 .27.208.489.465.489z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.36 1.285v33.994a.096.096 0 0 1-.093.097H2.61a.095.095 0 0 1-.093-.097V1.285c0-.054.042-.098.093-.098h15.657c.051 0 .093.044.093.098m.371 33.994c0 .27-.208.489-.464.489H2.61a.477.477 0 0 1-.465-.49V1.285c0-.27.208-.49.465-.49h15.657c.256 0 .464.22.464.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M6.754 3.176c-.443 0-.802.378-.802.844v28.307c0 .466.36.844.802.844s.802-.378.802-.844V4.02c0-.466-.359-.844-.802-.844M9.263 3.176c-.443 0-.802.378-.802.844v28.307c0 .466.359.844.802.844s.802-.378.802-.844V4.02c0-.466-.36-.844-.802-.844M11.693 3.176c-.443 0-.802.378-.802.844v28.307c0 .466.359.844.802.844s.802-.378.802-.844V4.02c0-.466-.36-.844-.802-.844M14.123 3.176c-.443 0-.802.378-.802.844v28.307c0 .466.359.844.802.844s.802-.378.802-.844V4.02c0-.466-.36-.844-.802-.844"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.238.796a.095.095 0 0 0-.093.098V35.67c0 .054.042.098.093.098h1.748a.095.095 0 0 0 .093-.098V.894a.095.095 0 0 0-.093-.098z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.517 1.187h1.19v34.19h-1.19zM2.145.894c0-.054.042-.098.093-.098h1.748c.051 0 .093.044.093.098V35.67a.095.095 0 0 1-.093.098H2.238a.095.095 0 0 1-.093-.098z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.891.796a.095.095 0 0 0-.093.098V35.67c0 .054.042.098.093.098h1.748a.095.095 0 0 0 .093-.098V.894a.095.095 0 0 0-.093-.098z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.17 1.187h1.19v34.19h-1.19zm-.372-.293c0-.054.042-.098.093-.098h1.748c.051 0 .093.044.093.098V35.67a.095.095 0 0 1-.093.098H16.89a.095.095 0 0 1-.093-.098z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 1.047C.508 1.047 0 1.555 0 2.18v4.504a1.134 1.134 0 0 0 2.269 0V2.181c0-.626-.508-1.134-1.135-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 6.685V2.181a.836.836 0 0 1 1.672 0v4.504a.836.836 0 0 1-1.672 0M0 2.181a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 8.37C.508 8.37 0 8.879 0 9.506v4.504a1.134 1.134 0 1 0 2.269 0V9.505c0-.627-.508-1.134-1.135-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 14.009V9.505a.836.836 0 0 1 1.672 0v4.504a.836.836 0 1 1-1.672 0M0 9.505a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 1 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 28.512C.508 28.512 0 29.02 0 29.646v4.504a1.134 1.134 0 1 0 2.269 0v-4.504c0-.626-.508-1.134-1.135-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 34.15v-4.504a.836.836 0 1 1 1.672 0v4.504a.836.836 0 1 1-1.672 0M0 29.646a1.134 1.134 0 1 1 2.269 0v4.504a1.134 1.134 0 1 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 1.047c-.627 0-1.135.508-1.135 1.134v4.504a1.134 1.134 0 0 0 2.269 0V2.181c0-.626-.508-1.134-1.134-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 6.685V2.181a.836.836 0 0 1 1.671 0v4.504a.836.836 0 0 1-1.671 0m-.299-4.504a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 8.37c-.627 0-1.135.508-1.135 1.135v4.504a1.134 1.134 0 1 0 2.269 0V9.505c0-.627-.508-1.134-1.134-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 14.009V9.505a.836.836 0 0 1 1.671 0v4.504a.836.836 0 0 1-1.671 0m-.299-4.504a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 28.512c-.627 0-1.135.508-1.135 1.134v4.504a1.134 1.134 0 1 0 2.269 0v-4.504c0-.626-.508-1.134-1.134-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 34.15v-4.504a.836.836 0 1 1 1.671 0v4.504a.836.836 0 0 1-1.671 0m-.299-4.504a1.134 1.134 0 1 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#03D8A9",
          fillRule: "evenodd",
          d: "M10.5 45.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M1.5 36.795a9 9 0 1 1 18.001.002A9 9 0 0 1 1.5 36.795m9-8.052a8.053 8.053 0 1 0 .001 16.106 8.053 8.053 0 0 0-.001-16.106",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M10.5 37.286a.48.48 0 0 1-.35-.14.48.48 0 0 1-.142-.35v-3.93q0-.21.142-.35a.48.48 0 0 1 .35-.142q.208 0 .35.141.14.141.14.35v3.93q0 .21-.14.35a.48.48 0 0 1-.35.141m0 3.93q-.921 0-1.726-.35a4.5 4.5 0 0 1-1.4-.946 4.5 4.5 0 0 1-.945-1.4 4.3 4.3 0 0 1-.35-1.725q0-.847.307-1.621.306-.773.884-1.4a.45.45 0 0 1 .344-.147q.209 0 .356.147a.42.42 0 0 1 .123.338.6.6 0 0 1-.148.362q-.429.48-.657 1.075a3.5 3.5 0 0 0-.227 1.246q0 1.437 1 2.438 1.001 1 2.439 1 1.437 0 2.437-1 1.001-1 1.001-2.438 0-.65-.233-1.259a3.5 3.5 0 0 0-.663-1.087.52.52 0 0 1-.142-.343.43.43 0 0 1 .13-.332.49.49 0 0 1 .356-.147q.208 0 .344.147.576.627.884 1.4.307.774.307 1.621 0 .922-.35 1.725a4.5 4.5 0 0 1-.946 1.4 4.5 4.5 0 0 1-1.4.946 4.3 4.3 0 0 1-1.725.35"
        }
      )
    ]
  }
);
const VehicleSLoaderUnavailable = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-loader-unavailable",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 46",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.267 35.827c.256 0 .464-.22.464-.49V1.301c0-.27-.208-.49-.465-.49H2.61a.48.48 0 0 0-.465.49v34.036c0 .27.208.49.465.49z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.36 1.301v34.036a.095.095 0 0 1-.093.098H2.61a.096.096 0 0 1-.093-.098V1.301c0-.054.041-.098.093-.098h15.657c.05 0 .092.044.092.098m.371 34.036c0 .27-.208.49-.465.49H2.61a.48.48 0 0 1-.465-.49V1.301c0-.27.208-.49.465-.49h15.657c.256 0 .464.22.464.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M6.754 3.195c-.443 0-.802.379-.802.845v28.342c0 .467.359.845.802.845s.802-.378.802-.845V4.04c0-.466-.36-.845-.802-.845M9.262 3.195c-.442 0-.802.379-.802.845v28.342c0 .467.36.845.802.845s.802-.378.802-.845V4.04c0-.466-.359-.845-.802-.845M11.693 3.195c-.443 0-.802.379-.802.845v28.342c0 .467.359.845.802.845s.802-.378.802-.845V4.04c0-.466-.36-.845-.802-.845M14.122 3.195c-.443 0-.802.379-.802.845v28.342c0 .467.36.845.802.845s.802-.378.802-.845V4.04c0-.466-.359-.845-.802-.845"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.238.812a.096.096 0 0 0-.093.097v34.82c0 .054.042.098.093.098h1.748a.096.096 0 0 0 .093-.098V.909a.096.096 0 0 0-.093-.097z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.517 1.203h1.19v34.232h-1.19zM2.145.91c0-.054.042-.097.093-.097h1.748c.051 0 .093.043.093.097v34.82a.096.096 0 0 1-.093.098H2.238a.095.095 0 0 1-.093-.098z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.89.812a.096.096 0 0 0-.092.098v34.82c0 .053.042.097.093.097h1.748a.095.095 0 0 0 .093-.098V.91a.096.096 0 0 0-.093-.097z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.17 1.204h1.19v34.231h-1.19zM16.798.91c0-.054.042-.098.093-.098h1.748c.05 0 .093.044.093.098v34.82a.095.095 0 0 1-.093.097H16.89a.095.095 0 0 1-.093-.098z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 1.063C.508 1.063 0 1.571 0 2.199v4.51a1.135 1.135 0 1 0 2.269 0v-4.51c0-.628-.508-1.136-1.135-1.136"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 6.708v-4.51a.836.836 0 1 1 1.672 0v4.51a.836.836 0 1 1-1.672 0M0 2.198a1.135 1.135 0 1 1 2.269 0v4.51a1.135 1.135 0 1 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 8.396C.508 8.396 0 8.904 0 9.532v4.51a1.135 1.135 0 1 0 2.269 0v-4.51c0-.628-.508-1.136-1.135-1.136"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 14.041v-4.51a.836.836 0 1 1 1.672 0v4.51a.836.836 0 1 1-1.672 0M0 9.531a1.135 1.135 0 1 1 2.269 0v4.51a1.135 1.135 0 1 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 28.562C.508 28.562 0 29.07 0 29.698v4.51a1.135 1.135 0 1 0 2.269 0v-4.51c0-.628-.508-1.136-1.135-1.136"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 34.207v-4.51a.836.836 0 1 1 1.672 0v4.51a.836.836 0 1 1-1.672 0M0 29.697a1.135 1.135 0 1 1 2.269 0v4.51a1.135 1.135 0 1 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 1.063c-.627 0-1.135.508-1.135 1.136v4.51a1.135 1.135 0 1 0 2.269 0v-4.51c0-.628-.508-1.136-1.134-1.136"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 6.708v-4.51a.836.836 0 1 1 1.671 0v4.51a.836.836 0 1 1-1.671 0m-.299-4.51a1.135 1.135 0 1 1 2.269 0v4.51a1.135 1.135 0 1 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 8.396c-.627 0-1.135.508-1.135 1.136v4.51a1.135 1.135 0 1 0 2.269 0v-4.51c0-.628-.508-1.136-1.134-1.136"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 14.041v-4.51a.836.836 0 1 1 1.671 0v4.51a.836.836 0 1 1-1.671 0m-.299-4.51a1.135 1.135 0 1 1 2.269 0v4.51a1.135 1.135 0 1 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 28.562c-.627 0-1.135.508-1.135 1.136v4.51a1.135 1.135 0 1 0 2.269 0v-4.51c0-.628-.508-1.136-1.134-1.136"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 34.207v-4.51a.836.836 0 1 1 1.671 0v4.51a.836.836 0 1 1-1.671 0m-.299-4.51a1.135 1.135 0 1 1 2.269 0v4.51a1.135 1.135 0 1 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          d: "M3.036 29.822h14.928c.78 0 1.273.838.894 1.52l-7.464 13.413c-.39.7-1.398.7-1.788 0L2.143 31.34c-.38-.68.113-1.519.893-1.519"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M11.84 45.003a1.534 1.534 0 0 1-2.68 0L1.696 31.59a1.534 1.534 0 0 1 1.34-2.279h14.928c1.17 0 1.91 1.257 1.34 2.28zm-1.787-.497c.195.35.699.35.894 0l7.464-13.413a.51.51 0 0 0-.447-.76H3.036a.51.51 0 0 0-.447.76z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M10.5 40.326a.76.76 0 0 1-.569-.245.82.82 0 0 1-.236-.59q0-.344.236-.59a.76.76 0 0 1 .57-.245q.33 0 .568.246.236.245.236.59a.82.82 0 0 1-.236.589.76.76 0 0 1-.569.245m0-2.505a.76.76 0 0 1-.569-.245.82.82 0 0 1-.236-.59v-3.34q0-.343.236-.589a.76.76 0 0 1 .57-.245q.33 0 .568.245.236.245.236.59v3.34a.82.82 0 0 1-.236.59.76.76 0 0 1-.569.244"
        }
      )
    ]
  }
);
const VehicleSLoaderUnplugged = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-loader-unplugged",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 46",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.267 35.804c.256 0 .464-.219.464-.49V1.297c0-.27-.208-.489-.465-.489H2.61a.48.48 0 0 0-.465.49v34.018c0 .27.208.49.465.49z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.36 1.296v34.019a.096.096 0 0 1-.093.098H2.61a.096.096 0 0 1-.093-.098V1.296c0-.054.041-.097.093-.097h15.657c.05 0 .092.043.092.097m.371 34.019c0 .27-.208.49-.465.49H2.61a.48.48 0 0 1-.465-.49V1.296c0-.27.208-.489.465-.489h15.657c.256 0 .464.22.464.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M6.754 3.19c-.443 0-.802.378-.802.844v28.327c0 .467.359.845.802.845s.802-.379.802-.845V4.034c0-.466-.36-.845-.802-.845M9.262 3.19c-.442 0-.802.378-.802.844v28.327c0 .467.36.845.802.845s.802-.379.802-.845V4.034c0-.466-.359-.845-.802-.845M11.693 3.19c-.443 0-.802.378-.802.844v28.327c0 .467.359.845.802.845s.802-.379.802-.845V4.034c0-.466-.36-.845-.802-.845M14.122 3.19c-.443 0-.802.378-.802.844v28.327c0 .467.36.845.802.845s.802-.379.802-.845V4.034c0-.466-.359-.845-.802-.845"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.238.807a.096.096 0 0 0-.093.098v34.801c0 .054.042.098.093.098h1.748a.096.096 0 0 0 .093-.098V.905a.096.096 0 0 0-.093-.098z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.517 1.199h1.19v34.214h-1.19zM2.145.905c0-.054.042-.098.093-.098h1.748c.051 0 .093.044.093.098v34.801a.096.096 0 0 1-.093.098H2.238a.095.095 0 0 1-.093-.098z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.89.808a.095.095 0 0 0-.092.098v34.8c0 .055.042.099.093.099h1.748a.095.095 0 0 0 .093-.098V.905a.095.095 0 0 0-.093-.097z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.17 1.2h1.19v34.213h-1.19zm-.372-.294c0-.055.042-.098.093-.098h1.748c.05 0 .093.043.093.097v34.802a.095.095 0 0 1-.093.098H16.89a.095.095 0 0 1-.093-.098z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 1.059C.508 1.059 0 1.567 0 2.194V6.7a1.135 1.135 0 1 0 2.269 0V2.194c0-.627-.508-1.135-1.135-1.135"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 6.7V2.195a.836.836 0 1 1 1.672 0V6.7a.836.836 0 1 1-1.672 0M0 2.195a1.135 1.135 0 1 1 2.269 0V6.7A1.135 1.135 0 1 1 0 6.7z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 8.388C.508 8.388 0 8.896 0 9.523v4.507a1.135 1.135 0 1 0 2.269 0V9.523c0-.627-.508-1.135-1.135-1.135"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 14.03V9.523a.836.836 0 1 1 1.672 0v4.507a.836.836 0 1 1-1.672 0M0 9.523a1.135 1.135 0 1 1 2.269 0v4.507a1.135 1.135 0 1 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 28.543c-.626 0-1.134.508-1.134 1.135v4.507a1.135 1.135 0 1 0 2.269 0v-4.507c0-.627-.508-1.135-1.135-1.135"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 34.185v-4.507a.836.836 0 1 1 1.672 0v4.507a.836.836 0 1 1-1.672 0M0 29.678a1.135 1.135 0 1 1 2.269 0v4.507a1.135 1.135 0 1 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 1.059c-.627 0-1.135.508-1.135 1.135V6.7A1.135 1.135 0 1 0 21 6.7V2.194c0-.627-.508-1.135-1.134-1.135"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 6.7V2.195a.836.836 0 1 1 1.671 0V6.7a.836.836 0 1 1-1.671 0m-.299-4.506a1.135 1.135 0 1 1 2.269 0V6.7a1.135 1.135 0 1 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 8.388c-.627 0-1.135.508-1.135 1.135v4.507a1.135 1.135 0 1 0 2.269 0V9.523c0-.627-.508-1.135-1.134-1.135"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 14.03V9.523a.836.836 0 1 1 1.671 0v4.507a.836.836 0 1 1-1.671 0m-.299-4.507a1.135 1.135 0 1 1 2.269 0v4.507a1.135 1.135 0 1 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 28.543c-.627 0-1.135.508-1.135 1.135v4.507a1.135 1.135 0 1 0 2.269 0v-4.507c0-.627-.508-1.135-1.134-1.135"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 34.185v-4.507a.836.836 0 1 1 1.671 0v4.507a.836.836 0 1 1-1.671 0m-.299-4.507a1.135 1.135 0 1 1 2.269 0v4.507a1.135 1.135 0 1 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          d: "M3.035 29.823h14.913c.78 0 1.272.837.893 1.519l-7.457 13.413c-.39.7-1.396.7-1.785 0L2.142 31.342a1.022 1.022 0 0 1 .893-1.52"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M11.83 45.003a1.532 1.532 0 0 1-2.678 0L1.695 31.59a1.534 1.534 0 0 1 1.34-2.279h14.913a1.534 1.534 0 0 1 1.34 2.28zm-1.785-.497a.51.51 0 0 0 .893 0l7.457-13.413a.51.51 0 0 0-.447-.76H3.034a.51.51 0 0 0-.446.76z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M11.992 33.112c0-.165-.128-.3-.284-.3a.29.29 0 0 0-.285.3v1.96H9.56v-1.96c0-.165-.127-.3-.285-.3a.293.293 0 0 0-.284.3v1.96h-.645v1.202c.003 1.07.72 1.99 1.716 2.203v1.85h.858v-1.85c.996-.213 1.713-1.133 1.717-2.203v-1.206h-.645z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M6.2 32.276h8.582v8.588H6.2z" }) }) })
    ]
  }
);
const VehicleSLoader = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-loader",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 36",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.267 35.795a.477.477 0 0 0 .464-.489V1.313c0-.27-.208-.49-.464-.49H2.61a.477.477 0 0 0-.465.49v33.993c0 .27.208.49.465.49z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M18.36 1.313v33.993a.096.096 0 0 1-.093.098H2.61a.096.096 0 0 1-.093-.098V1.313c0-.054.042-.098.093-.098h15.657c.051 0 .093.044.093.098m.371 33.993c0 .27-.208.49-.464.49H2.61a.477.477 0 0 1-.465-.49V1.313c0-.27.208-.49.465-.49h15.657c.256 0 .464.22.464.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M6.754 3.204c-.443 0-.802.378-.802.844v28.307c0 .466.36.844.802.844s.802-.378.802-.844V4.048c0-.466-.359-.844-.802-.844M9.263 3.204c-.443 0-.802.378-.802.844v28.307c0 .466.359.844.802.844s.802-.378.802-.844V4.048c0-.466-.36-.844-.802-.844M11.693 3.204c-.443 0-.802.378-.802.844v28.307c0 .466.359.844.802.844s.802-.378.802-.844V4.048c0-.466-.36-.844-.802-.844M14.123 3.204c-.443 0-.802.378-.802.844v28.307c0 .466.359.844.802.844s.802-.378.802-.844V4.048c0-.466-.36-.844-.802-.844"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M2.238.824a.095.095 0 0 0-.093.098v34.776c0 .054.042.098.093.098h1.748a.095.095 0 0 0 .093-.098V.922a.095.095 0 0 0-.093-.098z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.517 1.215h1.19v34.19h-1.19zM2.145.922c0-.054.042-.098.093-.098h1.748c.051 0 .093.044.093.098v34.776a.095.095 0 0 1-.093.098H2.238a.096.096 0 0 1-.093-.098z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.891.824a.095.095 0 0 0-.093.098v34.776c0 .054.042.098.093.098h1.748a.096.096 0 0 0 .093-.098V.922a.095.095 0 0 0-.093-.098z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M17.17 1.215h1.19v34.19h-1.19zm-.372-.293c0-.054.042-.098.093-.098h1.748c.051 0 .093.044.093.098v34.776a.096.096 0 0 1-.093.098H16.89a.095.095 0 0 1-.093-.098z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 1.075C.508 1.075 0 1.583 0 2.209v4.504a1.134 1.134 0 1 0 2.269 0V2.209c0-.626-.508-1.134-1.135-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 6.713V2.209a.836.836 0 0 1 1.672 0v4.504a.836.836 0 0 1-1.672 0M0 2.209a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 8.398C.508 8.398 0 8.906 0 9.533v4.504a1.134 1.134 0 1 0 2.269 0V9.533c0-.627-.508-1.135-1.135-1.135"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 14.037V9.533a.836.836 0 0 1 1.672 0v4.504a.836.836 0 1 1-1.672 0M0 9.533a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 1 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.134 28.54C.508 28.54 0 29.047 0 29.674v4.504a1.134 1.134 0 0 0 2.269 0v-4.504c0-.627-.508-1.134-1.135-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.298 34.178v-4.504a.836.836 0 1 1 1.672 0v4.504a.836.836 0 0 1-1.672 0M0 29.674a1.134 1.134 0 1 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 1.075c-.627 0-1.135.508-1.135 1.134v4.504a1.134 1.134 0 0 0 2.269 0V2.209c0-.626-.508-1.134-1.134-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 6.713V2.209a.836.836 0 0 1 1.671 0v4.504a.836.836 0 0 1-1.671 0m-.299-4.504a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 8.398c-.627 0-1.135.508-1.135 1.135v4.504a1.134 1.134 0 1 0 2.269 0V9.533c0-.627-.508-1.135-1.134-1.135"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 14.037V9.533a.836.836 0 0 1 1.671 0v4.504a.836.836 0 0 1-1.671 0m-.299-4.504a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.866 28.54c-.627 0-1.135.507-1.135 1.134v4.504a1.134 1.134 0 0 0 2.269 0v-4.504c0-.627-.508-1.134-1.134-1.134"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.03 34.178v-4.504a.836.836 0 0 1 1.671 0v4.504a.836.836 0 0 1-1.671 0m-.299-4.504a1.134 1.134 0 0 1 2.269 0v4.504a1.134 1.134 0 0 1-2.269 0z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSMotorcycleDisablePending = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-motorcycle-disable-pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M15.31 13.447c0-3.017-1.045-4.247-1.045-4.247l-2.742-.302-2.462.302S7.69 10.43 7.69 13.447s1.254 5.557 2.6 7.042h2.208c1.264-1.355 2.812-4.026 2.812-7.042"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.16 9.385q.039.052.101.156c.093.153.218.39.345.721.252.662.51 1.7.51 3.185 0 2.91-1.475 5.5-2.703 6.848h-2.035c-1.295-1.46-2.493-3.926-2.493-6.848 0-1.477.335-2.51.665-3.167.165-.33.329-.566.45-.72a3 3 0 0 1 .15-.174l2.375-.29zm-5.1-.184-.13-.145a.2.2 0 0 1 .107-.048l2.463-.302a.2.2 0 0 1 .045 0l2.741.301q.077.01.127.068l-.148.126.149-.126.001.002.004.004.01.014.039.05q.048.066.127.195c.104.172.24.43.375.784.27.707.535 1.792.535 3.323 0 3.078-1.577 5.794-2.865 7.176a.2.2 0 0 1-.142.062H10.29a.2.2 0 0 1-.145-.064c-1.375-1.518-2.65-4.105-2.65-7.174 0-1.539.35-2.63.705-3.341.178-.355.357-.614.493-.786a3 3 0 0 1 .23-.258l.004-.004.002-.001z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.172 0c.659 0 1.194.534 1.194 1.193v2.592a1.194 1.194 0 0 1-2.389 0V1.193C9.977.534 10.512 0 11.171 0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M11.976 3.785V1.193a.804.804 0 0 0-1.609 0v2.592a.804.804 0 0 0 1.609 0m.39-2.592a1.194 1.194 0 0 0-2.389 0v2.592a1.194 1.194 0 0 0 2.389 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M13.15 6.692c1.506 0 2.517-.371 2.835-.557H13.15z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M16.173 6.085a.195.195 0 0 1-.09.218c-.353.207-1.4.584-2.932.584a.195.195 0 0 1-.195-.195v-.556c0-.108.087-.195.194-.195h2.835c.088 0 .165.059.188.144m-1.362.245h-1.466v.166a8 8 0 0 0 1.466-.166",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#18182E", d: "M9.27 6.692c-1.506 0-2.517-.371-2.834-.557H9.27z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M6.247 6.085a.195.195 0 0 0 .09.218c.353.207 1.4.584 2.933.584a.195.195 0 0 0 .194-.195v-.556a.195.195 0 0 0-.194-.195H6.435a.195.195 0 0 0-.188.144m1.362.245h1.466v.166a8 8 0 0 1-1.466-.166",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.1 28.858c0-1.393-.65-2.05-.975-2.205l-1.72 1.021v6.59c.9-1.222 2.696-4.014 2.696-5.406"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m15.126 26.876-1.526.906v5.87c.406-.587.895-1.35 1.319-2.123.278-.508.526-1.017.704-1.483.18-.47.282-.878.282-1.19 0-1.198-.5-1.788-.78-1.98m.082-.401c.406.193 1.087.928 1.087 2.38 0 .384-.122.846-.308 1.33a13 13 0 0 1-.727 1.53 26 26 0 0 1-1.698 2.662.195.195 0 0 1-.352-.115v-6.59c0-.069.036-.133.096-.168l1.719-1.02a.2.2 0 0 1 .183-.009",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "m13.408 5.561.776 3.26.119.467H8.55l.674-3.727 1.931-.7z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.457 9.408a.2.2 0 0 1-.154.076H8.55a.195.195 0 0 1-.192-.23l.674-3.727a.2.2 0 0 1 .125-.148l1.932-.7a.2.2 0 0 1 .124-.002l2.253.7c.066.02.116.073.132.14l.775 3.259.119.465a.2.2 0 0 1-.035.167m-.405-.314-.058-.227-.75-3.152-2.084-.647-1.765.639-.612 3.387z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M7.147 28.858c0-1.393.65-2.05.976-2.205l1.72 1.021v6.59c-.9-1.222-2.696-4.014-2.696-5.406"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m8.122 26.876 1.525.906v5.87a25 25 0 0 1-1.318-2.123 12.4 12.4 0 0 1-.705-1.483c-.18-.47-.282-.878-.282-1.19 0-1.198.5-1.788.78-1.98m-.083-.401c-.406.193-1.087.928-1.087 2.38 0 .384.122.846.308 1.33.186.488.443 1.014.727 1.53a26 26 0 0 0 1.698 2.662.195.195 0 0 0 .352-.115v-6.59a.2.2 0 0 0-.096-.168l-1.719-1.02a.2.2 0 0 0-.183-.009",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M13.383 34.31c1.152-2.656 1.094-5.207.92-6.15l-1.339-2.715-2.671.696L8.62 28.16c-.074 2.413.784 5.105 1.223 6.15l1.727 1.032z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m14.117 28.222-1.257-2.549-2.457.64-1.59 1.92c-.055 2.313.75 4.882 1.185 5.942l1.575.942 1.657-.944c1.098-2.57 1.049-5.028.887-5.952m.378-.097c.18.977.236 3.568-.933 6.262a.2.2 0 0 1-.082.091l-1.813 1.033a.2.2 0 0 1-.197-.002l-1.727-1.033a.2.2 0 0 1-.08-.091c-.444-1.057-1.313-3.778-1.238-6.23a.2.2 0 0 1 .045-.119l1.673-2.019a.2.2 0 0 1 .1-.064l2.672-.696c.09-.024.183.02.224.102l1.34 2.715a.2.2 0 0 1 .016.051",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M15.287 26.43c-1.43-3.87-1.076-7.715-.72-9.154H8.356c.996 3.23-.013 7.449-.642 9.154l.952 1.729c.504-.317 1.766-.951 2.788-.951 1.278 0 2.442.613 2.849.95 0 0 .622-1.152.984-1.728"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M15.47 26.364c.02.057.014.12-.018.17a27 27 0 0 0-.623 1.073l-.328.595-.027.05a.195.195 0 0 1-.296.058c-.378-.314-1.5-.907-2.725-.907-.475 0-1.02.15-1.517.344a7.4 7.4 0 0 0-1.167.578.195.195 0 0 1-.274-.071l-.953-1.729a.2.2 0 0 1-.012-.16c.31-.84.716-2.306.92-3.963s.205-3.49-.281-5.068a.195.195 0 0 1 .186-.252h6.211a.195.195 0 0 1 .19.242c-.35 1.408-.702 5.213.713 9.04m-1.232 1.506.25-.453c.183-.328.406-.72.583-1.008-1.337-3.685-1.086-7.33-.749-8.937H8.614c.436 1.59.42 3.378.223 4.978-.202 1.634-.596 3.088-.91 3.965l.812 1.474a8 8 0 0 1 1.055-.505c.515-.201 1.113-.37 1.66-.37 1.17 0 2.246.491 2.784.856",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.616 36.805c1.227 0 1.72-1.87 1.72-2.45H9.841c0 .673.547 2.45 1.774 2.45"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M13.53 34.16v.195c0 .324-.132.967-.42 1.532-.287.558-.767 1.113-1.494 1.113-.72 0-1.215-.523-1.518-1.074-.304-.554-.45-1.198-.45-1.57v-.195zm-.404.39H10.05c.04.32.165.78.39 1.19.278.505.67.87 1.176.87.5 0 .88-.38 1.146-.9.21-.41.326-.863.364-1.16",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "m12.499 2.38-1.37-.673-1.287.672v2.39c.212-.123.766-.37 1.286-.37s1.13.154 1.37.231z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M12.585 2.206c.067.033.109.1.109.175v2.25a.194.194 0 0 1-.255.186c-.23-.075-.82-.223-1.31-.223-.472 0-.991.23-1.189.345a.195.195 0 0 1-.293-.168V2.38c0-.073.04-.14.104-.173l1.287-.673a.2.2 0 0 1 .176-.002zm-.28.296-1.174-.576-1.094.573v1.959c.286-.123.694-.253 1.091-.253.41 0 .868.09 1.176.169zM22.348 11.882a.68.68 0 0 1-.914.308c-2.875-1.425-7.362-2.377-10.105-2.377-3.264 0-7.062 1.036-9.72 2.375a.682.682 0 0 1-.615-1.217C3.82 9.55 7.826 8.451 11.33 8.451c2.943 0 7.638.996 10.71 2.518a.68.68 0 0 1 .309.913",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.501 15.32a1.315 1.315 0 1 1-.002-2.63 1.315 1.315 0 0 1 .002 2.63"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M10.575 14.006a.925.925 0 1 0 1.85-.001.925.925 0 0 0-1.85 0m-.39 0a1.315 1.315 0 1 0 2.63-.002 1.315 1.315 0 0 0-2.63.002",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M11.33 5.326c1.22 0 1.985.34 2.215.51-.093-.479-.666-1.438-2.216-1.438s-2.157.96-2.268 1.439c.248-.17 1.049-.51 2.268-.51"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M13.65 6.002a.195.195 0 0 1-.22-.009c-.189-.139-.91-.472-2.1-.472s-1.95.333-2.158.476a.195.195 0 0 1-.3-.204c.129-.56.81-1.59 2.458-1.59 1.65 0 2.297 1.033 2.407 1.597a.195.195 0 0 1-.088.202m-.49-.573c-.262-.398-.811-.836-1.83-.836s-1.587.438-1.866.838c.427-.155 1.062-.3 1.866-.3.798 0 1.417.143 1.83.298",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M21.006 9.61c-1.101 0-1.994-.537-1.994-1.198s.893-1.197 1.994-1.197S23 7.75 23 8.412s-.893 1.198-1.994 1.198"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M20.369 8.169v.486h-1.827c-.48 0-.97.094-1.398.243-.43.151-.78.353-.99.556l-.339-.35c.277-.268.697-.5 1.168-.665a4.8 4.8 0 0 1 1.559-.27z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.994 9.61c1.102 0 1.994-.537 1.994-1.198s-.892-1.197-1.994-1.197S0 7.75 0 8.412.893 9.61 1.994 9.61"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.632 8.169v.486h1.827c.48 0 .97.094 1.397.243.431.151.78.353.99.556l.34-.35c-.278-.268-.697-.5-1.169-.665a4.8 4.8 0 0 0-1.558-.27z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCF0DE",
          fillRule: "evenodd",
          stroke: "#F9D199",
          d: "M11.5 46.526a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 .001 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F9D199",
          fillRule: "evenodd",
          d: "M2.5 38a9 9 0 1 1 18.002.001A9 9 0 0 1 2.5 38m9-8.053a8.053 8.053 0 1 0 .002 16.107 8.053 8.053 0 0 0-.002-16.107",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          fillRule: "evenodd",
          d: "M14.424 36.342h-.473v-.947a2.37 2.37 0 0 0-4.737 0v.947H8.74a.95.95 0 0 0-.947.947v4.737a.95.95 0 0 0 .947.948h5.684a.95.95 0 0 0 .948-.948V37.29a.95.95 0 0 0-.948-.947m-2.842 4.263a.95.95 0 0 1-.947-.947.95.95 0 0 1 .947-.947.95.95 0 0 1 .948.947.95.95 0 0 1-.948.947m1.469-4.263h-2.937v-.947a1.47 1.47 0 0 1 2.937 0z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSMotorcycleDisabled = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-motorcycle-disabled",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M15.31 13.447c0-3.017-1.046-4.247-1.046-4.247l-2.741-.302L9.06 9.2s-1.37 1.23-1.37 4.247 1.254 5.557 2.6 7.042h2.207c1.264-1.355 2.813-4.026 2.813-7.042"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.16 9.385q.039.052.101.156c.092.153.218.39.344.721.253.662.51 1.7.51 3.185 0 2.91-1.474 5.5-2.703 6.848h-2.034c-1.295-1.46-2.493-3.926-2.493-6.848 0-1.477.335-2.51.665-3.167.164-.33.328-.566.45-.72q.092-.114.143-.167l.007-.007 2.374-.29zm-5.1-.184-.13-.145a.2.2 0 0 1 .107-.048l2.462-.302a.2.2 0 0 1 .046 0l2.74.301c.05.006.096.03.128.068l-.148.126.148-.126.002.002.004.004a1 1 0 0 1 .048.065q.049.065.128.194c.104.172.24.43.374.784.27.707.536 1.792.536 3.323 0 3.078-1.577 5.794-2.865 7.176a.2.2 0 0 1-.142.062H10.29a.2.2 0 0 1-.145-.064c-1.376-1.518-2.65-4.105-2.65-7.174 0-1.539.349-2.63.705-3.341.178-.355.356-.614.493-.786a3 3 0 0 1 .23-.258l.004-.004.001-.001h.001z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.171 0c.66 0 1.195.534 1.195 1.193v2.592a1.194 1.194 0 0 1-2.389 0V1.193C9.977.534 10.512 0 11.171 0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M11.976 3.785V1.193a.804.804 0 0 0-1.61 0v2.592a.804.804 0 0 0 1.61 0m.39-2.592a1.194 1.194 0 0 0-2.389 0v2.592a1.194 1.194 0 0 0 2.389 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M13.15 6.692c1.505 0 2.517-.371 2.834-.557H13.15z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M16.173 6.085a.194.194 0 0 1-.09.218c-.353.207-1.4.584-2.933.584a.195.195 0 0 1-.195-.195v-.556c0-.108.088-.195.195-.195h2.835c.088 0 .165.059.188.144m-1.362.245h-1.466v.166a8 8 0 0 0 1.465-.166",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#18182E", d: "M9.27 6.692c-1.506 0-2.517-.371-2.835-.557H9.27z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M6.247 6.085a.195.195 0 0 0 .09.218c.353.207 1.4.584 2.932.584a.195.195 0 0 0 .195-.195v-.556a.195.195 0 0 0-.195-.195H6.435a.195.195 0 0 0-.188.144m1.362.245h1.466v.166a8 8 0 0 1-1.466-.166",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.1 28.858c0-1.393-.65-2.05-.975-2.205l-1.72 1.021v6.59c.899-1.222 2.696-4.014 2.696-5.406"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m15.125 26.876-1.525.906v5.87a25 25 0 0 0 1.318-2.123c.279-.508.527-1.017.705-1.483.18-.47.282-.878.282-1.19 0-1.198-.5-1.788-.78-1.98m.083-.401c.406.193 1.087.928 1.087 2.38 0 .384-.123.846-.308 1.33a13 13 0 0 1-.727 1.53 26 26 0 0 1-1.698 2.662.195.195 0 0 1-.352-.115v-6.59c0-.069.036-.133.095-.168l1.72-1.02a.2.2 0 0 1 .183-.009",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "m13.408 5.561.775 3.26.12.467H8.55l.673-3.727 1.932-.7z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.456 9.408a.2.2 0 0 1-.153.076H8.55a.195.195 0 0 1-.192-.23l.674-3.727a.2.2 0 0 1 .125-.148l1.932-.7a.2.2 0 0 1 .124-.002l2.253.7c.066.02.116.073.132.14l.775 3.259.118.465a.2.2 0 0 1-.035.167m-.404-.314-.058-.227-.75-3.152-2.084-.647-1.765.639-.612 3.387z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M7.147 28.858c0-1.393.65-2.05.976-2.205l1.719 1.021v6.59c-.898-1.222-2.695-4.014-2.695-5.406"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m8.121 26.876 1.526.906v5.87a25 25 0 0 1-1.319-2.123 12.4 12.4 0 0 1-.704-1.483c-.18-.47-.282-.878-.282-1.19 0-1.198.5-1.788.78-1.98m-.082-.401c-.406.193-1.087.928-1.087 2.38 0 .384.122.846.308 1.33.186.488.443 1.014.726 1.53a26 26 0 0 0 1.699 2.662.195.195 0 0 0 .351-.115v-6.59a.2.2 0 0 0-.095-.168l-1.719-1.02a.2.2 0 0 0-.183-.009",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M13.383 34.31c1.152-2.656 1.094-5.207.92-6.15l-1.339-2.715-2.672.696L8.62 28.16c-.075 2.413.784 5.105 1.222 6.15l1.728 1.032z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m14.116 28.222-1.256-2.549-2.457.64-1.59 1.92c-.055 2.313.75 4.882 1.185 5.942l1.575.942 1.656-.944c1.099-2.57 1.05-5.028.887-5.952m.379-.097c.18.977.236 3.568-.933 6.262a.2.2 0 0 1-.083.091l-1.812 1.033a.2.2 0 0 1-.197-.002l-1.728-1.033a.2.2 0 0 1-.08-.091c-.443-1.057-1.313-3.778-1.237-6.23a.2.2 0 0 1 .045-.119l1.672-2.019a.2.2 0 0 1 .101-.064l2.672-.696c.09-.024.183.02.224.102l1.34 2.715a.2.2 0 0 1 .016.051",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M15.287 26.43c-1.431-3.87-1.076-7.715-.72-9.154H8.355c.997 3.23-.012 7.449-.642 9.154l.953 1.729c.503-.317 1.766-.951 2.788-.951 1.278 0 2.442.613 2.849.95 0 0 .622-1.152.984-1.728"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M15.47 26.364a.2.2 0 0 1-.019.17 27 27 0 0 0-.622 1.073c-.1.18-.19.34-.253.457l-.075.138-.027.05a.195.195 0 0 1-.297.058c-.377-.314-1.498-.907-2.724-.907-.476 0-1.02.15-1.517.344a7.4 7.4 0 0 0-1.167.578.195.195 0 0 1-.274-.071l-.953-1.729a.2.2 0 0 1-.012-.16c.31-.84.715-2.306.92-3.963s.205-3.49-.282-5.068a.195.195 0 0 1 .187-.252h6.211a.195.195 0 0 1 .19.242c-.35 1.408-.702 5.213.713 9.04m-1.232 1.506.25-.453c.183-.328.406-.72.583-1.008-1.337-3.685-1.086-7.33-.749-8.937H8.614c.435 1.59.42 3.378.223 4.978-.202 1.634-.596 3.088-.91 3.965l.811 1.474a8 8 0 0 1 1.055-.505c.516-.201 1.114-.37 1.66-.37 1.17 0 2.247.491 2.785.856",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.616 36.805c1.226 0 1.719-1.87 1.719-2.45H9.842c0 .673.547 2.45 1.774 2.45"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M13.53 34.16v.195c0 .324-.132.967-.42 1.532-.287.558-.767 1.113-1.494 1.113-.72 0-1.215-.523-1.518-1.074-.304-.554-.451-1.198-.451-1.57v-.195zm-.404.39H10.05c.04.32.165.78.39 1.19.278.505.67.87 1.176.87.5 0 .88-.38 1.146-.9.21-.41.325-.863.364-1.16",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "m12.499 2.38-1.371-.673-1.287.672v2.39c.212-.123.767-.37 1.287-.37s1.13.154 1.37.231z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M12.585 2.206c.066.033.109.1.109.175v2.25a.195.195 0 0 1-.255.186c-.231-.075-.82-.223-1.31-.223-.472 0-.991.23-1.19.345a.195.195 0 0 1-.292-.168V2.38c0-.073.04-.14.104-.173l1.287-.673a.2.2 0 0 1 .176-.002zm-.281.296-1.173-.576-1.095.573v1.959c.287-.123.694-.253 1.092-.253.41 0 .867.09 1.176.169zM22.348 11.882a.68.68 0 0 1-.915.308c-2.874-1.425-7.361-2.377-10.104-2.377-3.264 0-7.063 1.036-9.72 2.375a.682.682 0 0 1-.615-1.217C3.82 9.55 7.826 8.451 11.33 8.451c2.942 0 7.638.996 10.71 2.518a.68.68 0 0 1 .308.913",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.5 15.32a1.315 1.315 0 1 1 0-2.63 1.315 1.315 0 0 1 0 2.63"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M10.575 14.006a.925.925 0 1 0 1.85-.001.925.925 0 0 0-1.85 0m-.39 0a1.315 1.315 0 1 0 2.63-.002 1.315 1.315 0 0 0-2.63.002",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M11.33 5.326c1.219 0 1.985.34 2.215.51-.093-.479-.666-1.438-2.216-1.438s-2.157.96-2.268 1.439c.248-.17 1.049-.51 2.268-.51"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M13.65 6.002a.195.195 0 0 1-.22-.009c-.19-.139-.911-.472-2.1-.472s-1.95.333-2.158.476a.195.195 0 0 1-.3-.204c.128-.56.81-1.59 2.457-1.59 1.65 0 2.298 1.033 2.407 1.597a.19.19 0 0 1-.087.202m-.49-.573c-.262-.398-.811-.836-1.83-.836s-1.587.438-1.867.838c.427-.155 1.062-.3 1.866-.3.799 0 1.418.143 1.831.298",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M21.006 9.61c-1.101 0-1.994-.537-1.994-1.198s.893-1.197 1.994-1.197S23 7.75 23 8.412s-.893 1.198-1.994 1.198"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M20.368 8.169v.486h-1.826c-.48 0-.97.094-1.398.243-.431.151-.78.353-.99.556l-.34-.35c.278-.268.698-.5 1.169-.665a4.8 4.8 0 0 1 1.559-.27z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.994 9.61c1.101 0 1.994-.537 1.994-1.198s-.893-1.197-1.994-1.197S0 7.75 0 8.412.893 9.61 1.994 9.61"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.632 8.169v.486h1.826c.48 0 .97.094 1.398.243.431.151.78.353.99.556l.34-.35c-.278-.268-.698-.5-1.169-.665a4.8 4.8 0 0 0-1.559-.27z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCEDEB",
          fillRule: "evenodd",
          stroke: "#F5B7B1",
          d: "M11.5 46.526a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F5B7B1",
          fillRule: "evenodd",
          d: "M2.5 38a9 9 0 1 1 18.001.001A9 9 0 0 1 2.5 38m9-8.053a8.053 8.053 0 1 0 .001 16.107 8.053 8.053 0 0 0-.001-16.107",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          fillRule: "evenodd",
          d: "M14.424 36.342h-.474v-.947a2.37 2.37 0 0 0-4.736 0v.947H8.74a.95.95 0 0 0-.948.947v4.737a.95.95 0 0 0 .948.948h5.684a.95.95 0 0 0 .947-.948V37.29a.95.95 0 0 0-.947-.947m-2.842 4.263a.95.95 0 0 1-.947-.947.95.95 0 0 1 .947-.947.95.95 0 0 1 .947.947.95.95 0 0 1-.947.947m1.468-4.263h-2.937v-.947a1.47 1.47 0 0 1 2.937 0z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSMotorcycleEnablePending = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-motorcycle-enable-pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 48",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M15.31 13.447c0-3.017-1.046-4.247-1.046-4.247l-2.741-.302L9.06 9.2s-1.37 1.23-1.37 4.247 1.254 5.557 2.6 7.042h2.207c1.264-1.355 2.813-4.026 2.813-7.042"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.16 9.385q.039.052.101.156c.092.153.218.39.344.721.253.662.51 1.7.51 3.185 0 2.91-1.474 5.5-2.703 6.848h-2.034c-1.295-1.46-2.493-3.926-2.493-6.848 0-1.477.335-2.51.665-3.167.164-.33.328-.566.45-.72q.092-.114.143-.167l.007-.007 2.374-.29zm-5.1-.184-.13-.145a.2.2 0 0 1 .107-.048l2.462-.302a.2.2 0 0 1 .046 0l2.74.301c.05.006.096.03.128.068l-.148.126.148-.126.002.002.004.004a1 1 0 0 1 .048.065q.049.065.128.194c.104.172.24.43.374.784.27.707.536 1.792.536 3.323 0 3.078-1.577 5.794-2.865 7.176a.2.2 0 0 1-.142.062H10.29a.2.2 0 0 1-.145-.064c-1.376-1.518-2.65-4.105-2.65-7.174 0-1.539.349-2.63.705-3.341.178-.355.356-.614.493-.786a3 3 0 0 1 .23-.258l.004-.004.001-.001h.001z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.171 0c.66 0 1.195.534 1.195 1.193v2.592a1.194 1.194 0 0 1-2.389 0V1.193C9.977.534 10.512 0 11.171 0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M11.976 3.785V1.193a.804.804 0 0 0-1.61 0v2.592a.804.804 0 0 0 1.61 0m.39-2.592a1.194 1.194 0 0 0-2.389 0v2.592a1.194 1.194 0 0 0 2.389 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M13.15 6.692c1.505 0 2.517-.371 2.834-.557H13.15z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M16.173 6.085a.194.194 0 0 1-.09.218c-.353.207-1.4.584-2.933.584a.195.195 0 0 1-.195-.195v-.556c0-.108.088-.195.195-.195h2.835c.088 0 .165.059.188.144m-1.362.245h-1.466v.166a8 8 0 0 0 1.465-.166",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#18182E", d: "M9.27 6.692c-1.506 0-2.517-.371-2.835-.557H9.27z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M6.247 6.085a.195.195 0 0 0 .09.218c.353.207 1.4.584 2.932.584a.195.195 0 0 0 .195-.195v-.556a.195.195 0 0 0-.195-.195H6.435a.195.195 0 0 0-.188.144m1.362.245h1.466v.166a8 8 0 0 1-1.466-.166",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.1 28.858c0-1.393-.65-2.05-.975-2.205l-1.72 1.021v6.59c.899-1.222 2.696-4.014 2.696-5.406"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m15.125 26.876-1.525.906v5.87a25 25 0 0 0 1.318-2.123c.279-.508.527-1.017.705-1.483.18-.47.282-.878.282-1.19 0-1.198-.5-1.788-.78-1.98m.083-.401c.406.193 1.087.928 1.087 2.38 0 .384-.123.846-.308 1.33a13 13 0 0 1-.727 1.53 26 26 0 0 1-1.698 2.662.195.195 0 0 1-.352-.115v-6.59c0-.069.036-.133.095-.168l1.72-1.02a.2.2 0 0 1 .183-.009",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "m13.408 5.561.775 3.26.12.467H8.55l.673-3.727 1.932-.7z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.456 9.408a.2.2 0 0 1-.153.076H8.55a.195.195 0 0 1-.192-.23l.674-3.727a.2.2 0 0 1 .125-.148l1.932-.7a.2.2 0 0 1 .124-.002l2.253.7c.066.02.116.073.132.14l.775 3.259.118.465a.2.2 0 0 1-.035.167m-.404-.314-.058-.227-.75-3.152-2.084-.647-1.765.639-.612 3.387z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M7.147 28.858c0-1.393.65-2.05.976-2.205l1.719 1.021v6.59c-.898-1.222-2.695-4.014-2.695-5.406"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m8.121 26.876 1.526.906v5.87a25 25 0 0 1-1.319-2.123 12.4 12.4 0 0 1-.704-1.483c-.18-.47-.282-.878-.282-1.19 0-1.198.5-1.788.78-1.98m-.082-.401c-.406.193-1.087.928-1.087 2.38 0 .384.122.846.308 1.33.186.488.443 1.014.726 1.53a26 26 0 0 0 1.699 2.662.195.195 0 0 0 .351-.115v-6.59a.2.2 0 0 0-.095-.168l-1.719-1.02a.2.2 0 0 0-.183-.009",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M13.383 34.31c1.152-2.656 1.094-5.207.92-6.15l-1.339-2.715-2.672.696L8.62 28.16c-.075 2.413.784 5.105 1.222 6.15l1.728 1.032z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m14.116 28.222-1.256-2.549-2.457.64-1.59 1.92c-.055 2.313.75 4.882 1.185 5.942l1.575.942 1.656-.944c1.099-2.57 1.05-5.028.887-5.952m.379-.097c.18.977.236 3.568-.933 6.262a.2.2 0 0 1-.083.091l-1.812 1.033a.2.2 0 0 1-.197-.002l-1.728-1.033a.2.2 0 0 1-.08-.091c-.443-1.057-1.313-3.778-1.237-6.23a.2.2 0 0 1 .045-.119l1.672-2.019a.2.2 0 0 1 .101-.064l2.672-.696c.09-.024.183.02.224.102l1.34 2.715a.2.2 0 0 1 .016.051",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M15.287 26.43c-1.431-3.87-1.076-7.715-.72-9.154H8.355c.997 3.23-.012 7.449-.642 9.154l.953 1.729c.503-.317 1.766-.951 2.788-.951 1.278 0 2.442.613 2.849.95 0 0 .622-1.152.984-1.728"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M15.47 26.364a.2.2 0 0 1-.019.17 27 27 0 0 0-.622 1.073c-.1.18-.19.34-.253.457l-.075.138-.027.05a.195.195 0 0 1-.297.058c-.377-.314-1.498-.907-2.724-.907-.476 0-1.02.15-1.517.344a7.4 7.4 0 0 0-1.167.578.195.195 0 0 1-.274-.071l-.953-1.729a.2.2 0 0 1-.012-.16c.31-.84.715-2.306.92-3.963s.205-3.49-.282-5.068a.195.195 0 0 1 .187-.252h6.211a.195.195 0 0 1 .19.242c-.35 1.408-.702 5.213.713 9.04m-1.232 1.506.25-.453c.183-.328.406-.72.583-1.008-1.337-3.685-1.086-7.33-.749-8.937H8.614c.435 1.59.42 3.378.223 4.978-.202 1.634-.596 3.088-.91 3.965l.811 1.474a8 8 0 0 1 1.055-.505c.516-.201 1.114-.37 1.66-.37 1.17 0 2.247.491 2.785.856",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.616 36.805c1.226 0 1.719-1.87 1.719-2.45H9.842c0 .673.547 2.45 1.774 2.45"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M13.53 34.16v.195c0 .324-.132.967-.42 1.532-.287.558-.767 1.113-1.494 1.113-.72 0-1.215-.523-1.518-1.074-.304-.554-.451-1.198-.451-1.57v-.195zm-.404.39H10.05c.04.32.165.78.39 1.19.278.505.67.87 1.176.87.5 0 .88-.38 1.146-.9.21-.41.325-.863.364-1.16",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "m12.499 2.38-1.371-.673-1.287.672v2.39c.212-.123.767-.37 1.287-.37s1.13.154 1.37.231z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M12.585 2.206c.066.033.109.1.109.175v2.25a.195.195 0 0 1-.255.186c-.231-.075-.82-.223-1.31-.223-.472 0-.991.23-1.19.345a.195.195 0 0 1-.292-.168V2.38c0-.073.04-.14.104-.173l1.287-.673a.2.2 0 0 1 .176-.002zm-.281.296-1.173-.576-1.095.573v1.959c.287-.123.694-.253 1.092-.253.41 0 .867.09 1.176.169zM22.348 11.882a.68.68 0 0 1-.915.308c-2.874-1.425-7.361-2.377-10.104-2.377-3.264 0-7.063 1.036-9.72 2.375a.682.682 0 0 1-.615-1.217C3.82 9.55 7.826 8.451 11.33 8.451c2.942 0 7.638.996 10.71 2.518a.68.68 0 0 1 .308.913",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.5 15.32a1.315 1.315 0 1 1 0-2.63 1.315 1.315 0 0 1 0 2.63"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M10.575 14.006a.925.925 0 1 0 1.85-.001.925.925 0 0 0-1.85 0m-.39 0a1.315 1.315 0 1 0 2.63-.002 1.315 1.315 0 0 0-2.63.002",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M11.33 5.326c1.219 0 1.985.34 2.215.51-.093-.479-.666-1.438-2.216-1.438s-2.157.96-2.268 1.439c.248-.17 1.049-.51 2.268-.51"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M13.65 6.002a.195.195 0 0 1-.22-.009c-.19-.139-.911-.472-2.1-.472s-1.95.333-2.158.476a.195.195 0 0 1-.3-.204c.128-.56.81-1.59 2.457-1.59 1.65 0 2.298 1.033 2.407 1.597a.19.19 0 0 1-.087.202m-.49-.573c-.262-.398-.811-.836-1.83-.836s-1.587.438-1.867.838c.427-.155 1.062-.3 1.866-.3.799 0 1.418.143 1.831.298",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M21.006 9.61c-1.101 0-1.994-.537-1.994-1.198s.893-1.197 1.994-1.197S23 7.75 23 8.412s-.893 1.198-1.994 1.198"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M20.368 8.169v.486h-1.826c-.48 0-.97.094-1.398.243-.431.151-.78.353-.99.556l-.34-.35c.278-.268.698-.5 1.169-.665a4.8 4.8 0 0 1 1.559-.27z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.994 9.61c1.101 0 1.994-.537 1.994-1.198s-.893-1.197-1.994-1.197S0 7.75 0 8.412.893 9.61 1.994 9.61"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.632 8.169v.486h1.826c.48 0 .97.094 1.398.243.431.151.78.353.99.556l.34-.35c-.278-.268-.698-.5-1.169-.665a4.8 4.8 0 0 0-1.559-.27z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#CFDEF2",
          fillRule: "evenodd",
          stroke: "#F5B7B1",
          d: "M11.5 46.526a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#8AB9F7",
          fillRule: "evenodd",
          d: "M2.5 38a9 9 0 1 1 18.001.001A9 9 0 0 1 2.5 38m9-8.053a8.053 8.053 0 1 0 .001 16.107 8.053 8.053 0 0 0-.001-16.107",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1774F0",
          fillRule: "evenodd",
          d: "M11.582 40.369a.95.95 0 0 0 .947-.948.95.95 0 0 0-.947-.947.95.95 0 0 0-.947.947.95.95 0 0 0 .947.947m2.842-4.264h-.474v-.947a2.37 2.37 0 0 0-4.736 0h.9c0-.81.658-1.468 1.468-1.468s1.468.658 1.468 1.468v.947H8.74a.95.95 0 0 0-.948.948v4.737a.95.95 0 0 0 .948.947h5.684a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.948m0 5.685H8.74v-4.737h5.684z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSMotorcycleNoSignal = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-motorcycle-no-signal",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 47",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M15.31 13.447c0-3.017-1.045-4.247-1.045-4.247l-2.742-.302-2.462.302S7.69 10.43 7.69 13.447s1.254 5.557 2.6 7.042h2.208c1.264-1.355 2.812-4.026 2.812-7.042"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.16 9.385q.039.052.101.156c.093.153.218.39.345.721.252.662.51 1.7.51 3.185 0 2.91-1.475 5.5-2.703 6.848h-2.035c-1.295-1.46-2.493-3.926-2.493-6.848 0-1.477.335-2.51.665-3.167.165-.33.329-.566.45-.72a3 3 0 0 1 .15-.174l2.375-.29zm-5.1-.184-.13-.145a.2.2 0 0 1 .107-.048l2.463-.302a.2.2 0 0 1 .045 0l2.741.301q.077.01.127.068l-.148.126.149-.126.001.002.004.004.01.014.039.05q.048.066.127.195c.104.172.24.43.375.784.27.707.535 1.792.535 3.323 0 3.078-1.577 5.794-2.865 7.176a.2.2 0 0 1-.142.062H10.29a.2.2 0 0 1-.145-.064c-1.375-1.518-2.65-4.105-2.65-7.174 0-1.539.35-2.63.705-3.341.178-.355.357-.614.493-.786a3 3 0 0 1 .23-.258l.004-.004.002-.001z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.172 0c.659 0 1.194.534 1.194 1.193v2.592a1.194 1.194 0 0 1-2.389 0V1.193C9.977.534 10.512 0 11.171 0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M11.976 3.785V1.193a.804.804 0 0 0-1.609 0v2.592a.804.804 0 0 0 1.609 0m.39-2.592a1.194 1.194 0 0 0-2.389 0v2.592a1.194 1.194 0 0 0 2.389 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M13.15 6.692c1.506 0 2.517-.371 2.835-.557H13.15z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M16.173 6.085a.195.195 0 0 1-.09.218c-.353.207-1.4.584-2.932.584a.195.195 0 0 1-.195-.195v-.556c0-.108.087-.195.194-.195h2.835c.088 0 .165.059.188.144m-1.362.245h-1.466v.166a8 8 0 0 0 1.466-.166",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#18182E", d: "M9.27 6.692c-1.506 0-2.517-.371-2.834-.557H9.27z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M6.247 6.085a.195.195 0 0 0 .09.218c.353.207 1.4.584 2.933.584a.195.195 0 0 0 .194-.195v-.556a.195.195 0 0 0-.194-.195H6.435a.195.195 0 0 0-.188.144m1.362.245h1.466v.166a8 8 0 0 1-1.466-.166",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.1 28.858c0-1.393-.65-2.05-.975-2.205l-1.72 1.021v6.59c.9-1.222 2.696-4.014 2.696-5.406"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m15.126 26.876-1.526.906v5.87c.406-.587.895-1.35 1.319-2.123.278-.508.526-1.017.704-1.483.18-.47.282-.878.282-1.19 0-1.198-.5-1.788-.78-1.98m.082-.401c.406.193 1.087.928 1.087 2.38 0 .384-.122.846-.308 1.33a13 13 0 0 1-.727 1.53 26 26 0 0 1-1.698 2.662.195.195 0 0 1-.352-.115v-6.59c0-.069.036-.133.096-.168l1.719-1.02a.2.2 0 0 1 .183-.009",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "m13.408 5.561.776 3.26.119.467H8.55l.674-3.727 1.931-.7z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.457 9.408a.2.2 0 0 1-.154.076H8.55a.195.195 0 0 1-.192-.23l.674-3.727a.2.2 0 0 1 .125-.148l1.932-.7a.2.2 0 0 1 .124-.002l2.253.7c.066.02.116.073.132.14l.775 3.259.119.465a.2.2 0 0 1-.035.167m-.405-.314-.058-.227-.75-3.152-2.084-.647-1.765.639-.612 3.387z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M7.147 28.858c0-1.393.65-2.05.976-2.205l1.72 1.021v6.59c-.9-1.222-2.696-4.014-2.696-5.406"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m8.122 26.876 1.525.906v5.87a25 25 0 0 1-1.318-2.123 12.4 12.4 0 0 1-.705-1.483c-.18-.47-.282-.878-.282-1.19 0-1.198.5-1.788.78-1.98m-.083-.401c-.406.193-1.087.928-1.087 2.38 0 .384.122.846.308 1.33.186.488.443 1.014.727 1.53a26 26 0 0 0 1.698 2.662.195.195 0 0 0 .352-.115v-6.59a.2.2 0 0 0-.096-.168l-1.719-1.02a.2.2 0 0 0-.183-.009",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M13.383 34.31c1.152-2.656 1.094-5.207.92-6.15l-1.339-2.715-2.671.696L8.62 28.16c-.074 2.413.784 5.105 1.223 6.15l1.727 1.032z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m14.117 28.222-1.257-2.549-2.457.64-1.59 1.92c-.055 2.313.75 4.882 1.185 5.942l1.575.942 1.657-.944c1.098-2.57 1.049-5.028.887-5.952m.378-.097c.18.977.236 3.568-.933 6.262a.2.2 0 0 1-.082.091l-1.813 1.033a.2.2 0 0 1-.197-.002l-1.727-1.033a.2.2 0 0 1-.08-.091c-.444-1.057-1.313-3.778-1.238-6.23a.2.2 0 0 1 .045-.119l1.673-2.019a.2.2 0 0 1 .1-.064l2.672-.696c.09-.024.183.02.224.102l1.34 2.715a.2.2 0 0 1 .016.051",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M15.287 26.43c-1.43-3.87-1.076-7.715-.72-9.154H8.356c.996 3.23-.013 7.449-.642 9.154l.952 1.729c.504-.317 1.766-.951 2.788-.951 1.278 0 2.442.613 2.849.95 0 0 .622-1.152.984-1.728"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M15.47 26.364c.02.057.014.12-.018.17a27 27 0 0 0-.623 1.073l-.328.595-.027.05a.195.195 0 0 1-.296.058c-.378-.314-1.5-.907-2.725-.907-.475 0-1.02.15-1.517.344a7.4 7.4 0 0 0-1.167.578.195.195 0 0 1-.274-.071l-.953-1.729a.2.2 0 0 1-.012-.16c.31-.84.716-2.306.92-3.963s.205-3.49-.281-5.068a.195.195 0 0 1 .186-.252h6.211a.195.195 0 0 1 .19.242c-.35 1.408-.702 5.213.713 9.04m-1.232 1.506.25-.453c.183-.328.406-.72.583-1.008-1.337-3.685-1.086-7.33-.749-8.937H8.614c.436 1.59.42 3.378.223 4.978-.202 1.634-.596 3.088-.91 3.965l.812 1.474a8 8 0 0 1 1.055-.505c.515-.201 1.113-.37 1.66-.37 1.17 0 2.246.491 2.784.856",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.616 36.805c1.227 0 1.72-1.87 1.72-2.45H9.841c0 .673.547 2.45 1.774 2.45"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M13.53 34.16v.195c0 .324-.132.967-.42 1.532-.287.558-.767 1.113-1.494 1.113-.72 0-1.215-.523-1.518-1.074-.304-.554-.45-1.198-.45-1.57v-.195zm-.404.39H10.05c.04.32.165.78.39 1.19.278.505.67.87 1.176.87.5 0 .88-.38 1.146-.9.21-.41.326-.863.364-1.16",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "m12.499 2.38-1.37-.673-1.287.672v2.39c.212-.123.766-.37 1.286-.37s1.13.154 1.37.231z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M12.585 2.206c.067.033.109.1.109.175v2.25a.194.194 0 0 1-.255.186c-.23-.075-.82-.223-1.31-.223-.472 0-.991.23-1.189.345a.195.195 0 0 1-.293-.168V2.38c0-.073.04-.14.104-.173l1.287-.673a.2.2 0 0 1 .176-.002zm-.28.296-1.174-.576-1.094.573v1.959c.286-.123.694-.253 1.091-.253.41 0 .868.09 1.176.169zM22.348 11.882a.68.68 0 0 1-.914.308c-2.875-1.425-7.362-2.377-10.105-2.377-3.264 0-7.062 1.036-9.72 2.375a.682.682 0 0 1-.615-1.217C3.82 9.55 7.826 8.451 11.33 8.451c2.943 0 7.638.996 10.71 2.518a.68.68 0 0 1 .309.913",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.501 15.32a1.315 1.315 0 1 1-.002-2.63 1.315 1.315 0 0 1 .002 2.63"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M10.575 14.006a.925.925 0 1 0 1.85-.001.925.925 0 0 0-1.85 0m-.39 0a1.315 1.315 0 1 0 2.63-.002 1.315 1.315 0 0 0-2.63.002",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M11.33 5.326c1.22 0 1.985.34 2.215.51-.093-.479-.666-1.438-2.216-1.438s-2.157.96-2.268 1.439c.248-.17 1.049-.51 2.268-.51"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M13.65 6.002a.195.195 0 0 1-.22-.009c-.189-.139-.91-.472-2.1-.472s-1.95.333-2.158.476a.195.195 0 0 1-.3-.204c.129-.56.81-1.59 2.458-1.59 1.65 0 2.297 1.033 2.407 1.597a.195.195 0 0 1-.088.202m-.49-.573c-.262-.398-.811-.836-1.83-.836s-1.587.438-1.866.838c.427-.155 1.062-.3 1.866-.3.798 0 1.417.143 1.83.298",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M21.006 9.61c-1.101 0-1.994-.537-1.994-1.198s.893-1.197 1.994-1.197S23 7.75 23 8.412s-.893 1.198-1.994 1.198"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M20.369 8.169v.486h-1.827c-.48 0-.97.094-1.398.243-.43.151-.78.353-.99.556l-.339-.35c.277-.268.697-.5 1.168-.665a4.8 4.8 0 0 1 1.559-.27z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.994 9.61c1.102 0 1.994-.537 1.994-1.198s-.892-1.197-1.994-1.197S0 7.75 0 8.412.893 9.61 1.994 9.61"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.632 8.169v.486h1.827c.48 0 .97.094 1.397.243.431.151.78.353.99.556l.34-.35c-.278-.268-.697-.5-1.169-.665a4.8 4.8 0 0 0-1.558-.27z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M10.8 29.785a.99.99 0 0 1 1.4 0l7.515 7.514a.99.99 0 0 1 0 1.401L12.2 46.214a.99.99 0 0 1-1.401 0L3.285 38.7a.99.99 0 0 1 0-1.4z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#9DA9B6",
          fillRule: "evenodd",
          d: "M10.45 29.435c.58-.58 1.52-.58 2.1 0l7.515 7.514c.58.58.58 1.521 0 2.102l-7.514 7.514c-.58.58-1.521.58-2.102 0L2.935 39.05a1.486 1.486 0 0 1 0-2.102zm1.4.7a.495.495 0 0 0-.7 0L3.636 37.65a.495.495 0 0 0 0 .7l7.514 7.514a.495.495 0 0 0 .7 0l7.514-7.514a.495.495 0 0 0 0-.7z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          d: "M14.637 34.36a.386.386 0 0 0-.659-.273l-2.542 2.543 3.2 3.201zm.17 6.73-6.095-6.094a.384.384 0 1 0-.543.544l2.18 2.18-2.758 2.758a.385.385 0 0 0 .27.659h5.901l.497.497c.15.15.393.15.543 0a.38.38 0 0 0 .004-.543"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M6.547 33.047h9.245v9.245H6.547z" }) }) })
    ]
  }
);
const VehicleSMotorcycleOff = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-motorcycle-off",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 47",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M15.31 13.447c0-3.017-1.046-4.247-1.046-4.247l-2.741-.302L9.06 9.2s-1.37 1.23-1.37 4.247 1.254 5.557 2.6 7.042h2.207c1.264-1.355 2.813-4.026 2.813-7.042"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.16 9.385q.039.052.101.156c.092.153.218.39.344.721.253.662.51 1.7.51 3.185 0 2.91-1.474 5.5-2.703 6.848h-2.034c-1.295-1.46-2.493-3.926-2.493-6.848 0-1.477.335-2.51.665-3.167.164-.33.328-.566.45-.72q.092-.114.143-.167l.007-.007 2.374-.29zm-5.1-.184-.13-.145a.2.2 0 0 1 .107-.048l2.462-.302a.2.2 0 0 1 .046 0l2.74.301c.05.006.096.03.128.068l-.148.126.148-.126.002.002.004.004a1 1 0 0 1 .048.065q.049.065.128.194c.104.172.24.43.374.784.27.707.536 1.792.536 3.323 0 3.078-1.577 5.794-2.865 7.176a.2.2 0 0 1-.142.062H10.29a.2.2 0 0 1-.145-.064c-1.376-1.518-2.65-4.105-2.65-7.174 0-1.539.349-2.63.705-3.341.178-.355.356-.614.493-.786a3 3 0 0 1 .23-.258l.004-.004.001-.001h.001z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.171 0c.66 0 1.195.534 1.195 1.193v2.592a1.194 1.194 0 0 1-2.389 0V1.193C9.977.534 10.512 0 11.171 0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M11.976 3.785V1.193a.804.804 0 0 0-1.61 0v2.592a.804.804 0 0 0 1.61 0m.39-2.592a1.194 1.194 0 0 0-2.389 0v2.592a1.194 1.194 0 0 0 2.389 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M13.15 6.692c1.505 0 2.517-.371 2.834-.557H13.15z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M16.173 6.085a.194.194 0 0 1-.09.218c-.353.207-1.4.584-2.933.584a.195.195 0 0 1-.195-.195v-.556c0-.108.088-.195.195-.195h2.835c.088 0 .165.059.188.144m-1.362.245h-1.466v.166a8 8 0 0 0 1.465-.166",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#18182E", d: "M9.27 6.692c-1.506 0-2.517-.371-2.835-.557H9.27z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M6.247 6.085a.195.195 0 0 0 .09.218c.353.207 1.4.584 2.932.584a.195.195 0 0 0 .195-.195v-.556a.195.195 0 0 0-.195-.195H6.435a.195.195 0 0 0-.188.144m1.362.245h1.466v.166a8 8 0 0 1-1.466-.166",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.1 28.858c0-1.393-.65-2.05-.975-2.205l-1.72 1.021v6.59c.899-1.222 2.696-4.014 2.696-5.406"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m15.125 26.876-1.525.906v5.87a25 25 0 0 0 1.318-2.123c.279-.508.527-1.017.705-1.483.18-.47.282-.878.282-1.19 0-1.198-.5-1.788-.78-1.98m.083-.401c.406.193 1.087.928 1.087 2.38 0 .384-.123.846-.308 1.33a13 13 0 0 1-.727 1.53 26 26 0 0 1-1.698 2.662.195.195 0 0 1-.352-.115v-6.59c0-.069.036-.133.095-.168l1.72-1.02a.2.2 0 0 1 .183-.009",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "m13.408 5.561.775 3.26.12.467H8.55l.673-3.727 1.932-.7z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.456 9.408a.2.2 0 0 1-.153.076H8.55a.195.195 0 0 1-.192-.23l.674-3.727a.2.2 0 0 1 .125-.148l1.932-.7a.2.2 0 0 1 .124-.002l2.253.7c.066.02.116.073.132.14l.775 3.259.118.465a.2.2 0 0 1-.035.167m-.404-.314-.058-.227-.75-3.152-2.084-.647-1.765.639-.612 3.387z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M7.147 28.858c0-1.393.65-2.05.976-2.205l1.719 1.021v6.59c-.898-1.222-2.695-4.014-2.695-5.406"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m8.121 26.876 1.526.906v5.87a25 25 0 0 1-1.319-2.123 12.4 12.4 0 0 1-.704-1.483c-.18-.47-.282-.878-.282-1.19 0-1.198.5-1.788.78-1.98m-.082-.401c-.406.193-1.087.928-1.087 2.38 0 .384.122.846.308 1.33.186.488.443 1.014.726 1.53a26 26 0 0 0 1.699 2.662.195.195 0 0 0 .351-.115v-6.59a.2.2 0 0 0-.095-.168l-1.719-1.02a.2.2 0 0 0-.183-.009",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M13.383 34.31c1.152-2.656 1.094-5.207.92-6.15l-1.339-2.715-2.672.696L8.62 28.16c-.075 2.413.784 5.105 1.222 6.15l1.728 1.032z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m14.116 28.222-1.256-2.549-2.457.64-1.59 1.92c-.055 2.313.75 4.882 1.185 5.942l1.575.942 1.656-.944c1.099-2.57 1.05-5.028.887-5.952m.379-.097c.18.977.236 3.568-.933 6.262a.2.2 0 0 1-.083.091l-1.812 1.033a.2.2 0 0 1-.197-.002l-1.728-1.033a.2.2 0 0 1-.08-.091c-.443-1.057-1.313-3.778-1.237-6.23a.2.2 0 0 1 .045-.119l1.672-2.019a.2.2 0 0 1 .101-.064l2.672-.696c.09-.024.183.02.224.102l1.34 2.715a.2.2 0 0 1 .016.051",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M15.287 26.43c-1.431-3.87-1.076-7.715-.72-9.154H8.355c.997 3.23-.012 7.449-.642 9.154l.953 1.729c.503-.317 1.766-.951 2.788-.951 1.278 0 2.442.613 2.849.95 0 0 .622-1.152.984-1.728"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M15.47 26.364a.2.2 0 0 1-.019.17 27 27 0 0 0-.622 1.073c-.1.18-.19.34-.253.457l-.075.138-.027.05a.195.195 0 0 1-.297.058c-.377-.314-1.498-.907-2.724-.907-.476 0-1.02.15-1.517.344a7.4 7.4 0 0 0-1.167.578.195.195 0 0 1-.274-.071l-.953-1.729a.2.2 0 0 1-.012-.16c.31-.84.715-2.306.92-3.963s.205-3.49-.282-5.068a.195.195 0 0 1 .187-.252h6.211a.195.195 0 0 1 .19.242c-.35 1.408-.702 5.213.713 9.04m-1.232 1.506.25-.453c.183-.328.406-.72.583-1.008-1.337-3.685-1.086-7.33-.749-8.937H8.614c.435 1.59.42 3.378.223 4.978-.202 1.634-.596 3.088-.91 3.965l.811 1.474a8 8 0 0 1 1.055-.505c.516-.201 1.114-.37 1.66-.37 1.17 0 2.247.491 2.785.856",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.616 36.805c1.226 0 1.719-1.87 1.719-2.45H9.842c0 .673.547 2.45 1.774 2.45"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M13.53 34.16v.195c0 .324-.132.967-.42 1.532-.287.558-.767 1.113-1.494 1.113-.72 0-1.215-.523-1.518-1.074-.304-.554-.451-1.198-.451-1.57v-.195zm-.404.39H10.05c.04.32.165.78.39 1.19.278.505.67.87 1.176.87.5 0 .88-.38 1.146-.9.21-.41.325-.863.364-1.16",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "m12.499 2.38-1.371-.673-1.287.672v2.39c.212-.123.767-.37 1.287-.37s1.13.154 1.37.231z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M12.585 2.206c.066.033.109.1.109.175v2.25a.195.195 0 0 1-.255.186c-.231-.075-.82-.223-1.31-.223-.472 0-.991.23-1.19.345a.195.195 0 0 1-.292-.168V2.38c0-.073.04-.14.104-.173l1.287-.673a.2.2 0 0 1 .176-.002zm-.281.296-1.173-.576-1.095.573v1.959c.287-.123.694-.253 1.092-.253.41 0 .867.09 1.176.169zM22.348 11.882a.68.68 0 0 1-.915.308c-2.874-1.425-7.361-2.377-10.104-2.377-3.264 0-7.063 1.036-9.72 2.375a.682.682 0 0 1-.615-1.217C3.82 9.55 7.826 8.451 11.33 8.451c2.942 0 7.638.996 10.71 2.518a.68.68 0 0 1 .308.913",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.5 15.32a1.315 1.315 0 1 1 0-2.63 1.315 1.315 0 0 1 0 2.63"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M10.575 14.006a.925.925 0 1 0 1.85-.001.925.925 0 0 0-1.85 0m-.39 0a1.315 1.315 0 1 0 2.63-.002 1.315 1.315 0 0 0-2.63.002",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M11.33 5.326c1.219 0 1.985.34 2.215.51-.093-.479-.666-1.438-2.216-1.438s-2.157.96-2.268 1.439c.248-.17 1.049-.51 2.268-.51"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M13.65 6.002a.195.195 0 0 1-.22-.009c-.19-.139-.911-.472-2.1-.472s-1.95.333-2.158.476a.195.195 0 0 1-.3-.204c.128-.56.81-1.59 2.457-1.59 1.65 0 2.298 1.033 2.407 1.597a.19.19 0 0 1-.087.202m-.49-.573c-.262-.398-.811-.836-1.83-.836s-1.587.438-1.867.838c.427-.155 1.062-.3 1.866-.3.799 0 1.418.143 1.831.298",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M21.006 9.61c-1.101 0-1.994-.537-1.994-1.198s.893-1.197 1.994-1.197S23 7.75 23 8.412s-.893 1.198-1.994 1.198"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M20.368 8.169v.486h-1.826c-.48 0-.97.094-1.398.243-.431.151-.78.353-.99.556l-.34-.35c.278-.268.698-.5 1.169-.665a4.8 4.8 0 0 1 1.559-.27z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.994 9.61c1.101 0 1.994-.537 1.994-1.198s-.893-1.197-1.994-1.197S0 7.75 0 8.412.893 9.61 1.994 9.61"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.632 8.169v.486h1.826c.48 0 .97.094 1.398.243.431.151.78.353.99.556l.34-.35c-.278-.268-.698-.5-1.169-.665a4.8 4.8 0 0 0-1.559-.27z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M11.5 46.526a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M2.5 38a9 9 0 1 1 18.001.001A9 9 0 0 1 2.5 38m9-8.053a8.053 8.053 0 1 0 .001 16.107 8.053 8.053 0 0 0-.001-16.107",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M7.972 38a3.528 3.528 0 1 0 7.056 0 3.528 3.528 0 0 0-7.056 0m-.893 0a4.421 4.421 0 1 0 8.842 0 4.421 4.421 0 0 0-8.842 0m2.615-.3a.55.55 0 0 0-.11.35q0 .208.11.35a.33.33 0 0 0 .273.14h3.066q.162 0 .273-.14a.55.55 0 0 0 .11-.35.55.55 0 0 0-.11-.35.33.33 0 0 0-.273-.142H9.967q-.163 0-.273.141",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSMotorcycleOn = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-motorcycle-on",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 47",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M15.31 13.447c0-3.017-1.046-4.247-1.046-4.247l-2.741-.302L9.06 9.2s-1.37 1.23-1.37 4.247 1.254 5.557 2.6 7.042h2.207c1.264-1.355 2.813-4.026 2.813-7.042"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.16 9.385q.039.052.101.156c.092.153.218.39.344.721.253.662.51 1.7.51 3.185 0 2.91-1.474 5.5-2.703 6.848h-2.034c-1.295-1.46-2.493-3.926-2.493-6.848 0-1.477.335-2.51.665-3.167.164-.33.328-.566.45-.72q.092-.114.143-.167l.007-.007 2.374-.29zm-5.1-.184-.13-.145a.2.2 0 0 1 .107-.048l2.462-.302a.2.2 0 0 1 .046 0l2.74.301c.05.006.096.03.128.068l-.148.126.148-.126.002.002.004.004a1 1 0 0 1 .048.065q.049.065.128.194c.104.172.24.43.374.784.27.707.536 1.792.536 3.323 0 3.078-1.577 5.794-2.865 7.176a.2.2 0 0 1-.142.062H10.29a.2.2 0 0 1-.145-.064c-1.376-1.518-2.65-4.105-2.65-7.174 0-1.539.349-2.63.705-3.341.178-.355.356-.614.493-.786a3 3 0 0 1 .23-.258l.004-.004.001-.001h.001z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.171 0c.66 0 1.195.534 1.195 1.193v2.592a1.194 1.194 0 0 1-2.389 0V1.193C9.977.534 10.512 0 11.171 0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M11.976 3.785V1.193a.804.804 0 0 0-1.61 0v2.592a.804.804 0 0 0 1.61 0m.39-2.592a1.194 1.194 0 0 0-2.389 0v2.592a1.194 1.194 0 0 0 2.389 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M13.15 6.692c1.505 0 2.517-.371 2.834-.557H13.15z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M16.173 6.085a.194.194 0 0 1-.09.218c-.353.207-1.4.584-2.933.584a.195.195 0 0 1-.195-.195v-.556c0-.108.088-.195.195-.195h2.835c.088 0 .165.059.188.144m-1.362.245h-1.466v.166a8 8 0 0 0 1.465-.166",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#18182E", d: "M9.27 6.692c-1.506 0-2.517-.371-2.835-.557H9.27z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M6.247 6.085a.195.195 0 0 0 .09.218c.353.207 1.4.584 2.932.584a.195.195 0 0 0 .195-.195v-.556a.195.195 0 0 0-.195-.195H6.435a.195.195 0 0 0-.188.144m1.362.245h1.466v.166a8 8 0 0 1-1.466-.166",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.1 28.858c0-1.393-.65-2.05-.975-2.205l-1.72 1.021v6.59c.899-1.222 2.696-4.014 2.696-5.406"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m15.125 26.876-1.525.906v5.87a25 25 0 0 0 1.318-2.123c.279-.508.527-1.017.705-1.483.18-.47.282-.878.282-1.19 0-1.198-.5-1.788-.78-1.98m.083-.401c.406.193 1.087.928 1.087 2.38 0 .384-.123.846-.308 1.33a13 13 0 0 1-.727 1.53 26 26 0 0 1-1.698 2.662.195.195 0 0 1-.352-.115v-6.59c0-.069.036-.133.095-.168l1.72-1.02a.2.2 0 0 1 .183-.009",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "m13.408 5.561.775 3.26.12.467H8.55l.673-3.727 1.932-.7z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.456 9.408a.2.2 0 0 1-.153.076H8.55a.195.195 0 0 1-.192-.23l.674-3.727a.2.2 0 0 1 .125-.148l1.932-.7a.2.2 0 0 1 .124-.002l2.253.7c.066.02.116.073.132.14l.775 3.259.118.465a.2.2 0 0 1-.035.167m-.404-.314-.058-.227-.75-3.152-2.084-.647-1.765.639-.612 3.387z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M7.147 28.858c0-1.393.65-2.05.976-2.205l1.719 1.021v6.59c-.898-1.222-2.695-4.014-2.695-5.406"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m8.121 26.876 1.526.906v5.87a25 25 0 0 1-1.319-2.123 12.4 12.4 0 0 1-.704-1.483c-.18-.47-.282-.878-.282-1.19 0-1.198.5-1.788.78-1.98m-.082-.401c-.406.193-1.087.928-1.087 2.38 0 .384.122.846.308 1.33.186.488.443 1.014.726 1.53a26 26 0 0 0 1.699 2.662.195.195 0 0 0 .351-.115v-6.59a.2.2 0 0 0-.095-.168l-1.719-1.02a.2.2 0 0 0-.183-.009",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M13.383 34.31c1.152-2.656 1.094-5.207.92-6.15l-1.339-2.715-2.672.696L8.62 28.16c-.075 2.413.784 5.105 1.222 6.15l1.728 1.032z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m14.116 28.222-1.256-2.549-2.457.64-1.59 1.92c-.055 2.313.75 4.882 1.185 5.942l1.575.942 1.656-.944c1.099-2.57 1.05-5.028.887-5.952m.379-.097c.18.977.236 3.568-.933 6.262a.2.2 0 0 1-.083.091l-1.812 1.033a.2.2 0 0 1-.197-.002l-1.728-1.033a.2.2 0 0 1-.08-.091c-.443-1.057-1.313-3.778-1.237-6.23a.2.2 0 0 1 .045-.119l1.672-2.019a.2.2 0 0 1 .101-.064l2.672-.696c.09-.024.183.02.224.102l1.34 2.715a.2.2 0 0 1 .016.051",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M15.287 26.43c-1.431-3.87-1.076-7.715-.72-9.154H8.355c.997 3.23-.012 7.449-.642 9.154l.953 1.729c.503-.317 1.766-.951 2.788-.951 1.278 0 2.442.613 2.849.95 0 0 .622-1.152.984-1.728"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M15.47 26.364a.2.2 0 0 1-.019.17 27 27 0 0 0-.622 1.073c-.1.18-.19.34-.253.457l-.075.138-.027.05a.195.195 0 0 1-.297.058c-.377-.314-1.498-.907-2.724-.907-.476 0-1.02.15-1.517.344a7.4 7.4 0 0 0-1.167.578.195.195 0 0 1-.274-.071l-.953-1.729a.2.2 0 0 1-.012-.16c.31-.84.715-2.306.92-3.963s.205-3.49-.282-5.068a.195.195 0 0 1 .187-.252h6.211a.195.195 0 0 1 .19.242c-.35 1.408-.702 5.213.713 9.04m-1.232 1.506.25-.453c.183-.328.406-.72.583-1.008-1.337-3.685-1.086-7.33-.749-8.937H8.614c.435 1.59.42 3.378.223 4.978-.202 1.634-.596 3.088-.91 3.965l.811 1.474a8 8 0 0 1 1.055-.505c.516-.201 1.114-.37 1.66-.37 1.17 0 2.247.491 2.785.856",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.616 36.805c1.226 0 1.719-1.87 1.719-2.45H9.842c0 .673.547 2.45 1.774 2.45"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M13.53 34.16v.195c0 .324-.132.967-.42 1.532-.287.558-.767 1.113-1.494 1.113-.72 0-1.215-.523-1.518-1.074-.304-.554-.451-1.198-.451-1.57v-.195zm-.404.39H10.05c.04.32.165.78.39 1.19.278.505.67.87 1.176.87.5 0 .88-.38 1.146-.9.21-.41.325-.863.364-1.16",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "m12.499 2.38-1.371-.673-1.287.672v2.39c.212-.123.767-.37 1.287-.37s1.13.154 1.37.231z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M12.585 2.206c.066.033.109.1.109.175v2.25a.195.195 0 0 1-.255.186c-.231-.075-.82-.223-1.31-.223-.472 0-.991.23-1.19.345a.195.195 0 0 1-.292-.168V2.38c0-.073.04-.14.104-.173l1.287-.673a.2.2 0 0 1 .176-.002zm-.281.296-1.173-.576-1.095.573v1.959c.287-.123.694-.253 1.092-.253.41 0 .867.09 1.176.169zM22.348 11.882a.68.68 0 0 1-.915.308c-2.874-1.425-7.361-2.377-10.104-2.377-3.264 0-7.063 1.036-9.72 2.375a.682.682 0 0 1-.615-1.217C3.82 9.55 7.826 8.451 11.33 8.451c2.942 0 7.638.996 10.71 2.518a.68.68 0 0 1 .308.913",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.5 15.32a1.315 1.315 0 1 1 0-2.63 1.315 1.315 0 0 1 0 2.63"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M10.575 14.006a.925.925 0 1 0 1.85-.001.925.925 0 0 0-1.85 0m-.39 0a1.315 1.315 0 1 0 2.63-.002 1.315 1.315 0 0 0-2.63.002",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M11.33 5.326c1.219 0 1.985.34 2.215.51-.093-.479-.666-1.438-2.216-1.438s-2.157.96-2.268 1.439c.248-.17 1.049-.51 2.268-.51"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M13.65 6.002a.195.195 0 0 1-.22-.009c-.19-.139-.911-.472-2.1-.472s-1.95.333-2.158.476a.195.195 0 0 1-.3-.204c.128-.56.81-1.59 2.457-1.59 1.65 0 2.298 1.033 2.407 1.597a.19.19 0 0 1-.087.202m-.49-.573c-.262-.398-.811-.836-1.83-.836s-1.587.438-1.867.838c.427-.155 1.062-.3 1.866-.3.799 0 1.418.143 1.831.298",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M21.006 9.61c-1.101 0-1.994-.537-1.994-1.198s.893-1.197 1.994-1.197S23 7.75 23 8.412s-.893 1.198-1.994 1.198"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M20.368 8.169v.486h-1.826c-.48 0-.97.094-1.398.243-.431.151-.78.353-.99.556l-.34-.35c.278-.268.698-.5 1.169-.665a4.8 4.8 0 0 1 1.559-.27z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.994 9.61c1.101 0 1.994-.537 1.994-1.198s-.893-1.197-1.994-1.197S0 7.75 0 8.412.893 9.61 1.994 9.61"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.632 8.169v.486h1.826c.48 0 .97.094 1.398.243.431.151.78.353.99.556l.34-.35c-.278-.268-.698-.5-1.169-.665a4.8 4.8 0 0 0-1.559-.27z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#03D8A9",
          fillRule: "evenodd",
          d: "M11.5 46.526a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M2.5 38a9 9 0 1 1 18.001.001A9 9 0 0 1 2.5 38m9-8.053a8.053 8.053 0 1 0 .001 16.107 8.053 8.053 0 0 0-.001-16.107",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M11.5 38.49a.48.48 0 0 1-.35-.14.48.48 0 0 1-.142-.35v-3.93q0-.21.142-.35a.48.48 0 0 1 .35-.141q.208 0 .35.14.14.143.14.35V38q0 .21-.14.35a.48.48 0 0 1-.35.142m0 3.93q-.921 0-1.726-.35a4.5 4.5 0 0 1-1.4-.945 4.5 4.5 0 0 1-.945-1.4A4.3 4.3 0 0 1 7.079 38q0-.848.307-1.621.306-.774.884-1.4a.45.45 0 0 1 .344-.148q.209 0 .356.148a.42.42 0 0 1 .123.337.6.6 0 0 1-.148.363q-.429.478-.657 1.074A3.5 3.5 0 0 0 8.061 38q0 1.437 1 2.437 1.001 1.001 2.439 1.001 1.437 0 2.437-1 1.001-1.001 1.001-2.438 0-.651-.233-1.26a3.5 3.5 0 0 0-.663-1.086.52.52 0 0 1-.142-.344.43.43 0 0 1 .13-.331.49.49 0 0 1 .356-.148q.208 0 .344.148.576.626.884 1.4.307.773.307 1.62 0 .922-.35 1.726a4.5 4.5 0 0 1-.946 1.4 4.5 4.5 0 0 1-1.4.946 4.3 4.3 0 0 1-1.725.35"
        }
      )
    ]
  }
);
const VehicleSMotorcycleUnavailable = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-motorcycle-unavailable",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 47",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M15.31 13.447c0-3.017-1.046-4.247-1.046-4.247l-2.741-.302L9.06 9.2s-1.37 1.23-1.37 4.247 1.254 5.557 2.6 7.042h2.207c1.264-1.355 2.813-4.026 2.813-7.042"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.16 9.385q.039.052.101.156c.092.153.218.39.344.721.253.662.51 1.7.51 3.185 0 2.91-1.474 5.5-2.703 6.848h-2.034c-1.295-1.46-2.493-3.926-2.493-6.848 0-1.477.335-2.51.665-3.167.164-.33.328-.566.45-.72q.092-.114.143-.167l.007-.007 2.374-.29zm-5.1-.184-.13-.145a.2.2 0 0 1 .107-.048l2.462-.302a.2.2 0 0 1 .046 0l2.74.301c.05.006.096.03.128.068l-.148.126.148-.126.002.002.004.004a1 1 0 0 1 .048.065q.049.065.128.194c.104.172.24.43.374.784.27.707.536 1.792.536 3.323 0 3.078-1.577 5.794-2.865 7.176a.2.2 0 0 1-.142.062H10.29a.2.2 0 0 1-.145-.064c-1.376-1.518-2.65-4.105-2.65-7.174 0-1.539.349-2.63.705-3.341.178-.355.356-.614.493-.786a3 3 0 0 1 .23-.258l.004-.004.001-.001h.001z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.171 0c.66 0 1.195.534 1.195 1.193v2.592a1.194 1.194 0 0 1-2.389 0V1.193C9.977.534 10.512 0 11.171 0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M11.976 3.785V1.193a.804.804 0 0 0-1.61 0v2.592a.804.804 0 0 0 1.61 0m.39-2.592a1.194 1.194 0 0 0-2.389 0v2.592a1.194 1.194 0 0 0 2.389 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M13.15 6.692c1.505 0 2.517-.371 2.834-.557H13.15z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M16.173 6.085a.194.194 0 0 1-.09.218c-.353.207-1.4.584-2.933.584a.195.195 0 0 1-.195-.195v-.556c0-.108.088-.195.195-.195h2.835c.088 0 .165.059.188.144m-1.362.245h-1.466v.166a8 8 0 0 0 1.465-.166",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#18182E", d: "M9.27 6.692c-1.506 0-2.517-.371-2.835-.557H9.27z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M6.247 6.085a.195.195 0 0 0 .09.218c.353.207 1.4.584 2.932.584a.195.195 0 0 0 .195-.195v-.556a.195.195 0 0 0-.195-.195H6.435a.195.195 0 0 0-.188.144m1.362.245h1.466v.166a8 8 0 0 1-1.466-.166",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.1 28.858c0-1.393-.65-2.05-.975-2.205l-1.72 1.021v6.59c.899-1.222 2.696-4.014 2.696-5.406"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m15.125 26.876-1.525.906v5.87a25 25 0 0 0 1.318-2.123c.279-.508.527-1.017.705-1.483.18-.47.282-.878.282-1.19 0-1.198-.5-1.788-.78-1.98m.083-.401c.406.193 1.087.928 1.087 2.38 0 .384-.123.846-.308 1.33a13 13 0 0 1-.727 1.53 26 26 0 0 1-1.698 2.662.195.195 0 0 1-.352-.115v-6.59c0-.069.036-.133.095-.168l1.72-1.02a.2.2 0 0 1 .183-.009",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "m13.408 5.561.775 3.26.12.467H8.55l.673-3.727 1.932-.7z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.456 9.408a.2.2 0 0 1-.153.076H8.55a.195.195 0 0 1-.192-.23l.674-3.727a.2.2 0 0 1 .125-.148l1.932-.7a.2.2 0 0 1 .124-.002l2.253.7c.066.02.116.073.132.14l.775 3.259.118.465a.2.2 0 0 1-.035.167m-.404-.314-.058-.227-.75-3.152-2.084-.647-1.765.639-.612 3.387z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M7.147 28.858c0-1.393.65-2.05.976-2.205l1.719 1.021v6.59c-.898-1.222-2.695-4.014-2.695-5.406"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m8.121 26.876 1.526.906v5.87a25 25 0 0 1-1.319-2.123 12.4 12.4 0 0 1-.704-1.483c-.18-.47-.282-.878-.282-1.19 0-1.198.5-1.788.78-1.98m-.082-.401c-.406.193-1.087.928-1.087 2.38 0 .384.122.846.308 1.33.186.488.443 1.014.726 1.53a26 26 0 0 0 1.699 2.662.195.195 0 0 0 .351-.115v-6.59a.2.2 0 0 0-.095-.168l-1.719-1.02a.2.2 0 0 0-.183-.009",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M13.383 34.31c1.152-2.656 1.094-5.207.92-6.15l-1.339-2.715-2.672.696L8.62 28.16c-.075 2.413.784 5.105 1.222 6.15l1.728 1.032z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m14.116 28.222-1.256-2.549-2.457.64-1.59 1.92c-.055 2.313.75 4.882 1.185 5.942l1.575.942 1.656-.944c1.099-2.57 1.05-5.028.887-5.952m.379-.097c.18.977.236 3.568-.933 6.262a.2.2 0 0 1-.083.091l-1.812 1.033a.2.2 0 0 1-.197-.002l-1.728-1.033a.2.2 0 0 1-.08-.091c-.443-1.057-1.313-3.778-1.237-6.23a.2.2 0 0 1 .045-.119l1.672-2.019a.2.2 0 0 1 .101-.064l2.672-.696c.09-.024.183.02.224.102l1.34 2.715a.2.2 0 0 1 .016.051",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M15.287 26.43c-1.431-3.87-1.076-7.715-.72-9.154H8.355c.997 3.23-.012 7.449-.642 9.154l.953 1.729c.503-.317 1.766-.951 2.788-.951 1.278 0 2.442.613 2.849.95 0 0 .622-1.152.984-1.728"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M15.47 26.364a.2.2 0 0 1-.019.17 27 27 0 0 0-.622 1.073c-.1.18-.19.34-.253.457l-.075.138-.027.05a.195.195 0 0 1-.297.058c-.377-.314-1.498-.907-2.724-.907-.476 0-1.02.15-1.517.344a7.4 7.4 0 0 0-1.167.578.195.195 0 0 1-.274-.071l-.953-1.729a.2.2 0 0 1-.012-.16c.31-.84.715-2.306.92-3.963s.205-3.49-.282-5.068a.195.195 0 0 1 .187-.252h6.211a.195.195 0 0 1 .19.242c-.35 1.408-.702 5.213.713 9.04m-1.232 1.506.25-.453c.183-.328.406-.72.583-1.008-1.337-3.685-1.086-7.33-.749-8.937H8.614c.435 1.59.42 3.378.223 4.978-.202 1.634-.596 3.088-.91 3.965l.811 1.474a8 8 0 0 1 1.055-.505c.516-.201 1.114-.37 1.66-.37 1.17 0 2.247.491 2.785.856",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.616 36.805c1.226 0 1.719-1.87 1.719-2.45H9.842c0 .673.547 2.45 1.774 2.45"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M13.53 34.16v.195c0 .324-.132.967-.42 1.532-.287.558-.767 1.113-1.494 1.113-.72 0-1.215-.523-1.518-1.074-.304-.554-.451-1.198-.451-1.57v-.195zm-.404.39H10.05c.04.32.165.78.39 1.19.278.505.67.87 1.176.87.5 0 .88-.38 1.146-.9.21-.41.325-.863.364-1.16",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "m12.499 2.38-1.371-.673-1.287.672v2.39c.212-.123.767-.37 1.287-.37s1.13.154 1.37.231z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M12.585 2.206c.066.033.109.1.109.175v2.25a.195.195 0 0 1-.255.186c-.231-.075-.82-.223-1.31-.223-.472 0-.991.23-1.19.345a.195.195 0 0 1-.292-.168V2.38c0-.073.04-.14.104-.173l1.287-.673a.2.2 0 0 1 .176-.002zm-.281.296-1.173-.576-1.095.573v1.959c.287-.123.694-.253 1.092-.253.41 0 .867.09 1.176.169zM22.348 11.882a.68.68 0 0 1-.915.308c-2.874-1.425-7.361-2.377-10.104-2.377-3.264 0-7.063 1.036-9.72 2.375a.682.682 0 0 1-.615-1.217C3.82 9.55 7.826 8.451 11.33 8.451c2.942 0 7.638.996 10.71 2.518a.68.68 0 0 1 .308.913",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.5 15.32a1.315 1.315 0 1 1 0-2.63 1.315 1.315 0 0 1 0 2.63"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M10.575 14.006a.925.925 0 1 0 1.85-.001.925.925 0 0 0-1.85 0m-.39 0a1.315 1.315 0 1 0 2.63-.002 1.315 1.315 0 0 0-2.63.002",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M11.33 5.326c1.219 0 1.985.34 2.215.51-.093-.479-.666-1.438-2.216-1.438s-2.157.96-2.268 1.439c.248-.17 1.049-.51 2.268-.51"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M13.65 6.002a.195.195 0 0 1-.22-.009c-.19-.139-.911-.472-2.1-.472s-1.95.333-2.158.476a.195.195 0 0 1-.3-.204c.128-.56.81-1.59 2.457-1.59 1.65 0 2.298 1.033 2.407 1.597a.19.19 0 0 1-.087.202m-.49-.573c-.262-.398-.811-.836-1.83-.836s-1.587.438-1.867.838c.427-.155 1.062-.3 1.866-.3.799 0 1.418.143 1.831.298",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M21.006 9.61c-1.101 0-1.994-.537-1.994-1.198s.893-1.197 1.994-1.197S23 7.75 23 8.412s-.893 1.198-1.994 1.198"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M20.368 8.169v.486h-1.826c-.48 0-.97.094-1.398.243-.431.151-.78.353-.99.556l-.34-.35c.278-.268.698-.5 1.169-.665a4.8 4.8 0 0 1 1.559-.27z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.994 9.61c1.101 0 1.994-.537 1.994-1.198s-.893-1.197-1.994-1.197S0 7.75 0 8.412.893 9.61 1.994 9.61"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.632 8.169v.486h1.826c.48 0 .97.094 1.398.243.431.151.78.353.99.556l.34-.35c-.278-.268-.698-.5-1.169-.665a4.8 4.8 0 0 0-1.559-.27z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          d: "M4.036 31.027h14.928c.78 0 1.273.838.894 1.52l-7.464 13.412c-.39.7-1.398.7-1.787 0L3.143 32.546c-.38-.681.113-1.52.893-1.52"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M12.84 46.208a1.534 1.534 0 0 1-2.68 0L2.696 32.795a1.533 1.533 0 0 1 1.34-2.28h14.928c1.17 0 1.91 1.258 1.34 2.28zm-1.787-.497c.195.35.699.35.894 0l7.464-13.413a.51.51 0 0 0-.447-.76H4.036a.51.51 0 0 0-.447.76z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M11.5 41.53a.76.76 0 0 1-.569-.245.82.82 0 0 1-.236-.59q0-.343.236-.589a.76.76 0 0 1 .57-.245q.33 0 .568.245.236.245.236.59a.82.82 0 0 1-.236.59.76.76 0 0 1-.569.245m0-2.504a.76.76 0 0 1-.569-.245.82.82 0 0 1-.236-.59v-3.34q0-.344.236-.59a.76.76 0 0 1 .57-.244q.33 0 .568.245.236.245.236.59v3.34a.82.82 0 0 1-.236.589.76.76 0 0 1-.569.245"
        }
      )
    ]
  }
);
const VehicleSMotorcycleUnplugged = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-motorcycle-unplugged",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 47",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M15.31 13.447c0-3.017-1.046-4.247-1.046-4.247l-2.741-.302L9.06 9.2s-1.37 1.23-1.37 4.247 1.254 5.557 2.6 7.042h2.207c1.264-1.355 2.813-4.026 2.813-7.042"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.16 9.385q.039.052.101.156c.092.153.218.39.344.721.253.662.51 1.7.51 3.185 0 2.91-1.474 5.5-2.703 6.848h-2.034c-1.295-1.46-2.493-3.926-2.493-6.848 0-1.477.335-2.51.665-3.167.164-.33.328-.566.45-.72q.092-.114.143-.167l.007-.007 2.374-.29zm-5.1-.184-.13-.145a.2.2 0 0 1 .107-.048l2.462-.302a.2.2 0 0 1 .046 0l2.74.301c.05.006.096.03.128.068l-.148.126.148-.126.002.002.004.004a1 1 0 0 1 .048.065q.049.065.128.194c.104.172.24.43.374.784.27.707.536 1.792.536 3.323 0 3.078-1.577 5.794-2.865 7.176a.2.2 0 0 1-.142.062H10.29a.2.2 0 0 1-.145-.064c-1.376-1.518-2.65-4.105-2.65-7.174 0-1.539.349-2.63.705-3.341.178-.355.356-.614.493-.786a3 3 0 0 1 .23-.258l.004-.004.001-.001h.001z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.171 0c.66 0 1.195.534 1.195 1.193v2.592a1.194 1.194 0 0 1-2.389 0V1.193C9.977.534 10.512 0 11.171 0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M11.976 3.785V1.193a.804.804 0 0 0-1.61 0v2.592a.804.804 0 0 0 1.61 0m.39-2.592a1.194 1.194 0 0 0-2.389 0v2.592a1.194 1.194 0 0 0 2.389 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M13.15 6.692c1.505 0 2.517-.371 2.834-.557H13.15z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M16.173 6.085a.194.194 0 0 1-.09.218c-.353.207-1.4.584-2.933.584a.195.195 0 0 1-.195-.195v-.556c0-.108.088-.195.195-.195h2.835c.088 0 .165.059.188.144m-1.362.245h-1.466v.166a8 8 0 0 0 1.465-.166",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#18182E", d: "M9.27 6.692c-1.506 0-2.517-.371-2.835-.557H9.27z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M6.247 6.085a.195.195 0 0 0 .09.218c.353.207 1.4.584 2.932.584a.195.195 0 0 0 .195-.195v-.556a.195.195 0 0 0-.195-.195H6.435a.195.195 0 0 0-.188.144m1.362.245h1.466v.166a8 8 0 0 1-1.466-.166",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.1 28.858c0-1.393-.65-2.05-.975-2.205l-1.72 1.021v6.59c.899-1.222 2.696-4.014 2.696-5.406"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m15.125 26.876-1.525.906v5.87a25 25 0 0 0 1.318-2.123c.279-.508.527-1.017.705-1.483.18-.47.282-.878.282-1.19 0-1.198-.5-1.788-.78-1.98m.083-.401c.406.193 1.087.928 1.087 2.38 0 .384-.123.846-.308 1.33a13 13 0 0 1-.727 1.53 26 26 0 0 1-1.698 2.662.195.195 0 0 1-.352-.115v-6.59c0-.069.036-.133.095-.168l1.72-1.02a.2.2 0 0 1 .183-.009",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "m13.408 5.561.775 3.26.12.467H8.55l.673-3.727 1.932-.7z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.456 9.408a.2.2 0 0 1-.153.076H8.55a.195.195 0 0 1-.192-.23l.674-3.727a.2.2 0 0 1 .125-.148l1.932-.7a.2.2 0 0 1 .124-.002l2.253.7c.066.02.116.073.132.14l.775 3.259.118.465a.2.2 0 0 1-.035.167m-.404-.314-.058-.227-.75-3.152-2.084-.647-1.765.639-.612 3.387z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M7.147 28.858c0-1.393.65-2.05.976-2.205l1.719 1.021v6.59c-.898-1.222-2.695-4.014-2.695-5.406"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m8.121 26.876 1.526.906v5.87a25 25 0 0 1-1.319-2.123 12.4 12.4 0 0 1-.704-1.483c-.18-.47-.282-.878-.282-1.19 0-1.198.5-1.788.78-1.98m-.082-.401c-.406.193-1.087.928-1.087 2.38 0 .384.122.846.308 1.33.186.488.443 1.014.726 1.53a26 26 0 0 0 1.699 2.662.195.195 0 0 0 .351-.115v-6.59a.2.2 0 0 0-.095-.168l-1.719-1.02a.2.2 0 0 0-.183-.009",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M13.383 34.31c1.152-2.656 1.094-5.207.92-6.15l-1.339-2.715-2.672.696L8.62 28.16c-.075 2.413.784 5.105 1.222 6.15l1.728 1.032z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m14.116 28.222-1.256-2.549-2.457.64-1.59 1.92c-.055 2.313.75 4.882 1.185 5.942l1.575.942 1.656-.944c1.099-2.57 1.05-5.028.887-5.952m.379-.097c.18.977.236 3.568-.933 6.262a.2.2 0 0 1-.083.091l-1.812 1.033a.2.2 0 0 1-.197-.002l-1.728-1.033a.2.2 0 0 1-.08-.091c-.443-1.057-1.313-3.778-1.237-6.23a.2.2 0 0 1 .045-.119l1.672-2.019a.2.2 0 0 1 .101-.064l2.672-.696c.09-.024.183.02.224.102l1.34 2.715a.2.2 0 0 1 .016.051",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M15.287 26.43c-1.431-3.87-1.076-7.715-.72-9.154H8.355c.997 3.23-.012 7.449-.642 9.154l.953 1.729c.503-.317 1.766-.951 2.788-.951 1.278 0 2.442.613 2.849.95 0 0 .622-1.152.984-1.728"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M15.47 26.364a.2.2 0 0 1-.019.17 27 27 0 0 0-.622 1.073c-.1.18-.19.34-.253.457l-.075.138-.027.05a.195.195 0 0 1-.297.058c-.377-.314-1.498-.907-2.724-.907-.476 0-1.02.15-1.517.344a7.4 7.4 0 0 0-1.167.578.195.195 0 0 1-.274-.071l-.953-1.729a.2.2 0 0 1-.012-.16c.31-.84.715-2.306.92-3.963s.205-3.49-.282-5.068a.195.195 0 0 1 .187-.252h6.211a.195.195 0 0 1 .19.242c-.35 1.408-.702 5.213.713 9.04m-1.232 1.506.25-.453c.183-.328.406-.72.583-1.008-1.337-3.685-1.086-7.33-.749-8.937H8.614c.435 1.59.42 3.378.223 4.978-.202 1.634-.596 3.088-.91 3.965l.811 1.474a8 8 0 0 1 1.055-.505c.516-.201 1.114-.37 1.66-.37 1.17 0 2.247.491 2.785.856",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.616 36.805c1.226 0 1.719-1.87 1.719-2.45H9.842c0 .673.547 2.45 1.774 2.45"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M13.53 34.16v.195c0 .324-.132.967-.42 1.532-.287.558-.767 1.113-1.494 1.113-.72 0-1.215-.523-1.518-1.074-.304-.554-.451-1.198-.451-1.57v-.195zm-.404.39H10.05c.04.32.165.78.39 1.19.278.505.67.87 1.176.87.5 0 .88-.38 1.146-.9.21-.41.325-.863.364-1.16",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "m12.499 2.38-1.371-.673-1.287.672v2.39c.212-.123.767-.37 1.287-.37s1.13.154 1.37.231z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M12.585 2.206c.066.033.109.1.109.175v2.25a.195.195 0 0 1-.255.186c-.231-.075-.82-.223-1.31-.223-.472 0-.991.23-1.19.345a.195.195 0 0 1-.292-.168V2.38c0-.073.04-.14.104-.173l1.287-.673a.2.2 0 0 1 .176-.002zm-.281.296-1.173-.576-1.095.573v1.959c.287-.123.694-.253 1.092-.253.41 0 .867.09 1.176.169zM22.348 11.882a.68.68 0 0 1-.915.308c-2.874-1.425-7.361-2.377-10.104-2.377-3.264 0-7.063 1.036-9.72 2.375a.682.682 0 0 1-.615-1.217C3.82 9.55 7.826 8.451 11.33 8.451c2.942 0 7.638.996 10.71 2.518a.68.68 0 0 1 .308.913",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.5 15.32a1.315 1.315 0 1 1 0-2.63 1.315 1.315 0 0 1 0 2.63"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M10.575 14.006a.925.925 0 1 0 1.85-.001.925.925 0 0 0-1.85 0m-.39 0a1.315 1.315 0 1 0 2.63-.002 1.315 1.315 0 0 0-2.63.002",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M11.33 5.326c1.219 0 1.985.34 2.215.51-.093-.479-.666-1.438-2.216-1.438s-2.157.96-2.268 1.439c.248-.17 1.049-.51 2.268-.51"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M13.65 6.002a.195.195 0 0 1-.22-.009c-.19-.139-.911-.472-2.1-.472s-1.95.333-2.158.476a.195.195 0 0 1-.3-.204c.128-.56.81-1.59 2.457-1.59 1.65 0 2.298 1.033 2.407 1.597a.19.19 0 0 1-.087.202m-.49-.573c-.262-.398-.811-.836-1.83-.836s-1.587.438-1.867.838c.427-.155 1.062-.3 1.866-.3.799 0 1.418.143 1.831.298",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M21.006 9.61c-1.101 0-1.994-.537-1.994-1.198s.893-1.197 1.994-1.197S23 7.75 23 8.412s-.893 1.198-1.994 1.198"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M20.368 8.169v.486h-1.826c-.48 0-.97.094-1.398.243-.431.151-.78.353-.99.556l-.34-.35c.278-.268.698-.5 1.169-.665a4.8 4.8 0 0 1 1.559-.27z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.994 9.61c1.101 0 1.994-.537 1.994-1.198s-.893-1.197-1.994-1.197S0 7.75 0 8.412.893 9.61 1.994 9.61"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.632 8.169v.486h1.826c.48 0 .97.094 1.398.243.431.151.78.353.99.556l.34-.35c-.278-.268-.698-.5-1.169-.665a4.8 4.8 0 0 0-1.559-.27z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          d: "M4.262 31.012H19.19c.78 0 1.272.838.893 1.52L12.62 45.958a1.022 1.022 0 0 1-1.787 0L3.368 32.532c-.38-.682.114-1.52.894-1.52"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M13.066 46.206a1.533 1.533 0 0 1-2.68 0L2.92 32.781a1.535 1.535 0 0 1 1.34-2.281H19.19c1.17 0 1.909 1.258 1.34 2.28zm-1.787-.497c.195.35.698.35.893 0l7.464-13.426a.512.512 0 0 0-.447-.76H4.262c-.39 0-.637.42-.447.76z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M13.228 34.304c0-.165-.128-.3-.285-.3a.29.29 0 0 0-.285.3v1.962h-1.865v-1.962c0-.165-.127-.3-.284-.3a.293.293 0 0 0-.286.3v1.962h-.645v1.203c.003 1.071.721 1.992 1.718 2.205v1.852h.859v-1.852c.997-.213 1.715-1.134 1.718-2.205v-1.207h-.645z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M7.43 33.467h8.59v8.596H7.43z" }) }) })
    ]
  }
);
const VehicleSMotorcycle = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-motorcycle",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 37",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M15.31 13.447c0-3.017-1.046-4.247-1.046-4.247l-2.741-.302L9.06 9.2s-1.37 1.23-1.37 4.247 1.254 5.557 2.6 7.042h2.207c1.264-1.355 2.813-4.026 2.813-7.042"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.16 9.385q.039.052.101.156c.092.153.218.39.344.721.253.662.51 1.7.51 3.185 0 2.91-1.474 5.5-2.703 6.848h-2.034c-1.295-1.46-2.493-3.926-2.493-6.848 0-1.477.335-2.51.665-3.167.164-.33.328-.566.45-.72q.092-.114.143-.167l.007-.007 2.374-.29zm-5.1-.184-.13-.145a.2.2 0 0 1 .107-.048l2.462-.302a.2.2 0 0 1 .046 0l2.74.301c.05.006.096.03.128.068l-.148.126.148-.126.002.002.004.004a1 1 0 0 1 .048.065q.049.065.128.194c.104.172.24.43.374.784.27.707.536 1.792.536 3.323 0 3.078-1.577 5.794-2.865 7.176a.2.2 0 0 1-.142.062H10.29a.2.2 0 0 1-.145-.064c-1.376-1.518-2.65-4.105-2.65-7.174 0-1.539.349-2.63.705-3.341.178-.355.356-.614.493-.786a3 3 0 0 1 .23-.258l.004-.004.001-.001h.001z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.171 0c.66 0 1.195.534 1.195 1.193v2.592a1.194 1.194 0 0 1-2.389 0V1.193C9.977.534 10.512 0 11.171 0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M11.976 3.785V1.193a.804.804 0 0 0-1.61 0v2.592a.804.804 0 0 0 1.61 0m.39-2.592a1.194 1.194 0 0 0-2.389 0v2.592a1.194 1.194 0 0 0 2.389 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M13.15 6.692c1.505 0 2.517-.371 2.834-.557H13.15z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M16.173 6.085a.194.194 0 0 1-.09.218c-.353.207-1.4.584-2.933.584a.195.195 0 0 1-.195-.195v-.556c0-.108.088-.195.195-.195h2.835c.088 0 .165.059.188.144m-1.362.245h-1.466v.166a8 8 0 0 0 1.465-.166",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#18182E", d: "M9.27 6.692c-1.506 0-2.517-.371-2.835-.557H9.27z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M6.247 6.085a.195.195 0 0 0 .09.218c.353.207 1.4.584 2.932.584a.195.195 0 0 0 .195-.195v-.556a.195.195 0 0 0-.195-.195H6.435a.195.195 0 0 0-.188.144m1.362.245h1.466v.166a8 8 0 0 1-1.466-.166",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.1 28.858c0-1.393-.65-2.05-.975-2.205l-1.72 1.021v6.59c.899-1.222 2.696-4.014 2.696-5.406"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m15.125 26.876-1.525.906v5.87a25 25 0 0 0 1.318-2.123c.279-.508.527-1.017.705-1.483.18-.47.282-.878.282-1.19 0-1.198-.5-1.788-.78-1.98m.083-.401c.406.193 1.087.928 1.087 2.38 0 .384-.123.846-.308 1.33a13 13 0 0 1-.727 1.53 26 26 0 0 1-1.698 2.662.195.195 0 0 1-.352-.115v-6.59c0-.069.036-.133.095-.168l1.72-1.02a.2.2 0 0 1 .183-.009",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "m13.408 5.561.775 3.26.12.467H8.55l.673-3.727 1.932-.7z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.456 9.408a.2.2 0 0 1-.153.076H8.55a.195.195 0 0 1-.192-.23l.674-3.727a.2.2 0 0 1 .125-.148l1.932-.7a.2.2 0 0 1 .124-.002l2.253.7c.066.02.116.073.132.14l.775 3.259.118.465a.2.2 0 0 1-.035.167m-.404-.314-.058-.227-.75-3.152-2.084-.647-1.765.639-.612 3.387z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M7.147 28.858c0-1.393.65-2.05.976-2.205l1.719 1.021v6.59c-.898-1.222-2.695-4.014-2.695-5.406"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m8.121 26.876 1.526.906v5.87a25 25 0 0 1-1.319-2.123 12.4 12.4 0 0 1-.704-1.483c-.18-.47-.282-.878-.282-1.19 0-1.198.5-1.788.78-1.98m-.082-.401c-.406.193-1.087.928-1.087 2.38 0 .384.122.846.308 1.33.186.488.443 1.014.726 1.53a26 26 0 0 0 1.699 2.662.195.195 0 0 0 .351-.115v-6.59a.2.2 0 0 0-.095-.168l-1.719-1.02a.2.2 0 0 0-.183-.009",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M13.383 34.31c1.152-2.656 1.094-5.207.92-6.15l-1.339-2.715-2.672.696L8.62 28.16c-.075 2.413.784 5.105 1.222 6.15l1.728 1.032z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "m14.116 28.222-1.256-2.549-2.457.64-1.59 1.92c-.055 2.313.75 4.882 1.185 5.942l1.575.942 1.656-.944c1.099-2.57 1.05-5.028.887-5.952m.379-.097c.18.977.236 3.568-.933 6.262a.2.2 0 0 1-.083.091l-1.812 1.033a.2.2 0 0 1-.197-.002l-1.728-1.033a.2.2 0 0 1-.08-.091c-.443-1.057-1.313-3.778-1.237-6.23a.2.2 0 0 1 .045-.119l1.672-2.019a.2.2 0 0 1 .101-.064l2.672-.696c.09-.024.183.02.224.102l1.34 2.715a.2.2 0 0 1 .016.051",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M15.287 26.43c-1.431-3.87-1.076-7.715-.72-9.154H8.355c.997 3.23-.012 7.449-.642 9.154l.953 1.729c.503-.317 1.766-.951 2.788-.951 1.278 0 2.442.613 2.849.95 0 0 .622-1.152.984-1.728"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M15.47 26.364a.2.2 0 0 1-.019.17 27 27 0 0 0-.622 1.073c-.1.18-.19.34-.253.457l-.075.138-.027.05a.195.195 0 0 1-.297.058c-.377-.314-1.498-.907-2.724-.907-.476 0-1.02.15-1.517.344a7.4 7.4 0 0 0-1.167.578.195.195 0 0 1-.274-.071l-.953-1.729a.2.2 0 0 1-.012-.16c.31-.84.715-2.306.92-3.963s.205-3.49-.282-5.068a.195.195 0 0 1 .187-.252h6.211a.195.195 0 0 1 .19.242c-.35 1.408-.702 5.213.713 9.04m-1.232 1.506.25-.453c.183-.328.406-.72.583-1.008-1.337-3.685-1.086-7.33-.749-8.937H8.614c.435 1.59.42 3.378.223 4.978-.202 1.634-.596 3.088-.91 3.965l.811 1.474a8 8 0 0 1 1.055-.505c.516-.201 1.114-.37 1.66-.37 1.17 0 2.247.491 2.785.856",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.616 36.805c1.226 0 1.719-1.87 1.719-2.45H9.842c0 .673.547 2.45 1.774 2.45"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M13.53 34.16v.195c0 .324-.132.967-.42 1.532-.287.558-.767 1.113-1.494 1.113-.72 0-1.215-.523-1.518-1.074-.304-.554-.451-1.198-.451-1.57v-.195zm-.404.39H10.05c.04.32.165.78.39 1.19.278.505.67.87 1.176.87.5 0 .88-.38 1.146-.9.21-.41.325-.863.364-1.16",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "m12.499 2.38-1.371-.673-1.287.672v2.39c.212-.123.767-.37 1.287-.37s1.13.154 1.37.231z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M12.585 2.206c.066.033.109.1.109.175v2.25a.195.195 0 0 1-.255.186c-.231-.075-.82-.223-1.31-.223-.472 0-.991.23-1.19.345a.195.195 0 0 1-.292-.168V2.38c0-.073.04-.14.104-.173l1.287-.673a.2.2 0 0 1 .176-.002zm-.281.296-1.173-.576-1.095.573v1.959c.287-.123.694-.253 1.092-.253.41 0 .867.09 1.176.169zM22.348 11.882a.68.68 0 0 1-.915.308c-2.874-1.425-7.361-2.377-10.104-2.377-3.264 0-7.063 1.036-9.72 2.375a.682.682 0 0 1-.615-1.217C3.82 9.55 7.826 8.451 11.33 8.451c2.942 0 7.638.996 10.71 2.518a.68.68 0 0 1 .308.913",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M11.5 15.32a1.315 1.315 0 1 1 0-2.63 1.315 1.315 0 0 1 0 2.63"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M10.575 14.006a.925.925 0 1 0 1.85-.001.925.925 0 0 0-1.85 0m-.39 0a1.315 1.315 0 1 0 2.63-.002 1.315 1.315 0 0 0-2.63.002",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M11.33 5.326c1.219 0 1.985.34 2.215.51-.093-.479-.666-1.438-2.216-1.438s-2.157.96-2.268 1.439c.248-.17 1.049-.51 2.268-.51"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M13.65 6.002a.195.195 0 0 1-.22-.009c-.19-.139-.911-.472-2.1-.472s-1.95.333-2.158.476a.195.195 0 0 1-.3-.204c.128-.56.81-1.59 2.457-1.59 1.65 0 2.298 1.033 2.407 1.597a.19.19 0 0 1-.087.202m-.49-.573c-.262-.398-.811-.836-1.83-.836s-1.587.438-1.867.838c.427-.155 1.062-.3 1.866-.3.799 0 1.418.143 1.831.298",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M21.006 9.61c-1.101 0-1.994-.537-1.994-1.198s.893-1.197 1.994-1.197S23 7.75 23 8.412s-.893 1.198-1.994 1.198"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M20.368 8.169v.486h-1.826c-.48 0-.97.094-1.398.243-.431.151-.78.353-.99.556l-.34-.35c.278-.268.698-.5 1.169-.665a4.8 4.8 0 0 1 1.559-.27z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.994 9.61c1.101 0 1.994-.537 1.994-1.198s-.893-1.197-1.994-1.197S0 7.75 0 8.412.893 9.61 1.994 9.61"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M2.632 8.169v.486h1.826c.48 0 .97.094 1.398.243.431.151.78.353.99.556l.34-.35c-.278-.268-.698-.5-1.169-.665a4.8 4.8 0 0 0-1.559-.27z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSTractorDisablePending = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-tractor-disable-pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 39",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.542 27.446c.27 0 .49-.22.49-.49v-13.12a.49.49 0 0 0-.49-.49H4.45a.49.49 0 0 0-.49.49v13.12c0 .27.22.49.49.49z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M16.64 13.836v13.12a.1.1 0 0 1-.098.098H4.45a.1.1 0 0 1-.098-.098v-13.12c0-.054.044-.098.098-.098h12.092c.054 0 .098.044.098.098m.392 13.12c0 .27-.22.49-.49.49H4.45a.49.49 0 0 1-.49-.49v-13.12c0-.27.22-.49.49-.49h12.092c.27 0 .49.22.49.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M14.168 13.744c.27 0 .49-.22.49-.49V2.27a.49.49 0 0 0-.49-.49H6.824a.49.49 0 0 0-.49.49v10.984c0 .27.22.49.49.49z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.266 2.27v10.984a.1.1 0 0 1-.098.098H6.824a.1.1 0 0 1-.098-.098V2.27c0-.054.044-.098.098-.098h7.344c.054 0 .098.044.098.098m.392 10.984c0 .27-.22.49-.49.49H6.824a.49.49 0 0 1-.49-.49V2.27c0-.27.22-.49.49-.49h7.344c.27 0 .49.22.49.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M5.179 8.313c.638 0 1.155-.517 1.155-1.155V1.951a1.155 1.155 0 0 0-2.31 0v5.207c0 .638.517 1.155 1.155 1.155M15.814 8.313c.638 0 1.155-.517 1.155-1.155V1.951a1.155 1.155 0 1 0-2.31 0v5.207c0 .638.517 1.155 1.155 1.155M10.496 18.339a2.057 2.057 0 1 0 0 4.114 2.057 2.057 0 0 0 0-4.114M1.98 29.215c1.093 0 1.98-.962 1.98-2.15V14.049c0-1.187-.887-2.15-1.98-2.15-1.094 0-1.98.963-1.98 2.15v13.018c0 1.187.886 2.15 1.98 2.15M19.02 29.215c1.093 0 1.98-.962 1.98-2.15V14.049c0-1.187-.887-2.15-1.98-2.15-1.094 0-1.98.963-1.98 2.15v13.018c0 1.187.886 2.15 1.98 2.15"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCF0DE",
          fillRule: "evenodd",
          stroke: "#F9D199",
          d: "M10.5 38.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F9D199",
          fillRule: "evenodd",
          d: "M1.5 29.795a9 9 0 1 1 18.001.002A9 9 0 0 1 1.5 29.795m9-8.052a8.053 8.053 0 1 0 .001 16.106 8.053 8.053 0 0 0-.001-16.106",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          fillRule: "evenodd",
          d: "M13.424 28.138h-.474v-.948a2.37 2.37 0 0 0-4.736 0v.948H7.74a.95.95 0 0 0-.948.947v4.737a.95.95 0 0 0 .948.947h5.684a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.947M10.582 32.4a.95.95 0 0 1-.947-.948.95.95 0 0 1 .947-.947.95.95 0 0 1 .947.947.95.95 0 0 1-.947.948m1.468-4.263H9.114v-.948a1.47 1.47 0 0 1 2.936 0z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSTractorDisabled = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-tractor-disabled",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 39",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.542 27.446c.27 0 .49-.22.49-.49v-13.12a.49.49 0 0 0-.49-.49H4.45a.49.49 0 0 0-.49.49v13.12c0 .27.22.49.49.49z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M16.64 13.836v13.12a.1.1 0 0 1-.098.098H4.45a.1.1 0 0 1-.098-.098v-13.12c0-.054.044-.098.098-.098h12.092c.054 0 .098.044.098.098m.392 13.12c0 .27-.22.49-.49.49H4.45a.49.49 0 0 1-.49-.49v-13.12c0-.27.22-.49.49-.49h12.092c.27 0 .49.22.49.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M14.168 13.744c.27 0 .49-.22.49-.49V2.27a.49.49 0 0 0-.49-.49H6.824a.49.49 0 0 0-.49.49v10.984c0 .27.22.49.49.49z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.266 2.27v10.984a.1.1 0 0 1-.098.098H6.824a.1.1 0 0 1-.098-.098V2.27c0-.054.044-.098.098-.098h7.344c.054 0 .098.044.098.098m.392 10.984c0 .27-.22.49-.49.49H6.824a.49.49 0 0 1-.49-.49V2.27c0-.27.22-.49.49-.49h7.344c.27 0 .49.22.49.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M5.179 8.313c.638 0 1.155-.517 1.155-1.155V1.951a1.155 1.155 0 0 0-2.31 0v5.207c0 .638.517 1.155 1.155 1.155M15.814 8.313c.638 0 1.155-.517 1.155-1.155V1.951a1.155 1.155 0 1 0-2.31 0v5.207c0 .638.517 1.155 1.155 1.155M10.496 18.339a2.057 2.057 0 1 0 0 4.114 2.057 2.057 0 0 0 0-4.114M1.98 29.215c1.093 0 1.98-.962 1.98-2.15V14.049c0-1.187-.887-2.15-1.98-2.15-1.094 0-1.98.963-1.98 2.15v13.018c0 1.187.886 2.15 1.98 2.15M19.02 29.215c1.093 0 1.98-.962 1.98-2.15V14.049c0-1.187-.887-2.15-1.98-2.15-1.094 0-1.98.963-1.98 2.15v13.018c0 1.187.886 2.15 1.98 2.15"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCEDEB",
          fillRule: "evenodd",
          stroke: "#F5B7B1",
          d: "M10.5 38.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F5B7B1",
          fillRule: "evenodd",
          d: "M1.5 29.795a9 9 0 1 1 18.001.002A9 9 0 0 1 1.5 29.795m9-8.052a8.053 8.053 0 1 0 .001 16.106 8.053 8.053 0 0 0-.001-16.106",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          fillRule: "evenodd",
          d: "M13.424 28.138h-.474v-.948a2.37 2.37 0 0 0-4.736 0v.948H7.74a.95.95 0 0 0-.948.947v4.737a.95.95 0 0 0 .948.947h5.684a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.947M10.582 32.4a.95.95 0 0 1-.947-.948.95.95 0 0 1 .947-.947.95.95 0 0 1 .947.947.95.95 0 0 1-.947.948m1.468-4.263H9.114v-.948a1.47 1.47 0 0 1 2.936 0z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSTractorEnablePending = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-tractor-enable-pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 39",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.542 27.446c.27 0 .49-.22.49-.49v-13.12a.49.49 0 0 0-.49-.49H4.45a.49.49 0 0 0-.49.49v13.12c0 .27.22.49.49.49z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M16.64 13.836v13.12a.1.1 0 0 1-.098.098H4.45a.1.1 0 0 1-.098-.098v-13.12c0-.054.044-.098.098-.098h12.092c.054 0 .098.044.098.098m.392 13.12c0 .27-.22.49-.49.49H4.45a.49.49 0 0 1-.49-.49v-13.12c0-.27.22-.49.49-.49h12.092c.27 0 .49.22.49.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M14.168 13.744c.27 0 .49-.22.49-.49V2.27a.49.49 0 0 0-.49-.49H6.824a.49.49 0 0 0-.49.49v10.984c0 .27.22.49.49.49z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.266 2.27v10.984a.1.1 0 0 1-.098.098H6.824a.1.1 0 0 1-.098-.098V2.27c0-.054.044-.098.098-.098h7.344c.054 0 .098.044.098.098m.392 10.984c0 .27-.22.49-.49.49H6.824a.49.49 0 0 1-.49-.49V2.27c0-.27.22-.49.49-.49h7.344c.27 0 .49.22.49.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M5.179 8.313c.638 0 1.155-.517 1.155-1.155V1.951a1.155 1.155 0 0 0-2.31 0v5.207c0 .638.517 1.155 1.155 1.155M15.814 8.313c.638 0 1.155-.517 1.155-1.155V1.951a1.155 1.155 0 1 0-2.31 0v5.207c0 .638.517 1.155 1.155 1.155M10.496 18.339a2.057 2.057 0 1 0 0 4.114 2.057 2.057 0 0 0 0-4.114M1.98 29.215c1.093 0 1.98-.962 1.98-2.15V14.049c0-1.187-.887-2.15-1.98-2.15-1.094 0-1.98.963-1.98 2.15v13.018c0 1.187.886 2.15 1.98 2.15M19.02 29.215c1.093 0 1.98-.962 1.98-2.15V14.049c0-1.187-.887-2.15-1.98-2.15-1.094 0-1.98.963-1.98 2.15v13.018c0 1.187.886 2.15 1.98 2.15"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#CFDEF2",
          fillRule: "evenodd",
          stroke: "#F5B7B1",
          d: "M10.5 38.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#8AB9F7",
          fillRule: "evenodd",
          d: "M1.5 29.795a9 9 0 1 1 18.001.002A9 9 0 0 1 1.5 29.795m9-8.052a8.053 8.053 0 1 0 .001 16.106 8.053 8.053 0 0 0-.001-16.106",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1774F0",
          fillRule: "evenodd",
          d: "M10.582 32.164a.95.95 0 0 0 .947-.948.95.95 0 0 0-.947-.947.95.95 0 0 0-.947.948.95.95 0 0 0 .947.947m2.842-4.263h-.474v-.948a2.37 2.37 0 0 0-4.736 0h.9a1.47 1.47 0 0 1 2.936 0v.948H7.74a.95.95 0 0 0-.948.947v4.737a.95.95 0 0 0 .948.947h5.684a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.947m0 5.684H7.74v-4.737h5.684z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSTractorNoSignal = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-tractor-no-signal",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 39",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.542 27.446c.27 0 .49-.22.49-.49v-13.12a.49.49 0 0 0-.49-.49H4.45a.49.49 0 0 0-.49.49v13.12c0 .27.22.49.49.49z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M16.64 13.836v13.12a.1.1 0 0 1-.098.098H4.45a.1.1 0 0 1-.098-.098v-13.12c0-.054.044-.098.098-.098h12.092c.054 0 .098.044.098.098m.392 13.12c0 .27-.22.49-.49.49H4.45a.49.49 0 0 1-.49-.49v-13.12c0-.27.22-.49.49-.49h12.092c.27 0 .49.22.49.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M14.168 13.744c.27 0 .49-.22.49-.49V2.27a.49.49 0 0 0-.49-.49H6.824a.49.49 0 0 0-.49.49v10.984c0 .27.22.49.49.49z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.266 2.27v10.984a.1.1 0 0 1-.098.098H6.824a.1.1 0 0 1-.098-.098V2.27c0-.054.044-.098.098-.098h7.344c.054 0 .098.044.098.098m.392 10.984c0 .27-.22.49-.49.49H6.824a.49.49 0 0 1-.49-.49V2.27c0-.27.22-.49.49-.49h7.344c.27 0 .49.22.49.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M5.179 8.313c.638 0 1.155-.517 1.155-1.155V1.951a1.155 1.155 0 0 0-2.31 0v5.207c0 .638.517 1.155 1.155 1.155M15.814 8.313c.638 0 1.155-.517 1.155-1.155V1.951a1.155 1.155 0 1 0-2.31 0v5.207c0 .638.517 1.155 1.155 1.155M10.496 18.339a2.057 2.057 0 1 0 0 4.114 2.057 2.057 0 0 0 0-4.114M1.98 29.215c1.093 0 1.98-.962 1.98-2.15V14.049c0-1.187-.887-2.15-1.98-2.15-1.094 0-1.98.963-1.98 2.15v13.018c0 1.187.886 2.15 1.98 2.15M19.02 29.215c1.093 0 1.98-.962 1.98-2.15V14.049c0-1.187-.887-2.15-1.98-2.15-1.094 0-1.98.963-1.98 2.15v13.018c0 1.187.886 2.15 1.98 2.15"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M9.8 21.58a.99.99 0 0 1 1.4 0l7.515 7.515a.99.99 0 0 1 0 1.4L11.2 38.01a.99.99 0 0 1-1.401 0l-7.515-7.514a.99.99 0 0 1 0-1.401z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#9DA9B6",
          fillRule: "evenodd",
          d: "M9.45 21.23c.58-.58 1.52-.58 2.1 0l7.515 7.515c.58.58.58 1.52 0 2.101L11.55 38.36c-.58.58-1.521.58-2.102 0l-7.514-7.514a1.486 1.486 0 0 1 0-2.101zm1.4.701a.495.495 0 0 0-.7 0l-7.514 7.514a.495.495 0 0 0 0 .7l7.514 7.515a.495.495 0 0 0 .7 0l7.514-7.514a.495.495 0 0 0 0-.7z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          d: "M13.637 26.156a.386.386 0 0 0-.659-.273l-2.542 2.542 3.2 3.201zm.17 6.73-6.095-6.094a.384.384 0 1 0-.543.543l2.18 2.18-2.758 2.758a.385.385 0 0 0 .27.66h5.901l.497.496c.15.15.393.15.543 0a.38.38 0 0 0 .004-.543"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M5.547 24.843h9.245v9.245H5.547z" }) }) })
    ]
  }
);
const VehicleSTractorOff = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-tractor-off",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 39",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.542 27.446c.27 0 .49-.22.49-.49v-13.12a.49.49 0 0 0-.49-.49H4.45a.49.49 0 0 0-.49.49v13.12c0 .27.22.49.49.49z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M16.64 13.836v13.12a.1.1 0 0 1-.098.098H4.45a.1.1 0 0 1-.098-.098v-13.12c0-.054.044-.098.098-.098h12.092c.054 0 .098.044.098.098m.392 13.12c0 .27-.22.49-.49.49H4.45a.49.49 0 0 1-.49-.49v-13.12c0-.27.22-.49.49-.49h12.092c.27 0 .49.22.49.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M14.168 13.744c.27 0 .49-.22.49-.49V2.27a.49.49 0 0 0-.49-.49H6.824a.49.49 0 0 0-.49.49v10.984c0 .27.22.49.49.49z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.266 2.27v10.984a.1.1 0 0 1-.098.098H6.824a.1.1 0 0 1-.098-.098V2.27c0-.054.044-.098.098-.098h7.344c.054 0 .098.044.098.098m.392 10.984c0 .27-.22.49-.49.49H6.824a.49.49 0 0 1-.49-.49V2.27c0-.27.22-.49.49-.49h7.344c.27 0 .49.22.49.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M5.179 8.313c.638 0 1.155-.517 1.155-1.155V1.951a1.155 1.155 0 0 0-2.31 0v5.207c0 .638.517 1.155 1.155 1.155M15.814 8.313c.638 0 1.155-.517 1.155-1.155V1.951a1.155 1.155 0 1 0-2.31 0v5.207c0 .638.517 1.155 1.155 1.155M10.496 18.339a2.057 2.057 0 1 0 0 4.114 2.057 2.057 0 0 0 0-4.114M1.98 29.215c1.093 0 1.98-.962 1.98-2.15V14.049c0-1.187-.887-2.15-1.98-2.15-1.094 0-1.98.963-1.98 2.15v13.018c0 1.187.886 2.15 1.98 2.15M19.02 29.215c1.093 0 1.98-.962 1.98-2.15V14.049c0-1.187-.887-2.15-1.98-2.15-1.094 0-1.98.963-1.98 2.15v13.018c0 1.187.886 2.15 1.98 2.15"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M10.5 38.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M1.5 29.795a9 9 0 1 1 18.001.002A9 9 0 0 1 1.5 29.795m9-8.052a8.053 8.053 0 1 0 .001 16.106 8.053 8.053 0 0 0-.001-16.106",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M6.972 29.796a3.528 3.528 0 1 0 7.056 0 3.528 3.528 0 0 0-7.056 0m-.893 0a4.421 4.421 0 1 0 8.842 0 4.421 4.421 0 0 0-8.842 0m2.615-.301a.55.55 0 0 0-.11.35q0 .209.11.35a.33.33 0 0 0 .273.14h3.066q.162 0 .273-.14a.55.55 0 0 0 .11-.35.55.55 0 0 0-.11-.35.33.33 0 0 0-.273-.142H8.967q-.163 0-.273.142",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSTractorOn = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-tractor-on",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 39",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.542 27.446c.27 0 .49-.22.49-.49v-13.12a.49.49 0 0 0-.49-.49H4.45a.49.49 0 0 0-.49.49v13.12c0 .27.22.49.49.49z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M16.64 13.836v13.12a.1.1 0 0 1-.098.098H4.45a.1.1 0 0 1-.098-.098v-13.12c0-.054.044-.098.098-.098h12.092c.054 0 .098.044.098.098m.392 13.12c0 .27-.22.49-.49.49H4.45a.49.49 0 0 1-.49-.49v-13.12c0-.27.22-.49.49-.49h12.092c.27 0 .49.22.49.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M14.168 13.744c.27 0 .49-.22.49-.49V2.27a.49.49 0 0 0-.49-.49H6.824a.49.49 0 0 0-.49.49v10.984c0 .27.22.49.49.49z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.266 2.27v10.984a.1.1 0 0 1-.098.098H6.824a.1.1 0 0 1-.098-.098V2.27c0-.054.044-.098.098-.098h7.344c.054 0 .098.044.098.098m.392 10.984c0 .27-.22.49-.49.49H6.824a.49.49 0 0 1-.49-.49V2.27c0-.27.22-.49.49-.49h7.344c.27 0 .49.22.49.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M5.179 8.313c.638 0 1.155-.517 1.155-1.155V1.951a1.155 1.155 0 0 0-2.31 0v5.207c0 .638.517 1.155 1.155 1.155M15.814 8.313c.638 0 1.155-.517 1.155-1.155V1.951a1.155 1.155 0 1 0-2.31 0v5.207c0 .638.517 1.155 1.155 1.155M10.496 18.339a2.057 2.057 0 1 0 0 4.114 2.057 2.057 0 0 0 0-4.114M1.98 29.215c1.093 0 1.98-.962 1.98-2.15V14.049c0-1.187-.887-2.15-1.98-2.15-1.094 0-1.98.963-1.98 2.15v13.018c0 1.187.886 2.15 1.98 2.15M19.02 29.215c1.093 0 1.98-.962 1.98-2.15V14.049c0-1.187-.887-2.15-1.98-2.15-1.094 0-1.98.963-1.98 2.15v13.018c0 1.187.886 2.15 1.98 2.15"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#03D8A9",
          fillRule: "evenodd",
          d: "M10.5 38.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M1.5 29.795a9 9 0 1 1 18.001.002A9 9 0 0 1 1.5 29.795m9-8.052a8.053 8.053 0 1 0 .001 16.106 8.053 8.053 0 0 0-.001-16.106",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M10.5 30.286a.48.48 0 0 1-.35-.14.48.48 0 0 1-.142-.35v-3.93q0-.21.142-.35a.48.48 0 0 1 .35-.142q.208 0 .35.141.14.141.14.35v3.93q0 .21-.14.35a.48.48 0 0 1-.35.141m0 3.93q-.921 0-1.726-.35a4.5 4.5 0 0 1-1.4-.946 4.5 4.5 0 0 1-.945-1.4 4.3 4.3 0 0 1-.35-1.725q0-.847.307-1.621.306-.773.884-1.4a.45.45 0 0 1 .344-.147q.209 0 .356.147a.42.42 0 0 1 .123.338.6.6 0 0 1-.148.362q-.429.479-.657 1.075a3.5 3.5 0 0 0-.227 1.246q0 1.436 1 2.438 1.001 1 2.439 1 1.437 0 2.437-1 1.001-1 1.001-2.438 0-.65-.233-1.259a3.5 3.5 0 0 0-.663-1.087.52.52 0 0 1-.142-.343.43.43 0 0 1 .13-.332.49.49 0 0 1 .356-.147q.208 0 .344.147.576.627.884 1.4.307.774.307 1.621 0 .922-.35 1.725a4.5 4.5 0 0 1-.946 1.4 4.5 4.5 0 0 1-1.4.946 4.3 4.3 0 0 1-1.725.35"
        }
      )
    ]
  }
);
const VehicleSTractorUnavailable = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-tractor-unavailable",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 39",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.542 27.437c.27 0 .49-.22.49-.49V13.83a.49.49 0 0 0-.49-.49H4.45a.49.49 0 0 0-.49.49v13.117c0 .27.22.49.49.49z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M16.64 13.83v13.117a.1.1 0 0 1-.098.098H4.45a.1.1 0 0 1-.098-.098V13.83c0-.054.044-.098.098-.098h12.092c.054 0 .098.044.098.098m.392 13.117c0 .27-.22.49-.49.49H4.45a.49.49 0 0 1-.49-.49V13.83c0-.271.22-.49.49-.49h12.092c.27 0 .49.219.49.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M14.168 13.738c.27 0 .49-.22.49-.49V2.267a.49.49 0 0 0-.49-.49H6.824a.49.49 0 0 0-.49.49v10.98c0 .271.22.49.49.49z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.266 2.267v10.98a.1.1 0 0 1-.098.098H6.824a.1.1 0 0 1-.098-.098V2.268c0-.055.044-.099.098-.099h7.344c.054 0 .098.044.098.099m.392 10.98c0 .271-.22.49-.49.49H6.824a.49.49 0 0 1-.49-.49V2.268c0-.271.22-.49.49-.49h7.344c.27 0 .49.219.49.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M5.179 8.308c.638 0 1.155-.517 1.155-1.155V1.947a1.155 1.155 0 0 0-2.31 0v5.206c0 .638.517 1.155 1.155 1.155M15.814 8.308c.638 0 1.155-.517 1.155-1.155V1.947a1.155 1.155 0 0 0-2.31 0v5.206c0 .638.517 1.155 1.155 1.155M10.496 18.33a2.057 2.057 0 1 0 0 4.114 2.057 2.057 0 0 0 0-4.114M1.98 29.206c1.093 0 1.98-.963 1.98-2.15V14.042c0-1.187-.887-2.149-1.98-2.149-1.094 0-1.98.963-1.98 2.15v13.015c0 1.186.886 2.149 1.98 2.149M19.02 29.206c1.093 0 1.98-.963 1.98-2.15V14.042c0-1.187-.887-2.149-1.98-2.149-1.094 0-1.98.963-1.98 2.15v13.015c0 1.186.886 2.149 1.98 2.149"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          d: "M3.036 22.823h14.928c.78 0 1.273.837.894 1.519l-7.464 13.413c-.39.7-1.398.7-1.788 0L2.143 24.342c-.38-.682.113-1.52.893-1.52"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M11.84 38.003a1.534 1.534 0 0 1-2.68 0L1.696 24.59a1.533 1.533 0 0 1 1.34-2.28h14.928c1.17 0 1.91 1.258 1.34 2.28zm-1.787-.497c.195.35.699.35.894 0l7.464-13.413a.51.51 0 0 0-.447-.76H3.036a.51.51 0 0 0-.447.76z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M10.5 33.327a.76.76 0 0 1-.569-.246.82.82 0 0 1-.236-.59.82.82 0 0 1 .236-.589.76.76 0 0 1 .57-.245q.33 0 .568.245a.82.82 0 0 1 .236.59q0 .344-.236.59a.76.76 0 0 1-.569.245m0-2.505a.76.76 0 0 1-.569-.245.82.82 0 0 1-.236-.59v-3.34q0-.344.236-.59a.76.76 0 0 1 .57-.244q.33 0 .568.245.236.245.236.59v3.34q0 .343-.236.589a.76.76 0 0 1-.569.245"
        }
      )
    ]
  }
);
const VehicleSTractorUnplugged = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-tractor-unplugged",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 39",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.542 27.438c.27 0 .49-.22.49-.49v-13.12a.49.49 0 0 0-.49-.49H4.45a.49.49 0 0 0-.49.49v13.12c0 .27.22.49.49.49z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M16.64 13.828v13.12a.1.1 0 0 1-.098.098H4.45a.1.1 0 0 1-.098-.098v-13.12c0-.054.044-.098.098-.098h12.092c.054 0 .098.044.098.098m.392 13.12c0 .27-.22.49-.49.49H4.45a.49.49 0 0 1-.49-.49v-13.12c0-.271.22-.49.49-.49h12.092c.27 0 .49.219.49.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M14.168 13.736c.27 0 .49-.22.49-.49V2.261a.49.49 0 0 0-.49-.49H6.824a.49.49 0 0 0-.49.49v10.983c0 .271.22.49.49.49z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.266 2.262v10.983a.1.1 0 0 1-.098.099H6.824a.1.1 0 0 1-.098-.099V2.262c0-.054.044-.098.098-.098h7.344c.054 0 .098.044.098.098m.392 10.983c0 .271-.22.49-.49.49H6.824a.49.49 0 0 1-.49-.49V2.262c0-.27.22-.49.49-.49h7.344c.27 0 .49.22.49.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M5.179 8.305c.638 0 1.155-.517 1.155-1.155V1.942a1.155 1.155 0 0 0-2.31 0V7.15c0 .638.517 1.155 1.155 1.155M15.814 8.305c.638 0 1.155-.517 1.155-1.155V1.942a1.155 1.155 0 1 0-2.31 0V7.15c0 .638.517 1.155 1.155 1.155M10.496 18.33a2.057 2.057 0 1 0 0 4.114 2.057 2.057 0 0 0 0-4.114M1.98 29.207c1.093 0 1.98-.962 1.98-2.15V14.04c0-1.187-.887-2.15-1.98-2.15-1.094 0-1.98.962-1.98 2.15v13.018c0 1.187.886 2.149 1.98 2.149M19.02 29.207c1.093 0 1.98-.962 1.98-2.15V14.04c0-1.187-.887-2.15-1.98-2.15-1.094 0-1.98.962-1.98 2.15v13.018c0 1.187.886 2.149 1.98 2.149"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          d: "M3.036 22.818h14.928c.78 0 1.273.838.894 1.52l-7.464 13.416c-.39.7-1.398.7-1.788 0L2.143 24.338c-.38-.682.113-1.52.893-1.52"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M11.84 38.002a1.534 1.534 0 0 1-2.68 0L1.696 24.586a1.534 1.534 0 0 1 1.34-2.28h14.928c1.17 0 1.91 1.258 1.34 2.28zm-1.787-.497c.195.35.699.35.894 0L18.41 24.09a.51.51 0 0 0-.447-.76H3.036c-.39 0-.636.42-.447.76z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M12.002 26.109c0-.166-.128-.3-.285-.3a.29.29 0 0 0-.285.3v1.96H9.567v-1.96c0-.166-.127-.3-.284-.3a.293.293 0 0 0-.285.3v1.96h-.645v1.203c.003 1.07.72 1.99 1.717 2.202v1.85h.86v-1.85c.996-.213 1.714-1.132 1.717-2.202v-1.207h-.645z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M6.205 25.273h8.59v8.589h-8.59z" }) }) })
    ]
  }
);
const VehicleSTractor = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-tractor",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 29",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M16.542 27.027c.27 0 .49-.22.49-.49v-13.12a.49.49 0 0 0-.49-.49H4.45a.49.49 0 0 0-.49.49v13.12c0 .27.22.49.49.49z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M16.64 13.417v13.12a.1.1 0 0 1-.098.098H4.45a.1.1 0 0 1-.098-.099v-13.12c0-.053.044-.097.098-.097h12.092c.054 0 .098.043.098.098m.392 13.12c0 .27-.22.49-.49.49H4.45a.49.49 0 0 1-.49-.49v-13.12c0-.271.22-.49.49-.49h12.092c.27 0 .49.219.49.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M14.168 13.325c.27 0 .49-.22.49-.49V1.85a.49.49 0 0 0-.49-.49H6.824a.49.49 0 0 0-.49.49v10.983c0 .271.22.49.49.49z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M14.266 1.851v10.983a.1.1 0 0 1-.098.098H6.824a.1.1 0 0 1-.098-.098V1.851c0-.054.044-.098.098-.098h7.344c.054 0 .098.044.098.098m.392 10.983c0 .271-.22.49-.49.49H6.824a.49.49 0 0 1-.49-.49V1.851c0-.27.22-.49.49-.49h7.344c.27 0 .49.22.49.49z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M5.179 7.894c.638 0 1.155-.517 1.155-1.155V1.531a1.155 1.155 0 1 0-2.31 0V6.74c0 .638.517 1.155 1.155 1.155M15.814 7.894c.638 0 1.155-.517 1.155-1.155V1.531a1.155 1.155 0 1 0-2.31 0V6.74c0 .638.517 1.155 1.155 1.155M10.496 17.919a2.057 2.057 0 1 0 0 4.114 2.057 2.057 0 0 0 0-4.114M1.98 28.796c1.093 0 1.98-.962 1.98-2.15V13.63c0-1.188-.887-2.15-1.98-2.15-1.094 0-1.98.962-1.98 2.15v13.018c0 1.187.886 2.149 1.98 2.149M19.02 28.796c1.093 0 1.98-.962 1.98-2.15V13.63c0-1.188-.887-2.15-1.98-2.15-1.094 0-1.98.962-1.98 2.15v13.018c0 1.187.886 2.149 1.98 2.149"
        }
      )
    ]
  }
);
const VehicleSTruckDisablePending = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-truck-disable-pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 66",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M10 0c2.313 0 4.533.925 6.647 2.753.455.394.716.968.716 1.573v3.47l.806.368c.411.188.713.536.825.954.034.134-.09.255-.234.228l-1.397-.263v7.65c0 .92-.541 1.728-1.34 2.09v1.527H3.977v-1.527a2.29 2.29 0 0 1-1.342-2.09v-7.65l-1.396.263c-.143.028-.268-.094-.234-.23a1.48 1.48 0 0 1 .825-.952l.805-.368v-3.47c0-.605.262-1.179.718-1.573C5.468.925 7.688 0 10 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M10 .55q1.804 0 3.537.802a.2.2 0 0 0 .07.128l1.577 1.41c.13.115.34.04.357-.128l.035-.171q.36.271.715.58c.335.289.527.71.527 1.155v12.407c0 .827-.573 1.52-1.341 1.696v1.37H4.523v-1.37a1.74 1.74 0 0 1-1.341-1.696V4.326c0-.444.192-.866.527-1.155q.356-.31.716-.581l.034.172c.018.168.228.244.358.128l1.577-1.41a.2.2 0 0 0 .07-.128Q8.197.55 10 .55M5.395 14.3h-.91c-.05 0-.09.044-.09.1v2c0 .077.077.126.137.085l.91-.6a.1.1 0 0 0 .043-.085v-1.4c0-.055-.04-.1-.09-.1m10.18 0h-.91c-.05 0-.09.044-.09.1v1.4c0 .035.016.067.044.085l.909.6c.06.04.138-.008.138-.085v-2c0-.055-.041-.1-.091-.1M4.568 8.863c-.04-.106-.173-.071-.173.044v4.736c0 .058.04.107.09.107h.91c.05 0 .09-.049.09-.108v-2.367l-.008-.044zm10.924 0-.909 2.367-.008.045v2.367c0 .06.04.108.09.108h.91c.05 0 .09-.049.09-.108V8.908c0-.116-.133-.15-.173-.045M10.107 7.15q-2.382 0-4.945.553l-.047.013a.44.44 0 0 0-.275.557l.833 1.876c.06.18.225.3.412.3h7.828a.43.43 0 0 0 .411-.3l.835-1.884.012-.041a.44.44 0 0 0-.327-.527 21 21 0 0 0-4.737-.547",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M4.491 18.425H15.51v1.65H4.491z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          d: "M15.956 19.8H4.044a.866.866 0 0 0-.862.87v33.46c0 .48.386.87.862.87h11.912c.476 0 .862-.39.862-.87V20.67c0-.48-.386-.87-.863-.87"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M5.025 21.45c.113 0 .205.093.205.207v31.486a.207.207 0 0 1-.205.207.207.207 0 0 1-.207-.207V21.658c0-.115.093-.208.207-.208m4.636 0c.113 0 .205.093.205.207v31.486a.207.207 0 0 1-.205.207.207.207 0 0 1-.206-.207V21.658c0-.115.092-.208.206-.208m4.636 0c.114 0 .206.093.206.207v31.486a.207.207 0 0 1-.206.207.207.207 0 0 1-.206-.207V21.658c0-.115.093-.208.206-.208",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#DDE5ED",
          fillRule: "evenodd",
          d: "M6.147 16.5h7.706c.142 0 .279.056.38.155l.404.395H5.365l.403-.395a.54.54 0 0 1 .38-.155M5.368 6.47l1.169-4.19c.013-.047.06-.08.113-.08h.234c.078 0 .134.068.111.135l-1.401 4.19c-.044.13-.262.077-.226-.055M14.438 6.47 13.27 2.28c-.013-.047-.06-.08-.114-.08h-.233c-.078 0-.134.068-.112.135l1.402 4.19c.043.13.262.077.225-.055",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCF0DE",
          fillRule: "evenodd",
          stroke: "#F9D199",
          d: "M10 64.526a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F9D199",
          fillRule: "evenodd",
          d: "M1 56a9 9 0 1 1 18.001.001A9 9 0 0 1 1 56m9-8.053a8.053 8.053 0 1 0 .001 16.107A8.053 8.053 0 0 0 10 47.947",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          fillRule: "evenodd",
          d: "M12.924 54.342h-.474v-.947a2.37 2.37 0 0 0-4.737 0v.947h-.474a.95.95 0 0 0-.947.947v4.737a.95.95 0 0 0 .947.948h5.685a.95.95 0 0 0 .947-.948V55.29a.95.95 0 0 0-.947-.947m-2.842 4.263a.95.95 0 0 1-.948-.947.95.95 0 0 1 .947-.947.95.95 0 0 1 .948.947.95.95 0 0 1-.947.947m1.468-4.263H8.613v-.947a1.47 1.47 0 0 1 2.937 0z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSTruckDisabled = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-truck-disabled",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 66",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M10 0c2.313 0 4.533.925 6.647 2.753.455.394.716.968.716 1.573v3.47l.806.368c.411.188.713.536.825.954.034.134-.09.255-.234.228l-1.397-.263v7.65c0 .92-.541 1.728-1.34 2.09v1.527H3.977v-1.527a2.29 2.29 0 0 1-1.342-2.09v-7.65l-1.396.263c-.143.028-.268-.094-.234-.23a1.48 1.48 0 0 1 .825-.952l.805-.368v-3.47c0-.605.262-1.179.718-1.573C5.468.925 7.688 0 10 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M10 .55q1.804 0 3.537.802a.2.2 0 0 0 .07.128l1.577 1.41c.13.115.34.04.357-.128l.035-.171q.36.271.715.58c.335.289.527.71.527 1.155v12.407c0 .827-.573 1.52-1.341 1.696v1.37H4.523v-1.37a1.74 1.74 0 0 1-1.341-1.696V4.326c0-.444.192-.866.527-1.155q.356-.31.716-.581l.034.172c.018.168.228.244.358.128l1.577-1.41a.2.2 0 0 0 .07-.128Q8.197.55 10 .55M5.395 14.3h-.91c-.05 0-.09.044-.09.1v2c0 .077.077.126.137.085l.91-.6a.1.1 0 0 0 .043-.085v-1.4c0-.055-.04-.1-.09-.1m10.18 0h-.91c-.05 0-.09.044-.09.1v1.4c0 .035.016.067.044.085l.909.6c.06.04.138-.008.138-.085v-2c0-.055-.041-.1-.091-.1M4.568 8.863c-.04-.106-.173-.071-.173.044v4.736c0 .058.04.107.09.107h.91c.05 0 .09-.049.09-.108v-2.367l-.008-.044zm10.924 0-.909 2.367-.008.045v2.367c0 .06.04.108.09.108h.91c.05 0 .09-.049.09-.108V8.908c0-.116-.133-.15-.173-.045M10.107 7.15q-2.382 0-4.945.553l-.047.013a.44.44 0 0 0-.275.557l.833 1.876c.06.18.225.3.412.3h7.828a.43.43 0 0 0 .411-.3l.835-1.884.012-.041a.44.44 0 0 0-.327-.527 21 21 0 0 0-4.737-.547",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M4.491 18.425H15.51v1.65H4.491z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          d: "M15.956 19.8H4.044a.866.866 0 0 0-.862.87v33.46c0 .48.386.87.862.87h11.912c.476 0 .862-.39.862-.87V20.67c0-.48-.386-.87-.863-.87"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M5.025 21.45c.113 0 .205.093.205.207v31.486a.207.207 0 0 1-.205.207.207.207 0 0 1-.207-.207V21.658c0-.115.093-.208.207-.208m4.636 0c.113 0 .205.093.205.207v31.486a.207.207 0 0 1-.205.207.207.207 0 0 1-.206-.207V21.658c0-.115.092-.208.206-.208m4.636 0c.114 0 .206.093.206.207v31.486a.207.207 0 0 1-.206.207.207.207 0 0 1-.206-.207V21.658c0-.115.093-.208.206-.208",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#DDE5ED",
          fillRule: "evenodd",
          d: "M6.147 16.5h7.706c.142 0 .279.056.38.155l.404.395H5.365l.403-.395a.54.54 0 0 1 .38-.155M5.368 6.47l1.169-4.19c.013-.047.06-.08.113-.08h.234c.078 0 .134.068.111.135l-1.401 4.19c-.044.13-.262.077-.226-.055M14.438 6.47 13.27 2.28c-.013-.047-.06-.08-.114-.08h-.233c-.078 0-.134.068-.112.135l1.402 4.19c.043.13.262.077.225-.055",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCEDEB",
          fillRule: "evenodd",
          stroke: "#F5B7B1",
          d: "M10 64.526a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F5B7B1",
          fillRule: "evenodd",
          d: "M1 56a9 9 0 1 1 18.001.001A9 9 0 0 1 1 56m9-8.053a8.053 8.053 0 1 0 .001 16.107A8.053 8.053 0 0 0 10 47.947",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          fillRule: "evenodd",
          d: "M12.924 54.342h-.474v-.947a2.37 2.37 0 0 0-4.737 0v.947h-.474a.95.95 0 0 0-.947.947v4.737a.95.95 0 0 0 .947.948h5.685a.95.95 0 0 0 .947-.948V55.29a.95.95 0 0 0-.947-.947m-2.842 4.263a.95.95 0 0 1-.948-.947.95.95 0 0 1 .947-.947.95.95 0 0 1 .948.947.95.95 0 0 1-.947.947m1.468-4.263H8.613v-.947a1.47 1.47 0 0 1 2.937 0z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSTruckEnablePending = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-truck-enable-pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 66",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M10 0c2.313 0 4.533.925 6.647 2.753.455.394.716.968.716 1.573v3.47l.806.368c.411.188.713.536.825.954.034.134-.09.255-.234.228l-1.397-.263v7.65c0 .92-.541 1.728-1.34 2.09v1.527H3.977v-1.527a2.29 2.29 0 0 1-1.342-2.09v-7.65l-1.396.263c-.143.028-.268-.094-.234-.23a1.48 1.48 0 0 1 .825-.952l.805-.368v-3.47c0-.605.262-1.179.718-1.573C5.468.925 7.688 0 10 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M10 .55q1.804 0 3.537.802a.2.2 0 0 0 .07.128l1.577 1.41c.13.115.34.04.357-.128l.035-.171q.36.271.715.58c.335.289.527.71.527 1.155v12.407c0 .827-.573 1.52-1.341 1.696v1.37H4.523v-1.37a1.74 1.74 0 0 1-1.341-1.696V4.326c0-.444.192-.866.527-1.155q.356-.31.716-.581l.034.172c.018.168.228.244.358.128l1.577-1.41a.2.2 0 0 0 .07-.128Q8.197.55 10 .55M5.395 14.3h-.91c-.05 0-.09.044-.09.1v2c0 .077.077.126.137.085l.91-.6a.1.1 0 0 0 .043-.085v-1.4c0-.055-.04-.1-.09-.1m10.18 0h-.91c-.05 0-.09.044-.09.1v1.4c0 .035.016.067.044.085l.909.6c.06.04.138-.008.138-.085v-2c0-.055-.041-.1-.091-.1M4.568 8.863c-.04-.106-.173-.071-.173.044v4.736c0 .058.04.107.09.107h.91c.05 0 .09-.049.09-.108v-2.367l-.008-.044zm10.924 0-.909 2.367-.008.045v2.367c0 .06.04.108.09.108h.91c.05 0 .09-.049.09-.108V8.908c0-.116-.133-.15-.173-.045M10.107 7.15q-2.382 0-4.945.553l-.047.013a.44.44 0 0 0-.275.557l.833 1.876c.06.18.225.3.412.3h7.828a.43.43 0 0 0 .411-.3l.835-1.884.012-.041a.44.44 0 0 0-.327-.527 21 21 0 0 0-4.737-.547",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M4.491 18.425H15.51v1.65H4.491z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          d: "M15.956 19.8H4.044a.866.866 0 0 0-.862.87v33.46c0 .48.386.87.862.87h11.912c.476 0 .862-.39.862-.87V20.67c0-.48-.386-.87-.863-.87"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M5.025 21.45c.113 0 .205.093.205.207v31.486a.207.207 0 0 1-.205.207.207.207 0 0 1-.207-.207V21.658c0-.115.093-.208.207-.208m4.636 0c.113 0 .205.093.205.207v31.486a.207.207 0 0 1-.205.207.207.207 0 0 1-.206-.207V21.658c0-.115.092-.208.206-.208m4.636 0c.114 0 .206.093.206.207v31.486a.207.207 0 0 1-.206.207.207.207 0 0 1-.206-.207V21.658c0-.115.093-.208.206-.208",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#DDE5ED",
          fillRule: "evenodd",
          d: "M6.147 16.5h7.706c.142 0 .279.056.38.155l.404.395H5.365l.403-.395a.54.54 0 0 1 .38-.155M5.368 6.47l1.169-4.19c.013-.047.06-.08.113-.08h.234c.078 0 .134.068.111.135l-1.401 4.19c-.044.13-.262.077-.226-.055M14.438 6.47 13.27 2.28c-.013-.047-.06-.08-.114-.08h-.233c-.078 0-.134.068-.112.135l1.402 4.19c.043.13.262.077.225-.055",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#CFDEF2",
          fillRule: "evenodd",
          stroke: "#F5B7B1",
          d: "M10 64.526a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#8AB9F7",
          fillRule: "evenodd",
          d: "M1 56a9 9 0 1 1 18.001.001A9 9 0 0 1 1 56m9-8.053a8.053 8.053 0 1 0 .001 16.107A8.053 8.053 0 0 0 10 47.947",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1774F0",
          fillRule: "evenodd",
          d: "M10.082 58.369a.95.95 0 0 0 .947-.948.95.95 0 0 0-.947-.947.95.95 0 0 0-.948.947.95.95 0 0 0 .947.947m2.842-4.264h-.474v-.947a2.37 2.37 0 0 0-4.737 0h.9a1.47 1.47 0 0 1 2.937 0v.947H7.24a.95.95 0 0 0-.948.948v4.737a.95.95 0 0 0 .947.947h5.685a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.948m0 5.685H7.239v-4.737h5.685z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSTruckNoSignal = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-truck-no-signal",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 65",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M9 0c2.313 0 4.533.925 6.647 2.753.455.394.716.968.716 1.573v3.47l.806.368c.411.188.713.536.825.954.034.134-.09.255-.234.228l-1.397-.263v7.65c0 .92-.541 1.728-1.34 2.09v1.527H2.977v-1.527a2.29 2.29 0 0 1-1.342-2.09v-7.65L.24 9.346c-.143.028-.268-.094-.234-.23a1.48 1.48 0 0 1 .825-.952l.805-.368v-3.47c0-.605.262-1.179.718-1.573C4.468.925 6.688 0 9 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M9 .55q1.804 0 3.537.802a.2.2 0 0 0 .07.128l1.577 1.41c.13.115.34.04.357-.128l.035-.171q.36.271.715.58c.335.289.527.71.527 1.155v12.407c0 .827-.573 1.52-1.341 1.696v1.37H3.523v-1.37a1.74 1.74 0 0 1-1.341-1.696V4.326c0-.444.192-.866.527-1.155q.356-.31.716-.581l.034.172c.018.168.228.244.358.128l1.577-1.41a.2.2 0 0 0 .07-.128Q7.197.55 9 .55M4.395 14.3h-.91c-.05 0-.09.044-.09.1v2c0 .077.077.126.137.085l.91-.6a.1.1 0 0 0 .043-.085v-1.4c0-.055-.04-.1-.09-.1m10.18 0h-.91c-.05 0-.09.044-.09.1v1.4c0 .035.016.067.044.085l.909.6c.06.04.138-.008.138-.085v-2c0-.055-.041-.1-.091-.1M3.568 8.863c-.04-.106-.173-.071-.173.044v4.736c0 .058.04.107.09.107h.91c.05 0 .09-.049.09-.108v-2.367l-.008-.044zm10.924 0-.909 2.367-.008.045v2.367c0 .06.04.108.09.108h.91c.05 0 .09-.049.09-.108V8.908c0-.116-.133-.15-.173-.045M9.107 7.15q-2.382 0-4.945.553l-.047.013a.44.44 0 0 0-.275.557l.833 1.876c.06.18.225.3.412.3h7.828a.43.43 0 0 0 .411-.3l.835-1.884.012-.041a.44.44 0 0 0-.327-.527 21 21 0 0 0-4.737-.547",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M3.491 18.425H14.51v1.65H3.491z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          d: "M14.956 19.8H3.044a.866.866 0 0 0-.862.87v33.46c0 .48.386.87.862.87h11.912c.476 0 .862-.39.862-.87V20.67c0-.48-.386-.87-.862-.87"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M4.025 21.45c.113 0 .205.093.205.207v31.486a.207.207 0 0 1-.205.207.207.207 0 0 1-.207-.207V21.658c0-.115.093-.208.207-.208m4.636 0c.113 0 .205.093.205.207v31.486a.207.207 0 0 1-.205.207.207.207 0 0 1-.206-.207V21.658c0-.115.092-.208.206-.208m4.636 0c.114 0 .206.093.206.207v31.486a.207.207 0 0 1-.206.207.207.207 0 0 1-.206-.207V21.658c0-.115.093-.208.206-.208",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#DDE5ED",
          fillRule: "evenodd",
          d: "M5.147 16.5h7.706c.142 0 .279.056.38.155l.404.395H4.365l.403-.395a.54.54 0 0 1 .38-.155M4.368 6.47l1.169-4.19c.013-.047.06-.08.113-.08h.234c.078 0 .134.068.111.135l-1.401 4.19c-.044.13-.262.077-.226-.055M13.438 6.47 12.27 2.28c-.013-.047-.06-.08-.114-.08h-.233c-.078 0-.134.068-.112.135l1.402 4.19c.043.13.262.077.225-.055",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M8.3 47.785a.99.99 0 0 1 1.4 0l7.514 7.514a.99.99 0 0 1 0 1.401L9.7 64.214a.99.99 0 0 1-1.4 0L.784 56.7a.99.99 0 0 1 0-1.4z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#9DA9B6",
          fillRule: "evenodd",
          d: "M7.95 47.435c.58-.58 1.52-.58 2.1 0l7.515 7.514c.58.58.58 1.521 0 2.102l-7.514 7.514c-.58.58-1.521.58-2.102 0L.435 57.05a1.486 1.486 0 0 1 0-2.102zm1.4.7a.495.495 0 0 0-.7 0L1.136 55.65a.495.495 0 0 0 0 .7l7.514 7.514a.495.495 0 0 0 .7 0l7.514-7.514a.495.495 0 0 0 0-.7z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          d: "M12.136 52.36a.386.386 0 0 0-.658-.273L8.935 54.63l3.201 3.201zm.17 6.73-6.094-6.094a.384.384 0 1 0-.543.544l2.18 2.18-2.758 2.758a.385.385 0 0 0 .27.659h5.9l.498.497c.15.15.393.15.543 0a.38.38 0 0 0 .004-.543"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M4.047 51.047h9.245v9.245H4.047z" }) }) })
    ]
  }
);
const VehicleSTruckOff = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-truck-off",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 65",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M9 0c2.313 0 4.533.925 6.647 2.753.455.394.716.968.716 1.573v3.47l.806.368c.411.188.713.536.825.954.034.134-.09.255-.234.228l-1.397-.263v7.65c0 .92-.541 1.728-1.34 2.09v1.527H2.977v-1.527a2.29 2.29 0 0 1-1.342-2.09v-7.65L.24 9.346c-.143.028-.268-.094-.234-.23a1.48 1.48 0 0 1 .825-.952l.805-.368v-3.47c0-.605.262-1.179.718-1.573C4.468.925 6.688 0 9 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M9 .55q1.804 0 3.537.802a.2.2 0 0 0 .07.128l1.577 1.41c.13.115.34.04.357-.128l.035-.171q.36.271.715.58c.335.289.527.71.527 1.155v12.407c0 .827-.573 1.52-1.341 1.696v1.37H3.523v-1.37a1.74 1.74 0 0 1-1.341-1.696V4.326c0-.444.192-.866.527-1.155q.356-.31.716-.581l.034.172c.018.168.228.244.358.128l1.577-1.41a.2.2 0 0 0 .07-.128Q7.197.55 9 .55M4.395 14.3h-.91c-.05 0-.09.044-.09.1v2c0 .077.077.126.137.085l.91-.6a.1.1 0 0 0 .043-.085v-1.4c0-.055-.04-.1-.09-.1m10.18 0h-.91c-.05 0-.09.044-.09.1v1.4c0 .035.016.067.044.085l.909.6c.06.04.138-.008.138-.085v-2c0-.055-.041-.1-.091-.1M3.568 8.863c-.04-.106-.173-.071-.173.044v4.736c0 .058.04.107.09.107h.91c.05 0 .09-.049.09-.108v-2.367l-.008-.044zm10.924 0-.909 2.367-.008.045v2.367c0 .06.04.108.09.108h.91c.05 0 .09-.049.09-.108V8.908c0-.116-.133-.15-.173-.045M9.107 7.15q-2.382 0-4.945.553l-.047.013a.44.44 0 0 0-.275.557l.833 1.876c.06.18.225.3.412.3h7.828a.43.43 0 0 0 .411-.3l.835-1.884.012-.041a.44.44 0 0 0-.327-.527 21 21 0 0 0-4.737-.547",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M3.491 18.425H14.51v1.65H3.491z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          d: "M14.956 19.8H3.044a.866.866 0 0 0-.862.87v33.46c0 .48.386.87.862.87h11.912c.476 0 .862-.39.862-.87V20.67c0-.48-.386-.87-.862-.87"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M4.025 21.45c.113 0 .205.093.205.207v31.486a.207.207 0 0 1-.205.207.207.207 0 0 1-.207-.207V21.658c0-.115.093-.208.207-.208m4.636 0c.113 0 .205.093.205.207v31.486a.207.207 0 0 1-.205.207.207.207 0 0 1-.206-.207V21.658c0-.115.092-.208.206-.208m4.636 0c.114 0 .206.093.206.207v31.486a.207.207 0 0 1-.206.207.207.207 0 0 1-.206-.207V21.658c0-.115.093-.208.206-.208",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#DDE5ED",
          fillRule: "evenodd",
          d: "M5.147 16.5h7.706c.142 0 .279.056.38.155l.404.395H4.365l.403-.395a.54.54 0 0 1 .38-.155M4.368 6.47l1.169-4.19c.013-.047.06-.08.113-.08h.234c.078 0 .134.068.111.135l-1.401 4.19c-.044.13-.262.077-.226-.055M13.438 6.47 12.27 2.28c-.013-.047-.06-.08-.114-.08h-.233c-.078 0-.134.068-.112.135l1.402 4.19c.043.13.262.077.225-.055",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M9 64.526a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M0 56a9 9 0 1 1 18.001.001A9 9 0 0 1 0 56m9-8.053a8.053 8.053 0 1 0 .001 16.107A8.053 8.053 0 0 0 9 47.947",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M5.472 56a3.528 3.528 0 1 0 7.056 0 3.528 3.528 0 0 0-7.056 0m-.893 0a4.421 4.421 0 1 0 8.842 0 4.421 4.421 0 0 0-8.842 0m2.615-.3a.55.55 0 0 0-.11.35q0 .208.11.35a.33.33 0 0 0 .273.14h3.066q.162 0 .273-.14a.55.55 0 0 0 .11-.35.55.55 0 0 0-.11-.35.33.33 0 0 0-.273-.142H7.467q-.163 0-.273.141",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSTruckOn = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-truck-on",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 65",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M9 0c2.313 0 4.533.925 6.647 2.753.455.394.716.968.716 1.573v3.47l.806.368c.411.188.713.536.825.954.034.134-.09.255-.234.228l-1.397-.263v7.65c0 .92-.541 1.728-1.34 2.09v1.527H2.977v-1.527a2.29 2.29 0 0 1-1.342-2.09v-7.65L.24 9.346c-.143.028-.268-.094-.234-.23a1.48 1.48 0 0 1 .825-.952l.805-.368v-3.47c0-.605.262-1.179.718-1.573C4.468.925 6.688 0 9 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M9 .55q1.804 0 3.537.802a.2.2 0 0 0 .07.128l1.577 1.41c.13.115.34.04.357-.128l.035-.171q.36.271.715.58c.335.289.527.71.527 1.155v12.407c0 .827-.573 1.52-1.341 1.696v1.37H3.523v-1.37a1.74 1.74 0 0 1-1.341-1.696V4.326c0-.444.192-.866.527-1.155q.356-.31.716-.581l.034.172c.018.168.228.244.358.128l1.577-1.41a.2.2 0 0 0 .07-.128Q7.197.55 9 .55M4.395 14.3h-.91c-.05 0-.09.044-.09.1v2c0 .077.077.126.137.085l.91-.6a.1.1 0 0 0 .043-.085v-1.4c0-.055-.04-.1-.09-.1m10.18 0h-.91c-.05 0-.09.044-.09.1v1.4c0 .035.016.067.044.085l.909.6c.06.04.138-.008.138-.085v-2c0-.055-.041-.1-.091-.1M3.568 8.863c-.04-.106-.173-.071-.173.044v4.736c0 .058.04.107.09.107h.91c.05 0 .09-.049.09-.108v-2.367l-.008-.044zm10.924 0-.909 2.367-.008.045v2.367c0 .06.04.108.09.108h.91c.05 0 .09-.049.09-.108V8.908c0-.116-.133-.15-.173-.045M9.107 7.15q-2.382 0-4.945.553l-.047.013a.44.44 0 0 0-.275.557l.833 1.876c.06.18.225.3.412.3h7.828a.43.43 0 0 0 .411-.3l.835-1.884.012-.041a.44.44 0 0 0-.327-.527 21 21 0 0 0-4.737-.547",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M3.491 18.425H14.51v1.65H3.491z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          d: "M14.956 19.8H3.044a.866.866 0 0 0-.862.87v33.46c0 .48.386.87.862.87h11.912c.476 0 .862-.39.862-.87V20.67c0-.48-.386-.87-.862-.87"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M4.025 21.45c.113 0 .205.093.205.207v31.486a.207.207 0 0 1-.205.207.207.207 0 0 1-.207-.207V21.658c0-.115.093-.208.207-.208m4.636 0c.113 0 .205.093.205.207v31.486a.207.207 0 0 1-.205.207.207.207 0 0 1-.206-.207V21.658c0-.115.092-.208.206-.208m4.636 0c.114 0 .206.093.206.207v31.486a.207.207 0 0 1-.206.207.207.207 0 0 1-.206-.207V21.658c0-.115.093-.208.206-.208",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#DDE5ED",
          fillRule: "evenodd",
          d: "M5.147 16.5h7.706c.142 0 .279.056.38.155l.404.395H4.365l.403-.395a.54.54 0 0 1 .38-.155M4.368 6.47l1.169-4.19c.013-.047.06-.08.113-.08h.234c.078 0 .134.068.111.135l-1.401 4.19c-.044.13-.262.077-.226-.055M13.438 6.47 12.27 2.28c-.013-.047-.06-.08-.114-.08h-.233c-.078 0-.134.068-.112.135l1.402 4.19c.043.13.262.077.225-.055",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#03D8A9",
          fillRule: "evenodd",
          d: "M9 64.526a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M0 56a9 9 0 1 1 18.001.001A9 9 0 0 1 0 56m9-8.053a8.053 8.053 0 1 0 .001 16.107A8.053 8.053 0 0 0 9 47.947",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M9 56.49a.48.48 0 0 1-.35-.14.48.48 0 0 1-.141-.35v-3.93q0-.21.141-.35a.48.48 0 0 1 .35-.141q.21 0 .35.14.141.143.141.35V56q0 .21-.14.35a.48.48 0 0 1-.35.142m0 3.93q-.921 0-1.725-.35a4.5 4.5 0 0 1-1.4-.945 4.5 4.5 0 0 1-.946-1.4A4.3 4.3 0 0 1 4.58 56q0-.848.307-1.621.308-.774.884-1.4a.45.45 0 0 1 .344-.148q.21 0 .356.148a.42.42 0 0 1 .123.337.6.6 0 0 1-.147.363q-.43.478-.657 1.074A3.5 3.5 0 0 0 5.562 56q0 1.437 1 2.437Q7.564 59.438 9 59.438t2.438-1q1-1.001 1-2.438 0-.651-.233-1.26a3.5 3.5 0 0 0-.663-1.086.52.52 0 0 1-.141-.344.43.43 0 0 1 .129-.331.49.49 0 0 1 .356-.148q.21 0 .344.148.578.626.884 1.4t.307 1.62q0 .922-.35 1.726a4.5 4.5 0 0 1-.945 1.4 4.5 4.5 0 0 1-1.4.946A4.3 4.3 0 0 1 9 60.42"
        }
      )
    ]
  }
);
const VehicleSTruckUnavailable = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-truck-unavailable",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 65",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M9 0c2.313 0 4.533.925 6.647 2.753.455.394.716.968.716 1.573v3.47l.806.368c.411.188.713.536.825.954.034.134-.09.255-.234.228l-1.397-.263v7.65c0 .92-.541 1.728-1.34 2.09v1.527H2.977v-1.527a2.29 2.29 0 0 1-1.342-2.09v-7.65L.24 9.346c-.143.028-.268-.094-.234-.23a1.48 1.48 0 0 1 .825-.952l.805-.368v-3.47c0-.605.262-1.179.718-1.573C4.468.925 6.688 0 9 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M9 .55q1.804 0 3.537.802a.2.2 0 0 0 .07.128l1.577 1.41c.13.115.34.04.357-.128l.035-.171q.36.271.715.58c.335.289.527.71.527 1.155v12.407c0 .827-.573 1.52-1.341 1.696v1.37H3.523v-1.37a1.74 1.74 0 0 1-1.341-1.696V4.326c0-.444.192-.866.527-1.155q.356-.31.716-.581l.034.172c.018.168.228.244.358.128l1.577-1.41a.2.2 0 0 0 .07-.128Q7.197.55 9 .55M4.395 14.3h-.91c-.05 0-.09.044-.09.1v2c0 .077.077.126.137.085l.91-.6a.1.1 0 0 0 .043-.085v-1.4c0-.055-.04-.1-.09-.1m10.18 0h-.91c-.05 0-.09.044-.09.1v1.4c0 .035.016.067.044.085l.909.6c.06.04.138-.008.138-.085v-2c0-.055-.041-.1-.091-.1M3.568 8.863c-.04-.106-.173-.071-.173.044v4.736c0 .058.04.107.09.107h.91c.05 0 .09-.049.09-.108v-2.367l-.008-.044zm10.924 0-.909 2.367-.008.045v2.367c0 .06.04.108.09.108h.91c.05 0 .09-.049.09-.108V8.908c0-.116-.133-.15-.173-.045M9.107 7.15q-2.382 0-4.945.553l-.047.013a.44.44 0 0 0-.275.557l.833 1.876c.06.18.225.3.412.3h7.828a.43.43 0 0 0 .411-.3l.835-1.884.012-.041a.44.44 0 0 0-.327-.527 21 21 0 0 0-4.737-.547",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M3.491 18.425H14.51v1.65H3.491z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          d: "M14.956 19.8H3.044a.866.866 0 0 0-.862.87v33.46c0 .48.386.87.862.87h11.912c.476 0 .862-.39.862-.87V20.67c0-.48-.386-.87-.862-.87"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M4.025 21.45c.113 0 .205.093.205.207v31.486a.207.207 0 0 1-.205.207.207.207 0 0 1-.207-.207V21.658c0-.115.093-.208.207-.208m4.636 0c.113 0 .205.093.205.207v31.486a.207.207 0 0 1-.205.207.207.207 0 0 1-.206-.207V21.658c0-.115.092-.208.206-.208m4.636 0c.114 0 .206.093.206.207v31.486a.207.207 0 0 1-.206.207.207.207 0 0 1-.206-.207V21.658c0-.115.093-.208.206-.208",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#DDE5ED",
          fillRule: "evenodd",
          d: "M5.147 16.5h7.706c.142 0 .279.056.38.155l.404.395H4.365l.403-.395a.54.54 0 0 1 .38-.155M4.368 6.47l1.169-4.19c.013-.047.06-.08.113-.08h.234c.078 0 .134.068.111.135l-1.401 4.19c-.044.13-.262.077-.226-.055M13.438 6.47 12.27 2.28c-.013-.047-.06-.08-.114-.08h-.233c-.078 0-.134.068-.112.135l1.402 4.19c.043.13.262.077.225-.055",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          d: "M1.536 49.031h14.928c.78 0 1.273.838.894 1.52L9.894 63.967c-.39.7-1.398.7-1.787 0L.643 50.55c-.38-.682.113-1.52.893-1.52"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M10.34 64.215a1.534 1.534 0 0 1-2.68 0L.196 50.8a1.534 1.534 0 0 1 1.34-2.28h14.928c1.17 0 1.91 1.258 1.34 2.28zm-1.787-.497c.195.35.699.35.894 0l7.464-13.416a.51.51 0 0 0-.447-.76H1.536c-.39 0-.636.42-.447.76z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M9 59.538a.76.76 0 0 1-.57-.245.82.82 0 0 1-.236-.59.82.82 0 0 1 .237-.59.76.76 0 0 1 .569-.245q.331 0 .568.245a.82.82 0 0 1 .237.59.82.82 0 0 1-.237.59.76.76 0 0 1-.568.245m0-2.505a.76.76 0 0 1-.57-.246.82.82 0 0 1-.236-.59v-3.34a.82.82 0 0 1 .237-.59.76.76 0 0 1 .569-.245q.331 0 .568.245a.82.82 0 0 1 .237.59v3.34a.82.82 0 0 1-.237.59.76.76 0 0 1-.568.245"
        }
      )
    ]
  }
);
const VehicleSTruckUnplugged = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-truck-unplugged",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 65",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M9 0c2.313 0 4.533.925 6.647 2.753.455.394.716.968.716 1.573v3.47l.806.368c.411.188.713.536.825.954.034.134-.09.255-.234.228l-1.397-.263v7.65c0 .92-.541 1.728-1.34 2.09v1.527H2.977v-1.527a2.29 2.29 0 0 1-1.342-2.09v-7.65L.24 9.346c-.143.028-.268-.094-.234-.23a1.48 1.48 0 0 1 .825-.952l.805-.368v-3.47c0-.605.262-1.179.718-1.573C4.468.925 6.688 0 9 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M9 .55q1.804 0 3.537.802a.2.2 0 0 0 .07.128l1.577 1.41c.13.115.34.04.357-.128l.035-.171q.36.271.715.58c.335.289.527.71.527 1.155v12.407c0 .827-.573 1.52-1.341 1.696v1.37H3.523v-1.37a1.74 1.74 0 0 1-1.341-1.696V4.326c0-.444.192-.866.527-1.155q.356-.31.716-.581l.034.172c.018.168.228.244.358.128l1.577-1.41a.2.2 0 0 0 .07-.128Q7.197.55 9 .55M4.395 14.3h-.91c-.05 0-.09.044-.09.1v2c0 .077.077.126.137.085l.91-.6a.1.1 0 0 0 .043-.085v-1.4c0-.055-.04-.1-.09-.1m10.18 0h-.91c-.05 0-.09.044-.09.1v1.4c0 .035.016.067.044.085l.909.6c.06.04.138-.008.138-.085v-2c0-.055-.041-.1-.091-.1M3.568 8.863c-.04-.106-.173-.071-.173.044v4.736c0 .058.04.107.09.107h.91c.05 0 .09-.049.09-.108v-2.367l-.008-.044zm10.924 0-.909 2.367-.008.045v2.367c0 .06.04.108.09.108h.91c.05 0 .09-.049.09-.108V8.908c0-.116-.133-.15-.173-.045M9.107 7.15q-2.382 0-4.945.553l-.047.013a.44.44 0 0 0-.275.557l.833 1.876c.06.18.225.3.412.3h7.828a.43.43 0 0 0 .411-.3l.835-1.884.012-.041a.44.44 0 0 0-.327-.527 21 21 0 0 0-4.737-.547",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M3.491 18.425H14.51v1.65H3.491z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          d: "M14.956 19.8H3.044a.866.866 0 0 0-.862.87v33.46c0 .48.386.87.862.87h11.912c.476 0 .862-.39.862-.87V20.67c0-.48-.386-.87-.862-.87"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M4.025 21.45c.113 0 .205.093.205.207v31.486a.207.207 0 0 1-.205.207.207.207 0 0 1-.207-.207V21.658c0-.115.093-.208.207-.208m4.636 0c.113 0 .205.093.205.207v31.486a.207.207 0 0 1-.205.207.207.207 0 0 1-.206-.207V21.658c0-.115.092-.208.206-.208m4.636 0c.114 0 .206.093.206.207v31.486a.207.207 0 0 1-.206.207.207.207 0 0 1-.206-.207V21.658c0-.115.093-.208.206-.208",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#DDE5ED",
          fillRule: "evenodd",
          d: "M5.147 16.5h7.706c.142 0 .279.056.38.155l.404.395H4.365l.403-.395a.54.54 0 0 1 .38-.155M4.368 6.47l1.169-4.19c.013-.047.06-.08.113-.08h.234c.078 0 .134.068.111.135l-1.401 4.19c-.044.13-.262.077-.226-.055M13.438 6.47 12.27 2.28c-.013-.047-.06-.08-.114-.08h-.233c-.078 0-.134.068-.112.135l1.402 4.19c.043.13.262.077.225-.055",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          d: "M1.536 49.031h14.928c.78 0 1.273.838.894 1.52L9.894 63.967c-.39.7-1.398.7-1.787 0L.643 50.55c-.38-.682.113-1.52.893-1.52"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M10.34 64.215a1.534 1.534 0 0 1-2.68 0L.196 50.8a1.534 1.534 0 0 1 1.34-2.28h14.928c1.17 0 1.91 1.258 1.34 2.28zm-1.787-.497c.195.35.699.35.894 0l7.464-13.416a.51.51 0 0 0-.447-.76H1.536c-.39 0-.636.42-.447.76z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M10.502 52.322c0-.166-.128-.3-.285-.3a.29.29 0 0 0-.285.3v1.96H8.067v-1.96c0-.166-.127-.3-.284-.3a.293.293 0 0 0-.285.3v1.96h-.645v1.203c.003 1.07.72 1.99 1.717 2.202v1.85h.86v-1.85c.996-.213 1.714-1.133 1.717-2.202v-1.207h-.645z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M4.705 51.485h8.59v8.59h-8.59z" }) }) })
    ]
  }
);
const VehicleSTruck = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-truck",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 64",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M10.409.916c2.675 0 5.242 1.06 7.687 3.158.526.452.83 1.11.83 1.804v3.98l.93.422a1.7 1.7 0 0 1 .955 1.094c.04.153-.105.293-.271.262l-1.615-.302v8.774a2.63 2.63 0 0 1-1.551 2.397v1.752H3.444v-1.752a2.63 2.63 0 0 1-1.552-2.397v-8.774l-1.615.302c-.165.031-.31-.109-.27-.263.13-.478.479-.878.954-1.093l.931-.422v-3.98c0-.694.303-1.352.83-1.805C5.167 1.977 7.735.916 10.409.916",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M10.409 1.547q2.086 0 4.09.92.008.078.081.147l1.824 1.616c.15.133.394.047.414-.146l.04-.196q.415.312.827.665c.387.332.61.816.61 1.325v14.23c0 .95-.663 1.744-1.552 1.946v1.572H4.074v-1.572a2 2 0 0 1-1.55-1.946V5.878c0-.51.222-.993.609-1.325q.412-.354.829-.666L4 4.084c.02.193.263.28.413.146l1.824-1.616a.23.23 0 0 0 .082-.147q2.002-.92 4.088-.92m-5.326 15.77H4.03c-.058 0-.105.052-.105.116v2.293c0 .09.09.145.16.099l1.05-.688a.12.12 0 0 0 .051-.099v-1.605c0-.063-.046-.115-.104-.115m11.774 0h-1.052c-.058 0-.105.052-.105.116v1.605c0 .04.02.078.05.099l1.052.687c.07.047.16-.009.16-.098v-2.293c0-.063-.047-.115-.105-.115m-12.73-6.235c-.047-.121-.2-.082-.2.05v5.432c0 .067.046.123.104.123h1.052c.058 0 .105-.056.105-.124v-2.715l-.01-.05zm12.634 0-1.051 2.715-.01.051v2.715c0 .069.047.124.105.124h1.052c.058 0 .105-.056.105-.124v-5.43c0-.132-.155-.172-.201-.051m-6.228-1.965q-2.754 0-5.72.635l-.054.015a.506.506 0 0 0-.317.638l.963 2.152c.068.206.26.345.476.345h9.053a.5.5 0 0 0 .476-.345l.966-2.16.013-.048a.504.504 0 0 0-.377-.604 24.5 24.5 0 0 0-5.48-.628z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M4.037 22.05H16.78v1.892H4.037z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          d: "M17.297 23.627H3.52a.997.997 0 0 0-.998.997v38.379c0 .55.447.997.998.997h13.776c.55 0 .997-.446.997-.997v-38.38a.997.997 0 0 0-.997-.997"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M4.654 25.519c.131 0 .238.106.238.237V61.87a.238.238 0 0 1-.476 0V25.756c0-.13.107-.237.238-.237m5.362 0c.132 0 .238.106.238.237V61.87a.238.238 0 0 1-.476 0V25.756c0-.13.107-.237.238-.237m5.363 0c.13 0 .237.106.237.237V61.87a.238.238 0 0 1-.476 0V25.756c0-.13.107-.237.239-.237",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#DDE5ED",
          fillRule: "evenodd",
          d: "M5.952 19.841h8.913c.164 0 .322.064.44.178l.466.453H5.047l.466-.453a.63.63 0 0 1 .44-.178M5.052 8.337l1.35-4.807c.016-.053.07-.09.132-.09h.27c.09 0 .155.077.13.154L5.311 8.4c-.05.15-.303.089-.26-.063M15.541 8.337 14.19 3.53c-.015-.053-.07-.09-.131-.09h-.27c-.09 0-.155.077-.13.154L15.281 8.4c.05.15.303.089.26-.063",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSTugDisablePending = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-tug-disable-pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 46",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.53 1.006H3.47a.53.53 0 0 0-.529.529v33.77c0 .291.237.528.529.528h15.06a.53.53 0 0 0 .528-.529V1.534a.53.53 0 0 0-.528-.528"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.153 1.535c0-.175.142-.317.317-.317h15.06c.175 0 .317.142.317.317v5.968H3.153zm0 6.391h15.694v27.382a.317.317 0 0 1-.317.317H3.47a.317.317 0 0 1-.317-.317zM3.47.796a.74.74 0 0 0-.74.74v33.772c0 .409.331.74.74.74h15.06a.74.74 0 0 0 .74-.74V1.535a.74.74 0 0 0-.74-.74z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M10.301 9.384H3.733v24.874h6.568zM18.332 9.384h-6.568v24.874h6.567z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.733 9.172a.21.21 0 0 0-.211.212v24.874c0 .117.095.211.211.211h6.568a.21.21 0 0 0 .212-.21V9.383a.21.21 0 0 0-.212-.212zm.212.423h6.145v24.452H3.945zm7.818-.422a.21.21 0 0 0-.21.21v24.875c0 .117.094.212.21.212h6.568a.21.21 0 0 0 .212-.212V9.384a.21.21 0 0 0-.212-.211zm.212.422h6.145v24.452h-6.145z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M4.03 1.734a.53.53 0 0 0-.53.528v.453c0 .292.237.529.53.529h13.988a.53.53 0 0 0 .529-.529v-.453a.53.53 0 0 0-.529-.528z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.923 2.715v-.453c0-.058.048-.105.106-.105h13.99c.058 0 .105.047.105.105v.453a.106.106 0 0 1-.106.106H4.03a.106.106 0 0 1-.106-.106m-.422-.453c0-.292.236-.528.528-.528h13.99c.29 0 .528.236.528.528v.453a.53.53 0 0 1-.529.529H4.03a.53.53 0 0 1-.528-.529z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.057 4.706a.53.53 0 0 0-.529.528v.454c0 .291.237.528.529.528H2.94v-1.51z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.95 5.688v-.454c0-.058.048-.105.107-.105h1.462v.664H1.057a.106.106 0 0 1-.106-.105m-.422-.454c0-.291.237-.528.529-.528H2.94v1.51H1.057a.53.53 0 0 1-.529-.528z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.058 4.706v1.51h1.885a.53.53 0 0 0 .529-.528v-.454a.53.53 0 0 0-.529-.528z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.481 5.793V5.13h1.462c.059 0 .106.047.106.105v.454a.106.106 0 0 1-.106.105zm-.423-1.087h1.885c.292 0 .529.237.529.528v.454a.53.53 0 0 1-.529.528h-1.885z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.47 9.523A1.47 1.47 0 0 0 0 10.994v5.84a1.47 1.47 0 1 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.471-1.47M20.53 9.523a1.47 1.47 0 0 0-1.472 1.471v5.84a1.47 1.47 0 0 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.47-1.47M1.47 25.477A1.47 1.47 0 0 0 0 26.947v5.84a1.47 1.47 0 1 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.471-1.47M20.53 25.477a1.47 1.47 0 0 0-1.472 1.47v5.84a1.47 1.47 0 0 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.47-1.47"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCF0DE",
          fillRule: "evenodd",
          stroke: "#F9D199",
          d: "M11 45.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F9D199",
          fillRule: "evenodd",
          d: "M2 36.795a9 9 0 1 1 18.001.002A9 9 0 0 1 2 36.795m9-8.052a8.053 8.053 0 1 0 .001 16.106A8.053 8.053 0 0 0 11 28.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          fillRule: "evenodd",
          d: "M13.924 35.138h-.474v-.948a2.37 2.37 0 0 0-4.736 0v.948H8.24a.95.95 0 0 0-.948.947v4.737a.95.95 0 0 0 .948.947h5.684a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.947M11.082 39.4a.95.95 0 0 1-.947-.948.95.95 0 0 1 .947-.947.95.95 0 0 1 .947.947.95.95 0 0 1-.947.948m1.468-4.263H9.614v-.948c0-.81.658-1.468 1.468-1.468s1.468.658 1.468 1.468z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSTugDisabled = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-tug-disabled",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 46",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.53 1.006H3.47a.53.53 0 0 0-.529.529v33.77c0 .291.237.528.529.528h15.06a.53.53 0 0 0 .528-.529V1.534a.53.53 0 0 0-.528-.528"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.153 1.535c0-.175.142-.317.317-.317h15.06c.175 0 .317.142.317.317v5.968H3.153zm0 6.391h15.694v27.382a.317.317 0 0 1-.317.317H3.47a.317.317 0 0 1-.317-.317zM3.47.796a.74.74 0 0 0-.74.74v33.772c0 .409.331.74.74.74h15.06a.74.74 0 0 0 .74-.74V1.535a.74.74 0 0 0-.74-.74z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M10.301 9.384H3.733v24.874h6.568zM18.332 9.384h-6.568v24.874h6.567z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.733 9.172a.21.21 0 0 0-.211.212v24.874c0 .117.095.211.211.211h6.568a.21.21 0 0 0 .212-.21V9.383a.21.21 0 0 0-.212-.212zm.212.423h6.145v24.452H3.945zm7.818-.422a.21.21 0 0 0-.21.21v24.875c0 .117.094.212.21.212h6.568a.21.21 0 0 0 .212-.212V9.384a.21.21 0 0 0-.212-.211zm.212.422h6.145v24.452h-6.145z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M4.03 1.734a.53.53 0 0 0-.53.528v.453c0 .292.237.529.53.529h13.988a.53.53 0 0 0 .529-.529v-.453a.53.53 0 0 0-.529-.528z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.923 2.715v-.453c0-.058.048-.105.106-.105h13.99c.058 0 .105.047.105.105v.453a.106.106 0 0 1-.106.106H4.03a.106.106 0 0 1-.106-.106m-.422-.453c0-.292.236-.528.528-.528h13.99c.29 0 .528.236.528.528v.453a.53.53 0 0 1-.529.529H4.03a.53.53 0 0 1-.528-.529z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.057 4.706a.53.53 0 0 0-.529.528v.454c0 .291.237.528.529.528H2.94v-1.51z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.95 5.688v-.454c0-.058.048-.105.107-.105h1.462v.664H1.057a.106.106 0 0 1-.106-.105m-.422-.454c0-.291.237-.528.529-.528H2.94v1.51H1.057a.53.53 0 0 1-.529-.528z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.058 4.706v1.51h1.885a.53.53 0 0 0 .529-.528v-.454a.53.53 0 0 0-.529-.528z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.481 5.793V5.13h1.462c.059 0 .106.047.106.105v.454a.106.106 0 0 1-.106.105zm-.423-1.087h1.885c.292 0 .529.237.529.528v.454a.53.53 0 0 1-.529.528h-1.885z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.47 9.523A1.47 1.47 0 0 0 0 10.994v5.84a1.47 1.47 0 1 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.471-1.47M20.53 9.523a1.47 1.47 0 0 0-1.472 1.471v5.84a1.47 1.47 0 0 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.47-1.47M1.47 25.477A1.47 1.47 0 0 0 0 26.947v5.84a1.47 1.47 0 1 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.471-1.47M20.53 25.477a1.47 1.47 0 0 0-1.472 1.47v5.84a1.47 1.47 0 0 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.47-1.47"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCEDEB",
          fillRule: "evenodd",
          stroke: "#F5B7B1",
          d: "M11 45.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F5B7B1",
          fillRule: "evenodd",
          d: "M2 36.795a9 9 0 1 1 18.001.002A9 9 0 0 1 2 36.795m9-8.052a8.053 8.053 0 1 0 .001 16.106A8.053 8.053 0 0 0 11 28.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          fillRule: "evenodd",
          d: "M13.924 35.138h-.474v-.948a2.37 2.37 0 0 0-4.736 0v.948H8.24a.95.95 0 0 0-.948.947v4.737a.95.95 0 0 0 .948.947h5.684a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.947M11.082 39.4a.95.95 0 0 1-.947-.948.95.95 0 0 1 .947-.947.95.95 0 0 1 .947.947.95.95 0 0 1-.947.948m1.468-4.263H9.614v-.948c0-.81.658-1.468 1.468-1.468s1.468.658 1.468 1.468z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSTugEnablePending = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-tug-enable-pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 46",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.53 1.006H3.47a.53.53 0 0 0-.529.529v33.77c0 .291.237.528.529.528h15.06a.53.53 0 0 0 .528-.529V1.534a.53.53 0 0 0-.528-.528"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.153 1.535c0-.175.142-.317.317-.317h15.06c.175 0 .317.142.317.317v5.968H3.153zm0 6.391h15.694v27.382a.317.317 0 0 1-.317.317H3.47a.317.317 0 0 1-.317-.317zM3.47.796a.74.74 0 0 0-.74.74v33.772c0 .409.331.74.74.74h15.06a.74.74 0 0 0 .74-.74V1.535a.74.74 0 0 0-.74-.74z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M10.301 9.384H3.733v24.874h6.568zM18.332 9.384h-6.568v24.874h6.567z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.733 9.172a.21.21 0 0 0-.211.212v24.874c0 .117.095.211.211.211h6.568a.21.21 0 0 0 .212-.21V9.383a.21.21 0 0 0-.212-.212zm.212.423h6.145v24.452H3.945zm7.818-.422a.21.21 0 0 0-.21.21v24.875c0 .117.094.212.21.212h6.568a.21.21 0 0 0 .212-.212V9.384a.21.21 0 0 0-.212-.211zm.212.422h6.145v24.452h-6.145z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M4.03 1.734a.53.53 0 0 0-.53.528v.453c0 .292.237.529.53.529h13.988a.53.53 0 0 0 .529-.529v-.453a.53.53 0 0 0-.529-.528z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.923 2.715v-.453c0-.058.048-.105.106-.105h13.99c.058 0 .105.047.105.105v.453a.106.106 0 0 1-.106.106H4.03a.106.106 0 0 1-.106-.106m-.422-.453c0-.292.236-.528.528-.528h13.99c.29 0 .528.236.528.528v.453a.53.53 0 0 1-.529.529H4.03a.53.53 0 0 1-.528-.529z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.057 4.706a.53.53 0 0 0-.529.528v.454c0 .291.237.528.529.528H2.94v-1.51z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.95 5.688v-.454c0-.058.048-.105.107-.105h1.462v.664H1.057a.106.106 0 0 1-.106-.105m-.422-.454c0-.291.237-.528.529-.528H2.94v1.51H1.057a.53.53 0 0 1-.529-.528z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.058 4.706v1.51h1.885a.53.53 0 0 0 .529-.528v-.454a.53.53 0 0 0-.529-.528z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.481 5.793V5.13h1.462c.059 0 .106.047.106.105v.454a.106.106 0 0 1-.106.105zm-.423-1.087h1.885c.292 0 .529.237.529.528v.454a.53.53 0 0 1-.529.528h-1.885z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.47 9.523A1.47 1.47 0 0 0 0 10.994v5.84a1.47 1.47 0 1 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.471-1.47M20.53 9.523a1.47 1.47 0 0 0-1.472 1.471v5.84a1.47 1.47 0 0 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.47-1.47M1.47 25.477A1.47 1.47 0 0 0 0 26.947v5.84a1.47 1.47 0 1 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.471-1.47M20.53 25.477a1.47 1.47 0 0 0-1.472 1.47v5.84a1.47 1.47 0 0 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.47-1.47"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#CFDEF2",
          fillRule: "evenodd",
          stroke: "#F5B7B1",
          d: "M11 45.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#8AB9F7",
          fillRule: "evenodd",
          d: "M2 36.795a9 9 0 1 1 18.001.002A9 9 0 0 1 2 36.795m9-8.052a8.053 8.053 0 1 0 .001 16.106A8.053 8.053 0 0 0 11 28.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1774F0",
          fillRule: "evenodd",
          d: "M11.082 39.164a.95.95 0 0 0 .947-.947.95.95 0 0 0-.947-.948.95.95 0 0 0-.947.948.95.95 0 0 0 .947.947m2.842-4.263h-.474v-.948a2.37 2.37 0 0 0-4.736 0h.9c0-.81.658-1.468 1.468-1.468s1.468.658 1.468 1.468v.948H8.24a.95.95 0 0 0-.948.947v4.737a.95.95 0 0 0 .948.947h5.684a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.947m0 5.684H8.24v-4.737h5.684z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSTugNoSignal = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-tug-no-signal",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 46",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.53 1.006H3.47a.53.53 0 0 0-.529.529v33.77c0 .291.237.528.529.528h15.06a.53.53 0 0 0 .528-.529V1.534a.53.53 0 0 0-.528-.528"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.153 1.535c0-.175.142-.317.317-.317h15.06c.175 0 .317.142.317.317v5.968H3.153zm0 6.391h15.694v27.382a.317.317 0 0 1-.317.317H3.47a.317.317 0 0 1-.317-.317zM3.47.796a.74.74 0 0 0-.74.74v33.772c0 .409.331.74.74.74h15.06a.74.74 0 0 0 .74-.74V1.535a.74.74 0 0 0-.74-.74z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M10.301 9.384H3.733v24.874h6.568zM18.332 9.384h-6.568v24.874h6.567z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.733 9.172a.21.21 0 0 0-.211.212v24.874c0 .117.095.211.211.211h6.568a.21.21 0 0 0 .212-.21V9.383a.21.21 0 0 0-.212-.212zm.212.423h6.145v24.452H3.945zm7.818-.422a.21.21 0 0 0-.21.21v24.875c0 .117.094.212.21.212h6.568a.21.21 0 0 0 .212-.212V9.384a.21.21 0 0 0-.212-.211zm.212.422h6.145v24.452h-6.145z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M4.03 1.734a.53.53 0 0 0-.53.528v.453c0 .292.237.529.53.529h13.988a.53.53 0 0 0 .529-.529v-.453a.53.53 0 0 0-.529-.528z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.923 2.715v-.453c0-.058.048-.105.106-.105h13.99c.058 0 .105.047.105.105v.453a.106.106 0 0 1-.106.106H4.03a.106.106 0 0 1-.106-.106m-.422-.453c0-.292.236-.528.528-.528h13.99c.29 0 .528.236.528.528v.453a.53.53 0 0 1-.529.529H4.03a.53.53 0 0 1-.528-.529z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.057 4.706a.53.53 0 0 0-.529.528v.454c0 .291.237.528.529.528H2.94v-1.51z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.95 5.688v-.454c0-.058.048-.105.107-.105h1.462v.664H1.057a.106.106 0 0 1-.106-.105m-.422-.454c0-.291.237-.528.529-.528H2.94v1.51H1.057a.53.53 0 0 1-.529-.528z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.058 4.706v1.51h1.885a.53.53 0 0 0 .529-.528v-.454a.53.53 0 0 0-.529-.528z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.481 5.793V5.13h1.462c.059 0 .106.047.106.105v.454a.106.106 0 0 1-.106.105zm-.423-1.087h1.885c.292 0 .529.237.529.528v.454a.53.53 0 0 1-.529.528h-1.885z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.47 9.523A1.47 1.47 0 0 0 0 10.994v5.84a1.47 1.47 0 1 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.471-1.47M20.53 9.523a1.47 1.47 0 0 0-1.472 1.471v5.84a1.47 1.47 0 0 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.47-1.47M1.47 25.477A1.47 1.47 0 0 0 0 26.947v5.84a1.47 1.47 0 1 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.471-1.47M20.53 25.477a1.47 1.47 0 0 0-1.472 1.47v5.84a1.47 1.47 0 0 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.47-1.47"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M10.3 28.58a.99.99 0 0 1 1.4 0l7.515 7.515a.99.99 0 0 1 0 1.4L11.7 45.01a.99.99 0 0 1-1.401 0l-7.515-7.514a.99.99 0 0 1 0-1.401z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#9DA9B6",
          fillRule: "evenodd",
          d: "M9.95 28.23c.58-.58 1.52-.58 2.1 0l7.515 7.515c.58.58.58 1.52 0 2.101L12.05 45.36c-.58.58-1.521.58-2.102 0l-7.514-7.514a1.486 1.486 0 0 1 0-2.101zm1.4.701a.495.495 0 0 0-.7 0l-7.514 7.514a.495.495 0 0 0 0 .7l7.514 7.515a.495.495 0 0 0 .7 0l7.514-7.514a.495.495 0 0 0 0-.7z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          d: "M14.137 33.156a.386.386 0 0 0-.659-.273l-2.542 2.542 3.2 3.201zm.17 6.73-6.095-6.094a.384.384 0 1 0-.543.543l2.18 2.18-2.758 2.758a.385.385 0 0 0 .27.66h5.901l.497.496c.15.15.393.15.543 0a.38.38 0 0 0 .004-.543"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M6.047 31.843h9.245v9.245H6.047z" }) }) })
    ]
  }
);
const VehicleSTugOff = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-tug-off",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 46",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.53 1.006H3.47a.53.53 0 0 0-.529.529v33.77c0 .291.237.528.529.528h15.06a.53.53 0 0 0 .528-.529V1.534a.53.53 0 0 0-.528-.528"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.153 1.535c0-.175.142-.317.317-.317h15.06c.175 0 .317.142.317.317v5.968H3.153zm0 6.391h15.694v27.382a.317.317 0 0 1-.317.317H3.47a.317.317 0 0 1-.317-.317zM3.47.796a.74.74 0 0 0-.74.74v33.772c0 .409.331.74.74.74h15.06a.74.74 0 0 0 .74-.74V1.535a.74.74 0 0 0-.74-.74z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M10.301 9.384H3.733v24.874h6.568zM18.332 9.384h-6.568v24.874h6.567z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.733 9.172a.21.21 0 0 0-.211.212v24.874c0 .117.095.211.211.211h6.568a.21.21 0 0 0 .212-.21V9.383a.21.21 0 0 0-.212-.212zm.212.423h6.145v24.452H3.945zm7.818-.422a.21.21 0 0 0-.21.21v24.875c0 .117.094.212.21.212h6.568a.21.21 0 0 0 .212-.212V9.384a.21.21 0 0 0-.212-.211zm.212.422h6.145v24.452h-6.145z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M4.03 1.734a.53.53 0 0 0-.53.528v.453c0 .292.237.529.53.529h13.988a.53.53 0 0 0 .529-.529v-.453a.53.53 0 0 0-.529-.528z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.923 2.715v-.453c0-.058.048-.105.106-.105h13.99c.058 0 .105.047.105.105v.453a.106.106 0 0 1-.106.106H4.03a.106.106 0 0 1-.106-.106m-.422-.453c0-.292.236-.528.528-.528h13.99c.29 0 .528.236.528.528v.453a.53.53 0 0 1-.529.529H4.03a.53.53 0 0 1-.528-.529z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.057 4.706a.53.53 0 0 0-.529.528v.454c0 .291.237.528.529.528H2.94v-1.51z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.95 5.688v-.454c0-.058.048-.105.107-.105h1.462v.664H1.057a.106.106 0 0 1-.106-.105m-.422-.454c0-.291.237-.528.529-.528H2.94v1.51H1.057a.53.53 0 0 1-.529-.528z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.058 4.706v1.51h1.885a.53.53 0 0 0 .529-.528v-.454a.53.53 0 0 0-.529-.528z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.481 5.793V5.13h1.462c.059 0 .106.047.106.105v.454a.106.106 0 0 1-.106.105zm-.423-1.087h1.885c.292 0 .529.237.529.528v.454a.53.53 0 0 1-.529.528h-1.885z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.47 9.523A1.47 1.47 0 0 0 0 10.994v5.84a1.47 1.47 0 1 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.471-1.47M20.53 9.523a1.47 1.47 0 0 0-1.472 1.471v5.84a1.47 1.47 0 0 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.47-1.47M1.47 25.477A1.47 1.47 0 0 0 0 26.947v5.84a1.47 1.47 0 1 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.471-1.47M20.53 25.477a1.47 1.47 0 0 0-1.472 1.47v5.84a1.47 1.47 0 0 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.47-1.47"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M11 45.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M2 36.795a9 9 0 1 1 18.001.002A9 9 0 0 1 2 36.795m9-8.052a8.053 8.053 0 1 0 .001 16.106A8.053 8.053 0 0 0 11 28.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M7.472 36.796a3.528 3.528 0 1 0 7.056 0 3.528 3.528 0 0 0-7.056 0m-.893 0a4.421 4.421 0 1 0 8.842 0 4.421 4.421 0 0 0-8.842 0m2.615-.301a.55.55 0 0 0-.11.35q0 .209.11.35a.33.33 0 0 0 .273.14h3.066q.162 0 .273-.14a.55.55 0 0 0 .11-.35.55.55 0 0 0-.11-.35.33.33 0 0 0-.273-.142H9.467q-.163 0-.273.142",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSTugOn = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-tug-on",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 46",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.53 1.006H3.47a.53.53 0 0 0-.529.529v33.77c0 .291.237.528.529.528h15.06a.53.53 0 0 0 .528-.529V1.534a.53.53 0 0 0-.528-.528"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.153 1.535c0-.175.142-.317.317-.317h15.06c.175 0 .317.142.317.317v5.968H3.153zm0 6.391h15.694v27.382a.317.317 0 0 1-.317.317H3.47a.317.317 0 0 1-.317-.317zM3.47.796a.74.74 0 0 0-.74.74v33.772c0 .409.331.74.74.74h15.06a.74.74 0 0 0 .74-.74V1.535a.74.74 0 0 0-.74-.74z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M10.301 9.384H3.733v24.874h6.568zM18.332 9.384h-6.568v24.874h6.567z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.733 9.172a.21.21 0 0 0-.211.212v24.874c0 .117.095.211.211.211h6.568a.21.21 0 0 0 .212-.21V9.383a.21.21 0 0 0-.212-.212zm.212.423h6.145v24.452H3.945zm7.818-.422a.21.21 0 0 0-.21.21v24.875c0 .117.094.212.21.212h6.568a.21.21 0 0 0 .212-.212V9.384a.21.21 0 0 0-.212-.211zm.212.422h6.145v24.452h-6.145z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M4.03 1.734a.53.53 0 0 0-.53.528v.453c0 .292.237.529.53.529h13.988a.53.53 0 0 0 .529-.529v-.453a.53.53 0 0 0-.529-.528z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.923 2.715v-.453c0-.058.048-.105.106-.105h13.99c.058 0 .105.047.105.105v.453a.106.106 0 0 1-.106.106H4.03a.106.106 0 0 1-.106-.106m-.422-.453c0-.292.236-.528.528-.528h13.99c.29 0 .528.236.528.528v.453a.53.53 0 0 1-.529.529H4.03a.53.53 0 0 1-.528-.529z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.057 4.706a.53.53 0 0 0-.529.528v.454c0 .291.237.528.529.528H2.94v-1.51z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.95 5.688v-.454c0-.058.048-.105.107-.105h1.462v.664H1.057a.106.106 0 0 1-.106-.105m-.422-.454c0-.291.237-.528.529-.528H2.94v1.51H1.057a.53.53 0 0 1-.529-.528z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.058 4.706v1.51h1.885a.53.53 0 0 0 .529-.528v-.454a.53.53 0 0 0-.529-.528z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.481 5.793V5.13h1.462c.059 0 .106.047.106.105v.454a.106.106 0 0 1-.106.105zm-.423-1.087h1.885c.292 0 .529.237.529.528v.454a.53.53 0 0 1-.529.528h-1.885z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.47 9.523A1.47 1.47 0 0 0 0 10.994v5.84a1.47 1.47 0 1 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.471-1.47M20.53 9.523a1.47 1.47 0 0 0-1.472 1.471v5.84a1.47 1.47 0 0 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.47-1.47M1.47 25.477A1.47 1.47 0 0 0 0 26.947v5.84a1.47 1.47 0 1 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.471-1.47M20.53 25.477a1.47 1.47 0 0 0-1.472 1.47v5.84a1.47 1.47 0 0 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.47-1.47"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#03D8A9",
          fillRule: "evenodd",
          d: "M11 45.322a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M2 36.795a9 9 0 1 1 18.001.002A9 9 0 0 1 2 36.795m9-8.052a8.053 8.053 0 1 0 .001 16.106A8.053 8.053 0 0 0 11 28.743",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M11 37.286a.48.48 0 0 1-.35-.14.48.48 0 0 1-.142-.35v-3.93q0-.21.142-.35a.48.48 0 0 1 .35-.142q.208 0 .35.141.14.141.14.35v3.93q0 .21-.14.35a.48.48 0 0 1-.35.141m0 3.93q-.921 0-1.726-.35a4.5 4.5 0 0 1-1.4-.946 4.5 4.5 0 0 1-.945-1.4 4.3 4.3 0 0 1-.35-1.725q0-.847.307-1.621.306-.773.884-1.4a.45.45 0 0 1 .344-.147q.209 0 .356.147a.42.42 0 0 1 .123.338.6.6 0 0 1-.148.362q-.429.48-.657 1.075a3.5 3.5 0 0 0-.227 1.246q0 1.437 1 2.438 1.001 1 2.439 1 1.437 0 2.437-1 1.001-1 1.001-2.438 0-.65-.233-1.259a3.5 3.5 0 0 0-.663-1.087.52.52 0 0 1-.142-.343.43.43 0 0 1 .13-.332.49.49 0 0 1 .356-.147q.208 0 .344.147.576.627.884 1.4.307.774.307 1.621 0 .922-.35 1.725a4.5 4.5 0 0 1-.946 1.4 4.5 4.5 0 0 1-1.4.946 4.3 4.3 0 0 1-1.725.35"
        }
      )
    ]
  }
);
const VehicleSTugUnavailable = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-tug-unavailable",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 46",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.53 1.002H3.47a.53.53 0 0 0-.529.528V35.3c0 .292.237.528.529.528h15.06a.53.53 0 0 0 .528-.528V1.53a.53.53 0 0 0-.528-.528"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.153 1.53c0-.174.142-.316.317-.316h15.06c.175 0 .317.142.317.317v5.968H3.153zm0 6.392h15.694v27.382a.317.317 0 0 1-.317.317H3.47a.317.317 0 0 1-.317-.317zM3.47.79a.74.74 0 0 0-.74.74v33.773c0 .408.331.74.74.74h15.06a.74.74 0 0 0 .74-.74V1.53a.74.74 0 0 0-.74-.74z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M10.301 9.38H3.733v24.874h6.568zM18.332 9.38h-6.568v24.874h6.567z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.733 9.168a.21.21 0 0 0-.211.211v24.875c0 .117.095.211.211.211h6.568a.21.21 0 0 0 .212-.211V9.379a.21.21 0 0 0-.212-.211zm.212.423h6.145v24.451H3.945zm7.818-.423a.21.21 0 0 0-.21.211v24.875c0 .117.094.211.21.211h6.568a.21.21 0 0 0 .212-.211V9.379a.21.21 0 0 0-.212-.21zm.212.423h6.145v24.451h-6.145z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M4.03 1.73a.53.53 0 0 0-.53.528v.453c0 .292.237.528.53.528h13.988a.53.53 0 0 0 .529-.528v-.453a.53.53 0 0 0-.529-.529z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.923 2.711v-.453c0-.058.048-.106.106-.106h13.99c.058 0 .105.048.105.106v.453a.106.106 0 0 1-.106.106H4.03a.106.106 0 0 1-.106-.106m-.422-.453c0-.292.236-.529.528-.529h13.99c.29 0 .528.237.528.529v.453a.53.53 0 0 1-.529.528H4.03a.53.53 0 0 1-.528-.528z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.057 4.702a.53.53 0 0 0-.529.528v.453c0 .292.237.529.529.529H2.94v-1.51z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.95 5.683V5.23c0-.058.048-.106.107-.106h1.462v.665H1.057a.106.106 0 0 1-.106-.106M.529 5.23c0-.292.237-.528.529-.528H2.94v1.51H1.057a.53.53 0 0 1-.529-.529z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.058 4.702v1.51h1.885a.53.53 0 0 0 .529-.529V5.23a.53.53 0 0 0-.529-.528z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.481 5.789v-.665h1.462c.059 0 .106.048.106.106v.453a.106.106 0 0 1-.106.106zm-.423-1.087h1.885c.292 0 .529.236.529.528v.453a.53.53 0 0 1-.529.529h-1.885z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.47 9.519A1.47 1.47 0 0 0 0 10.989v5.84a1.47 1.47 0 1 0 2.942 0v-5.84A1.47 1.47 0 0 0 1.47 9.52M20.53 9.519a1.47 1.47 0 0 0-1.472 1.47v5.84a1.47 1.47 0 0 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.47-1.47M1.47 25.473A1.47 1.47 0 0 0 0 26.943v5.84a1.47 1.47 0 0 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.471-1.47M20.53 25.473a1.47 1.47 0 0 0-1.472 1.47v5.84a1.47 1.47 0 0 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.47-1.47"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          d: "M3.536 29.822h14.928c.78 0 1.273.838.894 1.52l-7.464 13.413c-.39.7-1.398.7-1.787 0L2.643 31.34c-.38-.68.113-1.519.893-1.519"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M12.34 45.003a1.534 1.534 0 0 1-2.68 0L2.196 31.59a1.534 1.534 0 0 1 1.34-2.279h14.928c1.17 0 1.91 1.257 1.34 2.28zm-1.787-.497c.195.35.699.35.894 0l7.464-13.413a.51.51 0 0 0-.447-.76H3.536a.51.51 0 0 0-.447.76z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M11 40.326a.76.76 0 0 1-.569-.245.82.82 0 0 1-.236-.59q0-.344.236-.59a.76.76 0 0 1 .57-.245q.33 0 .568.246.236.245.236.59a.82.82 0 0 1-.236.589.76.76 0 0 1-.569.245m0-2.505a.76.76 0 0 1-.569-.245.82.82 0 0 1-.236-.59v-3.34q0-.343.236-.589a.76.76 0 0 1 .57-.245q.33 0 .568.245.236.245.236.59v3.34a.82.82 0 0 1-.236.59.76.76 0 0 1-.569.244"
        }
      )
    ]
  }
);
const VehicleSTugUnplugged = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-tug-unplugged",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 46",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.53 1.002H3.47a.53.53 0 0 0-.529.528V35.3c0 .292.237.528.529.528h15.06a.53.53 0 0 0 .528-.528V1.53a.53.53 0 0 0-.528-.528"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.153 1.53c0-.174.142-.316.317-.316h15.06c.175 0 .317.142.317.317v5.968H3.153zm0 6.392h15.694v27.382a.317.317 0 0 1-.317.317H3.47a.317.317 0 0 1-.317-.317zM3.47.79a.74.74 0 0 0-.74.74v33.773c0 .408.331.74.74.74h15.06a.74.74 0 0 0 .74-.74V1.53a.74.74 0 0 0-.74-.74z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M10.301 9.38H3.733v24.874h6.568zM18.332 9.38h-6.568v24.874h6.567z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.733 9.168a.21.21 0 0 0-.211.211v24.875c0 .117.095.211.211.211h6.568a.21.21 0 0 0 .212-.211V9.379a.21.21 0 0 0-.212-.211zm.212.423h6.145v24.451H3.945zm7.818-.423a.21.21 0 0 0-.21.211v24.875c0 .117.094.211.21.211h6.568a.21.21 0 0 0 .212-.211V9.379a.21.21 0 0 0-.212-.21zm.212.423h6.145v24.451h-6.145z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M4.03 1.73a.53.53 0 0 0-.53.528v.453c0 .292.237.528.53.528h13.988a.53.53 0 0 0 .529-.528v-.453a.53.53 0 0 0-.529-.529z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.923 2.711v-.453c0-.058.048-.106.106-.106h13.99c.058 0 .105.048.105.106v.453a.106.106 0 0 1-.106.106H4.03a.106.106 0 0 1-.106-.106m-.422-.453c0-.292.236-.529.528-.529h13.99c.29 0 .528.237.528.529v.453a.53.53 0 0 1-.529.528H4.03a.53.53 0 0 1-.528-.528z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.057 4.702a.53.53 0 0 0-.529.528v.453c0 .292.237.529.529.529H2.94v-1.51z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.95 5.683V5.23c0-.058.048-.106.107-.106h1.462v.665H1.057a.106.106 0 0 1-.106-.106M.529 5.23c0-.292.237-.528.529-.528H2.94v1.51H1.057a.53.53 0 0 1-.529-.529z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.058 4.702v1.51h1.885a.53.53 0 0 0 .529-.529V5.23a.53.53 0 0 0-.529-.528z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.481 5.789v-.665h1.462c.059 0 .106.048.106.106v.453a.106.106 0 0 1-.106.106zm-.423-1.087h1.885c.292 0 .529.236.529.528v.453a.53.53 0 0 1-.529.529h-1.885z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.47 9.519A1.47 1.47 0 0 0 0 10.989v5.84a1.47 1.47 0 1 0 2.942 0v-5.84A1.47 1.47 0 0 0 1.47 9.52M20.53 9.519a1.47 1.47 0 0 0-1.472 1.47v5.84a1.47 1.47 0 0 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.47-1.47M1.47 25.473A1.47 1.47 0 0 0 0 26.943v5.84a1.47 1.47 0 0 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.471-1.47M20.53 25.473a1.47 1.47 0 0 0-1.472 1.47v5.84a1.47 1.47 0 0 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.47-1.47"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          d: "M3.536 29.807h14.928c.78 0 1.273.839.894 1.52l-7.464 13.427a1.022 1.022 0 0 1-1.787 0L2.643 31.328c-.38-.682.113-1.521.893-1.521"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M12.34 45.002a1.533 1.533 0 0 1-2.68 0L2.196 31.576a1.535 1.535 0 0 1 1.34-2.281h14.928c1.17 0 1.91 1.258 1.34 2.281zm-1.787-.498c.195.35.699.35.894 0L18.91 31.08a.512.512 0 0 0-.447-.76H3.536c-.39 0-.636.419-.447.76z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M12.502 33.1c0-.166-.128-.3-.285-.3a.29.29 0 0 0-.285.3v1.962h-1.865V33.1c0-.166-.127-.3-.284-.3a.293.293 0 0 0-.285.3v1.962h-.645v1.203c.003 1.07.72 1.99 1.717 2.204v1.852h.86v-1.852c.996-.213 1.714-1.133 1.717-2.204v-1.208h-.645z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M6.705 32.263h8.59v8.596h-8.59z" }) }) })
    ]
  }
);
const VehicleSTug = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-tug",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 36",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M18.53.754H3.47a.53.53 0 0 0-.529.528v33.77c0 .292.237.528.529.528h15.06a.53.53 0 0 0 .528-.528V1.282a.53.53 0 0 0-.528-.528"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.153 1.283c0-.175.142-.317.317-.317h15.06c.175 0 .317.142.317.317V7.25H3.153zm0 6.39h15.694v27.383a.317.317 0 0 1-.317.317H3.47a.317.317 0 0 1-.317-.317zM3.47.543a.74.74 0 0 0-.74.74v33.773c0 .408.331.74.74.74h15.06a.74.74 0 0 0 .74-.74V1.283a.74.74 0 0 0-.74-.74z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M10.301 9.131H3.733v24.875h6.568zM18.332 9.132h-6.568v24.874h6.567z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.733 8.92a.21.21 0 0 0-.211.211v24.875c0 .117.095.211.211.211h6.568a.21.21 0 0 0 .212-.211V9.13a.21.21 0 0 0-.212-.211zm.212.423h6.145v24.451H3.945zm7.818-.423a.21.21 0 0 0-.21.211v24.875c0 .117.094.211.21.211h6.568a.21.21 0 0 0 .212-.211V9.13a.21.21 0 0 0-.212-.21zm.212.423h6.145v24.452h-6.145z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M4.03 1.481a.53.53 0 0 0-.53.529v.453c0 .292.237.528.53.528h13.988a.53.53 0 0 0 .529-.528V2.01a.53.53 0 0 0-.529-.529z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M3.923 2.463V2.01c0-.058.048-.106.106-.106h13.99c.058 0 .105.048.105.106v.453a.106.106 0 0 1-.106.106H4.03a.106.106 0 0 1-.106-.106m-.422-.453c0-.292.236-.529.528-.529h13.99c.29 0 .528.237.528.529v.453a.53.53 0 0 1-.529.528H4.03a.53.53 0 0 1-.528-.528z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.057 4.454a.53.53 0 0 0-.529.528v.453c0 .292.237.529.529.529H2.94v-1.51z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M.95 5.435v-.453c0-.058.048-.106.107-.106h1.462v.665H1.057a.106.106 0 0 1-.106-.106m-.422-.453c0-.292.237-.528.529-.528H2.94v1.51H1.057a.53.53 0 0 1-.529-.529z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M19.058 4.454v1.51h1.885a.53.53 0 0 0 .529-.529v-.453a.53.53 0 0 0-.529-.528z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          fillRule: "evenodd",
          d: "M19.481 5.54v-.664h1.462c.059 0 .106.048.106.106v.453a.106.106 0 0 1-.106.106zm-.423-1.086h1.885c.292 0 .529.236.529.528v.453a.53.53 0 0 1-.529.529h-1.885z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#18182E",
          d: "M1.47 9.271A1.47 1.47 0 0 0 0 10.741v5.84a1.47 1.47 0 1 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.471-1.47M20.53 9.271a1.47 1.47 0 0 0-1.472 1.47v5.84a1.47 1.47 0 0 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.47-1.47M1.47 25.225A1.47 1.47 0 0 0 0 26.695v5.84a1.47 1.47 0 1 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.471-1.47M20.53 25.225a1.47 1.47 0 0 0-1.472 1.47v5.84a1.47 1.47 0 0 0 2.942 0v-5.84a1.47 1.47 0 0 0-1.47-1.47"
        }
      )
    ]
  }
);
const VehicleSVanDisablePending = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-van-disable-pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 51",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M10.3 0q2.904.002 5.787 1.773c.578.355.975.927 1.096 1.577l.35 1.89q.03.158.03.32v3.743l.52.236c.416.187.733.53.88.947l.034.105c.02.08-.055.152-.142.136l-1.292-.245v2.579l.507 2.398q.027.13.027.261v21.415c0 .286-.158.55-.415.692Q13.752 39.999 10.3 40q-3.452-.001-7.382-2.173a.79.79 0 0 1-.416-.692v-21.46q0-.134.029-.267l.506-2.334V10.37l-1.892.357c-.076.015-.143-.039-.145-.106l.004-.029.033-.105c.147-.417.464-.76.88-.947l1.12-.506V5.559q0-.16.03-.32l.354-1.908a2.32 2.32 0 0 1 1.071-1.545Q7.386 0 10.3 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M10.3.58q1.667 0 3.341.63.02.03.056.052l1.917 1.303c.146.1.35.019.38-.136.311.264.524.624.598 1.024l.35 1.889q.02.108.02.217l.005 5.21a.58.58 0 0 0-.37.535v3.479c0 .32.269.58.6.58h.24l.045.212.011.072.004.073v21.415c0 .078-.043.15-.113.188q-3.803 2.099-7.085 2.097-3.282.002-7.084-2.097a.22.22 0 0 1-.113-.188v-21.46q0-.075.015-.148l.036-.165H3.4c.332 0 .6-.26.6-.58v-3.478a.58.58 0 0 0-.365-.533V5.559q0-.11.02-.217l.354-1.909c.076-.41.302-.777.632-1.038.004.177.223.276.377.17l1.885-1.303a.3.3 0 0 0 .056-.053A9.4 9.4 0 0 1 10.3.58m0 8.985q-2.695 0-5.389 1.168a.505.505 0 0 0-.308.5l.284 3.66a.526.526 0 0 0 .644.456 21.4 21.4 0 0 1 4.768-.513q2.524 0 4.769.512.04.009.081.012a.52.52 0 0 0 .563-.467l.284-3.66a.505.505 0 0 0-.309-.5Q12.993 9.565 10.3 9.565",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#9DA9B6",
          fillRule: "evenodd",
          d: "m7.486 2.87-.423 2.276-.015.068-.781 2.817c-.043.153-.121.267-.175.253l-.194-.05c-.054-.015-.062-.15-.02-.304l1.398-5.043c.091-.328.27-.343.21-.018M13.347 5.195l-.422-2.276c-.061-.326.119-.31.21.018l1.398 5.042c.042.154.033.29-.02.304l-.195.05c-.053.014-.131-.1-.174-.253l-.78-2.817zM5.4 18.446l.2 8.066.003.244v10.207c0 .556-.045 1.008-.1 1.008h-.201c-.056 0-.1-.451-.1-1.008V18.69c0-1.189.169-1.398.197-.245M14.801 26.512l.201-8.067c.029-1.153.198-.944.198.245v18.273c0 .556-.045 1.008-.1 1.008h-.201c-.056 0-.1-.451-.1-1.008V26.756z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCF0DE",
          fillRule: "evenodd",
          stroke: "#F9D199",
          d: "M10 49.526a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F9D199",
          fillRule: "evenodd",
          d: "M1 41a9 9 0 1 1 18.001.001A9 9 0 0 1 1 41m9-8.053a8.053 8.053 0 1 0 .001 16.107A8.053 8.053 0 0 0 10 32.947",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          fillRule: "evenodd",
          d: "M12.924 39.342h-.474v-.947a2.37 2.37 0 0 0-4.737 0v.947h-.474a.95.95 0 0 0-.947.947v4.737a.95.95 0 0 0 .947.948h5.685a.95.95 0 0 0 .947-.948V40.29a.95.95 0 0 0-.947-.947m-2.842 4.263a.95.95 0 0 1-.948-.947.95.95 0 0 1 .947-.947.95.95 0 0 1 .948.947.95.95 0 0 1-.947.947m1.468-4.263H8.613v-.947a1.47 1.47 0 0 1 2.937 0z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSVanDisabled = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-van-disabled",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 51",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M10.3 0q2.904.002 5.787 1.773c.578.355.975.927 1.096 1.577l.35 1.89q.03.158.03.32v3.743l.52.236c.416.187.733.53.88.947l.034.105c.02.08-.055.152-.142.136l-1.292-.245v2.579l.507 2.398q.027.13.027.261v21.415c0 .286-.158.55-.415.692Q13.752 39.999 10.3 40q-3.452-.001-7.382-2.173a.79.79 0 0 1-.416-.692v-21.46q0-.134.029-.267l.506-2.334V10.37l-1.892.357c-.076.015-.143-.039-.145-.106l.004-.029.033-.105c.147-.417.464-.76.88-.947l1.12-.506V5.559q0-.16.03-.32l.354-1.908a2.32 2.32 0 0 1 1.071-1.545Q7.386 0 10.3 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M10.3.58q1.667 0 3.341.63.02.03.056.052l1.917 1.303c.146.1.35.019.38-.136.311.264.524.624.598 1.024l.35 1.889q.02.108.02.217l.005 5.21a.58.58 0 0 0-.37.535v3.479c0 .32.269.58.6.58h.24l.045.212.011.072.004.073v21.415c0 .078-.043.15-.113.188q-3.803 2.099-7.085 2.097-3.282.002-7.084-2.097a.22.22 0 0 1-.113-.188v-21.46q0-.075.015-.148l.036-.165H3.4c.332 0 .6-.26.6-.58v-3.478a.58.58 0 0 0-.365-.533V5.559q0-.11.02-.217l.354-1.909c.076-.41.302-.777.632-1.038.004.177.223.276.377.17l1.885-1.303a.3.3 0 0 0 .056-.053A9.4 9.4 0 0 1 10.3.58m0 8.985q-2.695 0-5.389 1.168a.505.505 0 0 0-.308.5l.284 3.66a.526.526 0 0 0 .644.456 21.4 21.4 0 0 1 4.768-.513q2.524 0 4.769.512.04.009.081.012a.52.52 0 0 0 .563-.467l.284-3.66a.505.505 0 0 0-.309-.5Q12.993 9.565 10.3 9.565",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#9DA9B6",
          fillRule: "evenodd",
          d: "m7.486 2.87-.423 2.276-.015.068-.781 2.817c-.043.153-.121.267-.175.253l-.194-.05c-.054-.015-.062-.15-.02-.304l1.398-5.043c.091-.328.27-.343.21-.018M13.347 5.195l-.422-2.276c-.061-.326.119-.31.21.018l1.398 5.042c.042.154.033.29-.02.304l-.195.05c-.053.014-.131-.1-.174-.253l-.78-2.817zM5.4 18.446l.2 8.066.003.244v10.207c0 .556-.045 1.008-.1 1.008h-.201c-.056 0-.1-.451-.1-1.008V18.69c0-1.189.169-1.398.197-.245M14.801 26.512l.201-8.067c.029-1.153.198-.944.198.245v18.273c0 .556-.045 1.008-.1 1.008h-.201c-.056 0-.1-.451-.1-1.008V26.756z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCEDEB",
          fillRule: "evenodd",
          stroke: "#F5B7B1",
          d: "M10 49.526a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F5B7B1",
          fillRule: "evenodd",
          d: "M1 41a9 9 0 1 1 18.001.001A9 9 0 0 1 1 41m9-8.053a8.053 8.053 0 1 0 .001 16.107A8.053 8.053 0 0 0 10 32.947",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          fillRule: "evenodd",
          d: "M12.924 39.342h-.474v-.947a2.37 2.37 0 0 0-4.737 0v.947h-.474a.95.95 0 0 0-.947.947v4.737a.95.95 0 0 0 .947.948h5.685a.95.95 0 0 0 .947-.948V40.29a.95.95 0 0 0-.947-.947m-2.842 4.263a.95.95 0 0 1-.948-.947.95.95 0 0 1 .947-.947.95.95 0 0 1 .948.947.95.95 0 0 1-.947.947m1.468-4.263H8.613v-.947a1.47 1.47 0 0 1 2.937 0z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSVanEnablePending = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-van-enable-pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 51",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M10.3 0q2.904.002 5.787 1.773c.578.355.975.927 1.096 1.577l.35 1.89q.03.158.03.32v3.743l.52.236c.416.187.733.53.88.947l.034.105c.02.08-.055.152-.142.136l-1.292-.245v2.579l.507 2.398q.027.13.027.261v21.415c0 .286-.158.55-.415.692Q13.752 39.999 10.3 40q-3.452-.001-7.382-2.173a.79.79 0 0 1-.416-.692v-21.46q0-.134.029-.267l.506-2.334V10.37l-1.892.357c-.076.015-.143-.039-.145-.106l.004-.029.033-.105c.147-.417.464-.76.88-.947l1.12-.506V5.559q0-.16.03-.32l.354-1.908a2.32 2.32 0 0 1 1.071-1.545Q7.386 0 10.3 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M10.3.58q1.667 0 3.341.63.02.03.056.052l1.917 1.303c.146.1.35.019.38-.136.311.264.524.624.598 1.024l.35 1.889q.02.108.02.217l.005 5.21a.58.58 0 0 0-.37.535v3.479c0 .32.269.58.6.58h.24l.045.212.011.072.004.073v21.415c0 .078-.043.15-.113.188q-3.803 2.099-7.085 2.097-3.282.002-7.084-2.097a.22.22 0 0 1-.113-.188v-21.46q0-.075.015-.148l.036-.165H3.4c.332 0 .6-.26.6-.58v-3.478a.58.58 0 0 0-.365-.533V5.559q0-.11.02-.217l.354-1.909c.076-.41.302-.777.632-1.038.004.177.223.276.377.17l1.885-1.303a.3.3 0 0 0 .056-.053A9.4 9.4 0 0 1 10.3.58m0 8.985q-2.695 0-5.389 1.168a.505.505 0 0 0-.308.5l.284 3.66a.526.526 0 0 0 .644.456 21.4 21.4 0 0 1 4.768-.513q2.524 0 4.769.512.04.009.081.012a.52.52 0 0 0 .563-.467l.284-3.66a.505.505 0 0 0-.309-.5Q12.993 9.565 10.3 9.565",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#9DA9B6",
          fillRule: "evenodd",
          d: "m7.486 2.87-.423 2.276-.015.068-.781 2.817c-.043.153-.121.267-.175.253l-.194-.05c-.054-.015-.062-.15-.02-.304l1.398-5.043c.091-.328.27-.343.21-.018M13.347 5.195l-.422-2.276c-.061-.326.119-.31.21.018l1.398 5.042c.042.154.033.29-.02.304l-.195.05c-.053.014-.131-.1-.174-.253l-.78-2.817zM5.4 18.446l.2 8.066.003.244v10.207c0 .556-.045 1.008-.1 1.008h-.201c-.056 0-.1-.451-.1-1.008V18.69c0-1.189.169-1.398.197-.245M14.801 26.512l.201-8.067c.029-1.153.198-.944.198.245v18.273c0 .556-.045 1.008-.1 1.008h-.201c-.056 0-.1-.451-.1-1.008V26.756z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#CFDEF2",
          fillRule: "evenodd",
          stroke: "#F5B7B1",
          d: "M10 49.526a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#8AB9F7",
          fillRule: "evenodd",
          d: "M1 41a9 9 0 1 1 18.001.001A9 9 0 0 1 1 41m9-8.053a8.053 8.053 0 1 0 .001 16.107A8.053 8.053 0 0 0 10 32.947",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1774F0",
          fillRule: "evenodd",
          d: "M10.082 43.369a.95.95 0 0 0 .947-.948.95.95 0 0 0-.947-.947.95.95 0 0 0-.948.947.95.95 0 0 0 .947.947m2.842-4.264h-.474v-.947a2.37 2.37 0 0 0-4.737 0h.9a1.47 1.47 0 0 1 2.937 0v.947H7.24a.95.95 0 0 0-.948.948v4.737a.95.95 0 0 0 .947.947h5.685a.95.95 0 0 0 .947-.947v-4.737a.95.95 0 0 0-.947-.948m0 5.685H7.239v-4.737h5.685z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSVanNoSignal = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-van-no-signal",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 50",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M9.3 0q2.904.002 5.787 1.773c.578.355.975.927 1.096 1.577l.35 1.89q.03.158.03.32v3.743l.52.236c.416.187.733.53.88.947l.034.105c.02.08-.055.152-.142.136l-1.292-.245v2.579l.507 2.398q.027.13.027.261v23.415c0 .286-.158.55-.415.692Q12.752 41.999 9.3 42q-3.452-.001-7.382-2.173a.79.79 0 0 1-.416-.692v-23.46q0-.134.029-.267l.506-2.334V10.37l-1.892.357c-.076.015-.143-.039-.145-.106l.003-.029.034-.105c.147-.417.464-.76.88-.947l1.12-.506V5.559q0-.16.03-.32l.354-1.908a2.32 2.32 0 0 1 1.071-1.545Q6.386 0 9.3 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M9.3.58q1.667 0 3.341.63.02.03.056.052l1.917 1.303c.146.1.35.019.38-.136.311.264.524.624.598 1.024l.35 1.889q.02.108.02.217l.005 5.21a.58.58 0 0 0-.37.535v3.479c0 .32.269.58.6.58h.24l.045.212.011.072.004.073v23.415c0 .078-.043.15-.113.188q-3.803 2.099-7.085 2.097-3.282.002-7.084-2.097a.22.22 0 0 1-.113-.188v-23.46q0-.075.015-.148l.036-.165H2.4c.332 0 .6-.26.6-.58v-3.478a.58.58 0 0 0-.365-.533V5.559q0-.11.02-.217l.354-1.909c.076-.41.302-.777.632-1.038.004.177.223.276.377.17l1.885-1.303a.3.3 0 0 0 .056-.053A9.4 9.4 0 0 1 9.3.58m0 8.985q-2.695 0-5.389 1.168a.505.505 0 0 0-.308.5l.284 3.66a.526.526 0 0 0 .644.456 21.4 21.4 0 0 1 4.768-.513q2.524 0 4.769.512.04.009.081.012a.52.52 0 0 0 .563-.467l.284-3.66a.505.505 0 0 0-.309-.5Q11.993 9.565 9.3 9.565",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#9DA9B6",
          fillRule: "evenodd",
          d: "m6.486 2.87-.423 2.276-.015.068-.781 2.817c-.043.153-.121.267-.175.253l-.194-.05c-.054-.015-.062-.15-.02-.304l1.398-5.043c.091-.328.27-.343.21-.018M12.347 5.195l-.422-2.276c-.061-.326.119-.31.21.018l1.398 5.042c.042.154.033.29-.02.304l-.195.05c-.053.014-.131-.1-.174-.253l-.78-2.817zM4.4 18.446l.2 8.066.003.244v10.207c0 .556-.045 1.008-.1 1.008h-.201c-.056 0-.1-.451-.1-1.008V18.69c0-1.189.169-1.398.197-.245M13.801 26.512l.201-8.067c.029-1.153.198-.944.198.245v18.273c0 .556-.045 1.008-.1 1.008h-.201c-.056 0-.1-.451-.1-1.008V26.756z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          d: "M8.3 32.785a.99.99 0 0 1 1.4 0l7.514 7.514a.99.99 0 0 1 0 1.401L9.7 49.214a.99.99 0 0 1-1.4 0L.784 41.7a.99.99 0 0 1 0-1.4z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#9DA9B6",
          fillRule: "evenodd",
          d: "M7.95 32.435c.58-.58 1.52-.58 2.1 0l7.515 7.514c.58.58.58 1.521 0 2.102l-7.514 7.514c-.58.58-1.521.58-2.102 0L.435 42.05a1.486 1.486 0 0 1 0-2.102zm1.4.7a.495.495 0 0 0-.7 0L1.136 40.65a.495.495 0 0 0 0 .7l7.514 7.514a.495.495 0 0 0 .7 0l7.514-7.514a.495.495 0 0 0 0-.7z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          d: "M12.136 37.36a.386.386 0 0 0-.658-.273L8.935 39.63l3.201 3.201zm.17 6.73-6.094-6.094a.384.384 0 1 0-.543.544l2.18 2.18-2.758 2.758a.385.385 0 0 0 .27.659h5.9l.498.497c.15.15.393.15.543 0a.38.38 0 0 0 .004-.543"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M4.047 36.047h9.245v9.245H4.047z" }) }) })
    ]
  }
);
const VehicleSVanOff = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-van-off",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 50",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M9.3 0q2.904.002 5.787 1.773c.578.355.975.927 1.096 1.577l.35 1.89q.03.158.03.32v3.743l.52.236c.416.187.733.53.88.947l.034.105c.02.08-.055.152-.142.136l-1.292-.245v2.579l.507 2.398q.027.13.027.261v21.415c0 .286-.158.55-.415.692Q12.752 39.999 9.3 40q-3.452-.001-7.382-2.173a.79.79 0 0 1-.416-.692v-21.46q0-.134.029-.267l.506-2.334V10.37l-1.892.357c-.076.015-.143-.039-.145-.106l.003-.029.034-.105c.147-.417.464-.76.88-.947l1.12-.506V5.559q0-.16.03-.32l.354-1.908a2.32 2.32 0 0 1 1.071-1.545Q6.386 0 9.3 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M9.3.58q1.667 0 3.341.63.02.03.056.052l1.917 1.303c.146.1.35.019.38-.136.311.264.524.624.598 1.024l.35 1.889q.02.108.02.217l.005 5.21a.58.58 0 0 0-.37.535v3.479c0 .32.269.58.6.58h.24l.045.212.011.072.004.073v21.415c0 .078-.043.15-.113.188q-3.803 2.099-7.085 2.097-3.282.002-7.084-2.097a.22.22 0 0 1-.113-.188v-21.46q0-.075.015-.148l.036-.165H2.4c.332 0 .6-.26.6-.58v-3.478a.58.58 0 0 0-.365-.533V5.559q0-.11.02-.217l.354-1.909c.076-.41.302-.777.632-1.038.004.177.223.276.377.17l1.885-1.303a.3.3 0 0 0 .056-.053A9.4 9.4 0 0 1 9.3.58m0 8.985q-2.695 0-5.389 1.168a.505.505 0 0 0-.308.5l.284 3.66a.526.526 0 0 0 .644.456 21.4 21.4 0 0 1 4.768-.513q2.524 0 4.769.512.04.009.081.012a.52.52 0 0 0 .563-.467l.284-3.66a.505.505 0 0 0-.309-.5Q11.993 9.565 9.3 9.565",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#9DA9B6",
          fillRule: "evenodd",
          d: "m6.486 2.87-.423 2.276-.015.068-.781 2.817c-.043.153-.121.267-.175.253l-.194-.05c-.054-.015-.062-.15-.02-.304l1.398-5.043c.091-.328.27-.343.21-.018M12.347 5.195l-.422-2.276c-.061-.326.119-.31.21.018l1.398 5.042c.042.154.033.29-.02.304l-.195.05c-.053.014-.131-.1-.174-.253l-.78-2.817zM4.4 18.446l.2 8.066.003.244v10.207c0 .556-.045 1.008-.1 1.008h-.201c-.056 0-.1-.451-.1-1.008V18.69c0-1.189.169-1.398.197-.245M13.801 26.512l.201-8.067c.029-1.153.198-.944.198.245v18.273c0 .556-.045 1.008-.1 1.008h-.201c-.056 0-.1-.451-.1-1.008V26.756z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5D7186",
          fillRule: "evenodd",
          d: "M9 49.526a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M0 41a9 9 0 1 1 18.001.001A9 9 0 0 1 0 41m9-8.053a8.053 8.053 0 1 0 .001 16.107A8.053 8.053 0 0 0 9 32.947",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M5.472 41a3.528 3.528 0 1 0 7.056 0 3.528 3.528 0 0 0-7.056 0m-.893 0a4.421 4.421 0 1 0 8.842 0 4.421 4.421 0 0 0-8.842 0m2.615-.3a.55.55 0 0 0-.11.35q0 .208.11.35a.33.33 0 0 0 .273.14h3.066q.162 0 .273-.14a.55.55 0 0 0 .11-.35.55.55 0 0 0-.11-.35.33.33 0 0 0-.273-.142H7.467q-.163 0-.273.141",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleSVanOn = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-van-on",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 50",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M9.3 0q2.904.002 5.787 1.773c.578.355.975.927 1.096 1.577l.35 1.89q.03.158.03.32v3.743l.52.236c.416.187.733.53.88.947l.034.105c.02.08-.055.152-.142.136l-1.292-.245v2.579l.507 2.398q.027.13.027.261v21.415c0 .286-.158.55-.415.692Q12.752 39.999 9.3 40q-3.452-.001-7.382-2.173a.79.79 0 0 1-.416-.692v-21.46q0-.134.029-.267l.506-2.334V10.37l-1.892.357c-.076.015-.143-.039-.145-.106l.003-.029.034-.105c.147-.417.464-.76.88-.947l1.12-.506V5.559q0-.16.03-.32l.354-1.908a2.32 2.32 0 0 1 1.071-1.545Q6.386 0 9.3 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M9.3.58q1.667 0 3.341.63.02.03.056.052l1.917 1.303c.146.1.35.019.38-.136.311.264.524.624.598 1.024l.35 1.889q.02.108.02.217l.005 5.21a.58.58 0 0 0-.37.535v3.479c0 .32.269.58.6.58h.24l.045.212.011.072.004.073v21.415c0 .078-.043.15-.113.188q-3.803 2.099-7.085 2.097-3.282.002-7.084-2.097a.22.22 0 0 1-.113-.188v-21.46q0-.075.015-.148l.036-.165H2.4c.332 0 .6-.26.6-.58v-3.478a.58.58 0 0 0-.365-.533V5.559q0-.11.02-.217l.354-1.909c.076-.41.302-.777.632-1.038.004.177.223.276.377.17l1.885-1.303a.3.3 0 0 0 .056-.053A9.4 9.4 0 0 1 9.3.58m0 8.985q-2.695 0-5.389 1.168a.505.505 0 0 0-.308.5l.284 3.66a.526.526 0 0 0 .644.456 21.4 21.4 0 0 1 4.768-.513q2.524 0 4.769.512.04.009.081.012a.52.52 0 0 0 .563-.467l.284-3.66a.505.505 0 0 0-.309-.5Q11.993 9.565 9.3 9.565",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#9DA9B6",
          fillRule: "evenodd",
          d: "m6.486 2.87-.423 2.276-.015.068-.781 2.817c-.043.153-.121.267-.175.253l-.194-.05c-.054-.015-.062-.15-.02-.304l1.398-5.043c.091-.328.27-.343.21-.018M12.347 5.195l-.422-2.276c-.061-.326.119-.31.21.018l1.398 5.042c.042.154.033.29-.02.304l-.195.05c-.053.014-.131-.1-.174-.253l-.78-2.817zM4.4 18.446l.2 8.066.003.244v10.207c0 .556-.045 1.008-.1 1.008h-.201c-.056 0-.1-.451-.1-1.008V18.69c0-1.189.169-1.398.197-.245M13.801 26.512l.201-8.067c.029-1.153.198-.944.198.245v18.273c0 .556-.045 1.008-.1 1.008h-.201c-.056 0-.1-.451-.1-1.008V26.756z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#03D8A9",
          fillRule: "evenodd",
          d: "M9 49.526a8.527 8.527 0 1 0-.001-17.054 8.527 8.527 0 0 0 0 17.054",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M0 41a9 9 0 1 1 18.001.001A9 9 0 0 1 0 41m9-8.053a8.053 8.053 0 1 0 .001 16.107A8.053 8.053 0 0 0 9 32.947",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M9 41.49a.48.48 0 0 1-.35-.14.48.48 0 0 1-.141-.35v-3.93q0-.21.141-.35a.48.48 0 0 1 .35-.141q.21 0 .35.14.141.143.141.35V41q0 .21-.14.35a.48.48 0 0 1-.35.142m0 3.93q-.921 0-1.725-.35a4.5 4.5 0 0 1-1.4-.945 4.5 4.5 0 0 1-.946-1.4A4.3 4.3 0 0 1 4.58 41q0-.848.307-1.621.308-.774.884-1.4a.45.45 0 0 1 .344-.148q.21 0 .356.148a.42.42 0 0 1 .123.337.6.6 0 0 1-.147.363q-.43.478-.657 1.074A3.5 3.5 0 0 0 5.562 41q0 1.437 1 2.437Q7.564 44.438 9 44.438t2.438-1q1-1.001 1-2.438 0-.651-.233-1.26a3.5 3.5 0 0 0-.663-1.086.52.52 0 0 1-.141-.344.43.43 0 0 1 .129-.331.49.49 0 0 1 .356-.148q.21 0 .344.148.578.626.884 1.4t.307 1.62q0 .922-.35 1.726a4.5 4.5 0 0 1-.945 1.4 4.5 4.5 0 0 1-1.4.946A4.3 4.3 0 0 1 9 45.42"
        }
      )
    ]
  }
);
const VehicleSVanUnavailable = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-van-unavailable",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 50",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M9.3 0q2.904.002 5.787 1.773c.578.355.975.927 1.096 1.577l.35 1.89q.03.158.03.32v3.743l.52.236c.416.187.733.53.88.947l.034.105c.02.08-.055.152-.142.136l-1.292-.245v2.579l.507 2.398q.027.13.027.261v21.415c0 .286-.158.55-.415.692Q12.752 39.999 9.3 40q-3.452-.001-7.382-2.173a.79.79 0 0 1-.416-.692v-21.46q0-.134.029-.267l.506-2.334V10.37l-1.892.357c-.076.015-.143-.039-.145-.106l.003-.029.034-.105c.147-.417.464-.76.88-.947l1.12-.506V5.559q0-.16.03-.32l.354-1.908a2.32 2.32 0 0 1 1.071-1.545Q6.386 0 9.3 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M9.3.58q1.667 0 3.341.63.02.03.056.052l1.917 1.303c.146.1.35.019.38-.136.311.264.524.624.598 1.024l.35 1.889q.02.108.02.217l.005 5.21a.58.58 0 0 0-.37.535v3.479c0 .32.269.58.6.58h.24l.045.212.011.072.004.073v21.415c0 .078-.043.15-.113.188q-3.803 2.099-7.085 2.097-3.282.002-7.084-2.097a.22.22 0 0 1-.113-.188v-21.46q0-.075.015-.148l.036-.165H2.4c.332 0 .6-.26.6-.58v-3.478a.58.58 0 0 0-.365-.533V5.559q0-.11.02-.217l.354-1.909c.076-.41.302-.777.632-1.038.004.177.223.276.377.17l1.885-1.303a.3.3 0 0 0 .056-.053A9.4 9.4 0 0 1 9.3.58m0 8.985q-2.695 0-5.389 1.168a.505.505 0 0 0-.308.5l.284 3.66a.526.526 0 0 0 .644.456 21.4 21.4 0 0 1 4.768-.513q2.524 0 4.769.512.04.009.081.012a.52.52 0 0 0 .563-.467l.284-3.66a.505.505 0 0 0-.309-.5Q11.993 9.565 9.3 9.565",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#9DA9B6",
          fillRule: "evenodd",
          d: "m6.486 2.87-.423 2.276-.015.068-.781 2.817c-.043.153-.121.267-.175.253l-.194-.05c-.054-.015-.062-.15-.02-.304l1.398-5.043c.091-.328.27-.343.21-.018M12.347 5.195l-.422-2.276c-.061-.326.119-.31.21.018l1.398 5.042c.042.154.033.29-.02.304l-.195.05c-.053.014-.131-.1-.174-.253l-.78-2.817zM4.4 18.446l.2 8.066.003.244v10.207c0 .556-.045 1.008-.1 1.008h-.201c-.056 0-.1-.451-.1-1.008V18.69c0-1.189.169-1.398.197-.245M13.801 26.512l.201-8.067c.029-1.153.198-.944.198.245v18.273c0 .556-.045 1.008-.1 1.008h-.201c-.056 0-.1-.451-.1-1.008V26.756z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E74C3C",
          d: "M1.536 34.031h14.928c.78 0 1.273.838.894 1.52L9.894 48.967c-.39.7-1.398.7-1.787 0L.643 35.55c-.38-.682.113-1.52.893-1.52"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M10.34 49.215a1.534 1.534 0 0 1-2.68 0L.196 35.8a1.534 1.534 0 0 1 1.34-2.28h14.928c1.17 0 1.91 1.258 1.34 2.28zm-1.787-.497c.195.35.699.35.894 0l7.464-13.416a.51.51 0 0 0-.447-.76H1.536c-.39 0-.636.42-.447.76z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M9 44.538a.76.76 0 0 1-.57-.245.82.82 0 0 1-.236-.59.82.82 0 0 1 .237-.59.76.76 0 0 1 .569-.245q.331 0 .568.245a.82.82 0 0 1 .237.59.82.82 0 0 1-.237.59.76.76 0 0 1-.568.245m0-2.505a.76.76 0 0 1-.57-.246.82.82 0 0 1-.236-.59v-3.34a.82.82 0 0 1 .237-.59.76.76 0 0 1 .569-.245q.331 0 .568.245a.82.82 0 0 1 .237.59v3.34a.82.82 0 0 1-.237.59.76.76 0 0 1-.568.245"
        }
      )
    ]
  }
);
const VehicleSVanUnplugged = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-van-unplugged",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 50",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M9.3 0q2.904.002 5.787 1.773c.578.355.975.927 1.096 1.577l.35 1.89q.03.158.03.32v3.743l.52.236c.416.187.733.53.88.947l.034.105c.02.08-.055.152-.142.136l-1.292-.245v2.579l.507 2.398q.027.13.027.261v21.415c0 .286-.158.55-.415.692Q12.752 39.999 9.3 40q-3.452-.001-7.382-2.173a.79.79 0 0 1-.416-.692v-21.46q0-.134.029-.267l.506-2.334V10.37l-1.892.357c-.076.015-.143-.039-.145-.106l.003-.029.034-.105c.147-.417.464-.76.88-.947l1.12-.506V5.559q0-.16.03-.32l.354-1.908a2.32 2.32 0 0 1 1.071-1.545Q6.386 0 9.3 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M9.3.58q1.667 0 3.341.63.02.03.056.052l1.917 1.303c.146.1.35.019.38-.136.311.264.524.624.598 1.024l.35 1.889q.02.108.02.217l.005 5.21a.58.58 0 0 0-.37.535v3.479c0 .32.269.58.6.58h.24l.045.212.011.072.004.073v21.415c0 .078-.043.15-.113.188q-3.803 2.099-7.085 2.097-3.282.002-7.084-2.097a.22.22 0 0 1-.113-.188v-21.46q0-.075.015-.148l.036-.165H2.4c.332 0 .6-.26.6-.58v-3.478a.58.58 0 0 0-.365-.533V5.559q0-.11.02-.217l.354-1.909c.076-.41.302-.777.632-1.038.004.177.223.276.377.17l1.885-1.303a.3.3 0 0 0 .056-.053A9.4 9.4 0 0 1 9.3.58m0 8.985q-2.695 0-5.389 1.168a.505.505 0 0 0-.308.5l.284 3.66a.526.526 0 0 0 .644.456 21.4 21.4 0 0 1 4.768-.513q2.524 0 4.769.512.04.009.081.012a.52.52 0 0 0 .563-.467l.284-3.66a.505.505 0 0 0-.309-.5Q11.993 9.565 9.3 9.565",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#9DA9B6",
          fillRule: "evenodd",
          d: "m6.486 2.87-.423 2.276-.015.068-.781 2.817c-.043.153-.121.267-.175.253l-.194-.05c-.054-.015-.062-.15-.02-.304l1.398-5.043c.091-.328.27-.343.21-.018M12.347 5.195l-.422-2.276c-.061-.326.119-.31.21.018l1.398 5.042c.042.154.033.29-.02.304l-.195.05c-.053.014-.131-.1-.174-.253l-.78-2.817zM4.4 18.446l.2 8.066.003.244v10.207c0 .556-.045 1.008-.1 1.008h-.201c-.056 0-.1-.451-.1-1.008V18.69c0-1.189.169-1.398.197-.245M13.801 26.512l.201-8.067c.029-1.153.198-.944.198.245v18.273c0 .556-.045 1.008-.1 1.008h-.201c-.056 0-.1-.451-.1-1.008V26.756z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F08C00",
          d: "M1.536 34.031h14.928c.78 0 1.273.838.894 1.52L9.894 48.967c-.39.7-1.398.7-1.787 0L.643 35.55c-.38-.682.113-1.52.893-1.52"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M10.34 49.215a1.534 1.534 0 0 1-2.68 0L.196 35.8a1.534 1.534 0 0 1 1.34-2.28h14.928c1.17 0 1.91 1.258 1.34 2.28zm-1.787-.497c.195.35.699.35.894 0l7.464-13.416a.51.51 0 0 0-.447-.76H1.536c-.39 0-.636.42-.447.76z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M10.502 37.322c0-.166-.128-.3-.285-.3a.29.29 0 0 0-.285.3v1.96H8.067v-1.96c0-.166-.127-.3-.284-.3a.293.293 0 0 0-.285.3v1.96h-.645v1.203c.003 1.07.72 1.99 1.717 2.202v1.85h.86v-1.85c.996-.213 1.714-1.133 1.717-2.202v-1.207h-.645z",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M4.705 36.485h8.59v8.59h-8.59z" }) }) })
    ]
  }
);
const VehicleSVan = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-s-van",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 19 44",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1E2535",
          fillRule: "evenodd",
          d: "M9.778.037q3.053.001 6.085 1.93a2.57 2.57 0 0 1 1.152 1.716l.368 2.056q.03.172.031.348v4.074l.548.256c.437.204.77.577.925 1.03l.035.115c.021.087-.058.165-.15.148l-1.358-.266v2.805l.534 2.61q.028.142.028.285v23.303a.87.87 0 0 1-.437.753q-4.132 2.364-7.761 2.365-3.63-.001-7.761-2.365a.87.87 0 0 1-.437-.753V17.096q0-.148.03-.291l.531-2.54V11.32l-1.989.389c-.08.015-.15-.043-.152-.116l.004-.032.035-.114a1.77 1.77 0 0 1 .925-1.03l1.177-.551v-3.78q0-.175.031-.348l.373-2.077A2.52 2.52 0 0 1 3.672 1.98Q6.714.04 9.778.037",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F4F7F9",
          fillRule: "evenodd",
          d: "M9.778.668q1.753 0 3.513.686.022.032.059.057l2.016 1.417c.154.108.369.021.4-.147.327.287.55.679.628 1.113l.369 2.056q.02.118.02.237l.005 5.669a.63.63 0 0 0-.388.582v3.786c0 .348.282.63.63.63h.252l.048.232q.008.039.012.079l.004.079v23.303a.24.24 0 0 1-.12.206q-3.998 2.283-7.448 2.281-3.45.002-7.449-2.281a.24.24 0 0 1-.119-.206V17.096q0-.082.017-.162l.037-.18h.262a.63.63 0 0 0 .63-.63v-3.785a.63.63 0 0 0-.384-.581V6.087q0-.12.021-.237l.373-2.077c.08-.446.317-.846.663-1.13.005.193.235.301.397.185l1.982-1.417a.3.3 0 0 0 .06-.058Q8.025.668 9.777.668m0 9.778q-2.832 0-5.665 1.27a.55.55 0 0 0-.325.546l.3 3.981a.552.552 0 0 0 .676.496q2.36-.557 5.014-.557 2.653 0 5.013.557a.552.552 0 0 0 .677-.496l.3-3.981a.55.55 0 0 0-.325-.545q-2.832-1.272-5.665-1.271",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#9DA9B6",
          fillRule: "evenodd",
          d: "m6.82 3.159-.445 2.477-.016.075-.821 3.065c-.045.167-.127.29-.184.275l-.204-.055c-.056-.015-.066-.163-.02-.33L6.6 3.18c.095-.358.284-.374.22-.02M12.982 5.69l-.444-2.477c-.064-.354.125-.338.22.02l1.47 5.487c.045.167.036.315-.02.33l-.205.055c-.056.015-.138-.108-.183-.276L13 5.764zM4.626 20.11l.211 8.777.003.266V40.26c0 .605-.047 1.097-.105 1.097h-.212c-.058 0-.106-.492-.106-1.097V20.375c0-1.294.179-1.521.209-.266M14.51 28.887l.212-8.778c.03-1.255.209-1.028.209.266V40.26c0 .605-.048 1.097-.106 1.097h-.211c-.059 0-.106-.492-.106-1.097V29.153z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const VehicleStatusIndicatorsOffIndicator = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-status-indicators-off-indicator",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 18",
    ...props,
    children: [
      /* @__PURE__ */ jsxs("g", { fillRule: "evenodd", clipPath: "url(#a)", clipRule: "evenodd", children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#5D7186",
            stroke: "#F4F7F9",
            d: "M9 17.1A8.1 8.1 0 1 0 8.999.899a8.1 8.1 0 0 0 0 16.2Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "M5.648 9a3.351 3.351 0 1 0 6.703 0 3.351 3.351 0 0 0-6.703 0M4.8 9a4.2 4.2 0 1 0 8.4 0 4.2 4.2 0 0 0-8.4 0m2.484-.286q-.105.134-.104.332 0 .2.104.333.105.134.26.134h2.912q.155 0 .259-.134t.105-.333a.52.52 0 0 0-.105-.332.32.32 0 0 0-.26-.134H7.545a.32.32 0 0 0-.26.134"
          }
        )
      ] }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h18v18H0z" }) }) })
    ]
  }
);
const VehicleStatusIndicatorsOffIndicatorOutlined = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-vehicle-status-indicators-off-indicator-outlined",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 12 13",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#5D7186",
        fillRule: "evenodd",
        d: "M1.81 6.5a4.19 4.19 0 1 0 8.38 0 4.19 4.19 0 0 0-8.38 0m-1.06 0a5.25 5.25 0 1 0 10.5 0 5.25 5.25 0 0 0-10.5 0m3.106-.357a.66.66 0 0 0-.131.415q0 .248.13.416a.4.4 0 0 0 .325.168h3.64a.4.4 0 0 0 .324-.168.66.66 0 0 0 .131-.416.66.66 0 0 0-.13-.415.4.4 0 0 0-.325-.168H4.18a.4.4 0 0 0-.324.168",
        clipRule: "evenodd"
      }
    )
  }
);
const VehicleStatusIndicatorsOnIndicator = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "data-testid": "cb-vehicle-status-indicators-on-indicator",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 18",
    ...props,
    children: [
      /* @__PURE__ */ jsxs("g", { clipPath: "url(#a)", children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#03D8A9",
            fillRule: "evenodd",
            stroke: "#F4F7F9",
            d: "M9 17.1A8.1 8.1 0 1 0 8.999.899a8.1 8.1 0 0 0 0 16.2Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "M9 9.467a.45.45 0 0 1-.333-.134A.45.45 0 0 1 8.533 9V5.267q0-.199.134-.333Q8.801 4.8 9 4.8q.198 0 .332.134t.134.333V9a.45.45 0 0 1-.134.333q-.134.134-.332.134M9 13.2q-.875 0-1.64-.332a4.3 4.3 0 0 1-1.33-.899 4.3 4.3 0 0 1-.898-1.33A4.1 4.1 0 0 1 4.8 9q0-.805.291-1.54.292-.735.84-1.33a.42.42 0 0 1 .327-.14q.198 0 .338.14a.4.4 0 0 1 .117.32.57.57 0 0 1-.14.345q-.408.455-.624 1.02A3.3 3.3 0 0 0 5.733 9q0 1.365.951 2.316t2.316.95 2.316-.95.95-2.316q0-.618-.221-1.196a3.3 3.3 0 0 0-.63-1.032.5.5 0 0 1-.134-.327.41.41 0 0 1 .122-.315.46.46 0 0 1 .338-.14q.2 0 .327.14.549.595.84 1.33.292.735.292 1.54 0 .875-.333 1.64a4.3 4.3 0 0 1-.898 1.33 4.3 4.3 0 0 1-1.33.897 4.1 4.1 0 0 1-1.64.333"
          }
        )
      ] }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h18v18H0z" }) }) })
    ]
  }
);
const VehicleStatusIndicatorsOnIndicatorOutlined = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-vehicle-status-indicators-on-indicator-outlined",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 12 13",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#03D8A9",
        d: "M6 7.083a.56.56 0 0 1-.416-.167.56.56 0 0 1-.167-.416V1.833q0-.247.167-.415A.56.56 0 0 1 6 1.25q.248 0 .416.168t.167.415V6.5a.56.56 0 0 1-.167.416.56.56 0 0 1-.416.167m0 4.667q-1.094 0-2.049-.416a5.3 5.3 0 0 1-1.662-1.123A5.3 5.3 0 0 1 1.166 8.55 5.1 5.1 0 0 1 .75 6.5q0-1.005.365-1.925a5.4 5.4 0 0 1 1.05-1.662.53.53 0 0 1 .408-.175q.248 0 .423.175.16.16.146.4a.72.72 0 0 1-.175.43q-.51.57-.78 1.277t-.27 1.48q0 1.706 1.188 2.895Q4.294 10.583 6 10.583t2.895-1.188T10.083 6.5q0-.773-.277-1.495a4.1 4.1 0 0 0-.787-1.29.62.62 0 0 1-.168-.409.51.51 0 0 1 .153-.393.58.58 0 0 1 .423-.175.53.53 0 0 1 .408.175q.686.743 1.05 1.662A5.2 5.2 0 0 1 11.25 6.5q0 1.094-.416 2.049a5.3 5.3 0 0 1-1.123 1.662 5.3 5.3 0 0 1-1.662 1.123A5.1 5.1 0 0 1 6 11.75"
      }
    )
  }
);
const Whatsapp = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    "data-testid": "cb-whatsapp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2m.01 1.67c2.2 0 4.26.86 5.82 2.42a8.23 8.23 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23-1.48 0-2.93-.39-4.19-1.15l-.3-.17-3.12.82.83-3.04-.2-.32a8.2 8.2 0 0 1-1.26-4.38c.01-4.54 3.7-8.24 8.25-8.24M8.53 7.33c-.16 0-.43.06-.66.31-.22.25-.87.86-.87 2.07 0 1.22.89 2.39 1 2.56.14.17 1.76 2.67 4.25 3.73.59.27 1.05.42 1.41.53.59.19 1.13.16 1.56.1.48-.07 1.46-.6 1.67-1.18s.21-1.07.15-1.18c-.07-.1-.23-.16-.48-.27-.25-.14-1.47-.74-1.69-.82-.23-.08-.37-.12-.56.12-.16.25-.64.81-.78.97-.15.17-.29.19-.53.07-.26-.13-1.06-.39-2-1.23-.74-.66-1.23-1.47-1.38-1.72-.12-.24-.01-.39.11-.5.11-.11.27-.29.37-.44.13-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.11-.56-1.35-.77-1.84-.2-.48-.4-.42-.56-.43-.14 0-.3-.01-.47-.01" })
  }
);
const cobliIconNames = {
  "cb-arrow-drop-down-cb": ArrowDropDownCb,
  "cb-arrow-drop-up-cb": ArrowDropUpCb,
  "cb-camera": Camera,
  "cb-car-crash": CarCrash,
  "cb-device-status-indicators-disable-pending-indicator": DeviceStatusIndicatorsDisablePendingIndicator,
  "cb-device-status-indicators-disabled-indicator": DeviceStatusIndicatorsDisabledIndicator,
  "cb-device-status-indicators-enable-pending-indicator": DeviceStatusIndicatorsEnablePendingIndicator,
  "cb-device-status-indicators-lost-data": DeviceStatusIndicatorsLostData,
  "cb-device-status-indicators-new": DeviceStatusIndicatorsNew,
  "cb-device-status-indicators-no-signal-indicator": DeviceStatusIndicatorsNoSignalIndicator,
  "cb-device-status-indicators-synchronizing-indicator": DeviceStatusIndicatorsSynchronizingIndicator,
  "cb-device-status-indicators-unavailable-indicator": DeviceStatusIndicatorsUnavailableIndicator,
  "cb-device-status-indicators-unplugged-indicator": DeviceStatusIndicatorsUnpluggedIndicator,
  "cb-double-check": DoubleCheck,
  "cb-eta-cb": EtaCb,
  "cb-filters-broken-link": FiltersBrokenLink,
  "cb-filters-directions-car-cb": FiltersDirectionsCarCb,
  "cb-filters-driver-cb": FiltersDriverCb,
  "cb-filters-face-recognition": FiltersFaceRecognition,
  "cb-filters-filter-alt-cb": FiltersFilterAltCb,
  "cb-filters-hourglass": FiltersHourglass,
  "cb-filters-link": FiltersLink,
  "cb-filters-speed": FiltersSpeed,
  "cb-filters-tag": FiltersTag,
  "cb-filters-vehicle-group-cb": FiltersVehicleGroupCb,
  "cb-geofences-base": GeofencesBase,
  "cb-geofences-client": GeofencesClient,
  "cb-geofences-fuel": GeofencesFuel,
  "cb-geofences-home": GeofencesHome,
  "cb-geofences-maintenance": GeofencesMaintenance,
  "cb-geofences-other": GeofencesOther,
  "cb-geofences-sede": GeofencesSede,
  "cb-gravity": Gravity,
  "cb-heavy-vehicle": HeavyVehicle,
  "cb-help": Help,
  "cb-ibutton": Ibutton,
  "cb-integrations": Integrations,
  "cb-lan": Lan,
  "cb-leading": Leading,
  "cb-light-vehicle": LightVehicle,
  "cb-loading-spin": LoadingSpin,
  "cb-logo-cobli-name": LogoCobliName,
  "cb-maintenance": Maintenance,
  "cb-medium-vehicle": MediumVehicle,
  "cb-new-release": NewRelease,
  "cb-obd": Obd,
  "cb-placeholder-car": PlaceholderCar,
  "cb-placeholder-checklists": PlaceholderChecklists,
  "cb-placeholder-vehicle-group": PlaceholderVehicleGroup,
  "cb-preferences": Preferences,
  "cb-report-lock": ReportLock,
  "cb-search-signal": SearchSignal,
  "cb-settings": Settings,
  "cb-signal-cellular-0": SignalCellular0,
  "cb-signal-cellular-4": SignalCellular4,
  "cb-signal-cellular-off": SignalCellularOff,
  "cb-signal-disconnected": SignalDisconnected,
  "cb-signal-nodata": SignalNodata,
  "cb-signal-normal": SignalNormal,
  "cb-signal-nosignal": SignalNosignal,
  "cb-signal-unavailable": SignalUnavailable,
  "cb-sort-menu-asc": SortMenuAsc,
  "cb-speed-lock": SpeedLock,
  "cb-status-danger": StatusDanger,
  "cb-status-info": StatusInfo,
  "cb-status-installation": StatusInstallation,
  "cb-status-processing": StatusProcessing,
  "cb-status-success": StatusSuccess,
  "cb-status-tracking": StatusTracking,
  "cb-status-warning": StatusWarning,
  "cb-steering-wheel": SteeringWheel,
  "cb-traffic-light": TrafficLight,
  "cb-unplugged": Unplugged,
  "cb-vehicle-s-boat-disable-pending": VehicleSBoatDisablePending,
  "cb-vehicle-s-boat-disabled": VehicleSBoatDisabled,
  "cb-vehicle-s-boat-enable-pending": VehicleSBoatEnablePending,
  "cb-vehicle-s-boat-no-signal": VehicleSBoatNoSignal,
  "cb-vehicle-s-boat-off": VehicleSBoatOff,
  "cb-vehicle-s-boat-on": VehicleSBoatOn,
  "cb-vehicle-s-boat-unavailable": VehicleSBoatUnavailable,
  "cb-vehicle-s-boat-unplugged": VehicleSBoatUnplugged,
  "cb-vehicle-s-boat": VehicleSBoat,
  "cb-vehicle-s-car-disable-pending": VehicleSCarDisablePending,
  "cb-vehicle-s-car-disabled": VehicleSCarDisabled,
  "cb-vehicle-s-car-enable-pending": VehicleSCarEnablePending,
  "cb-vehicle-s-car-no-signal": VehicleSCarNoSignal,
  "cb-vehicle-s-car-off": VehicleSCarOff,
  "cb-vehicle-s-car-on": VehicleSCarOn,
  "cb-vehicle-s-car-unavailable": VehicleSCarUnavailable,
  "cb-vehicle-s-car-unplugged": VehicleSCarUnplugged,
  "cb-vehicle-s-car": VehicleSCar,
  "cb-vehicle-s-conveyor-disable-pending": VehicleSConveyorDisablePending,
  "cb-vehicle-s-conveyor-disabled": VehicleSConveyorDisabled,
  "cb-vehicle-s-conveyor-enable-pending": VehicleSConveyorEnablePending,
  "cb-vehicle-s-conveyor-no-signal": VehicleSConveyorNoSignal,
  "cb-vehicle-s-conveyor-off": VehicleSConveyorOff,
  "cb-vehicle-s-conveyor-on": VehicleSConveyorOn,
  "cb-vehicle-s-conveyor-unavailable": VehicleSConveyorUnavailable,
  "cb-vehicle-s-conveyor-unplugged": VehicleSConveyorUnplugged,
  "cb-vehicle-s-conveyor": VehicleSConveyor,
  "cb-vehicle-s-fork-lift-disable-pending": VehicleSForkLiftDisablePending,
  "cb-vehicle-s-fork-lift-disabled": VehicleSForkLiftDisabled,
  "cb-vehicle-s-fork-lift-enable-pending": VehicleSForkLiftEnablePending,
  "cb-vehicle-s-fork-lift-no-signal": VehicleSForkLiftNoSignal,
  "cb-vehicle-s-fork-lift-off": VehicleSForkLiftOff,
  "cb-vehicle-s-fork-lift-on": VehicleSForkLiftOn,
  "cb-vehicle-s-fork-lift-unavailable": VehicleSForkLiftUnavailable,
  "cb-vehicle-s-fork-lift-unplugged": VehicleSForkLiftUnplugged,
  "cb-vehicle-s-fork-lift": VehicleSForkLift,
  "cb-vehicle-s-gpu-apu-disable-pending": VehicleSGpuApuDisablePending,
  "cb-vehicle-s-gpu-apu-disabled": VehicleSGpuApuDisabled,
  "cb-vehicle-s-gpu-apu-enable-pending": VehicleSGpuApuEnablePending,
  "cb-vehicle-s-gpu-apu-no-signal": VehicleSGpuApuNoSignal,
  "cb-vehicle-s-gpu-apu-off": VehicleSGpuApuOff,
  "cb-vehicle-s-gpu-apu-on": VehicleSGpuApuOn,
  "cb-vehicle-s-gpu-apu-unavailable": VehicleSGpuApuUnavailable,
  "cb-vehicle-s-gpu-apu-unplugged": VehicleSGpuApuUnplugged,
  "cb-vehicle-s-gpu-apu": VehicleSGpuApu,
  "cb-vehicle-s-ladder-disable-pending": VehicleSLadderDisablePending,
  "cb-vehicle-s-ladder-disabled": VehicleSLadderDisabled,
  "cb-vehicle-s-ladder-enable-pending": VehicleSLadderEnablePending,
  "cb-vehicle-s-ladder-no-signal": VehicleSLadderNoSignal,
  "cb-vehicle-s-ladder-off": VehicleSLadderOff,
  "cb-vehicle-s-ladder-on": VehicleSLadderOn,
  "cb-vehicle-s-ladder-unavailable": VehicleSLadderUnavailable,
  "cb-vehicle-s-ladder-unplugged": VehicleSLadderUnplugged,
  "cb-vehicle-s-ladder": VehicleSLadder,
  "cb-vehicle-s-loader-disable-pending": VehicleSLoaderDisablePending,
  "cb-vehicle-s-loader-disabled": VehicleSLoaderDisabled,
  "cb-vehicle-s-loader-enable-pending": VehicleSLoaderEnablePending,
  "cb-vehicle-s-loader-no-signal": VehicleSLoaderNoSignal,
  "cb-vehicle-s-loader-off": VehicleSLoaderOff,
  "cb-vehicle-s-loader-on": VehicleSLoaderOn,
  "cb-vehicle-s-loader-unavailable": VehicleSLoaderUnavailable,
  "cb-vehicle-s-loader-unplugged": VehicleSLoaderUnplugged,
  "cb-vehicle-s-loader": VehicleSLoader,
  "cb-vehicle-s-motorcycle-disable-pending": VehicleSMotorcycleDisablePending,
  "cb-vehicle-s-motorcycle-disabled": VehicleSMotorcycleDisabled,
  "cb-vehicle-s-motorcycle-enable-pending": VehicleSMotorcycleEnablePending,
  "cb-vehicle-s-motorcycle-no-signal": VehicleSMotorcycleNoSignal,
  "cb-vehicle-s-motorcycle-off": VehicleSMotorcycleOff,
  "cb-vehicle-s-motorcycle-on": VehicleSMotorcycleOn,
  "cb-vehicle-s-motorcycle-unavailable": VehicleSMotorcycleUnavailable,
  "cb-vehicle-s-motorcycle-unplugged": VehicleSMotorcycleUnplugged,
  "cb-vehicle-s-motorcycle": VehicleSMotorcycle,
  "cb-vehicle-s-tractor-disable-pending": VehicleSTractorDisablePending,
  "cb-vehicle-s-tractor-disabled": VehicleSTractorDisabled,
  "cb-vehicle-s-tractor-enable-pending": VehicleSTractorEnablePending,
  "cb-vehicle-s-tractor-no-signal": VehicleSTractorNoSignal,
  "cb-vehicle-s-tractor-off": VehicleSTractorOff,
  "cb-vehicle-s-tractor-on": VehicleSTractorOn,
  "cb-vehicle-s-tractor-unavailable": VehicleSTractorUnavailable,
  "cb-vehicle-s-tractor-unplugged": VehicleSTractorUnplugged,
  "cb-vehicle-s-tractor": VehicleSTractor,
  "cb-vehicle-s-truck-disable-pending": VehicleSTruckDisablePending,
  "cb-vehicle-s-truck-disabled": VehicleSTruckDisabled,
  "cb-vehicle-s-truck-enable-pending": VehicleSTruckEnablePending,
  "cb-vehicle-s-truck-no-signal": VehicleSTruckNoSignal,
  "cb-vehicle-s-truck-off": VehicleSTruckOff,
  "cb-vehicle-s-truck-on": VehicleSTruckOn,
  "cb-vehicle-s-truck-unavailable": VehicleSTruckUnavailable,
  "cb-vehicle-s-truck-unplugged": VehicleSTruckUnplugged,
  "cb-vehicle-s-truck": VehicleSTruck,
  "cb-vehicle-s-tug-disable-pending": VehicleSTugDisablePending,
  "cb-vehicle-s-tug-disabled": VehicleSTugDisabled,
  "cb-vehicle-s-tug-enable-pending": VehicleSTugEnablePending,
  "cb-vehicle-s-tug-no-signal": VehicleSTugNoSignal,
  "cb-vehicle-s-tug-off": VehicleSTugOff,
  "cb-vehicle-s-tug-on": VehicleSTugOn,
  "cb-vehicle-s-tug-unavailable": VehicleSTugUnavailable,
  "cb-vehicle-s-tug-unplugged": VehicleSTugUnplugged,
  "cb-vehicle-s-tug": VehicleSTug,
  "cb-vehicle-s-van-disable-pending": VehicleSVanDisablePending,
  "cb-vehicle-s-van-disabled": VehicleSVanDisabled,
  "cb-vehicle-s-van-enable-pending": VehicleSVanEnablePending,
  "cb-vehicle-s-van-no-signal": VehicleSVanNoSignal,
  "cb-vehicle-s-van-off": VehicleSVanOff,
  "cb-vehicle-s-van-on": VehicleSVanOn,
  "cb-vehicle-s-van-unavailable": VehicleSVanUnavailable,
  "cb-vehicle-s-van-unplugged": VehicleSVanUnplugged,
  "cb-vehicle-s-van": VehicleSVan,
  "cb-vehicle-status-indicators-off-indicator": VehicleStatusIndicatorsOffIndicator,
  "cb-vehicle-status-indicators-off-indicator-outlined": VehicleStatusIndicatorsOffIndicatorOutlined,
  "cb-vehicle-status-indicators-on-indicator": VehicleStatusIndicatorsOnIndicator,
  "cb-vehicle-status-indicators-on-indicator-outlined": VehicleStatusIndicatorsOnIndicatorOutlined,
  "cb-whatsapp": Whatsapp
};
const iconVariants = ce({
  base: "",
  variants: {
    color: {
      primary: "text-primary",
      secondary: "text-secondary",
      success: "text-success",
      danger: "text-danger",
      warning: "text-warning",
      white: "text-white",
      black: "text-black",
      gray: "text-gray",
      "gray-light": "text-gray-light",
      "gray-dark": "text-gray-dark"
    },
    size: {
      xs: "!size-3",
      sm: "!size-4",
      md: "!size-5",
      lg: "!size-8",
      xl: "!size-12",
      "2xl": "!size-16",
      "4xl": "!size-24"
    }
  },
  defaultVariants: {
    size: "sm"
  }
});
[...Object.keys(iconsLucide).map(parseCamelCaseToKebabCase), ...Object.keys(cobliIconNames)];
const Icon = ({ name, size, color, className, absoluteStrokeWidth }) => {
  const LucideIcon = iconsLucide[kebabToCamelCase(name)];
  if (LucideIcon) {
    return /* @__PURE__ */ jsx(LucideIcon, { "data-testid": `lucide-${name}`, absoluteStrokeWidth, className: cn(iconVariants({ size, color }), className) });
  }
  const CustomIcon = cobliIconNames[name];
  if (CustomIcon) {
    return /* @__PURE__ */ jsx(CustomIcon, { className: cn(iconVariants({ size, color }), className) });
  }
  console.error(`Icon "${name}" not found`);
  return /* @__PURE__ */ jsx("div", { "data-testid": "icon-fallback", className: cn(iconVariants({ size }), "bg-transparent", className) });
};
Icon.displayName = "Icon";
const Icon$1 = memo(Icon);
export {
  CircleX as C,
  Ellipsis as E,
  Icon$1 as I,
  Circle as a,
  ChevronRight as b,
  ce as c,
  Check as d
};
